import { getImgUrl } from "../Utility/Utility";

// start live shows
// export const ShowsPostsData = [

// 	{
// 		id:1,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tom Jones \n Tel Aviv ",
//         smltitle: "The one and only Tom Jones returns to Tel Aviv for one live performance",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.tomjones.com/">
// 												www.tomjones.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/1/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							At the request of the audience and after the success of his sold-out show in 2013, the legendary performer Tom Jones returns to Israel for one live performance, to be held in Tel Aviv on Wednesday, June 28, 2017.
// 						</p>

// 						<p>
// 							Tom Jones, a world-famous living legend, is known for not allowing the diverse audience that fills his halls to sit quietly for a moment. He is a performer who captures the hearts of men and women of all ages, crosses generations and genres with his infinite inherent talent and his powerful and unique voice.
// 						</p>
// 						<p>
// 							Tom Jones has had an amazing stage career and sold over 100 million records. He has been awarded many titles including the Brit Awards for his immense musical contribution and Lifetime Achievement Award for his many achievements in the world of music and live performances at the Silver Clef (annual British Music Awards). For his contribution to the music industry, he won a star on the Hollywood Walk of Fame. In 1999, Tom Jones was awarded the Order of the British Empire (OBE) and in 2006 His Royal Highness Queen Elizabeth gave him the title of nobility and he became Sir Tom Jones.
// 						</p>

// 						<p>
// 							Jones, recognized across the world as a "hit machine", will be hitting the 24/7 city this June for the second time. As he did in his last sold out show in Tel Aviv to the delight of his audience, will be performing his all-time greatest hits.
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//       id:2,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Britney Spears \n  Live in Concert",
//         smltitle: "Britney Spears- performing all her greatest hits in the fabulous city of Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											03.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.britneyspears.com">
// 												www.britneyspears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/2/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							Pop Icon Britney Spears is coming to Tel Aviv for the first time ever, for one show only, as part of her international tour of Asia. The show will take place in stunning Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>

// 						<p>
// 							Pop Icon Britney Spears will be coming to Israel for the first time ever for one show only as part of her international tour of Asia. The show will take place in Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Multi-platinum, Grammy Award-winning pop icon Britney Spears was born in Mississippi and raised in Louisiana, Spears became a household name as a teenager when she released her first single “…Baby One More Time,” a Billboard Hot 100 No. 1 smash and international hit that broke sales records with more than 20 million copies sold worldwide and is currently 14x Platinum in the U.S.
// 						</p>

// 						<p>
// 							Spears is one of the most successful and celebrated entertainers in pop history with nearly 150 million records worldwide. In the U.S. alone, she has sold more than 70 million albums, singles and songs, according to Nielsen Music.
// 						</p>

// 						<p>
// 							Britney’s live concerts are renowned for their amazing production and nonstop energy. Her first ever show in Tel Aviv is likely to feature some of her most recent songs from her Glory Album, including massive 2016 hit ‘Slumber Party’, and also some of her massive all-time hits such as ‘Baby One More Time’ and ‘Oops I Did It Again’!
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:3,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tears for Fears",
//         smltitle: "Tear for Fears in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.tearsforfears.com">
// 												www.tearsforfears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<p>
// 							This summer, the trendy city of Tel Aviv is embracing it’s 80s vibe for one performance only by the incomparable Tears for Fears. The legendary British pop/rock band that is responsible for many unforgettable hits is coming to the rocking city of Tel Aviv for a single awesome performance!
// 						</p>

// 						<p>
// 							Originally from Bath, Avon, Tears for Fears was founded in 1981 and was associated at first with the new wave synthesizer bands but later on became a part of mainstream rock and pop and hit international success. During the 80's the band released 3 albums that were a combination of pop, new wave and rock. Their first album from 1983, "The Hurting", reached number one in the UK albums chart and was a platinum-selling album. It included major hits such as "Pale Shelter", "Change", and "Mad World". Their second album, "Songs from the Big Chair", followed the same path and reached number one on the US Billboard 200, getting multi-platinum status in the UK and the US. It contained unforgettable hits such as "Shout", "Head Over Heels" and "Everybody Wants to Rule the World" which won the Brit Award for best British single in 1986. Their third successful album "The Seeds of Love" that came out in 1989 included the epic songs "The Seeds of Love", "Sowing Woman in Chains" and many more.
// 						</p>
// 						<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans
// 						</p>
// 						<p>
// 						Tears for Fears’ albums and singles were sold in tens of millions of copies and their songs were covered by other artists countless times. Last year the band announced they are working on a new album to be released during 2017. This July they will be gracing the nonstop city of Tel Aviv for the first time with a single performance, guaranteed to be a night to remember.
// 						</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:4,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: " Guns N' Roses  \"Not in this Lifetime\"",
//         smltitle: "Legendary Guns N' Roses is Coming Back to Rock Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											15.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.gunsnroses.com">
// 											www.gunsnroses.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								After their celebrated reunion tour last summer, which became the most profitable musical rock concert in 2016, Guns N' Roses, one of the world's most important and beloved rock bands, is coming to Tel Aviv as part of its successful tour with has already added more than 30 shows in the US and Europe.
// 							</p>

// 							<p>
// 								The concert in Tel Aviv will take place on Saturday, July 15 and, 17 at the Yarkon Park, and will close the European tour.
// 							</p>
// 							<p>
// 								Twenty-three years after standing together on the stage in Tel Aviv for the first time, the three original members of the ensemble will come back again: vocalist Axel Rose, guitarist Slash and bassist Duff McGinn, along with an impressive ensemble of musicians including drummer Frank Ferrer, keyboardist Dizzy Red (who was an integral part of the band in the 1990s) Guitarist Richard Fortus and keyboardist Melissa Reyes.
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/2.jpg"} class="img-responsive" />
// 							</div>

// 							<h3>
// 							"Not in this Lifetime"
// 							</h3>
// 							<p>
// 							Since their first reunion concert at Cochlea Festival last April, the band's tour has become one of the most sought-after shows in America with more than 2 million tickets sold.
// 							</p>
// 							<p>
// 								The success and numbers of the current tour show more than anything else that the audience's love of the band's music and rock music is more relevant and bigger than ever. The historic tour last summer visited 21 cities (25 performances) in North America.
// 							</p>
// 							<p>
// 								The band has recently completed a successful tour in South America, Brazil, Argentina and Mexico. All of band's new tour dates are completely sold out, generating massive interest among audiences. In January, the band will continue to Japan and from there to Australia, Thailand, Singapore, Dubai and will arrive in the “nonstop city” of Tel Aviv in July.
// 							</p>
// 						`
// 			}
// 		}

// 	},

// 	{
//         id:5,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: " RADIOHEAD  \n Tel Aviv",
//         smltitle: "The trailblazing RADIOHEAD bringing their iconic repertoire to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.radiohead.com">
// 											www.radiohead.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/5/1.jpeg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Preforming in Tel Aviv for the second time ever, Radiohead has managed to remain innovative, relevant and especially moving since first visiting here 17 years ago . It is a band blessed with superhuman ability to meld together distant musical influences to create a new identity for themselves and their listeners; A band whose compulsive tendency to experiment with groundbreaking sound echoed the impact of entire generations of artists and shattered it to the walls of superfluous genres; A band that changed the way we listen to music, make music, see music, think music and even buy music. Now, 17 years after they last visited here, Radiohead is coming to a concert in Tel Aviv.
// 							</p>

// 							<p>
// 								Watching Radiohead's show, it becomes clear that first and foremost, they are the authors and performers of a huge amount of unforgettable songs. Their repertoire manages to be on the one hand familiar, classical - most of us know it by heart - and on the other hand revolutionary, developing and surprising. The tight performance of the ensemble, along with the unique energy of the soloist, Tom York, transforms each performance into a one-time live experience that attracts huge audiences, to participate in the celebration of artistic evolution, to see how they grew, evolved and reinvented themselves time and time again.
// 							</p>

// 							<p>
// 								Today's Radiohead is a band with a more contemporary presence than ever before, with a glorious past and a variety that transcends all cataloging: a band that began with the Immortal Grange anthem of Creep; Slapped critics over the head with the alternative masterpiece The Bends and then committed commercial suicide - and reached heaven - twice! - with two of the best albums of all time, OK Computer and Kid A.
// 							</p>

// 							<p>
// 								The new generations who discover Radiohead through their new works - In Rainbows a favorite in Israel or the new and acclaimed album A Moon Shaped Pool - discover a band whose influences have permeated every musical genre today: rock, electronic, world, hip hop. Today's Radiohead is more than just another band, it is a world - with a unique visual language, exceptional imagery, an unreplaceable atmosphere and inner humor. Especially in Israel - a country that has always enjoyed an intimate and warm relationship with the band - Radiohead's performance is a cultural experience of the rarest kind.
// 							</p>
// 							<p>
// 							This concert will not have assigned seats, Golden Ring, VIP, unfair prices or any other division of class. Anyone who wants to sit is welcome to bring a blanket, and anyone who wants to stand close to the stage is welcome to arrive early, the ticket price is equal to all, and as many people as possible will be able to enjoy this momentous musical event.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:6,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											25-26.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!
// 							</p>

// 							<p>
// 								The famous rock band was founded in 1986 in Boston and released its first EP "Come on Pilgrim" in 1987. A year later, when their first album "Surfer Rose" came out, they became a unique voice in the American Rock. 2 years later, they released their second album "Doolittle" that is considered one of the best rock albums of all times. Their third album "Bossanova" came out in 1990 and included unforgettable songs such as "Hang Wire", "Stormy Weather", and "All Over the World".
// 							</p>
// 							<p>
// 							A year later they released their fourth album "Trompe le Monde" that featured songs such as "Planet of Sound", "Distance Equals Rate Times Time" and many more. They fell apart in 1993 but went back to performing together in 2004. After a decade of touring the world, they released their fifth album "Indie Cindy" which included songs like "Another Toe in The Ocean", "Blue Eyed Hexe", and "Jaime Bravo". To this date they released six albums, the last one, "Head Carrier" came out last year. Their biggest hits include "Hey", "Where Is My Mind", "Monkey Gone to Heaven" and "Here Comes Your Man".
// 							</p>
// 							<p>
// 								The band that is known to influence artists such as PJ Harvey and Kurt Kobain will perform this summer in Tel Aviv, giving only 7000 lucky fans the opportunity to see them live and after the rave reviews of their 2014 performance, it’s shaping up to be an unmissable night!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:7,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Regina Spektor – Back in Israel",
//         smltitle: "Regina Spektor – Back in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.reginaspektor.com">
// 											www.reginaspektor.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								Beloved pianist, songwriter and singer Regina Spektor is coming back to Tel Aviv for the third time, closing the worldwide tour of her recent 2016 album “Remember Us to Life” that has gotten excellent reviews.
// 							</p>

// 							<p>
// 								Regina Spektor, whose past concerts in Israel were sold out in 2007 and 2013, will perform again for one time only in Ra’anana Amphitheater on Saturday, August 19.
// 							</p>
// 							<p>
// 								Grammy and VMA nominee Regina Spektor was born in Russia, where she started her classical music training at the age of six and immigrated shortly after to the New York, where she began writing her own original songs. Her first Album came out in 2001 and a year later she already released her second album, “songs”, but her real success started after her third album, Soviet Kitsch, was out in 2004 and the fans started pouring in.
// 							</p>
// 							<p>
// 								Her international breakthrough came in 2006 with her album “Begin to Hope” that reached gold status and sold more than 500,000 copies (!!!). The album includes the single “Fidelity” that is very popular in Israel and in the rest of the world to this day and was used as part of the soundtrack of TV shows such as “Grey’s Anatomy”. Her success only became stronger when her fifth album “Far” and her sixth album “What We Saw From The Cheap Seats” got to the third place in Billboard's album chart.
// 							</p>

// 							<p>
// 								In 2013 Spektor created the theme song of the successful Netflix series “Orange Is the New Black”, called “You’ve Got Time” that also became a radio hit and got her her first Grammy Award nomination. The following year, she sang “Love Me or Leave Me” for the HBO historical crime series “Boardwalk Empire”.
// 							</p>
// 							<p>
// 								Regina Spektor is coming to the non-stop city of Tel Aviv after her sold-out tour in the United States and her old and new fans can’t wait for her show, guaranteed to light up the beautiful summer night of Tel Aviv with it’s amazing infectious energy.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:8,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Nick Cave & The Bad Seeds",
//         smltitle: "Rock legend Nick Cave & The Bad Seeds returning to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19-20.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.nick-cave.com">
// 											www.nick-cave.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								19 years after his last performance in Tel Aviv, the prince of darkness returns once again with his band The Bad Seeds for two shows only to the joy of his fans in what are set to be intimate and unique performances.
// 							</p>

// 							<p>
// 								Australian musician, singer-songwriter, author, screenwriter, composer and film actor Nick Cave is well known as rock musics' "Prince of Darkness" because of his dark, intense tunes. His music is known to be emotionally intense and is characterized by a variety of influences such as death, religion, love and violence. He was called by NME "the grand lord of gothic lushness".
// 							</p>

// 							<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans.
// 							</p>
// 							<p>
// 								Cave started his musical path in the 1970's when he formed "the Boys Next Door" which became a huge success in Melbourne's post-punk scene. Their name was changed to "the Birthday Party" and the band's sound and shows took a rather violent direction and they became known as one of the darkest groups of the 1980's, they fell apart in 1983
// 							</p>
// 							<p>
// 								The end of the Birthday Party was the beginning of Nick Cave and the Bad Seeds in 1983 and they released their debut album the following year. In 1996 the band released its album "Murder Ballads" which featured "Where the Wild Roses Grow", a duet with Kylie Minogue that is also Cave's biggest commercial success to date.
// 							</p>
// 							<p>
// 								Many artists have covered Cave's songs over the years, including Metallica, Johnny Cash, and even the Arctic Monkeys.
// 							</p>

// 							<p>
// 								Nick Cave & The Bad Seeds will perform at the Menora Arena in Tel Aviv on November 19 and an additional date has been added on November 20 due to high demand. For the mere 7,000 fans who will get the chance to look the legendary Nick Cave in the eyes, this is guaranteed to be an unforgettable show!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:9,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Justin Bieber",
//         smltitle: "Justin Bieber, is landing in Tel Aviv for a single breathtaking concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											03.05.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.justinbiebermusic.com">
// 											www.justinbiebermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/9/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The artist with the most followers on Twitter 90,149,014
// 								The artist with the most watched official music channel online 13,518,849,954
// 								The artist with the most mentions on Youtube music channel
// 							</p>

// 							<p>
// 							Justin Bieber, the biggest international star of our day, arrives in Israel for just one concert as part of the PURPOSE WORLD TOUR, a tour bearing the name of his last album, which has sold 640,000 copies in just a week and became his bestselling album.
// 							</p>
// 							<p>
// 								Bieber, born in Ontario, Canada, learned to play piano, guitar and drums as a child. At the age of 13, with the help of his mother, he began posting videos on YouTube where he sang covers to artists such as Asher, Stevie Wonder, Chris Brown and others.
// 							</p>

// 							<p>
// 								Scooter Browne, a former marketing director at “So So Def”, was the first to spot Bieber’s talent and invited him and his mother to recordings in Atlanta.
// 							</p>

// 							<p>
// 								In 2008, Bieber was signed by Universal Records, and in 2009, "My World", the first mini-album by Bieber, including "One Time Lonely", "Love Me" and "Favorite Girl" topped the Canadian Billboard charts and the top 40 Billboard Hot 100 hits
// 							</p>
// 							<p>
// 								In 2010, he released his second album, "My World 2.0" with the single "Baby", which became a huge hit and was accompanied by the most watched YouTube video by November 24, 2012.
// 							</p>
// 							<p>
// 								In October 2015, Bieber released the second single from the album "Sorry". The dance clip for the song accumulated over 10 million views in the first 24 hours since its release.
// 							</p>

// 							<p>
// 								In November 2015 he released his fourth album "Purpose", which sold 640,000 copies in the first week and became Bieber’s best-selling album with hits such as "Love Yourself." That same month Bieber made history by placing 17 songs on the American charts and breaking the record held by the Beatles since 1964.
// 							</p>

// 							<p>
// 								In December 2015, Bieber and Skrillex won the Grammy Award for "Where are You Now".
// 							</p>

// 							<p>
// 								Justin Bieber will be performing in Israel on May 3 at Hayarkon Park, with his latest hits "love yourself" and "Sorry" and with the hits "Baby" and "As long as you love me".
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:10,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "AEROSMITH \n \"AERO-VEDERCI BABY\" ",
//         smltitle: " Aerosmith launching its tour in the rocking city of Tel Aviv  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.aerosmith.com">
// 											www.aerosmith.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Aerosmith’s farewell concerts began several months ago in South America and will continue in 2017 in the United States and Europe. the European leg of the tour will begin in Tel Aviv and the band will go on to perform in Georgia, Russia, Germany, Poland, Denmark, Ireland, Italy, Portugal and Spain, including appearances in some of the world's leading rock festivals.
// 							</p>
// 							<p>
// 								For over 45 years, Aerosmith has been the quintessential Rock & Roll band, becoming one of the most influential and loved groups in the world. An endless list of amazing songs, many of them becoming massive worldwide hits, and their groundbreaking live shows have gained the band mass appeal for nearly half a century. Rock & Roll Hall of Fame inductees, Aerosmith, have sold over 100 million albums and won countless awards (including four Grammy Awards, eight American Music Awards, six Billboard Awards, and 12 MTV Awards).
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/2.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								<strong>Steven Tyler</strong> – "Aerosmith just got done ripping through South America like true ambassadors of rock...The band is unstoppable right now and in Europe, we're going to keep doing what we do best... Let The Music Do The Talking...Living On The Edge, and living to rock another day."
// 							</p>

// 							<p>
// 								<strong>Joe Perry </strong> – “It’s been 3 years since we have been on tour in Europe and I can speak for my brothers that we can’t wait to get over there and take it up a few notches. Last tour in South America we were running on all cylinders and I can see no reason to let up now." ;
// 							</p>

// 							<p>
// 							This May, the city of Tel Aviv will be hosting Steven Tyler, Joe Perry, Joey Kramer, Tom Hamilton and Brad Whitford in the beautiful Ganei Yehoshua Park for what promises to be an unforgettable experience and the concert of a lifetime.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:11,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Frankie Valli & The Four Seasons  ",
//         smltitle: " An American Legend in the heart of Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											4.007.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.frankievallifourseasons.com/">
// 											www.frankievallifourseasons.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/11/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The American legend comes to the rocking city of Tel Aviv for the first time ever for an unforgettable 4th of July celebration with the best timeless classics!
// 							</p>
// 							<p>
// 								The original Jersey boy, musical legend Frankie Valli, comes Tel Aviv for the first time for one single performance. Back in the 50’s, Valli started singing in harmonies with different bands in New Jersey, but the success only struck him when he grabbed the microphone in the early 60’s as the lead singer for The Four Seasons that rocked the music world in the next decades with major hits such as “Big Girls Don’t Cry”, “Sherry”, “Walk Like a Man” and more. Valli scored 29 Top 40 hits with The Four Seasons and nine Top 40 hits as a solo artist. The band sold more than 175 million albums and Valli, Tommy DeVito, Nick Massi and Bob Gaudio – the original members of The Four Seasons – were inducted into the Rock and Roll Hall of Fame in 1990 and the Vocal Group Hall of Fame in 1999.
// 							</p>

// 							<p>
// 								At the same time, Valli also has a successful solo career with songs such as the theme song for Grease, and “Can’t Take My Eyes Off You” that was covered by hundreds of artists, from The Pet Shop Boys to Muse. Younger generations got to know Valli from the remarkable musical “Jersey Boys” that tell the story of the band that is responsible for songs that became a part of our life’s soundtrack for over four decades and was turned into a movie which was directed by Clint Eastwood.
// 							</p>

// 							<p>
// 								Ever since he began, Frankie has been performing all over the world, and soon the magic will come to Tel Aviv for one unforgettable show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:12,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Unite With Tomorrowland",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											29.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tomorrowland.com/en/unite-israel/en/welcome">
// 											www.tomorrowland.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/12/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous Tomorrowland festival might take place in Belgium, but Tel Aviv is also up for the party! Unite with Tomorrowland brings the party to the hottest city in the Middle East with live connection from the Tomorrowland Mainstage, live local and international DJ’s on the UNITE stage and of course – the magical Tomorrowland atmosphere.
// 							</p>
// 							<p>
// 								The live connection with the Mainstage in Belgium will give the People of Tomorrow the chance to connect with the crowd in Israel and vice versa. 3 mainstage headliners will be broadcasted live on a unique UNITE with Tomorrowland stage and special effects will be synchronized with the show in Belgium, creating a special global connection.
// 							</p>

// 							<p>
// 								The main headliners in Belgium will be Armin Van Buuren who has won best trance DJ at the DJ Awards 9 years in a row, was ranked among the world’s top 4 DJ’s at DJ Magazine 13 years in a row, the known electro-house duo Dimitri Vegas & Like Mike and the house sensation KSHMR. On the UNITE stage in Israel the DJs will be Steve Angello who won the DJ award for best house in 2010, the Israeli trance artist Alien Project, DJ Tomer Maizner, Dor Dekel, Teamworx, and TRIPL.
// 							</p>

// 							<p>
// 								EUnite with Tomorrowland isn’t just a livestream, it’s a one of a kind show that allows you to escape reality and join the magical world of tomorrow.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:13,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Chainsmokers",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											NEAR Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											3.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.thechainsmokers.com/">
// 											www.thechainsmokers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/13/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Tel Aviv is known for its great dance scene, so it makes perfect sense that the hottest DJ/production duo that everyone is talking about to come to get the city on its feet! The duo is responsible for many current hits such as “Don’t let me go”, “Roses”, and their recent collaboration with Coldplay “Something Just Like This”, and they will perform in Israel as part of their international tour “Memories Do Not Open”.
// 							</p>
// 							<p>
// 								The Chainsmokers consists of Andrew Taggart and Alex Pall. The duo performed live for the first time as the opening for Timeflies in 2014, and their single "#Selfie" was re-released at the same year, leading to breakthrough success as "#Selfie" became a worldwide hit and peaked on the Dance/Electronic chart. In 2015 they released their first EP “Bouquet”, featuring “New York City”, “Until You Were Gone, “Good Intentions” and “Roses”, all of which climbed the international charts and became major hits.
// 							</p>

// 							<p>
// 								A year later, the duo released their singles “Don’t Let Me Down” featuring Daya, “Inside Out”, featuring Charlee, and “Closer” featuring Halsey. The latter peaked at number one in the United Kingdom and the United States. Their success didn’t stop there and after releasing “All We Know” featuring Phoebe Ryan, they were ranked 18th in DJ Magazine’s annual list of “Top 100 DJ’s” in 2016. The same year the duo won favorite electronic/dance music artist at the American Music Awards and top dance/electronic artist at the Billboard Music Awards. A year later “Closer” also won top hot 100 songs, top collaboration and top electronic/dance song at the same Awards ceremony.  “Don’t Let Me Down” also won best dance recording in 2017 at the Grammy awards.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:14,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Dire Straits Experience",
//         smltitle: "Get a shiver in the dark in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.09.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.direstraitsexperience.com/">
// 											www.direstraitsexperience.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/14/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								25 years have passed since Dire Straits disbanded and we last heard that unmistakable sound of Mark Knopfler’s guitar…
// 							</p>
// 							<p>
// 								Close your eyes and get transported back to an original Dire Straits gig. Beautiful inspiring tracks, quality sound, amazing atmosphere, spine tingling riffs, vocals, instrumentals and an outstanding performance.
// 							</p>

// 							<p>
// 								After selling over 25,000 tickets in Israel within the past three years, and in light of the high demand for yet another show, The Dire Straits Experience are coming to Tel Aviv for only one night.  A single performance on the 14th of September at the Menora Mivtachim Arena.
// 							</p>

// 							<p>
// 							   The Dire Straits Experience was founded by saxophonist Chris White after their successful debut playing for a charity event at the Royal Albert Hall where members of the legendary band got back together on stage. News travelled fast, and an increasing global demand to hear the most dramatic songs in rock history played live eventually led to a worldwide tour.
// 							</p>

// 							<p>
// 							    Chris White, who recorded and performed with the rock legends for over a decade, joined Dire Straits for their record breaking “Brothers in Arms” world tour in 1985. This included their famous performance at Live Aid and later the renowned Nelson Mandela 70th birthday concert. White has played with some of the greatest rock stars the world has known, such as Paul Mccartney, Joe Cocker, Mick Jagger, Robbie Williams and many others. Joining Chris White is a stellar band consisting of some of the finest professional musicians the UK has to offer.
// 							</p>

// 							<p>
// 							   “When I was first approached to put together a band to play Dire Straits songs, I didn’t believe it would be possible to find someone who would be able to stand in Mark’s shoes without sounding like an imposter. I was wrong. In Terence Reis, I think we may have found the only person on the planet that is able to play and sing like Mark but maintain his own integrity and identity.”
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:15,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alan Parsons",
//         smltitle: "The man that said no to Pink Floyd, live in TA",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											11.11.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.alanparsonsmusic.com/">
// 											 www.alanparsonsmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/15/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The musical legend Alan Parsons and his band are coming to Israel for two shows, the first at the Congress Centre in Haifa and the second at the Menorah Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 								Parsons has a large following in Israel. In fact, this will be his third visit to the country in order to play on stage. This time they’ll be performing their new “I Robot” tour, commemorating 40 years for the release of the similarly titled mythological album in 1977. You can expect to hear all of their greatest hits of course.
// 							</p>

// 							<p>
// 								Alan Parsons is a renowned musician and one of the most influential musical producers in history. He started out as a sound technician working in the notorious Abbey Road recording studio. Alan became famous after helping to produce Pink Floyd’s masterpiece album “Dark Side of the Moon”. He has worked as a sound technician with others such as The Beatles, Wings, Al Stewart and many more.
// 							</p>

// 							<p>
// 							   In 1975, Pink Floyd invited him to work on their next album “Wish You Were Here”. Alan declined the offer in order to form his progressive rock band “The Alan Parsons Project”. The band succeeded immediately, receiving international acclaim for their huge hits “Eye in the Sky”, “Time” and “Old and Wise” to name a few.
// 							</p>

// 							<p>
// 							   An accomplished vocalist, keyboardist, bassist, guitarist and flautist receiving gold and platinum awards from many nations, Parsons also has ten Grammy Award nominations for engineering and production. Up until today The Alan Parsons Project is one of the most popular events in Europe, with tickets being sold out within hours.
// 							</p>

// 							<p>
// 							   Come indulge your ears and listen firsthand to some of the classics of our time. You can catch the concerts either in Haifa on the 9th of November or in Tel Aviv on the 11th of November.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:16,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Bryan Adams",
//         smltitle: "Bryan Adams to warm our winter with 3 shows",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv & Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											4+5+6.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.bryanadams.co.il/">
// 											 www.bryanadams.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/16/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								With the summer days way behind us and the days getting shorter, a little winter comfort is necessary. What better way to warm up from the inside than with some romantic ballads and timeless rock anthems. Treat yourself (and someone you love) to a throwback of nostalgia from our younger days, reminding us those sweet moments of slow dancing, first crushes and innocent youth.
// 							</p>
// 							<p>
// 								The Canadian pop rock icon with hits spanning over four decades is coming to Israel for three consecutive shows! Two will performances in Tel Aviv on the 4th and 5th of December at the Menora Mivtachim Arena and one more concert in Jerusalem on the 6th of December at the Pais Arena.
// 							</p>

// 							<p>
// 								Born in 1959 in Kingston, Ontario, Bryan Adams’ music career took off in the early 80’s with the release of his third album “Cuts Like A Knife” which included the hit “Straight From The Heart”. It was his following album “Reckless” that skyrocketed his career and brought his rise to stardom with the hits “Run To You”, “Heaven” and “Summer of ‘69”. Following these hits Adams later brought us the U.S. Billboard Hot 100 number-one singles "Heaven", "All for Love" and "Have You Ever Really Loved a Woman?".
// 							</p>

// 							<p>
// 							  Besides topping the charts in North America and Europe, his songs were nominated for several Grammy, Golden Globe and Academy Awards. His records have collectively sold over 100 million copies worldwide, making him one of the best-selling music artists of all time.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   Make sure you don’t miss this time-defying legend.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {
//         id:17,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Chris Rock",
//         smltitle: "Coming to Tel Aviv to rock your world ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											8+9.01.18
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.chrisrock.com/">
// 											 www.chrisrock.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/17/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Chris Rock, one of the greatest standup comedians of all time and the funniest people in the world is going on a rare, highly awaited tour for the first time in 9 years. One of his few stops will be in Tel Aviv.
// 							</p>
// 							<p>
// 								The hilarious comedian has put on a new live act, after nearly a decade of focusing on television and film. Chris Rock will make his first ever live on stage appearance in Israel as part of his 2017 “Total Blackout” tour.
// 							</p>

// 							<p>
// 								Born in 1965, he made his breakthrough on SNL (Saturday Night Live) starring next to Adam Sandler, David Spade and Chris Farley. Eddie Murphy helped accelerate his stardom by giving him a role in Beverly Hills Cop 2. Since then it’s been a long line of success, from Lethal Weapon 4, Madagascar, Scary Movie, Nurse Betty and the list goes on. He’s hosted the Academy Awards twice and has also written, directed and produced several movies and TV shows. Despite all this, Chris Rock has and always will shine brightest where he truly belongs, on stage with a microphone.
// 							</p>

// 							<p>
// 							  His previous standup acts: Bigger and Blacker, Born Suspect, Bring the Pain and Kill the Messenger all broke records and are considered to be classics, with bits that are still quoted today.
//                               Rock is often compared to the greatest comedians in the field, alongside Jerry Seinfeld, Louis CK and Dave Chappelle (all of which he’s also collaborated with).

// 							</p>

// 							<p>
// 							   He made it to the top 5 in Rolling Stone magazine’s 50 greatest comedians of all time.
// 							</p>

// 							<p>
// 							   When he gets on stage it’s like seeing a boxer, a preacher and a poet all bundled together into one man. Chris delivers powerful, fast paced, side-splitting punches. His views on relationships, race and politics challenge his listeners and make them rethink everything they know. Rock dares to cross boundaries with his material and is not afraid to shock and surprise.
// 							</p>

// 							<p>
// 							   In an interview he recently gave to Rolling Stone magazine, he talked about his divorce after 18 years of marriage and how he decided to devote himself to standup again. According to him, these events gave rise to the world tour in which he will be performing in Tel Aviv.
// 							</p>

// 							<p>
// 							   Catch Chris live on January 8th at the Menorah Mivtachim Arena.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:18,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Patricia Kaas",
//         smltitle: "The great French singer returns to the white city once again",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.patriciakaas.net/">
// 											  www.patriciakaas.net
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/18/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous French singer and actress Patricia Kaas is coming back to Tel Aviv for the third time after her previous performance three years ago became a huge success and recieved incredible reviews. Kaas is considered one of the all-time most successful French singers and her music is a mix of pop, cabaret, jazz, and chanson. She started her career in the late 80’s and very quickly she climbed the charts in France.
// 							</p>
// 							<p>
// 								Kaas’s first single “Mademoiselle chante le blues” that came out in 1987 became a huge hit and got to the top 10 in the French chart. A year later she released her second single “D’Allemagne”, followed by her first album “Mademoiselle chante…” that was ranked number two at the French chart. The album sold over 100,000 copies within less than two months and became a gold album. It didn’t take long and within less than three months more than 350,000 copies were sold and it became a platinum album. Kaas received a platinum album status in Belgium, Switzerland and Canada as well, and at the same year she won the most important French music award – Victories de la Musique.
// 							</p>

// 							<p>
// 								Since then the French phenomenon sold more than 17 million albums worldwide. Her third album “Je te dis vous” brought her major success in Germany, Belgium, Switzerland, Canada, Russia, Finland, Ukraine and Korea. In 2002 she acted in a movie for the first time, it was “And now… Ladies and Gentlemen” in which she performed with the British actor Jeremy Irons. In 2009 she represented France at the Eurovision contest and got to the 8th place.
// 							</p>

// 							<p>

//                                    Patricia Kaas is responsible for many hits and her songs became a part of our lives. The talented musician is coming back to Tel Aviv to sing her famous repertoire and bring back the nostalgia to the nonstop city.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:19,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blue Man Group",
//         smltitle: "The phenomenal musical group is returning to Tel Aviv once again for a show like no other!  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											 7-23.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.blueman.com/">
// 											  www.blueman.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/19/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Blue Man Group is coming to Tel Aviv as a part of their 25 years of living in full-color tour! This is a show unlike anything you have ever seen before that combines music, theater, art and technology.
// 							</p>
// 							<p>
// 								Originally Formed in New York in 1988 by three close friends, Chris Wink, Matt Goldman and Phil Stanton, Blue Man Group originated as a celebration of the end of the 1980s. The three men wore blue masks and led a procession that included the burning of a Rambo doll and a piece of the Berlin Wall. They caught the eye of an MTV reporter and gained attention. They started with small acts on the streets of New York, growing into shows at downtown clubs, eventually becoming a full performance at the Astor Place Theatre in 1991.
// 							</p>

// 							<p>
// 								In 1999 the band released its first gold album “Audio” and it was nominated for the Grammy Award for Best Pop Instrumental Performance. Their second album, “The Complex” (2003), features collaborations with various musicians like Gavin Rossdale, Dave Matthews and many others. It charted four songs on the Billboard charts. In 2006 they released “Live at The Venetian – Las Vegas” which was an iTunes exclusive, and their most recent album, “THREE”, came out in 2016 and was also nominated for the Grammy Award.
// 							</p>

// 							<p>

//                                  Currently, the Blue Man Group is performing on a regular basis in five theaters around the world- in Vegas, New York, Boston, Orlando and Berlin. They recently launched their new book “Blue Man World” that tells the story of the blue man from their perspective.  Three blue people that will take you on a crazy adventure full of music, laughter and surprises. More than 35 million people worldwide have already seen them, not it’s your turn!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:20,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Sean Paul",
//         smltitle: "The international mega star is coming to make our summer sizzle!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv Outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.allseanpaul.com/">
// 											  www.allseanpaul.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/20/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Grammy winner dancehall artist, Sean Paul will return to Tel Aviv for a single hot hot hot hot performance.
// 							</p>
// 							<p>
// 								Sean Paul will arrive in Tel Aviv for the third time as part of his new international tour. The artist is currently storming the international charts with a string of hits that including collaborations with some of the most popular names in music including Sia, Anne-Marie and more.
// 							</p>
// 							<p>
// 							    His extraordinary voice, rhythms, catchy songs and super-polished productions all combine the winning recipe of the Grammy winner and international star - Sean Paul. Originally known as Sean Paul Ryan Francis Henriques, Sean Paul was born in Jamaica in 1973. His musical career soared in 2002 with the tremendous success of his second studio album, "Dutty Rock," mainly for the songs "Gimmie The Light" and "Get Busy" Hot 100 chart toppers). Sean Paul has managed to maintain his relevance in the music industry since breaking into fame in the year 2000 until now with a string hits such as Cheap Thrills, Rockabye, No Lie, and Body.
// 							</p>

// 							<p>
// 							   Sean Paul studied at the University of Technology in Jamaica with aspirations for a career in the hotel industry, but his passion for music took over. The single ‘Baby Girl’ was the first to mark his successful career as a recording artist and led to his debut album ‘Stage One’ at VP Records. To date, he has released six studio albums; the last five were all nominated for the Grammy Award.
// 							</p>
// 							<p>
// 							   The album "Dutty Rock," 2002, earned him the Grammy Best Reggae Album. "The Trinity," 2005, reached platinum status in Europe and the Recording Industry Association in the United States. His albums, "Imperial Blaze" in 2009 "Tomahawk Technique" in 2012, and the last one was released in 2014 - "Recent Full Frequency" – were all warmly received and highly acclaimed.
// 							</p>

// 							<p>

//                                   His hard work, perseverance, and dedication over the years have earned him several nominations for the Grammy and Billboard awards. His most notable accomplishments include An American Music Award, Mobo Awards, Soul Train Awards, MTV Music Awards, ASCAP Rhythm and Soul Music Awards, a Source Award and a BET Award.

// 							</p>

// 							<p>
//                                 Sean Paul maintains a multinational presence thanks to his collaborations with artists in a wide variety of genres such as EDM, Soca, Pop, Afro-Beat and Latin music. His icon status allows him to maintain an immense fan base in Latin America, Japan, Europe and the US and his relationship with the Spanish audience received a serious boost, following his collaboration with the singer Farruko in the single Passion Whine and of course the legendary collaboration with Enrico Iglesias ‘Bailando’ which became no.1 in 33 (!) countries and gained millions of views on YouTube.
// 							</p>

// 							<p>
//                                Sean's collaborations throughout his career include numerous international collaborations with hip-hop stars such as Busta Rhymes, Beyoncé, Rihanna, Keyshia Cole, Kelly Rowland, Juicy J, 2Chainz and Nicki Minaj.
// 							</p>

// 							<p>
//                                Sean Paul performs regularly on the biggest most respectable venues in the world and enjoys a huge following from a worldwide audience of all ages.
// 							</p>

// 							<p>
//                                His last performance in Tel Aviv received fantastic revues from critics and fans alike, and he is back on popular demand, promising to make the hot summer scorch even more with a what is guaranteed to be a party like no other!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:21,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "The Pretenders",
//         smltitle: "The legendary rock band and Chrissie Hynde are coming to rock out Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											23.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.thepretenders.com/">
// 											  www.thepretenders.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/21/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								For the past three decades Chrissie Hynde and The Pretenders stayed at the top of the British rock and won the hearts of millions of fans. Hynde took a long break from writing and recording new materials but after the raving reviews the band’s most recent album, “Alone” got, she and The Pretenders are back on a world tour and are now coming for one unforgettable show in Tel Aviv!
// 							</p>
// 							<p>
// 								The band started its way in the music world in England in 1978 and experienced numerous subsequent personnel changes, with Chrissie Hynde being the only consistent member. The original band was active until 1982 and released its first album (Pretenders) that was a success in the United Kingdom and the United States both critically and commercially. The band got to No. 1 in the UK with its single "Brass in Pocket", which was also successful in the US, reaching No. 14 on the Billboard Hot 100.
// 							</p>

// 							<p>
// 								Later on the band released nine more albums - Pretenders II (1981), Learning to Crawl (1984), Get Close (1986), Packed! (1990), Last of the Independents (1994) which was rated gold in the US, Viva el Amor (1999), Loose Screw (2002), Break Up the Concrete (2008) which was among the Top 40 album in the US, and The Pretenders’ most recent album - Alone (2016). During March 2005, the Pretenders were inducted into the Rock and Roll Hall of Fame. Among their most famous song one can remember “Brass in pocket”, “Hymn to her”, “Don’t get me wrong”, “I’ll stand by you”, and many others.
// 							</p>

// 							<p>

//                                   The Pretenders worked carefully on their new show and started their new tour at the Royal Albert Hall in London, which was full with fans that showed how much they missed the incredible band. Hynde and The Pretenders performed in music festivals all over the world, and they’ll start the second part of their tour right here in the rocking city of Tel Aviv, make sure not to miss it!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:22,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Cliff Richard",
//         smltitle: "The incomparable Cliff Richard coming back to Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											10.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.cliffrichard.org/">
// 											  www.cliffrichard.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/22/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Cliff Richard, the beloved British artist who previously performed in the fabulous city of Tel Aviv more than 20 years back, is coming back to the delight of his local fans.
// 							</p>
// 							<p>
// 								Over his long and illustrious career, the 72-year-old Cliff Richard has sold more than 260 million records worldwide and is best known for his tunes "Fallen angel Woman," "We Don't Talk Anymore," "The Young Ones," "Summer Holiday," and "Congrats" .
// 							</p>

// 							<p>
// 								Richard has a long list of hits and is responsible for many worldwide beloved songs. He has sold over 21 million singles in the UK and has become an intrinsic part of the nation’s soundtrack.
// 							</p>

// 							<p>

//                                  Richard has had eight US Top 40 singles, including the million-offering "Demon Woman" and "We Don't Talk Anymore". In Canada, Richard made a real splash during the mid-1960s, and again in the late 1970s and mid-1980s with a few singles and collections achieving gold and platinum status. He has remained a prominent music, film, and TV character in Australia, New Zealand, South Africa, Northern Europe and Asia, and has a strong following.

// 							</p>

// 							<p>
// 							   Throughout his career, spanning over 50 years, Richard has amassed numerous gold and platinum records and awards, including three Brit Awards—winning Best British Male Singer twice and the Brit Award for Outstanding Contribution to Music, as well as two Ivor Novello Awards. He has had more than 130 singles, collections and EPs make the UK Top 20, more than any other artist.
// 							</p>

// 							<p>
// 							   Richard has had 67 UK top ten singles, including one written for the great Elvis Presley.  He has had 14 UK No. 1 singles and is the leading vocalist to have had a No. 1 single in the UK in five back to back decades: the 1950s through to the 1990s.
// 							</p>

// 							<p>
// 							   This October, after much anticipation, Cliff Richard is coming to Tel Aviv to sing his mind-blowing songs live, in his unmatchable performing style. Come watch the living legend himself on-stage in the exciting city of Tel-Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:23,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "DGTL Festival",
//         smltitle: "An awesome digital celebration in the one of the world’s Digital Capitals",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/?skip_portal=1">
// 											  www.tlv-digital.nl
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/23/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The first ever of its kind in the country, the DGTL festival is a dream come true for the music and nightlife scene of this buzzing metropolis. The DGTL festival is set to be by far the biggest electronic music event held in Tel Aviv, which is considered one of the nightlife capitals of the world.
// 							</p>
// 							<p>
// 								DGTL Festival, making its Tel Aviv debut this October originates in Holland and takes place each year in the most trendy capitals including Amsterdam, Sau Paulo, and Barcelona.
// 							</p>

// 							<p>
// 								The festival is an innovative technology centered event showcasing some of the world’s greatest biggest names in the digital scene alongside new hot up and comers from the industry. Tickets are often sold out in advance, and dozens of DJs and leading artists show off their talents in this a multi-sensory experience of art, music, lighting and uncompromising production standards throughout the:
// 							</p>

// 							<p>

//                                The festival has a unique and electrifying atmosphere, and audiences will also get to enjoy a variety of food stalls, art, and meticulous sound.

// 							</p>

// 							<p>
// 							   The festival will include three stages featuring excellent music at any given moment.
// 							</p>

// 							<p>
// 							   The fantastic international line up is set to include:
// 							</p>

// 							<p>
// 							  Maslow Flux, Marcel Dettman, John Talabot, Red Access, Jennifer Cardini, Avalon Emerson, Young Marko, Yotam Avni, Otarki, Joba Jobsa and many others.
// 							</p>

// 							<p>
// 							  This huge production will be launched for the first time in October 2017. In addition to being an innovative music festival, DGTL is held under the theme of environmental preservation and sustainability and is considered the greenest festival in Europe. Also, DGTL festival promotes vegetarian food only and develops a unique program for recycling materials. Alongside the local audience, the festival will be marketed in 50 countries, and thousands of music fans from all over the world are expected to arrive in Tel Aviv to take part in the party.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:24,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Richard Clayderman",
//         smltitle: "The famous pianist returns to perform in Israel with all his unforgettable hits!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											17.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.clayderman.co.uk/">
// 											  www.clayderman.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/24/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Romance lovers, prepare yourselves – after his last show in Israel three years ago, the famous French pianist Richard Clayderman returns to the holy land as a part of his new tour that marks 40 years of an outstanding career!
// 							</p>
// 							<p>
// 								Clayderman recently turned 63 and he is one of the world’s most successful pianists with a rich and diverse career that started four decades ago. He recorded over 1200 songs and his biggest hit ever is “Ballade Pour Adeline” that was sold in 22 million copies in 38 different countries. Clayderman is considered one of the world’s most successful instrumental artists along with others like Kenny G and more.
// 							</p>

// 							<p>
// 								During his career, Richard Clayderman sold more than 85 million albums and had more than 340 gold and platinum albums. He created a new romantic style through a repertoire that combines his original melodies with classics and pop standards. The phenomenal artist devoted much of his time to performing, going as far as playing 200 shows in 250 days. The Guinness Book of World Records noted him as “the most successful pianist in the world”.
// 							</p>

// 							<p>

//                                His previous visits in Israel were extremely successful with multiple sold out concerts. In his upcoming shows in Israel, Clayderman will play a selection of his best pieces, including the 12 minutes of the “Titanic Symphony”, “Don’t Cry for Me Argentina”, “Love Story”, “Ballade Pour Adeline”, and song from other famous movies such as “West Side Story”, “Harry Potter Melody” and “The Schindler List”. Come listen to the outstanding pianist who has touched the heart of millions around the world!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:25,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Smokie",
//         smltitle: "Smokie, coming to light up the stage this fall in Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv + Jerusalim
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28+31.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://smokie.co.uk/Band">
// 											  www.smokie.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/25/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Smokie, the iconic British rock band is coming back to Tel Aviv to rock it out in the city this fall.
// 							</p>
// 							<p>
// 								Smokie initially rose to fame in the 1970's and is most know for its chart topping hits 'Living Next Door to Alice', 'Lay Back in the Arms of Someone', and "If You Think You Know How to Love Me.'
// 							</p>

// 							<p>
// 								The band has had 13 top twenty hits during the 1970s and has sold more than 30 million albums.
// 							</p>

// 							<p>

//                               Initially formed in Yorkshire, England, in 1966, Smokie hit the British pop charts a few times amid the late '70s with a fresh pop style.  The quartet recorded many singles amid the late '60s and mid '70s, and in 1975 hit number three in the U.K. with "If You Think You Know How to Love Me."

// 							</p>

// 							<p>
// 							   After another Top Ten hit, "Don't Play Your Rock’n’ Roll to Me,” the band made it big with three Top 20 hits, including "Living Next Door to Alice." Smokie hit number five both in 1977 ("It's Your Life") and 1978 ("Oh Carol(".
// 							</p>

// 							<p>
// 							   The band has performed in Tel Aviv several times and are returning shortly after their last visit to the non stop city with an extremely successful run two years ago. The Tel Aviv concert will be a part of the band’s new tour which includes England and many countries around Europe and which also includes musicians Martin Bullard, Mick McConnell, Mike Craft, Steve Pinnell and Terry Uttley.
// 							</p>

// 							<p>

// 							    Smokie’s songs have gained iconic status over the years and have been covered multiple times due to their catchy style. The band enjoys a strong fan base in the country and regularly fills every seat in the house in each of their performances. The band will be playing its greatest hits to the joy of their fans which will flock to see the rock legends in action in Tel Aviv.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:26,
//         bgImage :"/posts/bank/15/1.jpg",
//         mobBgImage :"/posts/bank/15/M.jpg",
//         title: "Foreigner",
//         smltitle: "The 80's are back to rock Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.foreigneronline.com/">
// 											  www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/26/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The 80's are coming back! The British-American hard rock group is returning once again to the amazing city of Tel Aviv. The band is returning to Israel again after 3 sold out concerts in the past – one in 2014 and two in 2016, which got incredible reviews.
// 							</p>
// 							<p>
// 								Foreigner was founded in New York in 1976 by veteran English musician Mick Jones, ex-King Crimson member Ian McDonald and American vocalist Lou Gramm. The band focused more on commercial rock and is remembered mostly for its soft ballads that topped the charts worldwide.
// 							</p>

// 							<p>
// 								The rock group released its debut album in 1977 which provided one of its most popular hits "Cold As Ice", but the band's real breakthrough happened in the early 1980's when they released the album "4". Their success continued as they released their next album "Agent Provocateur" in 1984, as well as in their last one- "Can't Slow Down", in 2009.
// 							</p>

// 							<p>

//                               The band has sold over 80 million records worldwide in the past 3 decades, out of them 37.5 were sold in the United States alone, making it one of the bestselling bands in the history. Their most memorable hits include "Waiting for a Girl Like You", "I Want to Know What Love Is", "Urgent", "Juke Box Hero", and "That Was Yesterday".

// 							</p>

// 							<p>
// 							  Come rock with the American-British legend and bring the 80's back to life in a one of a kind concert!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:27,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Carcass",
//         smltitle: "The British metal legends are coming <br>to rock the city that never sleeps!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											09.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/OfficialCarcass/">
// 											  facebook.com/OfficialCarcass
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/27/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The British extreme metal band was formed in 1985. They started as a school band by Bill Steer and Ken Owen, and the latter left the band soon after. Steer then joined the D-beat band Disattack and played with drummer Middie, bassist Paul and the lead singer Andrew Pek. The band later changed its name to Carcass as the members changed their musical direction. The band recorder only one album with Pek, who changed his name to Sanjiv, and shortly after "Flesh Ripping Sonic Torment" was released he left the group.
// 							</p>
// 							<p>
// 								The vocal duties were shared between Walker, Steer and Owen, and together they recorded a debut album in only four days.  The band wasn't pleased with the poor production of their album "Reek of Putrefaction" but it became a favorite of Radio 1 DJ John Peel. His interest in them made them participate in his first "Peel Session", in which they released materials for their second album.
// 							</p>

// 							<p>
// 								Carcass are considered to be the pioneers of the grindcore genre, although their early work is considered to be more splatter death metal, hardgore and goregrind. The band also became one of the pioneers of melodic death metal with their album "Heartwork" which was released in 1993. Their lyrics usually focus on animal rights issues, as both Jeff Walker and Bill Steer are vegetarians.
// 							</p>

// 							<p>

//                               In 2013 the band signed with Nuclear Blast, and in Japan they signed with Trooper Entertainment for the release of their new album. They released "Surgical Steel", which received extremely positive reviews and earned Top 50 position on the US Billboard 200 charts. Soon afterward they headlined Damnation Festival in Leeds and then performed at 70000 Tons of Metal in 2014 and headlined the Agglutination Festival the same year.

// 							</p>
// 							<p>
// 							   The band is coming to give only one show in the nonstop city of Tel Aviv, which is guaranteed to be an extraordinary experience for all the metal fans out there, make sure to get your ticket now!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:28,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Kygo",
//         smltitle: "The Norwegian house phenomena for the first time ever in Tal Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.kygomusic.com/">
// 											  www.kygomusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/28/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Kygo, originally a Norwegian pianist, became a tropical house music producer in no time. "Spotify" announced him as the biggest discovery of 2015 after his songs "Firestone" and "Stole the Show" were played over a billion times. Both of these songs also received gold and platinum status in 16 countries.
// 							</p>
// 							<p>
// 								His first album, "Cloud Nine", reached the top of the dance albums chart on "Itunes" and also on the electronic albums chart of Nielsen Soundscan. The house sensation preformed in the most popular TV shows in the United States such as "The Late Late Show" with James Corden, "The Tonight Show", "Good Morning America" with Jimmy Fallon and on Ellen Degeneres. Moreover, he was on the cover of the biggest magazines – "The Billboard", "Haute Living Magazine", "LA Times", "USA Today", "The Wall Street Journal", "The Rolling Stones", "Forbes" and more.
// 							</p>

// 							<p>
// 								Kygo started his musical journey at the age of 6 when he started learning how to play the piano. It took almost a decade for the classical music to step aside and for the new love in his life to take over – Electronic music. He only decided that he wants a career in the music industry a moment before he was about to graduate from his economics and business degree.
// 							</p>

// 							<p>

//                               His first significant breakthrough was with the hit "Firestone" that shortly grabbed the attention of tens of millions of listeners. Aviici played it in his sets and in festivals. Afterwards Coldplay's lead singer, Chris Martin, gave him permission to create a remix of their song "Midnight". Kygo's unique sound led him to incredible achievements, such as the hit "ID" that was featured in Ultra Festival's official trailer and in the playlist of FIFA 2016.

// 							</p>
// 							<p>
// 							  The extraordinary house sensation is coming to rock Tel Aviv for the first time ever, for one show only. His shows in New York and Hollywood were sold out, and the reviews were incredible. This is guaranteed to be a night to remember, you definitely want to be there!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:29,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Led Zeppelin 2",
//         smltitle: "Don’t Miss the Zeps in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv, Haifa and Be'er Sheva
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											07-10.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://zep2.com/">
// 											  www.zep2.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/29/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The tribute band from Chicago Led Zeppelin 2, which was named after the mythological band's second album, is coming to Israel for 4 shows only. Come feel the old Led Zeppelin vibes and kick it with the ultimate Led Zeppelin experience here in rocking Tel Aviv
// 							</p>
// 							<p>
// 								Led Zeppelin 2 have been performing  for over a decade and are considered to be the ultimate Led Zeppelin experience. The band consists of 4 musicians from the indie-rock, jazz and metal scene in Chicago. The lead singer, Bruce Lamont, who took the place of the legendary Robert Plant, is also a part of the avant-garde metal group "Yakuza", and he has collaborated with bands like "Dyslexic Apaches", and "Circle of Animals". His solo album "Feral Songs for The Epic Decline" was recently rated among SPIN magazine's top 20 metal albums.
// 							</p>

// 							<p>
// 								Greg Fundis, the group's drummer, is playing with leading musicians among which one can find the singer and jazz guitarist George Benson, the musician Joey De Francesco, the saxophonist Joe Lovano and more. The bassist Matthew Longbons participates in more than 200 shows a year next to leading international artists such as Alice Cooper and Matt Walker from the "Smashing Pumpkins". Paul Kamp, the group's guitarist, is known mostly from his collaboration with "Busker Soundcheck", a well-known alternative rock band.
// 							</p>

// 							<p>

//                              Led Zeppelin is considered until today to be one of the most revolutionary, influencing and successful bands in the history. They sold more than 300 million albums worldwide, with 'Led Zeppelin IV' alone selling over 37 million copies and being ranked as the third all-time best-selling album in the U.S. All 9 of the band's albums were rated in the top 10 in the U.S. chart, and 6 of them even top over the top 5. Their second album that was recorded during their first tour was a huge success both in the U.S. and in the UK, and it featured the hit 'Whole Lotta Love' that sold over a million copies.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:30,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Oh Wonder",
//         smltitle: "Live in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											16.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://ohwondermusic.com/">
// 											  www.ohwondermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/30/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Oh Wonder consist of Josephine Vander Gucht and Anthony West. In 2014 they started releasing singles every month and then they combined all of them and released a debut album that's named after them and sold over 500 million copies. This year they released their second album, "Ultralife", which had even a bigger success and reached the Top 10 in the UK charts.
// 							</p>
// 							<p>
// 								In 2015 the duo was announced by Billboard as one of the 5 biggest breakthroughs. They come to Israel this year after a long tour and performing in the biggest festivals around the world as part of the promotion of their new album, which includes hits such as "Without You" and "Drive".
// 							</p>

// 							<p>
// 								Gutcht and West played sold out shows in New York, Los Angeles, Paris and London, and now they're coming for one show only to give the people of Tel Aviv a taste of their alt-pop hits. The successful duo is guaranteed to get you dancing and give the ultimate pop experience, this will be one night in Tel Aviv you are sure to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:31,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Ott & The All Seeing I",
//         smltitle: "Electro explosion in the city that never sleeps",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											15.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://ottsonic.com/">
// 											  www.ottsonic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/31/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Ott and the All Seeing I are coming to take Tel Aviv by a storm this December.
// 							</p>
// 							<p>
// 								Ott is considered to be one of the pioneers of calm, groovy electronic music and likes to record the sounds of nature in his mobile studio, with which he tours England. The British record producer and musician has worked with Sinead O'Connor, The Orb, Brian Eno and Embrace, and has achieved recognition since 2002. He's known for psychedelic dub tracks and his collaborations with other artists. He has released two albums on Twisted Records – "Blumenkraft" in 2003 and "Skylon" in 2008, and two other albums on Ottsonic – "Mir" in 2011 and "Fairchildren" in 2015.
// 							</p>

// 							<p>
// 								The electro genius performed at the Glastonbury Festival in 2007, and then in 2011 he performed at Glade Festival, a show that was described as "the perfect opening act" in an article at Virtual Festivals. The same publication also called Ott a "Psy-dub maestro" and ranked his performance 10/10. The Israeli crowd was first exposed to Ott in the early 2000's with the album "Hallucinogen in Dub", the remix album he produced for Simon Posford. All the albums he released later only enhanced the effect he has with his powerful and addictive music.
// 							</p>

// 							<p>
// 							   The All Seeing I are an English electronic music group from Sheffield, consisting of Dean Honer, Jason Buckle and DJ Parrot. Their first single "I Walk" came out in 1997, but it was only in the following year that they gained mainstream commercial success with the song "Beat Goes On". The trio worked with artists such as Tony Christie, Jarvis Cocker, Babybird, Phillip Oakey and many others.
// 							</p>

// 							 <p>
// 							    Ott has performed Tel Aviv twice in the past and his shows received incredible reviews. This is guaranteed to be a one of a kind night that you definitely don't want to miss!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:32,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Take That",
//         smltitle: "Take That – Taking Tel Aviv By Storm!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://takethat.com/">
// 											  www.takethat.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/32/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The legendary British pop band is this coming November to rock Tel Aviv for one show only!
// 							</p>
// 							<p>
// 								Take That started in Manchester in 1990 and currently includes Mark Owen, Gary Barlow, and Howard Donald. The original band also featured Robbie Williams and Jason Orange. Barlow is the band's lead singer and songwriter, while Owen and Donald act as backing vocals.
// 							</p>

// 							<p>
// 								Their most memorable songs include "Pray" which won The Guardian Music Award for Best Number 1 Single, "Back For Good" which won BRIT Award for Best British Single, "Everything Changes" and "Could It Be Magic." The band released 28 top 40 singles and 17 top 5 singles in the United Kingdom, out of which 12 reached number one, and they have 7 number one albums. Internationally, the band released 56 number one singles and 37 number one albums. They won 8 Brit Awards, including awards for Best British Live Act and Best British Group.
// 							</p>

// 							<p>
// 							   The British pop sensation set the record in 2011 for the fastest-selling tour of all time in the United Kingdom with "Progress Live", beating their own personal record from 2009 with their "Circus Live Tour". They were named as Amazon's top-selling music artist of all time, and in 2012 Forbes announced them as the fifth highest-earning music stars in the world. During the same year, the Official Charts Company announced the biggest-selling singles artists in the British music chart history with Take That being placed at 15th overall and having four of the best-selling albums of the millennium, which makes them the most successful boy band in the UK chart history.
// 							</p>

// 							 <p>
// 							   The band will come to Israel as a part of its international tour in order to promote its last album "Wonderland". Their previous tours have gotten raving reviews, with "Progress" winning Audio Pro International Awards for Best Live Sound Event and Audio Pro International Awards Grand Prix Award. Their performance in Tel Aviv will for sure be a one to remember, don't miss out!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:33,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Kooks",
//         smltitle: "Getting it on with the Kooks in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27-28.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.thekooks.com/">
// 											  www.thekooks.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/33/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Kooks – one of the ultimate British rock/pop bands of the century are coming this January to rock Tel Aviv as a part of "The Best of The Kooks" tour that marks a decade to their existence.
// 							</p>
// 							<p>
// 								The band was formed in Brighton, UK, in 2004 by lead singer Luke Pritchard and consists of Hugh Harris the lead guitarist, drummer Alexis Nunez and bassist Peter Denton. The band released its debut album, "Inside In/Inside Out" in 2006, which included hits such as "Ooh La" and "She Moves in Her Own Way" and achieved quadruple platinum status in the UK within a year and also abroad in the form of a platinum certification in Australia and two times platinum in Ireland.
// 							</p>

// 							<p>
// 								The group released its second album "Konk" in 2008 which debuted at number one on the UK Albums Chart and recorded first week sales of 65000, achieving gold status in both the UK and Ireland, which continued to establish their reputation as one of the world's most beloved brit-pop and post-punk bands. In 2011 their third album "Junk of the Heart" came out, followed by "Listen" in 2014 which debuted at No. 16 on the UK Albums Chart. Besides the fact that they quickly signed with "Virgin Records" only 3 months after forming, they also won several awards, such as MTV's best band of 2006 award, Best UK & Ireland Act at the MTV Europe Music Awards 2006 and even a nomination for the famous Brits award.
// 							</p>

// 							<p>
// 							  The band's music is primarily influenced by the 1960s British Invasion movement and post-punk revival of the new millennium. The Kooks have experimented in genres such as pop, reggae, ska, Britpop, rock, funk and hip-hop, and released songs that were describes as "catchy as hell".
// 							</p>

// 							 <p>
// 							  The Kooks are known for their amazing sold out shows and this one is due to be no different, so make sure to get your ticket now!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:34,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Willy William and Farruko",
//         smltitle: "The reggaetón superstars coming to get you movin’ in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											  Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.reggaetontelaviv.co.il/indexEN.php">
// 											  www.reggaetontelaviv.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/34/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The reggaetón superstars coming to get you movin’ in Tel Aviv!
// 							</p>
// 							<p>
// 								Willy William and Farruko, the reggaeton megastars are coming this fall to perform as a part of the "Reggaeton Tel Aviv" festival and get the people of Tel Aviv on their feet in one extraordinary show only!
// 							</p>

// 							<p>
// 								Farruko , the 26-year-old world famous reggaton singer comes from Puerto Rico. He started his professional career in 2009 through Myspace. Since then, he released six albums and collaborated with Sean Paul, Daddy Yankee, Maluma, Don Omar, Shaggy, Nicky Jam, Ky-Many Marley, Chino&Nacho, J Balvin, Ozuna and many other successful reggaeton legends, and he was nominated for the Latin Grammy awards in 2012. His hits got millions of views on Youtube, and among them, one can find the famous "6 AM", "Passion Wine", "Me Voy Enamorando", "Krippy Kush", "Sunset" and "Chillax".
// 							</p>

// 							<p>
// 							  The 36-year-old singer, producer and DJ, Willy William is coming to Tel Aviv all the way from France. He's known for his remixes and collaborations with dance artists. His big breakthrough was in 2003 when he collaborated with DJ Flex and released his hit "B Boyz Shake da Body" and right afterwards his next song "Tragedie" and the name "Lord William". His most famous hits are "EGO" and "Mi Gente" which topped the charts in many radio stations worldwide, including Israel.
// 							</p>

// 							 <p>
// 							  Come get the addictive reggaetón vibes in you and dance the night away in the city that just won't quit!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:35,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Buena Vista",
//         smltitle: "The ultimate Cuban experience in Tel Aviv & Jerusalem!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											21-26.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.pasion-de-buena-vista.com/">
// 											  www.pasion-de-buena-vista.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/35/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   The ultimate Cuban experience in Tel Aviv & Jerusalem!
// 							</p>
// 							<p>
// 								After 600 shows worldwide -  the extraordinary Buena Vista Cuban sensation is coming for first time to give Tel Aviv and Jerusalem a taste of Cuba!
// 							</p>
// 							<p>
// 								The show is a one-of-a-kind experience that expresses love to the Cuban culture with all the known Cuban hits such as La Vida es un Carnaval. The Buena Vista Band includes 11 talented musicians, working together with a group of unbelievable dancers to provide an experience you never had before.
// 							</p>

// 							<p>
// 								The show will be held in two separate dates in Tel Aviv and Jerusalem, both awesome choices offering a huge host of activities and experiences in a unique unrivaled atmosphere. Jerusalem is known for its rich history, interesting architecture and incredible cultural diversity, while Tel Aviv is known for its fast tempo, warm exotic weather, amazing beaches and non-stop nightlife! Whatever city you'll choose- you visit is bound to be exciting and packed with unforgettable experiences!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:36,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Jerry Seinfeld",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.jerryseinfeld.com/">
// 											  www.jerryseinfeld.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/36/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Comedy King Closing 2017 in Tel Aviv!
// 							</p>
// 							<p>
// 								Jerry Seinfeld, the undisputed king of American comedy is returning to Tel Aviv for two performances which will be held on the same night in Tel Aviv.
// 							</p>
// 							<p>
// 								Home to incredible comedy venues a sought-after location for many international comedians such as Eddie Izzard, Jim Jeffries, Chris Rock and many others, Tel Aviv has a hedonistic vibe, incredible vibrancy and energy and a liberal loose spirit making in a comedy heaven.
// 							</p>

// 							<p>
// 								Seinfeld, hailed as one of the top comedians of his generation has without a doubt shaped the way we watch television and sitcoms, with his iconic show “Seinfeld” which ran from 1990-1998 and reigned over primetime TV for nearly a decade.
// 							</p>

// 							<p>
// 							   However, Seinfeld is a man loyal to his roots and has often declared that performing live is one of his favorites and he’s coming to Tel Aviv to do Just that.
// 							</p>

// 							<p>
// 							  This December, Seinfeld will strut his stuff onstage live in his hilarious laugh- a – second style, performing two consecutive shows in the nonstop city of Tel Aviv, and what better city is there to close the 2017 with a smile?
// 							</p>

// 							<p>
// 							   For visitors coming to check out Seinfeld’s show, the city of Tel Aviv, with its winter sunshine and world-famous nightlife is without a doubt THE place to spend a fantastic and absolutely unforgettable Tel Aviv Style New Year’s Eve.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:37,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alt-J",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											29.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.altjband.com/">
// 											  www.altjband.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/37/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  The British indie band is returning to Tel Aviv once again after their last successful sold-out show in Israel two years ago. The band was formed in 2007 in England, and their debut album “An Awesome Wave” was released in 2012 and won the Mercury award the same year. The band is a combination of electro-pop, psychedelic folk, African beats, post-dubstep and rock n’ roll. The band members met through their mutual love for Radiohead while they were in college, and their sound was affected by the fact that they weren’t allowed to use a bass guitar and drums when they were students.
// 							</p>
// 							<p>
// 								The band comes to rock Tel Aviv this spring and invites fans from all over the world to come and enjoy the wonderful alternative music scene that the city that never sleeps can offer. From extraordinary art galleries to unique theatre shows to live music concerts – the cultural scene in Tel Aviv is one of a kind. It’s a home for many musicians and artists, and now it welcomes every culture lover.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:38,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ozzy Osbourne",
//         smltitle: "Ozzy O -  coming to say goodbye to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											08.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.ozzy.com/">
// 											  www.ozzy.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/38/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Ozzy O -  coming to say goodbye to Tel Aviv!
// 							</p>
// 							<p>
// 								Ozzy Osbourne, the world-famous metal legend returns to Tel Aviv for the last time as part of his farewell tour. While known to younger audiences mainly from the reality show “The Osbournes”, Ozzy was already a musical icon and a huge star since way before – from his role as the lead singer for Black Sabbath, to being the headliner in the international metal festival that was named after him, the “Ozzfest”.
// 							</p>

// 							<p>
// 							   After 2500 shows all around the world, the star comes to say goodbye to his fans in Tel Aviv, a city known around the world for its rich rock and metal scene. Being the most liberal city in Israel, Tel Aviv is always full of action and attracts both younger and older visitors who craving a taste of the underground culture. The rocking city is full of bars with rock themes, alternative clubs, live music venues and is known to attract music lovers from every country.
// 							</p>

// 							<p>
// 							   Don’t miss your chance to see the metal star for the very last time, make sure to get your ticket now and come rock it with ozzy in rockin’ Tel Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:39,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jim Jefferies",
//         smltitle: "Jim Jefferies Kicks Off 2018 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											16.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://jimjefferies.com/">
// 											  www.jimjefferies.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/39/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Jim Jefferies Kicks Off 2018 in Tel Aviv!
// 							</p>
// 							<p>
// 								One of the most popular comedians worldwide, Jim Jefferies, is returning to Tel Aviv after only a year. He will be kicking off 2018 and unleashing his famous humor with new material in a new show, “The Unusual Punishment Tour”.
// 							</p>

// 							<p>
// 							  The show will take place on a special 360-degree platform at the Menorah Mivtachim Hall in Tel Aviv, the perfect location for a comedian of his stature. Catching the show with the hilarious Australian performer is just the right excuse to come visit Tel Aviv, renowned for its exciting atmosphere and diverse nightlife scene.
// 							</p>

// 							<p>
// 							  Take the opportunity to visit one of the exciting bars or clubs which attract top International DJs, or visit one of the smaller neighborhood bars or cafes with its atmospheres to suit all tastes. Whether it’s food, drink or dancing you are after, Tel Aviv has it all.
// 							</p>

// 							<p>
// 							    After creating, writing, producing and starring in the critically acclaimed FX series, Legit, Jefferies and his material have gained a cult following. His voice has become well-known in late-night entertainment, making his show a must-see in Tel Aviv. Those coming to the Tel Aviv for Jefferies’ show will enjoy some good laughs, set on a background of stunning warm winters and an exciting night vibe.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:40,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Gerard Depardieu & Isabelle Adjani",
//         smltitle: "“Love Letters” Coming to Tel Aviv from France!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/40/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 “Love Letters” Coming to Tel Aviv from France!
// 							</p>
// 							<p>
// 								From France with love! French actors, Gerard Depardieu and Isabelle Adjani, will be performing “Love Letters” in March in Tel Aviv. Written by the late A.R. Gurney, the show has been performed on and off-Broadway by actors and actresses around the world.
// 							</p>

// 							<p>
// 							 The Pulitzer Prize-nominated show is now coming to Israel and will be performed by Gerard Depardieu and Isabelle Adjani in French, with Hebrew and Russian subtitles. With the performance taking place in Tel Aviv, visitors to the city will have the chance to enjoy some of the exotic and exciting nightlife that makes Tel Aviv so popular.
// 							</p>

// 							<p>
// 							  With restaurants to suit all palettes, dinner is just the thing for before the show, and with a nightlife that just starts to come alive around midnight, those who are looking for some adventure after the show will have plenty of options open to them. Anyone visiting the city especially for the show is sure to come away dazzled, both by the liveliness of the atmosphere and from the two well-known French stars.
// 							</p>

// 							<p>
// 							   While this is Adjani’s first trip to Israel, Depardieu has been here a number of times, and this occasion is sure to be memorable.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:41,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "A-HA",
//         smltitle: "An Electric Summer with A-HA!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											21.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://a-ha.com/">
// 											  www.a-ha.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/41/1.gif"} class="img-responsive" />
// 							</div>

// 							<p>
// 							 An Electric Summer with A-HA!
// 							</p>
// 							<p>
// 								Israel will be treated to an exciting performance from Norwegian band, A-HA, in June, 2018. Coming to Israel as part of their Electric Summer Tour 2018, the band will perform in Tel Aviv at the Exhibition Grounds in a show that promises to be a hit.
// 							</p>

// 							<p>
// 							 Formed in Oslo in 1982, A-HA has been talked about for more than three decades, and since their hit “Take On Me” in 1985, they have grown to be one of the most popular Scandinavian bands in the world. While they originally split up in 2010, they have come back together again for a number of tours and Tel Aviv is honored to be among their stops this time around.
// 							</p>

// 							<p>
// 							 Fans of the band will be treated to an exciting performance by the well-known group, while having the chance to enjoy some of the best entertainment venues in the country. From museums to theatres, restaurants to clubs, there is something to suit everyone in the bustling city of Tel Aviv.
// 							</p>

// 							<p>
// 							  Take the opportunity to enjoy a walk along the brilliant beachfront as the city’s locals get ready for the summer sun, and enjoy the vibe as diverse cultures come together for the band’s latest show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:42,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ringo Starr",
//         smltitle: "Ringo’s All Starr Band Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											23-24.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.ringostarr.com/">
// 											 www.ringostarr.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/42/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Ringo’s All Starr Band Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								It’s been a year of stars in Tel Aviv and the latest concert to come to the dynamic city, has everyone talking! Ringo Starr will be coming to Israel as part of his European Tour and will be performing two concerts with his All Starrs Band at the Menorah Mivtachim Arena in June 2018.
// 							</p>

// 							<p>
// 							Starr, an English songwriter, singer and actor, first became famous as the drummer for the Beatles; however, since 1989, he has toured with his All Starr Band. The 77-year old released his 19th studio album in September, known as “Give More Love.”
// 							</p>

// 							<p>
// 							Tel Aviv is the ideal location for a concert with such a big name. Known as the New York City of Israel, Tel Aviv is the center of excitement, fun and initiatives in the country. As the city that attracts over a million tourists each year, whether for business or pleasure, Tel Aviv offers a beautiful beach, unique restaurants, theatres, museums and pulsing bars.
// 							</p>

// 							<p>
// 							  If you are joining the many fans who are coming to Tel Aviv to hear Ringo and his All Starrs Band perform, make sure not to miss out on the rest of what Tel Aviv has to offer and come away with an experience to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:43,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Scorpions",
//         smltitle: "Tel Aviv to Go Crazy in July with The Scorpions!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.the-scorpions.com/">
// 											 www.the-scorpions.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/43/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Go Crazy in July with The Scorpions!
// 							</p>
// 							<p>
// 								One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							Those looking to make a day of it in Tel Aviv, will have their pick of food and entertainment venues. The spirited city has become a melting pot of cultures and this is reflected in the museums, restaurants and street stalls that can be found all around the city. Enjoy cuisine to suit every palate, stroll around the interesting streets or pop into one of the many unique exhibitions that can be found around the city.
// 							</p>

// 							<p>
// 							  With the show scheduled for the beginning of the summer, it will be daylight until late and the locals will be out enjoying the sunshine. Soak up the vibe before you go on to rock the night away with The Scorpions!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:44,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Natalia Oreiro",
//         smltitle: "Natalia to Wow Tel Aviv in March",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											20.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.nataliaoreiro.com/">
// 											 www.nataliaoreiro.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/44/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							Natalia to Wow Tel Aviv in March
// 							</p>
// 							<p>
// 								South American singer and actress, Natalia Oreiro, is headed to Israel in March, where she will be performing a live concert at Menora Mivtachim Arena in Tel Aviv. Coming back to Tel Aviv, straight from Argentina, fans are looking forward to seeing the Latin star once again.
// 							</p>

// 							<p>
// 							Having performed in numerous daily series, including telenovelas and movies, and after producing 3 CDs, she will bring some of her biggest hits to the show, such as Cambio dolor, Corazon Valiente, Me Muero de Amor and Rio de la Plata y más, as she opens her new World Tour.
// 							</p>

// 							<p>
// 							Tel Aviv, which attracts celebrity singers, actors and performers from around the world, is the perfect location for the Grammy-nominated singer from Uruguay. The pumping city offers entertainment beyond the walls of the Menora Mivtachim Arena, with its trendy restaurants, upscale bars, and clubs.
// 							</p>

// 							<p>
// 							 Natalia, who has performed in Israel many times in the last 20 years, already has a following here. The show is sure to attract a large audience. Join the excitement before the performance by satisfying your taste buds in one of the many highly-acclaimed restaurants in the area or continue the celebration after the curtains have closed with a drink at a pub. Whatever your tastes, Tel Aviv is a great complement to Natalia Oreiro.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:45,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "André Rieu",
//         smltitle: "Tel Aviv to Be Treated to Rieu in 2018",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											04-05.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.andrerieu.com/">
// 											 www.andrerieu.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/45/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Be Treated to Rieu in 2018
// 							</p>
// 							<p>
// 								World-class Dutch composer and violinist, André Rieu, is coming to Tel Aviv with his Johann Strauss Orchestra for a performance that promises to be unforgettable. The two events, which are Rieu’s first in Israel, will be held at the Menora Mivtachim Arena in Tel Aviv.
// 							</p>

// 							<p>
// 							Rieu will be conducting his 60-piece orchestra while playing his famous Stradivarius violin, treating the audience to their repertoire of renowned ballads and waltzes. The event will be particularly captivating as Rieu will be presenting his new album, “Amore,” which includes a unique interpretation of Naomi Shemer’s “Jerusalem of Gold.”
// 							</p>

// 							<p>
// 							Tel Aviv, with its many facets, is just the right location for the range of musical pieces that Rieu and the Johann Strauss Orchestra will be performing. From the beach to the theater, classy restaurants to lively pubs, Tel Aviv has it all. Sit down to a posh dinner, visit a charming cafe, or enjoy a drink at a chic bar, before you end off your evening with a concert that promises no shortage of exquisite music.
// 							</p>

// 							<p>
// 							  André Rieu has become one of the most popular live acts around the world and Tel Aviv is about to find out why! Make sure you don’t miss out on the experience!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:46,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Foreigner",
//         smltitle: "Foreigner Returning to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.foreigneronline.com/">
// 											 www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/46/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Foreigner Returning to Israel in May!
// 							</p>
// 							<p>
// 								Popular British hard rock band, Foreigner, is returning to Tel Aviv in May 2018. After recently playing 2 concerts in Caesarea, the band will now be performing in the entertainment capital of the country, Tel Aviv.
// 							</p>

// 							<p>
// 							Since being founded in 1976 by Mick Jones, Foreigner has sold nearly 80 million albums across the globe. It reached the height of its popularity in the 1980s, with some of its most well-known hits including “I Want to Know What Love Is,” “I Don’t Want to Live Without You,” “That Was Yesterday” and “Waiting for a Girl Like You.”
// 							</p>

// 							<p>
// 							With the band performing at the Menora Mivtachim Arena in Tel Aviv, fans and visitors will be able to make the most of the concert and enjoy the vibe and energy of the city. Soak up the rays on the beach as the summer sun starts to make an appearance or spend the day in one of the many museums or exhibitions of the city.
// 							</p>

// 							<p>
// 							 You will be transported back to the 80’s with this popular band, while enjoying the best that Tel Aviv has to offer. Don’t miss out on the great nightlife of the clubs and pubs after the show, as you complete your evening with style!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:47,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Don Mclean",
//         smltitle: "Enjoy a Piece of “American Pie” in June!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											16.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://don-mclean.com/">
// 											 www.don-mclean.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/47/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Enjoy a Piece of “American Pie” in June!
// 							</p>
// 							<p>
// 								Famous American songwriter, Don McLean, will perform in the outskirts of Tel Aviv in June, 2018. After almost 60 years of career, McLean remains most famous for his hit song, American Pie, which came out in 1972 and is still covered by big names in the industry, such as Madonna.
// 							</p>

// 							<p>
// 							   McLean has released 40 gold and platinum records, but it is his attachment to Israel that makes him so popular here. This is particularly clear with his song, Jerusalem, which he wrote in support of the country. This time, he will be performing closer to the entertainment capital of Israel, Tel Aviv.
// 							</p>

// 							<p>
// 							    With the show taking place only 10 minutes from the hustle and bustle of the lively city, there are plenty of options for fans to make a full day of the concert. Visit one of a number of world-class museums or take in one of the many temporary exhibitions that come to the city. If you’re looking for food, there is certainly no shortage in Tel Aviv with a range of styles and tastes to suit all visitors. Soak up the sun as summer begins to arrive or enjoy the sounds and scenes of the nightlife that Tel Aviv is famous for.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:48,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Enrique Iglesias",
//         smltitle: "Tel Aviv to Host Spanish Pop Legend!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://enriqueiglesias.com/">
// 											 www.enriqueiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/48/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Tel Aviv to Host Spanish Pop Legend!
// 							</p>
// 							<p>
// 								Spanish pop legend, Enrique Iglesias, will be returning to Israel for his fourth visit, this time to perform at the Yarkon Park in Tel Aviv. While this won’t be his first time in the entertainment capital of the country, it is expected to be his largest performance to date.
// 							</p>

// 							<p>
// 							  This visit comes close on the heels of the Hebrew remix of his popular piece, “Subleme La Radio,” together with Israeli singer, Rotem Cohen. Concert-goers can look forward to hearing some of Iglesias’ hit songs which may include “Bailamos,” “Hero,” “Be With You” and “I Like It.” He is expected to perform together with his long-time guitarist, Israeli Sean Hurwitz.
// 							</p>

// 							<p>
// 							   Iglesias is predicted to be one of the most popular concerts of the year judging by the fact that it will be held in the Yarkon Park venue which can accommodate up to 100,000 people. Those looking to make a whole evening of the event will find plenty to keep them entertained in Tel Aviv before the concert starts.
// 							</p>

// 							<p>
// 							    With a wide range of eateries and pubs, there is something to suit all tastes. Enjoy the limitless choices when it comes to restaurants and pick up the vibe of the city before heading off to the main event.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:49,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blood Sweat and Tears",
//         smltitle: "Blood, Sweat & Tears Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://bloodsweatandtears.com/">
// 											 www.bloodsweatandtears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/49/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Blood, Sweat & Tears Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								Legendary rock band, Blood, Sweat & Tears, is heading to Israel for one concert to be held in Hangar 11 in Tel Aviv. The band was last in Israel 10 years ago when they played in Tel Aviv and Caesarea.
// 							</p>

// 							<p>
// 							  Established in 1967 in New York City, their best-known hits include “I Love You More than You’ll Ever Know,” “I Cannot Quit Her,” “When I Die” and “You’ve Made Me So Very Happy.” There are no original members of the band left, but seven current members will take to the stage when they perform in March. These include lead vocalist and popular runner-up to American Idol in 2005, Bo Bice.
// 							</p>

// 							<p>
// 							   Tel Aviv promises a full day of excitement for concert-goers with the opportunity to enjoy the beautiful beaches, parklands and entertainment options that the city offers before the concert even begins. Make sure to eat in one of the many restaurants scattered around the city and immerse yourself in the character of Tel Aviv by visiting one of the popular pubs or clubs that make up its charming nightlife.
// 							</p>
//                             <p>
//                                 Create the perfect night out as you combine the atmosphere of Tel Aviv with jazz and rock in a unique concert from Blood, Sweat & Tears.
//                             </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:50,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jamiroquai",
//         smltitle: "Jamiroquai Heads to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											02.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.jamiroquai.com/">
// 											 www.jamiroquai.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/50/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jamiroquai Heads to Israel in May!
// 							</p>
// 							<p>
// 								British band, Jamiroquai, is heading to Israel in May 2018, where they will perform in the outskirts of the bustling city of Tel Aviv. With only one performance in Israel, the popular band from the 90s is expected to attract a large crowd.
// 							</p>

// 							<p>
// 							  The band has published 8 studio albums, with “Automaton” being their latest from 2017. The hip city of Tel Aviv is the ideal location for a concert that promises an exciting performance by the group that introduced “future funk” and took the world by storm. Founded in 1992 by Jay Kay, Jamiroquai holds the Guinness Book of World Records listing for “Best Selling Funk Album” of all time.
// 							</p>

// 							<p>
// 							   Anyone looking for a lively night out will do well to head to this concert. Being held a short drive from the center of Tel Aviv, concert-goers will be able to begin the party early at one of the city’s top-notch restaurants, clubs or pubs. Start your evening with a quality dinner at any one of dozens of stylish restaurants and then move onto one of Tel Aviv’s famous clubs before making your way to the concert for an unforgettable night out.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:51,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Backstreet Boys",
//         smltitle: "The Backstreet Boys are Back and Larger Than Life",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.backstreetboys.com/">
// 												www.backstreetboys.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/51/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    The Backstreet Boys are Back and Larger Than Life
// 							</p>
// 							<p>
// 									The Backstreet Boys will be back in Israel this year for a concert. To be held in the outskirts of Tel Aviv in April, concert-goers will be able to enjoy the incredible vibe of the city together with some of the greatest hits in history.
// 							</p>

// 							<p>
// 									Tel Aviv is one of the most sought-after locations for big names in the entertainment industry, with its energy, vitality and spirit. There is no shortage of eateries, pubs and coffee shops for those looking for a culinary experience. Or, if you prefer to make a full day of it, you can visit some of the world-class museums, theaters or galleries around the city.
// 							</p>

// 							<p>
// 									Formed almost 20 years ago, the Backstreet Boys have produced 7 multi-platinum albums and sold more than 130 million records worldwide, with some of their most popular hits such as “I Want It That Way,” “As Long as You Love Me” and “Larger Than Life”.
// 							</p>
// 							<p>
// 									Visitors heading to the concert will be able to enjoy Tel Aviv at its best with beautiful Spring weather enticing locals and guests to the beach, before making their way to hear the best-selling boy band of all times!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:52,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alice in Chains",
//         smltitle: "Alice in Chains Announces Debut Show in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											17.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.aliceinchains.com/">
// 												www.aliceinchains.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/52/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Alice in Chains Announces Debut Show in Tel Aviv
// 							</p>
// 							<p>
// 									Making their debut appearance in Israel, rock band and grunge pioneer, Alice in Chains, will perform in July, north of Tel Aviv, in what promises to be an electrifying concert.
// 							</p>

// 							<p>
// 									Having come together in the late 80’s, Alice in Chains is one of four major groups that led the grunge revolution, and they became one of the most influential bands of all time. With music that combines rock, alternative rock and metal, the band was nominated for 9 Grammy awards and sold more than 20 million albums.
// 							</p>

// 							<p>
// 									Taking place in the middle of summer, Tel Aviv is the perfect location to start the day’s activities. If you’re looking for some indoor entertainment, visit one of the city’s world-class museums or galleries, or head over to one of the many restaurants around the city. For something a bit different, soak up the rays walking along the promenade of a beautiful beach or pop into a club or pub in the area before heading north for the concert.
// 							</p>
// 							<p>
// 									This show is part of the first European tour the band has been on in four years, and being its first appearance ever in Israel, it promises to be a night full of excitement.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:53,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Hardwell",
//         smltitle: "Hardwell Headed to Israel in April",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											06.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.djhardwell.com/">
// 												www.djhardwell.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/53/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Hardwell Headed to Israel in April
// 							</p>
// 							<p>
// 									Number 1 ranking DJ, Hardwell, is coming to Israel in April where he will thrill crowds just outside Tel Aviv. This will be his third concert in the country, after performing to sell-out audiences in 2013 and 2017.
// 							</p>

// 							<p>
// 									Robbert van de Corput, better known as DJ Hardwell, first made a name for himself at the young age of 14, but it was at age 25 when he truly became famous, named World’s #1 DJ by the 2013 DJ Mag. Hardwell has become an International name, hosting his own radio show which is broadcast around the world, and producing a consistently top 10 iTunes podcast. He is also well known for his remix of The Wanted’s “Chasing the Sun”.
// 							</p>

// 							<p>
// 									Tel Aviv is the ideal location for a concert of this type with the natural vibe and energy of the city adding to the excitement that will be in the air. Tel Aviv in Spring is full of blue skies and warm weather, attracting crowds to the beach and the outdoor cafes and restaurants that can be found throughout the city. Enjoy a full day out or join the gathering of people at one of the city’s world-class restaurants before heading to the concert.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:54,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jethro Tull",
//         smltitle: "Jethro Tull’s 50th Anniversary Tour Heads to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27-28.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jethrotull.com/">
// 												jethrotull.com/
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/54/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jethro Tull’s 50th Anniversary Tour Heads to Israel
// 							</p>
// 							<p>
// 									Ian Anderson, vocalist, flutist, and guitarist of the popular British rock band, Jethro Tull, is coming to Israel for the band’s 50th anniversary tour. Performances will take place at Heichal Hatarbut in Tel Aviv on October 27, followed by the International Convention Center in Jerusalem on October 28.
// 							</p>

// 							<p>
// 									Formed in 1967, the band initially played blues rock, but later evolved and developed elements of hard rock. Their greatest success came in the 1970s with hit songs such as “Bungle In The Jungle,” “Living In The Past,” and “The Witch’s Promise.” The band has performed in Israel numerous times in the past, and Anderson who is the only remaining member of the band who is coming on tour, is expected to receive a warm welcome.
// 							</p>

// 							<p>
// 									Performing in both Tel Aviv and Jerusalem will appeal to a wide audience. Join the energy and vibe of the lively city of Tel Aviv with its nightlife, culinary experiences and beautiful beaches, or enjoy the concert in the cultural and historic center of the country, which is Jerusalem. No matter which flavor of the region you prefer, there are plenty of restaurants, cafes, museums or galleries to visit in each of the cities before the venues open their doors.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:55,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Israel Calling",
//         smltitle: "Good Evening Europe, This is Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											08-10.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<!--	<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h2>
// 							   Good Evening Europe,<br class="show-on-mobile"> This is Tel Aviv!
// 							</h2>
// 							<p>
// 								Eurovision fever is sweeping over Tel Aviv as it confirms hosting the star and glitter studded event - “Israel Calling”, for the 3rd consecutive year!
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/55/1.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								About 30 delegates from Eurovision participating countries worldwide will be gathering at the beginning of April in the nonstop city of Tel Aviv, for the largest Eurovision promo-event to ever take place in front of a crowd of thousands from Israel and around Europe.
// 							</p>

// 							<p>
// 								This unique and exciting event, held only in Tel Aviv, will give Eurovision fans from far and wide an amazing and completely free of charge opportunity to take part in the glamour of the Eurovision right here in the beautiful city of Tel Aviv.

// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/2.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 						The event will be held for three days starting on the 8th of April. The main stage will be set in Rabin Square, Tel Aviv’s main square and one of the city’s favorite outdoor venues, located at the heart of the buzzing city.
// 						</p>

// 						<p>
// 						The main event will take place on Tuesday and will include a mini Eurovision show in front of a live audience, featuring performances by the various Eurovision contenders performing the songs they will be competing with on the main event in May.

// 						</p>

// 						<p>
// 						This much anticipated pre-Eurovision event is set to take place just a few minutes’ walk from the stunning Tel Aviv beach. Fans and music lovers coming to see the show will get to take in all the city has to offer, including the excellent bars, restaurants and the awesome nightlife in this world-famous ultimate vacation destination called Tel Aviv.
// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/3.jpg"} class="img-responsive" />
// 						</div>

// 						`
// 			}
// 		}

//     },

//     {

//       id:56,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Clean Bandit",
//         smltitle: "Clean Bandit Announces First Visit to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											26.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://cleanbandit.co.uk/">
// 												cleanbandit.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/56/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Clean Bandit Announces First Visit to Israel
// 							</p>
// 							<p>
// 									British electro-pop group, Clean Bandit, which has become one of the leading dance acts around the world, has announced their debut performance in Israel. Visiting as part of their European tour, the band will play on the outskirts of Tel Aviv on June 26.
// 							</p>

// 							<p>
// 									Formed in 2008, they became well-known for merging classical instruments and pop with a unique and masterful outcome and they became a sensation with their smash hits “Rather Be,” “Real Love,” “Rockabye,” and “Symphony.” Since its release in 2016, “Rockabye” has been viewed almost 2 billion times on YouTube, while they won a Grammy for “Rather Be” in 2015.
// 							</p>

// 							<p>
// 									The band has been together for ten years and has seen incredible success in the that time. Join the throngs of people heading to Tel Aviv for the group’s first visit.
// 						    </p>

// 						    <p>
// 									Tel Aviv is just the venue for the unforgettable night that this concert offers. With cafes, bars, clubs, and pubs throughout the city, there is no shortage of activities in Tel Aviv. Known as “the city that doesn’t stop”, you can take advantage of the buzz of the nightlife and enjoy the vibe of the bustling beachfront at any hour before or after the concert.
// 						    </p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:57,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alanis Morissette",
//         smltitle: "Alanis Morissette to Turn Up The Heat with Summer Performance in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://alanis.com/">
// 												alanis.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/57/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Alanis Morissette to Turn Up The Heat with Summer Performance in Israel
// 							</p>
// 							<p>
// 									Canadian singer and songwriter, Alanis Morissette, will return to Israel in the summer for one show which will take place on the outskirts of the lively city of Tel Aviv. Morissette has performed in Israel a number of times, including in 2000 and 2012, since she released her first album, “Jagged Little Pill” in 1995.
// 							</p>

// 							<p>
// 									The popular alternative rock singer is expected to rock Tel Aviv with some of her top hits, including “All I Really Want,” “Hand in My Pocket,” “Head Over Feet,” “Ironic,” “You Learn,” and “You Ought to Know.” Having taken home seven Grammy Awards and with eight albums having sold more than 60 million copies across the globe, her upcoming visit is already causing much excitement.
// 							</p>

// 							<p>
// 									The Tel Aviv area is the perfect location for a concert of this calibre, with visitors to the city given an exceptional choice of wining, dining and entertainment options. Begin your night at one of the many world-class restaurants or head out to one of the quaint coffee shops or bustling bars to end off your evening. The music scene will be hotter than ever with Alanis Morissette this July!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:58,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Marc Almond",
//         smltitle: "Marc Almond’s Amazing Summer Concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.marcalmond.co.uk/news/index.html">
// 												marcalmond.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/58/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Marc Almond’s Amazing Summer Concert
// 							</p>
// 							<p>
// 									English musician, Marc Almond, will be heading to Israel in the summer for a much-awaited concert. The singer, who is most famous for his part in the new wave duo Soft Cell, will be playing north of Just north of the nonstop city of Tel Aviv in August.
// 							</p>

// 							<p>
// 									Soft Cell became famous for its 80’s hits “Tainted Love,” “Torch,” “Say Hello, Wave Goodbye,” and others, while Almond’s solo career took off when the duo split in the mid-80’s with hits including “Jacky” and “Something’s Gotten Hold of My Heart.” In another tribute to the decade, the Israeli rock group, Tattoo, which broke up in 1989, will open the concert in a historic reunion.
// 							</p>

// 							<p>
// 									Fans have been waiting for this performance since 2011, when his planned concert was canceled due to technical reasons. The 2018 concert promises to be an experience to remember.
// 							</p>

// 						    <p>
// 									From music to art, culture to fun, Tel Aviv has something for everyone. Spend the day wandering the vibrant streets of the city or pop into one of the many museums, theatres or galleries downtown. Make sure to stop off for a bite to eat at any of the city’s many world-class restaurants so you’ll be energized for what is sure to be an awesome concert.
// 							</p>

// 						`
// 			}
// 		}

//     },
//     {

//         id:59,
//         bgImage:"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title : "Shakira",
//         smlTitle : "Shakira to heat up the summer in sizzling Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											09.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.shakira.com/">
// 												shakira.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/59/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Shakira to heat up the summer in sizzling Tel Aviv
// 							</p>
// 							<p>
// 									The worldwide sensation Shakira is set to perform for the first time on the big stage in Tel Aviv this coming July and the city’s a buzz. The 41-year-old Colombian superstar who has sold close to 200 million albums and has won over 250 awards including three Grammys is just the perfect fit for a summertime concert in Tel Aviv.
// 							</p>

// 							<p>
// 									With a long and illustrious list of hit songs, including “Waka-Waka”, “Chantage” and “Whenever, whenever” Shakira is one of the most celebrated artists in the world today and nearly every song she records tops the international charts and receives hundreds of millions of Youtube views.
// 							</p>

// 							<p>
// 									Shakira’s concert is due to be held on July 9th in Yarkon Park, Tel Aviv’s massive park also dubbed the city’s “Green Lung”, which boasts, in addition to beautiful greenery, a stunning lake and excellent bike trails, a huge outdoor live music venue.
// 							</p>
// 							<p>
// 							        The party atmosphere of the nonstop city in July, the beautiful beaches and amazing nightlife and cool street vibe, all set the scene for perfectly Shakira’s show-stopping style and what is guaranteed to be an explosive musical celebration in the heart of cool city of Tel Aviv.
// 							</p>

// 	                    `
// 			}
// 		}
//       },
//   //     {

//   //     id: 60,
//   //     bgImage:"/posts/bank/16/1.jpg",
//   //     mobBgImage:"/posts/bank/16/M.jpg",
//   //     title: "White Night TLV",
//   //     smlTitle: "A “White Night” Rager In the Non-Stop City!",
//   //     html: function(){
// 		// 	return {
// 		// 		__html: `

// 		// 					<h2 class="align-center">
// 		// 					   16.05.2019
// 		// 					</h2>
// 		// 					<h1 class="align-center">
// 		// 					   A “White Night” Rager In the<br class="show-on-mobile"/> Non-Stop City!
// 		// 					</h1>
// 		// 					<div class="responisve-iframe">
// 		// 						<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 		// 					</div>
// 		// 					<p>
// 		// 						When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…
// 		// 					</p>

// 		// 					<p>
// 		// 						From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Adam Primer
// 		// 					</small>
// 		// 					<p>
// 		// 						The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.
// 		// 					</p>
// 		// 					<p>
// 		// 						This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Kfir Sivan
// 		// 					</small>
// 		// 					<p>
// 		// 						The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by Moshik Lindenbaum
// 		// 					</small>
// 		// 					<p>
// 		// 						So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by: Guy Yechiely‎.
// 		// 					</small>

// 		// 			               `
// 		// 	}
// 		// }
//   //   },
//       {
//       id: 60,
//       bgImage:"/posts/bank/16/1.jpg",
//       mobBgImage:"/posts/bank/16/M.jpg",
//       title: "White Night TLV",
//       smlTitle: "All Night Citywide party in Tel Aviv on Eurovision Semifinal!",
//       html: function(){
// 			return {
// 				__html: `

// 							<h2 class="align-center">
// 							   16.05.2019
// 							</h2>
// 							<h1 class="align-center">
// 							   All Night Citywide party in Tel Aviv on Eurovision Semifinal!
// 							</h1>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>
// 								When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat, and this year the treat is going to be especially epic!
// 							</p>

// 							<p>
// 								As part of the warm and exciting welcome awaiting visitors during Eurovision week, the powers that be have decided to combine Tel Aviv’s annual “White Night” extravaganza with the Eurovision Semifinal set to be held on 16.05.2019.
// 							</p>
// 							<p>
// 								“White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open, and everything is happening throughout the city simultaneously.
// 							</p>
// 							<p>
// 								The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City as a world cultural heritage site, setting off annual citywide celebration in a series of white night events in the city that (truly) doesn’t sleeps.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>
// 								From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>
// 								So you better get some rest - you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>

// 					               `
// 			}
// 		}
//     },
//     {

//         id:61,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Brian Wilson",
// 	    smlTitle: "The legendary Brian Wilson returning to rock Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											07.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.brianwilson.com/">
// 												brianwilson.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/61/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 The legendary Brian Wilson returning to rock Tel Aviv!
// 							</p>
// 							<p>
// 									He returns to the white city with Al Jardine and Blondie Chaplin as a part of his world tour that celebrates his biggest hits from the last 54 years. The Beach Boys is one of the world’s most successful bands, the band has won many Grammy awards, got their own star in Hollywood and entered the Rock N’ Roll hall of fame.
// 							</p>

// 							<p>
// 									The band sold over 100 million records over the years and produced more hits than any other American band. They’re known especially for their hits “God Only Knows”, “Get Around”, “California Girls” and “Good Vibrations”. Wilson’s solo career is also successful, he recorded 11 albums and won 2 Grammy awards.
// 							</p>

// 							<p>
// 									Wilson’s concert will take place in Tel Aviv on August’s 7th. The summertime provides long daylight hours that give visitors the perfect opportunity to see what Tel Aviv has to offer; from an incredible art scene to fantastic theatres, to phenomenal live music shows and world-class restaurants – there are so many options in the spectacular city of Tel Aviv for  everyone will to find their brand of fun and excitement in the nonstop city.

//                             </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 62,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Jason Derulo and Rita Ora",
// 	    smlTitle: "Jason Derulo and Rita Ora to raise it up in Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											The outskirts of Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.jasonderulo.com/">
// 												jasonderulo.com
// 											</a><br>
// 											<a target="_blank" href="http://ritaora.com/">
// 												ritaora.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/62/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						         	Jason Derulo and Rita Ora to raise it up in Tel Aviv!
// 							</p>
// 							<p>
// 									The two mega pop stars will perform at the “Lollipop” festival that will take place at the outskirts of Tel Aviv on the first of August. Derulo, that made his big breakthrough in 2009 with the hit “Whatcha Say”, became over the last decade one of the biggest stars in the international music industry with his huge hits such as “Wiggle”, “Want to Want Me”, “Swalla”, “Tip Toe” and “Talk Dirty”. The popular British Pop star, Rita Ora, is known especially for her famous hits “I Will Never Let You Down”, “Anywhere”, “R.I.P” and “Hot Right Now”.
// 							</p>

// 							<p>
// 									The festival provides a great opportunity to explore the city that never sleeps and enjoy its famous nightlife scene – from world-class bars, to secret underground clubs, to live music shows and various culinary options and even alternative art galleries, Tel Aviv for sure has something for everyone to enjoy. Whether you’re following a map or letting yourself get lost in the streets, you’re sure to fall in love with Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 63,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Julio Iglesias",
// 	    smlTitle: "The Latin legend returning to wow Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											06.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.julioiglesias.com/">
// 												julioiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/63/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						             The Latin legend returning to wow Tel Aviv!
// 							</p>
// 							<p>
// 									Tel Aviv can’t wait for the return of the beloved Spanish star! With a great cultural scene, incredible culinary options, amazing beaches, phenomenal museums and galleries and plenty of unique spots to explore – those who come to enjoy Iglesias’s concert have plenty of different ways to spend their time in the cultural capital.
// 							</p>

// 							<p>
// 									The hot climate and long daylight hours just reminiscent of the phenomenal singer’s origin country, Tel Aviv offers a variety of options that suit all ages and therefore attracts a big amount of visitors all around the year.
// 							</p>
// 							<p>
// 							        Iglesias has an ongoing love affair with the nonstop city and his past shows were sold out. He’s one of the most successful singers in the history and during his career became a phenomenal success story all around the world. He has 77 different albums that sold over 300 million copies!
// 							</p>

// 							<p>
// 							         Many of the Spanish phenomenon’s hits have reached the top of the charts and he won numerous awards, such as the Grammy. His fans are incredibly excited about his return and tickets are selling like hot falafels. This is guaranteed to be a show to remember!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 64,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Maluma",
// 	    smlTitle: "The Reggaeton sensation returns to the white city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://fame.malumaofficial.com/">
// 												fame.malumaofficial.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/64/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The Reggaeton sensation returns to the white city!
// 							</p>
// 							<p>
// 									After winning over the crowd’s hearts during his last visit, the Colombian reggaetón singer and songwriter Juan Luis Londoño Arias, better known by his stage name Maluma returns to the city that never stops for one show only!
// 							</p>

// 							<p>
// 									Maluma has several singles that have charted within the top 10 on Billboard Hot Latin Songs, including "Felices los 4", "Borro Cassette", "El Perdedor" and "Corazón". During his career he won several awards, among which there is MTV Europe’s award for best world tour. The phenomenal performer is known among his fans as “the Latin lover” despite being only 24 years old.
// 							</p>
// 							<p>
// 							       His show will be held on June’s 28th in HaYarkon Park, located in the heart of Tel Aviv. Fans from all over the world who come to the show can enjoy the lovely beaches the city has to offer, the variety of restaurants and cafes, the remarkable art scene, the world-class bars and clubs, the various shopping venues spread all across the city – Tel Aviv has something for everyone.
// 						    </p>

// 							<p>
// 							         The Latin superstar is known to be quite a charmer and win everyone over in his shows – don’t miss this fantastic mix of Maluma and Tel Aviv -  come see the legend live in the hot hot city!
// 						    </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 65,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Martin Garrix",
// 	    smlTitle: "The 1# DJ comes to the nonstop city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											10.09.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.martingarrix.com/">
// 												martingarrix.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/65/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The 1# DJ comes to the nonstop city!
// 							</p>
// 							<p>
// 									Martin Garrix , hailed as “the world’s best DJ” by DJMag is coming to get the party going in the nightlife capital of the middle east! With tons of world known clubs, bars, pubs and a one of a kind atmosphere, Tel Aviv is known for its vibrant vibe and incredible night scene.
// 							</p>

// 							<p>
// 									At 20 years old, the Dutch wonderkid is coming at the height of his career for one unforgettable show in Tel Aviv! The international hits machine became famous when he was only 17 and since then has released many loved tracks and climbed the charts all over the world.
// 							</p>
// 							<p>
// 							       Garrix is considered by many is the undeniable king of the industry. With remarkable hits such as “Animals”, “Tremor”, “In the Name of Love” and “Scared to Be Lonely”, the phenomenal DJ is one of the most popular performers in the world and is a must-have headliner for every well-known festival.
// 							</p>

// 							<p>
// 							        The show will be held in HaYarkon Park, in the heart of the awesome city, on September 10th. The international vibe, gorgeous location and great nightlife scene attract an extraordinary crowd that comes from different corners of the world and is guaranteed to make this show a once in a lifetime experience!
// 						    </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 66,
// 	    bgImage:"/posts/bank/59/1.jpg",
// 	    mobBgImage:"/posts/bank/59/M.jpg",
// 	    title: "Eurovision Tel Aviv",
// 	    smlTitle: "Epic song contest in the Non-Stop City",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14-18.05.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<!--<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h3>A once in a lifetime opportunity to visit Tel Aviv as it hosts the Eurovision song contest.</h3>
// 							<p>
// 						     Epic song contest in the Non-Stop City
// 							</p>
// 							<p>Semi-final 1: 14 May 2019</p>
//                             <p>Semi-final 2: 16 May 2019</p>
//                             <p>Grand Final: 18 May 2019</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/67/1.svg"} class="img-responsive" />

// 							</div>
//                             <p>It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city. </p>
//                             <p>Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak.  Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest. </p>
//                             <div class="img-wrapper">

// 							    <img src=${getImgUrl() + "/Concerts/67/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv. </p>

//                             <p>The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all! </p>

// 					               `
// 			}
// 		}
//     },

//    {

//         id: 68,
// 	    bgImage:"/posts/bank/68/1.jpg",
// 	    mobBgImage:"/posts/bank/68/M.jpg",
// 	    title: "",
// 	    smlTitle: "36 Years of Cinema Magic!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											25.07-04.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jff.org.il/en">

// 												www.jff.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h2>Jerusalem Film Festival (JFF)</h2>
// 							<p>Time to start preparing your Summer 2019 checklist: Buy suntan lotion, pick wildflowers, host a barbeque, make plans to attend the 36th Annual Jerusalem Film Festival! It’s 11 days, over 200 films, prizes awarded to the very best, and you’ll be a part of it all! From star-studded international features to independent productions and the best of Israeli cinema, this unique film fest showcases excellence from various genres. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/68/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Take advantage of the opportunity to meet festival guests, including world-renown stars, writers, directors, cinematographers and other movie-making professionals. Film enthusiasts will enjoy Jerusalem’s many cinema spaces and be delighted by JFF on the Go, which presents films under the stars throughout the festival, and Cinema Park, which includes a 300 square meter pool with rubber boats, a giant LED screen, and a concert stage featuring live musical performances nightly. </p>
//                             <p>As you travel across the city to attend screenings, workshops, master classes, parties, musical shows and other festival events, you’ll experience how ancient cultures give modern spice to the contemporary vibe and personality of this global city. Fill your spare time strolling through neighborhood streets, exploring local shops, and taking your pick of Jerusalem’s wide variety of restaurants and cafes. You may have attended other film fests, but you won’t find one quite like this and, certainly, none other can boast the grandeur of the eternal City of Peace! </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 69,
// 	    bgImage:"/posts/bank/69/1.jpg",
// 	    mobBgImage:"/posts/bank/69/M.jpg",
// 	    title: "",
// 	    smlTitle: "Jerusalem Wine Festival (JWF)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											01-31.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Wine Festival (JWF)</h2>
// 							<p>
// 								Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premiere social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.
// 							</p>
//                            <p>
// 								Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: 70,
// 	    bgImage:"/posts/bank/70/1.jpg",
// 	    mobBgImage:"/posts/bank/70/M.jpg",
// 	    title: "OPEN RESTAURANTS TLV",
// 	    smlTitle: "Feed Your Curiosity!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											2019 y.
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Feed Your Curiosity!</h2>
// 							<p>
// 								Ever wanted to get more than a taste of what gets created in a truly fine restaurant? Have you ever fantasized about what it would be like to be a top chef? Well, now’s your chance!
// 							</p>
// 							<p>
// 								OpenRestaurants is more than a culinary event, it’s a cultural happening that showcases Tel Aviv’s wide array of restaurants, chefs, and local culinary personalities. Guests get to meet with chefs from around the city, wander through open markets, and try their hands at cooking up flagship dishes under the supervision of first-class professionals. It’s your opportunity to experience a day in the life of the sophisticated chefs, line cooks, restaurateurs, food vendors, and others who make gastronomy in Tel Aviv as palate pleasing as it is.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/70/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Beyond peeking behind many kitchen curtains, OpenRestaurants hosts a range of events that include curated dinners, history presentations, and exhibitions of culinary-themed art, design, music, and technology!
// 							</p>
//                            <p>
// 								Many events are available at no charge, including the Culinary Innovation Summit, the Food & Hospitality Hackathon, and various food talks. There are also family-oriented events that focus on cooking activities for children and several market tours.
// 							</p>
//                            <p>
// 								Everyone’s gotta eat and there’s no one who doesn’t enjoy good food that’s well prepared. So, whether you like to understand the process behind the preparation, you like to do the preparing, or you just have a hearty appetite, there’ll be plenty to delight your senses at OpenRestaurants: Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 71,
// 	    bgImage:"/posts/bank/71/1.jpg",
// 	    mobBgImage:"/posts/bank/71/M.jpg",
// 	    title: "CULINARY FESTIVAL",
// 	    smlTitle: "Round Tables Culinary Festival",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											09-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Round Tables Culinary Festival</h2>
// 							<p>
// 								The 4th edition of this celebrated culinary experience that brings renowned chefs from around the globe and invites them to take over the kitchens of several of Tel Aviv’s most notable restaurants.
// 							</p>
// 							<p>
// 								This year offers a new twist: The eight visiting chefs are all women – hailing from Mexico, South Korea, Italy, Switzerland, Colombia, Slovenia, Spain, and the United States. They’ll work with their local counterparts in the creation of culture crossover chowdowns featuring signature dishes from the guest chefs alongside flavors offered by the local chefs from the host restaurants.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/71/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Everyone involved agrees that creative cooking is always intensely steeped cultural context and a deeply felt sense of place. All of them are passionate about using local ingredients. Of course, each of these chefs has received accolades and awards from international critics and guides.
// 							</p>
//                            <p>
// 								There’s no better way to showcase Tel Aviv’s growing prominence on the global stage of gastronomy than the annual Round Table event. Seats get reserved quickly and must be made in advance. So, don’t miss your chance for a place at these prestigious tables – your taste buds will never forgive you!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 72,
// 	    bgImage:"/posts/bank/72/1.jpg",
// 	    mobBgImage:"/posts/bank/72/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "Tel Aviv Fashion Week (TAFW)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Tel Aviv Fashion Week (TAFW)</h2>
// 							<p>
// 								Fashion events are always occasions for the celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!
// 							</p>
//                            <p>
// 								In 2019, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 73,
// 	    bgImage:"/posts/bank/73/1.jpg",
// 	    mobBgImage:"/posts/bank/73/M.jpg",
// 	    title: "DGTL FESTIVAL",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 												tlv.dgtl.nl/en
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
//                             <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                             <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology and art, as well as the latest discoveries in production and sound. </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/73/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include three stages which will operate simultaneously at any given moment.</p>
//                             <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                             <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the host for DGTL. </p>
//                             <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 74,
// 	    bgImage:"/posts/bank/74/1.jpg",
// 	    mobBgImage:"/posts/bank/74/M.jpg",
// 	    title: "Tel Aviv Marathon",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.02.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>

// 											<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=5418">
// 												www.tlvmarathon.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Run and fun in the city that doesn’t stop</h2><br/>
//                             <p>Tel Aviv Marathon is the country’s biggest international sports event and a unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its awesome sites and views and feel their heart beat become one with the pulse of this adrenaline charged metropolis. </p>
//                             <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/74/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                             <p>Much more than just a run, the marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                             <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 75,
// 	    bgImage:"/posts/bank/75/1.jpg",
// 	    mobBgImage:"/posts/bank/75/M.jpg",
// 	    title: "Jerusalem Marathon",
// 	    smlTitle: "The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											15.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://jerusalem-marathon.com/Register.aspx">

// 												jerusalem-marathon.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem</h2>
//                             <p>The International Jerusalem Winner Marathon is one of Israel's largest marathons, with 30,000 participants including hundreds of elite runners from Israel and around the world.</p>
//                             <p>The marathon offers a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, Israel's capital guaranteeing a challenging, thrilling and unforgettable experience for all runners. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/75/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>With a series of cultural happenings planned around the central event, the Jerusalem International Marathon provides international runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event. </p>
//                             <p>The Jerusalem marathon allows runners the chance to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners.</p>
//                             <p>The course takes the runner on a unique path through Jerusalem’s 3,000-year historical narrative, on the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of Israel’s capital. The course includes the city’s best known sites including, among others, the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 76,
// 	    bgImage:"/posts/bank/76/1.jpg",
// 	    mobBgImage:"/posts/bank/76/M.jpg",
// 	    title: "Bon Jovi",
// 	    smlTitle: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, TLV
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											25.07.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.bonjovi.com/">

// 												bonjovi.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!</h2>

//                             <p>Bon Jovi, all-time favorites in Tel Aviv, are making their way back to the city, famed for its lively music scene once more to appear in the famous Yarkon Park, the beautiful green lung of the city.
//                             <p>Currently touring America to sold out venues, Bon Jovi will arrive here as part of a new European tour in the summer of 2019, entitled "This House is not for Sale". The tour is set will begin on May 31, 2019 in Moscow and will probably end on July 25, 2019 with their show in Tel Aviv.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/76/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The band, considered e one of the most successful American bands of all times has sold more than 100 million copies, performed in over 2700 concerts in 50 different countries to more than 34 million viewers worldwide.
//                             <p>This is not Bon Jovi's first stint in the city. The band gave a truly memorable performance about three years ago at the Hayarkon Park in Tel Aviv to 50,000 adoring fans, singing along to every lyric .
//                             <p>Those coming to see the band play in Tel Aviv are in for a special treat as they will get to experience Tel Aviv in July, the city’s summer finest,  sunbathe on the fabulous beaches, enjoy the awesome culinary options, take in  the epic hot night life and best of all see Bon Jovi raise it live on stage in the city that doesn’t stop!

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 77,
// 	    bgImage:"/posts/bank/77/1.jpg",
// 	    mobBgImage:"/posts/bank/77/M.jpg",
// 	    title: "TAG 2019",
// 	    smlTitle: "Tel Aviv Games are Back!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											TAG 2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27-30.3.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.bonjovi.com/">
// 												www.telavivgames.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <h2>
//                             	Tel Aviv Games are Back!
//                           	 </h2>

//                             <p>
// 								Tel Aviv, declared one of the best gay travel destinations in the world, is joining a list of renowned capitals such as Paris, New York, Berlin and Rome, organizing its own LGBT multinational sports event – Tel Aviv Games – TAG2019. TAG 2019 offering the LGBT+ traveler a unique and exciting sports experience.
//                             </p>
//                             <p>
// 								With over 250 athletes from all over the world already signed up, and an estimated 500 more expected, Tel Aviv Games 2019 is anticipated to become the biggest LGBT+ Sports event in the middle east and one of the biggest in Europe.
//                             </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/77/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>
// 								LGBT+ athletes from more than 17 countries (including France, Germany, UK, US, Australia, Canada, Belgium, Czech Rep., Greece, Netherlands, Norway, Spain, Russia, Surnami and more) will come together for a 3-day multi-national celebration of participation, inclusion and personal best.
//                             </p>
//                             <p>
// 								The tournament will include individual and team events in 7 sporting categories: Swimming, Tennis, Basketball, Soccer, Volleyball, Same Sex Dance, and 5K and 10K Competitive Running.
//                             </p>
//                             <p>
// 								This year Tel Aviv Games will also introduce the city’s first ever “Pride Run - Running for the youth”, supporting Healthy LGBT+ Youth lifestyle in a 5K race along Tel Aviv’s beautiful shore.
// 							 </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 78,
// 	    bgImage:"/posts/bank/100/1.jpg",
// 	    mobBgImage:"/posts/bank/100/M.jpg",
// 	    title: "Purim 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											20-22.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tel-aviv.gov.il/en/Pages/MainItemPage.aspx?WebID=9336473c-1537-4ab6-8a69-d299b5db8bcc&ListID=0ac6b290-896c-4fcb-bb36-0c5252101eff&ItemId=123">
// 												Tel Aviv Purim 2019
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <p>Every year in March, the people of Tel Aviv & Jerusalem dress up in costumes, the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/1.jpg"} class="img-responsive" />
// 							</div>

//                             <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – the annual street party is Tel Aviv’s biggest event. Thousands of dressed up people will gather together in “Kikar Hamedina” (State’s Square)  to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/2.jpg"} class="img-responsive" />
// 							</div>
//                             <p>If your prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events is at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/3.jpg"} class="img-responsive" />
// 							</div>
//                             <p>So choose your costume and come celebrate with us!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/4.jpg"} class="img-responsive" />
// 							</div>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "J_Lo",
// 	    bgImage:"/posts/bank/J_Lo/1.jpg",
// 	    mobBgImage:"/posts/bank/J_Lo/M.jpg",
// 	    title: "J.LO",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Hayarkon Park
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h3>
// 								J.LO HEADING TO TEL AVIV TO SET THE SUMMER ON FIRE!
// 							</h3>
// 							<p>
// 								Yes, it's true! after weeks of rumors flying around it is officially confirmed the J.Lo, AKA Jeniffer Lopes, AKA Jenny from the block, the hottest name worldwide as queen of pop for the past 2 decades, is coming to light up your summer in Tel Aviv!
// 							</p>
//                          <p>
// 								Performing for the first time in this country, J.Lo will be getting loud on the floor on August 1st at the Yarkon Park. The show, part of the maga star’s “It’s My Party” worldwide tour is expected to be one of the summer’s biggest concerts, along with Bon Jovi’s highly anticipated performance on the very same Tel Aviv stage on the 25th July.
// 							</p>
// 							<p>
// 								Hayarkon park is Tel Aviv’s green lung. This is the perfect place to get some respite after spending a wild night in Tel Aviv. Here you can spend the day cycling, walking or relaxing in the beautiful outdoor scenery and even enjoy flying high on a hot air balloon before heading to take your place in the stunning amphitheater. Whatever you choose, make sure to come packed with energy for J.Lo’s once in a lifetime performance in sunny awesome Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Parade_2019",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Parade 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.6.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h3>
// 								The  most fabulous event of the Year
// 							</h3>
// 							<p>
// 								<strong>
// 									Tel Aviv 2019 Pride Celebrations – guaranteed to blow your mind!
// 								</strong>
// 							</p>
// 							<p>
// 								Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties. One of the biggest and hottest events, by far in the city is the ‘Gay Pride Week’ parties ending with the awesome Friday Pride Parade.
// 							</p>
//                          <p>
// 								The parade, a tradition which began as early as 1998, draws a huge crowd of the coolest people and thousands of participants from around the world. All them come together to celebrate and support freedom and embrace all lifestyles and genres in an open minded, off the charts, celebration.
// 							</p>
// 							<p>
// 								The parade is the highlight of a week of gay pride events which take place around the city of Tel Aviv and include pride-themed parties, exhibitions, movie festivals, music concerts and so much more.
// 							</p>
// 							<p>
// 								The parade itself takes place along the buzzing main streets of marvelous Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic extravagant floats, live music, dance performances and revelers dressed in a colorful festival dress.
// 							</p>
// 							<p>
// 								The parade stops and rests at the stunning Tel Aviv promenade by the shores of the beautiful coastline, where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.
// 							</p>
// 							<p>
// 								The 2019 parade will take place on June 14th 2019 and participation, as always, will be completely free of charge.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Open_Restaurants_Jerusalem",
// 	    bgImage:"/posts/bank/Open_Restaurants_Jerusalem/1.jpg",
// 	    mobBgImage:"/posts/bank/Open_Restaurants_Jerusalem/M.jpg",
// 	    title: "Open Restaurants Jerusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												www.open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h3>
// 								Open Restaurants Jerusalem
// 							</h3>
// 							<p>
// 								Taking place in the iconic city of Jerusalem at varying hours, \‘Open Restaurants\’ is a unique culinary festival giving visitors a glimpse into the fascinating cultural and culinary diversity of Jerusalem.
// 							</p>
// 							<p>
// 								The festival includes about 100 different events held all over the city of Jerusalem, even in places which are less culinary oriented, as well as in culinary adequate venues and combine food with art, culture, innovation and technology.
// 							</p>
//                          <p>
// 								Festival-goers will also have a chance to participate in a series of meetings, workshops and lectures by prominent local personalities, and visits to the city\'s famous restaurant kitchens.
// 							</p>
// 							<p>
// 								As part of the festival program, day and night tours will be held at various culinary centers throughout Jerusalem including flavors tours in the Old City,Ein Kerem and more. You are encouraged to take at least one of them!
// 							</p>
// 							<p>
// 								In addition, FoodTalks meetings will be held with leading culinary experts (we can’t reveal who they are, so keep guessing…), photographers and chefs. The top hotels in Jerusalem will also collaborate with their private chefs at special prices.
// 							</p>
// 							<p>
// 								Whether you’re a foodie or just a curious visitor, you are sure to enjoy this unique taste of magical Jerusalem’s culinary side happening between the 19th -23rd , November,2019.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													28 - 29.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 	                                <p>The city of Jerusalem is proud to host, for the 15th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’.</p>
// 	                                <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>

// 	                                <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an incomparable atmosphere, guaranteeing an unforgettable experience. </p>

// 	                                <p>The iconic festival has become over the years, a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe, to enjoy a delicious variety of cold beers, food and people in open air of Jerusalem.</p>

// 	                                <p>During the festival you will have the opportunity to taste any (or all) of the variety special flavors of beers from around the country and the world (and we have over 120 of them), served in pop up bars, built specifically for the festival. </p>
// 	                                <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local breweries. </p>

// 	                                <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>
//                                     <a href="https://www.jerusalembeer.com/en" target="_blank" class="jerusalem-link">www.jerusalembeer.com</a>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Location</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													14.10.19
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>More Info</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to the Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                                    <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now, Tel Aviv. DGTL brings together the worlds of music, technology and art, as well as the latest discoveries in production and sound.</p>
//                                    <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which, will operate simultaneously at any given moment.</p>
//                                    <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for reducing electricity consumption, vegetarian food only, a recycling plan and more. </p>
//                                    <p>The Festival will be held in the fabulous Yarkon Park,  situated in the heart of the buzzing city of Tel Aviv. As a hub of innovation, trendiness and exciting nightlife scene, it is the perfect host for DGTL festival. </p>
//                                    <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 	                            `
// 			}
// 		}
//     },

//     {
// 	              id: "The_International_Arts",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "The International Arts",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Location</h2>
// 											<div class="text">
// 												<p>
// 													Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													12 - 24.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>

//                                     <h2>The International Arts and Crafts Festival 2019<br>
//                                     <small>Hutzot Hayotzer Jerusalem<small></h2>
//                                     <p>Jerusalem is packed with fantastic events throughout the summer. One of the most celebrated events is the colorful “Hutzot Hayotzer -International Art and Crafts Festival”. </p>
//                                     <p>This large-scale annual festival takes place in the Hutzot Hayotzer lane and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
//                                     <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years. It has long since became a hugely popular tourist and artistic attraction for visitors from around the world. Visitors will enjoy more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more, as well as an international exhibition, showcasing the work of overseas artists.  They will be able to engage in fascinating art conversations and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music, all wrapped up in an authentic European carnival atmosphere. </p>
//                                     <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
//                                     <p>Last but definitely not least, don’t miss the “Food around the world” - an Israeli and international food fair, which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>
//                                     <a href="https://artfair-jer.com/english/" target="_blank" class="artfair-link">www.artfair-jer.com</a>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Jerusalem_Marathon",
// 	              bgImage:"/posts/bank/jer-marathon2019/1.jpg",
// 	              mobBgImage:"/posts/bank/jer-marathon2019/M.jpg",
// 	              title: "Jerusalem Marathon",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Location</h2>
// 											<div class="text">
// 												<p>
// 													Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													20.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>More Info</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://jerusalem-marathon.com/default.aspx">

// 														jerusalem-marathon.com
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
//                                     <h2>A Spectacular run through the 3,000-Year-old city</h2>
//                                     <p>With 30,000 participants including hundreds of elite runners from around the world, The International Jerusalem marathon, is a fantastic celebration of body and mind in the heart of one of the most enchanted cities in the world. </p>
//                                     <p>The Jerusalem International Marathon provides the runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event, with a series of cultural happenings planned around the central event.</p>
//                                     <p>The marathon offers a variety of tracks, from professional to family friendly.</p>
//                                     <p>The course takes you by the fascinating historical sites that reveal the 3,000 years of Jerusalem’s history, the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of the capital. </p>
//                                     <p>The course includes the city’s best-known sites, among others the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>

//                                     <p>Runners are provided with the opportunity to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners. Ultimately guaranteeing an illuminating, challenging, thrilling and unforgettable experience for all runners. </p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Location</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, City -Wide
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													19 - 21.09.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>More Info</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="http://www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h3>An amazing experience for design lovers everywhere</h3>
//                                     <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>

//                                     <p>The ‘Open Houses’ opens a one-time door to allow a glimpse into the forms of design, style of living, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
//                                     <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical as well as urban buildings. The Festival will also include special guided tours and attractions in unusual places -  from tours of residential apartments to tours of  new buildings. </p>
//                                     <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel-Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
//                                      <p>"Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
//                                     <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "TelAviv_Marathon",
// 	              bgImage:"/posts/bank/tlv-marathon2020/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-marathon2020/M.jpg",
// 	              title: "Tel Aviv Marathon",
// 	              smlTitle: "",
// 	              html: function(){
// 			              return {
// 				              __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Location</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													28.02.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>More Info</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=6607">

// 														www.tlvmarathon.co.il
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
//                                     <h3 >Run and fun in the city that doesn’t stop</h3>
//                                     <p>Tel Aviv Marathon is the country’s biggest international sports event. A unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its remarkable sites and views while their heart beat becomes one with the pulse of this adrenaline charged metropolis. </p>
//                                      <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                                      <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                                      <p>The marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                                      <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Night_Run_TelAviv",
// 	              bgImage:"/posts/bank/tlv-nightrun2019/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-nightrun2019/M.jpg",
// 	              title: "Night Run Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tlvnightrun.co.il/MenuDefault.aspx?id=6571">

// 												www.tlvnightrun.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h3>The most exhilarating 10km you will ever experience</h3>
//                                     <p>A lot has been said about the world-renowned city of Tel Aviv. Named among Lonely Planet’s 'Top 10 Action-Packed Cities’, this city is a truly trendy buzzing metropolis that doesn’t rest. While its official slogan is the Non Stop City, it truly gives NYC a run for its money for the title the City that doesn’t sleep. </p>
//                                     <p>This is especially the case when it comes to the amazing Night Run Tel Aviv annual race. </p>
//                                     <p>With around 25,000 runners and tens of thousands of cheering spectators, this upbeat adrenaline-charged race is more of a full-blown night time party for the scores of participants and spectators who come from all around the world to take part.</p>
//                                     <p>Taking place during the autumn, the 10KM night run begins well after sundown and follows a fantastic urban route along the streets of Tel Aviv, starting at  Rabin Square in the center of town, and south along Rothschild Boulevard, before continuing along Dizengoff Street, Nordau Boulevard, and into Park Hayarkon, reaching the finish line alongside the river. </p>
//                                     <p>You will be passing all the trendy,, fascinating attractions and renowned Bauhaus architecture the "White City" of Tel Aviv has been declared a UNESCO World Heritage Site for. </p>
//                                     <p>Best of all, The TLV Night Run ends with a celebratory finish line festival at Hayarkon park in the heart of the city where thousands more come to join the runners and spectators in an all-night rager of music, dancing and nonstop fun.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Celine_Dion",
// 	              bgImage:"/posts/bank/Celine_Dion/1.jpg",
// 	              mobBgImage:"/posts/bank/Celine_Dion/M.jpg",
// 	              title: "Celine Dion",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											04.08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">

// 												www.celinedion.com

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h3>Our Heart Goes On – for Celine Dion in Tel Aviv!</h3>
// 										<p>The Diva is coming! Now it’s official: Celine Dion will perform in Tel Aviv on August 4th of next summer and it’s going to be a hot one! This will be Dion’s first ever concert here, and boy are we excited.</p>

//                                         <p>The 6 Grammy award-winner will visit Tel Aviv, the city that never sleeps, to keep the party going all Night. Dion’s countless hits, “Because you Loved Me”, “Just Walk Away” and of course her all-time greatest hit – “My Heart Will Go On” – will hopefully make their debut live in Tel Aviv.</p>

//                                         <p>Tel Aviv has also hosted some of the largest art exhibitions, live shows and festivals, making it one of the liveliest cities in the world. With a combination of sun, rich nightlife scene, spectacular sights in every corner and the Dion’s first appearance – Tel Aviv is the place to be next summer.</p>

//                                         <p>Ticket sales have yet to open, but it’s never too early to start planning your next visit to Tel Aviv!

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Nickcave_Badseeds",
// 	              bgImage:"/Concerts/bank/nickcave_badseeds/1.jpg",
// 	              mobBgImage:"/Concerts/bank/nickcave_badseeds/M.jpg",
// 	              title: "NICK CAVE & BAD SEEDS",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Bloomfield Stadium, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											17.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 												Update Soon

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h3 >NICK CAVE AND THE BAD SEEDS LIVE IN TEL AVIV!</h3>
//                                     <p>Nick Cave is coming to Tel Aviv to blow the roof off! Returning to the city that never sleeps in June 2020, the Australian pop-punk musician is coming to rock you.</p>

//                                     <p>Having recorded no less than 17 studio albums with his band, the talented musician is excited about his visit – which will be hotter than ever.</p>

//                                     <p>Coming back just a little more than two years after his previous performance here, this time, lighting up the newly renovated Bloomfield Stadium (which has hosted a long line of international artists). Judging by the last performance, this one should be truly sensational.</p>

//                                     <p>Tel Aviv has been known to attract and feature some of the biggest names in the world, making it one of the hottest cities when it comes to live concerts and the nightlife scene. This performance shouldn’t be any different and is a great opportunity to catch Nick Cave live, as part of his summer tour.</p>

//                                     <p>Warm summer nights, soft sand beaches and the mesmerizing music of a world-renowned artist – what more could you ask for? Tel Aviv has it all!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Louis_CK",
// 	              bgImage:"/posts/bank/Louis_CK/1.jpg",
// 	              mobBgImage:"/posts/bank/Louis_CK/M.jpg",
// 	              title: "He’s coming back! Louis CK in Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Hangar 11, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/events/%D7%A4%D7%99%D7%A1-%D7%90%D7%A8%D7%A0%D7%94-%D7%9E%D7%9C%D7%97%D7%94-%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%9C%D7%95%D7%90%D7%99%D7%A1-%D7%A1%D7%99-%D7%A7%D7%99%D7%99-%D7%91%D7%94%D7%95%D7%A4%D7%A2%D7%94-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-louis-ck-live-in-israel/554683431359536/">

// 												Louis CK

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>Back for the second time, Louis CK will preform at the Hangar 11 in Tel Aviv, this upcoming November.</p>

//                                     <p>After his tremendous success in Jerusalem in 2016, Louis CK is about to return for another exclusive show; this time, right here in Tel Aviv, one of the hottest cities for live shows.</p>

//                                     <p>The talented, hilarious comedian is back in action after a two-year break making this show, bigger, better and funnier than ever. Having a wide following audience in Tel Aviv alone, the sharp comedian is sure to light up the stage.</p>

//                                     <p>Tel Aviv has hosted dozens of comedians from all over the world, including Jerry Seinfeld and Chris Rock, Jim Jefferies and many others, is the ultimate city for having a good time. The city is known for its art and culture as well as its exciting club scene and trendy bars and restaurants.</p>

//                                     <p>So book your trip now and get ready for an unforgettable time in the city that doesn’t stop!</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Cycle_Tel_Aviv",
// 	              bgImage:"/Concerts/bank/cycle-tlv-2019/1.jpg",
// 	              mobBgImage:"/Concerts/bank/cycle-tlv-2019/M.jpg",
// 	              title: "Cycle Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											All Around Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											18.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>The mild to warm October weather, combined with the energetic vibe of Tel Aviv, provide the perfect setting for the biggest cycling event in the country.</p>

//                                     <p>Thousands of cycling enthusiasts flock to Tel Aviv to ride through the vibrant city, on a scenic course showing you everything Tel Aviv has to offer:</p>

//                                     <p>From the beautiful Yarkon Park, along the coast, past the city’s many dazzling beaches and back up to the park through the city center, you’ll get a glimpse of every characteristic place, the “Mediterranean capital” has to offer.</p>

//                                     <p>Everyone can experience the thrill and excitement of the event, from the 60 km course for professional riders to the 8 km course for families and beginners, there is even a rollerblades course for those who prefer to make their way through the city on foot.</p>

//                                     <p>With the locals coming out in droves to cheer on the event, you’ll see a colorful and diverse crowd, adding to the fun and excitement in the air.</p>

//                                     <p>Whether you’re looking for a personal challenge to compete against some of the top riders in the country, or you’re hoping to enjoy a family day out with the crowds, you’re sure to experience the beauty and energy that makes up the unique atmosphere of Tel Aviv.</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival_2020",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Location</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>More Info</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							         <p>DGTL Festival is back!  B</p>
//                                     <p>ringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                                     <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology, and art, as well as the latest discoveries in production and sound. </p>
//                                     <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which will operate simultaneously at any given moment.</p>
//                                     <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                                     <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the perfect host for DGTL festival.</p>
//                                     <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world!

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Week_2020",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Week 2020",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											12.6.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<div class="responisve-iframe">
// 					             <iframe width="560" height="315" src="https://www.youtube.com/embed/U8KwXVP3Xng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				             </div>
// 				             <div class="ac-cradit" style="margin-top: -15px;margin-bottom: 40px;">
// 							<span class="ac-cradit-text">Credits:</span>

// 								<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
// 							</div>
// 							<p></p>
// 							</div>
// 							 <h3>The  most fabulous event of the Year</h3>

//                             <p><strong>Tel Aviv 2020 Pride Celebrations – guaranteed to blow your mind!</strong></p>
//                             <p>Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties, but by far one of the biggest and hottest events in the city are the Gay Pride Week festivities culminating in the awesome Friday Pride Parade.</p>
//                             <p>The parade, a tradition which began as early as 1998 draws a huge crowd of the coolest people from around the world who come together to celebrate and support freedom and the embracing of all lifestyles and genres in an open-minded off the charts celebration.</p>
//                             <p>The parade is the highlight of a week of gay pride events that take place around the city and include nonstop pride-themed parties, exhibitions, movie festivals, music concerts and so much more. </p>
//                             <p>The parade itself takes place along the buzzing main streets of amazing Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic floats, live music, dance performances and revelers dressed in a colorful festival dress.</p>
//                             <p>The parade culminates at the stunning Tel Aviv promenade by the shores of the beautiful Tel Aviv coastline where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.  </p>
//                             <p>The 2020 parade will take place on June 12th 2020 and participation, as always, will be completely free of charge. </p>

// 					               `
// 			}
// 		}
//     },

//     {
// 	              id: "Hutzot_Hayotzer_Jerusalem_2020",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "Hutzot Hayotzer Jerusalem",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Location</h2>
// 											<div class="text">
// 												<p>
// 													The Sultan’s Pool, Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <div class="clear"></div>
//                                     <h3 >The International Arts and Crafts Festival</h3>
//                                     <p>Jerusalem is packed with fantastic events throughout the summer, one of the most celebrated events is the colorful “Hutzot Hayotzer International Art and Crafts Festival”. </p>
//                                     <p>This large-scale annual festival takes place in the Hutzot Hayotzer area and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
//                                     <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years and has become a hugely popular tourist and artistic attraction for visitors from around the world.</p>
//                                     <p>The festival includes more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more. The festival also includes an international exhibition, showcasing the work of overseas artist.</p>
//                                     <p>Visitors will get to engage in a fascinating dialogue of art and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music and all in an authentic European carnival atmosphere. </p>
//                                     <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
//                                     <p>Last but definitely not lease, don’t miss the “Food around the world” - an Israeli and international food fair which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival_2020",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							        <p>The city of Jerusalem is proud to host, for the 16th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’. </p>
//                                     <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>

//                                     <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an unparalleled atmosphere, guaranteeing an unforgettable experience.</p>

//                                     <p>The iconic festival has become over the years a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe to enjoy a delicious variety of excellent cold beers, food and people in open Jerusalem air.</p>

//                                     <p>During the festival, you will have the opportunity to taste any (or all) of the over 120 special flavors of beers from around the country and the world, served in pop up bars, build specifically for the festival. </p>
//                                     <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local artisanal breweries.</p>

//                                     <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Jerusalem_Wine_Festival_2020",
// 	    bgImage:"/Concerts/bank/jer-wine-festival-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jer-wine-festival-2020/M.jpg",
// 	    title: "Jerusalem Wine Festival",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							 <h3 >Wine and dine in the holy city!</h3>
// 							<p>Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world-class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premier social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.</p>
//                             <p>Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!</p>

// 					     `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival_2020",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Location</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, City -Wide
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													09.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>More Info</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="http://www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h3 >An amazing experience for design lovers everywhere</h3>
//                                     <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year in a row, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>
//                                     <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical buildings, and urban buildings. I from tours of residential apartments and new buildings. The Festival will also include special guided tours and attractions in unusual places.</p>
//                                     <p>The ‘Open Houses’ opens a one-time door and allow a glimpse into the forms of design, life forms, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
//                                     <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel-Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
//                                     <p> "Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
//                                     <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Purim_2020",
// 	              bgImage:"/Concerts/bank/purim2020/1.jpg",
// 	              mobBgImage:"/Concerts/bank/purim2020/M.jpg",
// 	              title: "Purim 2020",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Location</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv and Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													09-10.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									</div><div class="clear"></div>

//                                     <p>Every year in March, Tel Aviv and Jerusalem people dress up in costumes and the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!</p>
// 		                            <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/1.jpg"} class="img-responsive" />
// 									</div>
// 		                            <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – with the annual street party being Tel Aviv’s biggest event. Thousands of dressed up people will gather together in Kikar Hamedina to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.</p>
// 		                            <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/2.jpg"} class="img-responsive" />
// 									</div>
// 		                            <p>If you prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events are held at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!</p>
// 		                            <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/4.jpg"} class="img-responsive" />
// 									</div>
// 		                            <p>So choose your costume and come celebrate with us!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "TelAviv_Fashion_Week_2020",
// 	    bgImage:"/Concerts/bank/fashion-week-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/fashion-week-2020/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											03.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h3 >C'est chic, magnifique!</h3>
//                             <p>Fashion events are always a celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene. </p>

//                            <!--<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>-->
// 							<p>TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!</p>
//                             <p>In 2020, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "The_Jerusalem_March_2020",
// 	    bgImage:"/Concerts/bank/jerusalem-march/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jerusalem-march/M.jpg",
// 	    title: "The Jerusalem March",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.09.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<p>Taking place in October, the Jerusalem Walk is one of the most colorful and exciting events in the country, bringing together tens of thousands of marchers from around the world.</p>
//                              <p>The Jerusalem march includes three events - a morning walk on nature trails, a happening in Sacher Park and a festive parade that takes place in the streets of central Jerusalem.</p>
//                              <p>To ensure the inclusion of all those who want to join, the march offers a variety of routes with different lengths and difficulty levels. </p>
//                              <p><strong>Morning Tracks</strong><br/>
//                              	<u>Track A</u> - for those who can walk, about 12 km (07:00 to 09:00)</p>
//                              <p><strong>Ammunition Hill to Sacher Park.</strong><br/>
//                              	<u>Track B</u> - Medium difficulty level, about 9 km (07:30 to 09:30)</p>
//                              <p><strong>Mount Scopus to Sacher Park.</strong><br/>
//                                 <u>Track C </u>- easy / family difficulty level, about 4 km (08:00 to 10:00)</p>
//                              <p>Safra Square to Sacher Park.<br/>
//                              Sacher Park Festival </p>
//                              <p>Between 10:00 and 16:00 a festive happening will take place in Sacher Park that will include performances, live music and children’s shows, and a designated area dedicated for kids. </p>
//                              <p>The festive parade will begin at 15:00 and will follow the route of Bezalel, Hillel and King David streets and will end next to the bell park and will include collector vehicles, representative groups from Israel and around the world, orchestras, dance groups, IDF soldiers, street artists, sports teams and more.</p>
//                              <p>Don’t miss your chance to take part in this beautiful and lively Jerusalem celebration! </p>

// 				`
// 			}
// 		}
//     },

//     {

//         id:"The_Pixies_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.07.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="http://www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h3 >The Pixies - coming back to rock it live Tel Aviv!</h3>

// 										<p>The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!</p>
// 			                            <p>The famous American band, well known for its signature style of aggressive punk rock and pop, is responsible for some of the most iconic tunes in music history, including their all-time audience favorite ‘where is my mind’. The pixies are returning to Tel Aviv for the third time as part of their promotional tour for their new album, ‘Beneath the Eyrie’. </p>
// 			                            <p>The pixies will be giving a single performance in the nonstop city of Tel Aviv, the perfect way to rock your beach, sun and fun Tel Aviv holiday.  The concert is set to be held in July, a fabulous time to enjoy the famous Tel Aviv summer, the parties, the amazing cuisine, and the stunning beaches. </p>
// 			                            <p>Tickets are selling fast so hurry up and book your trip today!  </p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"White_Night_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "White Night",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h3>A “White Night” Rager In the Non-Stop City!</h3>

// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…</p>
//                             <p>From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.</p>
//                             <p>This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<p>The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time. </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv! </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"Piano_Competition_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Rubinstein International Piano Competition 2020",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05-21.05.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://arims.org.il/">
// 											www.arims.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>There is no shortage of fantastic arts and culture events in Tel Aviv, but the Rubinstein International Competition is the pride of the city. </p>

// 							<p>39 extremely talented pianists have been nominated to participate in the 16th Arthur Rubinstein International Piano Master Competition. 15 competitors are coming from Asia, 10 from Eastern Europe, 7 from Europe, 3 local talents, 2 from Georgia, and 2 from the USA. Tel Aviv, the cultural hub, is happy to welcome all of them. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/piano-competition-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>The first two stages of this prestigious competition will be held at the Tel Aviv Museum of Art, one of the country’s leading artistic and cultural institutions. The lively Sarona Market is only a 10-minute stroll from there. </p>
// 							<p>The final stages will be hosted at the Charles Bronfman Auditorium, also known as the Culture Palace (Heichal HaTarbut), located in Habima Square, next to the national theater. Some of the best cafés and restaurants of Tel Aviv are located nearby, as well as the beautiful Rothschild Boulevard. </p>
// 							<p>Early tickets sale for friends of the society and newcomers has already started. The regular sale will commence on 16 February 2020. </p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"Red_Hot_Chili_Peppers_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Red Hot Chili Peppers",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Location</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											10.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>More Info</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://redhotchilipeppers.com/">
// 											www.redhotchilipeppers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Red Hot Chili Peppers are coming to Funkyard Tel Aviv!</h2>
// 							<p><b>They’re hot, they’re sexy, they’re Red Hot Chili Peppers,<br class="hide-on-mobile"> and they’re coming back to Tel Aviv for the first time since 2012!</b></p>
// 							<p>With 11 albums, 16 Grammy nominations and six awards, this mega-successful band will make your heart, body, and soul dance at the new Funkyard Festival to be held at the green heart of Tel Aviv - Hayarkon Park. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/red-hot-chili-peppers-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>last December, the band announced the return of the legendary guitarist John Frusciante to the band for the second time, and we’re sure the LA funk-rock icons will rock the park once again.</p>
// 							<p>Red Hot Chili Peppers will give a single concert in the city that doesn’t stop, where you can start the day tanning at the beach with ice-cold beers and end up at one of the lively bars open till morning. The Peppers’ will perform at the beginning of summer when the temperatures are not too hot, but the parties across the city are sizzling. </p>
// 							<p>Tickets are on sale now and the concert is expected to be sold out, so book your trip before it’s gone!</p>

// 						`
// 			}
// 		}
// 	},

// ];

// End live shows
export const ShowsPostsData = [];

export const newPostdata = [
  {
    id: "Catholic-7_Day_Itinerary",
    ctg: "itineraries",
    bgImage: "posts/bank/catholic7dayitinerary/1.jpg",
    mobBgImage: "posts/bank/catholic7dayitinerary/M.jpg",
    isVid: false,
    vidId: "",
    title: "Catholic 7 Days Itinerary",
    smltitle: "",
    html: function() {
      return {
        __html: `	

				<h3>DAY 1: CAESAREA TO SEA OF GALILEE</h3>
				<p>Begin your journey by heading to Jaffa, the picturesque ancient port from which Jonah set sail on his fateful journey, where King Solomon imported the cedars of Lebanon to build the Temple in Jerusalem, and where Peter had his vision at the home of Simon the Tanner.</p>
				<p>Don’t miss the Visitor Center in Kedumim Square, showcasing the history of Jaffa, a site built around antiquities from the time of Jesus.</p>
				<p>Then, drive north across the Sharon Plain to the excavations of the ancient port city of Caesarea. King Herod built Caesarea in honor of his patron emperor, Augustus, in the mid-first century BC. This was also the provincial headquarters of the Roman governors, including Pontius Pilate, who was procurator of Judea at the time of Jesus.</p>
				<p>Peter’s story continues in Caesarea when Peter baptized Cornelius the Centurion. It was from this port that Paul set sail to preach in communities surrounding the Mediterranean Sea and where Paul was later imprisoned for two years and appeared before Felix, Festus, and King Agrippa. All these events are reflected in the ruins you will see, including the Roman theater, the Hippodrome, Herod's palace, and the Temple to Zeus. Learn more at the newly opened Visitors’ Center. You can also visit mosaics and other remains from the centuries when Caesarea was an important Christian center with its Crusader walls, moat, and gates.</p>
				<p>Drive through the Ara Valley to Tel Megiddo, referred to as Har-Magedon in Revelation 16:16. Tour the remains of one of the most consistently inhabited sites in the country with over 25 levels of civilization, spanning some 3,000 years, including walls, gates, palaces and dwellings from the time of King Solomon, King Ahab and the Assyrians. Be sure to walk through the water system, one of the great engineering marvels of the ancient world.</p>
				<p>Continue to Nazareth, stopping at Nazareth Village, an authentic, first-century farm and reconstruction of the village of Nazareth during the time of Jesus. Become a part of ancient Nazareth as you walk through the village and interact with locals in period dress and see the Bible come to life.</p>
				<p>Continue to the centuries-old Church of St. Gabriel that houses the village spring – one of the few authentic remains from the time of Jesus. Then visit the Basilica of the Annunciation, celebrating the Angel Gabriel’s announcement to Mary that she would bear the Messiah. The Basilica is built over the traditional site of Mary’s home.</p>
				<p>End your day atop Mount Arbel for a breathtaking view of the Sea of Galilee, the center of Jesus’ Galilean ministry.</p>
				<p>Overnight in the Sea of Galilee area. DAY 2</p>

				<h3>DAY 2: GALILEE</h3>
				<p>Begin your day at Kibbutz Ginosar to see the magnificent wooden, fishing boat, known as the Galilee Boat, which dates from the time of Jesus. Leave from Ginosar by boat and cross the Sea of Galilee on your way to Capernaum, stopping to worship on the sea where Jesus calmed the wind and the waves.<br/>
				Disembark at Capernaum and tour the “Town of Jesus” where Jesus established His ministry in Galilee. See the fourth-century synagogue which sits upon the foundation of the synagogue from Jesus’ days. Under the Chapel of Peter’s House, see the remains of an octagonal Byzantine church on the site of what was believed to be the home of Saint Peter.</p>
				<p>Leave Capernaum and visit Tabgha and the Chapel of The Primacy of Peter on the shore of the Sea of Galilee. Here, Jesus appeared to the Apostles after the resurrection. Experience the beautiful surroundings and descend to the water’s edge. Near this site is also the Church of the Multiplication with its famous mosaics, which celebrates the miracles of the fishes and loaves.</p>
				<p>Continue on to the Mount of Beatitudes, the hill where Jesus preached the Sermon on the Mount to the multitudes that stood below. Take a moment to read the Sermon on the Mount while enjoying a beautiful view of the Sea of Galilee.</p>
				<p>In the afternoon, drive north to Caesarea Philippi, known as Banias. Enjoy the natural beauty of the Banias nestled on the flourishing banks of one of the Jordan River’s main tributaries.</p>
				<p>Overnight in the Sea of Galilee area.</p>
				 
				<h3>DAY 3: SEA OF GALILEE TO THE DEAD SEA</h3>
				<p>After an Israeli breakfast at your hotel, leave the Sea of Galilee and drive south through the Jordan River Valley. You will notice as you travel that you will see lush and lavish landscape turn to desert terrain as you descend from 700 feet below sea level to 1,400 feet below sea level at the Dead Sea, the lowest point on earth.<br/>
				On the way, visit the well-preserved, Crusader fortress, Belvoir Castle. Built in the twelfth century, the fortress stands on a plateau high over the Jordan Valley. Your walking tour through the fortress will reveal halls, cisterns, and the secret of its strength.<br/>
				Continue south along the Jordan Valley to the ancient city of Beit She'an. Climb to the top of the huge mound of ancient Bet She’an and view the magnificent remnants of the Roman city of Scythopolis below. This was the capital of the Decapolis cities where the Gospels say the fame of Jesus spread during His public ministry. Walk the streets of Scythopolis and see the remains of temples and the marketplace.</p>
				<p>Continue down the Jordan Valley to Qasr Al-Yahud, the traditional baptismal site of Jesus of Nazareth. Celebrate a baptismal service at the site and consider all that took place near this site, including the miraculous crossing of the Jordan by the Israelites as they entered the Promised land, the resting place of Moses which is hidden just beyond the Jordan near Mount Nebo, the rapture of Elijah to heaven, and the ministry of John the Baptist and the baptism of Jesus.</p>
				<p>Continue south along the Dead Sea to Ein Bokek and enjoy a late afternoon float and soak in the medicinal waters of the Dead Sea.</p>
				<p>Overnight at Ein Bokek.</p>

				<h3>DAY 4: DEAD SEA TO JERUSALEM</h3>
				<p>Start your day on the southern end of the Dead Sea, and ascend to the top of an isolated rock plateau, to see one of the most spectacular views of the desert around you. Consider the years the Israelites spent wandering in terrain such as this.<br/>
				Drive to Masada and either hike the Snake Path or take the cable-car to the top. Masada was the scene of the epic resistance of the Jewish rebels at the end of the great revolt against Rome nearly 2,000 years ago. See the remnants of Herod’s palace, bath house, and storerooms. Walk down the Roman siege ramp and explore the huge cisterns that provided water for this desert retreat. The museum at the Visitor’s Center reveals the secrets of the daily life of the rebels, the story of the excavations, and how the site became one of Israel’s most important symbols of strength and heroism.</p>
				<p>Leave Masada and drive along the shore of the Dead Sea to the oasis at Ein Gedi where David hid from King Saul, and hike to a desert waterfall. <br/>
				After Ein Gedi, continue north to Qumran where the famed Dead Sea Scrolls were found. Modern scholarship places a community of Essenes at this site, and it is possible that John the Baptist also spent some time with the community here. Explore the remnants of the community, including the scribal rooms, dining hall, and mikvaot, and see some of the caves where the scrolls were found. Lunch at Qumran and take a moment to enjoy the gift shop, which has a selection of Dead Sea products.<br/>
				Leave Qumran and drive out of the Jordan Valley on your way to Jerusalem. Stop at a 19th-century Turkish building called the "Inn of the Good Samaritan.” There you can enjoy a museum, that features an open-air display of mosaics and archaeological findings from both Jewish and Samaritan synagogues, as well as Christian churches, including cisterns and remnants from the reconstructed Good Samaritan Byzantine Church.</p>
				<p>Continue to Jerusalem and stop for your first view of the Holy City from Mount Scopus. The first sight of Jerusalem is often a very emotional moment for both Christians and Jews. Open your Bibles to read Psalm 122, “I was glad when they said to me, ‘Let us go to the house of the Lord.’ Our feet are standing in your gates, O Jerusalem…” </p>
				<p>Overnight in Jerusalem.</p>

				<h3>DAY 5: JERUSALEM</h3>
				<p>Begin the new day at the most ancient part of Jerusalem – the City of David. In the past 120 years, this area has been excavated more than any area in Jerusalem. It boasts some of the most important discoveries in biblical archaeology. See the water source of ancient Jerusalem, the Gihon Spring, where King Solomon was crowned king of Israel. Bring your water shoes and headlamps and walk knee-deep through the water channel of Hezekiah’s Tunnel, named after the king who commissioned the digging of the channel to keep Jerusalem’s water supply safe from the Assyrians when the city was under siege around 720 BC.</p>
				<p>The tunnel will lead you to the Pool of Siloam, where recent excavations have uncovered the actual remains of the pool where Jesus healed a blind man. Take a walk up the partially excavated Pilgrim Road, the first-century road leading to the Temple. Walk back up to the visitor’s center through the Silwan neighborhood or take the ancient drainage tunnel under the city where a golden bell from the High Priest’s garment was found. The tunnel will lead to the Givati excavation, where it is believed the foundation of the ancient palace of King David has been discovered.</p>
				<p>Leave the City of David and enter the Dung Gate to the Jerusalem Archaeological Park. Explore the Southern Temple Excavations located around the southwestern corner of Temple Mount. Here you can stand on the very street that Jesus would have walked 2,000 years ago and view remnants of the Roman destruction of the Temple that took place in 70 AD. Climb the Southern Steps and recite the Psalms of Ascent (Psalms 120–134). You can also visit the magnificent Davidson Visitors Center in the basement of an 8th-century-CE palace. Take a look at the virtual-reconstruction, high-definition interactive model, and enjoy the high-definition film that depicts an ancient pilgrimage to the Temple.</p>
				<p>Exit the Davidson Center and visit the Western Wall, the last remnant of the Herodian Temple destroyed by the Romans nearly 2,000 years ago. While at the Western Wall[MOU3] [JD4] , arrange your schedule to join a public tour of the Western Wall Tunnels, also called the Rabbinical Tunnels. (Tours do need to booked in advance) If you wish to reserve in advance, enquire at the Western Wall Heritage Foundation.</p>
				<p>Stroll through the alleyways of the Jewish Quarter, including the Cardo, built by the Romans in the 2nd century, which became the main street of Jerusalem during the Byzantine era. Spend some time perusing the shops, but be sure to do so before the Sabbath begins.</p>
				<p>Overnight in Jerusalem</p>
				
				<h3>DAY 6: JERUSALEM</h3>
				<p>Start the day at the Israel Museum, home to the most important archaeological discovery of the 20th century – the Dead Sea Scrolls. An impressive model of Jerusalem in 69 AD sets the stage before entering the special shrine that contains the Scrolls. If time and interest permit, view the Antiquities section of the museum where most of the artifacts uncovered at the various sites throughout Israel are on display.</p>
				<p>Afterwards, stop at the square opposite the Knesset, to view Israel’s legislature and see the magnificent bronze menorah with its carvings depicting the biblical history of Israel and Zechariah’s immortal words “Not by might, nor by power but by My Spirit” (Zechariah 4:6).</p>
				<p>The, visit Yad Vashem, Israel's official memorial to the victims of the Holocaust, with its astounding historical museum, Hall of Remembrance, Children's Memorial and other sites. Do not rush this site, but take two or three hours to reflect deeply on the message of the memorial.</p>
				<p>In the afternoon, return to Mt. Zion in the Old City and tour its many sites, including King David’s Tomb, the Coenaculum, the Room of the Last Supper, and the Church of the Dormition. Despite its name, this is not the actual burial place of King David as his body was said to have been buried in the City of David. The tomb, however, is a medieval-era site, which is also situated in the same Crusader-era building marking the traditional site of the Last Supper.</p>
				<p>Take time to wander through the Old City markets, and enjoy the sights, sounds and aromas.Try your hand at bargaining for treasures.</p>
				<p>Overnight in Jerusalem. </p>

				<h3>DAY 7: JERUSALEM TO TEL AVIV</h3>
				<p>Welcome the day with one of the most magnificent views in the world – Jerusalem as seen from the top of the Mount of Olives. Allow time to visit the various churches on the summit, among them are the Pater Noster where the Lord’s Prayer is inscribed in dozens of languages, and the Chapel of Ascension, a Crusader-era chapel, marking the place where Jesus ascended to Heaven. Take the “Palm Sunday Walk” down the Mount of Olives in the footsteps of Jesus. On the way, stop at Dominus Flevit Church (The Lord Wept), marking the site of Jesus’ weeping over the city of Jerusalem (Luke 19:37-44).</p>

				<p>At the base of the mountain, visit the Garden of Gethsemane where you can spend time reflecting on Jesus [JD5] ' anguish before His arrest. See the ancient olive trees, and enter the impressive Church of All Nations, to see the brilliantly detailed floor-to-ceiling mosaics depicting the events of this important site.</p>
				<p>Cross the Kidron Valley and enter the Old City via the Lion’s Gate, also known as St. Stephen’s Gate to the Pool of Bethesda, where Jesus healed a paralytic (John 5: 2-9). Visit St. Anne's chapel, the purest Crusader church in the entire country, where Christian groups love to sing hymns due to the extraordinary acoustics. Walk the Via Dolorosa, the traditional street where Jesus walked from the place of His sentencing by Pontius Pilate to Golgotha. For as long as Christians have been visiting the Holy City, they have walked the last path of Jesus, ending in the Church of the Holy Sepulchre where Orthodox and Catholic Christians mark the site of His crucifixion, burial, and resurrection.</p>
									   
				`,
      };
    },
  },
  {
    id: "Youth_Itinerary_7_Day_Tour",
    ctg: "itineraries",
    bgImage: "posts/bank/youthitinerary7daytour/1.jpg",
    mobBgImage: "posts/bank/youthitinerary7daytour/M.jpg",
    isVid: false,
    vidId: "",
    title: "Youth Itinerary  - 7 Days Tour",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						<h3>Day 1</h3>
						<p>Start the day with breakfast in Old Jaffa and view the city from the Abrasha Park. Explore the archaeological site, walk through the old city streets to the house of Simon the Tanner. [MOU1] Learn [JD2] about the importance of Jaffa to the early spread of the gospel to the world.</p>
						<p>Afterwards, head to Tel Aviv and the Herzliya Marina for a morning sail on the Mediterranean Sea on a yacht. After your sail, head north along the Mediterranean coast to Caesarea where you will explore the ancient port city built by King Herod. Here, the Apostle Peter baptized the Roman centurion Cornelius, the first Gentile convert to Christianity (Acts 10).</p>
						<p>The Apostle Paul was also imprisoned for two years in Caesarea and made his powerful speech before Felix, Festus, and King Agrippa (Acts 25:6-12).</p>
						<p>From Caesarea drive to Haifa and see the beauty of the world-famous Bahai Gardens. From here, you will continue on to Acre, a city ruled at different times by the Egyptians, Phoenicians, Persians, Greeks, Muslims, and most notably, the Crusaders. You will explore the Crusader halls and tunnels and stroll through the city that welcomed such personalities as Alexander the Great, Julius Caesar, Herod, King Richard the Lionhearted, Marco Polo, Saladin, St. Francis of Assisi, and Napoleon Bonaparte! Overnight in Acre.</p>
						 
						<h3>Day 2</h3>
						<p>Start the day by riding bikes from Nahariyya to Rosh HaNikra and enjoy kayaking and diving in the grottos of Rosh HaNikra. After lunch, drive to the mountains of Western Galilee and hike to the Keshet Cave, followed by a rappelling class at the natural, stone, arch bridge. In the late afternoon, head to Karmiel to learn about Israel’s immigration system and meet Israeli youth at the Absorption Center. Overnight in the Sea of Galilee area.</p>

						<h3>Day 3</h3>
						<p>Leave the hotel early and head up to the Hula Valley for a morning bike ride to enjoy the beautiful lake, birds, and the fruit groves. You’ll then head up to the Banias area to see the headwaters of the Jordan River. Hike the trail to the Banias waterfall. Afterwards, drive up to the Golan Heights to explore the Nimrod Castle, a Crusader-era fortress in the Golan Heights. Afterwards, enjoy a Druze lunch in Magdal Shams. After lunch, head to Kibbutz Ein Zivan to explore and learn more about the kibbutz movement take time for a chocolate making workshop. End your day at Qatzrin, exploring this rebuilt, ancient town. Learn what life was like in Israel at the time of Jesus. Overnight in the Sea of Galilee area.</p>

						<h3>Day 4</h3>
						<p>Start your day with a boat ride on the Sea of Galilee in a replica boat from the time of Jesus. Disembark at Capernaum and explore the ancient ruins of the town Jesus chose as the center of his ministry in Galilee[MOU3] [JD4] [אנ5] . Drive south to Beit Shean, one of the Decapolis cities at the time of Jesus and explore the Roman ruins and climb to the top of the ancient tel.</p>
						<p>Afterwards, drive south down the Jordan River Valley to the Dead Sea. Drive to Ein Gedi, a natural oasis fed by four springs. David hid with his men from King Saul at Ein Gedi. Learn about the story and hike to David Falls.</p>
						<p>Afterwards, continue south to Masada and be challenged by hiking the Roman trail known as the Snake Path to the top of Masada. Explore Herod’s palaces, bathhouse, synagogue, and other fortifications on top of the plateau. Descend Masada by cable car, and head to Ein Bokek for a float in the Dead Sea.</p>
						<p>Drive out of the Dead Sea Valley to Arad and end your day with a desert experience and festive meal hosted by the hospitable Bedouin community. The night will be welcomed by star gazing in the desert and sleeping in Bedouin tents.</p>
						
						<h3>Day 5</h3>
						<p>Begin your day with a camel ride through the desert. Afterwards, head for Tel Beer Sheva and explore the ancient ruins. After lunch, drive to Bet Guvrin and spend the afternoon in a hands-on, archeological digging experience. Head to Jerusalem for dinner and overnight.</p>

						<h3>Day 6</h3>
						<p>Start your day at the City of David excavations and hike through Hezekiah tunnels in water up to your knees. Then walk the Via Dolorosa from the Lion’s Gate to the Church of the Holy Sepulchre. Afterwards, visit the Western Wall, and the exciting tunnels underneath it.</p>
						<p>After lunch, visit the Israel Museum where you will be mesmerized by a replica of Jerusalem during Jesus’ time and learn about the Bible’s origins at the Shrine of the Book. The day will continue at the Yad Vashem Holocaust Memorial Museum the garden of the Righteous Among the Nations. End your day with a nocturnal sound and light show at Jerusalem’s Tower of David. Overnight in Jerusalem.</p>

						<h3>Day 7</h3>
						<p>Begin your day with a visit to the Israeli Knesset where you will learn about Israeli democracy. Afterwards, head to Tel Aviv on the Mediterranean to learn about Israeli innovation at a start-up incubator showcasing the success of the Israeli business sector.</p>
						<p>Enjoy a leisurely lunch at an Ethiopian restaurant to learn about this Jewish community, their traditions, and the story of how they came to their homeland of Israel. Spend the afternoon volunteering at an Israeli charity as you learn more about the locals and living in Israel. Finish your day with some free time to visit a Tel Aviv beach. Enjoy a final dinner in Tel Aviv before heading to the airport for your flight home.</p>
							
						

					`,
      };
    },
  },
  {
    id: "First_Timers_7_Day_Tour",
    ctg: "itineraries",
    bgImage: "posts/bank/firsttimers7daytour/1.jpg",
    mobBgImage: "posts/bank/firsttimers7daytour/M.jpg",
    isVid: false,
    vidId: "",
    title: "First Timers - 7 Days Tour",
    smltitle: "",
    html: function() {
      return {
        __html: `	
					<h3>DAY 1: CAESAREA TO SEA OF GALILEE</h3>
					<p>Begin your journey by heading to Jaffa, the picturesque ancient port from which Jonah set sail on his fateful journey, where King Solomon imported the cedars of Lebanon to build the Temple in Jerusalem, and where Peter had his vision at the home of Simon the Tanner.</p>
					<p>Don’t miss the Visitor Center in Kedumim Square, showcasing the history of Jaffa, a site built around antiquities from the time of Jesus.</p>
					<p>Then, drive north across the Sharon Plain to the excavations of the ancient port city of Caesarea. King Herod built Caesarea in honor of his patron emperor, Augustus, in the mid-first century BC. This was also the provincial headquarters of the Roman governors, including Pontius Pilate, who was procurator of Judea at the time of Jesus.<br/>
					Peter’s story continues in Caesarea when Peter baptized Cornelius the Centurion. It was from this port that Paul set sail to preach in communities surrounding the Mediterranean Sea and where Paul was later imprisoned for two years and appeared before Felix, Festus, and King Agrippa. All these events are reflected in the ruins you will see, including the Roman theater, the Hippodrome, Herod's palace, and the Temple to Zeus. Learn more at the newly opened Visitors’ Center. You can also visit mosaics and other remains from the centuries when Caesarea was an important Christian center with its Crusader walls, moat, and gates.</p>
					<p>Drive through the Iron Valley (Wadi Ara) to Tel Megiddo, referred to as Har-Magedon in Revelation 16:16. Tour the remains of one of the most consistently inhabited sites in the country with over 25 levels of civilization, spanning some 3,000 years, including walls, gates, palaces and dwellings from the time of King Solomon, King Ahab and the Assyrians. Be sure to walk through the water system, one of the great engineering marvels of the ancient world.<br/>
					Continue to Nazareth, stopping at Nazareth Village, an authentic, first-century farm and reconstruction of the village of Nazareth during the time of Jesus. Become a part of ancient Nazareth as you walk through the village and interact with locals in period dress and see the Bible come to life.<br/>
					Continue to the centuries-old Church of St. Gabriel that houses the village spring – one of the few authentic remains from the time of Jesus. Then visit the Basilica of the Annunciation, celebrating the Angel Gabriel’s announcement to Mary that she would bear the Messiah. The Basilica is built over the traditional site of Mary’s home.</p>
					<p class="ac-margin-bot-20">End your day atop Mount Arbel for a breathtaking view of the Sea of Galilee, the center of Jesus’ Galilean ministry.</p>

					<h3>DAY 2: GALILEE</h3>
					<p>Begin your day at Kibbutz Ginosar to see the magnificent wooden, fishing boat, known as the Galilee Boat, which dates from the time of Jesus. Leave from Ginosar by boat and cross the Sea of Galilee on your way to Capernaum, stopping to worship on the sea where Jesus calmed the wind and the waves.<br/>
					Disembark at Capernaum and tour the “Town of Jesus” where Jesus established His ministry in Galilee. See the fourth-century synagogue which sits upon the foundation of the synagogue from Jesus’ day. Under the Chapel of Peter’s House, see the remains of an octagonal Byzantine church on the site of what was believed to be the home of Saint Peter.</p>
					<p>Leave Capernaum and visit Tabgha and the Chapel of The Primacy of Peter on the shore of the Sea of Galilee. Here, Jesus appeared to the Apostles after the resurrection. Experience the beautiful surroundings and descend to the water’s edge. Near this site is also the Church of the Multiplication with its famous mosaics, which celebrates the miracles of the fishes and loaves.</p>
					<p>Continue on to the Mount of Beatitudes, the hill where Jesus preached the Sermon on the Mount to the multitudes that stood below. Take a moment to read the Sermon on the Mount while enjoying a beautiful view of the Sea of Galilee.</p>
					<p>In the afternoon, drive north to Caesarea Philippi, known as Banias. Enjoy the natural beauty of the Banias nestled on the flourishing banks of one of the Jordan River’s main tributaries.<small>[MOU1] [JD2]</small></p>
					<p class="ac-margin-bot-20">Overnight in the Sea of Galilee area.</p>
					 
					<h3>DAY 3: SEA OF GALILEE TO THE DEAD SEA</h3>
					<p>After an Israeli breakfast at your hotel, leave the Sea of Galilee and drive south through the Jordan River Valley. You will notice as you travel that you will see lush and lavish landscape turn to desert terrain as you descend from 700 feet below sea level to 1,400 feet below sea level at the Dead Sea, the lowest point on earth.</p>
					<p>On the way, visit the well-preserved, Crusader fortress, Belvoir Castle. Built in the twelfth century, the fortress stands on a plateau high over the Jordan Valley. Your walking tour through the fortress will reveal halls, cisterns, and the secret of its strength.</p>
					<p>Continue south along the Jordan Valley to the ancient city of Beit She'an. Climb to the top of the huge mound of ancient Bet She’an and view the magnificent remnants of the Roman city of Sythopolis below. This was the capital of the Decapolis cities where the Gospels say the fame of Jesus spread during His public ministry. Walk the streets of Sythopolis and see the remains of temples and the marketplace.</p>
					<p>Continue down the Jordan Valley to Qasr Al-Yahud, the traditional baptismal site of Jesus of Nazareth. Celebrate a baptismal service at the site and consider all that took place near this site, including the miraculous crossing of the Jordan by the Israelites as they entered the Promised land, the resting place of Moses which is hidden just beyond the Jordan near Mount Nebo, the rapture of Elijah to heaven, and the ministry of John the Baptist and the baptism of Jesus. </p>
					<p>Continue south along the Dead Sea to Ein Bokek and enjoy a late afternoon float and soak in the medicinal waters of the Dead Sea.</p>
					<p class="ac-margin-bot-20">Overnight at Ein Bokek.</p>

					<h3>DAY 4: Dead Sea to Jerusalem</h3>
					<p>Start your day on the southern end of the Dead Sea, and ascend to the top of an isolated rock plateau, to see one of the most spectacular views of the desert around you. Consider the years the Israelites spent wandering in terrain such as this.</p>
					<p>Drive to Masada and either hike the Snake Path or take the cable-car to the top. Masada was the scene of the epic resistance of the Jewish rebels at the end of the great revolt against Rome nearly 2,000 years ago. See the remnants of Herod’s palace, bath house, and storerooms. Walk down the Roman siege ramp and explore the huge cisterns that provided water for this desert retreat. The museum at the Visitor’s Center reveals the secrets of the daily life of the rebels, the story of the excavations, and how the site became one of Israel’s most important symbols of strength and heroism.</p>
					<p>Leave Masada and drive along the shore of the Dead Sea to the oasis at Ein Gedi where David hid from King Saul, and hike to a desert waterfall. </p>
					<p>After Ein Gedi, continue north to Qumran where the famed Dead Sea Scrolls were found. Modern scholarship places a community of Essenes at this site, and it is possible that John the Baptist also spent some time with the community here. Explore the remnants of the community, including the scribal rooms, dining hall, and mikvaot, and see some of the caves where the scrolls were found. Lunch at Qumran and take a moment to enjoy the gift shop, which has a selection of Dead Sea products.</p>
					<p>Leave Qumran and drive out of the Jordan Valley on your way to Jerusalem. Stop at a 19th-century Turkish building called the "Inn of the Good Samaritan.” There you can enjoy a museum, that features an open-air display of mosaics and archaeological findings from both Jewish and Samaritan synagogues, as well as Christian churches, including cisterns and remnants from the reconstructed Good Samaritan Byzantine Church.</p>
					<p>Continue to Jerusalem and stop for your first view of the Holy City from Mount Scopus. The first sight of Jerusalem is often a very emotional moment for both Christians and Jews. Open your Bibles to read Psalm 122, “I was glad when they said to me, ‘Let us go to the house of the Lord.’ Our feet are standing in your gates, O Jerusalem…” </p>
					<p class="ac-margin-bot-20">Overnight in Jerusalem.</p>

					<h3>DAY 5: Jerusalem</h3>
					<p>Begin the new day at the most ancient part of Jerusalem – the City of David. In the past 120 years, this area has been excavated more than any area in Jerusalem. It boasts some of the most important discoveries in biblical archaeology. See the water source of ancient Jerusalem, the Gihon Spring, where King Solomon was crowned king of Israel. Bring your water shoes and headlamps and walk knee-deep through the water channel of Hezekiah’s Tunnel, named after the king who commissioned the digging of the channel to keep Jerusalem’s water supply safe from the Assyrians when the city was under siege around 720 BC.</p>
					<p>The tunnel will lead you to the Pool of Siloam, where recent excavations have uncovered the actual remains of the pool where Jesus healed a blind man. Take a walk up the partially excavated Pilgrim Road, the first-century road leading to the Temple. Walk back up to the visitor’s center through the Silwan neighborhood or take the ancient drainage tunnel under the city where a golden bell from the High Priest’s garment was found. The tunnel will lead to the Givati  excavation, where it is believed the foundation of the ancient palace of King David has been discovered.</p>
					<p>Leave the City of David and enter the Dung Gate to the Jerusalem Archaeological Park. Explore the Southern Temple Excavations located around the southwestern corner of Temple Mount. Here you can stand on the very street that Jesus would have walked 2,000 years ago and view remnants of the Roman destruction of the Temple that took place in 70 AD. Climb the Southern Steps and recite the Psalms of Ascent (Psalms 120–134). You can also visit the magnificent Davidson Visitors Center in the basement of an 8th-century-CE palace. Take a look at the virtual-reconstruction, high-definition interactive model, and enjoy the high-definition film that depicts an ancient pilgrimage to the Temple.</p>
					<p>Exit the Davidson Center and visit the Western Wall, the last remnant of the Herodian Temple Mount destroyed by the Romans nearly 2,000 years ago. While at the Western Wall, arrange your schedule to join a public tour of the Western Wall Tunnels, also called the Rabbinical Tunnels. If you wish to reserve in advance, enquire at the Western Wall Heritage Foundation.</p>
					<p>Stroll through the alleyways of the Jewish Quarter, including the Cardo, built by the Romans in the 2nd century, which became the main street of Jerusalem during the Byzantine era. Spend some time perusing the shops, but be sure to do so before the Sabbath begins.</p>
					<p class="ac-margin-bot-20">Overnight in Jerusalem.</p>

					<h3>DAY 6: Jerusalem</h3>
					<p>Start the day at the Israel Museum, home to the most important archaeological discovery of the 20th century – the Dead Sea Scrolls. An impressive model of Jerusalem in 69 AD sets the stage before entering the special shrine that contains the Scrolls. If time and interest permit, view the Antiquities section of the museum where most of the artifacts uncovered at the various sites throughout Israel are on display.</p>
					<p>Afterwards, stop at the square opposite the Knesset, to view Israel’s legislature and see the magnificent bronze menorah with its carvings depicting the biblical history of Israel and Zechariah’s immortal words “Not by might, nor by power but by My Spirit” (Zechariah 4:6).</p>
					<p>The, visit Yad Vashem, Israel's official memorial to the victims of the Holocaust, with its astounding historical museum, Hall of Remembrance, Children's Memorial and other sites. Do not rush this site, but take two or three hours to reflect deeply on the message of the memorial.</p>
					<p>In the afternoon, return to Mt. Zion in the Old City and tour its many sites, including King David’s Tomb, the Coenaculum, the Room of the Last Supper, and the Church of the Dormition. Despite its name, this is not the actual burial place of King David as his body was said to have been buried in the City of David. The tomb, however, is a medieval-era site, which is also situated in the same Crusader-era building marking the traditional site of the Last Supper.</p>
					<p>Take time to wander through the Old City markets, and enjoy the sights, sounds and aromas.Try your hand at bargaining for treasures.</p>
					<p class="ac-margin-bot-20">Overnight in Jerusalem.</p>
					 
					<h3>DAY 7: Jerusalem to Tel Aviv</h3>

					<p>Welcome the day with one of the most magnificent views in the world – Jerusalem as seen from the top of the Mount of Olives. Allow time to visit the various churches on the summit, among them are the Pater Noster where the Lord’s Prayer is inscribed in dozens of languages, and the Chapel of Ascension, a Crusader-era chapel, marking the place where Jesus ascended to Heaven. Take the “Palm Sunday Walk” down the Mount of Olives in the footsteps of Jesus. On the way, stop at Dominus Flevit Church (The Lord Wept), marking the site of Jesus’ weeping over the city of Jerusalem (Luke 19:37-44).</p>

					<p>At the base of the mountain, visit the Garden of Gethsemane where you can spend time reflecting on the Lord’s anguish before His arrest. See the ancient olive trees, and enter the impressive Church of All Nations, to see the brilliantly detailed floor-to-ceiling mosaics depicting the events of this important site.</p>
					<p>Cross the Kidron Valley and enter the Old City via the Lion’s Gate, also known as St. Stephen’s Gate to the Pool of Bethesda, where Jesus healed a paralytic (John 5: 2-9). Visit St. Anne's chapel, the purest Crusader church in the entire country, where Christian groups love to sing hymns due to the extraordinary acoustics. Walk the Via Dolorosa, the traditional street where Jesus walked from the place of His sentencing by Pontius Pilate to Golgotha. For as long as Christians have been visiting the Holy City, they have walked the last path of Jesus, ending in the Church of the Holy Sepulchre where Orthodox and Catholic Christians mark the site of His crucifixion, burial, and resurrection.</p>
					<p>The day will end with a visit to the Garden Tomb. Located a short distance to the north of the Damascus Gate, this ancient garden cemetery, discovered more than 150 years ago by the British General Charles Gordon, is a beautiful site in which to recall the crucifixion, burial, and resurrection of Jesus. Take a tour, enter the empty tomb, and enjoy a moment in a secluded, garden alcove with your group in prayer, song, and fellowship. End your journey to Israel by celebrating the Eucharist and taking communion together with olive-wood cups, which can be obtained from the Garden Tomb Association. Transfer to Tel Aviv for flight home.</p>

					`,
      };
    },
  },
  {
    id: "General_Israel_Itinerary",
    ctg: "itineraries",
    bgImage: "posts/bank/generalisraelitinerary/1.jpg",
    mobBgImage: "posts/bank/generalisraelitinerary/M.jpg",
    isVid: false,
    vidId: "",
    title: "General Israel Itinerary",
    smltitle: "",
    html: function() {
      return {
        __html: `	
	
		<h3>DEPARTURE FLIGHT &ndash; SATURDAY NIGHT</h3>
		<h3>DAY 1 - SUNDAY</h3>
		<p>Arrive at Ben Gurion International Airport  </p>
		<p>Transfer to Tel Aviv</p>
		<p>Dinner in Tel Aviv</p>
		<h3>OVERNIGHT: TEL AVIV</h3>
		<h3>DAY 2- MONDAY: TEL AVIV AND JAFFA</h3>
		<p>Drive to  Jaffa, one of the oldest biblical cities in the world, and an important seaport since antiquity. Visit Jaffa&apos;s restored Old City including the artists&apos; colony and the quaint historic harbor. Jaffa has much to offer in the way of art galleries, gift-shops and restaurants found tucked away amongst the winding, cobblestone alleyways. Nearby, visit the flourishing flea market. Tour the new visitor center, which tells the ancient city&rsquo;s 4,000-year-old story using state-of-the art techniques. An animated film recounts the myth of Andromeda and a dynamic display on a huge screen traces the city&rsquo;s history by illustrating important periods and events that took place there: the conquest of Jaffa by the Egyptians 3,500 years ago, the story of the Prophet Jonah who tried to flee from G-d, the spread of Christianity that began in Jaffa, the Ottoman administration, the wars and the reconstruction of the city.</p>
	
		<p>Proceed to  Independence Trail  and trace the story of Tel Aviv and the modern State of Israel beginning with the founding of Tel Aviv in 1909 and ending with the Declaration of Independence by David Ben Gurion May 14, 1948. Stop at the various sites and museums along the way to dive deeper into this inspiring, improbable story.</p>
	
		<p>For the history enthusiast, choose from an array of other sites and museums that tell the story of modern Israel. These can range from interactive experiences about the &ldquo;Palmach,&rdquo; Israel&rsquo;s elite fighting force to a clandestine bullet factory disguised as a bakery, which was run by teenagers.</p>
		 
		<p>Neve Tzedek.  This historic neighborhood has earned a reputation as the &ldquo;new Soho.&rdquo; Visitors enjoy its lovely narrow streets, wonderful Suzanne Dallal Centre of Dance, and charming galleries, restaurants, and cafes. Look for Shabazi Street &ndash; wonderful galleries and shops there</p>
		 
		<p>Dinner and evening in Tel Aviv area</p>
		<h3>OVERNIGHT: TEL AVIV</h3>
		<h3>DAY 3 - TUESDAY: UPPER GALILEE</h3>
		 
		<p>Caesaria, built by Herod the Great, was the Roman capital of Palestine for nearly 600 years. The extensive seaside ruins date back to Roman, Byzantine and Crusader times. Explore the 2,000-year-old Roman Theater, Crusader harbor and 12th-century ramparts. In addition to exciting ruins, this site also contains some new audio-visual presentations, which use modern technology (holographs) to highlight the ancient site and allow you to &ldquo;meet&rdquo; some of the historical figures who lived there.</p>
		 
		<p>Lunch in the Old City of Akko (Acre) at one of its most famous seafood restaurants.  </p>
		 
		<p>OR</p>
		 
		<p>Visit a Druze Village to hear about this unique community in the North of Israel while enjoying traditional Druze cuisine and hospitality.</p>
		 
		<p>Akko,  the coastal city, served as one of the key ports of Israel over much of its long history. The Canaanites and Phoenicians utilized the port, and the city is mentioned in ancient Egyptian records. Walk along the city&rsquo;s old harbor and visit the local market. Also visit the Turkish baths and the Prison. The Templars, who were also known as the Poor Knights of Christ and of the Temple of Solomon, built the Templar tunnels in the second half of the 12th century. Thanks to these buildings, UNESCO declared Akko a World Heritage Site in 2001</p>
		 
		<p>Depart for  Safed,  which sits at a higher altitude than any other city in Israel and has been known since the 16th century as a major center of Kabbalah, Jewish mysticism. Safed is one of Israel&rsquo;s four holy cities, along with Jerusalem, Tiberias and Hebron. Its old synagogues, narrow alleyways and artists&rsquo; colony add to the hilltop city&rsquo;s unmistakable charm</p>
		 
		<p>  Check into hotel or kibbutz guesthouse         </p>
		<h3>  OVERNIGHT: UPPER GALILEE</h3>
		 
		<h3>DAY 4- WEDNESDAY: NORTHERN ISRAEL</h3>
		 
		<p>Hike through the beautiful  Tel Dan Nature Reserve  with gorgeous trails leading through dense forest, streams, and the Chatzbani River. This is the site where the tribe of Dan once lived. Extensive archeological digs in the area have uncovered much of this ancient city along with the altar that once stood here.</p>
		 
		<p>OR</p>
		<p>Enjoy horseback riding with scenic views of Northern Israel or kayaking in the Jordan River.</p>
		<p>Jeep tour  up the  Golan Heights  in the footsteps of IDF soldiers and their battles in the Six Day War, to enjoy the beautiful natural scenery and gain an insight into the strategic complexity of the Golan</p>
		 
		<p>Explore Israel&apos;s security situation on the  Golan Heights  from  Mt. Bental  overlooking the abandoned Syrian town of Kuneitra, for a first-hand view of Israel&rsquo;s security position along the Syrian Border; visit a former Israeli bunker and gain further insight into the challenges Israel faced during the 1973 Yom Kippur War</p>
		 
		<p>Visit one of the many award-winning wineries in the region and combine it with fun for the kids such as such as  chocolate making, operating an old olive oil press, or a culinary workshop.  </p>
		 
		<p>Enjoy a tour and dinner at a local kibbutz</p>
		<h3>OVERNIGHT: UPPER GALILEE</h3>
		 
		 
		<h3>DAY 5 - THURSDAY: LOWER GALILEE</h3>
		<p>Drive to the  Hula Valley Nature Reserve  and enjoy a bike ride or golf-cart ride through the natural vegetation along the waters&rsquo; edge to see nature at its best. In the early 1990s part of the valley was flooded in the wake of heavy rains and it was decided to develop the surrounding area and leave the flooded area intact. The new site has become the second home and major stopover for hundreds of thousands of migrating birds in the autumn and spring from Europe to Africa and back. The lake covers an area of one square kilometer interspersed with islands that serve as protected bird nesting sites and the valley has become a major bird-watching site</p>
		 
		<p>At a Biblical-style village,  don traditional Israelite dress and take a donkey ride through countryside which has hardly changed in 2000 years. Afterwards, enjoy a whole range of activities such as baking fresh pita bread and making home- made cheese (from goat&rsquo;s milk) as our ancestors did</p>
		 
		<p>Drive south towards Jerusalem along the  Jordan Rift Valley</p>
		 
		<p>Stop and immerse yourself in history in  Beit She&rsquo;an, one of Israel&rsquo;s most spectacular archeological sites, with uncovered remains of a major Roman city, including a 10,000- seat theater as well as mosaics, ancient streets, public buildings and more</p>
		<p>Arrive in Jerusalem and check into hotel  </p>
		<p>Dinner and evening in Jerusalem</p>
		<h3>OVERNIGHT: JERUSALEM</h3>
		 
		<h3>DAY 6 - FRIDAY: JERUSALEM</h3>
		 
		<p>Walking tour through the  Jewish Quarter  of the Old City of Jerusalem, with visits to some of the sites excavated over the past 30 years, including:</p>
		<ul>
			<li>
				The <strong>Cardo</strong>, a Byzantine street that is now the world&rsquo;s oldest shopping arcade
			</li>
			<li>
				The <strong>Hurva Square</strong>, the central square of the Jewish Quarter
			</li>
			<li>
				The 2,000-year-old <strong>Herodian Mansions</strong>
			</li>
			<li>
				The <strong>Jerusalem Archaeological Park</strong>, including a visit to the Davidson Center and the Southern Wall Excavations
			</li>
			<li>
				The <strong>Kotel</strong> (Western Wall)
			</li>
			<li>
				The <strong>Western Wall Tunnel</strong>
			</li>
		</ul>
		 
		<p><strong>Machaneh Yehuda Market</strong>,  one of the most colorful spots in downtown Jerusalem. Stretching one city block, the market sells the best produce at the best prices in town. Visiting on Friday lets you experience the full effect of a bustling, Middle Eastern market</p>
		 
		<p>Optional: Bring in Shabbat at the Western Wall</p>
		 
		<p><strong>Enjoy a Shabbat home hosted dinner or group</strong>  experience in Jerusalem</p>
		 
		<h3>OVERNIGHT: JERUSALEM</h3>
		 
		<h3>Day 7: JERUSALEM OR SOUTHERN ISRAEL (NEGEV)</h3>
		 
		<h3>Optional Shabbat services and day at leisure</h3>
		 
		<p>OR</p>
		 
		<p>Descend to the <strong>Dead Sea Basin</strong></p>
		 
		<p>Arrive at  Masada  and ascend by cable car or climb up the Snake Path. As you explore the ancient remains of fortifications, King Herod&apos;s palaces, storerooms and baths, you will hear about the spirit of its last Jewish defenders. These Zealots held out for three years against the Roman legions in 70BCE and chose to die as free men at their own hands in preference to Roman slavery. From the top of Masada, the outlines of the Roman encampments are still visible below</p>
		 
		<p>Experience the weightlessness of the <strong>Dead Sea</strong>  as you float in its waters. The Dead Sea is the lowest place on earth and the water and mud of the Dead Sea are known for its healing and nourishing minerals</p>
		 
		<p>Learn about the Bedouin community in Israel by enjoying a homemade Bedouin lunch followed by camel riding!</p>
		 
		<p>Time and weather permitting, continue to  <strong>Ein Gedi</strong>  oasis and nature reserve and hike up to and cool off in the refreshing freshwater pools and waterfalls. The stunning Ein Gedi oasis consists of two separate waterways: Nachal David (David&rsquo;s Stream), where David took refuge from King Saul; and Nachal Arugot, where remains of a 6th-century synagogue were discovered. You will be able to appreciate the unique and flourishing flora and fauna of this area and you may be lucky enough to catch a glimpse of a few beautiful ibex and oryx hiding in the surrounding mountains</p>
		 
		<p>Return to Jerusalem</p>
		 
		<p>Dinner in Jerusalem followed by <strong>Night Spectacular at the Tower of David Museum</strong>  - a sound and light show not to be missed!</p>
		 
		<h3>OVERNIGHT: JERUSALEM</h3>
		<h3>DAY 8: JERUSALEM  </h3>
		 
		<p>Dig deep into the past at one of Israel&rsquo;s hundreds of archaeological sites where thousands of underground caves date back to the time of the Phoenicians. Become an archaeologist for a day and take part in a hands-on archaeological dig at the caves, which served as storerooms, burial crypts and safe havens during the time of the Bar Kochba revolt against the Romans</p>
		 
		<p>Visit the newly renovated  Yad Vashem  complex, the Jewish National Memorial to the six million Jewish victims of the Holocaust, including:</p>
		<ul>
			<li>
				The <strong>Avenue of the Righteous</strong>
			</li>
			<li>
				The new <strong>Historical Museum</strong>
			</li>
			<li>
				The <strong>Children's Memorial</strong>
			</li>
			<li>
				Ending with a <strong>Memorial Service</strong>
			</li>
		</ul>
		 
		<p>  Evening and dinner in Jerusalem</p>
		 
		<h3>OVERNIGHT: JERUSALEM</h3>
		 
		<h3>DAY 9: JERUSALEM-  </h3>
		 
		<p>End you trip with a meaningful  <strong>volunteer opportunity</strong>  by giving back &ndash; harvest surplus agricultural produce from local farms to be donated to the needy, plant a tree in a forest and learn about Israel&rsquo;s national sustainability story, and much more....</p>
		 
		<p>Tour the stunning <strong>Israel Museum</strong>, the largest cultural institution in the State of Israel, which is ranked among the world&rsquo;s leading art and archaeology museums. Founded in 1965, the museum houses encyclopedic collections, including works dating from prehistory to the present day in its archaeology, fine arts, and Jewish art and life wings; it also features the most extensive holdings of biblical and Holy Land archaeology in the world. In just 45 years, the museum has built a far-ranging collection of nearly 500,000</p>
		<p>objects, representing the full scope of world material culture. In July 2010, the museum reopened to great acclaim after a three-year renovation. Along with the exhibits, the museum includes the model of Jerusalem during temple times, the Billy Rose Sculpture Garden, the Youth Wing and the Shrine of the Book, where the Dead Sea Scrolls are housed</p>
		 
		<p>Free afternoon to shop and explore Jerusalem before departure</p>
		 
		<p>Enjoy your last evening and dinner in Jerusalem before heading to the airport</p>
		 
		<p>Transfer to Ben Gurion Airport for the group flight</p>
		<h3>OVERNIGHT: FLIGHT</h3>
					`,
      };
    },
  },
  {
    id: "Marketing_Cooperation_Agreement",
    ctg: "itineraries",
    bgImage: "posts/bank/Marketing_Cooperation_Agreement/1.jpg",
    mobBgImage: "posts/bank/Marketing_Cooperation_Agreement/M.jpg",
    isVid: false,
    fullTemplatePage: true,
    vidId: "",
    title: "Marketing Cooperation Agreement",
    smltitle: "",
    html: function() {
      return {
        __html: `	
		<p>The Israel Ministry of Tourism (IMOT) operates extensively to increase tourism to Israel, a large portion of activity being dedicated to marketing and promotion. We view the cooperation with the industry as invaluable and the tourism trade professionals as strategic partners for advancing our efforts to promote and increase tourism to Israel. It has been a long standing policy of the Ministry to assist tourism trade entities in their efforts to market Israel as an outstanding and unique destination. This assistance is part of the Ministry’s wide array of marketing efforts and is a common practice in our global activities. As we wish to expand our marketing efforts, we cordially invite you to establish a new marketing cooperation, or continue our existing marketing cooperation.</p>
<p>The purpose of this procedure is to regulate the Marketing Cooperation Agreements between IMOT and/or its overseas Israel Government Tourism Offices (hereinafter "IGTO"), and between tourism wholesalers, retailers, airlines, and different operators or relevant organizations around the world that conduct marketing activities aimed at the increase of tourism to Israel.
<p>IMOT's participation will be in the form of partaking in the costs of marketing activities performed by the agent within the framework of promoting tourism to Israel. </p>
<p>IMOT's participation in the agent's expenses will be up to 50% of each approved activity.</p>
<p>The following marketing activities can be recognized for the purpose of this agreement: 1) Advertising in various media: I. Printed media e.g. newspapers, magazines etc. II. Broadcast media e.g. TV, Radio etc. III. Online media e.g. internet, mobile etc. 2) Printing of promotional materials e.g. agent catalogues, brochures etc. 3) Seminars for target audiences e.g. tourism agents, religious leaders, relevant decision makers, relevant public audiences etc. 4) Direct mailing (post, e-blast etc.) 5) Any other form of marketing activity promoting tourism to Israel that will be approved by IMOT. </p>
<p>IMOT will not participate in the promotion of flight-seats only. </p>
<p>Regarding Online activities – IMOT will participate in the costs of online advertising, but not in the costs of the construction and maintenance of websites or any other online platform (apps, social media etc.)</p>

		
					`,
      };
    },
  },

  {
    id: "Why_Israel",
    ctg: "itineraries",
    bgImage: "posts/bank/Why_Israel/1.jpg",
    mobBgImage: "posts/bank/Why_Israel/M.jpg",
    isVid: false,
    fullTemplatePage: true,
    vidId: "",
    title: "Why Israel",
    smltitle: "",
    html: function() {
      return {
        __html: `	
		<p>Innovative people and futuristic country built on ancient pillars.<br/>
		Cutting edge of global innovation.<br/>
		Endless networking opportunities at the heart of the Startup Nation.<br/>
		Everlasting emotional experience at the Land of Creation.<br/>
		Israel connects to major cities around the world:<br/>
		Istanbul: 2hrs | Dubai: 3.5hrs | Paris: 5hrs | Amsterdam: 5hrs | London: 6hrs | Moscow: 7hrs | Stockholm: 8hrs | Beijing: 9hrs Johannesburg: 9hrs | New York: 10hrs | Toronto: 10hrs | Chicago: 11hrs | Hong Kong: 11hrs | Sao Paulo: 14hrs | San Francisco: 14hrs</p>
		<p>Ben Gurion Airport (TLV):</p>
		<ul>
		<li>Ultra-modern airport </li>
		<li>Close to everywhere in Israel</li>
		<li>20 km from Tel Aviv</li>
		<li>40 km from Jerusalem</li>
		<li>60 km Dead Sea</li>
		<li>VIP facilities</li>
		</ul>








		
					`,
      };
    },
  },

  {
    id: "The_Industrial_Cooperation_Authority",
    ctg: "itineraries",
    bgImage: "posts/bank/The_Industrial_Cooperation_Authority/1.jpg",
    mobBgImage: "posts/bank/The_Industrial_Cooperation_Authority/M.jpg",
    isVid: false,
    fullTemplatePage: true,
    vidId: "",
    title: "The Industrial Cooperation Authority (ICA)",
    smltitle: "",
    html: function() {
      return {
        __html: `	
		<p>Foreign companies committed to reciprocal procurement in Israel will be able to realize some of their obligations in Israel by purchasing business tourism services in Israel (MICE)</p>

		<p>Jerusalem, 27 November 2022 - The Industrial Cooperation Authority (ICA) at the Israel Ministry of Economy and Industry has, following discussions with the Israel Hotels Association and the Israel Ministry of Tourism, decided on a pilot that would facilitate reciprocal procurement in the field of incoming business tourism, for international companies that have won government tenders. </p>
		
		<p>This means that international companies committed to reciprocal procurement in Israel will be able to purchase hotel accommodation services within the framework of business tourism: conferences, seminars, corporate vacations, exhibitions, etc. The new outline should give a significant boost to business tourism (MICE) in Israel, which is considered a central engine for growth in the tourism industry.</p>
		
		<p>Against this background and following an appeal on behalf of the Israel Hotels Association and the Israel Ministry of Tourism, the ICA has decided, within the framework of the realization of commitments of foreign companies (in government tenders) for business collaborations and reciprocal procurement, to temporarily allow recognition of services and/or products that include accommodation services for MICE tourism, corporate vacations, conferences, seminars for no less than $75,000 per event. Such business tourism activities will be recognized as collaboration within the framework of the company’s commitments to indirect collaboration, and not instead of direct collaboration (direct collaboration in the project in which the company won the tender). In addition, in the outline, regular tourism expenses that are not part of the business tourism events will not be recognized.</p>
		
		<p>The agreement is valid for two years. In the first stage, the Tourism Ministry and the Economy Ministry will approach international companies currently committed to reciprocal procurement and market this new outline.</p>
		
		<p>The ICA, which operates in the Israel Ministry of Economy and Industry, is entrusted with the management of the State of Israel's reciprocal procurement, to monitor the realization of the commitments of the foreign companies and the connection between Israeli factories and industry and the relevant foreign companies, with emphasis on industrial activity in the periphery and promoting small and medium-sized businesses.</p>
		<p>A foreign company, from which government entities purchase, are obliged by law to make procurements and industrial collaborations in Israel from Israeli companies for a certain amount of the transaction: 50% on security transactions, 20% on civilian transactions with countries who are signatories of the GPA agreement and 35% on all other transactions. The ICA monitors this compulsory obligation, from the tender phase, through the preparation of a business plan together with the foreign companies where investment options are offered in Israeli companies, to the monitoring of debt.</p>

        <p>Procurement is a significant growth engine that produces business opportunities worth billions of dollars annually for Israeli industry, which contributes to the development of the industry and breaking into new markets for these industries. Procurement is much more than a legal commitment - it represents leverage for investment in Israeli industry and economic growth, creates business relationships between Israeli and foreign companies, and a quality, long-term investment for foreign companies which today understand more and more that reciprocal procurement in Israel is a most lucrative investment.</p>
        <a href="//ica.gov.il/eng/Pages/default.aspx" rel="noopener" target="_blank">The Industrial Cooperation Authority at the Ministry of Economy and Industry (ica.gov.il)</a>
	
		
					`,
      };
    },
  },
  {
    id: "Multi_Generational_Israel_Itinerary",
    ctg: "itineraries",
    bgImage: "posts/bank/MultiGenerationalIsraelItinerary/1.jpg",
    mobBgImage: "posts/bank/MultiGenerationalIsraelItinerary/M.jpg",
    isVid: false,
    vidId: "",
    title: "Multi-Generational Israel Itinerary",
    smltitle: "",
    html: function() {
      return {
        __html: `	

		  
		<h3>DEPARTURE FLIGHT &ndash; SATURDAY NIGHT</h3>
		<h3>DAY 1 - SUNDAY&nbsp;</h3>
		<p>Arrive at Ben Gurion International Airport&nbsp;</p>
		<p>Transfer to Tel Aviv</p>
		<p>Dinner in Tel Aviv</p>
		<h3>OVERNIGHT: TEL AVIV</h3>
		  
		<h3>DAY 2- MONDAY: TEL AVIV AND JAFFA</h3>
		<p>Drive to <strong>Jaffa</strong>, one of the oldest biblical cities in the world, and an important seaport since antiquity. Visit Jaffa&apos;s restored Old City including the artists&apos; colony and the quaint historic harbor. Jaffa has much to offer in the way of art galleries, gift-shops and restaurants found tucked away amongst the winding, cobblestone alleyways. Nearby, visit the flourishing flea market. Tour the new visitor center, which tells the ancient city&rsquo;s 4,000-year-old story using state-of-the art techniques. An animated film recounts the myth of Andromeda and a dynamic display on a huge screen traces the city&rsquo;s history by illustrating important periods and events that took place there: the conquest of Jaffa by the Egyptians 3,500 years ago, the story of the Prophet Jonah who tried to flee from G-d, the spread of Christianity that began in Jaffa, the Ottoman administration, the wars and the reconstruction of the city.</p>
		  
		<p>Proceed to&nbsp;Independence Trail&nbsp;and trace the story of Tel Aviv and the modern State of Israel beginning with the founding of Tel Aviv in 1909 and ending with the Declaration of Independence by David Ben Gurion May 14, 1948. Stop at the various sites and museums along the way to dive deeper into this inspiring, improbable story.</p>
		  
		<p>For the history enthusiast, choose from an array of other sites and museums that tell the story of modern Israel. These can range from interactive experiences about the &ldquo;Palmach,&rdquo; Israel&rsquo;s elite fighting force to a clandestine bullet factory disguised as a bakery, which was run by teenagers.</p>
		  
		<p>Neve Tzedek.&nbsp;This historic neighborhood has earned a reputation as the &ldquo;new Soho.&rdquo; Visitors enjoy its lovely narrow streets, wonderful Suzanne Dallal Centre of Dance, and charming galleries, restaurants, and cafes. Look for Shabazi Street &ndash; wonderful galleries and shops there</p>
		  
		<p>Dinner and evening in Tel Aviv area</p>
		<h3>OVERNIGHT: TEL AVIV</h3>
		<h3>DAY 3 - TUESDAY: UPPER GALILEE</h3>
		  
		<p>Caesaria, built by Herod the Great, was the Roman capital of Palestine for nearly 600 years. The extensive seaside ruins date back to Roman, Byzantine and Crusader times. Explore the 2,000-year-old Roman Theater, Crusader harbor and 12th-century ramparts. In addition to exciting ruins, this site also contains some new audio-visual presentations, which use modern technology (holographs) to highlight the ancient site and allow you to &ldquo;meet&rdquo; some of the historical figures who lived there.</p>
		  
		<p>Lunch in the Old City of Akko (Acre) at one of its most famous seafood restaurants.&nbsp;</p>
		  
		<p>OR</p>
		  
		<p>Visit a Druze Village to hear about this unique community in the North of Israel while enjoying traditional Druze cuisine and hospitality.</p>
		  
		<p>Akko,&nbsp;the coastal city, served as one of the key ports of Israel over much of its long history. The Canaanites and Phoenicians utilized the port, and the city is mentioned in ancient Egyptian records. Walk along the city&rsquo;s old harbor and visit the local market. Also visit the Turkish baths and the Prison. The Templars, who were also known as the Poor Knights of Christ and of the Temple of Solomon, built the Templar tunnels in the second half of the 12th century. Thanks to these buildings, UNESCO declared Akko a World Heritage Site in 2001</p>
		  
		<p>Depart for&nbsp;Safed,&nbsp;which sits at a higher altitude than any other city in Israel and has been known since the 16th century as a major center of Kabbalah, Jewish mysticism. Safed is one of Israel&rsquo;s four holy cities, along with Jerusalem, Tiberias and Hebron. Its old synagogues, narrow alleyways and artists&rsquo; colony add to the hilltop city&rsquo;s unmistakable charm</p>
		  
		<p>&nbsp;Check into hotel or kibbutz guesthouse &nbsp; &nbsp; &nbsp;</p>
		<h3>&nbsp;OVERNIGHT: UPPER GALILEE</h3>
		  
		<h3>DAY 4- WEDNESDAY: NORTHERN ISRAEL</h3>
		  
		<p>Hike through the beautiful&nbsp;Tel Dan Nature Reserve&nbsp;with gorgeous trails leading through dense forest, streams, and the Chatzbani River. This is the site where the tribe of Dan once lived. Extensive archeological digs in the area have uncovered much of this ancient city along with the altar that once stood here.</p>
		  
		<p>OR</p>
		<p>Enjoy horseback riding with scenic views of Northern Israel or kayaking in the Jordan River.</p>
		<p>Jeep tour&nbsp;up the&nbsp;Golan Heights&nbsp;in the footsteps of IDF soldiers and their battles in the Six Day War, to enjoy the beautiful natural scenery and gain an insight into the strategic complexity of the Golan</p>
		  
		<p>Explore Israel&apos;s security situation on the&nbsp;Golan Heights&nbsp;from&nbsp;Mt. Bental&nbsp;overlooking the abandoned Syrian town of Kuneitra, for a first-hand view of Israel&rsquo;s security position along the Syrian Border; visit a former Israeli bunker and gain further insight into the challenges Israel faced during the 1973 Yom Kippur War</p>
		  
		<p>Visit one of the many award-winning wineries in the region and combine it with fun for the kids such as such as&nbsp;chocolate making, operating an old olive oil press, or a culinary workshop.&nbsp;</p>
		  
		<p>Enjoy a tour and dinner at a local kibbutz</p>
		<h3>OVERNIGHT: UPPER GALILEE</h3>
		  
		  
		<h3>DAY 5 - THURSDAY: LOWER GALILEE</h3>
		<p>Drive to the&nbsp;Hula Valley Nature Reserve&nbsp;and enjoy a bike ride or golf-cart ride through the natural vegetation along the waters&rsquo; edge to see nature at its best. In the early 1990s part of the valley was flooded in the wake of heavy rains and it was decided to develop the surrounding area and leave the flooded area intact. The new site has become the second home and major stopover for hundreds of thousands of migrating birds in the autumn and spring from Europe to Africa and back. The lake covers an area of one square kilometer interspersed with islands that serve as protected bird nesting sites and the valley has become a major bird-watching site</p>
		  
		<p>At a Biblical-style village,&nbsp;don traditional Israelite dress and take a donkey ride through countryside which has hardly changed in 2000 years. Afterwards, enjoy a whole range of activities such as baking fresh pita bread and making home- made cheese (from goat&rsquo;s milk) as our ancestors did</p>
		  
		<p>Drive south towards Jerusalem along the&nbsp;Jordan Rift Valley</p>
		  
		<p>Stop and immerse yourself in history in&nbsp;Beit She&rsquo;an, one of Israel&rsquo;s most spectacular archeological sites, with uncovered remains of a major Roman city, including a 10,000- seat theater as well as mosaics, ancient streets, public buildings and more</p>
		<p>Arrive in Jerusalem and check into hotel&nbsp;</p>
		<p>Dinner and evening in Jerusalem</p>
		<h3>OVERNIGHT: JERUSALEM</h3>
		  
		<h3>DAY 6 - FRIDAY: JERUSALEM</h3>
		  
		<p>Walking tour through the&nbsp;Jewish Quarter&nbsp;of the Old City of Jerusalem, with visits to some of the sites excavated over the past 30 years, including:</p>
		<ul>
			<li>
				The&nbsp;Cardo, a Byzantine street that is now the world&rsquo;s oldest shopping arcade
			</li>
			<li>
				The&nbsp;Hurva Square, the central square of the Jewish Quarter
			</li>
			<li>
				The 2,000-year-old&nbsp;Herodian Mansions
			</li>
			<li>
				The&nbsp;Jerusalem Archaeological Park, including a visit to the Davidson Center and the Southern Wall Excavations
			</li>
			<li>
				The&nbsp;Kotel&nbsp;(Western Wall)
			</li>
			<li>
				The Western Wall Tunnel
			</li>
		</ul>
		  
		<p>Machaneh Yehuda Market,&nbsp;one of the most colorful spots in downtown Jerusalem. Stretching one city block, the market sells the best produce at the best prices in town. Visiting on Friday lets you experience the full effect of a bustling, Middle Eastern market</p>
		  
		<p>Optional: Bring in Shabbat at the Western Wall</p>
		  
		<p>Enjoy a Shabbat home hosted dinner or group&nbsp;experience in Jerusalem</p>
		  
		<h3>OVERNIGHT: JERUSALEM</h3>
		  
		<h3>Day 7: JERUSALEM OR SOUTHERN ISRAEL (NEGEV)</h3>
		  
		<h3>Optional Shabbat services and day at leisure</h3>
		  
		<p>OR</p>
		  
		<p>Descend to the&nbsp;Dead Sea Basin</p>
		  
		<p>Arrive at&nbsp;Masada&nbsp;and ascend by cable car or climb up the Snake Path. As you explore the ancient remains of fortifications, King Herod&apos;s palaces, storerooms and baths, you will hear about the spirit of its last Jewish defenders. These Zealots held out for three years against the Roman legions in 70BCE and chose to die as free men at their own hands in preference to Roman slavery. From the top of Masada, the outlines of the Roman encampments are still visible below</p>
		  
		<p>Experience the weightlessness of the&nbsp;Dead Sea&nbsp;as you float in its waters. The Dead Sea is the lowest place on earth and the water and mud of the Dead Sea are known for its healing and nourishing minerals</p>
		  
		<p>Learn about the Bedouin community in Israel by enjoying a homemade Bedouin lunch followed by camel riding!</p>
		  
		<p>Time and weather permitting, continue to&nbsp;Ein Gedi&nbsp;oasis and nature reserve and hike up to and cool off in the refreshing freshwater pools and waterfalls. The stunning Ein Gedi oasis consists of two separate waterways: Nachal David (David&rsquo;s Stream), where David took refuge from King Saul; and Nachal Arugot, where remains of a 6th-century synagogue were discovered. You will be able to appreciate the unique and flourishing flora and fauna of this area and you may be lucky enough to catch a glimpse of a few beautiful ibex and oryx hiding in the surrounding mountains</p>
		  
		<p>Return to Jerusalem</p>
		  
		<p>Dinner in Jerusalem followed by&nbsp;Night Spectacular at the Tower of David Museum&nbsp;&ndash; a sound and light show not to be missed!</p>
		  
		<h3>OVERNIGHT: JERUSALEM</h3>
		<h3>DAY 8: JERUSALEM&nbsp;</h3>
		  
		<p>Dig deep into the past at one of Israel&rsquo;s hundreds of archaeological sites where thousands of underground caves date back to the time of the Phoenicians. Become an archaeologist for a day and take part in a hands-on archaeological dig at the caves, which served as storerooms, burial crypts and safe havens during the time of the Bar Kochba revolt against the Romans</p>
		  
		<p>Visit the newly renovated&nbsp;Yad Vashem&nbsp;complex, the Jewish National Memorial to the six million Jewish victims of the Holocaust, including:</p>
		<ul>
			<li>
				The&nbsp;Avenue of the Righteous
			</li>
			<li>
				The new&nbsp;Historical Museum
			</li>
			<li>
				The&nbsp;Children&apos;s Memorial
			</li>
			<li>
				Ending with a&nbsp;Memorial Service
			</li>
		</ul>
		  
		<p>&nbsp;Evening and dinner in Jerusalem</p>
		  
		<h3>OVERNIGHT: JERUSALEM</h3>
		  
		<h3>DAY 9: JERUSALEM-&nbsp;</h3>
		  
		<p>End you trip with a meaningful&nbsp;volunteer opportunity&nbsp;by giving back &ndash; harvest surplus agricultural produce from local farms to be donated to the needy, plant a tree in a forest and learn about Israel&rsquo;s national sustainability story, and much more....</p>
		  
		<p>Tour the stunning&nbsp;Israel Museum, the largest cultural institution in the State of Israel, which is ranked among the world&rsquo;s leading art and archaeology museums. Founded in 1965, the museum houses encyclopedic collections, including works dating from prehistory to the present day in its archaeology, fine arts, and Jewish art and life wings; it also features the most extensive holdings of biblical and Holy Land archaeology in the world. In just 45 years, the museum has built a far-ranging collection of nearly 500,000</p>
		<p>objects, representing the full scope of world material culture. In July 2010, the museum reopened to great acclaim after a three-year renovation. Along with the exhibits, the museum includes the model of Jerusalem during temple times, the Billy Rose Sculpture Garden, the Youth Wing and the Shrine of the Book, where the Dead Sea Scrolls are housed</p>
		  
		<p>Free afternoon to shop and explore Jerusalem before departure</p>
		  
		<p>Enjoy your last evening and dinner in Jerusalem before heading to the airport</p>
		  
		<p>Transfer to Ben Gurion Airport for the group flight</p>
		<h3>OVERNIGHT: FLIGHT</h3>
	
					`,
      };
    },
  },
  {
    id: "ISRAEL_CULINARY_TOUR",
    ctg: "itineraries",
    bgImage: "posts/bank/israelculinarytour/1.jpg",
    mobBgImage: "posts/bank/israelculinarytour/M.jpg",
    isVid: false,
    vidId: "",
    title: "ISRAEL CULINARY TOUR (SAMPLE ITINERARY)",
    smltitle: "",
    html: function() {
      return {
        __html: `	

		            <h3>Day 1</h3>
					<p>Arrivals at Ben Gurion International Airport</p>
					<p>Guests to be greeted by tourism official representatives and escorted to private car</p>
					
					<p>Drive to Jerusalem</p>
					
					<p>Visit a winery in the Judean mountains for a welcome toast / a hotel on the way to the city</p>
					
					<p>Quick visit&nbsp;The German Colony neighborhood in Jerusalem, established in the second half of the 19th century by members of the German Temple Society. The Moshava, is an upscale neighborhood bisected by Emek Refaim Street, an avenue lined with trendy shops, restaurants, and cafes (+the new train station)</p>
					
					<p>Check in to your hotel &nbsp;</p>
					<p>Freshen up/relax and prepare for dinner</p>
					
					<p>7:30pm Dinner at restaurant in the market/city center (TBD)</p>
					
					<p>Overnight at Jerusalem</p>
					
					<h3>Day 2</h3>
					
					<p>Breakfast at hotel</p>
					
					<p>9:30 Tour of the Jerusalem Old City and its main historical and religious sites: &nbsp;</p>
					
					<ul>
						<li>
							Tower of David at the Citadel
						</li>
						<li>
						Western&nbsp;Wall (Kotel) - Judaism&rsquo;s most sacred site
						</li>
						<li>
							Food tasting in the&nbsp;Muslim Quarter Market and talk with a local vendor
						</li>
						<li>
							Via Dolorosa (Stations of the Cross)
						</li>
						<li>
							Christian Quarter with the Church of the Holy Sepulcher
						</li>
						<li>
							Reconstructed Jewish Quarter and Cardo - ruins of a main street &nbsp;&nbsp;
						</li>
					</ul>
					
					<p>Continue to Machane Yehuda outdoor market and sample some local delicacies.</p>
					
					<p>8:00 pm Dinner at area restaurant</p>
					
					<p>10:00 pm (Optional) night walk along the ramparts of the Old City and/or nightlife tour</p>
					
					<h3>Day 3</h3>
					
					<p>Breakfast at your hotel</p>
					
					<p>9:30 am visit to the Israel Museum in Jerusalem&nbsp;</p>
					
					<p>12:30 pm Head towards the historic village of Ein Kerem (birthplace of John the Baptist to experience a culinary workshop with a local family</p>
					
					<p>5:00 pm tour the culinary spaces of hotel(s) in the Mamilla district + wine tasting followed by a short tour of Mamilla with optional shopping</p>
					
					<p>8:00 pm Dinner at Jerusalem area restaurant</p>
					
					<p>Overnight at Jerusalem area hotel (TBD)</p>
					
					
					<h3>Day 4</h3>
					
					<p>Drive to Tel Aviv/Jaffa &ndash; Israel&rsquo;s financial, cultural and entertainment mecca</p>
					
					<p>Optional &ndash; stop at a brewery along the way</p>
					
					<p>10:00 am Tel Aviv tour to include: Nachalat Binyamin pedestrian mall, Neve Tzedek (Tel Aviv&rsquo;s oldest neighborhood), and Rothchild Blvd. &nbsp;</p>
					
					<p>12:00 pm Hummus tasting at Jaffa area hummuseriya</p>
					
					<p>Continue to Old Jaffa &ndash; the Ancient Port city including fisherman&rsquo;s port and revitalized artists&rsquo; quarter and flea market</p>
					
					<p>3:00 pm return to hotel/free time</p>
					
					<p>8:00 pm Dinner at Tel Aviv area restaurant and meet with chef / dinner at a private house</p>
					
					<p>10:00 pm Nightlife tour of Tel Aviv</p>
					
					
					<h3>Day 5</h3>
					
					<p>Breakfast at your hotel</p>
					
					<p>9:30 am Drive along the coast to Haifa &ndash; Israel&rsquo;s third largest city and second largest port</p>
					
					<p>Haifa tour to include: Bahai Shrine and Gardens &ndash; the world center of Bahai Faith and UNESCO World Heritage site.</p>
					<p>Visit the Talpiyut market</p>
					
					<p>12:00 pm Continue to Daliat El Carmel Druze village high up the slopes of Mt. Carmel. Stroll the market with its shops and art galleries.</p>
					
					<p>2:00 pm Visit a local dairy farms in Bat Shlomo and sample high quality goat and cow cheeses and meet the dairy farms&rsquo; cheesemaker</p>
					
					<p>Take a stroll around Zichron Yaacov in the heart of Israel&rsquo;s wine country, which was founded by Baron Edmund de Rothchild in 1880.</p>
					
					<p>Continue to area winery to sample Israel&rsquo;s most notable wines and meet with the winemakers</p>
					
					<p>6:00 pm Drive to Caesarea- &nbsp;take a brief tour of the ancient port build by King Herod and its new visitor center</p>
					
					<p>7:00 pm Dinner at area restaurant in Caesarea</p>
					
					<p>9:30 pm Drive back to Tel Aviv/Overnight at area hotel (TBD)</p>
					
					<h3>Day 6</h3>
					
					<p>Breakfast at your hotel</p>
					
					<p>9:30 am Experience culinary food tour at Carmel Market led by local food expert &nbsp;</p>
					
					<p>2:30 pm River walk through Yarkon Park &ndash; Tel Aviv&rsquo;s Urban Oasis - &nbsp;alongside the Yarkon River in&nbsp;</p>
					<p>Tel Aviv and visit the agricultural farm there &ndash; experience the petting zoo and learn more about their</p>
					<p>&nbsp;urban gardening project&nbsp;</p>
					
					<p>7:30 pm Dinner at area restaurant at the Port of Tel Aviv, with a visit from a local a&nbsp;</p>
					<p>culinary expert and advisor for restaurants followed by a nightlife tour</p>
					
					<h3>Day 7&nbsp;</h3>
					
					<p>Departures from Ben Gurion International</p>
					`,
      };
    },
  },
  {
    id: "Active_Israel_Itinerary",
    ctg: "itineraries",
    bgImage: "posts/bank/ActiveIsraelItinerary/1.jpg",
    mobBgImage: "posts/bank/ActiveIsraelItinerary/M.jpg",
    isVid: false,
    vidId: "",
    title: "Active Israel Itinerary",
    smltitle: "",
    html: function() {
      return {
        __html: `	
		<p>Departure flight &ndash; Saturday night&nbsp;</p>
		 
		<h3>Day 1, Sunday: Arrival</h3>
		 
		<p>Arrive at Ben Gurion International Airport&nbsp;</p>
		<p>Transfer to Tel Aviv</p>
		<p>Dinner in Tel Aviv</p>
		 
		<p>Overnight in Tel Aviv&nbsp;</p>
		 
		<h3>Day 2, Monday: Tel Aviv</h3>
		 
		<p>Tel Aviv has a unique, cool and just al around fun vibe. Take<strong>&nbsp;a walk from the HaBima Square</strong> all the way through <strong>Rothchild Blvd</strong>. You will see all the cafe&rsquo;s and restaurants. At the end of Rothchild Blvd you will get to Neve Tzedek. This historic neighborhood has earned a reputation as the &ldquo;new Soho.&rdquo; Visitors enjoy its lovely narrow streets, wonderful Suzanne Dallal Centre of Dance, and charming galleries, restaurants, and cafes. Look for Shabazi Street &ndash; wonderful galleries and shops there.&nbsp;</p>
		 
		<p>Proceed to the <strong>Herbert Samuel promenade</strong> along the beach where you can take a<strong>&nbsp;bike and ride</strong> while passing by the wonderful sunny beaches (of the Mediterranean Sea) until you reach the <strong>Tel Aviv port</strong> that was transformed into a dining and shopping area, you can walk around in the wooden docks and enjoy the great breeze.&nbsp;</p>
		 
		<p>If the weather allows it, you can take part in&ndash; surf <strong>water sport</strong>, sail, dive, Yoga on the beach, SUP &ndash; you name it! &nbsp;</p>
		<p>Take a <strong>graffiti tour</strong> that will take you inside the creative urban street art throughout the city, see the different neighborhoods (the tours are relevant for morning and evening).&nbsp;</p>
		 
		<p>Overnight in Tel Aviv&nbsp;</p>
		 
		<h3>Day 3, Tuesday:&nbsp;Western Galilee</h3>
		 
		<p>On the way to the north (about 55 Km / 34 miles from Tel Aviv) make a stop in <strong>Caesarea</strong>, built by Herod the Great, was the Roman capital of Palestine for nearly 600 years. The extensive seaside ruins date back to Roman, Byzantine and Crusader times. Explore the 2,000-year-old Roman Theater, Crusader harbor and 12th-century ramparts. In addition to exciting ruins, this site also contains some new audio-visual presentations, which use modern technology (holographs) to highlight the ancient site and allow you to &ldquo;meet&rdquo; some of the historical figures who lived there.</p>
		 
		<p>Lunch in the <strong>Old City of Akko</strong> (Acre) at one of its famous fish &amp; seafood restaurants.&nbsp;</p>
		 
		<p>Drive north to <strong>Rosh Hanikra</strong> - The cable car, which is the steepest in the world, takes visitors down for a fascinating encounter with the sea grottoes. The walking path in the heart of the cliff exposes visitors to the grottoes, which &ndash; more simply put &ndash; are sea caves.&nbsp;</p>
		<p>From - <a href="https://www.akko.org.il/en/Rosh-Hanikra-Tourist-Site-">https://www.akko.org.il/en/Rosh-Hanikra-Tourist-Site-</a></p>
		 
		<p>Drive East and hike part of the <strong>Israel trail</strong></p>
		 
		<p>Overnight in Western Galilee &nbsp;</p>
		 
		<h3>Day 4, Wednesday:&nbsp;Northern Israel, Galilee</h3>
		 
		<p><strong>Nature Reserve Nahal Amud</strong> - In Nahal Amud Nature Reserve there is a combination of a unique form of nature and human heritage, including a perennial stream, rock pools, the lush vegetation characteristic of riverbanks, flour mills, and prehistoric caves.</p>
		<p>From <a href="https://www.parks.org.il/en/reserve-park/amud-stream-nature-reserve/">https://www.parks.org.il/en/reserve-park/amud-stream-nature-reserve/</a></p>
		 
		<p>Winter time - ski at <strong>Mount Hermon</strong></p>
		 
		<p>Hike through the beautiful <strong>Tel Dan Nature Reserve</strong> with gorgeous trails leading through dense forest, streams, and the Chatzbani River. This is the site where the tribe of Dan once lived. Extensive archeological digs in the area have uncovered much of this ancient city along with the altar that once stood here.</p>
		<p><br>Enjoy horseback riding with scenic views of Northern Israel or kayaking in the<strong>&nbsp;Jordan River.&nbsp;</strong></p>
		 
		<p>Tour and dinner at a local kibbutz</p>
		 
		<p>Overnight in Upper Galilee&nbsp;</p>
		 
		<h3>Day 5, Thursday:&nbsp;Lower Galilee</h3>
		 
		<p>Drive to the <strong>Hula Valley Nature Reserve</strong> and enjoy a bike ride or golf-cart ride through the natural vegetation along the waters&rsquo; edge to see nature at its best. In the early 1990s part of the valley was flooded in the wake of heavy rains and it was decided to develop the surrounding area and leave the flooded area intact. The new site has become the second home and major stopover for hundreds of thousands of migrating birds in the autumn and spring from Europe to Africa and back. The lake covers an area of one square kilometer interspersed with islands that serve as protected bird nesting sites and the valley has become a major bird-watching site</p>
		 
		<p>Bike around<strong>&nbsp;Sea of Galilee</strong></p>
		 
		<p>Hike down <strong>Mount Arbel</strong>, overlooking Sea of Galilee</p>
		 
		<p>Drive south towards Jerusalem along the<span style="font-size:12pt;font-family:Calibri,sans-serif;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap;">Jordan Rift Valley</span></p>
		 
		<p>Arrive in <strong>Jerusalem</strong> and check into hotel&nbsp;</p>
		 
		<p>Dinner and evening in Jerusalem</p>
		 
		<p>Overnight in Jerusalem&nbsp;</p>
		 
		<h3>Day 6, Friday: Jerusalem</h3>
		 
		<p>Walking tour through the <strong>Jewish Quarter</strong> of the Old City of Jerusalem, with visits to some of the sites excavated over the past 30 years, including:&nbsp;</p>
		 
		<p>The <strong>Cardo</strong>, a Byzantine street that is now the world&rsquo;s oldest shopping arcade</p>
		<ul>
			<li>
				The <strong>Hurva Square</strong>, the central square of the Jewish Quarter
			</li>
			<li>
				The 2,000-year-old <strong>Herodian Mansions</strong>
			</li>
			<li>
				The<strong>&nbsp;Jerusalem Archaeological Park</strong>, including a visit to the Davidson Center and the Southern Wall Excavations
			</li>
			<li>
				The <strong>Kotel&nbsp;</strong>(Western Wall)
			</li>
			<li>
				The Western Wall Tunnel
			</li>
		</ul>
		 
		<p><strong>Ramparts walk</strong> above walls of Old City</p>
		 
		<p><strong>Repel&nbsp;</strong>down walls of Old City</p>
		 
		<p>&quot;Hike&quot; through Hezekiah&apos;s Tunnel in <strong>City of David</strong></p>
		 
		<p><span style='color: rgb(0, 0, 0); font-family: "Times New Roman"; font-size: medium; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; display: inline !important; float: none;'><strong>Machaneh Yehuda Marke</strong></span><strong>t</strong>, one of the most colorful spots in downtown Jerusalem. Stretching one city block, the market sells the best produce at the best prices in town. Visiting on Friday lets you experience the full effect of a bustling, Middle Eastern market.<br>Have a <strong>Culinary tour&nbsp;</strong>of Machane Yehuda</p>
		 
		<p>Optional: Bring in Shabbat at the Western Wall</p>
		<p>Electric scooter tours of Jerusalem</p>
		<p><strong>Enjoy a Shabbat home hosted dinner or group</strong> experience in Jerusalem</p>
		 
		<p>Overnight in Jerusalem&nbsp;</p>
		 
		<h3>Day 7, Saturday: The Dead Sea</h3>
		 
		<p>Descend to the&nbsp;<strong>Dead Sea Basin</strong></p>
		 
		<p>Time and weather permitting, continue to&nbsp;<strong>Ein Gedi</strong>&nbsp;oasis and nature reserve and hike up to and cool off in the refreshing freshwater pools and waterfalls. The stunning Ein Gedi oasis consists of two separate waterways: Nachal David (David&rsquo;s Stream), where David took refuge from King Saul; and Nachal Arugot, where remains of a 6th-century synagogue were discovered. You will be able to appreciate the unique and flourishing flora and fauna of this area and you may be lucky enough to catch a glimpse of a few beautiful ibex and oryx hiding in the surrounding mountains</p>
		 
		<p>Arrive at&nbsp;<strong>Masada</strong>&nbsp;and ascend by cable car or climb up the Snake Path. As you explore the ancient remains of fortifications, King Herod&apos;s palaces, storerooms and baths, you will hear about the spirit of its last Jewish defenders. These Zealots held out for three years against the Roman legions in 70BCE and chose to die as free men at their own hands in preference to Roman slavery. From the top of Masada, the outlines of the Roman encampments are still visible below</p>
		 
		<p>Hike up <strong>&lsquo;snake path&rsquo; </strong>to Masada</p>
		 
		<p>Experience the weightlessness of the&nbsp;Dead Sea&nbsp;as you float in its waters. The <strong>Dead Sea</strong> is the lowest place on earth and the water and mud of the Dead Sea are known for its healing and nourishing minerals</p>
		 
		<p>Learn about the Bedouin community in Israel by enjoying a homemade Bedouin lunch followed by&nbsp;<strong>camel riding!</strong></p>
		 
		<p>Overnight in The Dead Sea</p>
		 
		<h3>Day 8,&nbsp;Sunday:&nbsp;Negev and Arava</h3>
		 
		<p><strong>En Avdat spring</strong>&nbsp;- At the foot of Midreshet Ben Gurion, the Tsin Stream has carved out a deep and impressive canyon. Three springs feed a brook that flows all year round, and an enchanted oasis. En Avdat &ndash; the kingdom of ibex and vultures.</p>
		<p>From: <a href="https://www.parks.org.il/en/reserve-park/en-avdat-national-park-2/">https://www.parks.org.il/en/reserve-park/en-avdat-national-park-2/</a>&nbsp;</p>
		 
		<p>Jeeping &nbsp;and repelling in <strong>Ramon Crater</strong></p>
		 
		<p>Machtesh Ramon -&nbsp;At the heart of Israel&rsquo;s vast Negev Desert, lies the Ramon Crater, the world&rsquo;s largest erosion crater, also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an elongated heart, and forms Israel&rsquo;s largest national park, the Ramon Nature Reserve.</p>
		 
		<p>Camel riding (with a Bedouin experience)</p>
		 
		<p>Biking in the&nbsp;<strong>Negev trails</strong></p>
		 
		<p>Tour in a Kibutz in the&nbsp;<strong>Arava </strong>- Desert agriculture, renewable energy and other fascinating stories:</p>
		<ul>
			<li>
				Kibbutz Ktora&nbsp;
			</li>
			<li>
				Pharan
			</li>
			<li>
				Ein Yahav
			</li>
			<li>
				Tzukim
			</li>
			<li>
				Tzofar
			</li>
		</ul>
		 
		<p>Overnight in a Kibbutz in the Arava area&nbsp;</p>
		 
		 
		 
		<h3>Day 9, Monday: Eilat</h3>
		 
		<p>Just before Eilat drive to<strong>&nbsp;Timna Park</strong></p>
		<p>Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you&apos;ll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions. Timna Park is located just 20 minutes from Eilat, in the heart of the enchanted Israeli desert and ensconced between breathtaking natural scenery.&nbsp;</p>
		<p>Embark upon one of the park&rsquo;s 20 well-marked hiking trails, each varying in level of difficulty, selected to fit your individual or group needs and capabilities. Trek through the spectacular, geological and archaeologically-significant trails, or choose instead to take it easy and lounge by the shaded Timna Lake and its adjacent camping grounds and King Solomon&rsquo;s Khan restaurant, where desert-related crafts such as colored sand bottles can be made, or pedal boats can be taken for a spin.</p>
		<p>Try out the&nbsp;<strong>park&rsquo;s rappelling, zip line and bike tours</strong>, each sure to leave you feeling invigorated and accomplished.</p>
		 
		<p><strong>Eilat </strong>- Eilat&rsquo;s stunning red sea offers loads of fantastic adventures. For one, its gorgeous underwater environment is known as a world-famous scuba diving destination.&nbsp;</p>
		<p>Atop the waves, you&rsquo;ll find, windsurfing, kitesurfing, and stand-up paddle boarding options for which it&rsquo;s always an ideal time in Eilat, with its pristine beaches, calm waters, and perfect sunny weather almost year-round.&nbsp;</p>
		 
		<p><strong>The Coral reef Nature Reserve</strong> - Including an underwater snorkeling experience at one of the most beautiful and famous in the world. The reefs of the Gulf of Eilat are the only coral reefs in our country, and among them a wonderful and colorful world of corals, fish and a huge variety of unique creatures can be seen. The Coral Beach Nature Reserve in Eilat allows visitors easy access to the reef, as well as essential beach services, including a shop, showers, toilets, sunshades, deck chairs and sun loungers.&nbsp;</p>
		<p>From: <a href="https://www.parks.org.il/en/reserve-park/eilat-coral-beach-nature-reserve-2/">https://www.parks.org.il/en/reserve-park/eilat-coral-beach-nature-reserve-2/</a></p>
		 
		<p><strong>Dolphin Reef </strong>- The unique ecological site, in the midst of a magical beach, allows visitors an up-close glimpse into the dolphins&rsquo; lives and makes for an exciting outdoor adventure. Fancy an underwater experience without getting wet? Take a tour of the Eilat Underwater Observatory, a captivating glimpse into life below sea level, combined with interactive activities and special exhibits.</p>
		 
		<p><strong>Hiking</strong>- Eilat&rsquo;s nearby desert area offers&nbsp;fantastic hikes&nbsp;in stunning trails where you can&nbsp;walk or bike&nbsp;through breathtaking desert scenery. Check out the huge array of unique action attractions from unforgettable camel rides to&nbsp;adrenaline charged ATV rides&nbsp;to thrilling off cliff&nbsp;paragliding,&nbsp;guaranteed to get the heart racing.</p>
		 
		<p>Flight from Eilat to Ben Gurion Airport&nbsp;</p>
		          
					`,
      };
    },
  },
  {
    id: "Jewish_Israel_Itinerary",
    ctg: "itineraries",
    bgImage: "posts/bank/JewishIsraelItinerary/1.jpg",
    mobBgImage: "posts/bank/JewishIsraelItinerary/M.jpg",
    isVid: false,
    vidId: "",
    title: "Jewish Israel Itinerary",
    smltitle: "",
    html: function() {
      return {
        __html: `	
		<p>Jewish Israel Itinerary</p>

<p>DEPARTURE FLIGHT &ndash; SATURDAY NIGHT</p>
<h3>Day 1 - SUNDAY </h3>
<p>Arrive at Ben Gurion International Airport&nbsp;</p>
<p>Transfer to Tel Aviv</p>
<p>Dinner in Tel Aviv</p>
<p><strong>OVERNIGHT: TEL AVIV</strong></p>

<h3>Day 2- MONDAY: TEL AVIV AND JAFFA</h3>
<p>Drive to&nbsp;<strong>Jaffa</strong>, one of the oldest biblical cities in the world, and an important seaport since antiquity. Visit Jaffa&apos;s restored Old City including the artists&apos; colony and the quaint historic harbor. Jaffa has much to offer in the way of art galleries, gift-shops and restaurants found tucked away amongst the winding, cobblestone alleyways. Nearby, visit the flourishing flea market. Tour the new visitor center, which tells the ancient city&rsquo;s 4,000-year-old story using state-of-the art techniques. An animated film recounts the myth of Andromeda and a dynamic display on a huge screen traces the city&rsquo;s history by illustrating important periods and events that took place there: the conquest of Jaffa by the Egyptians 3,500 years ago, the story of the Prophet Jonah who tried to flee from G-d, the spread of Christianity that began in Jaffa, the Ottoman administration, the wars and the reconstruction of the city.</p>

<p>Proceed to&nbsp;<strong>Independence Trail</strong>&nbsp;and trace the story of Tel Aviv and the modern State of Israel beginning with the founding of Tel Aviv in 1909 and ending with the Declaration of Independence by David Ben Gurion May 14, 1948. Stop at the various sites and museums along the way to dive deeper into this inspiring, improbable story.</p>

<p>For the history enthusiast, choose from an array of other sites and museums that tell the story of modern Israel. These can range from interactive experiences about the &ldquo;Palmach,&rdquo; Israel&rsquo;s elite fighting force to a clandestine bullet factory disguised as a bakery, which was run by teenagers.</p>

<p><strong>Neve Tzedek</strong>.&nbsp;This historic neighborhood has earned a reputation as the &ldquo;new Soho.&rdquo; Visitors enjoy its lovely narrow streets, wonderful Suzanne Dallal Centre of Dance, and charming galleries, restaurants, and cafes. Look for Shabazi Street &ndash; wonderful galleries and shops there</p>

<p>Dinner and evening in Tel Aviv area</p>
<p>OVERNIGHT: TEL AVIV</strong></p>
<h3>Day 3 - TUESDAY: UPPER GALILEE</h3>

<p><strong>Caesaria</strong>, built by Herod the Great, was the Roman capital of Palestine for nearly 600 years. The extensive seaside ruins date back to Roman, Byzantine and Crusader times. Explore the 2,000-year-old Roman Theater, Crusader harbor and 12th-century ramparts. In addition to exciting ruins, this site also contains some new audio-visual presentations, which use modern technology (holographs) to highlight the ancient site and allow you to &ldquo;meet&rdquo; some of the historical figures who lived there.</p>

<p>Lunch in the Old City of Akko (Acre) at one of its most famous seafood restaurants.&nbsp;</p>

<p>OR</p>

<p>Visit a Druze Village to hear about this unique community in the North of Israel while enjoying traditional Druze cuisine and hospitality.</p>

<p><strong>Akko</strong>,&nbsp;the coastal city, served as one of the key ports of Israel over much of its long history. The Canaanites and Phoenicians utilized the port, and the city is mentioned in ancient Egyptian records. Walk along the city&rsquo;s old harbor and visit the local market. Also visit the Turkish baths and the Prison. The Templars, who were also known as the Poor Knights of Christ and of the Temple of Solomon, built the Templar tunnels in the second half of the 12th century. Thanks to these buildings, UNESCO declared Akko a World Heritage Site in 2001</p>

<p>Depart for&nbsp;<strong>Safed</strong>,&nbsp;which sits at a higher altitude than any other city in Israel and has been known since the 16th century as a major center of Kabbalah, Jewish mysticism. Safed is one of Israel&rsquo;s four holy cities, along with Jerusalem, Tiberias and Hebron. Its old synagogues, narrow alleyways and artists&rsquo; colony add to the hilltop city&rsquo;s unmistakable charm</p>

<p>&nbsp;Check into hotel or kibbutz guesthouse &nbsp; &nbsp; &nbsp;</p>
<p>OVERNIGHT: UPPER GALILEE</p>

<h3>Day 4- WEDNESDAY: NORTHERN ISRAEL</h3>

<p><strong>Rosh Hanikra Grottoes - instead of Tel Dan/horseback riding?</strong></p>

<p>Hike through the beautiful<strong>&nbsp;Tel Dan Nature Reserve</strong>&nbsp;with gorgeous trails leading through dense forest, streams, and the Chatzbani River. This is the site where the tribe of Dan once lived. Extensive archeological digs in the area have uncovered much of this ancient city along with the altar that once stood here.</p>

<p>OR</p>
<p><br>Enjoy horseback riding with scenic views of Northern Israel or kayaking in the Jordan River.</p>
<p><strong>Jeep tour</strong>&nbsp;up the&nbsp;<strong>Golan Heights</strong>&nbsp;in the footsteps of IDF soldiers and their battles in the Six Day War, to enjoy the beautiful natural scenery and gain an insight into the strategic complexity of the Golan</p>

<p>Explore Israel&apos;s security situation on the&nbsp;<strong>Golan Heights</strong>&nbsp;from&nbsp;<strong>Mt. Bental</strong>&nbsp;overlooking the abandoned Syrian town of Kuneitra, for a first-hand view of Israel&rsquo;s security position along the Syrian Border; visit a former Israeli bunker and gain further insight into the challenges Israel faced during the 1973 Yom Kippur War</p>

<p>Visit one of the many award-winning wineries in the region and combine it with fun for the kids such as <strong>chocolate making, operating an old olive oil press, or a culinary workshop</strong>.&nbsp;</p>

<p>Enjoy a tour and dinner at a local kibbutz</p>
<p><strong>OVERNIGHT: UPPER GALILEE</strong></p>


<h3>Day 5 - THURSDAY: LOWER GALILEE</h3>
<p>Drive to the&nbsp;<strong>Hula Valley Nature Reserve</strong>&nbsp;and enjoy a bike ride or golf-cart ride through the natural vegetation along the waters&rsquo; edge to see nature at its best. In the early 1990s part of the valley was flooded in the wake of heavy rains and it was decided to develop the surrounding area and leave the flooded area intact. The new site has become the second home and major stopover for hundreds of thousands of migrating birds in the autumn and spring from Europe to Africa and back. The lake covers an area of one square kilometer interspersed with islands that serve as protected bird nesting sites and the valley has become a major bird-watching site</p>

<p>At a Biblical-style village,&nbsp;don traditional Israelite dress and take a donkey ride through countryside which has hardly changed in 2000 years. Afterwards, enjoy a whole range of activities such as baking fresh pita bread and making home- made cheese (from goat&rsquo;s milk) as our ancestors did</p>

<p>Drive south towards Jerusalem along the&nbsp;<strong>Jordan Rift Valley</strong></p>

<p>Stop and immerse yourself in history in&nbsp;<strong>Beit She&rsquo;an</strong>, one of Israel&rsquo;s most spectacular archeological sites, with uncovered remains of a major Roman city, including a 10,000- seat theater as well as mosaics, ancient streets, public buildings and more</p>
<p>Arrive in Jerusalem and check into hotel&nbsp;</p>
<p>Dinner and evening in Jerusalem</p>
<p>OVERNIGHT: JERUSALEM</p>

<h3>Day 6 - FRIDAY: JERUSALEM</h3>

<p>Walking tour through the&nbsp;<strong>Jewish Quarter</strong>&nbsp;of the Old City of Jerusalem, with visits to some of the sites excavated over the past 30 years, including:</p>
<ul>
    <li>
        The&nbsp;<strong>Cardo</strong>, a Byzantine street that is now the world&rsquo;s oldest shopping arcade
    </li>
    <li>
       The&nbsp;<strong>Hurva Square</strong>, the central square of the Jewish Quarter
    </li>
    <li>
        The 2,000-year-old&nbsp;Herodian Mansions
    </li>
    <li>
        The&nbsp;<strong>Jerusalem Archaeological Park</strong>, including a visit to the Davidson Center and the Southern Wall Excavations
    </li>
    <li>
       The <strong>Kotel </strong>(Western Wall)
    </li>
    <li >
        <strong>The Western Wall Tunnel</strong>
    </li>
</ul>

<p><strong>Machaneh Yehuda Market</strong>,&nbsp;one of the most colorful spots in downtown Jerusalem. Stretching one city block, the market sells the best produce at the best prices in town. Visiting on Friday lets you experience the full effect of a bustling, Middle Eastern market</p>

<p>Bring in&nbsp;<strong>Shabbat </strong>at the Western Wall</p>

<p><strong>Enjoy a Shabbat home hosted dinner or group</strong>&nbsp;experience in Jerusalem</p>

<p>OVERNIGHT: JERUSALEM</p>

<h3>Day 7: JERUSALEM OR SOUTHERN ISRAEL (NEGEV)</h3>

<p>Optional Shabbat services and day at leisure</p>

<p>OR</p>

<p>Descend to the&nbsp;<strong>Dead Sea Basin</strong></p>

<p>Arrive at&nbsp;<strong>Masada </strong>and ascend by cable car or climb up the Snake Path. As you explore the ancient remains of fortifications, King Herod&apos;s palaces, storerooms and baths, you will hear about the spirit of its last Jewish defenders. These Zealots held out for three years against the Roman legions in 70BCE and chose to die as free men at their own hands in preference to Roman slavery. From the top of Masada, the outlines of the Roman encampments are still visible below</p>

<p>Experience the weightlessness of the<strong>&nbsp;Dead Sea</strong>&nbsp;as you float in its waters. The Dead Sea is the lowest place on earth and the water and mud of the Dead Sea are known for its healing and nourishing minerals</p>

<p>Learn about the Bedouin community in Israel by enjoying a homemade Bedouin lunch followed by camel riding!</p>

<p>Time and weather permitting, continue to&nbsp;<strong>Ein Gedi</strong>&nbsp;oasis and nature reserve and hike up to and cool off in the refreshing freshwater pools and waterfalls. The stunning Ein Gedi oasis consists of two separate waterways: Nachal David (David&rsquo;s Stream), where David took refuge from King Saul; and Nachal Arugot, where remains of a 6th-century synagogue were discovered. You will be able to appreciate the unique and flourishing flora and fauna of this area and you may be lucky enough to catch a glimpse of a few beautiful ibex and oryx hiding in the surrounding mountains</p>

<p>Return to Jerusalem</p>

<p>Dinner in Jerusalem followed by&nbsp;<strong>Night Spectacular at the Tower of David Museum</strong>&nbsp;&ndash; a sound and light show not to be missed!</p>

<p>OVERNIGHT: JERUSALEM</p>
<h3>Day 8: JERUSALEM </h3>

<p>Dig deep into the past at one of Israel&rsquo;s hundreds of archaeological sites where thousands of underground caves date back to the time of the Phoenicians. Become an archaeologist for a day and take part in a hands-on archaeological dig at the caves, which served as storerooms, burial crypts and safe havens during the time of the Bar Kochba revolt against the Romans</p>

<p>Visit the newly renovated&nbsp;<strong>Yad Vashem</strong>&nbsp;complex, the Jewish National Memorial to the six million Jewish victims of the Holocaust, including:</p>
<ul>
    <li>
        The&nbsp;<strong>Avenue of the Righteous</strong>
    </li>
    <li>
        The new&nbsp;<strong>Historical Museum</strong>
    </li>
    <li>
        The&nbsp;<strong>Children&apos;s Memorial</strong>
    </li>
    <li>
        Ending with a&nbsp;<strong>Memorial Service</strong>
    </li>
</ul>

<p>&nbsp;Evening and dinner in Jerusalem</p>

<p>OVERNIGHT: JERUSALEM</h3>
<h3>Day 9: JERUSALEM- </h3>

<p>End your trip with a meaningful&nbsp;<strong>volunteer opportunity</strong>&nbsp;by giving back &ndash; harvest surplus agricultural produce from local farms to be donated to the needy, plant a tree in a forest and learn about Israel&rsquo;s national sustainability story, and much more....</p>

<p>Tour the stunning&nbsp;<strong>Israel Museum</strong>, the largest cultural institution in the State of Israel, which is ranked among the world&rsquo;s leading art and archaeology museums. Founded in 1965, the museum houses encyclopedic collections, including works dating from prehistory to the present day in its archaeology, fine arts, and Jewish art and life wings; it also features the most extensive holdings of biblical and Holy Land archaeology in the world. In just 45 years, the museum has built a far-ranging collection of nearly 500,000</p>
<p>objects, representing the full scope of world material culture. In July 2010, the museum reopened to great acclaim after a three-year renovation. Along with the exhibits, the museum includes the model of Jerusalem during temple times, the Billy Rose Sculpture Garden, the Youth Wing and the Shrine of the Book, where the Dead Sea Scrolls are housed</p>

<p>Free afternoon to shop and explore Jerusalem before departure</p>

<p>Enjoy your last evening and dinner in Jerusalem before heading to the airport</p>

<p>Transfer to Ben Gurion Airport for the group flight</p>
<p><strong>OVERNIGHT: FLIGHT</strong></p>
		          
					`,
      };
    },
  },
  {
    id: "Christian_Interest_Itinerary_10_Days_Tour",
    ctg: "itineraries",
    bgImage: "posts/bank/christianinterestitineraries10daystour/1.jpg",
    mobBgImage: "posts/bank/christianinterestitineraries10daystour/M.jpg",
    isVid: false,
    vidId: "",
    title: "Christian Interest Itinerary - 10 Days Tour",
    smltitle: "",
    html: function() {
      return {
        __html: `	
									  <p>Region: Eilat, Dead Sea, Jerusalem Area, North, Tel Aviv and Center, Number of Days: 10, Starting Point: Old City, Jerusalem, Ending Point: Be'er Sheva, Trail Type: Vehicle Route</p>
								<p class="ac-margin-bot-20">Visiting the Holy Land? Don't miss all the hotspots with our suggested itinerary: visit Jerusalem's Via Dolorosa and the room of the Last Supper, check out the Sea of Galilee and all the famous sites of the New Testament, and explore ancient cultures in various archaeological sites.</p>
								<h3>Day 1</h3>
								<p>Begin in Jerusalem with the inspiring panoramic view of the Old City from the Mount of Olives. From here it is a short walk to Dominus Flevit and then a walk (or drive) to the Church of All Nations and the Garden of Gethsemane.</p>
								<p>Continue to the Temple Mount, scene of Abraham’s offering of Isaac today marked by the Dome of the Rock.</p>
								<p>Then, it’s on to the Western Wall, revered as Judaism most sacred site as the last remnant of the Second Temple. On Mondays, Thursdays and Saturdays you can see Bar Mitzva ceremonies at the Western Wall, the joyful occasion when a Jewish boy of 13 reads from the Torah in public for the first time.</p>
								<p>While at the Western Wall, arrange your schedule to join a public tour of the Western Wall Tunnels by enquiring at the Western Wall Heritage Foundation.</p>
								<p>At the Southern Wall Excavations, you can walk on the original two thousand-year old street and climbing the ancient steps that Jesus and the disciples probably also climbed. At the Davidson Center, in the basement of an eighth-century-CE palace, look into the possibility of seeing its virtual-reconstruction, high-definition interactive model, and enjoy the high-definition film open to all visitors that depicts ancient pilgrimage to the Temple in a unique way.</p>
								<p>Next, visit the City of David, where Jerusalem became David’s capital some 3,000 years ago. See the Visitors Center, with its excavations of the First Temple Period, Warren's Shaft and the ancient water system built by King Hezekiah to protect the city’s water supply from the Assyrians.</p>
								<p>Continue to Mount Zion, to visit the Church of St. Peter in Gallicantu, where Peter denied Jesus, King David’s Tomb, the Room of the Last Supper and the Church of the Dormition - where by Catholic tradition Mary fell in to eternal sleep.</p>
								<p class="ac-margin-bot-20">Overnight: in Jerusalem.</p>
								<h3>Day 2</h3>
								<p>It’s time to get to know Jerusalem close-up today. Begin at St. Stephen’s Gate, also known as Lion’s Gate[MOU1] [JD2] , and visit the Pool of Bethesda - site of the miraculous healing of a paralyzed man by Jesus, and the Church of St. Anne, where Christian groups love to sing hymns as they visit.</p>
								<p>Take the Via Dolorosa passing the Stations of the Cross to the Church of the Holy Sepulchre, the traditional site of the crucifixion and burial of Jesus.</p>
								<p>Wander the Old City markets, steeping yourself in its sights, sounds and aromas, and try your hand at hunting and bargaining for treasures.</p>
								<p>Next visit the rebuilt Jewish Quarter with its old Sephardic synagogues. Byzantine-era Cardo, Second-Temple-era Herodian Mansions and the Burnt House, and First-Temple-era Broad Wall, as well as fun people-watching, galleries and restaurants.</p>
								<p>End your day at the Garden Tomb – a rock hewn tomb believed by Protestant denominations to be the site of Jesus’ crucifixion, burial and resurrection.</p>
								<p class="ac-margin-bot-20">Overnight: in Jerusalem.</p>
								<h3>Day 3</h3>
								<p>The New City is on today’s agenda. You can begin at Yad Vashem, the Holocaust memorial, with its astounding new historical museum, Hall of Remembrance, Children's’ Memorial and other moving sites.</p>
								<p>Drive by the Knesset (Israel’s Parliament – open for tours on Sundays and Thursdays) and the New Supreme Court Building.</p>
								<p>Nearby is the Israel Museum where among many other treasures you can delve into the mysteries of the Dead Sea Scrolls at the Shrine of the Book and see the Model of Jerusalem at the time of the Second Temple.</p>
								<p>Continue to Ein [JD3] [אנ4] Karem picturesque village, birthplace of John the Baptist, with the Church of John the Baptist, the Church of the Visitation and the Russian Orthodox Church[MOU5] [JD6]  as well as Miriam’s Spring.</p>
								<p>End your day in downtown Jerusalem, walking the pedestrian malls of Ben Yehuda Street and Nahalat Shiva, enjoying this restored quarter of shops, cafes and restaurants that are favorites with Jerusalemites.</p>
								<p class="ac-margin-bot-20">Overnight: in Jerusalem.</p>
								<h3>Day 4</h3>
								<p>Head to Tel Aviv-Yafo today. On the way, stop at the tranquil Latrun Monastery, overlooking the Valley of Ayalon, where Joshua made the sun stand still. The monastery was founded in 1890 by French Trappist monks, and the monks, who maintain a vow of silence, produce wine from their own vineyards.</p>
								<p>Then, it’s on to Jaffa the ancient seaport mentioned in the biblical narrative of Jonah and the whale, and in the story of Solomon’s import of the cedars of Lebanon. Jaffa’s fishing port, St. Peter’s Church, artists quarter, Visitor Center and panoramic view of Tel Aviv are all highlights.</p>
								<p>Walk through the area known as the White City to see the preservation of buildings of Bauhaus architecture of the 1920s and 1930s, a UNESCO World Heritage Site, and stop at Independence Hall, where Ben-Gurion declared independence in 1948.</p>
								<p>On Tuesdays and Fridays, enjoy the crafts market on Nahalat Binyamin Street. The nearby open-air Carmel fruit and vegetable market is open daily, and is a colorful opportunity to mingle with the locals.</p>
								<p>Enjoy a fish dinner or a snack at the Tel Aviv Port and an evening walk through Yarkon Park where you’ll find the locals enjoying cycling, jogging and enjoying family time on the lawns.</p>
								<p class="ac-margin-bot-20">Overnight: in Tel Aviv.</p>
								<h3>Day 5</h3>
								<p>Caesarea National Park on the Mediterranean is your first stop today, where you’ll find the remains of former Roman capital home of Philip the Evangelist, and where Paul was imprisoned and appeared before Festus, Felix and King Agrippa.</p>
								<p>Tour the Roman theater, the hippodrome and promenade to the renovated Crusader city. Don’t miss the "Caesarea Experience" a fascinating computerized presentation about the city's history.</p>
								<p>Then, it’s on to Muhraka, the traditional site of Elijah’s confrontation with the prophets of Ba’al, with the Carmelite Monastery of St. Elijah.</p>
								<p>Continue to Acre, the ancient Phoenician and Crusader seaport (designated by UNESCO as a world heritage site) for a tour of the Knight​s Halls, the Al-Jazzar Mosque, the bathhouse with its multi-media display and the new ethnic museum, built right into the rooms of the old wall, and the covered markets.</p>
								<p>Cross the beautiful Galilee Mountains, stopping at Arbel National Park for an overview of the Sea of Galilee in the late afternoon.</p>
								<p class="ac-margin-bot-20">Overnight: in the Sea of Galilee region.</p>
								<h3>Day 6</h3>
								<p>Start the day with a visit to the Christian holy sites around the Sea of Galilee, including:</p>
								<p>The Mount of Beatitudes: The traditional site of Jesus’ Sermon on the Mount with its beautiful view of the lake and its sacred sites.</p>
								<p>Capernaum: Known as "Jesus' Town" in the New Testament, Capernaum on the Sea of Galilee is home to one of the earliest churches in the world as well as a monumental ancient synagogue. This was also Peter's home town where Jesus performed many miracles.</p>
								<p>Tabha: Jesus' miracle of the Multiplication of the Fish and Loaves is illustrated beautifully in an ancient mosaic of the Byzantine church that stood here. Visit the renovated Benedictine church, built in the same style and along the same lines as the original one.</p>
								<p>Bethsaida: Home of Peter, Andrew and Philip and scene of Jesus’ healing of a blind man.</p>
								<p>The Yigal Alon Museum at Kibbutz Ginosar: A magnificent display of the wooden Galilee Boat, dating from the time of Jesus, discovered mired in the mud on the shore of the Sea of Galilee.</p>
								<p>In the afternoon, drive to scenic Mount Tabor, scene of Deborah and Barak’s battle against Sisera, and of the Transfiguration of Jesus[MOU7] [JD8] .</p>
								<p>Consider an evening boat-ride on the Sea of Galilee.</p>
								<p class="ac-margin-bot-20">Overnight in the Sea of Galilee area.</p>
								<h3>Day 7</h3>
								<p>Drive to Cana - the village where Jesus performed the first miracle, turning water into wine, with the Wedding Church and the Church of Nathanael.</p>
								<p>Continue to Nazareth - childhood town of Jesus, with the Basilica of the Annunciation; the Church of St. Joseph; Mary’s Well; the Church of St. Gabriel; and the reconstructed Nazareth Village, where you can learn about daily life in the days of Jesus.</p>
								<p>Then, it’s on to Megiddo, the site of biblical Armageddon, to see the excavations of the ancient fortified city that was one of Solomon’s most important centers, overlooking the Jezreel Valley and the ancient Via Maris.</p>
								<p>In the afternoon, visit the charming church at Nain, where Jesus raised a widow’s son from the dead.</p>
								<p class="ac-margin-bot-20">Overnight in the Sea of Galilee area.</p>
								<h3>Day 8</h3>
								<p>Before saying farewell to the Sea of Galilee area, visit Yardenit – the baptismal site for pilgrims on the Jordan River south of Tiberias.</p>
								<p>Then it’s on down the Jordan Valley to the Dead Sea and Qumran - ruins of the ancient Essene settlement in whose nearby caves the Dead Sea Scrolls were discovered.</p>
								<p>Enjoy a walk through the Ein Gedi Nature Reserve, a biblical oasis with a spring and waterfalls, where David hid from Saul.</p>
								<p>In the afternoon, take the cable-car to the top of Massada scene of the epic stand by Jewish rebels at the end of the Great Revolt against Rome nearly 2,000 years ago. The new museum at the visitor’s center reveals the secrets of the daily life of the rebels, the story of the excavations, and how the site became one of Israel’s most important symbols.</p>
								<p>Check into your Dead Sea hotel and enjoy a relaxing float in the healthful waters of the lowest, saltiest body of water on earth.</p>
								<p class="ac-margin-bot-20">Overnight: in the Dead Sea.</p>
								<h3>Day 9</h3>
								<p>Drive on down to Eilat today, stopping at the Hai Bar Reserve for a safari-like drive through the park where biblical animals are being fostered. Further south, visit Timna Park, geological wonders including Solomon’s Pillars, a full-scale replica of the biblical Tabernacle and ancient copper mines whose story is showcased at the park’s exciting multimedia presentation “Mines of Time.”</p>
								<p>Settle into your bed and breakfast in the Eilat area or hotel right in the Red Sea resort town itself.</p>
								<p>Visit the wonderful Underwater Observatory Marine Park, or choose from a variety of other activities, such as swimming with the dolphins or bird-watching.</p>
								<p class="ac-margin-bot-20">Overnight: in Eilat.</p>
								<h3>Day 10</h3>
								<p>Head north today via the central Negev and the Ramon Crate[MOU9] r, stopping at the Visitor Center in Mitspe Ramon that tells the story of this amazing natural wonder, the world’s largest natural crater.</p>
								<p>Continue to Avdat, once a central city on the Nabatean trade route (known as the Incense Route), which became a Christian city of pilgrimage.</p>
								<p>Then, it’s on to biblical Be'er Sheba and northward.</p>
													 
								   
						`,
      };
    },
  },
  {
    id: "Eilat_To_Jerusalem_In_10_Days",
    ctg: "itineraries",
    bgImage: "posts/bank/eilattojerusalemin10days/1.jpg",
    mobBgImage: "posts/bank/eilattojerusalemin10days/M.jpg",
    isVid: false,
    vidId: "",
    title: "A Christian Adventure Itinerary",
    smltitle: "",
    html: function() {
      return {
        __html: `	
							   <p class="ac-margin-bot-20"><strong>Eilat to Jerusalem in 10-Days. A Christian Adventure Itinerary </strong><br/><em>This is a high-energy itinerary and will require agility, stamina, and endurance.</em></p>
							<p>This is a high-energy itinerary and will require agility, stamina, and endurance.</p>
							<h3>DAY 1: EILAT TO RAMON</h3>
							<p class="ac-margin-bot-20">Begin your journey in Eilat, Israel’s southern-most city on the Red Sea. Fly directly from several European cities to Ramon Airport in Eilat or connect through Europe or Tel Aviv from North America. Overnight then leave your hotel after breakfast for an early morning hike through the Red Canyon. Hike through beautiful water-and-wind carved sandstone formations. In the late morning, drive to Timnah Park. Enjoy the Mushroom formation, Solomon’s Pillars, Solomon’s copper mines, and a full-sized replica of the ancient Tabernacle. After lunch, drive through the Negev Desert to Mitzpe Ramon, stopping at Avdat National Park to see the Nabatean and Byzantine-era ruins of this ancient city along the Old Spice Route. Then, end your day at Ein Avdat for an evening hike through the canyon. Overnight in Mitzpe Ramon.</p>
							<h3>DAY 2: RAMON TO ARAD</h3>
							<p class="ac-margin-bot-20">After breakfast, take a morning bike ride along the rim of the Ramon Crater, the world’s largest natural crater. If you want more of a challenge, take a rappelling course on the crater’s edge. After lunch, drive to Be’er Sheva. Tour Tel Be’er Sheva, Abraham’s early, nomadic camp, and ancient Judahite settlement. Drive to Arad and the visit a Bedouin Camp. The Bedouins continue the culture of the nomadic, desert people that have dwelt in this region for centuries. Enjoy a camel ride, learn about Bedouin culture, and go scorpion hunting in the evening. Enjoy a traditional Bedouin dinner and overnight in a Bedouin tent.</p>
							<h3>DAY 3: DEAD SEA</h3>
							<p class="ac-margin-bot-20">Rise early to drive to Masada and hike the Snake Path to the top. Masada was the site of the final resistance of the Jews against the Romans during the First Jewish War. Explore the ruins of Herod’s palaces and bath house, and the Roman siege ramp and massive cisterns. Continue to Ein Gedi. Hike the Canaanite Temple trail to the Nahal David. Enjoy a swim in the waterfalls and pools. Return to Ein Bokek for Dead Sea Swim and overnight.</p>
							<h3>DAY 4: DEAD SEA TO NAZARETH</h3>
							<p class="ac-margin-bot-20">After breakfast, drive to Qumran, the site of one the world’s greatest archaeological finds – the Dead Sea Scrolls. Explore the ruins and hike to the top of the mountain above Qumran for an extraordinary view of the Dead Sea and Mountains of Moab on the other side. Descend the mountain and leave for the Qasr Al-Yahud baptismal site on the Jordan River. This is the traditional site of the ministry of John the Baptist, where the baptism of Jesus of Nazareth took place. Celebrate a baptism in the Jordan River, and then drive up the Jordan Valley to Bet She’an. Lunch along the way. Tour the ruins at Bet She’an, the site where the bodies of Saul and Jonathan were hung by the Philistines, and the site of the main Decapolis city during the time of Jesus. Tour the extraordinary Roman ruins. Afterwards, drive to the Mount of Precipice in Nazareth for a view of the Jezreel Valley. Visit the Church of the Annunciation built over the house of the Virgin Mary. End your day at the Nazareth Village, a recreation of the first-century village of Nazareth. Dinner and overnight.</p>
							<h3>DAY 5: NAZARETH TO THE SEA OF GALILEE</h3>
							<p class="ac-margin-bot-20">Today, spend the entire day hiking a portion of the Jesus Trail to the Sea of Galilee. This is the most beautiful section of the entire trail. The Jesus trail is a 60 km trail that leads from the Mount of Precipice in Nazareth to Capernaum on north shore of the Sea of Galilee. Your portion will be approximately 15 km as you descend past the Horns of Hattin, where the Ayyubid Sultan, Saladin, defeated the Crusaders in 1187, down to Mount Arbel and Magdala, the home of Mary Magdalene on the Sea of Galilee. You’ll pick up the trail just outside the kibbutz and hike through olive groves and pastures, following a stream and the path that Jesus and his disciples walked many times. You’ll ascend Arbel to the top where you’ll have lunch and take in a breathtaking view of the Sea of Galilee. After descending from Arbel, you’ll continue to Magdala and tour among the ruins a first-century synagogue, where Jesus most certainly preached. </p>
							<h3>DAY 6: GALILEE TO AKKO</h3>
							<p class="ac-margin-bot-20">Begin the day kayaking on the Sea of Galilee from Kibbutz Ginosar to Capernaum, stopping for a moment in the middle of the Sea to consider the ministry of Jesus throughout this region and the power of the One, who calmed the Sea. Arrive at Capernaum and tour the site. This was the hometown of Jesus during His ministry in Galilee. Tour the fourth-century synagogue on the very site where Jesus preached. See the remains of what is considered Peter’s house. Afterwards, drive to the Golan Heights, to Nimrod’s Castle and explore the old Crusader-era fortress. Continue on to Tel Dan to see the springs of the Jordan, the Abrahamic-era gate, and the Israelite fortifications. Afterwards, take an evening drive into Western Galilee, arriving at Akko for dinner and overnight.</p>
							<h3>DAY 7: AKKO TO THE SHEPHELAH</h3>
							<p class="ac-margin-bot-20">After breakfast at your hotel, tour the Crusader Halls and Tunnels in Akko. Akko was the main port city of the Kingdom of Jerusalem and the Knights Templar for nearly two hundred years; and the city became the capital of the kingdom after Jerusalem fell to the Islamic Ayyubid Dynasty. Take a walk along the sea wall and stroll through the old city of Akko, stopping for lunch in the market. Afterwards, drive down the coast through Haifa to the Caesarea National Park. Herod the Great had Caesarea built between the years 22 – 10 BCE to honor Caesar Augustus. Caesarea was the provincial seat of the Roman government in Israel at the time of Christ. Pontius Pilate, who gave the edict to crucify Christ, ruled Judea from here. An inscription bearing Pilate’s name was found in Caesarea and is now on display at the Israel Museum. See the Roman aqueduct, the Crusader-era fortifications, the Roman temple to Zeus, the visitors’ center in the ancient storage facilities, the Hippodrome, the remains of the palace, and the extraordinary amphitheater. Leave Caesarea and drive to Tel Gezer, an ongoing, archaeological excavation in the Shephelah region of Israel. Gezer was given to King Solomon by the Pharaoh of Egypt as a wedding gift when Solomon married his daughter. Solomon fortified the city to defend the approach to Jerusalem via the Aijalon Valley. Tour the Solomonic-era gate, the Canaanite-era gate, and the standing stones. Dinner and overnight in the Neve Ilan area.</p>
							<h3>DAY 8: THE SHEPHELAH TO JERUSALEM</h3>
							<p class="ac-margin-bot-20">Leave your hotel after breakfast and head to the Shephelah region of Israel. You’ll spend the day on an actual archaeological dig site, helping archaeologists from major universities in Israel excavate one of the sites in the region such as Tel Bet Shemesh, Tel Azekah, Tel Maresha, Tel Lachish, and Tel Gat. Learn archaeological techniques and plan to get dirty. You might be the one to make the next great discovery that rocks the archaeological world! In the afternoon, head to the Bar Kokba caves in the Adullam Reserve. These are a series of tunnels and rooms hand-hewn by the Jewish rebels out of the limestone rock during the Second Jewish Revolt. Enjoy crawling through the tunnels to the interior rooms to experience what it was like to hide from the Romans during this important time in Israel’s history. The passages are narrow and will require some agility and strength to maneuver. In the evening head to Jerusalem for dinner and overnight.</p>
							<h3>DAY 9: JERUSALEM</h3>
							<p class="ac-margin-bot-20">Start you day watching the sun rise over the City of Jerusalem from the top of the Mount of Olives. This is the most extraordinary and iconic view of Jerusalem. Take time to identify key sites in the Old City and read the Olivet Discourse from the Gospel of Matthew as you sit on the very mount where Jesus delivered this message to His disciples. Then, hike down the Mount of Olives to the Garden of Gethsemane. See the ancient olives trees in the courtyard of the Church of All Nations and continue across the Kidron Valley to the Lion’s Gate. Pass through the gate and begin your journey on the Via Dolorosa, the Way of Suffering. This is the traditional path that Jesus walked, carrying His cross on His way to Calvary. Take as much time as you would like to see the various stations of the cross, which include chapels and other important sites, marking moments in Jesus' journey to the cross. Be sure to see the Pool of Bethesda and Saint Anne’s Church. Sing a hymn and enjoy the extraordinary acoustics inside this Crusader-era chapel. Continue on the Via Dolorosa through the markets of the Muslim and Christian quarters to the Church of the Holy Sepulchre. Try your hand at finding a bargain from the vendors along the way[MOU1] [JD2] . The Church of the Holy Sepulchre is the traditional site of the death, burial, and resurrection of Jesus[JD3] . Explore the Church, being sure to see the place of His crucifixion as well as the place of His burial and resurrection, which are in two separate locations inside the basilica. If time permits, enter the Edicule to see the site of the tomb of Jesus. Exit the Sepulchre and continue through the Old City to the Jaffa Gate. Near the Jaffa Gate pick up tickets for the Ramparts Walk, which will take you along the defensive pathways on top of the Old City Walls. Take the northern route which leads from the Jaffa Gate to Herod’s Gate. Enjoy views of the Christian and Muslim Quarters from the top of the city. Exit at the Damascus Gate and head north to the Garden Tomb, where you can enter an ancient tomb from the time of Jesus to see what the burial and resurrection of [JD4] Jesus may have been like. Find a private alcove and celebrate the Lord’s Supper with your companions. Return to your hotel for dinner and overnight.</p>
							<h3>DAY 10: JERUSALEM TO TEL AVIV</h3>
							<p class="ac-margin-bot-20">Begin your day at the City of David. The City of David is the extraordinary excavation site of Zion, the earliest settlement of the city of Jerusalem. Take time to see the main excavations sites, including the Stepped Stone Structure and the Givati Parking Lot. Then, climb down through Warren’s Shaft to the Gihon Spring and Hezekiah’s tunnel, and make your way under the city through the water channel to the Pool of Siloam. Be sure to take your water shoes and a head lamp. This is one of the greatest adventures in Jerusalem. Hezekiah’s tunnel was dug under the City of David during the reign of King Hezekiah to divert water from the Gihon Spring to the west side of the city to protect Jerusalem’s water supply from the advancing Assyrians. The Pool of Siloam was the site of the healing of the blind man by Jesus of Nazareth. From the Pool of Siloam, take the Pilgrim’s Road up toward the Temple Mount and walk on pavement stones from the first century. You can also walk the entire route underneath the city back to the Givati excavations and the visitor’s center via the Herodian-era drainage tunnel. After leaving the City of David, make your way to the Dung gate and enter the Jerusalem Archaeological Park and the Davidson Center. Explore a first-century street, showing evidence of the Roman destruction of the Temple in 70 CE. Walk the Southern Steps, the ancient steps leading up to the Temple Mount at the time of Christ. The original stones of the Steps most likely held the feet of Jesus and His disciples as they ascended to the Temple. Explore the other excavation sites in the park, which reveal ancient Jerusalem through the centuries. Exit the park and visit the Western Wall. This the holiest site in the world to the Jewish religion as the Herodian-era ashlar stones at the base of the wall are remnants of the Second Temple complex and the nearest site to where the ancient Holy of Holies once stood. Visitors of all faiths may approach the wall and pray. Men must have their heads covered. After leaving the Western Wall, take a tour of the Western Wall tunnels, which lead from the Western Wall plaza underneath the Muslim quarter of the Old City to the northwestern corner of the Temple Mount. The Western Wall tunnels show further evidence of the Second Temple and the amazing building techniques used in construction of the retaining wall. After your tour, transfer to Jaffa for dinner and a stroll through the ancient alleys of the old city. Take an evening flight home from Ben Gurion International Airport.</p>
								
						`,
      };
    },
  },
  {
    id: "Evangelical_Christian_Itineraries_10_Day_Tour",
    ctg: "itineraries",
    bgImage: "posts/bank/evangelicalchristianitineraries10daytour/1.jpg",
    mobBgImage: "posts/bank/evangelicalchristianitineraries10daytour/M.jpg",
    isVid: false,
    vidId: "",
    title: "EVANGELICAL CHRISTIAN ITINERARIES - 10 DAYS TOUR",
    smltitle: "",
    html: function() {
      return {
        __html: `	
							   <h3>DAY 1 </h3>
							<p>Begin your visit by heading straight to Jaffa, the picturesque ancient port from which Jonah set sail before being swallowed by the whale, where King Solomon imported the cedars of Lebanon to build the Temple in Jerusalem, and where Peter had his vision at Simon the Tanner's home.</p>
							<p>Don’t miss the visitor center in Kedumim Square that showcases the history of the city and is built around antiquities from the time of Jesus. Enjoy a beautiful view of modern Tel Aviv from Jaffa, before driving through the city.</p>
							<p>Tour Tel Aviv’s White City to see the preservation of buildings of Bauhaus architecture (a UNESCO World Heritage Site) including Independence Hall, where Ben-Gurion declared independence in 1948.</p>
							<p>Sheinkin Street is famous for its fun shopping, dining and people-watching in a youthful atmosphere, while the open-air Carmel fruit and vegetable market is a treat for all the senses. On Tuesdays and Fridays, the Nahalat Binyamin pedestrian mall comes alive with stalls selling handicrafts of every type.</p>
							<p class="ac-margin-bot-20">Overnight in the Tel Aviv or Netanya area.</p>
							<h3>DAY 2</h3>
							<p>Drive north across the Sharon Plain to the excavations of the ancient city and port at Caesarea National Park. King Herod built Caesarea in honor of his patron Emperor Augustus in the mid-first century BCE, and Pontius Pilate ruled the country from here.</p>
							<p>Peter’s story, which you began to explore in Jaffa, continues here when he baptized Cornelius the Centurion in Caesarea. It was from this port that Paul set sail to preach in communities all over the Mediterranean, where he was later imprisoned for two years and appeared before Felix, Festus and King Agrippa. All these events are reflected in the ruins you’ll tour, including the Roman theater, the hippodrome and Herod's palace, as well as mosaics and other remains from the centuries when Caesarea was an important Christian center, and the Crusader walls, moat and gates.</p>
							<p>Drive through Ara Wadito Tel Megiddo, the Armageddon of Revelations 16:16. Tour the remains of one of the most intensively inhabited sites in the country with over 25 levels of settlement, spanning some 3,000 years, including walls, gates, palaces and dwellings from the time of King Solomon, King Ahab and the Assyrians. A highlight will be your walk through the water system, one of the great engineering marvels of antiquity.</p>
							<p>Cross the Jezreel Valley, sometimes called “the battlefield of the Bible” and now Israel’s breadbasket, to Mt. Tabor to hear the account of the prophetess Deborah gathering her forces here in the time of the Judges to battle against Sisera. Jesus came to Tabor with Peter and James, was transfigured before them, and met with Moses and Elijah. After a breathtaking view of the valley below, visit the beautiful two-level Church of the Transfiguration.</p>
							<p>Continue to Nazareth to visit Nazareth Village, a full-scale reconstruction of life in Nazareth during the time of Jesus.</p>
							<p>Continue to the centuries-old Church of St. Gabriel, which houses the village spring – one of the few authentic remains of the time of Jesus to be seen in Nazareth.</p>
							<p>Drive across the Galilee Mountains via Cana, the scene of Jesus’ first miracle of changing water into wine, and home of Nathanael.</p>
							<p>Stop for a breathtaking overview of the Sea of Galilee and the scenes of Jesus’ Galilee ministry that you will be visiting over the next few days from the Arbel Cliff.</p>
							<p class="ac-margin-bot-20">Overnight in the Sea of Galilee area.</p>
							<h3>DAY 3</h3>
							<p>Begin your day at Kibbutz Ginosar to see the magnificent display of the wooden Galilee Boat, dating from the time of Jesus, which was discovered, mired in the mud on the shore of the Sea of Galilee. Continue from Ginosar with a boat-ride across the Sea of Galilee, stopping for devotions as the waves lap quietly around the boat, recalling ancient times.</p>
							<p>Landing near Capernaum, begin to follow in the footsteps of Jesus' ministry in the villages around the Sea of Galilee. This area is known as the “Evangelical Triangle” since most of Jesus’ miracles and teachings occurred around here. Capernaum, often called the hometown of Jesus, with its synagogue, church marking the home of Peter, and dwellings from the time of Jesus is one of its “points.”</p>
							<p>Crossing the Jordan River north of the lake, continue east to Bethsaida, another point on the Evangelical Triangle, where a street from the time of Jesus and a fisherman’s house are among the highlights, as well as massive walls from the biblical city of Geshur.</p>
							<p>Now that you are on the east side of the Sea of Galilee, continue to Kursi, the traditional place where Jesus healed the demon-possessed men by casting their evil spirits into a herd of pigs, with the remains of the largest Byzantine monastic complex.</p>
							<p>Then, head west, passing Capernaum again, to stop at the Chapel of the Primacy of Peter, where Jesus appeared to the Apostles after the resurrection, and where you can go right down to the water’s edge in beautiful surroundings. Nearby is the site of the miracle of the loaves and fishes at Tabha, with its famed mosaic depicting the two fishes and the five loaves Jesus multiplied.</p>
							<p>Now, it’s on to the third and last point on the Evangelical Triangle, Korazim, where you can see a synagogue with a ritual bath and an excavated public square.</p>
							<p>End the day at the nearby Mount of Beatitudes, the hill where Jesus preached the Sermon on the Mount to the multitudes that stood below, with a beautiful view of the Sea of Galilee.</p>
							<p class="ac-margin-bot-20">Overnight in the Tiberias area.</p>
							<h3>DAY 4</h3>
							<p>Ascend the Golan Heights today, the biblical Bashan and ancestral home of the half-tribe of Manasseh and in Jesus’ day, part of the territory of Herod Philip. Stop for an overview of Gamla, also known as “Massada of the north” where you’ll hear a heroic story of the few against the many, as the raptors that are protected here soar overhead in these magnificent natural surroundings.</p>
							<p>Continue to Katsrin and visit its ancient Talmudic Village to understand aspects of daily life at the time of Jesus as they are reflected in Gospel stories.</p>
							<p>Drive along Israel’s border with Syria and stop at the Kuneitra overlook.</p>
							<p>Continue to Kibbutz El-Rom to attend the audio-visual presentation that tells the story of the battle at the nearby “Vale of Tears” where a few Israeli tanks fended off waves of Syrian forces during the 1973 Yom Kippur War. Following the presentation descend from the Golan to the Hula Valley via the Druze villages.</p>
							<p>Visit Tel Dan, one of the most important biblical mounds in the country. Here archaeologists discovered an inscription with the words “House of David,” and you can see a gateway from the time of Abraham, as well as the High Place of Jeroboam and the Israelite gate.</p>
							<p>Continue to Caesarea Philippi, now known as Banias. Open your Bible among the ruins of pagan temples to consider the words Jesus spoke here: “Who do people say the Son of Man is?” (Matt. 16:13). As at Dan, you’ll also enjoy the natural beauty of Banias nestled on the flourishing banks of one the Jordan’s main tributaries.</p>
							<p class="ac-margin-bot-20">Overnight in the Sea of Galilee area.</p>
							<h3>DAY 5</h3>
							<p>Today you’re heading up to Jerusalem! But before you leave the Sea of Galilee area, begin the day with an inspiring visit to Yardenit, the baptismal site located at the Jordan River on the southern tip of the Sea of Galilee.</p>
							<p>Driving south along the Jordan Valley your next stop will be the ancient city of Beit She'an. On the walls of this once-powerful city that controlled the gateway to the land of Israel the Philistines hung the bodies of Saul and his three sons, whom they had defeated in battle on nearby Mount Gilboa. You can climb to the top of the huge mound of biblical antiquities, and see many magnificent remnants of this city that was the capital of the Decapolis cities where the Gospels say the fame of Jesus spread during his public ministry.</p>
							<p>Continue down the Jordan Valley, seeing Jericho, and the Mountains of Ammon and Moab in Jordan, as you ascend through the Judean Desert to the Holy City.</p>
							<p>Before heading to your hotel in Jerusalem, stop for your first moving view of the Holy City from Mount Scopus, and open your Bibles to read “Our feet are standing in your gates, O Jerusalem (Psalm 122:2) and others of the Psalms of Ascent.</p>
							<p class="ac-margin-bot-20">Overnight in Jerusalem.</p>
							<h3>DAY 6</h3>
							<p>Welcome the day with one of the most magnificent views in the world: ancient Jerusalem as seen from the top of the Mount of Olives. Allow some time to visit the various churches on the summit, among them: Pater Noster, where the prayer “Our Father” is inscribed in dozens of languages, and the Church of Ascension, marking the place where Jesus ascended to Heaven.</p>
							<p>Take the “Palm Sunday Walk” down the Mount of Olives in the footsteps of Jesus. On the way, stop at Dominus Flevit Church (The Lord Wept), marking the site of Jesus’ weeping over the city (Luke 19: 37-42). At the Garden of Gethsemane at the base of the mountain, you can spend time pondering and praying about the time Jesus spent here with his disciples before his arrest.</p>
							<p>Enter the Old City via Lion’s Gate, also known as St. Stephen’s Gate to the Pools of Bethesda, where Jesus healed a paralytic (John 5: 2-9). Christian groups love to raise their voices in song at the adjacent Church of St. Anne.</p>
							<p>Walking up through the Old City streets, your next stop can be the Sisters of Zion Convent, built over the Praetorium, where Jesus was judged by Pontius Pilate and took up the cross, marked by the Ecce Homo (“Here is the Man” - John 19:5) Arch over the street. This site marks the beginning of the Via Dolorosa, the Way of Sorrows, which tradition says Jesus went with the cross to Calvary. Today, it passes through the colorful Old City markets to the Church of the Holy Sepulcher. This is the site venerated by the Roman Catholic and the Orthodox world as the place of crucifixion, death, burial and resurrection of Jesus.</p>
							<p>The day will end with a visit to the Garden Tomb. Located 500 meters to the north of Damascus Gate, this ancient cemetery discovered approximately 130 years ago by the British General Charles Gordon has become a moving site in which to recall the crucifixion and burial of Jesus, and spend time in these peaceful garden surroundings in prayer, song, fellowship and communion.</p>
							<p class="ac-margin-bot-20">Overnight in Jerusalem.</p>
							<h3>DAY 7</h3>
							<p>Start the day with a visit to Mt. Zion and its many sites, among them: King David’s Tomb and the Room of the Last Supper.</p>
							<p>Enter the Old City via Zion Gate and stroll through the alleyways of the Jewish Quarter, overflowing with historic sites and archaeological treasures. Stop at the Western Wall, the last remnant of the Herodian Temple Mount destroyed by the Romans nearly 2,000 years ago. While at the Western Wall, arrange your schedule to join a public tour of the Western Wall Tunnels by enquiring at the Western Wall Heritage Foundation.</p>
							<p>Explore the Southern Wall Archaeological Park located around the southwestern corner of Temple Mount. Here you can stand on the very street that Jesus would have walked 2,000 years ago and view other archaeological remains that shed light on other New Testament events. You can also visit the magnificent Davidson Visitors Center in the basement of an eighth-century-CE palace. Look into the possibility of seeing its virtual-reconstruction, high-definition interactive model, and enjoy the high-definition film open to all visitors that depicts ancient pilgrimage to the Temple in a unique way.</p>
							<p>Continue to the most ancient part of Jerusalem: the City of David. This area has been excavated more than any other place in Jerusalem in the past 120 years and boasts some of the most important discoveries in biblical archaeology to date.</p>
							<p>End the day with a walk through the water of Hezekiah’s Tunnel, named after the king who ordered it hewn to keep Jerusalem’s water from the Assyrians when the city was under siege. A highlight of this visit is a stop at the Pool of Siloam, where new excavations have uncovered the actual remains of the pool where Jesus healed a blind man.</p>
							<p class="ac-margin-bot-20">Overnight in Jerusalem.</p>
							<h3>Day 8</h3>
							<p>Start the day with a visit to Yad Vashem the Holocaust memorial, with its astounding new historical museum, Hall of Remembrance, Children's’ Memorial and other moving sites.</p>
							<p>Proceed to Ein Karem. This picturesque village is full of winding lanes, enchanting architectural features and lush green gardens. There are seven monasteries and convents inspired by various traditions at Ein Karem. It is said that John the Baptist was born here and that Mary drank from the Spring of the Virgin, still bubbling from a cave at an abandoned mosque near the center of the village.</p>
							<p>Continue to the Israel Museum, home to the most important archaeological discovery of the 20th century – the Dead Sea Scrolls. An impressive model of Jerusalem in 69 CE sets the stage before entering the special shrine that contains the Scrolls. Stop at the square opposite the Knesset, to view Israel’s legislature and see the magnificent bronze menorah with its carvings depicting the biblical history of Israel and Zechariah’s immortal words “Not by might, nor by power but by My Spirit...” (4:6).</p>
							<p>Finish the day with a visit to downtown Jerusalem’s Ben Yehuda and Nahalat Shiva pedestrian malls and meet Jerusalemites over a cup of coffee or a local dish at a cafe or restaurant, or stroll the open-air fruit and vegetable market, Mahane Yehuda. (Ask at your hotel about optional evening tours).</p>
							<p class="ac-margin-bot-20">Overnight in Jerusalem.</p>
							<h3>Day 9</h3>
							<p>Head east out of Jerusalem through the Judean Desert to visit Qumran, where the famed Dead Sea Scrolls were found. Modern scholarship places a community of Essenes at this site, and it is possible that John the Baptist spent some time with the community here.</p>
							<p>Drive along the shore of the Dead Sea, to the oasis at Ein Gedi, where David hid from King Saul, and you can hike to a desert waterfall.</p>
							<p>In the afternoon, take the cable-car to the top of Masada[JD1] , scene of the epic stand by Jewish rebels at the end of the great revolt against Rome nearly 2,000 years ago. The new museum at the visitor’s center reveals the secrets of the daily life of the rebels, the story of the excavations, and how the site became one of Israel’s most important symbols.</p>
							<p>Enjoy a healthful and relaxing dip in the Dead Sea, the lowest, saltiest body of water on earth, before returning to Jerusalem.</p>
							<p class="ac-margin-bot-20">Overnight in Jerusalem.</p>
							<h3>Day 10</h3>
							<p>Drive west to the Valley of Ayalon, where Joshua called on the Lord to make the moon stand still. Stop at Emmaus on the road to which Jesus appeared to two of his disciples when they left Jerusalem after his crucifixion.</p>
							<p>Continue to the Valley of Elah, where David fought Goliath. Drive up Tel Azekah to enjoy the fine overview of the famous battleground.</p>
							<p>Continue to Beit Guvrin National Park and Tel Maresha, the Israelite/Idumean town of Maresha – believed to be the birthplace of King Herod. Visit the underground network of man-made caves and see the Roman amphitheater.</p>
							<p>In the afternoon, visit the Neot Kedumim Biblical Landscape Reserve where the flora of the Scripture comes alive, along with biblical tools and industrial implements: oil presses, wine presses, cisterns and more.</p>


						`,
      };
    },
  },
  {
    id: "Catholic_Interest_Itineraries_10_Days_Tour",
    ctg: "itineraries",
    bgImage: "posts/bank/catholicinterestitineraries10daystour/1.jpg",
    mobBgImage: "posts/bank/catholicinterestitineraries10daystour/M.jpg",
    isVid: false,
    vidId: "",
    title: "Catholic Interest Itineraries - 10 Days Tour",
    smltitle: "",
    html: function() {
      return {
        __html: `	
														  <p>Region: Eilat, South, Dead Sea, Jerusalem Area, North, Tel Aviv and Center, Number of Days: 10, Starting Point: Jaffa, Ending Point: Be'er Sheva, Trail Type: Walking</p>
													   <p class="ac-margin-bot-20">Follow the footsteps of Jesus in a tour of the Holy Land: walk the Via Dolorosa, visit Nazareth and wet your feet in the Sea of Galilee. A spiritual experience to remember.</p>
													   <h3>DAY 1</h3>
													   <p><strong>From Jaffa to the Sea of Galilee.</strong></p>
													   <p>Jaffa – where St. Peter had his vision on the rooftop of the House of Simon the tanner (Acts 10:32), raised Tabitha from the dead (Acts 9:36); Jonah set sail to Tarshish (Jonah 1:3) and King Solomon built his port (2 Chron. 2:16) on the Mediterranean.</p>
													<p>Caesarea – the magnificent ruins of Herod’s showcase port city continue the story of St. Peter, with his conversion of Cornelius’ household (Acts 10:24). Caesarea is also the scene of St. Paul’s imprisonment (Acts 23:35), his appearance before King Agrippa and his departure for Rome (Acts 25:13-26:32). It figures centrally in the history of early Christianity as home to the Church father Eusebius.</p>
													<p>The Carmelite Monastery of Mukhraka – where Elijah called down fire from Heaven (1 Kings 18:19-39). After this miracle, a great drought ended with the appearance of a small cloud over the sea (1 Kings 18:44), a pre-figuring of St. Mary.</p>
													<p>Acre – called Ptolemais when St. Paul visited it (Acts 21:7), a gem of the medieval world, with its Knights Halls, fishermen’s port, Turkish Bath Museum, bazaar and ramparts overlooking the Mediterranean Sea.</p>
													<p class="ac-margin-bot-20">Possible venues for Mass: Church of St. Peter in Jaffa, Carmelite Monastery of Mukhraka; Franciscan Church in Acre.</p>
													<h3>DAY 2</h3>
													   <p><strong>Around the Sea of Galilee.</strong></p>
													   <p>A boat-ride across the Sea of Galilee in a wooden vessel reminiscent of Jesus’ day.</p>
													<p>The Ancient Galilee Boat ­ – a wooden vessel dating back to the days of Jesus in a fascinating display.</p>
													<p>Mount of Beatitudes – where Jesus preached the Sermon on the Mount (Matt. 5), and one of many sites where Pope Paul VI and Pope John Paul II prayed.</p>
													<p>The Tabha Benedictine Monastery Multiplication of Loaves and Fishes – the site of the feeding of the 5,000 (Matt. 14:13-21).</p>
													<p>Church of the Primacy of Peter – site of the miraculous catch of fish (John 21:6), where Jesus appeared to the disciples after the Resurrection (John 21:7), and of St. Peter’s reconciliation to Jesus (John 21:15-19).</p>
													<p>Capernaum – scene of many miracles and teachings, and known as Jesus’ “own town” (Matt. 9:1), including:</p>
													<p>The House of St. Peter – (Mark 1:29) and the Memorial of St. Peter. The Ancient Synagogue – built over the site where Jesus preached (Mark 1:21).</p>
													<p>Tiberias – built by Herod Antipas (Luke 13:31) during Jesus’ ministry, Tiberias is the contemporary capital of the Sea of Galilee, with many reminders of Bible days.</p>
													<p class="ac-margin-bot-20">Possible venues for Mass: Mount of Beatitudes; Peter’s Primacy; Memorial of St. Peter in Capernaum, St. Peter’s Church in Tiberias.</p>
													<h3>DAY 3</h3>
													   <p><strong>From Armageddon to Nazareth</strong></p>
													   <p>Megiddo – with ramparts, temples, dwellings and a water system that made it one of the greatest cities of the ancient Near East, Megiddo became a regional capital of King Solomon (1 Kings 9:15), and is the New Testament’s Armageddon (Rev. 16:16).</p>
													<p>Mount Tabor ­– crowned by the magnificent Church of the Transfiguration with its brilliant mosaics, this mountain is also the scene of gathering of the forces of Barak and Deborah (Judges 4:6).</p>
													<p>Nain – a charming church graces this picturesque village where Jesus raised the widow’s son from the dead (Luke 7:11-15).</p>
													<p>Cana – on the outskirts of Nazareth, here Jesus performed the first miracle, changing water into wine (John 2:1-11), with the Wedding Church and the Church of Nathanael (John 21:2).</p>
													<p>Nazareth – beautiful churches now grace Jesus’ boyhood home, including Mensa Christi in an old residential quarter, the Synagogue Church in the market, St. Gabriel’s Church over the ancient spring, the Church of St. Joseph, and the jewel in the crown, the Basilica of the Annunciation, with its magnificent representations of Mary from around the world.</p>
													<p class="ac-margin-bot-20">Possible venues for Mass: the Basilica of the Annunciation, the Church of St. Joseph, Cana, Mount Tabor, Nain.</p>
													<h3>DAY 4</h3>
													   <p><strong>Upper Galilee: From Bethsaida to Dan.</strong></p>
													   <p>Bethsaida – home of Sts. Peter, Andrew and Philip (John 1:44), where Jesus healed a blind man (Mark 8:22), with remains of a fisherman’s house, a grape-grower’s house and a street from Jesus’ day, and the huge gateway of the biblical city of Geshur, home of David’s wife Maacah (2 Sam 3:3). A place for prayer and Mass overlooking the Sea of Galilee has been set up here for pilgrims by the Archdiocese of Omaha, Nebraska.</p>
													<p>Caesarea Philippi (Banias) – at the headwaters of the Jordan, where Jesus asked his disciples “Who do men say that I am” (Mark 8:27) and gave St. Peter the keys to Heaven (Matt. 16:19). Banias also features the ruins of temples built by Herod and his son Philip (Luke 3:1), and a thundering waterfall.</p>
													<p>Dan – a treasure-trove of Old Testament history dating back to Abraham (Gen. 14:14) in a magnificent natural setting that brings alive the biblical verse “a land of brooks of water, of fountains and springs” (Deut. 8:7).</p>
													<p>Domus Galilaeae – some pilgrims may want to visit this center of the Neo-Catechumenal Way.</p>
													<p class="ac-margin-bot-20">Possible venues for Mass: Bethsaida, outdoors at Caesarea Philippi, Domus Galilaeae.</p>
													<h3>DAY 5</h3>
													   <p><strong>Jerusalem The Mount of Olives and Mount Zion</strong></p>
													   <p>Mount of Olives –a magnificent vantage point of the Holy City, with many important churches marking biblical sites, including:</p>
													<p>Paternoster – where Jesus taught the Our Father prayer (Luke 11:1-4).</p>
													<p>The Dome of the Ascension ­– the site where Jesus ascended to Heaven (Acts 1:11).</p>
													<p>Bethphage – where Jesus began the triumphal entrance to Jerusalem on Palm Sunday (Luke 19:29).</p>
													<p>Dominus Flevit – where Jesus wept over Jerusalem (Luke 19:41).</p>
													<p>The Garden of Gethsemane – with its ancient olive trees where Jesus was arrested (John 18:1-12), next to the Church of All Nations, named for the contributions made by Catholics from around the world. The church overlooks the Kidron Valley (John 18:1), and is also known as the Basilica of the Agony, as here Jesus sweated blood in fervent prayer (Luke 22:44).</p>
													<p>Mount Zion, including:</p>
													<p>St. Peter in Gallicantu – with its beautiful mosaics and bronze statuary, built over the ruins of the house of Caiphas (Matt. 26:57), the stone pit where tradition says Jesus was held, and the Sacred Staircase, which for centuries has led here from the Kidron Valley.</p>
													<p>The Coenaculum – or Room of the Last Supper, built over the site of where Jesus and the disciples celebrated the first Eucharist (Mark 14:24).</p>
													<p>Dormition Abbey – marking the site of the Dormition of Mary, where Mary was taken up to Heaven.</p>
													<p class="ac-margin-bot-20">Possible venues for Mass: Pater Noster, Dominus Flevit, Church of All Nations, or the Dormition Abbey; St. Peter in Gallicantu, Bethphage.</p>
													<h3>DAY 6</h3>
													<p><strong>Jerusalem – the Via Dolorosa and Ein Karem.</strong></p>
													<p>Via Dolorosa – following the Stations of the Cross from the Chapel of the Flagellation, and the Sisters of Zion Convent, through the streets of Old Jerusalem to the Judgment Gate and the Tomb of Jesus in the Church of the Holy Sepulchre.</p>
													<p>Pools of Bethesda – where Jesus healed a paralytic (John 5:2).</p>
													<p>Church of St. Anne – built over the home of Anne and Joachim, the parents of Mary.</p>
													<p>Ein Kerem – the “city of Judah” (Luke 1:39), which was birthplace of John the Baptist, including:</p>
													<p>Church of the Visitation – where Mary met Elizabeth and uttered the Magnificat (Luke 1:46-55).<small>[MOU1]</small></p>
													<p>Mary’s Spring</p>
													<p>Church of St. John – where John the Baptist was born.</p>
													<p class="ac-margin-bot-20">Possible venues for Mass: The Franciscan Chapel in the Church of the Holy Sepulchre; the Church of the Visitation; the Church of St. John.</p>
													<h3>DAY 7</h3>
													<p><strong>Jerusalem – From the Old City to the New.</strong></p>
													<p>The Maronite Catholic Church – near the Jaffa Gate, with a wonderful view of Jerusalem from the roof.</p>
													<p>The Convent of Akeldama– where Judas died, in the Valley of Hinnom (Acts 1:18-19).</p>
													<p>The City of David – the most ancient part of the Holy City (2 Sam. 5:7).</p>
													<p>The Pool of Siloam – where Jesus healed a blind man (John 9:7).</p>
													<p>Shrine of the Book – in the Israel Museum, home of the Dead Sea Scrolls.</p>
													<p>The Model of Jerusalem – the famed 1:50 model of the way the Holy City looked in Jesus’ day.</p>
													<p class="ac-margin-bot-20">Possible venues for Mass: The Maronite Catholic Church.</p>
													<h3>DAY 8</h3>
													<p><strong>Through the Judean Wilderness to Eilat.</strong></p>
													<p>The Judean wilderness – where John the Baptist preached (Matt. 3:1) and where Jesus fasted for 40 days and nights (Matt. 4:2).</p>
													<p>Inn of the Good Samaritan – traditional site of Jesus’ parable (Luke 10:30-37).</p>
													<p>Qumran – where the Dead Sea Scrolls where discovered.</p>
													<p>Massada – the dramatic mountain fortress built by Herod the Great where the Jews made their last stand against the Romans in the Great Revolt.</p>
													<p>The Dead Sea – The lowest, saltiest body of water on earth; the Salt Sea, or Eastern Sea of the Bible (Josh. 15:5; Ezek. 47:18).</p>
													<p class="ac-margin-bot-20">Possible venue for Mass: Open-air at Qumran.</p>
													<h3>DAY 9</h3>
													<p><strong>The Southern Negev around Eilat.</strong></p>
													<p>The Underwater Observatory Marine Park – showcasing the natural beauty of the Red Sea.</p>
													<p>Timna Park – with its ancient copper mines, model of the Tabernacle, and impressive rock formations, including “Solomon’s Pillars.”</p>
													<p class="ac-margin-bot-20">Possible venue for Mass: Open-air Mass at Solomon’s Pillars.</p>
													<h3>DAY 10</h3>
													<p><strong>Through the Negev and northward.</strong></p>
													<p>The Wilderness of Zin – where the Israelites wandered Miriam died (Numbers 20:1).</p>
													<p>The Joe Alon Bedouin Museum – hands-on learning about how the Patriarchs and the Matriarchs lived.</p>
													<p>Be'er Sheba – the city Abraham founded (Gen. 21:31) and southern border of biblical Israel (1 Sam. 3:20).</p>
													<p>Possible venue for Mass: Open-air Mass at Be'er Sheba.</p>

							   
					`,
      };
    },
  },
  {
    id: "Women_In_The_Old_And_New_Testament",
    ctg: "itineraries",
    bgImage: "posts/bank/womenintheoldandnewtestament/1.jpg",
    mobBgImage: "posts/bank/womenintheoldandnewtestament/M.jpg",
    isVid: false,
    vidId: "",
    title: "Women in the Old and New Testament - 10 Days Tour",
    smltitle: "",
    html: function() {
      return {
        __html: `	
							   <p>Follow the Matriarchs, heroines and prophetesses of the Bible and the New Testament in this special tour of Israel.</p>
							
							<h3>DAY 1</h3>
							<p><strong>Jerusalem: city of prophetesses, heroines and queens.</strong></p>
							<p>Overview of Jerusalem from the Mount of Olives – this spiritually significant mountain is also the place for a bird’s-eye view of the mountains and valleys surrounding the city and the way it grew through the ages.</p>
							<p>Huldah's Tomb –Huldah the prophetess (2 Kings 22:14; 2 Chron. 34:22) has been commemorated here since the Middle Ages. The lady buried here is sacred by other names to other faiths: to Christians, she is St. Pelagia, a fifth-century singer from Antioch who abandoned her former life to devote herself to God. To Muslims, she is Lady Raba’ah, a ninth-century religious luminary.</p>
							<p>Eleona (Pater Noster) – one of the first churches to be founded on the Mount of Olives in 326 CE by Queen Helene, the mother of King Constantine who was the first Christian emperor. Queen Helene also identified Calvary and the birthplace of Jesus in Bethlehem; in this and other ways she left an indelible mark on Christian history.</p>
							<p>Russian Orthodox Church of Mary Magdalene – this beautiful 19th century church in its tranquil garden setting (open on Tuesday mornings) is the burial site of Princess Alice of Battenberg, Queen Elizabeth’s mother-in-law. Princess Alice, who married into the Greek royal family, was honored as a Righteous Gentile by Yad Vashem in 1994 for hiding a Jewish family when the Nazis took over Athens.</p>
							<p>The Tombs of ​the Kings – an old Jerusalem tradition has it that this magnificent tomb was the burial place of the kings of Judah. But it is actually that of a queen – Helene of Adiabene –who converted to Judaism and came with her family from Mesopotamia to Jerusalem, where she was highly praised for her gifts to the poor and to the Temple.</p>
							<p>The Western Wall – a last remnant of the Second Temple, and as such, the holiest place in the Jewish world and a scene of fervent prayer and Bar Mitzvah celebrations (Mondays, Thursdays and Saturdays).</p>
							<p>The Southern Wall Archaeological Park – a “still-life” of the original Herodian street, revealing Roman destruction Robinson’s Arch, and where a highlight is Hulda’s Gates, named after the prophetess, and by tradition a teacher, who both censured and comforted at the end of the First Temple period.</p>
							<p>The Davidson Visitor Center – housed in an eighth-century CE palace, where beautiful displays and a virtual-reconstruction, high-definition interactive model bring Jerusalem’s history alive.</p>
							<p class="ac-margin-bot-20">The Bible Lands Museum Jerusalem – in this unique collection of items reflecting Egyptians, the Hittites, the Philistines, the Assyrians and others who left their mark on the region are many displays relating to women, including jewelry, figurines, a bust of “Sarah the Matriarch,” a model of Esther’s palace in Shushan, a Byzantine woman’s decorated sarcophagus and more.​</p>
							
							<h3>DAY 2</h3>
							<p><strong>Jerusalem and southern environs: rooftops, matriarchs and wise women.</strong></p>
							<p>The Ramparts​ Walk – the opportunity to see the Holy City from above, with the mountains and the modern city on the outside, and a unique slice of life on the inside. One still-prevalent ancient custom is the women’s use of rooftops surrounded by special barriers to shield them from strangers as they work at household tasks.</p>
							<p>Kibbutz Ramat Rachel (“Rachel’s Height”) – the remains of a First Temple royal citadel unusually accented with artwork by sculptor Ran Morin. From here, an overview of the Judean Desert, Bethlehem, and the Mountains of Moab recalls that Ruth the Moabite changed history by braving the unknown to come to Bethlehem with her mother-in-law Naomi.</p>
							<p>The Church of Mary’s Seat – some years ago during road work here the remains came to light of the Katisma (“seat”), a church previously known only from pilgrims’ literature, where tradition says the heavily pregnant Mary rested on her way to Bethlehem. It is hoped the remains, including magnificent mosaics, will someday be restored. Meanwhile, the stone seat and the form of the octagonal church around it are still visible.</p>
							<p>Rachel’s Tomb – Rachel was another biblical mother-to-be on the road to Bethlehem. After she died giving birth to Benjamin, Jacob built her a monument here (Gen. 35:20). To this day, women come to Rachel’s tomb to pray for fertility and safe childbirth.</p>
							<p class="ac-margin-bot-20">Tekoa – explore the story of the savvy Wise Woman of Tekoa (2 Sam. 14:1-21) who got David to recall his estranged son Absalom. Take in beautiful views of the Judean Desert, visit with local women leaders to discuss models of female biblical leadership, and see two unlikely arid-land endeavors: a winery and a mushroom farm.</p>
							
							<h3>DAY 3</h3>
							<p><strong>Jerusalem: highlights of the Old City.</strong></p>
							<p>The Jewish Quarter – including the Cardo, Jerusalem’s ancient main street; the First Temple-era Hezekiah’s Wall; and the Burnt Ho​use, destroyed when the Romans conquered Jerusalem in 70 CE, where a moving audiovisual presentation highlights questions of class, the place of women, and the tragic end of one ancient Jerusalem family.</p>
							<p>The Syriac Orthodox Church of St. Mark – over the traditional house of Mark (Acts 12:13-16), where visitors can consider the part played by the servant girl Rhoda in the story of Peter’s return to the community and other “lowly” female figures in Scripture.</p>
							<p>The Church of the Holy Sepulchre – the most sacred ground in the Christian world, this ancient church stands over the Tomb of Jesus and the last of the Stations of the Cross.<small>[MOU1] [JD2] [אנ3]</small> </p>
							<p>The Dormition Abbey – marking the site of the Assumption of Mary, with an unusual representation of Mary surrounded by a mosaic of Old Testament women.</p>
							<p class="ac-margin-bot-20">The Church of the Visitation in Ein [JD4] [אנ5] Kerem – study comparisons between two biblical women’s praise-poems: the Magnificat (Luke 1:46-55), which Mary uttered here, and the paean Hannah recited in Shiloh when she offered her son Samuel to God’s service (1 Sam. 2:1-10).</p>
							
							<h3>DAY 4</h3>
							<p><strong>Jerusalem and northern environs: the women behind the men.</strong></p>
							<p>The City of David – the most ancient part of Jerusalem, with Warren’s Shaft, the “water fortress” at Gihon (1 Kings 1:38-40), the Pool of Siloam and more. While overlooking the present-day homes on the hillside, consider the story of David and Bathsheba and the role she played in Solomon’s life.</p>
							<p>Tel Shiloh – the location of the Tent of Meeting (Josh. 18:1), where Hannah came to pray for a son (1 Sam. 1:12-18), has been pinpointed on this archaeological mound; an interesting visitor center and film rounds out the experience.</p>
							<p class="ac-margin-bot-20">The Israel Museum – the Ethnography Wing reveals ways that customs involving women and families in traditional cultures can reflect those of the Bible; the Shrine of the Book, where the Dead Sea Scrolls were discovered; the 1:50 Model of Second Temple Jerusalem.​</p>
							
							<h3>DAY 5</h3>
							<p><strong>The Almog Tabernacle, Massada, Ein Gedi and the Dead Sea: sacred servants and heroic tales.</strong></p>
							<p>Massada National Park – Herod’s magnificent fortress, with its palaces, bathhouses and ramparts was also the last stand of the Jews against the Romans in the Great Revolt in 73 CE. The historian Josephus notes that two women and five children survived, and visitors wonder who they were and what might have been their fate. The new​ Massada Museum reflects daily life, highlighting among its exhibits women at their many daily tasks. The combination of Massada’s dramatic story with its fabulous architecture and finds has won it recognition as a UNESCO World Heritage Site.</p>
							<p>Ein Gedi National Park – a walk through the oasis, where “vineyards” once grew, a metaphor in the love poetry of the Song of Songs 1:14. The remains of Ein Gedi’s antiquities frame the story of Babatha, a woman of the town who fled the Romans to a cave where archaeologists found documents telling her life story.</p>
							<p class="ac-margin-bot-20">End the day with a dip in the Dead Sea and spa treatments.</p>
							
							<h3>DAY 6</h3>
							<p><strong>The Negev: meeting the Matriarchs.</strong></p>
							<p>Be'er-Sheba – the city that Abraham founded (Gen. 21:31) when he moved here with Sarah, and where the conflict between Sarah and Hagar reached its climax (Gen. 21:9-14). The landmark we​ll outside the gate is a backdrop for the many stories about women’s encounters at the well, including Rebecca (Gen. 24:13-26) Rachel (Gen. 29:9-12), the Samaritan woman (John 4:7-29), and others. Be'er Sheba’s ancient urban planning, water systems and other finds, along with its biblical significance, have made it a UNESCO World Heritage Site.</p>
							<p>Bedouin women’s craft center in Rahat - learn how crafts going back to Bible days can improve the lives of contemporary women who are descendents of a culture going back to the days of the Patriarchs and the Matriarchs.</p>
							<p>David and Paula Ben-Gurion’s home at Sde Boker – the modest home of Israel’s first prime minister and his feisty and devoted American-born wife, Paula. Visit the nearby tomb of the couple, overlooking the magnificent Zin Canyon. The view of the Desert of Zin, in the southwestern portion of which, at Kadesh, Miriam died (Numbers 20:1), is also opportunity to consider Miriam as a leader alongside Moses and Aaron (Micah 6:4).</p>
							<p class="ac-margin-bot-20">Walk through the Avdat Canyon to the Avdat Spring.</p>
							
							<h3>DAY 7</h3>
							<p><strong>From the Mediterranean to the Sea of Galilee: women in their private and public lives.</strong></p>
							<p>Neot Kedumim Biblical Landscape Reserve - take a biblical cooking workshop to learn about ancient herbs, spices, foods and dining customs, and explore romantic imagery in the Vale of the Song of Songs.</p>
							<p>Caesarea – the showcase Roman port built by Herod the Great, figuring centrally in both Jewish and Christian history. In addition to touring the theater, amphitheater, Crusader walls and other highlights Caesarea, as the home of the four daughters of Philip (Acts 21:8-9), is an excellent place to explore the role of women in public life in the early church. Visit the Hannah Senesch Museum at adjacent Sdot Yam to hear the moving story of a modern-day heroine.</p>
							<p class="ac-margin-bot-20">Tel Jezreel – home of Queen Jezebel (1 Kings 21:1-17), one of the so-called “bad girls of the Bible.” View Shunem, scene of the dramatic story of Elisha and the “well-to-do woman” (2 Kings 4:8-36).</p>
							
							<h3>DAY 8</h3>
							<p><strong>The Jezreel Valley: a new perspective on an ancient battlefield.</strong></p>
							<p>Nain – a charming church in a village that seems to have changed little since Jesus raised a widow’s son from the dead here (Luke 7:11-15), becomes the venue to learn how widows and other lone women fared in ancient society.</p>
							<p>Mount Tabor – to this mountain, the “high mount” of Transfiguration (Mark 9: 2-9), the judge Deborah called Barak to fight the Canaanites (Judges 4:4-16). With the ancient ruins and beautiful views as inspiration, find out who Deborah really was.</p>
							<p>Sepphoris – traditional birthplace of Mary, Sepphoris was built by Herod Antipas. Joanna, the wife of Cuza, Herod’s steward (Luke 8:3), who might have lived here, was among Jesus’ early supporters. Visit the restored theater, the “Mona Lisa of Galilee” mosaic, the Nile House and the Cardo. Another highlight is the sixth-century synagogue that tells a story of redemption and reveals an unusual representation of Sarah.</p>
							<p>Nazareth – most of the monuments in Nazareth, the town where Jesus grew up, are devoted to Mary, this is where the Annunciation (Luke 1:26-38) took place. Highlights include the Church of St. Gabriel, built over the spring where Mary no doubt drew water for her family, and the magnificent Basilica of the Annunciation. At the reconstructed Nazareth Village, learn about the daily life of women in Jesus’ day and take part in a weaving workshop.</p>
							<p class="ac-margin-bot-20">Cana – the scene of Jesus’ first miracle, the changing of water into wine at a wedding (John 2:1-11), in which Mary’s played a role with great theological implications.</p>
							
							<h3>DAY 9</h3>
							<p><strong>Around the Sea of Galilee: spirits of protection and the pioneering spirit.</strong></p>
							<p>Tiberius – this ancient city on the lake is the location of the tomb another Rachel, who loved and supported her husband, the great Rabbi Akiva, through thick and thin. Among the city’s Roman ruins, a first-century Herodian palace has been discovered, including a room with a marble floor where visitors can imagine Salome, the daughter of Herodias, dancing for the head of John the Baptist (Matt. 14:3-11).</p>
							<p>The tomb of Rachel the poetess – the passionate verses of Israel’s pioneering poet laureate are some of the best-loved in modern Hebrew literature. Reading them in this tranquil lakeside setting provides fertile ground for exploring women’s experiences as pioneers in this land in the early 20th century and elsewhere.</p>
							<p>A boat ride on the Sea of Galilee – emulating the experience of Jesus and the disciples, and recalling the story of “Miriam’s Well”: Miriam died in Kadesh, but immediately thereafter, according to legend, a miraculous spring appeared that nourished the Children of Israel everywhere in their hour of need and eventually found its way to the Sea of Galilee.</p>
							<p>The Mount of Beatitudes – an overview of the Sea of Galilee from the place where Jesus preached the Sermon on the Mount.</p>
							<p>Capernaum – scene of many miracles and teachings, and known as Jesus’ “own town” (Matt. 9:1), including the house of St. Peter – (Mark 1:29) and the Ancient Synagogue – built over the site where Jesus preached. Healings of women figure centrally in Jesus’ Galilee ministry, and the Capernaum synagogue is an excellent place to delve into these stories.</p>
							<p>The Tabgha Benedictine Monastery Multiplication of Loaves and Fishes – the site of the feeding of the 5,000 (Matt. 14:13-21).</p>
							<p>Job's Spring – a warm spring surrounded by an old stone tower, where local women came seeking healing in days gone by. According to tradition, Job's wife, who had sold her long hair to support the family when they became destitute, was reunited with her husband here.</p>
							<p>Bethsaida – the home of Peter, Andrew and Philip (John 1:44; 12:21), Bethsaida is now undergoing excavation, revealing homes and a street from the Roman period, and remains of the biblical city of Geshur, including a huge gateway and a palace. David himself may have come to the throne room discovered here to ask Talmai King of Geshur for the hand of his daughter, Maacah (2 Sam. 3:3).</p>
							<p class="ac-margin-bot-20">Mount Arbel National Park – with an ancient story of its own and a magnificent view of the entire region, particularly old and new Magdala, the hometown of Mary Magdalene, at its foot. Delve more deeply into the story of this “proclaimer.”</p>
							
							<h3>DAY 10</h3>
							<p><strong>The Hula Valley: Women as victors and vanquished, a Druze holy place and “clay in the hands of the potter”.</strong></p>
							<p>Hazor National Park – located in the lush Hula Valley, one of the first conquests of Joshua (Joshua 11:1-11), with fascinating remains that have won it recognition as a UNESCO World Heritage Site. In the time of the Judges, Hazor’s king sent Sisera to fight against Deborah and Barak. The fate of the defeated Sisera was decided after he encountered the brave and resourceful Jael (Judges 4:18-22). Jael is mentioned in Deborah’s song (Judges 5:28-30) along with Sisera's mother, waiting in vain for her son.</p>
							<p>Dan Nature Reserve – the capital of the northern kingdom, this fine example of a biblical city, includes "Abraham's Gate" and the high place of Jeroboam in a beautiful setting on the Dan River. A biblical gateway with a seat for the king and the elders is the place to recall the story of Boaz declaring before witnesses his desire to marry Ruth (Ruth 4:1-11), and the complexities of Levirate customs.</p>
							<p>Banias Nature Reserve – the remains of another riverbank city grace this site, the Roman Caesarea Philippi (Matt. 16:13-20). Visitors see a temple to Pan, a shrine to the wood nymph Echo, and enjoy a thundering waterfall. A number of Druze holy places are to be found in this area, including one to a righteous woman known as Sit (Lady) Sara, where the faithful come to light candles and make vows for healing and success.</p>
							<p class="ac-margin-bot-20">Attend a workshop with a pottery artisan for hands-on learning about one of the most important crafts of antiquity, which some scholars think may have been invented by women as they tended the family fire.</p>


						`,
      };
    },
  },

  {
    id: "eurovision",
    bgImage: "/posts/bank/eurovision/1.jpg",
    mobBgImage: "/posts/bank/eurovision/M/1.jpg",
    title: "EUROVISION TEL AVIV",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/logo.png"} class="img-responsive" />
					</div>
					<h3>
						A ONCE IN A LIFETIME OPPORTUNITY TO VISIT TEL AVIV AS IT HOSTS THE EUROVISION SONG CONTEST
					</h3>
					<p>					
						Epic song contest in the Non-Stop City
					</p>
					<p>
						Semi-final 1: 14 May 2019
					</p>
					<p>
						Semi-final 2: 16 May 2019
					</p>
					<p>
						Grand Final: 18 May 2019
					</p>
					<p>
						It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city.
					</p>					
					<p>
						Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak. Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest.
					</p>            
                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv.
					</p>
					<p>
						The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all!
					</p>

            	`,
      };
    },
  },

  {
    id: "Get_ready_to_party",
    bgImage: "/posts/bank/Get_ready_to_party/1.jpg",
    mobBgImage: "/posts/bank/Get_ready_to_party/M/1.jpg",
    title: "The best Eurovision parties to be at",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

               <h3>
               	Your Total Guide to Tel Aviv Eurovision parties
               </h3>
               <p>
					From the Eurovision Village to the EXPO Centre, these are all the key places you need to know about for Eurovision 2019 in Tel Aviv…
				</p>
				<h3>
					CHARLES CLORE PARTY VENUE
				</h3>
				<h3>
					Charles Clore Park: home to the largest Eurovision Village to have ever been made.
				</h3>
				<p>
					Charles Clore Park is located on the sea-front in the south-west of Tel Aviv. It’s a beautiful green space overlooking Old Jaffa, one of the most ancient places in Tel Aviv. 
					During Eurovision week it will be home to the Eurovision Village, where free concerts from the biggest Eurovision stars will take place. Highlights include Dana International and Conchita Wurst, plus parties and screenings of the live Eurovision TV shows will take place outside, right in-front of the beautiful Mediterranean sea! 
				</p>
				<p>
					Also, some of Israel’s best chefs will be opening food stalls for the public to get first-hand experience of-mouth-watering Israeli and Middle-Eastern cuisine.
				</p>
				<p>
					Charles Clore is easy to get to: It’s a five minute walk from the Carmelit bus terminal, so any bus terminating there is a good choice. Then you can just walk towards the sea and you’ll see the village. If coming by foot, walk along the beach promenade. Or you can cycle or scoot along the sea front to get there. 
					It’s a big park and will be having a Eurovision makeover, so you won’t be able to miss it! In fact, this is the largest village to ever have been made for the Eurovision!
				</p>
				<h3>
					TEL AVIV PORT VENUE (“The Namal”)
				</h3>
				<h3>
					Home to 2019’s official Eurovision Euro Club
				</h3>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					The club will feature theme parties, live performances, screenings of the Eurovision live shows and many more surprises to be revealed. Former Eurovision acts and winners, both Israeli and international, are set to perform there during the Eurovision week, so the venue will offer much more than just a traditional night-club. Entry to the Euroclub is free for accredited fans, journalists, delegations and artists. Members of the general public can get in to the Euroclub by purchasing a special weekly bracelet, here:
					<a href="https://www.eventer.co.il/euroclub?fbclid=IwAR37-d_19OE7bsq0rQ_gPHAW-sRfn1QAMi-cxp_ID2pFtDODBYzbf5NB6S0" target="_blank">https://www.eventer.co.il</a>
				</p>
				<h3>
					EUROVISION VENUE
				</h3>
				<h3>
					Expo Tel Aviv: home to the Eurovision Song Contest itself
				</h3>
				<p>
					The 2019 Eurovision Song Contest will be held at the Tel Aviv Expo center on the14th, 16th and 18th May. If you’ve got tickets, this is the place you’ll need to get to.
					It’s located on Rokach Boulevard in the north of the city, past HaYarkon Park and near to Tel Aviv University. To get there, use a journey planning app to find a bus route that will drop you right outside. Or, if travelling by train, get off at Tel Aviv University Train Station which is just a few minutes’ away from the convention centre.
				</p>
				<p>
					Don’t forget about the White Night, all the details are in the next article.
				</p>

         	`,
      };
    },
  },

  {
    id: "Tourist_info",
    bgImage: "/posts/bank/Tourist_info/1.jpg",
    mobBgImage: "/posts/bank/Tourist_info/M/1.jpg",
    title: "Tourist info",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

					<h3>
					How to get to Tel Aviv from the airport:
					</h3>
					<p>
					The cheapest way to get into central Tel Aviv from Ben Gurion airport is by train. Follow the signs to the train station that’s attached to the airport (it’s clearly sign-posted) and look for a train that’s going to Tel Aviv-HaHagana (for south Tel Aviv), Tel Aviv-HaShalom (for Central Tel Aviv), Tel Aviv-Savidor Center (for the Old North area of Tel Aviv), or Tel Aviv-University (for the Eurovision Song Contest venue itself). Please note that Tel Aviv HaShalom is closed on Fridays until September 2019. 
					A one-way single ride ticket will cost 13 shekels 50, and the journey takes around 25 minutes. When you get off the train, you might want to take a taxi to your accommodation. Whenever you get in a taxi, ask the driver to use the meter (“monet”) and have cash ready to pay. Or see below for details of taxi apps. For more information and to plan your journey, visit <a href="https://www.rail.co.il/en" target="_blank">https://www.rail.co.il/en</a>: - it’s in English!
					</p>
					<p>
					If you’d prefer to take a taxi all the way to Tel Aviv from the airport, then join the registered taxi queue outside the arrivals hall. A member of staff will ask you where you’re going and how many passengers and cases you have, then will give you a ticket to hand to your driver. You can either use a meter or accept a fixed price. Journeys usually cost around 150-170 shekels for one person. 
					</p>
					<h3>
					How to get from Tel Aviv to Jerusalem:
					</h3>
					<h3>
					By Bus
					</h3>
					<p>
					Head to the Tel Aviv Savidor train central station take bus no.480. The journey time is around 45 minutes. The bus route finishes at the Jerusalem Central Bus Station on Jaffa Road. From there you can take the tram or any other means of transportation available to you, to get to your final destination. 
					</p>
					<h3>
					By Train
					</h3>            
					<p>
					You can also take the brand new train! If you want to go to Jerusalem directly from Ben Gurion Airport, take the train to Navon Station in Jerusalem. The journey from the airport takes around 25 minutes. If you’re connecting from other Tel Aviv stations, just take a train to Ben Gurion Airport station and change there for a connection to Navon.  
					</p>            
					<h3>
					How to get around Tel Aviv
					</h3>
					<p>
					The municipality of Tel Aviv will offer free public transport throughout the city over the weekend of the Eurovision Song Contest. 
					Free buses will run on Friday and Saturday May 17-18.
					However Usually on Saturday there is no public transport in Tel Aviv (aside from taxies).
					</p>
					<p>
					For the other days of Eurovision week, you’ll need a Rav Kav card: Similar to the “Oyster Card” in London, a Rav Kav is a smart card that can be loaded with credit to allow you to ride on buses without needing to worry about cash. In fact, bus drivers no longer let you pay in cash, so it’s super important to get a Rav Kav as soon as you arrive in Tel Aviv.
					To get a card, just jump on a bus at any bus stop, and ask the driver for a Rav-Kav card - it costs 5 shekels (You will need exact change). Then, when you get off the bus, take the card anywhere with you. Some local 7/11s (Kiosk) provide top up serives, ask to add some credit. 50 shekels is probably enough for a one-week visit, as it will cover the cost of around 10 local journeys (each journey is 5 shekels 90). 
					You can also buy a Rav Kav at the official Rav Kav office at 35 Iban Gabirol Street, which is open Sunday to Thursday 8:00 - 20:00 and Friday and holiday eves 8:00 - 13:00 ,or in the Tel Aviv Savidor train station and Carmelit central. You can also add credit at any train station. 
					</p>
					<h3>
					Cycling
					</h3>
					<p>
					Tel Aviv is a cycling hot-spot and there are bike lanes all around the city, including one that runs all the way along the beach promenade from Jaffa in the south  the north of Tel Aviv and beyond, which are gorgeous locations to take a bike ride while soaking up the atmosphere and architecture of Tel Aviv. If you have a bicycle helmet, bring it with you. 
					</p>
					<h3>
					Electric Scooters
					</h3>
					<p>
					Scooters have become super popular in Tel Aviv! They offer a convenient and fun way to get round the city. There are a few brands around – all you have to do is download the relevant app, follow instructions and off you go. Swap your handbag for a rucksack as this will help with balance and remember to keep an eye on the traffic and not to listen to music while scooting. If you have a helmet, it’s a good idea to wear it while you scoot
					</p>
					<h3>
					Walking
					</h3>
					<p>
					Walking is also a great option too - your step-count will soar after a few days in the non-stop city! Equip yourself with a map, a sun-hat and a bottle fo water, and hit the pavements!
					</p>
					<h3>
					Transportation Apps 
					</h3>
					<p>
					There are various transportation apps you can download before arrival to help you plan your way around. Search for one from each category: there are taxi apps, bicycle rental apps, scooter rental apps and journey planning apps. You can also ask your hotel concierge or apartment host for advice on how to get around Tel Aviv - they will be happy to help! 
					</p>
					<h3>
					WIFI
					</h3>
					<p>
					Tel Aviv has a free Wifi network throughout the city. Look for the ‘Free TLV’ network in your smartphone - it works in 80 locations around the city. Most cafes and bars have free public Wifi networks you can use too; just ask for the password when you make your order. Hotels also have free Wifi so just ask for the password information when you check-in.
					</p>

         	`,
      };
    },
  },

  {
    id: "White_night",
    bgImage: "/posts/bank/White_night/1.jpg",
    mobBgImage: "/posts/bank/White_night/M/1.jpg",
    title: "White night",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<h1 class="align-center">
							  White Night Lights Up Tel Aviv on 16th May 
							</h1>
        					<div class="responisve-iframe">
								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
							</div>

							<p>What do you get when you cross a Eurovision Semi-Final with an all-night party in a city that is famous for its 24/7 party energy? The answer is White Night, which will hit Tel Aviv this year on Thursday 16th May, just two days before the 2019 Eurovision Song Contest grand final.</p>
                            <p>Featuring pop-up art installations, live music, dance parties, cultural events, food and drink, all fused together with Tel Aviv’s eclectic atmosphere, White Night is one of the biggest cultural events of the year. </p>
                            <p>And for 2019, it’s taking place a month earlier than usual, so that visitors coming for the Eurovision Song Contest can also experience this magical experience in the White City of Tel Aviv.</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/1.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Adam Primer
							</small>

							<p>From sunset until sunrise, the city will be wide-awake with cultural activities. Locals and visitors alike are invited to explore the city and soak up all the activities on offer. Many bars, restaurants and shops will be offering experiences free of charge or at reduced rates, so it’s definitely worth stocking up on sleep so you’re ready to party all night long!</p>
                            <p>And at the Eurovision Village in Charles Clore Park, there’ll be an extra sparkle of Eurovision magic, as several icons of the competition take to the stage to entertain visitors during the night. </p>
                            <p>Last year’s runner-up, Eleni Foureira, who narrowly missed out to Tel Aviv’s own Neta Barzilai with her smash-hit song “Fuego”, will be performing, as will 2014 winner, Conchita Wurst from Austria, who will most likely perform his iconic winning song, “Rise Like a Phoenix” while showcasing his new-look for 2019!</p>
                            <p>They’ll be joined by three more Queens of Eurovision, in the form of 1970s pop icon Anne-Marie David, who won for Luxembourg in 1973, Swedish pop star Carola Häggkvist, who won the contest in 1991, and Loreen, who also won for Sweden in 2012 with her song Euphoria. The performances will take place on the coast, overlooking the Mediterranean; the live semi-final will also be shown on big-screens in the Eurovision Village, off-set by jaw-dropping light compositions, created by the competition’s official lighting partner OSRAM.</p>
                            <p>All in all, White Night is a night not to be missed. So make the 15th May your duvet day and get-set to party all night long on Thursday 16th May 2019. Tel Aviv is ready and waiting to celebrate with you!</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/2.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Kfir Sivan
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/3.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by Moshik Lindenbaum
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/4.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by: Guy Yechiely‎.
							</small>

         	`,
      };
    },
  },

  {
    id: "Tel_Aviv_Street_Food",
    bgImage: "/posts/bank/street-food/1.jpg",
    mobBgImage: "/posts/bank/street-food/M/1.jpg",
    title: "TEL AVIV STREET FOOD",
    ctg: "telaviv",
    isVid: true,
    vidId: "JQD9JpMaw9g",
    smlTitle: "",
    html: function() {
      return {
        __html: `

                     <h3>It is no wonder that Tel Aviv was named one of Saveur Magazine’s “Outstanding Culinary Destinations</h3>

                        <p>Tel Aviv, home to sandy beaches, non-stop action and a raging nightlife, is also chock-full of unique restaurants and bars, making the seaside city a trendy foodie destination. The Tel Aviv food industry is truly the city’s heart and soul and while plenty of high-end eateries can be found throughout Tel Aviv, it is fresh local street food that has taken the city by storm.</p>

                        <h3>Taking traditional street food to a whole new level</h3>

                        <p>Say goodbye to the days where Tel Aviv street food was mostly limited to the scrumptious, yet singular concept of crisply fried falafel stuffed into a freshly baked pita. Today, the Tel Aviv street food scene is just that - a scene, with gourmet and specialty treats being served to the masses on local street corners. Take a walk down Ibn Gvirol, Ben Yehuda or Carmel streets and choose from a myriad of high-end meats, fish, prepared vegetables and sauces, all artfully inserted inside pita bread, between slices of toast or other casings. Nibble on the succulent delicacies inspired by the four corners of the world - sabich and tahini in laffa bread, unique herring sandwiches and more, as you continue to wander throughout the city, a taste of Israeli culture on your tongue and a pleasant sense of satisfaction in your belly.</p>


                        <h3>Restaurant quality meals for the foodie on the go</h3>

                        <p>What more could a bustling city full of hurried business professionals and excited tourists want than easy access to flavorful and trendy dishes that can be eaten on the go? With more and more unique streetside quick-stop eateries popping up throughout the city and serving dishes like entrecote-stuffed ciabatta bread and cornflour arepas, it is no wonder that Tel Aviv was named one of Saveur Magazine’s “Outstanding Culinary Destinations.” </p>

                        <p>Foodies delight: Tel Aviv and its hip street food scene, with countless delectable choices on every corner, is the ultimate culinary travel destination and a must-visit stop on your next Israel trip.</p>

         	`,
      };
    },
  },

  {
    id: "Jerusalem_Old_City",
    bgImage: "/posts/bank/jerusalem-old-city/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-old-city/M/1.jpg",
    title: "JERUSALEM’S OLD CITY",
    ctg: "jewish",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
         
                     <h3>
                         Sensational sites of Ancient Times
                     </h3>
                     <p>No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. A tour of the Old City of Jerusalem is an opportunity to get lost among the magical walkways and connect with the city’s resplendent past, history, culture and spirituality. </p>

                             <h3>The Western Wall</h3>
                             <p>Thousands of years old, the Western Wall is the last remaining relic of the Second Jewish Temple and the most important Jewish prayer site in the world, where millions of visitors from around the world place notes with requests and prayers into its cracks.</p>
                             <div class="img-wrapper">
								<img src=${getImgUrl() +
                  "/posts/jerusalem-old-city/1.jpg"} class="img-responsive" />
							 </div>
                             <h3>Western Wall Tunnels</h3>
                             <p>Located beneath the Western Wall, the tunnels provide a glimpse of the various periods in the history of Jerusalem and are as close as you'll probably get to travelling back in time.</p>

                             <h3>City of David</h3>
                             <p>Discover the story of Jerusalem during the reigns of Kings David, Solomon and Hezekiah in this captivating archeological site, where many treasures have been unearthed. A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was carved during the reign of King Hezekiah.</p>

                             <h3>The Old City Market</h3>
                             <p>A must-see attraction made up of a series of alleyways, with numerous stalls offering a staggering variety of products of every imaginable kind. This lively bustling market (or shuk) is a perfect place to pick up a unique souvenir (haggling is a
                             must) or try one of the many local delicacies.</p>
         	`,
      };
    },
  },

  {
    id: 13,
    bgImage: "/posts/bank/25/1.jpg",
    mobBgImage: "/posts/bank/25/M.jpg",
    vidId: "k4OwoEk5wMw",
    ctg: "jerusalem",
    isVid: true,
    title: "Jerusalem’s Calling",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>The most magical and radiant city on Earth </h3>

					<p>
						What else can you say about the world’s most unique city? Simply put: Welcome to Jerusalem – where a glorious history is intertwined with modern and dynamic life.
					</p>

					<p>
						Jerusalem is home to innumerable fascinating historic sites, magical walkways, breathtaking views at sunset, a wide variety of entertainment options, restaurants that offer culinary excitement, spirited nightlife and a tremendous offering of centers for the arts and culture.
					</p>

					<h3>
					   The Old City
					</h3>
					<p>
						No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. The Old City of Jerusalem brims with opportunities for you to connect with the city’s resplendent past, history, culture and spirituality. In the Old City, you’ll find archaeological treasures that are thousands of years old, contemporary art and bustling markets where you can purchase delectable delights.
					</p>

					<h3>
					  The Western Wall:
					</h3>
					<p>
						Believed to be the only remaining segment of the Second Temple, the Western Wall has become truly synonymous with Jerusalem. Thousands of years old, it is the most important Jewish prayer site in the world, where thirteen-year-old boys come to celebrate their bar mitzvahs, and where millions of visitors and tourists from around the world place notes with requests and prayers into its cracks.
					</p>
					<h3>
					  Western Wall Tunnels:
					</h3>
					<p>
						Visiting the tunnels is like entering a time machine. Located beneath the Western Wall and the Muslim Quarter, provides visitors with a glimpse of the various periods in the history of Jerusalem.
					</p>
					<h3>
					   City of David:
					</h3>
					<p>
						Located next to the Dung Gate, this site presents the story of Jerusalem during the reigns of King David, King Solomon and King Hezekiah. Many archeological treasures were unearthed in the excavation, including a two-thousand year-old gold earring.
					</p>
					<p>
					   A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was built during the reign of King Hezekiah.
					</p>

					<h3>
					 Via Dolorosa
					</h3>
					<p>
						Christian faithful follow in the footsteps of Jesus down the Via Dolorosa and the 14 Stations of the Cross, reenacting the fateful path that had an unprecedented impact on the course of history.
					</p>

					<h3>
					  Church of the Holy Sepulchre:
					</h3>
					<p>
						According to Christian tradition, the Church is the site where Jesus was crucified, buried and where he resurrected from the dead. It has long been and continues to be a major pilgrimage center for Christians world over.
					</p>

					<h3>
					 The market in the Old City:
					</h3>
					<p>
						This must-see attraction is made up of a series of alleyways, with numerous stalls offering a staggering variety of souvenirs, clothing, foods (baked goods, spices, sweets, tehini and more); stands hawking juices of all kinds, Armenian ceramics, drums and other musical instruments, earthenware jugs and much more. The colorful market delivers an authentic and extremely enjoyable experience that simply cannot be missed.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/2.jpg"} class="img-responsive" />
					</div>

					<h3>
						Attractions
					</h3>

					<h3>
						Segway tours:
					</h3>
					<p>
						This adrenaline-packed method of seeing the city will allow you to take in the beauty of Jerusalem from an entirely different perspective. The Segway tours leave from various central spots, including the Armon HaNatziv Promenade (East Talpiot), Yemin Moshe, and the Old City, as well as near the Knesset and the museum area.
					</p>

					<h3>
                        First Station (Hatachana):
					</h3>

					<p>
					   If you like amusement park rides, you love having your senses scintillated by the Time Elevator. It’s an interactive experience that takes visitors on fabulous voyages to fascinating places, with motion-based seating in a unique hall that is filled with special effects.
					</p>

					<h3>
                        Time Elevator:
					</h3>

					<p>
					   The First Station is right in the heart of Jerusalem, between the Old City and the city center, and between the historical neighborhoods of the German Colony and Yemin Moshe. It is the site of the first train station in Jerusalem, which was built in 1892. After undergoing renovation and preservation, the First Station was reopened as a lively entertainment spot.
					</p>

					<h3>
					   Machane Yehuda Market:
					</h3>

					<p>
					   To experience the city as authentically as possible, your itinerary must include a stop at Machane Yehuda Market. It represents Jerusalem of the present and the future. Machane Yehuda uniquely brings together old and new, with its fruit and vegetable market, along with an excellent food and a vibrant entertainment area.
					</p>

					<h3>
					   Museums
					</h3>

					<p>
					   In a city filled with a large number of museums, you have every opportunity to experience and learn about the events of the past and to visit modern and contemporary exhibits.
					</p>

					<h3>
					   Israel Museum
					</h3>

					<p>
					   The Israel Museum is the largest cultural institution in the country. It has many wings and very large collections of art, archeology and Judaica. One of the highlights of any visit to the museum is the Shrine of the Book, with its unique design that has come to be closely associated with the city itself.
					</p>

					<h3>
					   Tower of David Museum:
					</h3>

					<p>
					  Thousands of years ago, Jerusalem was a small city, where kings and prophets walked or rode their horses down the alleys. Since that time, one of the best-known symbols of the city is David’s Tower, with its turret standing proudly above the ancient fortress that has also become one of the city’s important museums.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/3.jpg"} class="img-responsive" />
					</div>

					<h3>
					   Restaurants
					</h3>

					<p>
					  Jerusalem boasts many restaurants, where you can dine on a wide array of delicacies –local and international, standard and exotic. And if you are looking for the gourmet experience, you can reserve a spot at exclusive chef restaurants. The following are five of Jerusalem’s finest and most popular spots, which attract crowds all day long:
					</p>

					<h3>
					   Café Kadosh
					</h3>

					<p>
					 Highly popular, the café serves kosher dairy cuisine – all made in house, and all delicious!
					</p>

					<h3>
					   Tmol Shilshom
					</h3>

					<p>
					  A dairy bookstore café in the city center, favored for its warmth, delicious food and friendly service. Don’t miss the shakshuka or salmon fillet in fig sauce!
					</p>

					<h3>
					   The Eucalyptus
					</h3>

					<p>
					  The kosher restaurant, located in the Artist’s Quarter, serves Chef Moshe Basson’s interpretation of biblical cuisine. Every dish has its origins in biblical scenes and all the spices and herbs used grow, as in ancient times, in the surrounding hills of Jerusalem and Judea. An unforgettable experience.					</p>

					<h3>
					   Darna
					</h3>

					<p>
					  An authentic, glatt kosher, Moroccan restaurant, located in the heart of the city. Experience the warm welcome and the true meaning of Moroccan hospitality, while enjoying the culinary excellence of the Maghreb.
					</p>

					<h3>
					   Ima Restaurant
					</h3>

					<p>
					  Right down the street from Machane Yehuda market, Ima offers excellent kosher Middle Eastern food, served in a relaxed family atmosphere
					</p>

					<h3>
					   And no visit to Jerusalem is complete without scooping up some hummus with a pita right out of the oven. The following are a few centrally located hummus spots:
					</h3>

					<div class="cradit">
							<p>
							<strong>Azura,</strong><small> in the Iraqi section of the Mahane Yehuda Market </small><br>
							<strong>Lina,</strong><small> in the Christian Quarter of the Old City</small><br>
							<strong>Hummus Acramawi,</strong><small>  in the Muslim Quarter of the Old City </small><br>
							<strong>Hummus</strong><small> Ben Sira, in the city center next to the Mamilla Hotel</small><br>
							<strong>Abu Shukri,</strong><small> in the Muslim Quarter in the Old City of Jerusalem </small><br>
							</p>
				    </div>

				    <h3>
				        Nightlife
				    </h3>

				    <p>
				         Jerusalem is filled with scores of restaurants and entertainment spots that are also open on Friday nights (the Jewish Sabbath). All of Jerusalem’s entertainment areas have excellent options for weekend fun on Friday nights as well as Saturdays, and you can most definitely enjoy a delightful evening over a cold beer or dance to great music.
                         Below is a small selection of bars and clubs that are hopping on Friday nights and will leave you wanting more…
				    </p>

				    <h3>
				       Mantra
				    </h3>

				    <p>
				       An intimate restaurant and wine bar, where a friendly atmosphere meets superb cuisine.
				    </p>

				    <h3>
				       Gatsby Cocktail Room
				    </h3>

				    <p>
				       The cocktail lounge and bar evokes the magic of the Roaring 20’s and the days of cabarets.
				    </p>

				    <h3>
				        HaTaklit
				    </h3>

				    <p>
				       With a name means “the record” in Hebrew, the trendy bar is decorated with record sleeves. Enjoy full bar, live music, DJs and even independent performers.
				    </p>

				    <h3>
				       Toy Bar (HaTza’atzua)
				    </h3>

				    <p>
				      Centrally located, Toy Bar offers great drinks, great music by some of the best local DJs and great dance bar experience.
				    </p>

				    <h3>
                        Sira
				    </h3>

				    <p>
                       One of the city’s most eclectic underground clubs, with an arcade room and dance floor. The pub also hosts events and performances.
				    </p>

				    <h3>
                        Even / Juke
				    </h3>

				    <p>
				       A music club that showcases the most creative bands in Israel, with an emphasis on jazz, blues and funk.
				    </p>

				    <h3>
                       Video Pub
				    </h3>

				    <p>
				       Jerusalem’s only “official” gay bar is home to some of the wildest parties in the city.
				    </p>

				    <p>
				       Jerusalem is the ultimate vacation destination! With so much to see and do, so much to stimulate your senses and pique your curiosity, your trip to Jerusalem promises us an unforgettable experience. Book your vacation now!
				    </p>

				    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/4.jpg"} class="img-responsive" />
					</div>

					<h3>Box:</h3>
					<h3>
					   Annual events
					</h3>

					<p>
					   Jerusalem plays host to a variety of unique annual events. Check the Internet for dates and further information.
					</p>

					<h3>
					   Festival of Light
					</h3>

					<p>
					   Held in the Old City – May 25, 2016 to June 2, 2016. Come and be part of the enchanting games of light and color, with dozens of displays by Israeli and international artists. Follow the paths set up throughout the Old City, guiding visitors from one mesmerizing work to another.
					</p>

					<h3>
					   International Arts and Crafts Fair (Khutsot Hayotser):
					</h3>

					<p>
					  August 15, 2016 – August 29, 2016. Held against the backdrop of the Old City walls, visitors enjoy a very special nighttime atmosphere and happening with musical performances. Walk through the gardens and stop at the various stands, where artists from Israel and the world exhibit paintings, prints, ceramics, metalwork and jewelry, weaving and textiles, Judaica, toys, crafts in various techniques, woodwork and more.
					</p>

					<h3>
					   The Israel Festival
					</h3>

					<p>
					   May 24, 2016 – June 11, 2016. The festival is Israel’s premiere multi-disciplinary international festival. It takes place annually in the spring, presenting outstanding theater performances, contemporary dance, classical music and performances from around the world, along with ground breaking Israeli works. Numerous festival events are held at unique Jerusalem locations that have historic significance of hundreds, if not thousands, of years. There are also many street performances that are open to the public.
					</p>

					<h3>
					  Jerusalem Film Festival
					</h3>

					<p>
					   July 7, 2016 – July 17, 2016. The festival sprinkles star dust across the city, with quality cinema, actors and writers that are guests. Many famous stars have come to the festival of the years. Over 200 Israeli and foreign films will be screened during the festival, highlighting various genres and competing for prizes. The festival offers opportunities for meetings with artists, workshops, parties and musical events.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/5.jpg"} class="img-responsive" />
					</div>


         `,
      };
    },
  },

  {
    id: "Outdoor_Adventures",
    bgImage: "/posts/bank/40/1.jpg",
    mobBgImage: "/posts/bank/40/M.jpg",
    title: "Outdoor Adventures",
    ctg: "telaviv",
    vidId: "88OV6xU0vPI",
    isVid: true,
    smltitle: "",
    html: function() {
      return {
        __html: `
                <h3>An action-packed city that’s perfect for active people</h3>
			<p>
				People in Tel Aviv live life to the fullest – and they do it outside. This city is chock-full with outdoor activities, and you can pick and choose your favorites. It’s an action packed city – perfect for active people.
			</p>
			<h3>
				Hayarkon Park
			</h3>
			<p>
				Known as the “Central Park” of Tel Aviv, Hayarkon Park is visited by approximately sixteen million people annually. Attractions range from picnics on the huge lawns, pedal boating on its beautiful manmade lake to cycle tracks and tours of the many amazing gardens, portraying nature at the heart of the city.
			</p>
			<h3>
				The Cycling Scene
			</h3>
			<p>
				One of the ultimate ways to discover Tel Aviv is via its 100km of dedicated bike lanes, where you can enjoy the Tel-O-Fun public bike hire system that lets residents and visitors pick up and drop off sleek green bicycles in 150 stations citywide. If you enjoy spending your time on wheels, you should also check out the many dedicated skating parks, where you can watch the local daredevils do their thing, or get your own skateboard or rollerblades and join the action.
			</p>

         `,
      };
    },
  },

  {
    id: "Port_Pleasures",
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    vidId_post: "LLOUxE-K_9Y",
    vidId_post: "tgF0zMUYY2g",
    ctg: "general",
    isVid: true,
    //  vidId : "LLOUxE-K_9Y",
    vidId: "tgF0zMUYY2g",
    title: "Port Pleasures",
    smltitle: "",
    html: function() {
      return {
        __html: `

        			
                    <h3>The different charms of Tel Aviv and Jaffa Ports </h3>
					<p>
						Jaffa Port offers an ancient history, stone buildings and cobbled lanes while Tel Aviv Port is a contemporary cultural, recreational and commercial hub.
					</p>

					<h3>
					    Jaffa Port
					</h3>
					<p>
						The modern city of Tel Aviv had its humble beginnings in the port of Jaffa where immigrants, armies and traders docked their ships. The port is famed as one of the oldest in the world and today it is still used by local fishermen while the historic surrounding area has become a popular tourist destination.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>


					<p>
						The waterside hangers have been converted into galleries and cultural spaces like the Nalaga’at Center operated by the deaf and blind community and the Dvir Gallery. From the waterfront the ancient cobbled alleyways wend their way up through stone buildings reminiscent of old Jerusalem. In among the historic buildings are galleries, specialty stores and excellent restaurants. As you reach the upper levels of the Old Port area you can see St. Peter’s Church, the Wishing Bridge, the Old Jaffa Museum and the Ilana Goor Museum.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
					</div>

					<h3>
						Tel Aviv Port
					</h3>
					<p>
						In contrast to Jaffa Port Tel Aviv has a more commercial and contemporary feel. The port operated from 1938 to 1965 and has undergone renewal and restoration to convert it into a shopping and entertainment district. The port area consists of converted hangers and a long wide waterfront promenade. It is popular with families visiting the Dyada Center for children’s activities and others visiting the yoga center, center for women, conference venue and the Cavim Institute of Design and Architecture. The promenade is always alive with street performers, musical events and outdoor markets. The port is a contemporary and dynamic area for creative and cultural expression. When the sun goes down the Tel Aviv Port becomes a popular nightlife destination with bars and clubs.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>

         `,
      };
    },
  },

  {
    id: 14,
    bgImage: "/posts/videos/deadsea/1/1.jpg",
    mobBgImage: "/posts/videos/deadsea/1/M.jpg",
    title: "The Dead Sea",
    vidId: "ixFocykfYHo",
    ctg: "deadsea",
    isVid: true,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
			<p>
					A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
			</p>
           <p>
					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
           </p>
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    vidId: "LLOUxE-K_9Y",
    title: "Port Pleasures",
    isVid: true,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>The different charms of Tel Aviv and Jaffa Ports</h3>
					<p>
						Jaffa Port offers an ancient history, stone buildings and cobbled lanes while Tel Aviv Port is a contemporary cultural, recreational and commercial hub.
					</p>

					<h3>
					    Jaffa Port
					</h3>
					<p>
						The modern city of Tel Aviv had its humble beginnings in the port of Jaffa where immigrants, armies and traders docked their ships. The port is famed as one of the oldest in the world and today it is still used by local fishermen while the historic surrounding area has become a popular tourist destination.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>

					<p>
						The waterside hangers have been converted into galleries and cultural spaces like the Nalaga’at Center operated by the deaf and blind community and the Dvir Gallery. From the waterfront the ancient cobbled alleyways wend their way up through stone buildings reminiscent of old Jerusalem. In among the historic buildings are galleries, specialty stores and excellent restaurants. As you reach the upper levels of the Old Port area you can see St. Peter’s Church, the Wishing Bridge, the Old Jaffa Museum and the Ilana Goor Museum.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
					</div>

					<h3>
						Tel Aviv Port
					</h3>
					<p>
						In contrast to Jaffa Port Tel Aviv has a more commercial and contemporary feel. The port operated from 1938 to 1965 and has undergone renewal and restoration to convert it into a shopping and entertainment district. The port area consists of converted hangers and a long wide waterfront promenade. It is popular with families visiting the Dyada Center for children’s activities and others visiting the yoga center, center for women, conference venue and the Cavim Institute of Design and Architecture. The promenade is always alive with street performers, musical events and outdoor markets. The port is a contemporary and dynamic area for creative and cultural expression. When the sun goes down the Tel Aviv Port becomes a popular nightlife destination with bars and clubs.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>


         `,
      };
    },
  },

  {
    id: "TelAviv_By_The_Sea",
    bgImage: "posts/bank/17/1.jpg",
    mobBgImage: "posts/bank/17/M.jpg",
    title: "TEL AVIV BY THE SEA",
    vidId: "XDei1Zy_cu4",
    isVid: true,
    ctg: "general",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>
				Tel Aviv Beaches - Cause life’s a beach in Tel Aviv.
			</h3>
			<p>
				Get ready for some serious fun in the sun!
			</p>

			<p>With clear waters and action-packed beaches, each one of Tel Aviv’s 13 beaches has its own style and attracts a variety of personalities - from hippie, casual to Riviera chic. No winder it’s National Geographic Magazine's “One of the 10 best beach cities in the world”</p>
			<p>If you are into water sports, can’t chill without a surf board, must pump your arms rowing a kayak, a quasi-professional wind / kite surfer or simply looking for a place to chillax, choose your beach:</p>
			<h3>NORTH TZUK BEACH</h3>
			<p><strong>Location:</strong> Yunitzman 21<br/>
			This northern beach, which borders the city of Herzliya, is a great getaway spot. Besides stunning views, a designated area for wind / kite surfing and white sands, the area also boasts volleyball courts, wide lawns, and a playground. Families love coming here for a day full of sea and sun, while the young crowds visit for a break from the city.</p>

			<h3>SOUTH TZUK BEACH</h3>
			<p><strong>Location </strong>: HaTsuk Beach<br/>
			This beautiful beach, located in Northern Tel Aviv, is a tranquil spot. The area, favored by families, includes a restaurant, outdoor gym, playground, and volleyball court. Pack your sunglasses and bathing suit, it’s time to soak in some vitamin D.</p>
			<h3>TEL BARUCH BEACH</h3>
			<p><strong>Location:</strong> Artzi Itzhak st.<br/>
			For a quiet atmosphere away from the city center, visit Tel Baruch Beach, situated near the Ramat Aviv neighborhood. This family-oriented spot boasts an outdoor workout area, restaurant, playground, volleyball court, green lawns, and beautiful views. The beach’s warm waters and relaxing atmosphere make it the perfect place to spend the day.</p>
			 
			<h3>METSITSIM BEACH</h3>
			<p><strong>Location:</strong> south of the Tel Aviv port<br/>
			This beach is considered to many Israelis an iconic place. It is named after its appearance in a monumental 1970’s film with the same name, “Metsitsim.” The spot is family-friendly and conveniently close to the Tel Aviv Port. Besides beautiful views and white sands, here you can find volleyball courts, outdoor workout equipment, and a children’s playground.</p>

			<h3>NORDAU BEACH</h3>
			<p><strong>Location:</strong> Nordau Blvd.<br/>
			Surrounded by high walls on both sides, this gender-segregated beach is designated for Tel Aviv’s religious population. On Sundays, Tuesdays and Thursdays, it’s open to women only, while on Mondays, Wednesdays, and Fridays, it’s open to men only. Saturdays, the beach is open to all. This is one of Tel Aviv’s quietest beaches, so if you’re looking for a more secluded experience, this is the place to go.</p>

			<h3>HILTON BEACH: </h3>
			<p><strong>Location:</strong> 205, Ha-Yarkon st. <br/> 
			Located in central Tel Aviv, in front of the Hilton hotel –In Hilton Beach, you can take part in adventurous water-sports such as surfing and paddle boarding. The southern part of the beach is considered the number one spot in Tel Aviv for surfers, while the northern area is completely dog-friendly.</p>
			<p>Also, Hilton beach is considered Tel Aviv’s unofficial gay beach.</p>

			<h3>GORDON BEACH</h3>
			<p><strong>Location:</strong> Gordon st.<br/>
			Gordon Beach is located near the Tel Aviv Marina. It is one of Tel Aviv’s busiest beaches. If you love being active, this place is a must. Here you can enjoy volleyball courts, a seawater swimming pool overlooking the sea, workout equipment, and more. The area also offers several bars, ideal for watching the sunset.</p>

			<h3>FRISHMAN BEACH</h3>
			<p><strong>Location:</strong> Frishman st.<br/>
			Located in the heart of Tel Aviv, Frishman Beach is a popular spot. This beach offers volleyball courts, an outdoor fitness center, and a variety of nearby restaurants and bars. Whether you’re looking to workout in a beautiful backdrop or spend the day relaxing in the sun, this is the place to go.</p>


			<p>Aviv Beach: This beach is located in the southern part of the Tel Aviv Promenade and offers a wide range of water activities including a surfing club.</p>
			 

			<h3>CHARLES CLORE BEACH</h3>
			<p>Kaufman 6<br/>
			Charles Clore Beach, located near Jaffa. The beach is divided into 2 sections. The part closer to the lifeguard tower tends to be more family oriented while the further south you walk, you are bound to meet young folk chilling in the sun or surfers. The atmosphere gets younger hippie like, offering the perfect getaway from the busy city center. After your visit, check out the nearby Manta Ray restaurant or walk to the gorgeous Jaffa Port.</p>

			<h3>GIVAT ALIYA BEACH</h3>
			<p><strong>Location:</strong> 22, Bat Galim st.<br/>
			This is Tel Aviv’s southernmost beach, bordering the city of Bat Yam. It is known for its beautiful stone arches and tall palm trees. If you’re a sports enthusiast, you can play beach volleyball here or check out the wide selection of water sports such as windsurfing and kayaking. It also offers a more secluded atmosphere if you prefer, simply spread a towel on the sand and appreciate the view.</p>

			<p>Day or night, hanging out on the beach is one of the best ways to spend time in Tel Aviv.</p>

			

			`,
      };
    },
  },

  {
    id: "Sarona_TelAviv",
    bgImage: "posts/bank/36/1.jpg",
    mobBgImage: "posts/bank/36/M.jpg",
    title: "Sarona Tel Aviv",
    isVid: true,
    ctg: "general",
    // vidId: "AcjsyamDZL8",
    vidId: "MJ-gsGs1tqA",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>At Tel Aviv’s Sarona Market, the culinary options are endless</h3>

						<p>Built in and around 150-year-old Templer structures in the heart of Tel Aviv is Israel’s culinary melting pot: Sarona Market. Reflecting Tel Aviv’s exemplary culinary atmosphere and placing a modern urban twist on the city’s more traditional marketplaces, Sarona is the place to visit to satisfy your every craving - and get a taste for the diverse ethnic inspirations that drive the bustling sea-side city. </p>



						<h3>Visit Israel’s largest covered culinary marketplace</h3>

						<p>From gourmet creations to spins on traditional local dishes, Sarona Market has it all and will satisfy every quaking belly. With over 90 restaurants, food stands, pubs and culinary boutiques operating seven days of the week, all you need to do is decide whether you’d rather tuck into a bowl of succulent ramen, a plate of spicy empanadas, a tangy sub sandwich or a sweet baked confection. Can’t decide? The eateries are all adjacent to one another, making a seafood entree followed by spicy pad thai or a juicy burger an easy feat. </p>

						<p>Need to take a break between courses? Sarona Market is also home to accessory shops, museums, a visitor’s center and other fun, must-see attractions.  </p>

						<h3>Go Green</h3>

						<p>TGIF! Fridays at Sarona are exceptionally enthralling, with farm-fresh produce available for purchase, making the culinary experience that much more interactive and engaging. Once you’ve selected your produce, continue on your urban market adventure, adding savory imported cheeses, top-quality Italian balsamic vinegar, boutique beers and sweet confections to your shopping bag, all tasty additions to a weekend home-cooked meal. </p>

						<p>Experience modern Israeli cuisine in full force at Sarona Market. With no end to the available culinary options reflecting the popular and unique foodie atmosphere of Tel Aviv, Sarona Market is a must-visit hotspot that will certainly satisfy every imaginable gustatory craving.</p>

			`,
      };
    },
  },

  {
    id: "Neve_Tzedek",
    bgImage: "posts/bank/4/1.jpg",
    mobBgImage: "posts/bank/4/M.jpg",
    title: "Neve Tzedek",
    // vidId: "bHQwLO6cefs",
    vidId: "5jl13Z-38eE",
    smlTitle: "",
    isVid: true,
    ctg: "general",
    html: function() {
      return {
        __html: `

                      	<br/><h3>An artsy oasis in  the heart of bustling Tel Aviv</h3>
                      	<h3>Enjoy the magical ambiance in the shaded courtyards of Neve Tzedek’s restaurants and cafes</h3>
						<p>Tucked inside one of Tel Aviv’s oldest districts, lies an architectural gem with a young, beating heart. Established in 1887, Neve Tzedek, the first Jewish neighborhood outside of the old port city of Jaffa, has recently become a trendy stomping ground for artists of all modalities, who fit in perfectly with the district’s restored quaint Oriental architecture.</p>
						
						<h3>A true oasis within bustling Tel Aviv</h3>
						<p>Whether you’re hunting for a handcrafted ceramic dish, a one-of-a-kind article of clothing, or jewelry made from traditional welding techniques, the countless boutiques, galleries, design ateliers and fashion shops within the Oriental-style buildings lining the narrow side passages and up Shabazi Street provide a unique and personal shopping experience. And with the cool sea breeze cooling you as you roam around the neighborhood, you will begin to feel alive and mirthful, just like the neighborhood’s whimsical spirit.</p>
						<p>Enjoy the magical ambiance in the shaded courtyards of Neve Tzedek’s restaurants and cafes with a light, yet satisfying meal. The many eateries, housed in quaint, historic structures built around the neighborhood’s narrow alleyways, are true culinary treats. The yummy meals, married with the serene air experienced upon walking through the neighborhood streets, transport you to a uniquely bohemian reality.</p>
						<h3>Where creativity knows no bounds</h3>
						<p>Visiting Neve Tzedek would be incomplete without paying homage to Tel Aviv’s ultimate creator at the Nachum Gutman Museum of Art, where standing exhibits and interactive activities enhance the artsy feel exemplified by the serene neighborhood, driving you to visit other local galleries and ceramics studios.</p>
						<p>Visit Tel Aviv’s Suzanne Dellal Center for Dance and Theater, where watching of one of the many performances and festivals the cultural center puts together - including ethnic song dance performances, fosters a true connection between Israeli performing arts and international displays.<br><br>Follow Shabazi Street to its summit and watch as the neighborhood’s creative juices continue to flow, spilling over into HaTachana, the old Jaffa railway station, recently transformed into yet another boutiquey hotspot, where shops and cafes emerge from a surprisingly historic-looking setting.</p>
						<p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in </a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">Tel Aviv &amp; Center</a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> at Tourist Information site</a></p>

              
			`,
      };
    },
  },

  {
    id: 9,
    bgImage: "posts/bank/5/1.jpg",
    mobBgImage: "posts/bank/5/M.jpg",
    title: "Jerusalem Old and new ",
    isVid: true,
    ctg: "jerusalem",
    vidId: "MXtcTm_JXus",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Ancient treasures and modern luxuries.</h3>

			<p>
				Downtown Jerusalem is the heart of the modern metropolis, bursting with nightlife, dining and cultural options to rival any major city in the world.
			</p>
			<p>
				The area is made up of several neighborhoods and appealing locations such as charming Nachlat Shiva, the bustling Yafo Street and Ben Yehuda Street, with its own unique personality and atmosphere not to be missed.
			</p>
			<p>
				The center of Jerusalem includes some of the city’s most charming neighborhoods and fascinating attractions. For an unbeatable cultural experience, check out Jerusalem’s variety of fascinating museums, including the world class Israel Museum, the Bible Lands Museum and Jerusalem’s Science Museum.
			</p>
			<h3>
				Machane Yehuda Market
			</h3>
			<p>
				Discover this market's unrivaled atmosphere and variety which draw thousands of tourists every day. Once the shopping is done and the food vendors close up, join the young trendy crowds, foreign and locals alike, who descend on the market to drink and party until the small hours, in the bars, restaurants and alleyways.
			</p>
			<h3>
				Nahalat Shiv’a
			</h3>
			<p>
				This charming cobblestone neighborhood at the heart of the city offers an excellent selection of shops, restaurants, bars and outdoor cafés. Nahalat Shiva is home to Kikar Hamusica (Music Square) – a lively and trendy outdoor space that offers live music every day throughout the week.
			</p>
			<h3>
				Yemin Moshe
			</h3>
			<p>
				This lovely neighborhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. Home to artists, writers and academics, Yemin Moshe is known for its beautiful windmill and oriental style houses, green parks, lively music center and stunning views.
			</p>
			<h3>
				Ein Kerem
			</h3>
			<p>
				Nestled in a peaceful valley between the mountains and the terraced hills southwest of Jerusalem, Ein Kerem is one of Jerusalem’s most picturesque neighborhoods. With its winding paved lanes, their charming stone houses adorned with arches, churches whose bells chime in the clear air, Ein Kerem radiates charm and beauty like an island in a sea of green forest
			</p>  

			`,
      };
    },
  },

  {
    id: "Market_Madness",
    bgImage: "posts/bank/10/1.jpg",
    mobBgImage: "posts/bank/10/M.jpg",
    title: "Market Madness",
    vidId: "2CSCe2WC7Ns",
    isVid: true,
    ctg: "jerusalem",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                     <h3>A celebration for all the senses</h3>
					<p>
						Throngs of locals and tourists are drawn during the day to witness the authentic atmosphere and workings of the market, and of course do some shopping, and once the food vendors close up, revellers — foreign and local alike — descend on the market to drink and make marry in the bars, restaurants and alleyways.
                        The shuk never really takes a day off during the week, but if you’re looking for a truly electrifying night out, then Thursday is your target. For locals, it’s the only night can go out without having to worry about getting up for work the next day, and it shows, as the bars and restaurants stay open late, throw parties that spill out into the streets and host special events.
					    <br>My “date” and I arrived at 7:20 pm, when many of the vendors were still open, and the aisles were crowded with shoppers looking for weekend bargains. However, as the vendors closed, the shoppers quickly dissipated making room for the party people.
					    <br>Although, it seems like yesterday that the shuk was just a place where you shopped and maybe grabbed a bite to eat from a local, working class eatery, over the past 5 years or so, the number of hip bars and restaurants has skyrocketed to the point that you can hardly keep track of everything between new ones popping every day and secret spots hidden away in corners only the locals know about.
                        “When you see the throngs of partiers at the shuk on a Thursday night, it is easy to forget that just a few short years ago you wouldn’t find a soul here at night,” said local tour guide Joel Haber. “But the truth is, this is not just the next logical step in Machane Yehuda’s constant historical development, but also the most vibrant new contribution to the city’s nightlife scene. The shuk has always been the crossroads where all Jerusalemites mix. Now the young and the less so, secular and religious, all sit side by side drinking beers and drinking in the shuk’s special character.”
					    <br>Check out some of the establishments that have more or less attained all-star status and always promise a good time.
					</p>



					<h3>
					   WINE, DINE AND DANCE
					</h3>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/1.jpg"} class="img-responsive" />
					</div>

					<h3>
					   CASINO DE PARIS
					</h3>

                    <p>

                          Tucked away in the depths of the Georgian shuk between the covered and uncovered market streets,  <a href="http://www.itraveljerusalem.com/city/jerusalem/casino-de-paris/" target="_blank"><strong>Casino de Paris</strong></a>  has a colourful history. The building it’s housed in has served as a casino, hotel, British officer’s club and a brothel over the years, but now it’s one of the classier joints in the shuk. The crowd skews a little bit older, attracting mostly professionals in their 30′s and 40′s, but Thursday nights still have an air of fun and youth as the bar stays open until 2 or 3 am serving well-made, original house cocktails inspired by the shuk, craft beers, some decent wines and an eclectic dairy menu also inspired by the ingredients and culture of the shuk.

                    </p>

                    <h3>
					   CINCO DE MAYO
					</h3>

					<p>
					    If you’re looking for a legitimate party atmosphere, Cinco De Mayo isn’t a bad place to start. The bar frequently hosts DJ’s playing a range of different styles and you’ll find people drinking, eating and maybe even dancing until around 2 am on Thursday nights. The revellers really begin to pack the place around 10:30 pm, so don’t be surprised if you have trouble finding a seat after that, but you can always make like the locals and grab a drink from inside and hang out in the alley.
                        Despite the name, Cinco de Mayo actually has nothing to do with Mexico or the 5th of May. The group of friends who started the bar took the name from their time living on a commune outside of Jerusalem, where nobody worked on May 5.
					</p>

                    <h3>
					  SHUKA BAR
					</h3>

					<p>
                       Despite its location off the main drag and relatively small stature, Shuka Bar on Egoz Street is one of the most popular places in the shuk. It’s a relatively meat and potatoes types of place, serving only Israeli beers, choice liquors and small snacks, but on Thursday nights it tends to turn from hole-in-the-wall hangout to a big party.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/2.jpg"} class="img-responsive" />
					</div>



					<h3>
					    QUE PASA
					</h3>

					<p>
					    Meanwhile next door, Que Pasa is the valiant effort by owner Yaniv Kovenshtein to recreate the tapas culture he loved so much in Spain.
                        Co-owner and chef Avi Betito Golansky brings the vision to life with a menu full of dairy and fish tapas-sized dishes, including tasty Bruschetta Cuca (sardines, onion, hot pepper olive oil on delicious crunchy bread) and Porcini Bruschetta (porcini sautéed in butter with garlic, almond oil and parsley), shaved artichoke with truffles, filleted sardines stuffed with Saint Moor cheese and fried with sage butter atop a lush tomato salad, mullet rings fried with roasted peppers, and more. If you’ve got the appetite they also have larger portions, such as gnocchi, sea bass fillet or red mullet.
					</p>

					<p>
					    While the bar’s motto is “a beer in the afternoon solves all problems,” it also pays to go for one Thursday night at Que Pasa, which also hosts local musicians on a regular basis.
					</p>

					<h3>
					    SHEM TOV
					</h3>

					<p>
					    Located on Eshkol Street, a street off the open shuk, Shem Tov truly captures the shuk vibe with a rich Middle Eastern menu, a pretty expansive selection of Israeli beer, wine and liquor and the coup de gras, music from all over the world that keeps the happy vibes going until 2 or 3 a.m. <br>It’s also a prime place to grab a glass of cold sahleb, a shuk staple usually served hot, made from the flour of ground tubers of orchids with rose water, milk, and cinnamon). Mmmmmm.Delicious!
					</p>

					<h3>
					    LATE NIGHT EATS
					</h3>

					<p>
					   If you’ve been out drinking, you’re probably in the mood for some munchies by around midnight, and lucky for you, there’s still plenty of eateries catering to your (probably) not-so-specific needs.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/3.jpg"} class="img-responsive" />
					</div>

					<h3>
					    SORAMELO
					</h3>

					<p>
					    If all that drinking’s given you a sweet tooth, then head to Soramelo at the Aggripas entrance of the covered shuk for some shuk-inspired waffles.
                        Named for a neighbourhood legend known for having a story about everything, Soramelo has no doubt produced a few stories of its own.<br>Soramelo stays steadily busy throughout the night with people stopping in for a microbrew, coffee of a sweet bite to eat, but it really gets busy later when people move on from drinking to late-night snacking. If you’re one of them, you have until 3 am on Thursdays to get a waffle in you to soak up all the beer and arak. Try the one with chocolate and tahina — you won’t be disappointed!
					</p>

					<h3>
					    MICHI’S
					</h3>

					<p>
					    Michi’s is a simple, yet delicious concept that makes for the perfect late-night eatery — high-quality hamburgers and meat sandwiches at a shockingly good price. You can get a simple 100-gram burger on a fresh bun with some serious fixings for just 17 NIS. If you’re really hungry, you can also get larger portions of meat, roast beef and chicken sandwiches and much more. Michi’s is open until 12 am.
					</p>

					<h3>
					    MEORAV YERUSHALMI
					</h3>

					<p>
					   This may be the best place to get the famous Jerusalem mixed grill, made of various meats and organs stuffed into a pita with fries and salad on the side. In addition to the traditional recipe, they also serve a mixed grill with fish. The portions are downright massive and perfect for those who have really worked up an appetite. Just make sure to get there before midnight.
					</p>

					<h3>
					    PASTA BASTA
					</h3>

					<p>
					    By far one of the most popular joints in the shuk, Pasta Basta is the place to go for fresh, homemade pasta dishes that won’t break the bank. All you have to do is choose a type of pasta and sauce and then you’ve got your food. The prices go according to the type of sauce and range from 19-26 NIS. Gnocchi, ravioli and additional toppigngs cost extra.
					    <br>Pasta Basta is open until midnight, and don’t be surprised when you see a line out the door.
					</p>

              
			`,
      };
    },
  },

  {
    id: 13,
    bgImage: "posts/bank/24/1.jpg",
    mobBgImage: "posts/bank/24/M.jpg",
    title: "The old city ",
    vidId: "k4OwoEk5wMw",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Feel the story come alive</h3>
			<p>
			   Become inspired by the world renowned treasures of the ancient city of Jerusalem.
			</p>
              
			`,
      };
    },
  },

  {
    id: 14,
    bgImage: "posts/bank/32/1.jpg",
    mobBgImage: "posts/bank/32/M.jpg",
    title: "The Dead Sea ",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
			<p>
			   Get high on life in the lowest place on earth.
			</p>
              
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "posts/bank/58/1.jpg",
    mobBgImage: "posts/bank/58/M.jpg",
    title: "The Dead Sea ",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
              <p>
						The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
              </p>
              <p>
              		This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
              </p>
              <p>
              		The Dead Sea is lined with spas, bathing beaches and spa hotels.
              </p>
			`,
      };
    },
  },

  {
    id: "Go_To_Guide",
    bgImage: "/posts/bank/gotoguide/1.jpg",
    mobBgImage: "/posts/bank/gotoguide/M/1.jpg",
    title: "Tel Aviv and Jerusalem so Close and yet so Far",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `

                    <h3>
                   Travel from Tel Aviv and Jerusalem
                    </h3>
					<p>
						One of the best things in visiting Tel Aviv and Jerusalem is how incredibly different yet amazingly close these two fabulous destinations are. In fact, the two cities are less than one hour’s drive(!) from each other, which means that should you choose to, you could spend the day exploring the awesome and world-famous sites of Jerusalem and be back in time to watch the sunset from one of Tel Aviv’s stunning beaches, before heading on to an all-night party in one of the city’s hottest clubs. Talk about a full day’s fun…
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/gotoguide/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Getting to and from Tel Aviv and Jerusalem is easy and there are several ways depending on your preference and budget:
					</p>
					<p>
						<strong>By Car</strong>: Should you choose to hire a car you will find route 1 connects the two cities directly, road signs are pretty clear and come in three languages. However, you might also want to use one of the local navigation apps to show you the way and help you avoid heavy traffic.

					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/gotoguide/2.jpg"} class="img-responsive" />
					</div>
					<p>
						<strong>By Bus</strong>: there are several public buses which travel to and from Tel Aviv and Jerusalem. This is by far one of the most convenient and budget-friendly means of travel.</p>
					<p>
						<strong>By Train</strong>: The train service operates in several main stations along Tel Aviv:  From the ‘University’ station, in the north of Tel Aviv, to ‘Savidor’ and ‘Hashalom’ in central Tel Aviv, to ‘Ha-Hagana’ in the south end of Tel Aviv, taking you to Jerusalem and back. 
				    </p>
					<p>
						<strong>By Taxi</strong>: Taxis can be flagged on the street or booked via phone or designated apps such as Gett (GetTaxi).
					</p>
					<p>
						<strong>Sherut Taxis</strong>: “Sherut” (service) taxis are 10 - 12 seater vans which generally follow major bus routes in the city and interurban rides. Pricewise, "Sherut" taxi fares have a fixed price, similar to public bus fares. "Sherut "taxis also offer a replacement service to buses on Fridays afternoon till Saturday evening.
					</p>
			            	<p>
			            		For information regarding train stations, routes and schedules, visit <a href="https://www.rail.co.il/" target="_blank">www.rail.co.il</a>
			            	</p>
			            	<p>
			            		For information regarding bus routes and schedules visit  <a href="https://www.bus.co.il/otobusimmvc?" target="_blank">www.bus.co.il</a>
			            	</p>
			            	<p>
			            		Public transport helpline <a href="tel:*8787">*8787</a>
			            	</p>
			            	<p>
			            		Local public transport app - ‘Moovit’
			            	</p>
			            	<p>
						        So come check out Epic Tel Aviv and unforgettable Jerusalem, less than one hour away from each other!
			            	</p>

            	`,
      };
    },
  },

  {
    id: "Day_IsTrippin",
    bgImage: "/posts/bank/48/1.jpg",
    mobBgImage: "/posts/bank/48/M/1.jpg",
    title: "Day Trippin’",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>Fabulous and fascinating one day in Tel Aviv</h3>

				<p>
					Start your day at Jaffa harbor, enjoy the salty refreshing sea air and treat yourself to breakfast at any of the lovely restaurants along the Marina. the Jaffa slope park, with a magnificent panorama over most of the Israeli shoreline, and the historical starting point of the metropolis, some 4000 years ago. Grab a cup of coffee at the renovated ancient port, and head north for a lovely stroll along the promenade and some fantastic seaside fun. 
				</p>
				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/37/2.jpg"} class="img-responsive" />
				</div>
				<p>
					Cross the street to the “Tachana Compound”, a fabulously renovated outdoor shopping center housed in a defunct historic train station built in the 1890s as Tel Aviv and Jaffa’s central train station. 
				</p>
				<p>
					Head to the picturesque neighborhood of Neve Tzedek and cross the beautiful alleyways. Treat yourself in their boutique shops until you reach the colorful hustle and bustle of Hacarmel market. Stop for some excellent street food and if it's a Tuesday or Friday – consider yourself lucky and get some shopping done at the traditional Nachlat Binyamin fair, where local artisans present their work. 
				</p>
				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/37/1.jpg"} class="img-responsive" />
				</div>
				<p>
					Continue all the way to gorgeous Rothschild Blvd, the heart of the Bauhaus architecture and a UNESCO international heritage site. This is the place to rent a bicycle and join the local flow all the way to Habima Square, home to the national theater and the Israeli philharmonic orchestra. Head down to the trendy, bustling Dizengoff Street or grab a bite in one of the coffee shops around the square and keep walking or cycling along Hen Blvd, all the way to Rabin square. 
				</p>
				<p>
					Check out Eben Gabiroll street, a trendy hub of the fabulous city, home to a huge array of award-winning restaurants, and excellent pubs and bars where you can grab a meal or an early drink and hang with the locals. 
				</p>
				<p>
					Hop on a number 5 service line, in itself an urban icon, and get off at the Tel Aviv port. Enjoy the sunset and look back south at the Jaffa skyline, where the day started. Spend your evening in the area and watch as it transforms into the city’s hottest nightlife scene, packed with fabulous bars and nightclubs tailor-made for epic nights. 
				</p>

            	`,
      };
    },
  },

  //Hadar asked to hide the video in this post on 18.01.2021
  {
    id: "Non_Stop_Culture",
    bgImage: "/posts/bank/non-stop-culture/1.jpg",
    mobBgImage: "/posts/bank/non-stop-culture/M/1.jpg",
    title: "Non Stop Culture",
    isVid: false,
    // vidId:"MXtcTm_JXus",
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h3>Tel Aviv’s fascinating cultural scene</h3>
				    <p>Tel Aviv is famous around the world for its culture and entertainment scene. Home to fantastic museums and art galleries, theaters, concert halls, and dance centers, your cultural desires are sure to be met. 
                    <h3>Theatres</h3>
                    <p>The Tel Aviv theatre scene is flourishing and visitors to the city will enjoy the many world class plays of the city’s main theatres – Habima, Hakameri and Gesher, located is beautiful surroundings and often hosting shows in English or offer subtitles for non-Hebrew speakers.  
                    <h3>Tel Aviv Museum of Art</h3>
                    <p> The city’s beautifully designed, leading museum for Israeli and international art containing one of the world’s largest contemporary art collections featuring permanent displays alongside rotating exhibitions.
                      

                    <div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/posts/non-stop-culture/1.jpg"} class="img-responsive" />
				    </div>    

                    <h3>Beit Ha’ir (The old Town Hall)</h3>
                    <p>The recently renovated Beit Ha’ir, was the old city hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city’s history, featuring a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years. 

                    <h3>Eretz Israel Museum</h3>
                    <p>A multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, Judaica, cultural history, local identity, traditional crafts and functional arts. 
                     
                    
                    <h3>Private Galleries</h3>
                    <p>All around Tel Aviv, but mainly in Neve Tzedek, Ben Yehuda and Gordon streets you can freely wonder into any of the privately-owned beautiful art galleries featuring original works of local contemporary artists.  


            	`,
      };
    },
  },
  //End Hadar asked to hide the video in this post on 18.01.2021

  {
    id: "A_Taste_Of_Jerusalem",
    bgImage: "/posts/bank/taste-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/taste-of-jerusalem/M/1.jpg",
    title: "A taste of Jerusalem",
    ctg: "culinary",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                <h3>Must eat dishes to try when visiting the magical city</h3>
				<p>
					While people rave about the amazing atmosphere, the unforgettable sites, the breathtaking views and more, to truly understand what Jerusalem is all about, there are some things that you simply have to experience through your stomach. Here are just a few of the things you really should try while visiting Jerusalem:
				</p>
	                    	<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/39/1.jpg"} class="img-responsive" />
				</div>
				<p>
					<strong>Meorav Yerushalmi:</strong> “Directly translates to “Mixed Jerusalem” this delicious mix of different meats in a special local blend of spices is an absolute carnivors’ heaven.</p>
				</p>
				<p>
					<strong>“Ashtanur”:</strong> Short in Hebrew for “fire in the oven” Ashtanur is an authentic local pitta bread which you can find in midtown or the markets during lunchtime. If you’re especially hungry, try it wrapped around a portion of shawarma or falafel.</p>
				</p>
				<p>
					<strong>Sabich:</strong> an absolute original, the Sabich is a truly unique local dish comprised of a Pitta bread packed with fried eggplant, hard-boiled eggs, and pickles, usually topped by Amba, a local, flavorful condiment. Once you try it, you’ll be hooked for life.</p>
				</p>
				<p>
					<strong>Malabi:</strong> A unique a combination of beverage and dessert, made of a mixture of rosewater, milk, cornstarch and sugar. Malabi is a very popular Jerusalem dish, sold in many middle eastern restaurants and kiosks throughout the city. Guaranteed to be nothing like anything you have ever tasted.</p>
				</p>
				<p>
					And of course… Falafel: The ultimate local street food, found on nearly every street, try it alone or even better in a pitta bread with hummus, fries and fresh vegetable salad – absolutely delicious. 
				</p>
				<p>
					So book your vacation now and get a taste of these awesome local treats to go with the your unforgettable trip to the magical city of Jerusalem. 
				</p>

            	`,
      };
    },
  },

  {
    id: "Sectrets_Of_Jewish_Jerusalem",
    bgImage: "/posts/bank/sectrets-of-jewish-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/sectrets-of-jewish-jerusalem/M/1.jpg",
    title: "Sectrets of jewish Jerusalem",
    ctg: "jewish",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                <p>Jerusalem is an open invitation for a journey. Climb the mountains, enter the city and feel the unique mix between past and present, ordinary and extraordinary. One of the most ancient cities in the world, sacred for Jews, Christians and Muslims, Jerusalem offers an unparalleled sensory and spiritual experience.</p>

                                <p>Enter. The heart of the holiest city in Judaism is the Old City. Enter through the historic entrance, The Jaffa Gate, or use The Zion Gate that leads straight to the Jewish Quarter, one of the four quarters of the walled city and home to Jews almost consecutively since 8 BCE. Wonder through the alleyways, see the people, visit the Cardo, Jerusalem's ancient main street and absorb the unique atmosphere. You're walking in the footsteps of kings and prophets – It's no ordinary thing.</p>
                                <div class="img-wrapper">
					                <img src=${getImgUrl() +
                            "/posts/sectrets-of-jewish-jerusalem/1.jpg"} class="img-responsive" />
				                </div>
							    <small style="color:#000; display:block;">
                      		        Credit: Noam Chen
                      	        </small>
								<p>Witness History Comes alive and Feel the Deep Spiritual Energy within the Walls </h3>

                                <p>What Lays Ahead.  The last remaining segment from the ancient walls that surrounded The Second Temple, The Western Wall, is a symbol of Jewish yearnings for their ancestral and spiritual homeland. Every Jew outside Jerusalem pray facing the place you stand in now, the place where according to Judaism, God resides. No matter what your beliefs are, it's a humbling experience. Honor the spirit of the site and place a note in the wall with a prayer or a wish.</p>

                                <p>What Lays Beneath. Jerusalem is literally covered with layers of history and touching history gets a whole new meaning here.</p>

                                <p>Take the fascinating tour at the Western Wall Tunnels and reveal the hidden sections of the Western Wall. History will come to life as you move through underground passages, discover life in Jerusalem during The Second Temple era and learn about the art, architecture and building practices.</p>

                                <p>Visit the nearby archeological site City of David and learn more about the history of the city King David declared as the unified capital of Israel's 12 tribes 3000 years ago. Go on a journey between ancient walls and fortresses, hidden springs where kings were coroneted and follow the path of fleeing Jerusalem residents after the city was conquered by the Romans.</p>

                                <h3>Marvel at the Breathtaking Extraordinary Vista and Feel on Top of the World</h3>

                                <p>What Lays Above. Originally built to protect the city against intruders, Jerusalem is surrounded by walls.  Today The Walls of Jerusalem offer an opportunity to explore the city from a different angle. Hear the stories, see the city below you and take in all this beauty.</p>

                                <p>You are just beginning to stretch the surface.</p>

            	`,
      };
    },
  },

  {
    id: "Jamie_Oliver",
    bgImage: "/posts/bank/jamie_oliver/1.jpg",
    mobBgImage: "/posts/bank/jamie_oliver/M/1.jpg",
    title: "Jamie Oliver gets a taste of Tel Aviv's breakfast",
    ctg: "culinary",
    isVid: true,
    vidId: "gGe4W8WaIiQ",
    smlTitle: "",
    html: function() {
      return {
        __html: `

						<small style="color:#000; display:block;position: relative;top: 5px;">
						Credit:  Israeli food channel
						</small>

            	`,
      };
    },
  },

  {
    id: 37,
    bgImage: "/posts/bank/enjoy-and-indulge/1.jpg",
    mobBgImage: "/posts/bank/enjoy-and-indulge/M/1.jpg",
    title: "Enjoy and Indulge",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h3>Tel Aviv - The ultimate luxury destination</h3>
					<p>
						Forget the Caribbean, Cannes or the Maldives, if it’s a luxury vacation you’re after -   Tel Aviv is the place to be! 
					</p>

					<p> 
						First of all, the city, named “the capital of cool” by the NY Times is only a few short hours away, meaning you don’t have to worry about wasting even a minute of your dream vacation on shaking off the Jet Leg.
					</p>
					<p>
						Once here, your first treat is the gorgeous year-round sunny weather – tailor-made for pleasure. 
					</p>
					<p> 
						Next – go and put your feet up and relax in the huge variety of luxury accommodations on offer – from world class 5-star hotels overlooking the beach to the numerous stunning boutique hotels in breathtaking locations all around the city. 
					</p>
                   	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/38/1.jpg"} class="img-responsive" />
					</div>
					<p>
						To complete the experience, throw on a towel and head to any of the gorgeous beaches, complete with all amenities needed for a fabulous day, not to mention the gorgeous cool waters.
					</p>
					<p> 
		 				Feeling hungry? No need to stand in line in London and Paris for their award-winning restaurants - Tel Aviv is home to famous chefs revered all over the world.  Aviv is renowned worldwide for its quality of cuisine, enjoy a huge selection of gourmet dining, from local to fusion, offered in exquisitely designed chef restaurant.  
		 			</p>
		 			<p>
						Time for some shopping – get your wallet and come check out the goodies in the local designer boutiques stores, chic upscale shops in places such as Kikar Hamedina and luxury shopping malls where you can find anything from Haute Couture to the latest international trends. 
					</p>
					<p>
						To finish off your day, grab a craft beer or a glamorous cocktail in any of the sensational nightclubs or glamourous bars around the city and dance your night away before heading off to your hotel for a well-earned 5 star slumber. 
					</p>
					<p>
						Luxury? Style? Glamour? We have it all! So hurry up and book your trip to Tel Aviv Today! 
					</p>

            	`,
      };
    },
  },

  {
    id: "Cool_Jerusalem",
    bgImage: "/posts/bank/cool-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/cool-jerusalem/M/1.jpg",
    title: "",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    smltitle: "Cool Jerusalem",
    html: function() {
      return {
        __html: `
                    <h3>A city beyond expectations</h3>
					<p>
					Jerusalem is a globally famous city and one of the most popular vacation destinations in the world. Many people visit Jerusalem every year for its historic significance, its holy sites, its beautiful and unique architecture and remarkable atmosphere. However, Jerusalem is a city of surprises and there are many things on offer in this amazing city which most people won’t associate with it immediately. Here are just some of the things you wouldn’t necessarily expect to find in Jerusalem:
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/40/1.jpg"} class="img-responsive" />
					</div>

					<h3>Summer Parties</h3>
					<p>
					Every year during the summer the center of Jerusalem becomes awash with Friday noon parties, filled with music, dancing, gorgeous people from around the world and an intoxicating off the hook party vibe to start things off with a bang and get you hot and ready for the rest of the weekend.
					</p>

					<h3>Market Madness </h3>
					<p>
					An amazing experience taking place of Thursday nights, in which the bustling day market of Machne Yehuda becomes a buzzing late night scene packed with fantastic bars and pubs and live music all night long. 
					</p>

					<h3>Festivals</h3>
					<p>
					Jerusalem is a city chalk full of festivals – from the famous film festival to the wine festival, an international puppetry festival and even a happening beer festival, whatever you’re into, you’re sure to find a festival to suit your style at taking place at some point in the city. 
					</p>
					<h3>Jerusalem Marathon</h3>
					<p>
					A fantastic and extremely popular marathon offering a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, guaranteeing a challenging, thrilling and unforgettable experience for all runners and viewers.
					</p>

					<h3>Museums and Exhibitions</h3>
					<p>
					The diverse nature of the city of Jerusalem extends to its museums and culture event showcased across the city. From the world famous Israel museum to Yad Vashem, to the memorable light and sound spectacular at the citadel and the walk on the walls, and so much more, the city is simply packed with amazing cultural experiences. 
					</p>

					<h3>The farmers’ market </h3>
					<p>Every Friday in the German Colony in the heart of the city, you can find the local farmer’s market. Offering a host of great produce and a huge variety of local delicacies and excellent bargains.</p>

					<h3>A World Class Aquarium </h3>
					<p>
					One of the largest aquariums in the middle east, this fabulous attraction for children and adults alike opened its doors to the public for the first time this year. The Aquarium is 7,000sqm in size and houses 40 marine species in 33 water tanks, the largest of which contains 1.6 million liters of water. 
					</p>
					<p>
					All these are just a small part of what this magnificent city has to offer. From culture to history, fashion to nightlife, Jerusalem is a city not to be missed!
					</p>

            	`,
      };
    },
  },

  {
    id: "Cycle_TelAviv",
    bgImage: "/posts/bank/cycle-in-telaviv/1.jpg",
    mobBgImage: "/posts/bank/cycle-in-telaviv/M/1.jpg",
    //   vidId: "88OV6xU0vPI",
    vidId: "5nqL-oIC0GA",
    isVid: true,
    ctg: "active-adventure",
    title: "Cycle Tel Aviv",
    smltitle: "",
    html: function() {
      return {
        __html: `

					<h3>Get on your bicycle - explore the city in style</h3>
					<p>
						As one of the trendiest cities in the world, it is no surprise that Tel Aviv has, in recent years, joined the trend that’s sweeping the worlds most famous cities- the bicycle trend. 
					</p>
					<p>
						Exploring the city on a bike has a variety of benefits – it is environmentally conscious, substantially reducing your carbon footprint, it saves you precious vacation time otherwise spent fighting traffic and is of course extremely healthy. Biking is a fantastic means of exercise, and as a tourist or visitor, cycling as a means of exploring the city is a fabulous way of enjoying its sights, sounds and smells up close with no interference. 
					</p>
					<p>
						Here are just some of the things that make Tel Aviv a fantastic city for cycling: 
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/41/1.jpg"} class="img-responsive" />
					</div>
					<p>
						<strong>The dedicated bike lanes:</strong> 
						The city of Tel Aviv is a strong advocate of bicycles as a means of transport and to support the cause, there are over 100km of dedicated bike lanes paved throughout the city, for the safety and convenience of the city’s cyclists. 
					</p>
					<p>
						<strong>The fantastic weather:</strong> 
						Tel Aviv enjoys fantastic weather year-round with very little rainfall, making it an ultimate city for cycling in weather enjoying the cool breeze coming off the beach on the stunning promenade or zooming down the stunning inner streets with their fabulous Bauhaus architecture.  
					</p>
					<p><strong>Tel-O-Fun:</strong> 
						the Tel o Fun is an easy, simple and cost effective municipal public bike hire system. With Tel o Fun s residents and visitors alike can pick up and drop off excellent quality bicycles using a credit card at 150 convenient stations citywide.
					</p>
					<p>
						Should you wish you can rent a bike perfect for you in any of the bike rental places all across the city. Most hotels offer a bike rental option, allowing you to explore the city on 2  wheels, just like the locals. 
					</p>
					<p>
						Best thing of all, everything in Tel Aviv is so close, you can take your bike to the beach, cycle along the stunning promenade, take your bike and go for a fantastic picnic in park Ha’Yarkon and take them on a night on the town in the fabulous clubs and bars of Dizengoff or the harbor. 
					</p>
					<p>
						Cycling has never been easier, healthier, or more fun than in the gorgeous city of Tel Aviv. 
					</p>

            	`,
      };
    },
  },

  {
    id: "TelAviv_Adventures",
    bgImage: "/posts/bank/telaviv-adventures/1.jpg",
    mobBgImage: "/posts/bank/telaviv-adventures/M/1.jpg",
    title: "Tel Aviv Adventures",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `

				    <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/42/1.jpg"} class="img-responsive" />
					</div>
                    <br/><h3>Cool things to do in the hot city</h3>
					<p>
					Tel Aviv is world famous for being the city that never stops, renowned for its amazing nightlife, the fabulous beaches, the fantastic culture and art and much more. But here are a few lesser known things you can do in the summer in the city.
					</p>
					

					<h3>Check out the Bracelet bars</h3>
					<p>
					Bracelet bars are a great way to drink the night away on a budget. Simply wend your way to one of the many bars in Tel Aviv which let you pay a fixed price in advance and drink as much as you want or as much as you can… 
					</p>
					<h3>Friday afternoons drum circles<h3>
					<p>
					Make your way to the famous Banana beach on Friday afternoons and treat yourself twice – enjoy the awesome drum session on the beach and check out the gorgeous sunset – both completely free of charge! 
					<p>
					<h3>Rooftop fun <h3>
					<p>
					Maybe it’s the weather; maybe it’s the view – one thing’s for sure, Tel Avivians love the outdoors, especially with a drink in hand. During the summer you’ll find most bars and pubs raise the roof (literally!) and turn into outdoor venues, while many bars pop up on rooftops of commercial and office buildings. To find these awesome places all you need to do is simply follow the sounds of music and fun. 
					</p>
					<h3>Outdoor fitness <h3>
					<p>
					Nothing’s more important than your health, and one of the best things you can do for your body is to give it some exercise. Tel Aviv offers some great ways to do just that – from swimming in the sea, running along the promenade, bicycling through the fabulous city streets and even getting some gym action on in any of the outdoor (free) exercise stations located around the city. 
					</p>
					<h3>Epic Summer Events <h3>
					<p>
					From world famous international artists to amazing tech, art and beer festivals, gallery openings, exhibitions, live street music, to open cinemas and beach parties that last all night, Tel Aviv in the summer is an endless source of fun and entertainment not to be missed! 
					</p>

            	`,
      };
    },
  },

  {
    id: "2_AWESOME_CITIES",
    bgImage: "/posts/bank/27/1.jpg",
    mobBgImage: "/posts/bank/27/M.jpg",
    title: "2 Awesome Cities",
    smltitle: "",
    isVid: true,
    vidId: "b0QexDxEklA",
    ctg: "telavivAndJerusalem",
    html: function() {
      return {
        __html: `

					
					<h3>One magical unforgettable getaway to the sun</h3>
					<p>
						Tel Aviv, a bustling a highly modern metropolis, boasting glistening golden beaches, a hip atmosphere and ample opportunities for fun infused with authentic Middle Eastern flavour, not to mention great food and coffee. Just forty minutes away, experience an entirely different beat and pulse: Jerusalem, a city of such unparalleled splendour, it will be easy to understand why for millennia it has been so inspirational for so many.
					</p>

					<p>
						While both Tel Aviv and Jerusalem are two busy, vital and intriguing cities that offer a multitude of must-see attractions, they couldn’t be more different. Despite their geographic proximity, they have entirely different landscapes, scents and flavours. Where else could you so easily combine the ultimate beach destination with one of the most ancient and holiest cities in history?  So here’s a sample menu of what you can do in one holiday in both cities.
						So here’s a sample menu of what you can do on a vacation in both cities.
					</p>

					<h3>Tel Aviv – the city that never sleeps</h3>
					<p>
						So you’ve landed in Tel Aviv… Experience all the excitement the first Hebrew city dishes up. Discover the stunning azure hues of the Mediterranean, the quaint spots in the White City, its markets, restaurants, special flavours and scintillating night life. Catch a few waves and see exactly why Tel Aviv is known as the non-stop city, living and breathing vitality, 24 hours a day.
						So let’s go.
					</p>
					<h3>
						Neve Tzedek:
					</h3>
					<p>
						Discover the magic of this spectacular and beautifully renovated neighbourhood, located on the southern end of the Tel Aviv Promenade, next to Jaffa. Start your morning with a culinary experience that includes a typical Israeli breakfast: delicious baked goods, eggs, cheeses and dips, green salad or chopped salad, orange juice and, of course, excellent coffee. The recommended tour of Neve Zedek takes you to historical landmarks and small, wonderful museums.
					</p>

					<h3>
						Hatachana:
					</h3>
					<p>
						After recharging, go visit Hatachana, which is close by. There you can visit renovated Templar buildings, as well as Jaffa’s old train station, completely redone. The site tells the tale of the train station, with its Jaffa-Jerusalem line, that operated here from 1892-1948.
					</p>
					<h3>
						Jaffa
					</h3>
					<p>
						Next, take a walk along the stunning Tel Aviv beach promenade to Jaffa. We recommend visiting Jaffa Port, considered to be one of the world’s most ancient ports. Lounge at one of the many cafes that dot the wharf, and watch the fisherman at work. Then, continue towards the colourful flea market, where you can treat yourself to a vintage item, Armenian ceramics, a hamsa or any of a multitude of souvenirs. At night, the area transforms itself into a bustling bar and restaurant scene.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/7.jpg"} class="img-responsive" />
					</div>
					<h3>
						Pedal down the beach:
					</h3>
					<p>
						Tel Aviv is known as Israel’s bicycle capital. On a nice day, those of you with a sporty spirit can rent a bike at a one of the Tel-O-Fun stations or any other rental spot around town. Biking from Neve Zedek to Tel Baruch beach in the northern part of the city is a phenomenally fun experience.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/2.jpg"} class="img-responsive" />
					</div>
					<h3>
						Eretz Israel Museum
					</h3>
					<p>
						If you find yourself in the northern section of town, we suggest you visit the Eretz Israel Museum. It is a multidisciplinary museum that focuses on the history and culture of Israel through permanent and temporary exhibits dedicated to archaeology, ethnography, post and philately, folklore, Judaica, traditional crafts, popular art, cultural history and local identity.
					</p>
					<h3>
						Rothschild Boulevard
					</h3>
					<p>
						Looking for an inviting location where you can enjoy a great meal? Try eating at one of the fine restaurants on or around Rothschild Boulevard, right in the heart of the city, it is one of the three zones that make up the White City, recognized by UNESCO as a World Cultural Heritage Site. This street, which perfectly defines the essence of Tel Aviv, offers you a prime opportunity for people watching. You can also take a stroll and take in the impressive Bauhaus architecture, the old kiosk and the small museums that relate the fascinating story of Tel Aviv and its first neighbourhood, Ahuzat Bayit.
					</p>
					<h3>
						Nightlife
					</h3>
					<p>
						If you plan on staying in the city, you can opt to take a room at one of the big hotels located on the beach, near the promenade, or at one of the lovely boutique hotels. If you’re still energized and raring to go, now’s the time to enjoy yourself at one of the popular bars, nightclubs, the Opera House, a dance performance or any of the many events and festivals in Tel Aviv.
						Done sampling the good life in Tel Aviv? Now enjoy the best of both worlds by heading out to Jerusalem. It’s only 40 minutes away! The Holy City awaits you!
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/3.jpg"} class="img-responsive" />
					</div>
					<h3>
						Jerusalem – the world’s most beautiful city
					</h3>
					<p>
						Discover the city most sacred to three religions: Judaism, Islam and Christianity. Visit the historic sites, breathe in the dizzying scents, taste the special dishes, inhale the clean mountain air and have fun at the many entertainment hot spots around the city.
					</p>
					<h3>
						Ein Kerem
					</h3>
					<p>
						Even before reaching the city, you can visit the picturesque neighbourhood  of Ein Kerem. Just a 20-minute drive from the city centre, it is known for its idyllic character. Nestled in greenery, Ein Kerem brings you breathtaking views, charming stone houses, churches and mosques, fascinating historical sites, enchanting alleys, galleries and special boutique shops, cafes and fine restaurants, as well as exquisite hotels, both old and new.
					</p>
					<h3>
						Bloomfield Science Museum
					</h3>
					<p>
						Jerusalem’s science museum is a magical kingdom for adults and children alike, filled with moving objects, optical illusions, electrical experiments and everything that has made our world a user-friendly place.
					</p>
					<h3>
						The Old City
					</h3>
					<p>
						At the top of any Jerusalem itinerary! The Old City of Jerusalem is, simply put, an ancient treasure trove of discovery and delight. The true essence of Jerusalem is hidden in the narrow, winding alleyways of the Old City: the special atmosphere, fascinating history and secrets are revealed among its ancient stones. Visit the Western Wall to be moved by the sanctity of the remains of the Temple and to place a note with a request to the Holy One between the stones.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/4.jpg"} class="img-responsive" />
					</div>
					<p>
						Follow in the footsteps of Jesus, down the Via Dolorosa, to the Church of the Holy Sepulchre – home to the two holiest sites of Christianity: the site where Jesus of Nazareth was crucified and the empty tomb, from which he is believed to have resurrected. Continue to Mount Zion, where you can visit the Cenacle (also known as the Upper Room), traditionally held to be the site of the Last Supper. Then, as Jesus did frequently, visit the Mount of Olives for a moment of meditation at Gethsemane, where Jesus prayed and his disciples slept the night before the crucifixion. And, ascend to the rooftop of the Austrian Hospice of the Holy Family for a truly magnificent view of Jerusalem and the Old City.
						To immerse you even deeper into the roots of ancient Jerusalem, tour the Western Wall tunnels, visit the Dome of the Rock, the holy site where Muhammad is believed to have ascended to Heaven, and the Lutheran Church of the Redeemer, home to one of the most beautiful organs in Israel.
					</p>
					<h3>
						Machane Yehuda Market
					</h3>
					<p>
						You’ve been busy today. Starting to feel hungry? Now you can visit Machane Yehuda Market – Jerusalem’s bustling and vibrant open air market. Alongside the market’s well-known stands, many cafes and upscale food shops have sprung up in recent years.
					</p>
					<h3>
						Shopping in Jerusalem:
					</h3>
					<p>
						Ready for some shopping and souvenirs? Buy Armenian ceramics or Judaica in the special and beautiful stores in the Old City. You will also find stores selling a plethora of souvenirs from Israel in the city center. You’ll find numerous clothing stores located on the Ben-Yehuda Promenade. And don’t forget to check out the second hand shops if you want to purchase something a little more authentic. What’s more, don’t miss a visit to the upscale Mamila mall, considered one of the city’s most active shopping centers.
					</p>
					<p>
						So diverse, so distinct and any yet just a short commute apart, Jerusalem and Tel Aviv make the perfect destination package. Together, they bring you history and modernity, ancient artifacts and modern arts, fun in the sun and the most spiritual journey of your life. It doesn’t get any better than that! So what are you waiting for? Book your vacation now!
					</p>


           `,
      };
    },
  },

  {
    id: "Jerusalem",
    bgImage: "/posts/bank/jerusalem-p/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-p/M.jpg",
    title: "Jerusalem",
    smltitle: "",
    isVid: true,
    vidId: "FvAWuLQEOJw",
    ctg: "general",
    html: function() {
      return {
        __html: `

					<h3>A CITY OF MAGIC AND RADIANCE BEYOND YOUR WILDEST DREAMS</h3>
					<p>Jerusalem is The Capital of Israel and By Far One of The Most Famous and Fascinating Cities in the World, Where Thousands of Years of Glorious History Seamlessly Intertwine with Modern Day Life.</p>
                              
                                <p>Discover the overwhelming power of this 3,000 year old city - its innumerable historic sites and archeological wonders, its magical walkways and magnificent views which are guaranteed to leave a lasting impression. At the same time, the city’s strikingly modern attractions promise around the clock excitement and pleasure for all lovers of culture, arts, music, and culinary delights.</p>

                                <h3>Walk through 3000 years of history</h3>

                                <p>The Old City of Jerusalem is a favourite for all visitors from first timers, seasoned visitors as well as the locals. Surrounded by an ancient wall that has been rebuilt throughout history, there are 7 gates allowing access to historical and holy sites here. Make your way down the stone cobbled streets and find yourself walking through four thousand years of history, leaving you humbled and yet excited as you connect the modern day present with the simple beginnings of the past.</p>
                              
                                <h3>Meet the modern vibrant Jerusalem</h3>

                                <p>Step outside of the Old City and find everything that a typical modern city offers including hotels, promenades, restaurants and shopping malls. Visit museums, like the Israel Museum which is the largest cultural institution in Israel and ranked among the world’s leading art and archaeology museums housing the infamous Dead Sea Scrolls (oldest biblical manuscripts) among other treasures. Local farms, wineries and breweries are set up around Jerusalem offering a variety of options to foodies ranging from the traditional Israeli cuisine to the contemporary and fusion fare paired with delicious award-winning wines and beers attracting enthusiast from all over the world.</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Jerusalem-p/1.jpg"} class="img-responsive" />
							    </div>
                                <p>Visit Mahane Yehuda, a colourful and vibrant outdoor market with an attractive vibe filled with culture and delicious aromas of the delicacies sold here. Wait till sundown and see this ‘shuk’ transform into a trendy hangout with live music to suit every mood accompanied with energetic people, a growing ‘street-art’ gallery exceptional food and delightful drinks. Mahane Yehuda offers a special experience so walk down the streets, stop by a food joint, dance a little while enjoying a drink and make your way to the next spot.</p>

                                <p>Drenched in art, history, culture and diversity the capital city of Israel loves to have a good time while allowing one to experience the contrast between old world historical charm and modern city living. As you drive in to Jerusalem you can’t help but connect with the culture, archaeology and history of the many nations who have walked through here, where old meets new beyond the walls of the Old City in this unique world capital.</p>
                                
				


           `,
      };
    },
  },

  {
    id: "Magical_Deadsea",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "THE MAGICAL DEAD SEA",
    smltitle: "",
    isVid: true,
    vidId: "8p4qfkneH1c",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
							    <p>
									<strong>Relax in the "Salty Goodness" of the Dead Sea and Experience an Unforgettable Reviving Vacation</strong>
								</p>
								<p>
									With breathtaking natural beauty, soothing rich mineral Spas, proved healing qualities and many unique experiences, it's no wonder the Dead Sea became one the world's prominent tourist destinations. This mysterious salty lake is all you need for a perfect mind-body holiday experience.
									<strong>Relax.</strong> Salt, mud, sun…and there's more. Soak up in natural (hot) sulfurous springs and enjoy Spa treatments. Familiar with the phrase "guilty pleasure?" It doesn't apply here. Take the "guilty" out and simply enjoy a healthy revitalizing relaxing vacation.
								</p>
								
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Magical-Deadsea/1.jpg"} class="img-responsive" />
							    </div>
								<p>
									<strong>Let Go and Enjoy One of Nature's Most Wondrous Gifts</strong>
								</p>
								<p>
									<strong>Float.</strong> Thanks to the exceptional high level of saline in the water you will be able to perform a small "miracle" by, fine, not walking but naturally floating on water. Get in the water, lean back and let nature take its course. It may take a minute to get used to but then, we promise, it's magical.
									<strong>Heal.</strong> Entering the Dead Sea area feels like stepping into a different world. Different view, different pace, different air and even a different sun.
									The last two are the results of the special geological conditions of the area and the primary reasons for the area's healing powers.
									The Atmosphere is different because the sea saline dissolves into healthy rich minerals you absorb through the air. The sun is different because the location, so low below sea level, weaken and filters the harmful UV rays. Step outside and enjoy nature's wondrous gifts.
								</p>
								<p>
									<strong>Discover the Child in You and Let Nature Heal You</strong>
								</p>
								<p>
									<strong>Get Muddy –</strong> The Dead Sea mud has proven health benefits. It improves, revitalize and provides relief for your skin. You can buy and use it at home, but why miss out on the opportunity to channel your inner child? Cover yourself with that black mud head to toe and simply have fun. We dare you to take a selfie.
									<strong>Repeat</strong>
								</p>
                               


           `,
      };
    },
  },
  {
    id: "Next_Level_DS",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "TAKE RELAXATION TO THE NEXT LEVEL",
    smltitle: "",
    isVid: true,
    vidId: "8p4qfkneH1c",
    ctg: "general",
    html: function() {
      return {
        __html: `

					
					
                     <p>
					The Dead Sea, officially The Lowest Place On Earth (428m Below Sea Level) And A Shortlist Candidate For The World’s 7 Natural Wonders, Is An Enthralling And Evocative Combination Of Natural Splendor, Compelling Ancient History And Modern Luxuries.
				</p>
				<p>
					From the healing powers of the Dead Sea’s cobalt blue waters, through the awesome beauty of the surrounding landscape to the myriad of fascinating sights this area has to offer, the Dead Sea is a place of tranquility, health and inspiration for body and soul alike.
				</p>
				<p>
					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions. Along the main part of the 75 kilometer stretch dotted with beautiful beaches, you will also find world class hotels and spa facilities to guarantee a truly indulgent experience.
				</p>
				
				<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/next-level/1.jpg"} class="img-responsive" />
				</div>
				<p>
					The Magical Beaches of the Dead Sea
				</p>
				<p>
					The beaches of the Dead Sea are like nothing else the world has to offer. There are many kilometers of beautifully developed and well-maintained spots where you can soak up the sun while on your dream vacation. Choose your spot on the rocky sand and take in the breathtaking scenery with the incredible mountain ranges surrounding the sea. The warm waters of the Dead Sea are always calm and offer superior relaxation from the minute you get in.
				</p>
				<p>
					On the southern shores at the lowest point on earth, you will find an array of hotels where you can enjoy a magical sunrise over the lake, leaving an array of colors on the small ponds with the salt formations scattered throughout. To complete the experience of being at the Dead Sea, take some of the silky dark mud and lather it on allowing your skin to absorb the helpful minerals. Dead Sea mud has been proven beneficial to the skin and body. You will feel refreshed with skin that looks and feels younger. Give yourself the pampering that you deserve and get dirty with the Dead Sea mud – it’s healthy!
				</p>
				<p>
					Discover the desert area around the Dead Sea
				</p>
				<p>
					There is more to do than just relaxing in the spas and floating in the Dead Sea. If you are travelling south from Jerusalem, complement your desert experience by stopping at kibbutz Ein Gedi, a natural oasis on the slopes of the Judean desert, and take a hike through a nature reserve where you will see wildlife like the ibex (a kind of mountain goat) and enjoy the waterfalls and pools cascading on the rock formation. Ein Gedi also offers hotel accommodations and spas which houses hot sulphur pools and have different types of healing and therapeutic massages too. Continue south from here to Masada, a national landmark with a strong historical connection, located at the top of a massive mountain that the adventure seeker can hike, or it can be reached comfortably by cable car.
				</p>
			       


           `,
      };
    },
  },
  {
    id: "Natures_Glory",
    bgImage: "/posts/bank/natures-glory/1.jpg",
    mobBgImage: "/posts/bank/natures-glory/M.jpg",
    title: "NATURE'S GLORY",
    smltitle: "",
    isVid: true,
    vidId: "M627s8TdaB8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
			    <p>
					Get high on life in the lowest place on earth
				</p>
				<p>
					The Dead Sea, officially the lowest place on earth (428m below sea level) and one the world’s natural wonders, is an enthralling and evocative combination of natural splendor, compelling ancient history, and modern luxuries.
				</p>
				<p>
					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions.
				</p>
				<h3>
					NEW BOARDWALK AT THE DEAD SEA
				</h3>
				<p>
					Just in time for the Passover and Easter holidays, a new, stone 4k boardwalk and free, accessible public beaches with full facilities have opened in the hotels area of the Dead Sea. The promenade will eventually extend another ten kilometers, to include a total of 16 public beaches, connecting Ein Bokek and Hamei Zohar, along the southern part of the Dead Sea. This is part of a major new leisure and hotel complex that is planned for the region.
				</p>
				<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/natures-glory/1.jpg"} class="img-responsive" />
				</div>
				<p>
					Visitors to the Dead Sea - the lowest place on earth and the world’s largest natural spa known for its unique wellness properties since Biblical times – can now enjoy full access to wide, sandy beaches, walking, jogging, cycling or even taking a Segway along the entire length of the new boardwalk. The new beaches are all free to the public, with facilities that include beach chairs, showers, canopies, sports equipment, children’s playgrounds and more.
				</p>
				<p>
					The beaches are accessible for the disabled, with special wheelchairs and trails that can take visitors right into the waters of the Dead Sea. Special illumination allows tourists and visitors to walk the boardwalk at night, while at the same time enjoying the very special atmosphere at the Dead Sea.
				</p>
                               


           `,
      };
    },
  },
  {
    id: "Natural_Spa",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "THE DEAD SEA NATURAL SPA",
    smltitle: "",
    isVid: true,
    vidId: "8p4qfkneH1c",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
				    <p>
						The Dead Sea, officially The Lowest Place On Earth (428m Below Sea Level) And A Shortlist Candidate For The World’s 7 Natural Wonders, Is An Enthralling And Evocative Combination Of Natural Splendor, Compelling Ancient History And Modern Luxuries.
					</p>
					<p>
						From the healing powers of the Dead Sea’s cobalt blue waters, through the awesome beauty of the surrounding landscape to the myriad of fascinating sights this area has to offer, the Dead Sea is a place of tranquility, health and inspiration for body and soul alike.
					</p>
					<p>
						Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions. Along the main part of the 75 kilometer stretch dotted with beautiful beaches, you will also find world class hotels and spa facilities to guarantee a truly indulgent experience.
					</p>			

					<div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/posts/natural-spa/1.jpg"} class="img-responsive" />
					</div>

					<p>
						The Magical Beaches of the Dead Sea
					</p>
					<p>
						The beaches of the Dead Sea are like nothing else the world has to offer. There are many kilometers of beautifully developed and well-maintained spots where you can soak up the sun while on your dream vacation. Choose your spot on the rocky sand and take in the breathtaking scenery with the incredible mountain ranges surrounding the sea. The warm waters of the Dead Sea are always calm and offer superior relaxation from the minute you get in.
					</p>
					<p>
						On the southern shores at the lowest point on earth, you will find an array of hotels where you can enjoy a magical sunrise over the lake, leaving an array of colors on the small ponds with the salt formations scattered throughout. To complete the experience of being at the Dead Sea, take some of the silky dark mud and lather it on allowing your skin to absorb the helpful minerals. Dead Sea mud has been proven beneficial to the skin and body. You will feel refreshed with skin that looks and feels younger. Give yourself the pampering that you deserve and get dirty with the Dead Sea mud – it’s healthy!
					</p>
					<p>
						Discover the desert area around the Dead Sea
					</p>
					<p>
						There is more to do than just relaxing in the spas and floating in the Dead Sea. If you are travelling south from Jerusalem, complement your desert experience by stopping at kibbutz Ein Gedi, a natural oasis on the slopes of the Judean desert, and take a hike through a nature reserve where you will see wildlife like the ibex (a kind of mountain goat) and enjoy the waterfalls and pools cascading on the rock formation. Ein Gedi also offers hotel accommodations and spas which houses hot sulphur pools and have different types of healing and therapeutic massages too. Continue south from here to Masada, a national landmark with a strong historical connection, located at the top of a massive mountain that the adventure seeker can hike, or it can be reached comfortably by cable car.
					</p>
                               


           `,
      };
    },
  },
  {
    id: "Natural_Phenomena",
    bgImage: "/posts/bank/natural-phenomena/1.jpg",
    mobBgImage: "/posts/bank/natural-phenomena/M.jpg",
    title: "NATURAL PHENOMENA",
    smltitle: "",
    isVid: true,
    vidId: "8p4qfkneH1c",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
                        <p>
							The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
						</p>
						<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/natural-phenomena/1.jpg"} class="img-responsive" />
					    </div>
						<p>
							This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
						</p>
						<p>
							The Dead Sea is lined with spas, bathing beaches and spa hotels.
						</p>          


           `,
      };
    },
  },
  {
    id: "Masada",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "MASADA",
    smltitle: "",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    ctg: "general",
    html: function() {
      return {
        __html: `

					
					
                    <p>        	
				Next to the Dead Sea is a site that, unlike the rest of the landscape, appears to be part of the Rift Valley cliff but is in fact an oval-shaped flat-topped mesa – a mountain completely surrounded by a virtually sheer drop. In the days before helicopters and drones, this was about as secure a site as could be found for King Herod to build himself a palace fortress to which he could retire in the case of emergency. (And, as it was adjacent to the Dead Sea it was convenient for a monarch who historians tell us had a “chronic skin ailment” - possibly psoriasis.) The splendor of Masada was epic. It was also a marvel of engineering that used artificial water courses to channel the desert’s rare rainfall into giant cisterns where, despite the 120°-Fahrenheit heat, they could make and store ice.
			</p>			
			<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/masada/1.jpg"} class="img-responsive" />
							    </div>
			<p>
				After Herod’s death the site was all-but abandoned…until the year 73. After the Romans destroyed Jerusalem in 70 and expelled Jews from their holy city, a group of Jewish refugees made their way to the summit of Masada and converted the once grand palace into their home. Having no interest in the palace’s grandeur and considering themselves zealots, the refugees built a synagogue, created a mikveh, planted crops and tended goats. The Romans, however, could not tolerate their defiance and went on to besiege the mountain for three years, condemning thousands of legionnaires to camp in the extreme heat in a quest to starve the mountaintop inhabitants into surrender. (The outlines of the Roman encampments are clearly visible to this day.) Thousands of Jewish slaves were forced to build a giant ramp to the summit and after the months it took to complete the  construction, the mountaintop zealots -- realizing that the next day would bring Roman soldiers into their hideout -- determined to commit mass suicide rather than have their their wives, children and themselves murdered or enslaved. When the Romans finally battered their way onto the mountaintop they met no resistance and discovered 960 corpses. Two women who had hidden themselves from the mass suicide shared details of the events with the “conquerors” and Jewish Roman historian, Josephus, told the story of Masada in his book “The Jewish Wars.” The pledge by the zealots’ leader, Elazar Ben Yair on the last night of freedom has entered immortality: “Since we long ago resolved never to be servants to the Romans, nor to any other than to God Himself, Who alone is the true and just Lord of mankind, the time is now come that obliges us to make that resolution true in practice...We were the very first that revolted, and we are the last to fight against them; and I cannot but esteem it as a favor that God has granted us, that it is still in our power to die bravely, and in a state of freedom.” The Byzantines built a church atop Masada in the 4th-century, but it and the mountain went on to be abandoned for centuries.
			</p>
			<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/masada/2.jpg"} class="img-responsive" />
							    </div>
			<p>
				In 1964. Israel’s Professor Yigal Yadin lead a two-year international excavation to discover Masada’s secrets. Their hundreds of discoveries support Josephus’ history, with the archeologists even finding the clay tokens on which the zealots had carved names and used as lots to decide who would “euthanize” their families and themselves first…and last.
			</p>
			<p>
				The story of what occurred two millennia ago atop Masada has become a symbol of Israelis’ commitment never to allow “Masada to fall again” and, fifty years after the excavation, Masada is, after Jerusalem, the most visited site in Israel. Access to the summit on foot is possible up the traditional snake path used by Herod, and up the Roman ramp.  But the majority of the millions of tourists who visit Masada are whisked from the Masada Museum and Visitors Center to the summit in giant cable cars that operate daily with the exception of Yom Kippur. Every June, the base of Masada becomes the site of giant Opera Festival and spectacle that uses the floodlit mountain as a backdrop.
			</p>          


           `,
      };
    },
  },

  {
    id: "Tel_Aviv",
    bgImage: "/posts/bank/telaviv-p/1.jpg",
    mobBgImage: "/posts/bank/telaviv-p/M.jpg",
    title: "TEL AVIV",
    smltitle: "",
    isVid: true,
    vidId: "I9a4BFWO_6w",
    ctg: "general",
    html: function() {
      return {
        __html: `
			                    <p>Hailed as ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’, Tel Aviv is without a doubt THE place to visit in the Mediterranean.</p>
								<p>Named by The New York Times "The Mediterranean Capital of Cool", Tel Aviv is a modern, vibrant cosmopolitan. Buzzing art scene, UNESCO recognized Bauhaus architecture, award-winning cuisine, world-class nightlife, friendly laid-back atmosphere and gorgeous beaches all earned the city its rightful place as one of the world's top travel destinations.</p>

                                <p>But even in the city that has it all, there is only one place to start - the beach.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/telaviv-p/1.jpg"} class="img-responsive" />
							    </div>
								<h3>Discover the Heart of a Sizzling City</h3>

                                <p><strong>What.</strong> The heart of the city National Geographic called "Miami beach of the Mediterranean" and included in its top 10 world's best Beach Cities list, is its coastline.</p>

                                <p><strong>Why.</strong> Sandy beaches, warm waters, plenty of watersports opportunities and great weather, need we say more? Tel-Aviv coastline is comprised of 13 unique beaches that each gives different view and offers a different experience. From the busy and trendy to the chill and laid-back, together they form a rich, colorful tapestry of this exciting and diverse city.</p>

                                <p><strong>Where.</strong> Located at the western edge of the city, in Tel-Aviv you're always one step away from the beach. No need to resist the temptation. Just cross the street, take off your shoes and start having fun.</p>

                                <h3>Choose your own Beach Adventure</h3>

                                <p><strong>Get Active.</strong> Beach and watersports are very popular in Tel-Aviv. Surfing, sailing, rowing, swimming, Supping, diving, volleyball – the list of possibilities goes on and on.</p>

                                <p>Choose your favorite activity and enjoy. Then, when you the click-clock sound of the Matkot on the beach, join the masses in this hugely popular Israeli paddle ball game. There are no winners or losers here, but it's still fun…and very addictive.</p>

                                <p><strong>Sign up</strong> for the SAIL TLV sailing tournament that takes place in the spring and includes sailing yachts, motor yachts and motor boats from all around the world. Enjoy the sports activities and the wonderful embracive community.</p>

                                <p>Want more? Join the locals and bike, walk or jog on the promenade.</p>

                                <p><strong>Get Social.</strong> Build castles in sand with your family, take your dog for a walk and mix with the friendly diverse crowd.</p>

                                <p><strong>Get Chilled.</strong>  Want to slow down and relax? No problem! Find a quiet spot in one of the less crowded beaches, watch (or join) the drum circles and sit at one of the restaurants along the coast. In the afternoon, get close to the water, grab a chair, sit back and watch one of those beautiful Tel-Aviv sunsets. It doesn't get better than this.</p>
            	      


           `,
      };
    },
  },

  {
    id: "Simply_Delicious",
    bgImage: "/posts/bank/simply-delicious/1.jpg",
    mobBgImage: "/posts/bank/simply-delicious/M.jpg",
    ctg: "culinary",
    isVid: true,
    // vidId: "n4kCnPXEX7g",
    vidId: "JQD9JpMaw9g",
    title: "A Foodie’s Paradise",
    smltitle: "",
    html: function() {
      return {
        __html: `

                     <h3>Come Check Out Tel Aviv’s Fantastic Culinary Scene</h3>
					
					
					<p>If you’re a Foodie (and let’s face it, most of us are) you simply have to get a taste of Tel Aviv.</p>
					<p>Israeli chefs have become famous around the world for their innovative dishes. Therefore, if their dishes are amazing you can expect no less than that from the Tel Aviv culinary scene, as it is absolutely exploding with different and interesting flavors.</p>
					<p>With around 4500 eateries, Tel Aviv is a true foodies' heaven. Many of the restaurants are owned by brilliant worldwide acclaimed chefs, who trained and worked in some of the best establishments around the world before returning to Israel to put their unique mark on the local culinary scene.</p>
					<p>Some of the city’s most cutting-edge cuisine can be found at Sarona Market compound - originally a German Templar Colony; This 8,700 m2 compound has been meticulously restored and is now home to restaurants, where you can experience new dishes that are not only mouth-watering but also exceptionally original, as well as shop around or have a lovely outdoors picnic.</p>
                    <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/simply-delicious/1.jpg"} class="img-responsive" />
							    </div>
					<p>Tel Aviv’s cuisine has something to suit every palate. Named ‘Top vegan destination’ by the US foodie website, The Daily Meal, Tel Aviv has around 400 vegan friendly restaurants as well as excellent traditional street food, which are also vegan like Falafel and Hummus, a variety of delicacies in the local markets.</p>
					<p>For a fantastic culinary experience, check out the trendy restaurants at the Port of Tel Aviv, on Rothschild Avenue, in Neve Tzedek or in the stunningly renovated ‘Tachana’ complex.</p>


         `,
      };
    },
  },

  {
    id: "Nonstop_Excitement",
    bgImage: "/posts/bank/35/1.jpg",
    mobBgImage: "/posts/bank/35/M.jpg",
    title: "Tel Aviv: Nonstop excitement.",
    vidId: "88OV6xU0vPI",
    isVid: true,
    smltitle: "",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
                    <h3></h3>
					<p>
					Energetic, inspirational or funfilled relaxation - Your holiday in the vibrant city of Tel Aviv can be
					anything you want it to be. With great weather virtually all year round, you can chill on dazzling
					stretches of golden beaches, take in the colorful markets, cutting edge culture and entertainment,
					outstanding nightlife and an exciting culinary scene. You can also enjoy simply making your way through the streets with their fascinating Bauhaus buildings and just feel the city’s unique ‘non-stop’ vibe, which has made it one of the trendiest destinations for tourists worldwide.<br>
					So get energized, get inspired, get ready – you’re gonna fall in love with Tel Aviv!

					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/3.jpg"} class="img-responsive" />
					</div>

					<h3>
					NON-STOP Tel Aviv<br> Ultimate Beach Fun
					</h3>

					<p>
					Voted National Geographic Magazine “One of the ten best beach cities in the world” - with clear waters and action-packed beaches, each one of Tel Aviv’s 16 beaches has its own style and attracts certain personalities - from hippie casual to Riviera chic. Day or night, hanging out on the beach is one of the best ways to spend the time in Tel Aviv.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/2.jpg"} class="img-responsive" />
					</div>
					<h3>
					Sensational Nightlife
					</h3>
					<p>
					The Israeli weekend starts on Thursday evening and continues until nearly the crack of dawn on Sunday—when the work week resumes. But pretty much every night is “party night” in Tel Aviv. The city that doesn’t stop keeps going all night long and is constantly buzzing with trendy, vibrant hotspots, home to some of the most epic clubs and parties in the world.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/4.jpg"} class="img-responsive" />
					</div>


					<br>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/5.jpg"} class="img-responsive" />
					</div>

					<br>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/6.jpg"} class="img-responsive" />
					</div>

					<br>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/7.jpg"} class="img-responsive" />
					</div>

         `,
      };
    },
  },

  {
    id: "Vegan_Friendly_TelAviv",
    bgImage: "posts/bank/8/1.jpg",
    mobBgImage: "posts/bank/8/M.jpg",
    title: "Vegan-Friendly Tel Aviv",
    ctg: "culinary",
    isVid: true,
    // vidId: "prLvetkAWwg",
    vidId: "9l04RfZ95J0",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                     <br/><h3>Try this selection of top vegan restaurants in Tel Aviv</h3>
					<h3>Exploring Tel Aviv has never been so fun for vegans, or so yummy</h3>
					<p>Touring foreign cities can be rough on vegans, who adhere to a diet free of animal-based dishes. Not so in Tel Aviv, home to an all-vegan culinary school and scores of vegan-friendly eateries. Already a culinary hotspot for touring foodies and crowned “The World’s Best Culinary City” by Saveur Magazine, Tel Aviv has embraced veganism as it grows in popularity, leading The Daily Meal culinary magazine to declare the city “The World’s Best Vegan Destination,” ahead of eight other “vegan-friendly cities” as well.</p>
					
					<h3>What vegans want</h3>
					<p>Stroll through the city of Tel Aviv and you will stumble upon countless vegan and vegan-friendly restaurants, bistros and fast food stands. Take in the sweet and savory aromas wafting through the city air and know that nearby is a yummy treat you can most proxcbably eat. Keeping up with the tastes and demands of Tel Aviv locals and tourists, most of the city’s eateries- or at least those with any ounce of self-respect, have vegan-friendly options interspersed throughout their menus. Others have shifted to an entirely vegan spread, offering up a spin on local delicacies like egg-free falafel, seitan shawarma and dairy-free cheese pizza.</p>
					
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/6/2.jpg"} class="img-responsive" />
					</div>
                    <h3>Taste the fresh Mediterranean flavors</h3>
					<p>Breathing in the fresh Mediterranean air give you an appetite for some fresh local treats? For vegans touring Tel Aviv, your stomach grumbling is but an arrow pointing you in the direction of some of the freshest local produce transformed into scrumptious dishes reflecting many different cultures, culinary directions and trends.</p>
					
					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/6/3.jpg"} class="img-responsive" />
					</div>
                    <p>Israel is blessed with many vegan dining options, but when it comes to vegan eateries, Tel Aviv is a true vegan culinary gem. Whether it’s fast food, a gourmet menu or sweet desserts you are craving, Tel Aviv has a vegan option for you, making the seaside Israeli city a must-visit destination on your next Israel trip.</p>
					<p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in Tel Aviv &amp; Center at Tourist Information site</a></p>



			`,
      };
    },
  },

  {
    id: 13,
    bgImage: "/posts/bank/28/1.jpg",
    mobBgImage: "/posts/bank/28/M.jpg",
    title: "Jerusalem Cuisine",
    ctg: "culinary",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>Exhilarating and diverse and oh so yummy</h3>

					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/2CSCe2WC7Ns/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<p>
						Jerusalem is filled with scores of lively and trendy restaurants and entertainment spots. The city is packed with areas offering excellent options for every form of day and night time entertainment, where you can enjoy a delightful evening over a great meal, a cold beer or dance to great music.
					</p>

					<p>
						In Jerusalem, they say that you come for the hummus, but stay for the incredibly diverse cuisine. From traditional Middle Eastern and North African to South American, Asian fusion, and continental European cuisine; from street food to fine dining, Jerusalem’s got it all. Jerusalem’s wide array of culinary options can be found literally everywhere local delicacies in street stalls, authentic restaurants in the markets, and if you are looking for the gourmet experience, you can reserve a spot at one of the city’s many exclusive chef restaurants.
					</p>

         `,
      };
    },
  },

  {
    id: "Coffee_In_TelAviv",
    bgImage: "posts/bank/42/1.jpg",
    mobBgImage: "posts/bank/42/M.jpg",
    title: "Coffee in Tel Aviv",
    ctg: "culinary",
    isVid: true,
    vidId: "rVr0gqFC364",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			            
			            <br/><h2 >Coffee shop culture is fundamental to Tel Aviv, so slow down the pace and soak up the vibe</h3>
			            <h3>
                      		The Cafe Culture
                      	</h3>
                      	<p>
                      		If you want to experience the ‘real Tel Aviv’, there’s no better way than to join the local coffee shop tradition. You could drink in one of the many trendy tourist coffee places, but why not step off the beaten track to feel the rhythm of regular life in a small local coffee shop? Watch the morning rush flow around you, or join the Tel Aviv residents who fill street-side cafes in the evenings to enjoy the cool breeze, chat and, of course, have a coffee. You’ll want to linger at your table, so take advantage of the range of delicious foods that are served in every coffee shop. Some will delight you with rich European pastries, while others serve full meals that draw on a range of tastes and cultures.
                      	</p>
                      	<p>
                      		Tel Aviv is full of great places to drink coffee, each one with a different vibe. Sip an iced coffee by the beach as you soak up the sun, mingle with the locals in a sleek coffee shop among the famous Bauhaus buildings in trendy Neve Tzedek or relax with a latte at the revived Tel Aviv port. Watch the energetic bronzed joggers, bikers and rollerbladers surge past while you take some time out to savor life - and good coffee. 
                      	</p>
						<div class="img-wrapper">
						    <img src=${getImgUrl() +
                  "posts/coffe-in-tlv/1.jpg"} class="img-responsive" />
					    </div>
						<h3>
							Coffee Time
						</h3>
						<p>
							In Tel Aviv, you won’t just drink different types of coffee, you’ll absorb different worlds and traditions. Your morning joe could be a modern and trendy ‘cafe hafuch’ - the Israeli version of cappuccino made with a shot of espresso poured into steamed milk that’s drunk by cool young Tel Aviv-ians. For your mid-morning coffee break, let a pot of traditional Turkish coffee, hot, dark and strong, take you to a different world just a few minutes away in Old Jaffa. The aroma and the atmosphere will transport you through the years to the smells and flavors of the old Middle East. Finally, join the Mediterranean custom of an evening coffee at an outdoors table on Rothschild Boulevard with the sabras.
						</p>
						<p>
							It’s never a bad time for a coffee in Tel Aviv.
						</p>
              
			`,
      };
    },
  },

  {
    id: "Non_Stop_Markets",
    bgImage: "posts/bank/non-stop-markets/1.jpg",
    mobBgImage: "posts/bank/non-stop-markets/M.jpg",
    title: "Non Stop Markets",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			                 <p>A tour of the markets in Tel Aviv, with their unparalleled human tapestry and never-ending variety of delicacies is probably one of the best ways to get to know the true local spirit of Tel Aviv.<br>
                             Here are some of the markets that are definitely a must, when visiting the sunny city:</p>

                             <h3>Carmel Market:</h3>
                             <p>The city’s most famous market, renowned for its colorful spirit and food stalls, featuring fresh local delicacies and excellent restaurants serving fresh food straight from the market. You can also find hidden food placed behind the stalls and around the area. They are really worth finding. <br>
                             <h3>The Flea Market:</h3>
                             <p>Located in Jaffa, packed with fantastic authentic antiques from Tel Aviv and Jerusalem, a joy to bargain hunters. This market is also home to many fashionable and excellent cafés and restaurants of all varieties of cuisines: from Greek, to Italian, to Arabic.<br>
                             <div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/non-stop-markets/1.jpg"} class="img-responsive" />
					         </div>
                             <h3>Nahalat Binyamin Arts & Crafts Market: </h3>
                             <p>Open on Tuesdays and Fridays, this is a ‘fair-like’ artists’ market, rich with creative and original ideas for gifts. It is just the place to pick up that perfect souvenir you won’t find in any store.<br> 
                             <h3>Sarona Market</h3>
                             <p>Offering a unique and fabulous culinary adventure, Sarona Market is located in the Trendy Sarona Complex, and is home to a modern and vibrant “food court” which offers a huge assortment of culinary options. Sarona is also extremely family friendly, filled with outdoor activities and fantastic playgrounds. <br>
                             <h3>Tel Aviv Port Market</h3>
                             <p>With more of a Farmers Market feel, this seaside Market is packed with tasty treats and specialty produce which you can enjoy, on the spot of take home as culinary souvenirs.<br>

              
			`,
      };
    },
  },

  {
    id: "Joys_Of_Jaffa",
    bgImage: "posts/bank/joys-of-jaffa/1.jpg",
    mobBgImage: "posts/bank/joys-of-jaffa/M.jpg",
    title: "Joys of Jaffa",
    ctg: "telaviv",
    isVid: true,
    // vidId:"LLOUxE-K_9Y",
    vidId: "tgF0zMUYY2g",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			            <p>Recently named among CNN Travel’s must visit places for 2019, Jaffa is Tel Aviv’s smaller sister, and even though it dates back thousands of years, a visit to Old Jaffa always feels like an exciting discovery. A tour of Jaffa reveals charming winding alleyways interspersed with art galleries, historic buildings, newly renovated hotels in extraordinary landmark areas and a multitude of quaint authentic restaurants.</p>

                        <h3>Jaffa Flea Market</h3>
                        <p>Located in Jaffa, the famous flea market is a pure delight for the bargain hunters among you, packed with great authentic antiques. The flea market has been experiencing a recent bloom, and is considered a nightlife hub, featuring trendy bars and cool outdoor eateries, packed with young party people until the (very) late.</p> 

                        <h3>Jaffa Port </h3>
                        <p>Considered one of the world’s most ancient ports, the Port of Jaffa served fishermen, sailors, merchants, crusaders, conquerors and immigrants for thousands of years. Today, the port continues to serve as a fishing port, and is also being renovated as an urban attraction that offers cultural and leisure activities, shopping and tourism, while preserving its unique historical and fascinating character.</p>

                        <h3>Around Jaffa </h3>
                        <p>A stone’s throw away from Jaffa you can find the HaTachana complex, Tel Aviv’s renovated Old Railway is now a now vibrant tourist hub and an attractive site in itself and also lovely Neve Tzaedek  neighborhood, perfect for a leisurely stroll. Jaffa also boasts stunning beaches and fantastic restaurants serving a variety of fantastic local cuisine at affordable prices.  </p>
                        
                        <h3>Colorful History and Irresistible Levantine Charm</h3>
                        <p>The smells of the sea flavored with black coffee and spices from the markets, Levantine culture combined with European, ancient mixed with new – this is Jaffa. One of the oldest port cities in the world whose history dates back to the great flood, today's Jaffa is a vibrant city that never ceases to surprise and innovates. Picturesque alleys, art galleries, unique boutiques, ancient building, wonderful landmarks and an abundant of authentic middle-eastern restaurants – a trip to old Jaffa is a must-have multi-sensory stimulating experience for anyone visiting Israel. Prepare to fall in love.<br>  </p>
                        <h3>Discover the magic of a vibrant Port City</h3>
                        <p>Situated on a hill overlooking the Mediterranean Sea, in the southern part of Tel-Aviv, Jaffa has been the center of historical events for thousands of years. Still an active port today the Jaffa Port is a great place to explore. Wander through the art galleries, shopping boutiques and gourmet food markets. Stroll by the old docks, listen to live music, drink, eat and absorb the special atmosphere.<br><br>To get a better view of the city, climb up the hill to Peak (Ha'Pisga) Park overlooking the bay and gaze at the beautiful city below. On your way down, make a wish at the Wishing Bridge. Who know, it may come true.</p>
                        <h3>Go on A Romantic urban adventure</h3>
                        <p>Jaffa streets are full of surprises. Stroll in the narrow stone-paved streets of old Jaffa, discover hidden courtyards and notice the small details – painted ceramic tiles, small sculptures and upper open terrace. See the people, enter the art galleries, artists' studios and unique boutique.<br><br>Keep exploring. From the Clock tower square at the heart of the city continue to the well-known Jaffa Flea Market and weave your way through daily basics and hidden treasures. It's time to test those bargaining skills. Enjoy the small quaint cafés, middle-eastern authentic restaurants, great bar and some of best hummus you ever tasted. Guaranteed.</p>
					
                        <p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in </a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">Tel Aviv &amp; Center</a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> at Tourist Information site</a></p>
					
              
			`,
      };
    },
  },

  {
    id: 22,
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "Shakshuka Time",
    smltitle: "",
    isVid: true,
    vidId: "n4kCnPXEX7g",
    html: function() {
      return {
        __html: `

				<h3>Learn how to make the world famous Shakshuka Dish!</h3>

		<!--<div class="responisve-iframe">
			<iframe src="https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
		</div>-->

      		<p>
      		When you ask people who visit Tel Aviv and Jerusalem what was their favorite dish they tried on their trip, the answer, more often than not, will be Shakshuka. This Mediterranean delicacy, a definite local favorite is essentially a dish of eggs poached in a sauce of tomatoes, chili peppers, and onions rich in flavor and often served with bread and tahini. Of course, there are many variations on this dish according to local styles and tastes and it is usually served for breakfast or brunch though you’’ll find it makes for a fantastic dinner as well.
      		</p>
      		<p>
      		The best way to eat Shakshuka is definitely by under the fantastic year round sun of Tel Aviv or Jerusalem, as you enjoy an amazing city break full of flavors and unforgettable experiences.
      		</p>
      		<p>
      		However, should wish to DIY and recreate the taste of the sensational Shakshuka in your own kitchen, here’s how it’s done:
      		</p>
      		<h3>
            Ingredients
          </h3>
          <ul>
             <li>2 tablespoons olive oil</li>
             <li>1 onion, chopped</li>
             <li>1 red bell pepper, seeded and diced</li>
             <li>4 cloves garlic, minced</li>
             <li>2 cans of diced tomatoes</li>
             <li>6 eggs</li>
             <li>2 tablespoon fresh cilantro, chopped</li>
             <li>¾ teaspoon salt</li>
             <li>1 teaspoon paprika</li>
             <li>¼ teaspoon black pepper</li>
             <li>1 jalapeno (optional)</li>
          </ul>
          <h3>
             Instructions
          </h3>
          <ol>
              <li>Preheat oven to 375 degrees while you wait.</li>
              <li>Heat the olive oil in a heavy oven-safe pan over medium heat. Add in onion, bell pepper, and jalapeno and fry until onions are translucent.</li>
              <li>Add in garlic and paprika. Add tomatoes, salt, and black pepper. </li>
              <li>Bring to a simmer and reduce heat. cook for 10- 15 minutes. </li>
              <li>Create 6 small spaces in the sauce and carefully crack each egg into the space.</li>
              <li>Place pan into the preheated oven and cook until eggs whites are set – roughly 10 minutes.</li>
              <li>Add cilantro as garnish before serving.  </li>
              <li>Serve with bread and tahini and enjoy! </li>
          </ol>

         `,
      };
    },
  },

  {
    id: "Gourmet_TelAviv",
    bgImage: "posts/bank/gourmet-telaviv/1.jpg",
    mobBgImage: "posts/bank/gourmet-telaviv/M.jpg",
    title: "TEL AVIV GOURMET SCENE",
    ctg: "culinary",
    isVid: true,
    vidId: "jfyHxk8ZRrI",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<p class="ac-cradit">A film by VIA TOLILA</p>
			<h3>Wake up your taste buds in Tel Aviv</h3>
			<p>
			   Tel Aviv's huge variety of amazing restaurants - The perfect place to treat yourself.
			</p>

            <p>A Mouthwatering Culinary Travel Destination - Tel Aviv is a world-class foodie travel destination with thousands of unique restaurants and bars</p>
            <p>Tel Aviv is a foodie travel destination which offers sun, fun, beaches, history, a unique culture as well as delicious and exciting food. Tel Aviv recently made it on to gourmet magazine Sauver’s list of  Outstanding Culinary Destinations  in their annual Culinary Travel Awards. Tel Aviv was also named “outstanding” in the Best Markets and Shops category. Tel Aviv’s Pastel Brasserie was voted 2014’s  Most Beautiful Restaurant in the World  in the International Space Design Awards.</p>
            <div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/gourmet-telaviv/1.jpg"} class="img-responsive" />
					         </div>
            <h3>Linneah anders</h3>
            <p>Israel is a land of immigrants, each ethnic community brought with it a unique culinary culture and together they have evolved into the Tel Aviv foodie experience. While in Tel Aviv you can try cuisine from Ethiopian, Romanian, Georgian, Russian, Indian, Yemenite, Iraqi, Iranian and more which have been given an Israeli Mediterranean twist. The city has elegant chef restaurants like Chef Mir Adoni’s Mizlala, Chef Avi Conforti’s Topolpompo restaurant and celebrity Chef Eyal Shani’s North Abraxas. There are intimate neighborhood restaurants like Abdu Hadayag. And don’t forget the famous Tel Aviv street food which is the healthiest fast-food in the world and always served with fresh Arabic salad.</p>
            <div class="img-wrapper">
				<img src=${getImgUrl() +
          "posts/gourmet-telaviv/2.jpg"} class="img-responsive" /><br/>Dana Friedlander
		    </div>
            <h3>Tel Aviv Bar Scene</h3>
            <p>It is not just the food that is superior in Tel Aviv the bar scene is also exemplary. Drinks International Magazine included Tel Aviv in their list of World’s 50 Best Bars Awards. Tel Aviv’s Imperial Craft Cocktail Bar was voted the Best Bar in Africa and the Middle East. The Imperial stands out for its amazing made-to-order cocktails and Tel Aviv in general has caught on to the “mixology” trend. Tel Aviv has a buzzing bar scene with about 4,500 food and drink related establishments which means a ratio of one restaurant for every 1,000 people. Time Out Israel recently named Lilienblum Street, the Port, the promenade, Ben Yehuda Street and Dizengoff Street as the best bar areas in the city. Among the top hot spots in Tel Aviv is Trip Advisor’s #1 pick Lima Lima Bar, veteran bar Abraxas, intimate Ozen Bar and beach bar La La Land.</p>
			`,
      };
    },
  },

  {
    id: 34,
    bgImage: "/posts/34/1.jpg",
    mobBgImage: "/posts/34/M/1.jpg",
    title: "the DEAD SEA",
    ctg: "deadsea",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            
				<p>
               		A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction.

                </p>

                <p>
               		Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
					
                </p>

                <p>

					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.

                </p>
				
            	 `,
      };
    },
  },

  {
    id: 22,
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "Shakshuka Time",
    ctg: "culinary",
    isVid: true,
    vidId: "n4kCnPXEX7g",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Learn how to make the world famous Shakshuka Dish!</h3>
				<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->

      		<p>
      		When you ask people who visit Tel Aviv and Jerusalem what was their favorite dish they tried on their trip, the answer, more often than not, will be Shakshuka. This Mediterranean delicacy, a definite local favorite is essentially a dish of eggs poached in a sauce of tomatoes, chili peppers, and onions rich in flavor and often served with bread and tahini. Of course, there are many variations on this dish according to local styles and tastes and it is usually served for breakfast or brunch though you’’ll find it makes for a fantastic dinner as well.
      		</p>
      		<p>
      		The best way to eat Shakshuka is definitely by under the fantastic year round sun of Tel Aviv or Jerusalem, as you enjoy an amazing city break full of flavors and unforgettable experiences.
      		</p>
      		<p>
      		However, should wish to DIY and recreate the taste of the sensational Shakshuka in your own kitchen, here’s how it’s done:
      		</p>
      		<h3>
            Ingredients
          </h3>
          <ul>
             <li>2 tablespoons olive oil</li>
             <li>1 onion, chopped</li>
             <li>1 red bell pepper, seeded and diced</li>
             <li>4 cloves garlic, minced</li>
             <li>2 cans of diced tomatoes</li>
             <li>6 eggs</li>
             <li>2 tablespoon fresh cilantro, chopped</li>
             <li>¾ teaspoon salt</li>
             <li>1 teaspoon paprika</li>
             <li>¼ teaspoon black pepper</li>
             <li>1 jalapeno (optional)</li>
          </ul>
          <h3>
             Instructions
          </h3>
          <ol>
              <li>Preheat oven to 375 degrees while you wait.</li>
              <li>Heat the olive oil in a heavy oven-safe pan over medium heat. Add in onion, bell pepper, and jalapeno and fry until onions are translucent.</li>
              <li>Add in garlic and paprika. Add tomatoes, salt, and black pepper. </li>
              <li>Bring to a simmer and reduce heat. cook for 10- 15 minutes. </li>
              <li>Create 6 small spaces in the sauce and carefully crack each egg into the space.</li>
              <li>Place pan into the preheated oven and cook until eggs whites are set – roughly 10 minutes.</li>
              <li>Add cilantro as garnish before serving.  </li>
              <li>Serve with bread and tahini and enjoy! </li>
          </ol>

         `,
      };
    },
  },

  {
    id: "The_Gates_Of_Jerusalem",
    ctg: "jewish",
    isVid: true,
    // vidId:"MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/gates-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/gates-of-jerusalem/M.jpg",
    title: "THE GATES OF JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `
				  
				                <p>Jerusalem’s Old City walls, built in the early 16th century by the Turkish Sultan Suleiman the Magnificent, have eight gates. All but one (the Gate of Mercy) still serve Jerusalemites and visitors streaming to its markets, and sacred and historic sites.</p>

                                <p>Following  is a thumbnail description of the gates, counter-clockwise from south to west:</p>

                                <h3>The Zion Gate:</h3>

                                <p>Bearing Jerusalem’s earliest biblical name in Hebrew and English, this gate’s  Arabic name is the Gate of the Prophet David, as the Tomb of King David, on adjacent Mount Zion, is only a few steps away. Zion Gate leads directly to the Armenian and Jewish quarters.</p>

                                <p><strong>The Dung Gate:</strong> This gate’s unusual name derives from the refuse dumped here in antiquity, where the prevailing winds would carry odors away. Nehemiah 2:13 mentions a Dung Gate that was probably near this one. This gate leads directly to the Western Wall and the Southern Wall Archaeological Park.</p>

                                <p><strong>Gate of Mercy:</strong> This gate, in the eastern Temple-Mount wall, may be the best-known of them all. Also called the Golden Gate or the Eastern Gate, it has been blocked for centuries, and is said to be awaiting a miraculous opening when the Messiah comes and the dead are resurrected.</p>
                                <div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/gates-of-jerusalem/1.jpg"} class="img-responsive" />
					            </div>

							    <h3>Lion’s Gate:</h3>

                                <p>This portal is named after a pair of ferocious-looking animal carvings that flank it. They are actually tigers, the heraldic symbol of the 13th-century Sultan Beybars. It is also called St. Stephen’s Gate, after the first Christian martyr, who tradition says was stoned nearby. Lion’s Gate, which leads to the Pools of Bethesda, the Via Dolorosa, and the markets, became famous during the Six Day War.</p>

                                <h3>Herod’s Gate:</h3>

                                <p>  Despite its name, the notorious Judean king had nothing to do with this gate. In Arabic and Hebrew this north-facing gate, which leads to the Old City markets, is called the Flowers Gate. Some say the name derives from a rosette carved over it. However, in Arabic a similar word means “awakened,” and may refer to a nearby cemetery and the hope of resurrection.</p>

                                <h3> Damascus Gate:</h3>

                                <p> This most imposing of Jerusalem’s gateways also faces north and is named for the grand city from which Jerusalem’s rulers once came. It is always a busy thoroughfare, thanks to the bustling markets within. Below the 16th-century gate, archaeologists have uncovered part of the entryway built by Emperor Hadrian in the second century CE.</p>

                                <h3> The New Gate:</h3>

                                <p>This is the only Old City entryway not part of the original design of the 16th-century walls. It was breached in the waning days of the Ottoman Empire to allow Christian pilgrims quicker access to their holy places within the ramparts.</p>

                                <p>The Jaffa Gate: This was the destination of Jewish and Christian pilgrims disembarking at the Jaffa port, hence its name. It led (and still leads) directly to the Jewish and Christian quarters, as well as to the most popular parts of the market, and to the Tower of David Museum, once Jerusalem’s citadel and now a showcase of its history.</p>
							    

         `,
      };
    },
  },

  {
    id: "Shopping_Delights",
    ctg: "jerusalem",
    isVid: true,
    // vidId:"MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/shopping-delights/1.jpg",
    mobBgImage: "/posts/bank/shopping-delights/M.jpg",
    title: "Shopping Delights",
    smltitle: "",
    html: function() {
      return {
        __html: `
				  
					<h3>
						From couture to souvenirs, Jerusalem has it all. 
					</h3>
					<p>
						There are several areas in Jerusalem with outdoor shopping promenades and a few indoor malls as well. Rest assured, going shopping in Jerusalem, you can find what you’re looking for budget.
					</p>

					<h3>
					   CITY CENTER: BEN YEHUDA AND SURROUNDING STREETS
					</h3>


					<p>
                          Jerusalem’s entire city center area is now one large pedestrian mall.   The city is  <a href="http://www.itraveljerusalem.com/ben-yehuda-street" target="_blank"><strong>Ben Yehuda St.</strong></a>, a pedestrian street full of shops and restaurants<a href="http://www.itraveljerusalem.com/ben-yehuda-street"><strong>,</strong></a>   with its repaved Jerusalem stone walkway,   classy street lamp, elevated seating areas,   and a small fountain to boot.   The surrounding streets also enjoyed an upgrade with a sleek, grey-tiled sidewalk resurfacing and the same classy street lamp. This renovation was in preparation for the city’s  <a href="http://www.itraveljerusalem.com/articles/jerusalem-light-rail/" target="_blank"><strong>lightrail on Jaffa St</strong></a>.
                    </p>

                    <p>
                       Given the expanded revamped area, when you go shopping in Jerusalem, it’s worth a stroll on all of the center city streets: Shatz St., King George St.,Hillel St., Ben Yehuda St., Jaffa St., Yoel Salomon St., and all of their offshoot streets. Tip: On Fridays during the day, check out the Artists Fair on Shatz and Betzalel Streets – an excellent place to purchase Jerusalem gifts by local artisans.
                    </p>

                    <p>
                       Ben Yehuda St. itself is a hill, connecting with King George St. at the top, and Jaffa St. at the bottom, where it opens up into the Zion Square plaza (Kikar Tzion). Ben Yehuda highlights include branches of two famous Israeli companies: The Dead Sea spa products, Ahava, and the quality Teva-Naot leather shoes. Ben Yehuda St. is also a good place to peruse Judaica and Christian souvenirs at overall mid-tier prices – be sure to haggle! The area also offers practical day-to-day items, from hats and umbrellas to electronics.
                    </p>

                    <!--<p>
                          At the bottom of Ben Yehuda St., at Zion Square plaza, stands the newly-installed department store HaMashbir LaTzarchan (commonly referred to as simply “HaMashbir”), whose multiple floors offer everything you’re used to in a department store. Near Zion Square, jewellery store  <a href="http://www.itraveljerusalem.com/baltinester-jewelry-judaica-jerusalem" target="_blank"><strong>Baltinester (Jaffa St.</strong></a>) is well known in particular for its name necklaces made to order.  From Zion Square, you’ll enter into Nachalat Shiva, centeredon Yoel Salomon St., home to several pottery and jewellery shops as well as boutique clothing stores.
                    </p>-->

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/2.jpg"} class="img-responsive" />
					</div>

					<h3>
					   MAMILLA MALL & THE OLD CITY’S CARDO: UPSCALE SHOPPING
					</h3>

					<p>
                          During your  <a href="http://www.itraveljerusalem.com/jerusalem-old-city" target="_blank"><strong>Old City tours</strong></a>, you’ll find an exclusive shopping experience at  <a href="http://www.itraveljerusalem.com/cardo-jerusalem" target="_blank"><strong>the Cardo</strong></a>  in the Jewish Quarter. The Cardo’s row of luxury shops are particularly suited to purchasing Jerusalem souvenirs, all with the unique backdrop of the Cardo’s ancient Roman columns and other archaeological remains.   Thereby, the Cardo is a one-of-a-kind experience for any Jerusalem visitor, in that you can combine treading on history with shopping high-end.
                    </p>

					<h3>
					THE JERUSALEM MALCHA MALL
					</h3>

					<p>
					    The Jerusalem Malcha Mall is a solid choice for anyone seeking the suburban indoor shopping mall experience, as well as families seeking an indoor outing.
					</p>

					<p>
					    Now over twenty years old, when the Jerusalem Malcha Mall was established it was dubbed “The Biggest Mall in the Middle East”. To date Malcha Mall certainly maintains its status as the biggest conglomerate of stores in Jerusalem, with over 250 to choose from.
					</p>

					<p>
					    The Jerusalem Malcha Mall houses both international and Israeli stores, ranging from somewhat low to mid-range budget to boutique, higher end. World-famous brand names such as H&M, Zara, Home Depot, and Toys R Us all maintain branches at this mall. Several Israeli clothing shops for all budgets have space here, as well as a branch of the department store HaMashbir LaTzarchan (the same department store as on Zion Square), and the Mega supermarket. In addition, Malcha Mall offers practical services such as a synagogue, a post office, and Bank Hapoalim. For eats, there’s a vast selection of take out restaurants at the food court, all kosher.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/3.jpg"} class="img-responsive" />
					</div>

					<p>
                          Activities include an indoor ice skating rink during winter, and entertainment and crafts workshops during holiday seasons – check our  <a href="http://www.itraveljerusalem.com/jerusalem-events" target="_blank"><strong>events schedule</strong></a>  to plan your outing. In addition, the Shilav baby store has a gymboree area good for ages up to six. <br>
                          Malcha Mall is an easy bus ride from center city or cab ride from anywhere.
                    </p>

                    <h3>
                       THE OLD CITY’S ARAB SHUK
                    </h3>

                    <p>
                       If you’re looking for authentic, local ware, the Old City’s Arab Shuk is the place to be. Located in the Muslim and Christian quarters, enter via Jaffa Gate and go straight into the Muslim Quarter. Once you see dresses and frocks hanging high, you’ll know you’re in the right place. The Arab shuk in the Old City is a Middle Eastern market full of endemic artistry both in clothing and in foods. You can also find Christian, Jewish, and Muslim souvenirs here, often at a lower price than on Ben Yehuda St. – it’s up to you to know, and use, your bargaining chips.(Hint: Start at half the offer price.)
                    </p>

                    <p>
                      In the Arab shuk, you’ll have a taste of the way things used to be. Merchants have been operating in the Old City for a couple of millenia, in these narrow alleyways, day in, day out; the sincerity of this centuries-old, Middle Eastern marketplace is something unmatched in Western culture in general.
                    </p>

                    <h3>
                        MAHANE YEHUDA SHUK (MARKET)
                    </h3>

                    <p>
                       The Mahane Yehuda market, or shuk, is renowned mostly for its Jerusalem flare with local food – fresh produce and nuts, bakeries (such as  Marzipan), and shawarma/falafel  joints.   In recent years  <a href="http://www.itraveljerusalem.com/mahane-yehuda-market" target="_blank"><strong>Mahane Yehuda</strong></a>  has seen a slew of more upscale establishments – going from “shuk   to chic” – with specialized wine and cheese shops, health food stores, vegetarian restaurants, and even a branch of the Israeli international franchise, Café Aroma. In addition to food, you can find gifts to take home such as Judaica, jewelleryry, and pottery.   You can also purchase electronics and low-cost clothing.
                    </p>



                    <p>
                    Even with its upscale spin of late, the Mahane Yehuda shuk’s salt of the earth, authentic Jerusalemite ambience remains entrenched, and for this reason it's a must.
                    </p>

                    <h3>
                       IN SUMMARY
                    </h3>

                    <p>
                          All in all, shopping in Jerusalem reflects the city itself, spanning the spectrum of ancient to modern, with options for those on a limited budget to those looking for upscale. You will see that shopping in Jerusalem is certainly an exciting, varied experience.
                          <br>– See more at: http://www.itraveljerusalem.com/articles/popular-shopping-places/#sthash.HdOTQ81q.dpuf
                    </p>

         `,
      };
    },
  },

  {
    id: "Tel-Aviv_Highlights",
    ctg: "telaviv",
    isVid: false,
    bgImage: "/posts/bank/37/1.jpg",
    mobBgImage: "/posts/bank/37/M.jpg",
    title: "Tel-Aviv Highlights",
    smltitle: "",
    isVid: true,
    // vidId: "LLOUxE-K_9Y",
    vidId: "tgF0zMUYY2g",
    html: function() {
      return {
        __html: `
					
					<h3>Top 5 things to see and do in the city:</h3>
					<h3>Old Jaffa</h3>
					<p>Even though it A visit to Old Jaffa always feels like an exciting discovery. Historic buildings dating back thousands of years, charming winding alleyways interspersed with art galleries, extraordinary landmarks and a multitude of quaint authentic restaurants. A tour of old Jaffa is an inspiring experience, a definite must for every tourist visiting Israel.</p>
					<h3>Jaffa Port</h3>
					<p>The Port of Jaffa served fishermen, sailors, merchants, crusaders, conquerors and immigrants for thousands of years and is considered one of the world’s most ancient ports. Today, the port continues to serve as a fishing port, even after its renovation as an urban attraction. When you visit the port, you can now choose between cultural and leisure activities, shopping and tourism while preserving its unique historical atmosphere.</p>
					<h3>Tel Aviv Port</h3>
					<p>The trendy port area has really got it all. During the day, you can find yourself wandering through remarkable hangar style spaces for brand and boutique shopping, sharing a meal in restaurants with magnificent sea views and taking part in lots of activities for the whole family. At night however, crowds of young clubbers descend on the area, which transforms into one of the city’s most popular hotspots with some of the coolest clubs and bars in Tel Aviv.</p>
					<h3>The White City</h3>
					<p>The ‘White City’ is home to the world’s largest grouping of international style buildings, also known as Bauhaus. Built in the 1920’s and 1930’s, and meticulously restored to its original glory, you are encouraged to take a fascinating tour of the “White City” quarter of Tel Aviv and discover why it has been declared a UNESCO World Heritage Site. The ‘White City’ quarter is a truly unique and memorable architectural treasure.</p>
					<h3>Neve Tzedek</h3>
					<p>Take a break from the hectic pace of Tel Aviv; this hidden gem of a neighbourhood boasts beautiful european architectural style and charming narrow streets. Found I 1887, Neve Tzedek was the first Jewish settlement outside of the Jaffa walls. It was founded 22 years before Tel Aviv. An extensive renovation and preservation of the neighborhood, had turned it into a trendy, artistic area. You can find art galleries, boutique shops & trendy restaurants, all which make Neve Tzedek, an actual oasis at the heart of the bustling city.</p>


         `,
      };
    },
  },

  {
    id: "Amazing_Nightlife",
    bgImage: "/posts/bank/18/1.jpg",
    mobBgImage: "/posts/bank/18/M.jpg",
    title: "Amazing Nightlife",
    ctg: "general",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    // vidId:"WKfjMATNH8Q", - this is an old youtube video
    smltitle: "",
    html: function() {
      return {
        __html: `

					<!--<div class="ac-cradit">
					<span class="ac-cradit-text">Credits:</span>
						
						<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
					</div>
					<p></p>
					</div>-->

					<div class="ac-cradit">
					<span class="ac-cradit-text">Credits:</span>
						<br/>
						<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
						<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
					</div>
					<p></p>
					</div>

                    <h3>
                    It’s a never-ending party in the nonstop city!</h3>
					<p>
					    Tel Aviv is rightly famous as one of the world’s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that’s pulsing with life.</p>
						<h3>Tel Aviv by Night</h3>
						<p>No matter what time it is, there’s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv’s pumping, pulsing clubs to dance the night away.</p>
				

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/2.jpg"} class="img-responsive" />
					</div>

					<p>Foodies will love the amazing cocktails mixed by Tel Aviv’s expert baristas, Israel’s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>
                        <h3>Making the Most of Tel Aviv’s Nightlife</h3>
                        <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you’ll be introduced to some of Israel’s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv’s new and exciting gallery bars that display pieces by up and coming artists.</p>
                         

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/3.jpg"} class="img-responsive" />
					</div>

					<p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv’s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn’t reach full swing until 2am in most of Tel Aviv’s wildly popular nightclubs, manned by top DJs. You’ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>
                         

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/4.jpg"} class="img-responsive" />
					</div>
                      <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you’ll find countless places to hang out at every hour of the day and night.</p>

                        <p>photo credit: Dana Friedlander</p>

         `,
      };
    },
  },

  {
    id: "Boutique_Hospitality",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "Boutique Hospitality",
    ctg: "general",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `

                                <p>Tel Aviv has long been known as a young and vibrant seaside city, where life is fast-paced and non-stop. And with countless bars, restaurants, beaches, museums, shops and attractions lining every free inch of prime Tel Aviv real estate, the recent revolution in the city’s boutique hotel offerings in the past two years has paved the way for luxury and leisure packed vacations, combining action with relaxation and increased visitor satisfaction.</p>

                                <h3>A unique, personalized touch</h3>

                                <p>If you are seeking a unique hospitality experience in a trendy neighborhood establishment that blends into the local infrastructure, a Tel Aviv boutique hotel stay is just what you need. Perfectly bringing together desired service and amenity features with an added increasingly personalized customer service, boutique hotels are known for their staff’s exemplary accommodating attention to their visitors’ every request and fancy.</p>

                                <p>Built in converted heritage sites, restored old buildings or other contemporarily designed structures, each Tel Aviv neighborhood boutique hotel possesses unique themes, concepts and characteristics. Defined by their souls and coupled with uniquely designed guest rooms and a high level of customized service, the boutique hotels have great views of the “City that Never Sleeps” from sprawling rooftop terraces, in-house spas, internet hubs and restaurants.</p>
								<div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/boutique-hospitality/1.jpg"} class="img-responsive" />
						            Credit: Dana Friedlander
					            </div>
							   
								<h3>Live the big city</h3>

                                <p>Looking to enjoy a romantic couple’s getaway, find a quiet place to unwind during a weeklong business conference, gather your family for an intimate reunion or hang out with friends for a fun beach vacation? Don’t want to travel far from your hotel room or sit in traffic to reach big city attractions, nightlife and events? The warm and inviting yet luxurious nature of boutique hotel stays in Tel Aviv provide the ideal hospitality experience that lets you “live” Tel Aviv like a local, minus the onus of cleaning your own rooms and preparing your own meals.</p>

                                <p>Think of boutique hotels as upscale and authentic guest houses in the heart of the big city. Somewhere you can go to escape the hustle and bustle when it’s time to relax and be pampered, but still be able to pop out on a whim and casually enjoy the plethora of sites and services Tel Aviv offers the public, just like any one of  the city’s locals. And with many of the city’s boutique hotels situated in trendy areas, including in Neve Tzedek, along the coastline, in the diamond district and on Rothschild, Shenkin and Montefiore streets, a Tel Aviv boutique hotel stay is charming, authentic, pleasurable and exciting for all hospitality seekers.</p>
            

         `,
      };
    },
  },

  {
    id: 10,
    bgImage: "/posts/bank/12/1.jpg",
    mobBgImage: "/posts/bank/12/M.jpg",
    ctg: "telaviv",
    isVid: false,
    title: "Culture Time",
    smltitle: " ",
    html: function() {
      return {
        __html: `

					<h3>A variety of fascinating museums and unique galleries</h3>

				    <h3>
				        Tel-Aviv Museum of Art
				    </h3>

					<p>
						The Tel Aviv Museum of Art presents a variety of permanent and temporal exhibits at its home in the Helena Rubenstein Pavilion, located on Shaul Hamelech Boulevard, next to the Mann Auditorium. The permanent exhibits include some of the best works of Israeli art, as well as sculptures from the 20’s until today. It features European paintings – impressionism and post-impressionism – from the 16th to the 19th centuries, as well as European and American works of the 20th century. The museum’s graphic collection includes more than 20,000 prints and sketches. Among the museum’s outstanding works are a unique selection of early painted reliefs of Alexander Archipenko and works by Chagall, which he donated to the museum before its establishment. Helena Rubenstein’s well-known collection of miniature rooms is on permanent display in the pavilion, which bears her name.
					</p>

					<h3>
				        OPENING HOURS:
				    </h3>

				    <p>

                          Sun Closed <br>
                          Mon, Wed, Sat 10:00-18:00 <br>
                          Tue, Thu 10:00-22:00 <br>
                          Fri 10:00-14:00 <br>
                          Sat 10:00-16:00 (July-August closed on Sat)<br>
                    </p>

                    <p>
                       For more information, click to the  <a href="http://www.tamuseum.org.il/en/default.aspx" target="_blank">Tel-Aviv Museum of Art</a>
                    </p>

                    <h3>
                        Beit Hatfutsot: The Diaspora Museum
                    </h3>

                    <p>
                       Beit Hatefutsot-The Jewish Diaspora Museum, situated on the Tel Aviv University campus, has gained honorary distinction throughout the Jewish world as the first museum of the history of the Jewish people to showcase the Jewish contribution to human creativity and culture over a period of more than two millennia. The Museum’s permanent exhibition brings the story of the Jewish People throughout the Diaspora to life through drawings, video clips, films, reconstructed models and other means. The exhibit focuses on various subjects – including “The Jewish Family life cycle”, “the community”, “the faith”, and “the return to Zion”.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/10/2.jpg"} class="img-responsive" />
					</div>

					<p>

                          For more information, click to the  <a href="http://www.bh.org.il/" target="_blank">Beit Hatfutsot: The Diaspora Museum</a>

                    </p>

                    <h3>
                         Eretz Israel Museum
                    </h3>

                    <p>

                            The Eretz Israel Museum- Tel Aviv is a multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, Judaica, cultural history, local identity, traditional crafts and functional arts. The museum’s pavilions are scattered throughout a spacious courtyard with the ancient archaeological mound of Tel Kassile, at which excavations revealed valuable findings, positioned at its center. The museum houses a variety of reconstructed ancient production devices, including wine presses, an olive oil press, and a flour mill, along with a “craftsperson’s marketplace” which showcases traditional work instruments that were used in the Land of Israel and throughout the region. There is also a sophisticated Planetarium with its “Journey to the Universe” program, and a museum shop offering a unique selection of locally produced gifts and ornaments.<br>

                            OPENING HOURS:<br>

                          Sun-Wed 10:00-16:00 <br>



                          Thu 10:00-20:00<br>



                          Fri-Sat 10:00-14:00<br>

                        </p>

                    <p>
                       For more information, click to the <strong>  </strong><a href="http://www.eretzmuseum.org.il/e/" target="_blank">Eretz Israel Museum  </a>
                    </p>

					<h3>
					    Beit Ha’ir
					</h3>


					<p>

                          Beit Ha’ir, renovated by the city, was the old City Hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city’s history.  Beit Ha’ir has a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years, a project that was part of the centenary celebrations of the city. The main hall has a virtual display, including hundreds of documentary films and thousands of rare photos and documents that showcase major events in the early years of city life.  At Beit Ha’ir you can also visit the Dizengoff House, the restored residence of Meir Dizengoff, first mayor of Tel Aviv-Yafo, which includes a permanent exhibition.

                          <br>
                          OPENING HOURS:
                          Sun Closed
                          Mon-Thu 9:00-17:00 <br>
                          Fri-Sat 10:00-14:00
                    </p>

                    <p>
                      For more information, click to the <a href="http://www.eretzmuseum.org.il/e/" target="_blank">Beit Ha’ir</a>
                    </p>

                    <h3>
                        The Olympic Experience Museum
                    <h3>

                    <p>

                          A new museum in Tel Aviv-Yafo, The Olympic Experience Museum, presents a one-hour, five-ring trip through the greatest Olympic records, with a special focus on Israel’s finest moments. The Olympic Experience boasts state-of-the art high tech imaging and illustrations, audio-visuals presentations, holograms, interactive screens, hands-on trials and much, much more.

                          Guided tours for organized groups every 30 minutes. Advanced reservation is recommended.

                          Opening Hours: Sunday-Thursday: 10:00-18:00, Friday:  10:00-14:00

                          The Olympic Experience, 6 Shitrit Street, Hadar-Yosef. Tel: +972-3-6498385

                    </p>

                    <p>
                       For more information, click to the  <a href="http://www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2" target="_blank">The Olympic Experience Museum</a>
                    </p>

                    <p>

                          Ilana Goor Museum in Jaffa

                          The private home of this world renowned artist has been turned into a museum. You can see her sculptures, furniture, jewelry and get a glimpse into this unique Jaffa home <br>
                          OPENING HOURS: <br>
                          Sun-Fri 10:00-16:00 <br>
                          Sat 10:00-18:00<br>
                          <a href="http://www.ilanagoormuseum.org/eng/">www.ilanagoormuseum.org</a>
                    </p>

                    <h3>
                         Palmach Museum
                    </h3>

                    <p>
                        Rated #1 Tel-Aviv museum on Trip Advisor, this museum examines the Palmach, the military wing of the Zionist Movement, which functioned until the establishment of the State of Israel.
                    </p>

                    <p>
                        For more information, click to the  <a href="http://info.palmach.org.il/show_item.asp?itemId=8096&amp;levelId=42798&amp;itemType=0" target="_blank">Palmach Museum</a>
                    </p>

                    <h3>
                        Other unique Museums
                    </h3>

                    <p>
                        Tel Aviv-Yafo is home to a variety of smaller, specialized museums, such as Beit Ben Gurion (The home of David Ben Gurion, Israel’s first prime minister), Beit Hatanach (The home of the Bible), The Haganah (defense) Museum, The I.Z.L. (the Irgun Zva’I Leumi – National Military Organization) Museum, Beit Hasofer (author’s house), Beit Reuven, The Jabotinsky Museum, and many others. Each of these smaller museums is a treasure house of artifacts. For example, Beit Bialik – the house of the national poet, displays the books, furniture and belongings of Israel’s renowned national poet. Bialik’s personal library of more than 3,000 books has been preserved, and the museum’s archives contain thousands of manuscripts, including the most extensive collection of his writings.
                    </p>

                    <h3>
                        OPENING HOURS OF TEL AVIV MUSEUMS:
                    </h3>
                    <h3>
                        Etzel Museum:
                    </h3>

                    <p>

                          King George 38: Sun-Thu 8:30-16:00 <br>

                          For more information, click to the  <a href="http://www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx" target="_blank">Etzel Museum</a>
                    </p>

                    <h3>
                        Ben Gurion House:
                    </h3>

                    <p>
                            Sun, Tue-Thu 8:00-15:00 <br>
                            Mon 8:00-17:00<br>
                            Fri 8:00-13:00<br>
                            Sat 11:00-14:00
                    </p>

                    <p>
                       For more information, click to the  <a href="http://www.bg-house.org/?categoryId=6575" target="_blank">Ben Gurion House</a>
                    </p>

                    <h3>
                        Jabotinsky Institute in Israel:
                    </h3>

                    <p>

                        Sun-Thu 8:00-16:00 <br>
                        For more information, click to the  <a href="http://en.jabotinsky.org/" target="_blank">Jabotinsky Institute in Israel</a>

                    </p>

                    <h3>
                           The Israeli Museum:
                    </h3>

                    <p>
                            Sun, Mon, Wed 9:00-17:00 <br>
                            Tue, Thu 9:00-19:00<br>
                            Fri 9:00-14:00 <br>
                            For more information, click to the
                            <a href="http://www.imj.org.il/en/">www.imj.org.il</a>
                    </p>

                    <h3>
                       Jaffa Visitors Center:
                    </h3>

                    <p>

                            Summer Sun-Thu, Sat 9:00-20:00<br>

                            Fri 9:00-17:00<br>

                            Winter Sun-Thu, Sat 9:00-18:00<br>

                            Fri 9:00-15:00<br>

                            For more information, click to the  <br>

                            <a href="http://www.touristisrael.com/old-jaffa-visitors-center/3604/" target="_blank">Jaffa Visitors Center</a>

                    </p>

                    <h3>
                         Hall of Independence:
                    </h3>

                   <p>

                            Sun-Thu 9:00-17:00 <br>

                            Fri 9:00-14:00<br>

                            For more information, click to the  <a href="http://eng.ihi.org.il/" target="_blank">Hall of Independence</a>

                    </p>

                    <h3>
                        The Bible Museum:
                    </h3>

                    <p>

                            Sun-Fri 10:00-13:00 + 16:00-18:30 <br>

                            For more information, click to the  <a href="http://www.blmj.org/en/" target="_blank">The Bible Museum</a>

                    </p>

                    <h3>
                        Joseph Bau house:
                    </h3>

                    <p>

                            By appointment only (including weekends) <br>

                            For more information, click to the  <a href="http://www.josephbau.com/" target="_blank">Joseph Bau house</a>

                    </p>

                    <h3>
                        Rubin Museum:
                    </h3>

                    <p>

                            Sun Closed <br>

                            Mon, Wed, Thu 10:00-15:00 <br>

                            Tue 10:00-20:00<br>

                            Sat 11:00-14:00<br>

                            For more information, click to the   <a href="http://www.rubinmuseum.org.il/" target="_blank">Rubin Museum</a>

                    </p>

                    <h3>
                        Art Galleries
                    </h3>

                    <p>
                        Don’t miss the dozens of fine galleries, primarily located along Gordon Street and in the Old City of Jaffa, featuring the very latest in contemporary Israeli art. We won’t say another word- we’ll let the art speak for itself.
                    </p>

         `,
      };
    },
  },

  {
    id: "Jerusalem_Main_Sites",
    bgImage: "/posts/bank/jerusalem4/1.jpg",
    mobBgImage: "/posts/bank/jerusalem4/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "k4OwoEk5wMw",
    title: "JERUSALEM MAIN SITES",
    smltitle: "",
    html: function() {
      return {
        __html: `
					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/k4OwoEk5wMw/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<h3>
					Discover the history that stretches back thousands of years
					</h3>
					<p>
						Like any city, the charm and essence of Jerusalem is best absorbed by walking its streets. However, depending on your interests, you don’t want to miss out on exploring at least some of these major attractions.
					</p>

					<p>
                         When visiting religious sites, it’s advised to dress modestly and wear clothing that covers your knees and elbows.
                    </p>

					<p>
                       A good place to start is Jerusalem’s Old City, which has a very special and distinct atmosphere and is where many of the major attractions of Jerusalem are found.
                    </p>

                    <h3>
                        OLD CITY
                    </h3>

                    <h3>
                        JERUSALEM WESTERN WALL
                    </h3>

                    <p>
                      The Western Wall, also known as the Wailing Wall and Kotel, is the western retaining wall of the Second Temple. Considered Judaisms’s holiest site, the wall is divided into a men’s and women’s section where worshipers congregate throughout the day for morning, afternoon and evening services. Diverse crowds come to pray against the stones, to tuck small pieces of paper with prayers into the cracks and to simply marvel at the site.
                    </p>

                    <p>
                          Address: Jewish Quarter, Old City <br>
                          Phone: +972-2-627-3515<br>
                          Hours: 24/7<br>
                    </p>

                    <h3>
                        VIA DOLOROSA
                    </h3>

                    <p>
                        TCrossing the Muslim Quarter from east to west is this street that traces the last steps of Jesus Christ as he was led to his crucifixion. Popular with both pilgrims and general tourists, the route marks 14 events on Christ’s last walk and is also lined with shops and stalls. It is worth visiting on a Friday afternoon (3:00opm in winter; 4:00pm in summer) when the Franciscans lead a procession along the route.
                        <br>Address: Via Dolorosa, Muslim Quarter, Old City.
                    </p>

                    <h3>
                        JERUSALEM CHURCH OF THE HOLY SEPULCHER
                    </h3>

                    <p>
                        One of the holiest sites for Christians, this impressive building draws millions of pilgrims from around the world every year. The compound is believed to be the site of Golgotha (the Hill of Calvary), where, according to the New Testament, Jesus was crucified, buried and resurrected.
                        <br>
                        Address: Between Suq Khan e-Zeit and Christian Quarter Rd, Christian Quarter, Old City<br>
                        Phone: +972-2-627-3314 <br>
                        Hours: Sun – Sat: 5:00am – 8:00pm/9:00pm
                    </p>



					<h3>
					    DAVID’S CITADEL
					</h3>

					<p>
					   David’s Citadel (also known as the Tower of David) was originally built in the second century BC to strategically strengthen a weak point in the city’s defences, and was subsequently destroyed and rebuilt many times over the ensuing centuries. Since 1989, the grounds are home to a fascinating museum, which sheds light on the history of Jerusalem. Don’t forget to take in the splendid view of Jerusalem from its ramparts.
					</p>

					<p>
                          Address: Jaffa Gate, Christian Quarter, Old City <br>
                          Phone: +972-2-626-5333<br>
                          Hours: Sun-Thu: 10:00am -4:00pm, Fri: Closed, Sat: 10:00am – 2:00pm (September-June), Sun-Thu:<br> 10:00am – 5:00pm, Fri: 10:00am – 2:00pm, Sat: 10:00am – 5:00pm (July-August)
                    </p>

                    <h3>
                        CITY OF DAVID
                    </h3>

                    <p>
                        Situated deep below ground in the Arab village of Silwan is the remains of the once-grand citadel where a dynasty of Judean kings once ruled. A massive visitors’ center offers a tour that begins with an observation point overlooking the remains of ancient Jerusalem, then continues underground with a look at recent archaeological finds and ends at the Gihon Spring, where according to tradition Solomon was anointed king. Visitors can also wade through the waters of the 2,700-year-old Hezekiah’s Tunnel.
                    </p>

                    <p>
                          Address: Silwan, East Jerusalem <br>
                          Phone: +972-2-626-2341<br>
                          Hours: Sun-Thu: 8:00am – 5:00pm (winter), 8:00am – 7:00pm (summer), Fri: 8:00am – 1:00pm (winter), 8:00am – 3:00pm (summer)
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/9/3.jpg"} class="img-responsive" />
					</div>

					<h3>
                       MOUNT OF OLIVES
                    </h3>

                    <p>
                        The hill that rises to the east of the Old City, the Mount of Olives, is a great place to take in views of the Old City and the Dome of the Rock. Its slopes are filled with holy and burial sites and are home to several grand churches including the Church of all Nations. To take in all the sights, it’s best to start at the top, near to the Mosque of Ascension, and walk downhill to the Tomb of the Virgin. The Old City views are best in the morning. <br>
                        Address: Mount of Olives, East Jerusalem
                    </p>

                    <h3>
                        YEMIN MOSHE
                    </h3>

                    <p>
                        This charming neighbourhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. It is known for its windmill and communal housing block, known as Mishkenot Shaananim, which is now a venue for art and culture. The area is home to artists, writers and academics and is renowned for its Oriental-style houses, green parks, a music center, the YMCA, King David Hotel, Herod’s Family Tomb. <br>
                        CITY CENTER
                    </p>

                    <h3>
                        MAMILLA ALROV AVENUE
                    </h3>

                    <p>
                          Situated between the city center and the Old City, Mamilla Alrov Avenue is a pedestrian mall that offers a selection of luxury shops, as well as upscale restaurants and cafes. Mamilla is known for its chic and tasteful European feel, and offers spectacular views of the Old City walls. <br>
                          Address: 6 Yitzhak Kariv St, Jerusalem <br>
                          Phone: +972-2-636-0000<br>
                          Hours: Sun-Thu: 10:00am – 9:30pm (winter), 10:00am – 10:30pm (summer), Fri: 9:00am – 2:00pm (winter), 9:30am – 3:30pm (summer), Sat: One hour after Shabbat – 11:00pm
                    </p>

                    <h3>
                        BEN YEHUDA STREET
                    </h3>

                    <p>
                    One of Jerusalem’s prime hangout spots for locals and tourists alike, Ben Yehuda Street is a pedestrian mall extending between King George Street and Jaffa Road in downtown Jerusalem. The street is filled with gift shops, falafel and ice-cream stores, buskers, beggars, musicians and street performers.
                    </p>

					<h3>
                        NACHALAT SHIVA
                    </h3>

                    <p>
                          This charming cobblestone neighbourhood just south of Ben Yehuda Street in the  <a href="http://www.itraveljerusalem.com/placecategory/food-nightlife?multi_hood=11" target="_blank"><strong>city center</strong></a>  offers a great selection of shops, restaurants, bars and outdoor cafes. This is a great place to experience in summer and at night with many bustling until late.
                    </p>

                    <h3>
                       MEAH SHEARIM
                    </h3>

                    <p>
                          Though it is just a few minutes’ walk from modern Ben Yehuda Street, the ultra-orthodox enclave of Mea Shearim is an entirely different reality. You will feel as though you have stepped into 18th Century Europe with Jewish Orthodoxy dressed in full traditional attire such as long black coats, black fur hats and stockings. When touring, it’s recommended to dress extremely modestly, covering up your wrists and ankles, and to take photos with discretion. <br>
                          Address: Meah Shearim Rd, Jerusalem
                    </p>

                    <h3>
                        Mahane Yehuda Market
                    </h3>

                    <p>
                          Often referred to as “the shuk”, Mahane Yehuda Market offers a huge assortment of fresh produce and food, as well as a variety of other shops like clothing stores, kitchenware shops, jewellery stores, ceramic stores and a variety of gentrified eateries. The shuk includes an open air and closed area, bounded by Jaffa Road on the one side and busy Agripas Street on the other. It’s worth taking public transportation to the shuk as there is not a huge abundance of parking, and a great deal of traffic. If you can handle crowds, go on a Friday to experience last minute Shabbat shopping.<br>
                          Address: Agripas and Jaffa Street, Jerusalem
                    </p>

                    <h3>
                        OTHER AREAS OF JERUSALEM
                    </h3>

                    <h3>
                       YAD VASHEM
                    </h3>

                    <p>
                          Yad Vashem, Israel’s national Holocaust memorial, commemorates the six million men, women and children murdered by the Nazis and their allies. Located at the foot of Mt. Herzl, Yad Vashem comprises several moving memorials, including the Hall of Remembrance and the haunting Children’s Memorial; the Holocaust History Museum; the Museum of Holocaust Art; sculptures and installations; a massive archive and a research institute. Dress appropriately, and make sure to reserve at least a few hours for a visit to the Museum.  Address: Har Hazikaron <br>
                          Phone: +972-2-644-3400
                    </p>

                    <h3>
                       ISRAEL MUSEUM
                    </h3>

                    <p>
                          You’ll want to devote at least a day to Israel’s largest cultural institution, the Israel Museum, which was re-launched in the summer of 2010 after a major overhaul. The Museum is made up of many different wings and a huge collection of art, archaeological findings and Judaica. One of the major highlights is the distinctly shaped Shrine of the Book, which houses many ancient manuscripts including the Dead Sea Scrolls. Other highlights include the Youth Wing for children, the Billy Rose Art Garden, which showcases the development of western sculpture over the centuries, the Museum’s Fine Arts Wing and its in-depth Archaeology Wing.
                    </p>

         `,
      };
    },
  },

  {
    id: "Sensational_Beaches",
    ctg: "telaviv",
    isVid: true,
    vidId: "XDei1Zy_cu4",
    bgImage: "/posts/bank/17/1.jpg",
    mobBgImage: "/posts/bank/17/M.jpg",
    title: "Sensational Beaches",
    smltitle: "",
    html: function() {
      return {
        __html: `
					
					<h3>Relax by the sunny beaches of Tel Aviv, pull out the sunscreen, grab your ‘matkot’ and let’s go play.</h3>
					<p>Tel Aviv-Jaffa prides itself with a long promenade alongside8/7 miles of seashore. People walk, jog, ride bikes, or just sit on benches and fill their lungs with fresh air, all while being surrounded by glorious sunshine, blue horizons, and white sails bobbing up and down on the waves.
					<p>Dozens of restaurants, cafes, and ice cream parlors are busy all day long, while pubs, dance clubs and jazz clubs blossom after dark. Regardless of the time of day, human attractions thrive by the beach: buskers, caricaturists, dancers and of course, the ever- changing parade of people strolling by the nearby beaches. Right off the promenade you’ll find clean sand, lounge chairs to hire, ice-cream vendors, and die-hard beach-lovers that swim daily, winter and summer, no matter what. Each of Tel Aviv’s 13 beautiful beaches enjoy unique characteristics and offer a variety of services, including lifeguard stations, kiosks, restaurants, children’s playgrounds, outdoors gyms, and more.
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>
					<p>Here’s what you need to know:
					<h3>Bathing Season</h3>
					<h3>The Tel Aviv bathing season opens on May 9th and will end on October 31st </h3>
					<p>During the season, rescue services, supervision and first aid will be given to all 13 beaches. 
					<h3>Hours of activity:</h3>
					May 9-31: 7am-5pm<br/>
					June: 7am-6pm<br/>
					July-August: 7am-7pm<br/>
					September-October: 7am-5pm<br/>
					Inspection and cleaning is provided for all beaches mentioned above daily.</p>
                     <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>
					<p>You can rent a parasol/chair or a reclining chair and a locker at a fixed price. However, you need to purchase tickets for them at the vending machines before you grab them on the beach.</p>
					<h3>The price list of the beaches is:</h3>
					<p>Pita or bread with humus or salad – 12 NIS<br/>
					Small bottle of mineral water – 7 NIS<br/>
					Popsicle – 5 NIS<br/>
					Reclining Beach chair for the day – 12 NIS<br/>
					Beach chair for the day – 6 NIS<br/>
					Parasol for the day – 6 NIS</p>
					<h3>Beach Guidelines</h3>
					<p>•	Every lifeguard station marks the safety condition of the sea by flags: <br/>
					White Flag means that bathing is permitted.<br/>
					Red Flag means that the sea is somewhat dangerous and bathing is permitted only between red flags.<br/>
					Black Flag means that bathing is not permitted.<br/>
					Purple Flag is to warn you of jellyfish.<br/>
					Now, about that, during the month of July, a swarm of Jelly fish migrates from Egypt northwards with the currents. Although this type of Jelly fish isn’t deadly, it does sting and can cause your skin sever blisters. So it’s best to not dwell too long in the water if at all.</p>
					<p>•	Bathers must comply with the lifeguard and rescue guards.<br/>
					•	Bathing is prohibited when there is no lifeguard on duty.<br/>
					•	Sea bathing is prohibited when the black flag is raised.<br/>
					•	Glass bottles are prohibited on the beach<br/>
					•	NO motor sports (jet skis, boats) are allowed on the beach.<br/>
					•	Motorized vehicles are forbidden on beaches and the boardwalk.<br/>
					•	Bonfires are prohibited on operating beaches.</p>


					<h3>A Few Tips</h3>
					<p>•	On Saturday morning you can join Israeli folk-dancing on Gordon beach.<br/>
					•	Geula beach and Gordon beach are great for beach volleyball.<br/>
					•	The LGBTQ community tends to gravitate to the stretch near the Hilton, which has earned the unofficial title as the city’s most gay-friendly beach.<br/>
					•	The narrow strip of sand near the Marina is less crowded and more peaceful than the other beaches. At the yacht basin, you can rent windsurfing equipment, surfboards, sailboats of various sizes, motorboats and diving equipment.<br/>
					•	Surfing is popular at Hilton Beach, where a special light system was recently installed to allow for night surfing.<br/>
					•	Kite Surfing is popular at Aviv Beach.<br/>
					•	To windsurf, go to Aviv or Hilton Beach.<br/>
					•	Volleyball can be found at both Aviv (The south part) and Gordon beaches.<br/>
					•	The city’s beaches are well equipped with open showers, lockers at a 5nis cost per 24 hours, changing rooms & toilets, which are also accessible for people with disabilities.<br/>
					•	 All beaches are now accessible to people with disabilities. Aviv, Jerusalem, Frishman, Bograshov, Gordon & Hilton beaches have a direct access to the water for people with mobility difficulties. For those with visual disability, the beaches also have a ‘Step Hear’ system which can be operated via an app: <a href="https://www.step-hear.com/" target="_blank">www.step-hear.com</a><br/>
					•	Tourist police officers are usually present to provide security, assistance and information services. <br/>
					•	There are free games to use such as Chess, Checkers & Backgamon for the grownups as well as children games. Just put them back when you are done playing.<br/>
					•	Fun Facts<br/>
					•	8,500,000 bathers enjoy the beaches yearly.<br/>
					•	The official bathing season is May-October.<br/>
					•	Tel Aviv’s beaches rank highly in tests run by the Israeli Ministry of the Environment and are considered to be very clean.<br/>
					•	An Israeli version of paddleball, called Matkot, is a favorite sport played along the shorelines (watch your head!).<br/>
					•	Watermelon with feta cheese is a very popular beach snack. ‘Artikim’, which are popsicles, are also well liked, with the banana-chocolate flavor ranking at the top of most people’s list.</p>


         `,
      };
    },
  },

  {
    id: "Modern_And_Vibrant",
    bgImage: "/posts/bank/39/1.jpg",
    mobBgImage: "/posts/bank/39/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    // vidId: "MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",
    title: "Modern and Vibrant",
    smltitle: "",
    html: function() {
      return {
        __html: `

                
                              <p>
						Downtown Jerusalem is the heart of the modern metropolis, bursting with nightlife, dining and cultural options to rival any major city in the world.
					</p>
					<p>
						The area is made up of several neighborhoods and appealing locations such as charming Nachlat Shiva, the bustling Yafo Street and Ben Yehuda Street, with its own unique personality and atmosphere not to be missed.
					</p>
					<p>
						The center of Jerusalem includes some of the city’s most charming neighborhoods and fascinating attractions. For an unbeatable cultural experience, check out Jerusalem’s variety of fascinating museums, including the world class Israel Museum, the Bible Lands Museum and Jerusalem’s Science Museum.
					</p>
					<h3>
						Machane Yehuda Market
					</h3>
					<p>
						Discover this market's unrivaled atmosphere and variety which draw thousands of tourists every day. Once the shopping is done and the food vendors close up, join the young trendy crowds, foreign and locals alike, who descend on the market to drink and party until the small hours, in the bars, restaurants and alleyways.
					</p>
					<h3>
						Nahalat Shiv’a
					</h3>
					<p>
						This charming cobblestone neighborhood at the heart of the city offers an excellent selection of shops, restaurants, bars and outdoor cafés. Nahalat Shiva is home to Kikar Hamusica (Music Square) – a lively and trendy outdoor space that offers live music every day throughout the week.
					</p>
					<h3>
						Yemin Moshe
					</h3>
					<p>
						This lovely neighborhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. Home to artists, writers and academics, Yemin Moshe is known for its beautiful windmill and oriental style houses, green parks, lively music center and stunning views.
					</p>
					<h3>
						Ein Kerem
					</h3>
					<p>
						Nestled in a peaceful valley between the mountains and the terraced hills southwest of Jerusalem, Ein Kerem is one of Jerusalem’s most picturesque neighborhoods. With its winding paved lanes, their charming stone houses adorned with arches, churches whose bells chime in the clear air, Ein Kerem radiates charm and beauty like an island in a sea of green forest.
					</p>

         `,
      };
    },
  },

  {
    id: "Jerusalem_After_Dark_Fun",
    bgImage: "/posts/bank/modern-and-vibrant/1.jpg",
    mobBgImage: "/posts/bank/modern-and-vibrant/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    title: "After Dark Fun in the Holy City",
    smltitle: "",
    html: function() {
      return {
        __html: `

                

					

					            <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
                              <p>To check it out, make your way to the City Center and explore the narrow streets just off Jaffa Street. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. Rivlin Street is a popular hangout for young people, while Shoshan Street and the surrounding area offers a more laid-back grown up vibe.</p>
                              <div class="img-wrapper">
						          <img src=${getImgUrl() +
                        "/posts/modern-and-vibrant/1.jpg"} class="img-responsive" />
					          </div>
                              <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing. </p>
                              <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session. </p>
                              <p>For a daytime change of pace head to the German Colony (Moshava) and, particularly, the neighborhood of Baka. Start at Beit Lechem Street where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up Emek Refaim Street or through HaMesila (Railway) Park until you reach The First Station – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>
            	

         `,
      };
    },
  },

  {
    id: "Jerusalem_Musts",
    bgImage: "/posts/bank/38/1.jpg",
    mobBgImage: "/posts/bank/38/M.jpg",
    ctg: "general",
    isVid: true,
    // vidId: "k4OwoEk5wMw",
    vidId: "FvAWuLQEOJw",
    title: "Jerusalem ‘Musts’",
    smltitle: "",
    html: function() {
      return {
        __html: `

				    <h3>5 top things to do and see in the stunning city</2>
					
					<h3>
						Segway Tours
					</h3>
					<p>
						This adrenaline-packed way of seeing the city will allow you to take in the
						beauty of Jerusalem from an entirely unique perspective. The Segway
						tours leave from various central spots, including the Armon HaNatziv
						Promenade (East Talpiot), Yemin Moshe and the Old City, as well as near
						the Knesset and the museum area.
					</p>
					<h3>
						The First Station (Hatachana)
					</h3>
					<p>
						The First Station is right at the heart of Jerusalem, between the Old
						City and the City Center, between the historic neighborhoods of the
						German Colony and Yemin Moshe. It is the site of the first train station
						in Jerusalem, which was built in 1892. After undergoing renovation and
						preservation, the First Station was reopened as a lively entertainment
						spot, open seven days a week.
					</p>
					<h3>
						The Time Elevator
					</h3>
					<p>
						If you are a fan of joy rides, you will love having your senses scintillated
						by the Time Elevator. It’s an interactive experience that takes visitors on
						fabulous voyages to fascinating places, with motion-based seating in a
						unique hall, filled with special effects.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/jerusalem-must/1.jpg"} class="img-responsive" />
					</div>
					<h3>
						The Biblical Zoo
					</h3>
					<p>
						Spreading over 62 acres, this beautiful two-tiered zoo centers on a vast
						man-made lake complete with waterfalls and side pools, surrounded
						by spacious lawns and shaded resting spots. To the delight of children
						and adults alike, there are over 200 species on view, most of them
						mentioned in the Bible and some almost made extinct in the interim.
						This does not mean that regular animals are not present they even have
						penguins here. Near the Zoo there is a beautiful, huge and impressive
						Aquarium, open for visitors during the day and evening, displaying marine
						habitat from the Mediterranean Sea, the Red Sea and more.
					</p>
					<h3>
						Teddy Park
					</h3>
					<p>
						Named after Teddy Kollek who was Mayor of Jerusalem between 1965-
						1995; Teddy park is fun, beautiful and historically significant.
						The park constitutes a significant meeting point between the Old and
						New Jerusalem and includes a wishing pond, an impressive sun clock
						original sculpture, restorations of historical properties and a fantastic
						water fountain attraction, featuring a spectacular light and sound
						evening show.
					</p>

         `,
      };
    },
  },

  {
    id: 16,
    bgImage: "/posts/bank/34/1.jpg",
    ctg: "eilat",
    isVid: true,
    vidId: "yXzhH92kREg",
    mobBgImage: "/posts/bank/34/M.jpg",
    title: "NEGEV MAJESTIC DESERT",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Action adventures in the desert sun. With so much to see and do, there is never a dull moment in the Negev</h3>

					
					<h3 class="negev-secondary-title">
								 The Negev Desert - Pure Magic Desert
							</h3>


							\n

                            <!--negev text-->

                            <p>
								The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.
							</p>
							<p>
								Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.
							</p>
							<p class="p-margin">
								There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.
							</p>

							<h3>
                                The Israeli desert is special for the following reasons:
                            </h3>

							<ul class="p-margin">
							    <li>
										<b>The desert is very near:</b> just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).
										Starting from November, there will be direct flights from Europe and Russia to Ovda airport including Ryanair, Wizzair, and SAS.
							    </li>
                                <li>
                                        <b>Easy to Hike and Bike:</b> There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:<br>
                                        <a href="http://www.negevtour.co.il" target="_blank">www.negevtour.co.il</a>
                                        <a href="http://www.en.aravaway.co.il " target="_blank">www.en.aravaway.co.il</a>
							    </li>
							    <li>
                                        <b>Cordial local population:</b> The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.
							    </li>
							    <li>
                                        <b>Tourists Activities:</b> Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.
							    </li>
							    <li>
                                        <b>Magnificent landscapes:</b> Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety<br>
                                        <ul>
                                        	<li>
                                        		There are spectacular sand dunes in the north.
                                        	</li>
                                        	<li>
                                        		The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.
                                        	</li>
                                        	<li>
                                        		In the east, one experiences the African desert with wide savannas and acacia trees.
                                        	</li>
                                        	<li>
                                        		To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.
                                        	</li>
                                        </ul>
                                        During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.
										Many tourists decide for to stay for 2 or 3 days in each region of the Negev.

							    </li>
							    <li>
                                        <b>The Negev is very safe to travel.</b> In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.
							    </li>
							</ul>
							<h3>
							    More information and tips for accommodation and recommendations:
							</h3>
							<p>
							   <a href="http://www.negevtour.co.il/homepage/accommodation/?lang=en" target="_blank">www.negevtour.co.il</a><br>
							   <a href="https://en.aravaway.co.il/business/category/1/" target="_blank">www.en.aravaway.co.il</a>
							</p>
							<p class="p-margin">
							   <a href="http://goisrael.de/taxonomy/term/85" target="_blank">Travel deals</a><br>

							</p>




                            <!--Negev - Transportations-->

							<h3>
							    NEGEV - LOCATION AND APPROACH
							</h3>
							<p class="p-margin">
							   Landing at the airports of Ovda or Eilat with the  onward journey to Mitzpe Ramon or Sde Boker:
							</p>

							<h3>
							   Public means of transportation:
							</h3>
							<p>
								Bus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p>
								Arrival at the central bus station of Mitzpe Ramon after about an hour and a half.
							</p>
							<p>
								Mondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p class="p-margin">
							   <a href="http://www.egged.co.il/HomePage.aspx" target="_blank">Bus service </a><br>
							   <a href="http://www.egged.co.il/HomePage.aspx" target="_blank">Shuttle service from Ovda Airport </a>
							</p>
							<h3>
							   Car rental in Eilat, Mitzpe Ramon and Be'erSheva:
							</h3>
							<p>
								There a multiple option in renting a car in these cities.
                                There is a choice of international and Israeli companies.

							</p>
							<p class="p-margin">
								Landing at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon

							</p>
							<h3>
							   Public means of transportation:
							</h3>
							<p>
								Bus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.
								<a href="http://www1.rail.co.il/EN/Pages/Homepage.aspx" target="_blank">Train from Ben Gurion or Tel Aviv to Be'erSheva.</a>
                            </p>
                            <p>
								From Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes).
                                Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.
                            </p>
                            <p class="p-margin">
								More information about the public means of transportation is given <a href="https://www.bus.co.il/otobusimmvc?Language=en" target="_blank">here</a> or <a href="http://www.egged.co.il/HomePage.aspx">here</a>
                            </p>


                             <!--NEGEV DESERT-don't miss-->








                            <h3 class="margin-h">
                                 NEGEV ROAD DISTANCES
                            </h3>
							<table>
							  <tr>
							    <th></th>
							    <th>Tel Aviv</th>
							    <th>Jerusalem</th>
							    <th>Bee'r Sheva</th>
							    <th>Eilat</th>
							  </tr>
							  <tr>
							    <td class="place-table"> <strong>Old Town <br class="show-on-mobile"> Beer Sheva</strong></td>
							    <td>113 Km</td>
							    <td>122 Km</td>
							    <td></td>
							    <td>232 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Tel Arad</strong></td>
							    <td>134 Km</td>
							    <td>144 Km</td>
							    <td>40 Km</td>
							    <td>229 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Ben-Gurion's House <br class="show-on-mobile">in Sde Boker</strong></td>
							    <td>162 Km</td>
							    <td>171 Km</td>
							    <td>49 Km</td>
							    <td>185 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Ramon Crater</strong></td>
							    <td>210 Km</td>
							    <td>192 Km</td>
							    <td>97 Km</td>
							    <td>141 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Hai Bar Wildlife <br class="show-on-mobile"> reserve Yotvata</strong></td>
							    <td>323 Km</td>
							    <td>288 Km</td>
							    <td>202 Km</td>
							    <td>35 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Timna Park</strong></td>
							    <td>330 Km</td>
							    <td>294 Km</td>
							    <td>208 Km</td>
							    <td>30 Km</td>
							  </tr>
							</table>

                            <h3>
								NEGEV DESERT - DON'T MISS
							</h3>

							 <h3>
                                Ramon Crater
                            </h3>

                            <p>
                                At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater,also known as Machtesh Ramon.
								Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.
								Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.
								The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/7.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
                                Timna Park
                            </h3>

                            <p>
                               15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions.
                               With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/9.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h2 class="title-to-play">
								CLICK TO PLAY: Timna Park - An Exhilarating Desert Adventure
							</h3>
							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/i_4QKtXIeto/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

						

                            <h3>
							    Sandboarding in the desert
							</h3>
							<p>
								An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?
							</p>
							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/1.jpg"} class="img-responsive" />
							</div>
							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/2.jpg"} class="img-responsive" />
							</div>

							<!--<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/3.jpg"} class="img-responsive" />
							</div>-->

							<h3>
							    Negev at night
							</h3>
							<p>
								The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/4.jpg"} class="img-responsive" />
							</div>

							<h3>
							    Sunrise at Masada
							</h3>
							<p>
								Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/6.jpg"} class="img-responsive" />
							</div>


							<h3>
                                NEGEV - ISRAEL’S MAJESTIC DESERT
                            </h3>
                            <h3>
                                Where Adventure and Inspiration Await
                            </h3>
                            <p>
                              An ideal destination for travelers who love adventure in the great outdoors.
							  The south of Israel is sparsely populated, but packed with fascinating sites and activities.

                            </p>
                            <p class="p-margin">
                                With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset.
								A desert but definitely not deserted, there is so much to see and do here – there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert.
								Simply put, this majestic Southern region is one of the country’s greatest assets and an absolute must on the itinerary.

                            </p>


							<h3>
                                Sde Boker
                            </h3>

                            <p class="p-margin">
                                A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50’s.
                                Sde Boker is renowned as the home of David Ben Gurion, Israel’s first Prime Minister whose home is now a museum open to the public.


                            </p>

                            <h3>
                                Vidor Center
                            </h3>

                            <p class="p-margin">
                                A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.
                            </p>



                            <h3>
                                Nevatim
                            </h3>

                            <p class="p-margin">
                               A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world.
                               The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.
                            </p>

                            <h3>
							   MidBurn Festival
							</h3>

							<p class="p-margin">
								Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.
							</p>

							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/QL3BGy2p77g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

							<br>

                            <h3>
                                The Bedouin Experience
                            </h3>

                            <p>
                               The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.
                               A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/8.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
                                The Culinary Queens of Yeruham
                            </h3>

                            <p class="p-margin">
                              For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham – a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors.
                              Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.

                            </p>
                            <h3>
                                The Old City of Be'er Sheva
                            </h3>

                            <p class="p-margin">
                               Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.
                            </p>
                            <h3>
                                Carasso Science Park
                            </h3>

                            <p>
                               New in the Old City of Be’er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel.
                               Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.

                            </p>
                            <h3>
                                Arad
                            </h3>

                            <p class="p-margin">
                               Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style.
                               With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.

                            </p>


							<h3>
                               Yotvata Hai-Bar
                            </h3>

                            <p>
                               The Yotvata Hai-Bar Nature Reserve is the area’s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators’ center with its live predators and small desert animals, a Nocturnal animal’s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/10.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>


							<h3>
                               Extreme Adventures
                            </h3>

                            <p>
                               The south of Israel is a total dream destination for adventure-hungry travelers.  Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/11.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
							    Camel rides
							</h3>
							<p>
								A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/5.jpg"} class="img-responsive" />
							</div>


                            <!--NEGEV - וPDATED TEXT SITES-->

                            <h3>
                                EVENTS IN THE NEGEV: CALENDAR
                            </h3>
						


							<div class="row-1 mounth-row">
					             <div class="mounths active">
					            <p id="myHeader1" data-div="newboxes1" onClick="toggleMounth(event)" href="">January <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths month-mid">
					            <p id="myHeader2" data-div="newboxes2" onClick="toggleMounth(event)" href="">February <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths" >
					            <p id="myHeader3" data-div="newboxes3" onClick="toggleMounth(event)" href="">May <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths month-mid">
					            <p id="myHeader1" data-div="newboxes4"onClick="toggleMounth(event)"  href="">June <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths">
					            <p id="myHeader2" data-div="newboxes5" onClick="toggleMounth(event)" href="">July <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>
					        </div>



					        <div class="row-2 mounth-row">
					          <div class="mounths" >
					            <p id="myHeader3" data-div="newboxes6" onClick="toggleMounth(event)" href="">August <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths month-mid">
					            <p id="myHeader1" data-div="newboxes7"onClick="toggleMounth(event)"  href="">October <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths">
					            <p id="myHeader2" data-div="newboxes8" onClick="toggleMounth(event)" href="">November <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths month-mid" >
					            <p id="myHeader3" data-div="newboxes9" onClick="toggleMounth(event)" href="">December <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					        </div>



					         <div class="newboxes" id="newboxes1" style="    display: block;"> <!--Jen-->
					                Round The Arava Race - The 63-kilometer bike race named after Yoni Friedman offers a breathtaking desert landscape, endless expanses of nature, the power of spirituality, serenity and serenity and a connection to an extraordinary sporting experience. The starting point and end of the race are in Moshav Hatzeva.<br>
					                <a href="https://www.arava-active.co.il/MenuDefault.aspx?id=4240" target="_blank">www.arava-active.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes2"><!--Feb-->
					                Darom Adom is an annual festival held during the Anemone flower's blossoming season in the northern Negev region. The festival offers agricultural tours, farmers' markets, and countryside lodging, as well as sports activities such as marches, race, bike tours through the red fields of the northern Negev and other activities such as artistic performances. The local tourism association "Shikma Besor" is responsible for the festival and its yearly activities.<br>
					                <a href="http://daromadom.habsor.co.il/" target="_blank">www.daromadom.habsor.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes3"><!--May-->
					                The cherry festival takes place in the Yatir Forest, which is the largest forest in Israel where large orchards of orchards grow, and is a 5-minute drive from Be'er Sheva. The event includes a cherry harvest for the whole family, sweet and sour snacks, baking pita bread, sheep herding, cheese gibbon, local farmers' market, klezmer melodies, climbing wall, omega and many other activities for the whole family.<br>
					                <a href="http://kinderland.co.il/events/%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%93%D7%95%D7%91%D7%93%D7%91%D7%9F-%D7%91%D7%99%D7%A2%D7%A8-2017-%D7%A7%D7%98%D7%99%D7%A3-%D7%A2%D7%A6%D7%9E%D7%99-%D7%A9%D7%9C-%D7%93%D7%91%D7%93%D7%91%D7%A0/" target="_blank">www.kinderland.co.il</a>
					        </div>

					        <div class="newboxes" id="newboxes4"><!--June-->
					                Experience the magic of Ramadan nights in Rahat - when the night becomes a day and the streets are bustling with life. Join an unforgettable tour at the most special time of the year, giving a unique glimpse into Bedouin culture in Rahat. Meet the authentic dishes, absorb the fragrances of spices and roasted coffee, discover the secrets of Rahat from local guides and enjoy street performances, Debka music and more.<br>
					                <a href="http://ramadan-nights.co.il/" target="_blank">www.ramadan-nights.co.il</a><br>
					                The Cinema South Festival, initiated by the School of Sound and Screen Arts at Sapir Academic College, started in 2002 with an emphasis on student films. Within a few years, however, became the festival an international film festival that provides a central stage for Israeli cinema, international quality and radical cinema. The festival takes place every year in June for five full days in various locations throughout the northern and western Negev. This is a festival that opens its doors to anyone, free of charge. The South Cinema Festival is produced from a unique cultural agenda relevant to the place where it was created.<br>
					                <a href="http://csf.sapir.ac.il/csf2017/csf.sapir.ac.il/index.html" target="_blank">www.csf.sapir.ac.il</a>
					        </div>
					        <div class="newboxes" id="newboxes5"><!--July-->
					               The International Fringe Festival Beer Sheva is a multi-disciplinary festival that crosses audiences and ages and constitutes a quality stage for the best Israeli and international artists from the fields of theater, dance, music, street art and the plastic arts. The festival is considered one of the major fringe events in Israel and the largest and leading cultural festivals in the south of the country. The festival was recently received by the EFFE (European Festivals Association) and is gaining a reputation as a prestigious event.<br>
					               <a href="https://www.iffb7.com/" target="_blank">www.iffb7.com</a>
					        </div>
					        <div class="newboxes" id="newboxes6"> <!--Aug-->
					               Negev Of Stars - Like every summer, the Earth passes through the shrapnel left behind by the comet SWIFT-TATTLE. These fragments penetrate our atmosphere and create a spectacular view of "shooting stars". During this time in the Negev celebratethe people the amazing experience of the Perseid Meters, a number of astronomical events - a joint observation of the meteor shower, observation points with elaborate telescopes, lectures and many other activities.
					        </div>
					        <div class="newboxes" id="newboxes7"><!--Oct-->
					                The Tamar Festival is a combination of the ideal Israeli soundtrack and the spectacular vista of Masada and the Dead Sea region. The extraordinary experience takes place with concerts over 4 days at various locations and at different times over 24 hours, when the audience ventures out to the country's most extraordinary sites and landscapes.<br>
					                <a href="http://www.tamarfestival.com/" target="_blank">www.tamarfestival.com</a><br>
					                Desert Magic Festival - The first Bedouin festival: A variety of experiential activities for the whole family that provide an authentic glimpse into the ancient Bedouin tradition.<br>
					                <a href="http://www.kesem-hamidbar.co.il/" target="_blank">www.kesem-hamidbar.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes8"><!--Nov-->
					                The Arava Film Festival is a unique event that has been going on for several years every November in the heart of the Arush Nature Reserve, adjacent to Tzukim. The films at the festival are screened in the evening and in the night, under the stars in the open air. They are the first line of international production that has been screened at world film festivals in the last year. Among the films of the festival are films for children and teenagers, as well as short films produced and filmed during the past year in the Arava. The films are screened on a giant screen and the audience can relax on a spacious and surprisingly comfortable platform, which was built especially for this purpose in the valley between the mountain cliffs of the eastern Negev.<br>
					                <a href="https://www.aravaff.co.il/" target="_blank">www.aravaff.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes9"><!--Dec-->
					                Ben-Gurion's march has been taking place for more than 20 years, at the initiative of the Ramat Negev Regional Council, following the daily sporting march of the first Prime Minister, David Ben-Gurion, during his stay in Kibbutz Sde-Boker. The march takes place on three tracks – a short track for families (7 km), a medium pathway (15 km) and a long one (22 km).<br>
					                <a href="http://www.zaadatbg.org.il/" target="_blank">www.zaadatbg.org.il</a><br>
					                 Docaviv Negev - Docaviv, the Tel Aviv International Documentary Film Festival, is the largest film festival in the city of Tel Aviv, and the only festival in Israel dedicated in its entirety to documentary films. In order to expose as wide an audience as possible to documentary work, the NPO also organizes a regional festivals: Docaviv Negev, held in Yeruham, as well as dozens of documentary film screenings at cultural centers located throughout the country. Each year, Docaviv NPO awards Israel’s largest prize for an original Israeli documentary production, and alongside it, prizes for the Best International Film Award, prizes for outstanding student filmmakers, and an additional prize within the Depth of Field framework, for innovative, inspiring documentary films from around the world.<br>
					                <a href="http://www.docaviv.co.il/" target="_blank">www.docaviv.co.il</a>
					        </div>




                            <a href="http://graphics-lapam.org.il/clients/tayarut/negev/files/assets/basic-html/page-1.html#" target="_blank">FOR MORE IMFORMATION CLICK HERE </a>


         `,
      };
    },
  },

  {
    ctg: "telavivAndJerusalem",
    isVid: false,
    id: 41,
    bgImage: "/posts/bank/46/1.jpg",
    mobBgImage: "/posts/bank/46/M/1.jpg",
    title: "Tel Aviv and Jerusalem",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Nonstop fun for the whole family</h3>

              		<p>
			Travelling with kids to Tel Aviv and Jerusalem is a fantastic experience. Both cities, as is most of the country, are extremely family oriented, and from nature to culture, there is absolutely loads of amazing attractions and exciting activities for families to enjoy together. Wherever you turn, you’re likely to find children out and about with parents, grandparents or groups.              		
		</p>
              		<p>
			With up to 300 sunny days a year, the beautiful beaches of Tel Aviv are a favorite destination for locals and tourists alike. The beaches themselves offer a fabulous combination of sun and fun the Tel Aviv boardwalk to is a great place for kids to walk, run or ride along on a bike or a mini scooter, and there are plenty of playgrounds and cafes.
              		</p>
              		<p>
			For a fun day outdoors, take a picnic basket to the lovely Yarkon Park and enjoy bike riding, boating or running around. Tel Aviv also offers a multitude of hands-on museums and exhibitions, free performances, especially in the gorgeous Tel Aviv port area and outdoor entertainment guaranteed to keep visitors of all ages entertained.
              		</p>
              		<p>
			A visit to Jerusalem will ignite the imaginations of your little ones with its quaint alleyways, unique museums and fascinating history. with shady parks, water fountains and children-oriented exhibits and shows, there’s definitely something for every age.
              		</p>
              		<p>
			An incredible variety of food will keep all the kids, and adults, of your group happy. From outdoor food stalls to sit-down restaurants there is no shortage of places to eat and most restaurants and cafés offer children’s’ meals at considerably reduced rates. 
              		</p>
              		<p>
			Your visit to Tel Aviv or Jerusalem with the young ones is guaranteed to be fun and rewarding.
			Here are just a few of the fabulous ways you can have a great family time in Jerusalem and Tel Aviv, all you and yours need to do is choose and go go go: 
              		</p>
		<div class="img-wrapper">
			<img src=${getImgUrl() + "/thingsToDo/posts/35/1.jpg"} class="img-responsive" />
		</div>
              		<h3>
              			Tel Aviv
              		</h3>
              		<p>
			<strong>"Luna Park":</strong> A fantastic amusement park in the heart of the city offering a range of fun and exciting rides and attractions for the entire family. Right across from the beautiful Hayarkon Park, the green lung of Tel Aviv.
              		</p>
              		<p>
			<strong>HaYarkon Park:</strong> The tranquil Yarkon Park on the outskirts of the busy city offers beautiful green expanses, boating on the river, cycling along the bike paths, sports fields, and much more for the whole family. Enjoy a picnic with a view of the stunning Tel Aviv Skyline.
              		</p>
              		<p>
			<strong>Hot Air Balloon:</strong> After relaxing in gorgeous HaYarkon Park, get high with a view of gorgeous Tel Aviv like you’ve never seen it before, float above the Yarkon Park in an experience that is suitable for romantic trips or family fun.
              		</p>
              		<p>
			<strong>The Observatory:</strong> While in Azrieli, be sure to check out the amazing top floor observatory located on the top floor for an 360 view of Tel Aviv the little ones will not soon forget.  
              		</p>
              		<p>
			<strong>The Planetarium:</strong> Offering a fun introduction to astronomy, you’ll be transported into space by interactive exhibits, revolving seats and informative presentations to suit the whole family.
              		</p>
              		<p>
			<strong>Safari:</strong> With the largest collection of animals in the Middle East, you can spend a wonderful day in the wild, just 15 minutes from the heart of Tel Aviv, where you can check out the rest of the city’s stunning attractions.
              		</p>
              		<p>
			<strong>HaTachana:</strong> Tel Aviv’s Old Railway Station: A delight for the whole family, the Old Train Station complex offers something for everyone with restaurants, kids activities, art galleries, street performances, and even a train carriage ride.
              		</p>
              		<p>
			<strong>Tel Aviv Port:</strong> Breath in the sea air and vies from the gorgeous marina, get some food in any of the  and check out the awesome street performances of music, magic theatre and more geared specifically for the joy of the little ones. 
              		</p>
              		<p>
			<strong>Nachlat Binyamin Street Fair:</strong> The biggest of its kind in Israel, the fair is a bright and bustling experience of crafts, live music, street performances, and cafes that will appeal to people of all ages.
              		</p>
              		<p>
			<strong>Sarona:</strong> A trendy hub of restaurants, cafes, and bars, the covered market is a popular destination for couples, groups and families looking for one of the most happening places in the city.
              		</p>
              		<h3>
              			Tel Aviv Museums
              		</h3>
              		<p>
			<strong>Tel Aviv Museum of Art:</strong> With a large number of collections, guides, creative and interactive activities, and games, the museum is a treasure for parents and children alike.
              		</p>
              		<p>
			<strong>The Museum of Natural History:</strong> Opened in 2018, the 5-floor museum with its 3,000 items, gives children the possibility to see the country’s creatures right up close.
              		</p>
              		<p>
			<strong>The Olympic Experience Museum:</strong> Available via guided tours, offering an interactive glimpse into the history of sport in Israel through multimedia exhibits that are fun for the whole family.
			Independence Hall- the birthplace of the State of Israel and the birthplace of the first Hebrew speaking city, Tel Aviv. A fascinating journey through history for the entire family. 
              		</p>
		<div class="img-wrapper">
			<img src=${getImgUrl() + "/thingsToDo/posts/35/2.jpg"} class="img-responsive" />
		</div>
              		<h3>
              			Jerusalem 
              		</h3>
              		<p>
              			<strong>City of David:</strong> An immersive archeological experience in the heart of Ancient Jerusalem including archeological digs, guided tours and a walk through an underground water tunnel.
              		</p>
              		<p>
			<strong>Night Spectacular Sound & Light Show:</strong> A stunning first of its kind show where the walls of the Citadel become the stage for a nighttime show celebrating Jerusalem’s 4,000-year-old history through sights and sounds.
              		</p>
              		<p>
			<strong>The Aquarium:</strong> One of the hottest attractions in Jerusalem, opened at the end of 2017, it offers a captivating adventure through the four seas of Israel that will thrill everyone, from young to old.
              		</p>
              		<p>
			<strong>The Time Elevator:</strong> Immerse yourself in virtual reality on a journey through the fascinating history of Jerusalem, with shaking seats and special effects that will amaze the youngsters among you.
              		</p>
              		<p>
			<strong>The Botanical Gardens:</strong> A stunning gem in the heart of the city featuring more than 6,000 species of plants from around the world, it is an interesting and tranquil location for anyone to enjoy.
              		</p>
              		<p>
			<strong>Segway Tours:</strong> Suitable for older teens to adults, Segway tours offer an unforgettable experience through fascinating areas, allowing you to enjoy the modern to the ancient character of the city.
              		</p>
              		<p>
			<strong>Mini Israel:</strong> Offering hundreds of mini replicas of Israeli landmarks, it offers a unique birds-eye view of historical, religious, and modern sites around the country.
              		</p>
              		<h3>
              			Jerusalem Museums
              		</h3>
              		<p>
              			<strong>Israel Museum:</strong> A leading art and archeological museum absorbing you in the rich history and culture of the country and its people, with exhibits to interest visitors of all ages.
              		</p>
              		<p>
			<strong>The Tower of David Museum:</strong> The historic entrance to the Old City of Jerusalem, the medieval citadel features 3D models, hidden passageways, and family tours and activities.
              		</p>
              		<p>
			<strong>Ein Yael Active Museum:</strong> Providing an experiential journey through an old Roman street, creative workshops, pita baking, and one-on-one meetings with period actors, families will love this day out.
              		</p>
              		<p>
			<strong>The Bloomfield Science Museum:</strong> A fantastic children oriented cultural and educational museum, that presents exhibitions and interactive exhibits on subjects of science and Technology. 
              		</p>

            	`,
      };
    },
  },

  {
    ctg: "telaviv",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    id: "Party_Capital",
    bgImage: "/posts/bank/party-capital/1.jpg",
    mobBgImage: "/posts/bank/party-capital/M.jpg",
    title: "Party Capital",
    smltitle: "",
    html: function() {
      return {
        __html: `

						<div class="ac-cradit">
							<span class="ac-cradit-text">Credits:</span>
								<br/>
								<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
								<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
							</div>
							<p></p>
						</div>

                            <h3>Epic Nights in the non stop city</h3>
              		        <p>Tel Aviv is rightly famous as one of the world’s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that’s pulsing with life.</p>

                            <h3>Tel Aviv by Night</h3>
                            <p>No matter what time it is, there’s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv’s pumping, pulsing clubs to dance the night away.</p>
                            
                            <p>Foodies will love the amazing cocktails mixed by Tel Aviv’s expert baristas, Israel’s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>
                            <div class="img-wrapper">
			                    <img src=${getImgUrl() +
                            "/posts/party-capital/1.jpg"} class="img-responsive" />
		                    </div>
                            <h3>Making the Most of Tel Aviv’s Nightlife</h3>
                            <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you’ll be introduced to some of Israel’s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv’s new and exciting gallery bars that display pieces by up and coming artists.</p>

                            <p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv’s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn’t reach full swing until 2am in most of Tel Aviv’s wildly popular nightclubs, manned by top DJs. You’ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>

                            <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you’ll find countless places to hang out at every hour of the day and night.</p>
                            <p>Tel Aviv’s awesome nightlife scene has become famous worldwide. The city the doesn’t stop is teaming up with endless possibilities designed for an epic night out! </p>
                            <p>Start slow and easy in a bar at the chilled out Port of Tel Aviv, or grab yourself a shoreline table, perhaps at Jerusalem Beach. Order a beer, feel the sand between your toes, and watch the sunset.</p>
                            <p>Now that you’re in a mellow mood, it’s time to get your groove on. you’ll be spoiled for choice with upscale clubs, bracelet bars, and other hangouts around Tel Aviv’s White City, Rothschild Boulevard and nearby streets (Levontin, Yehuda HaLevi, Lillenblum, and Allenby), with their trendy see and be seen vibe, filled with young party people all night long. </p>
                            <div class="img-wrapper">
			                    <img src=${getImgUrl() +
                            "/posts/party-capital/2.jpg"} class="img-responsive" />
		                    </div>
                            <p>A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.</p>
                            <p>Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.</p>
                            <p>Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv! </p>

            	`,
      };
    },
  },

  {
    ctg: "general",
    isVid: false,
    id: "Mamilla_Avenue",
    bgImage: "/posts/bank/mamila-avenue/1.jpg",
    mobBgImage: "/posts/bank/mamila-avenue/M.jpg",
    title: "MAMILLA AVENUE",
    smltitle: "",
    isVid: true,
    vidId: "V0Acsw3Hf_M",
    html: function() {
      return {
        __html: `
                                <p>In the seam between old and New Jerusalem, opposite the breathtaking view of the Old city walls and only few steps away from Jaffa Gate and the western wall, you'll find Alrov Mamilla Avenue. The modern open-air street mall, became popular with locals and tourists alike thanks to its proximity to the Old city and because it bring together the best of all worlds - Rich history, local culture, and sophisticated retail experience in a word-class prime location.</p>
                                <h3>Discover the modern entertainment complex at the foot of Jerusalem's Old City</h3>

                                <p>Walk on the Jerusalem stones paved streets and look for the plaques that tell the stories of the area's historical structures. Enjoy the street theatre performances, sit at one (or more) of the local restaurants and cafes and enjoy a large quality blend of designer shops of local and world-leading brands.</p>

                                <p>In the evening, sit in one of the excellent bars in the area, raise your head and look over to see the spectacular view of the old city in front of you. There's no other place like this in the world.</p>
                                <div class="img-wrapper">
			                         <img src=${getImgUrl() +
                                 "/posts/mamila-avenue/1.jpg"} class="img-responsive" />
		                         </div>

							     <h3>Visit the streets that bridge between old and New Jerusalem</h3>

                                <p>Mamilla Avenue is a contemporary entertainment complex that offers its visitors a taste of the rich, original and always innovative Jerusalem culture.</p>

                                <p>To fully experience what Mamilla Avenue has to offer, the best time to visit is when the weather is warm. Thousands of people stroll the avenue every night during the summer and enjoy a variety of cultural events. Join them as see enjoy the street art fairs, open exhibitions, street theater, clown, acrobats, drummers and daily musical performances. With so much to see and do, you'll never want to leave.</p>
            	
            	`,
      };
    },
  },

  {
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    id: "First_Time_In_Jerusalem",
    bgImage: "/posts/bank/first-time-in-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/first-time-in-jerusalem/M.jpg",
    title: "FIRST TIME IN JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>The must list for the first-time visitor</h3>

              		<p>
						Scour the globe it’s hard to match Jerusalem for history, culture, and significance! So rich in sites and activities, it’s difficult to know where to begin. Here are a few suggestions…
              		</p>
					<p>
						Jerusalem is the nexus of three of the world’s great faiths. As such, you might want to consider religious, spiritual, or historical locations that will be meaningful to you.
					</p>
					<p>
						Almost any itinerary will include Old City. Famous as the home of the Western Wall, and the Church of the Holy Sepulcher, you could spend days exploring its four quarters – Jewish, Christian, Muslim, and Armenian – and only see but a small part of its many treasures. Make sure to download the free Audio Tours of Jerusalem app, which offers dozens of walking routes, GPS maps, and geo-location alerts as you approach each site.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/first-time-in-jerusalem/1.jpg"} class="img-responsive" />
					</div>
					<p>
						A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.
					</p>
					<p>
						Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.
					</p>
					<p>
						Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!
					</p>
            	`,
      };
    },
  },

  {
    ctg: "telaviv",
    isVid: false,
    id: 44,
    bgImage: "/posts/bank/travelling-on-budget/1.jpg",
    mobBgImage: "/posts/bank/travelling-on-budget/M.jpg",
    title: "TRAVELLING ON A BUDGET",
    smltitle: "",
    html: function() {
      return {
        __html: `

				    <h3>Making It Count in Tel Aviv and Jerusalem!</h3>

              		<p>
						So you’ve heard of the stunning beaches, the amazing sights and the fabulous cuisine and you are looking to travel to Jerusalem and Tel Aviv, but affordability is a concern. Well, pack your bags and worry no more! Both cities offer low-cost accommodations, transportation, and meals, as well as countless sites to see and things to do, which require little or no expense.
              		</p>
					<p>
						For affordable accommodation you can choose from the many hostels and smaller hotels, many of which are located only a few minutes’ walk from Tel Aviv’s Beaches and Jerusalem’s main attractions.
					</p>
					<p>
						Getting around? In both cities it’s a snap with a Rav Kav card. Purchase one for little more than a dollar at”Al Hakav” (on the line) Service centers at central stations and other locations around the city. Jerusalem also offers an affordable City Pass option, and in Tel Aviv, the Tel Ofan bicycle rental municipal service is a great and low cost way to get around in the city.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/80/1.jpg"} class="img-responsive" />
					</div>
					<p>
						What to do? Jerusalem and Tel Aviv are packed with sites, marketplaces, parks, nearby nature reserves and hiking trails. There are endless ways to not spend a dime and fill your trip with unforgettable experiences.
					</p>
					<p>
						Finally, everyone’s gotta eat, from hummus to gourmet, both cities are famous for great street food and low-price restaurants offering cheap lunch time dining.
					</p>
					<p>
						So come visit Tel Aviv and Jerusalem where you are guaranteed a fantastic time without breaking the bank.
					</p>
            	`,
      };
    },
  },

  {
    ctg: "jerusalem",
    isVid: false,
    id: 45,
    bgImage: "/posts/bank/jerusalem1/1.jpg",
    mobBgImage: "/posts/bank/jerusalem1/M.jpg",
    title: "UPSCALE JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h3>Modern luxuries for the pampered traveler</h3>
              		<p>
						When it comes to luxury travel, high class accommodations, fine dining, and top-drawer shopping options Jerusalem is a city that’s truly arrived.
              		</p>
					<p>
						The city features numerous 5-star and boutique hotels ready to custom cater to your needs for comfort and relaxation, offering amazing rooftop views and inhouse spa treatments to boot.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/81/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Looking to delight your palette? Well, in 2018, several Jerusalem establishments were listed in the prestige French restaurant guide, Gault & Millau. Beyond that, the city features and is increasingly attracting some of the world’s best chefs.
					</p>
					<p>
						When it comes to style, fashion, and swanky shopping, Jerusalem has any number of places you’ll want to visit. Among these are Arlov Mamilla Avenue. This happening and trendy outdoor mall complex is a must for your go-to city destinations. Even better, it’s situated just steps away from the Old City’s Jaffa Gate.
					</p>
					<p>
						Another not-to-be-missed stop on your itinerary is the elegant The First Station. For over 100 years a railway depot, the site has been transformed into an urban shopping and culinary mecca that’s chock-a-block with restaurants, shops, art galleries and an artists’ marketplace three days a week, as well as live performances and more.
					</p>
					<p>
						And as long as you’re in the neighborhood, treat yourself to a romantic afternoon or evening on Emek Refaim Street, the German Colony’s main thoroughfare. Its beguiling architecture laid back mood, stylish boutiques, intimate restaurants, and 1920s-era cinema offer an absolute treat for all the senses.
					</p>
            	`,
      };
    },
  },

  // End Posts

  {
    id: 5,

    ctg: "deadsea",
    isVid: false,
    bgImage: "posts/bank/100/1.jpg",
    mobBgImage: "posts/bank/100/M.jpg",
    title: "Dead Sea Joys",
    smlTitle: "",
    html: function() {
      return {
        __html: `
					<h3>For a floating good time</h3>

			              <p>
			                              A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. 
			                              Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. 
			                              <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, 
			                              allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. 
			                              While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
			              </p>

			              <p>
			                              Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
			              </p>
			              
			`,
      };
    },
  },

  {
    id: "Ultimate_Beach_Fun",
    bgImage: "/posts/bank/17/1.jpg",
    mobBgImage: "/posts/bank/17/M.jpg",
    title: "ULTIMATE BEACH FUN",
    ctg: "telaviv",
    isVid: true,
    vidId: "I9a4BFWO_6w",
    smltitle: "",
    html: function() {
      return {
        __html: `
              
              
                
            		<p>Israel has a wide selection of beaches to choose from. The wide Mediterranean stretch along the west side of the country boasts wide golden sands and the gorgeous blue waves of the med.</p>
                                

        		 	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/24/1.jpg"} class="img-responsive" />
						
					</div>

            		<p>Up North the Sea of Galilee have some lovely beaches where you can camp out, barbeque and really make a day of it. The Galilee offer boat hire and water sport equipment for some water fun!</p>

            		
            	 `,
      };
    },
  },

  {
    id: "Purchases_In_Israel",
    bgImage: "/posts/bank/purches-in-israel/1.jpg",
    mobBgImage: "/posts/bank/purches-in-israel/M.jpg",
    title: "UNIQUE PURCHASES IN ISRAEL",
    ctg: "jewish",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
              
              
                
            		             <p>Shopping in Israel is more than acquiring things; it becomes the best way to think about your loved ones and friends at home, because you’ll be bringing them (and yourself) a bag, bottle, or box symbolizing the wonders you experienced. As you amble through markets, shops and galleries, you’ll see the incredible variety of products means you’ll find something for everyone and have fun while you’re doing it.</p>
                                <div class="img-wrapper">
						               <img src=${getImgUrl() +
                             "/posts/purches-in-israel/1.jpg"} class="img-responsive" />
						
					               </div>
                                 <h3>Beautiful Middle Eastern souvenirs</h3>

                                 <p>Some of the most meaningful mementos are waiting for you at Israel’s holy places in Galilee and Jerusalem. Eye-catching blue and white Armenian pottery items adorned with familiar themes from the holy places are popular as keepsakes, and useful as serving dishes. Olive wood and mother-of-pearl,  crafts that are centuries old, now adorn Bibles, boxes, broaches and many other items that will keep your visit fresh in your mind and heart.</p>

                                 <h3>Unique Judaica</h3>

                                 <p>And what better way to remember Safed, Jerusalem, Jaffa or other Judaica centers than to adorn a Sabbath and holiday table at home with a hand-embroidered Challah- or matzah-cover (lightweight and easy to pack!) or candlesticks, a Kiddush cup or Chanukkah menorah in contemporary or traditional silver, pewter, glass or pottery. Mezuzahs are the perfect housewarming present, and a prayer shawl is a life-long Bar/Bat Mitzvah keepsake.</p>

                                 <h3>Dead Sea mineral products</h3>

                                 <p>Israel is home to the word’s largest open-air spa – the Dead Sea – and after bathing in its mineral-rich water, your skin and hair feel silky-smooth. And yes, they do bottle it! You can buy a whole range of Dead Sea mineral products, all beautifully packaged, for the perfect present from Israel.</p>

                                 <h3>Shopping</h3>

                                 <p>You’ll certainly want to browse the factory-outlet racks or boutiques of Israel’s world-famous clothes designers while you’re here. Cute 100% cotton Israeli-made baby clothes are also easy to tuck into your burgeoning suitcase and make a great shower gift. Did you walk your feet off in Israel? Before your trip ends, pick up a pair of walk-on-air sandals or shoes made in Israel, at prices that can’t be beat at home.</p>

                                 <h3>Jewelry</h3>

                                 <p>Israeli jewelry designers star in fine stores everywhere and when you buy in Israel you’re at the source. Particularly alluring are trendy bangles with their mutli-colored crystals and beads in seemingly endless patterns, as well creations in fine green-blue malachite (Eilat stone), which that everyone will know you’ve been to Israel when you wear.</p>

                                 <p>Israel has long been famous for its cut and polished diamonds, and the experience, knowledge and skill of its diamond experts. And as a diamond-exporting country, purchases in Israel often enjoy a price advantage. You can also tour a diamond cutting and polishing facility to learn all about the industry.</p>

                                 <h3>Don 't forget the food</h3>

                                 <p>In a country famous for cuisine from the four corners of the earth packaged food products are great to take home. There are spices like the biblical hyssop for your favorite chef, and sweet dates handsomely packaged for passing around at your office or book club, and a variety of herbal teas, honey, prize-winning wines and other products.</p>

                                 <p>And when you and your gifts get to the airport, you’ll love the special incentive of a Value Added Tax rebate in purchases over $100 from participating stores.</p>
                           
            	 `,
      };
    },
  },

  {
    id: "Jerusalem_Fun",
    bgImage: "/posts/bank/jerusalem-fun/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-fun/M.jpg",
    title: "JERUSALEM FUN",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    smltitle: "",
    html: function() {
      return {
        __html: `
              
                               <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
                                <div class="img-wrapper">
						               <img src=${getImgUrl() +
                             "/posts/jerusalem-fun/1.jpg"} class="img-responsive" />
						
					               </div>
                                 <p>To check it out, make your way to the <b>City Center</b> and explore the narrow streets just off <b>Jaffa Street</b>. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. <b>Rivlin Street</b> is a popular hangout for young people, while <b>Shoshan Street</b> and the surrounding area offers a more laid-back grown up vibe.</p>

                                 <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing.</p>
                                 <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session.</p>

                                 <p>For a daytime change of pace head to the <b>German Colony (Moshava)</b> and, particularly, the neighborhood of <b>Baka</b>. Start at <b>Beit Lechem Street</b> where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up <b>Emek Refaim Street</b> or through <b>HaMesila (Railway) Park</b> until you reach The <b>First Station</b> – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>
                           
            	 `,
      };
    },
  },

  {
    id: "Western_Wall_Wonders",
    bgImage: "/posts/bank/jerusalem3/1.jpg",
    mobBgImage: "/posts/bank/jerusalem3/M.jpg",
    title: "WESTERN WALL WONDERS",
    ctg: "jewish",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
              

				<p>
					The Western Wall (or Kotel, in Hebrew) was part of the most magnificent building Jerusalem had ever seen, which was the Second Temple, built by the great King Herod.
				</p>

				<p>
					The Second Temple was destroyed in the year 70 CE and despite the destruction that took place, all four of the Temple Mount support walls remained standing.  Throughout the generations since the Temple’s destruction, the Western Wall was the remnant closest to the site of the Temple’s ‘holies of holies - a place where only the Jewish High Priests were allowed, as it was there they believed God was present.  The actual remains of the Temple can be found the Western Wall Tunnels, which are an extraordinary journey through time.
				</p>
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/27/1.jpg"} class="img-responsive" />
				</div>

				<p>
					For centuries Jewish People from around the world have been going there to mourn the loss of this grand temple. You will often find hundreds of people of different nationalities and religions’ pouring out their heart with prayers as the wall is believed to have enormous spiritual significance. 
				</p>

				<p>
					It is tradition for the people that visit to write a note and place it in the cracks of the Western Wall, as it is believed the message will be taken to God. You will often find doves resting in the crevices of this impressive structure, which are a symbol of peace.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/27/2.jpg"} class="img-responsive" />
				</div>

				<p>
					The Western Wall is a national symbol as the ancient bricks have seen Israel and the Jewish peoples  birth, exile and redemption. It’s a very popular location for national ceremonies and even Bar Mitzvah to take place
				</p>
				<p>
					For more information   <a  target="_blank" href="//www.thekotel.org">www.thekotel.org</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: "White_City_Splendor",
    bgImage: "/posts/bank/white-city-splendor/1.jpg",
    mobBgImage: "/posts/bank/white-city-splendor/M.jpg",
    title: "WHITE CITY SPLENDOR",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
              
				

				<p>
					Tel Aviv’s “WHITE CITY” is a UNESCO World Heritage Site, because the city is home to more Bauhaus, modern and “International” architecture than any city on earth.
				</p>

				
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/28/1.jpg"} class="img-responsive" />
				</div>

				<p>
					Tel Aviv was founded in 1909 as a garden suburb of the crowded port city of Jaffa. Very quickly it grew into a bustling metropolis so that by 1929, it was a flourishing city that was the apex of the Zionist dream. With the rise to power of Hitler in 1933, dozens of German Jewish architects escaped to Palestine – many of whom were students or graduates of the legendary Bauhaus school of design. The burgeoning of Tel Aviv required more and more buildings, and the arriving architects very quickly adapted their northern European Bauhaus design to the needs of the eastern Mediterranean heat. A walk through central Tel Aviv will bring you face to face with dozens of these extraordinary office buildings, apartment buildings and stores.
				</p>

				<p>
					<a  target="_blank" href="//www.bauhaus-center.com/">www.bauhaus-center.com/</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: "Tower_Of_David_Museum",
    bgImage: "/posts/bank/jerusalem6/1.jpg",
    mobBgImage: "/posts/bank/jerusalem6/M.jpg",
    title: "TOWER OF DAVID MUSEUM",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
            

				<p>
					Jerusalem’s Citadel, known as the “Tower of David”, is a historical and archaeological asset of international significance. The Tower is a medieval fortress that is located near the Jaffa Gate, the historical entrance to the Old City and has been the symbol for the city of Jerusalem for generations.
				</p>

				
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/1.jpg"} class="img-responsive" />
				</div>

				<p>
					At the Tower of David Museum you are presented with Jerusalem’s astounding story. While absorbing yourself in legends of the past and their dramatic chronicles it will not take you long to realise that the very stones of the museum are part of this city’s living history.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/2.jpg"} class="img-responsive" />
				</div>


				<p>
					The 500-year-old walls are part of the Turkish citadel; its name derives from a tower so massive that early Jerusalemites ascribed it to their great King David and despite the name being ‘The Tower of David’ it was actually build by King Herod.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/3.jpg"} class="img-responsive" />
				</div>

				<p>
					Your visit can begin with a breath-taking view of old and new Jerusalem from the top of the tower. Each ancient room has been revamped to showcase a different period, allowing the tempestuous events of 4,000 years to fall perfectly into place in your mind.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
				</div>

				<p>
					The windows frame glimpses of modern Jerusalem, and with each doorway you exit, you look down into the citadel’s central courtyard, where archaeologists have unearthed remains dating from the Maccabees to the Middle Ages. This incredible site really is a maze of time!
				</p>

				<p>
					The museum also utilizes its unique space for multi-sensory exhibits by leading designers and artists from Israel and abroad. This One of a kind museum hosts the annual ‘Night Spectacular’ which is a unique sound and light show where the whole of the Citadel is lit up with stunning designs!
				</p>

				<p>
					For more information:   <a href="//www.tod.org.il/en/">www.tod.org.il/en/</a>

				</p>
                
            	 `,
      };
    },
  },

  {
    id: "Must_Eat_In_Jerusalem",
    bgImage: "/posts/bank/must-in-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/must-in-jerusalem/M.jpg",
    title: "MESMERIZING AND MAGICAL CITY",
    ctg: "jerusalem",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smltitle: "",
    html: function() {
      return {
        __html: `
            
                                <p>
						            Jerusalem is a mesmerizing and magical city. Many people who visit Jerusalem rave about the amazing atmosphere, the unforgettable sites, the breathtaking views and more. However, to truly understand what Jerusalem is all about, there are some things that you simply have to experience through your stomach. Here are just a few of the things you really should try while visiting Jerusalem:
						        </p>
                               <div class="img-wrapper">
						                 <img src=${getImgUrl() +
                               "/posts/must-in-jerusalem/1.jpg"} class="img-responsive" />
				                 </div>

							    <p><strong>Malabi:</strong> A unique a combination of beverage and dessert, made of a mixture of rosewater, milk, cornstarch and sugar. Malabi is a very popular Jerusalem dish, sold in many middle eastern restaurants and kiosks throughout the city. Guaranteed to be nothing like anything you have ever tasted.</p>

                                <p><strong>Knafe:</strong> A very interesting and sensationally tasty dish when served and eaten fresh. Knafe is essentially an Arabic desert made of melted goats cheese and topped with hairs of orange pastry hairs, dipped in sweet rosewater syrup. Finding the perfect Knafe is a mission, once you find it, eating it becomes an addiction.</p>

                                <p><strong>Jerusalem Pretzel:</strong> An absolute must when touring the fascinating sites of the old city is stopping by one of the small green carts and purchasing an authentic Jerusalem pretzel. Along with it, you will get a fragrant local green herb called Zaatar which goes great with the delicious warm doe.</p>

                                <p><strong>“Meorav Yerushalmi”:</strong> Directly translates to “Mixed Jerusalem” this delicious mix of different meats in a special local blend of spices is an absolute carnivores’ heaven.</p>

                                <p><strong>“Ashtanur”:</strong> Short in Hebrew for “fire in the oven” Ashtanur is an authentic local pitta bread which you can find in midtown or the markets during lunchtime. If you’re especially hungry, try it wrapped around a portion of shawarma or falafel.</p>

                                <p><strong>Sabich:</strong> an absolute original, the Sabich is a truly unique local dish comprised of a Pitta bread packed with fried eggplant, hard-boiled eggs, and pickles, usually topped by Amba, a local, flavorful condiment. Once you try it, you’ll be hooked for life.</p>
                                
                
            	 `,
      };
    },
  },

  {
    id: "Jerusalem_Arts",
    bgImage: "/posts/bank/jerusalem-art/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-art/M.jpg",
    title: "JERUSALEM’S ART",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
            
                                <h3>Finding Inspiration in Jerusalem</h3>

                                <p>There's no doubt Jerusalem is one of the most fascinating cities in the world. Its fusion of diverse religions, traditions, ancient history and modern city life intrigues visitors for centuries. It's also what attracts artists there. Today's Jerusalem is full of Museums, galleries, marketplaces and cultural festivals, which together form a vivid and unique Art and Culture scene. Prepare to be inspired.</p>

                                <p>Discover. On a hill next to the Knesset and Israel's Supreme Court, situated Israel's largest cultural institution and one of the world's leading museums in art and archeology, The Israel Museum. Start with the archeological wing. Organized chronologically, the pieces there form the most extensive collection in the world for biblical and Holy Land archeology. Continue to the outstanding Jewish Art and Life wing, the impressive Fine Arts collection and the rotating contemporary art exhibitions. Don't miss few of the museum's highlights – The Shrine of The Book which holds the Dead Sea Scrolls and the stunning Art Garden looking over the Jerusalem Mountains. Tip: Give yourself time. It's an accessible, fascinating museum and there's so much to see.</p>
                                <div class="img-wrapper">
						                <img src=${getImgUrl() +
                              "/posts/jerusalem-art/1.jpg"} class="img-responsive" />
				                </div>
							    <small style="color:#000; display:block;">
                      		        Credit: Noam Chen
                      	        </small>

								<p>In close proximity to the Israel Museum you'll find the riveting <strong>Bible Lands Museum</strong>. Describes as "an interactive time capsule", it's the only museum of its kind in the world. Tour through the galleries and discover the wonders of the lives of ancient cultures in the Near East and their interrelations from the dawn on of civilization to the early Christian era.</p>

                                <p><strong>Experience</strong>. Go to <strong>The Artists' Colony of Jerusalem</strong> (Hutzot Hayotzer) and experience creativity. This Art and Craft complex is a workplace for artists and designers from various fields. Stroll down this picturesque boulevard of shops and galleries underneath the northern walls of the Old City and see artists at work. Hear stories, learn about traditional and more contemporary art techniques and purchase works directly from the artists.</p>

                                <p>See the <strong>Tower of David Light Show</strong>, known as the Jerusalem Night Spectacular. This truly stunning show combines modern technology with the city's history and the beauty of the Tower. You'll witness the walls and walkways comes alive with a 3D light show and vibrant music that pulls the viewer into an almost dreamlike experience.</p>

                                <p><strong>Celebrate</strong>. Jerusalem has rich history but it's also a bustling modern city that loves to celebrate. Make sure to check the city's rich schedule of festival and cultural events and enjoy of the best Jerusalem has to offer throughout the year.</p>

                                <p>Celebrate <strong>The Israel Festival</strong>, Israel's prominent multidisciplinary international festival that presents a large variety of outstanding theatre, contemporary dance, classical music and performance from all around the world. Join the Jerusalem Arts and Craft fair Hutzot Hayotzer where you'll meet Israeli and international artists and listen to great music; visit Jerusalem Night Market and stroll through the many stalls set by all types of artists and designers, showing off and selling their wares; Experience the Light in Jerusalem Festivalthat provides a dramatic unique and artistic dimension to the old city through use of light; listen to opera in the Jerusalem Opera Festival. Set in the Sultan pool, you'll watch great performance with the great Jerusalem night summer air and stunning view as a backdrop.</p>

                                <p>Don't miss the Jerusalem Sacred Music Festival. As part of the Jerusalem Season of Culture, this extraordinary festival brings together diverse artists from huge array of fields, cultures and traditions that show and explore 'sacred' music from all around the world.</p>
            	
                
            	 `,
      };
    },
  },

  {
    id: "All_Sensory_Markets",
    bgImage: "/posts/bank/jerusalem2/1.jpg",
    mobBgImage: "/posts/bank/jerusalem2/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: "ALL SENSORY MARKETS",
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            

				<p>
					For a genuine Middle Eastern experience you can’t beat a visit to one of Israel’s many markets (Shuks).  The different colours, textures, smells, tastes and sounds of these hives of activity can be a highlight of any Israel visit.  
				</p>

				<p>
					These markets are a melting pot of cultures and a great place to give your bartering skills a go. Through the winding cobbled streets you will find, fresh produce, souvenirs, art and handmade jewellery…the list is endless. Bring home a gift for your friends and family or just enjoy walking around and tasting different flavours.
				</p>
				
				
             	<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/1.jpg"} class="img-responsive" />
				</div>

				<h3>
					Tel Aviv
				</h3>
				<p>
					The Carmel Market, or Shuk HaCarmel, is the most famous of all Tel Aviv’s marketplaces. In recent years, it’s even joined the ranks of Tel Aviv’s trendy spots for bars, restaurants, coffee shops and chef-owned food stalls. It’s no wonder Shuk HaCarmel is Tel Aviv’s largest and most-centrally located shuk: From hand-made Jachnun, a traditional Yemenite dish, to boutique cheeses, and from one-off cotton clothes to designer threads, HaCarmel has it all. Plan your visit around your tastebuds and food preferences - salted fish, cured meats, Middle Eastern fare, fresh baked French pastries, and local-roasted coffee or fresh-pressed fruit or vegetable juice blends to wash it all down.
				</p>

				<p>
					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
						www.shuktlv.co.il/en/category/carmel-market
					</a>
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/2.jpg"} class="img-responsive" />
				</div>

				<p>
					Nachlat Binyamin arts and crafts fair was established in 1988. It is the oldest and biggest of its kind in Israel, and one of the nicest in the world. The market is home to over two hundred artists who use materials such as wood, glass, fabric, plastic, paper…even rocks (almost anything) to hand-make what they sell on their stall. 
				</p>

				<p>
					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
						www.shuktlv.co.il/en/category/carmel-market
					</a>
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/3.jpg"} class="img-responsive" />
				</div>
				<h3>
					Jerusalem
				</h3>

				<p>
					The Machane Yehuda market is widely recognized as a symbol of the Jerusalem, and for a very good reason: Jerusalemites see it as a place that represents them, symbolizes them, and gives them a unique identity in a larger Israeli social context. Jerusalem today has many shopping and entertainment centres, but there is something about the Machane Yehuda market that attracts people, even without a shopping list.  From the heady scent of spices to the colourful displays of fruits and vegetables, a trip to this market is pleasing for all your senses.
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
				</div>

				<p>
					One option of experiencing this market is by buying a ‘Machane Yehuda Bites Card’.  This card is comprised of vouchers curated in order to give you a chance to try a variety of products, flavours and the aromas of the market - without having to depend on an organized group or tour.  For more information please click here: 
				</p>

				<p>
					<a target="_blank" href="//www.machne.co.il/en/">
						http://www.machne.co.il/en/
					</a>
				</p>
				
                
            	 `,
      };
    },
  },

  {
    id: 31,
    bgImage: "/posts/bank/jerusalem1/1.jpg",
    mobBgImage: "/posts/bank/jerusalem1/M.jpg",
    title: "UNFORGETTABLE YAD VASHEM",
    ctg: "jewish",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            

				<p>
					Yad Vashem, Israel’s main Holocaust remembrance and education centre is situated on the green slopes of Har HaZikaron, (the Mount of Remembrance) in Jerusalem.
				</p>

				<p>
					Israel’s Holocaust commemoration project began in 1953 with the task of perpetuating the memory of Holocaust victims and documenting the history of the Jewish people during the Holocaust so that it will be remembered by future generations. This project was an important step for the young nation of Israel at the time and was significant for the citizens of Israel, particularly for the survivors of the ghettos and concentration camps.
				</p>
				
				
             	<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/31/1.jpg"} class="img-responsive" />
				</div>

				<p>
					The new Yad Vashem museum was opened to the public in 2005. The museum is designed in the shape of a prism penetrating the mountain. Divided into nine galleries, the museum relates the stories of the Jewish communities before the Second World War and the series of events beginning from the rise of the Nazis to power, the pursuit of the Jews, their eviction to the ghettos and ending with “the Final Solution” and mass genocide
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/31/2.jpg"} class="img-responsive" />
				</div>


				<p>
					The personal experiences and feelings of the victims of the Holocaust constitute the groundwork for the museum’s exhibits. Photographs, films, documents, letters, works of art, and personal items found in the camps and ghettos are all an integral part of the exhibits. As you exit the Museum itself is the Hall of Names, an inspiring memorial containing over three million names of Holocaust victims that were submitted by their families and relatives. Names can still be submitted by visitors to the memorial and added to the computerized archive.
				</p>

				<p>
					In addition to the Holocaust History Museum Yad Vashem has other memorials and monuments including  the Hall of Remembrance, where the ashes of the dead are buried and an eternal flame burns in commemoration; Yad Layeled, the children’s memorial, commemorating the one and a half million Jewish children who were murdered in the Holocaust;
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/31/3.jpg"} class="img-responsive" />
				</div>
				
				<p>
					The Memorial to the Deportees, an authentic railroad car hanging over the cliff on the road winding down from the mountain. The car was used to transport Jews who had been banished from their homes to the concentration camps.
				</p>

				<p>
					The Avenue of the Righteous Among the Nations has over 2,000 trees which were planted in honor of non-Jews who endangered their lives in order to rescue Jews from the Nazis; The archives and library of Yad Vashem House the world’s largest repository of material about the Holocaust;
				</p>

				<p>
					Visiting the Yad Vashem museum is an emotional and heartrending experience, but seeing the exhibits and remembering the Holocaust gives the more than one million individuals, world leaders and dignitaries who pass through its doors annually a meaningful way to commemorate the six million Jewish victims of the Holocaust.
				</p>

				<p>
					For more information   <a target="_blank" href="//www.yadvashem.org/">www.yadvashem.org</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: "What_To_Pack",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "WHAT TO PACK",
    smltitle: "",
    html: function() {
      return {
        __html: `

								<p>Israel is a modern, developed country, and you can purchase virtually anything you need during your stay, including clothing, cosmetics, and hygiene products.</p>
                                <p>If you are visiting Israel during the summer you will need lightweight clothing - short-sleeved and sleeveless shirts, shorts, sandals, beach shoes and a bathing suit.    It’s also a good idea to pack a sweater or jacket, since nights in the mountains and the desert can be cool.</p>
                                <p>If you are visiting Israel in the winter, you will need warm clothing, a coat (preferably a raincoat as well), good shoes, an umbrella, gloves, a scarf and other warm clothing.    Weather in Israel is not cold as it is in Europe, but days can be rainy and cold.</p>
                                <p>It’s a good idea to bring a small bag for day trips.    If you are traveling to Eilat or the Dead Sea, it’s a good idea to bring a bathing suit, since it is warm enough to swim there even in the winter.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/what-to-pack/1.jpg"} class="img-responsive">
							    </div>
								<p>
								Sunscreen, a sun hat, and sunglasses are essential items throughout the year.
If you are planning on hiking, you will need good shoes and a lot of water, either in a canteen or in several bottles. You will need a sleeping bag, tent, and camping equipment only if you are planning on sleeping outdoors.  Most youth hostels supply sheets and blankets.</p>

		                        `,
      };
    },
  },
  {
    id: "Electrical_Appliances",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "ELECTRICAL APPLIANCES",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>
									​The Israeli power supply is single phase 220 volts at 50 Hertz. Most power sockets in Israel have three pinholes, but many of them will work with double-pin European plugs. Visitors who want to use shavers, traveling irons and other small appliances may need both transformers and adaptor plugs.</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/electrical-appliances/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Weather",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "WEATHER",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>With around merely 40 rainy days a year on average, Israel is known for its sunny disposition, yet keep in mind this is a 4 season country. Summers are long, lasting from April to October and the height of heat and humidity is usually around July-August. Fall and winter last from November to March.</p>
<p>The southern city of Eilat enjoys nearly 360(!) sunny days a year, making it the hottest city in Israel (no pun intended).<br>
The Israeli Meteorological Service: <a href="http://www.ims.gov.il/ims/all_tahazit/" target="_blank" rel="nofollow noopener noreferrer" data-mk-aweb-org-font-size="17">www.ims.gov.il</a></p>
<p></p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/weather-planyour-trip/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Transportation",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "TRANSPORTATION",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<!--<p>Israel is a small country, which makes getting around fast and convenient. Taxis are common in Israel for urban and interurban travel and can be flagged in the street or booked via phone or designated international apps such as GetTexi.</p>
								<p>The main forms of public transportation are busses and the national train service both offering a convenient, reasonably priced means of travel to nearly every destination in the country.</p>
								<p>Train Information Services:<a href="http://www.rail.co.il" target="_blank" rel="noopener noreferrer"> www.rail.co.il</a> / Telephone: 08-6831222 or *5770</p>
								<p>Busses Information Services:<a href="http://www.bus.co.il" target="_blank" rel="noopener noreferrer"> www.bus.co.il</a> / Telephone: 1-900-72-1111</p>
								<p>Tickets can be purchased at the ticket booths in the central bus station in each city or town, or from the driver. Most of the bus lines do not run on Shabbat or on Jewish holidays. Service ends on Friday afternoon and resumes Saturday evening.</p>
								<p>Students are entitled to discounts on intercity bus lines. To receive a discount they must present an international student card when purchasing tickets.</p>
								<p></p>
								
							    <h3>Smart ride card - Rav Kav</h3>
								<p>Tourists can purchase an Anonymous Rav Kav Card. It can be purchased on board for a small fee, and then can be reloaded with a regular Multi-Ride or Single ticket, usually within the region offering a 20% discount.</p>
								<p>Tourists cannot use a Personal Rav Kav Card which has all the passenger’s personal details and is for citizens.</p>
								<p>Please note:<br>
								- The Rav Kav can be used to pay for the transportation of several passengers.<br>
								- The fee of a child is like an adult.<br>
								- The Rav Kav can be used in a region and not between regions unless specifically reloaded for the desired routes.<br>
								- In some areas, it is possible to get daily unlimited rides within that region only.</p>
								<h3>Domestic Flights</h3>
								<p>Israel is a small country, and for this reason, it is only worthwhile to consider flying between Eilat and Tel Aviv. Several companies operate flights from Eilat to Ben Gurion Airport, or Sde Dov in north Tel Aviv. Airfares are reasonable, but are higher than bus fares.</p>
								<p>There are also private companies that operate special flights from anywhere in the country upon request.</p>
								<h3>Renting a Car</h3>
								<p>Most international car rental companies and local companies have offices in the large cities and at Ben Gurion Airport. It is recommended to reserve a car in advance from abroad.</p>
								<p>To rent a car in Israel the driver must be over 24 years of age, and must hold a valid international driver’s license and an international credit card.</p>
								<p>Israel has an extensive road system and clear signage in most places (in Hebrew, English, and Arabic).</p>
								<h3>Driving in Israel</h3>
								<p><strong>The minimum</strong> driving age in Israel is 17 and the driving side of the road is the right. Speed limits are 30 to 50km/h in cities, 80-90 on freeways, 130 on highways and Route no.6. Safety belts are obligatory, and if you’re enjoying a night on the town, keep in mind there is a zero tolerance policy for drinking and driving so find a designated driver and enjoy safely.</p>
								<h3>Highway 6</h3>
								<p>Highway 6 operates as an electronic toll road with no barriers at entrances or exits and no traffic lights which allows for uninterrupted trips. Advanced computerized information systems installed along the highway include electronic tollgates, identify vehicles, categorize types of fees (subscription or unregistered) and calculate the number of highway sections each vehicle travels. Every trip is automatically tabulated and invoiced. Drivers enjoy a rich, convenient, and safe traveling experience with a speed limit of 130 kilometers per hour.</p>
								<p>Tourists renting a car will be charged via their credit card. Please inquire with the rental company the conditions and tariffs.</p>
								<p>Most Rent a Car companies do not offer insurance for the areas in the West Bank under the control of the Palestinian Authority. Tourists wishing to drive with rented cars into the areas of the Palestinian Authority are recommended to secure appropriate insurance.</p>
								-->

								<p>Israel is a small country, which makes getting around fast and convenient. Taxis are common in Israel for urban and interurban travel and can be flagged in the street,  or booked via phone or designated apps such as Gett and Yango.</p>
								<p>Busses and trains are the main forms of public transportation, both offering a convenient, reasonably priced means of travel to nearly every destination in the country.</p>
								<p>Train Information Services: <a href="//www.rail.co.il/">www.rail.co.il</a> / Telephone: <a href="tel:086831222">08-6831222</a> or <a href="tel:*5770">*5770</a></p>

								<p>Busses Information Services: <a href="//www.bus.co.il/otobusimmvc?">www.bus.co.il</a> / Telephone: <a href="tel:1900721111">1-900-72-1111</a></p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/transportation/1.jpg"} class="img-responsive">
							    </div>
								<p>Tickets can be purchased at the ticket booths in the central bus station in each city or town, or from the driver. Bus tickets can also be purchased via smart ride apps. Most bus lines do not run on Shabbat or on Jewish holidays. Service ends on Friday afternoon and resumes Saturday evening.</p>
								<p>Students are entitled to discounts on intercity bus lines. To receive a discount, they must present an international student card when purchasing tickets.</p>
								 
								<h3>Smart ride apps</h3>
								<p>As of December, 2020, public bus services can be paid for using smartphone apps. The official app is The Station and is available on Google Play for Android and on the App Store for IOS. There are also several private mobility apps on which payment can be made. </p>

								<p>The Station provides users with best options across bus, train, and more, using real-time data, taking into account schedules and the latest changes.</p>

								<p>In order to use the app, set up an account and submit your fare type, if eligible. </p>
								<p>On the bus, scan the QR sticker to validate your trip and share with the inspector if asked. </p>

								<p>For tourists or debit card holders, the app calculates the best price for your journeys at the end of each day. </p>
								<p>For Israeli credit card holders, best price is calculated and debited on a monthly basis. </p>
								<p>The apps are currently only available for travel on buses, but should soon be available on Israel Railways and the Jerusalem light rail.</p>

								<h3>Domestic Flights</h3>
								<p>Several companies operate flights between Eilat and Ben Gurion Airport. Airfares are reasonable, but are significantly higher than bus fares.</p>
								<p>There are also private companies that operate special flights from anywhere in the country upon request.</p>
								<h3>Car Rental</h3>
								<p>Most international car rental companies and local companies have offices in the large cities and at Ben Gurion Airport. It is recommended to reserve a car in advance from abroad.</p>
								<p>To rent a car in Israel the driver must be over 24 years of age, and must hold a valid international driver’s license and an international credit card.</p>
								<p>Israel has an extensive road system and clear signage in most places (in Hebrew, English, and Arabic).</p>
								<h3>Driving in Israel</h3>
								<p>Israel drives on the right hand side of the road. Speed limits are 30 to 50km/h in cities, 80-90 on freeways, 110 on highways and 120 on Highway 6. Safety belts are mandatory, and if you’re enjoying a night on the town, keep in mind there is a zero-tolerance policy for drinking and driving, so find a designated driver and get home safely!</p>
								<h3>Highway 6</h3>
								<p>Highway 6 operates as an electronic toll road with no barriers at entrances or exits and no traffic lights which allows for uninterrupted travel . Advanced computerized information systems installed along the highway identify vehicles, categorize types of fees (subscription or unregistered) and calculate the number of highway sections each vehicle travels. Every trip is automatically tabulated and invoiced. The speed limit is 120 kilometers per hour.</p>
								<p>Tourists renting a car will be charged via their credit card. Please inquire with the rental company for conditions and tariffs.</p>
								<p>Most Rental Car companies do not offer insurance for the areas in the West Bank under the control of the Palestinian Authority. Tourists wishing to drive with rented cars into the areas of the Palestinian Authority are recommended to secure appropriate insurance.</p>

            	

		                        `,
      };
    },
  },
  {
    id: "Israeli_Currency",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "ISRAELI CURRENCY",
    smltitle: "",
    html: function() {
      return {
        __html: `

								<h3>Currency exchange rates</h3>
									<p>The State of Israel’s currency is the New Israel Shekel (NIS) or shekel for short (pluralized as shkalim in Hebrew or shekels in English). There are 100 agorot (agora in singular) in each shekel. Bank notes are in denominations of NIS 20, 50, 100, and 200; coins are in denominations of NIS10, NIS5, NIS2 NIS1 and 50 and 10 agorot.</p>
									<p></p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/israeli-currency/1.jpg"} class="img-responsive">
							    </div>
							    <h3>Currency exchange rates</h3>
								<p>The State of Israel’s currency is the New Israel Shekel (NIS) or shekel for short (pluralized as shkalim in Hebrew or shekels in English). There are 100 agorot (agora in singular) in each shekel. Bank notes are in denominations of NIS 20, 50, 100, and 200; coins are in denominations of NIS10, NIS5, NIS2 NIS1 and 50 and 10 agorot.</p>
								<p></p>
            	

		                        `,
      };
    },
  },
  {
    id: "Immigration_Customs",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "IMMIGRATION & CUSTOMS",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <h3>Passport Control</h3>
                                <p>Upon arrival in Israel, visitors go to passport control and must present a passport that is valid for at least six months from the <strong>date of their departure.</strong><br>
                                   Please note, Israel has incorporated a new and modern technological system instrumental in meeting the needs of the various Immigration, security, Airport and Tourism authorities as well as providing the tourist with the credentials necessary to prove his visa status without stamping the passport. At a press of a button, the Border Control station will print a card including the principle details of the traveler as in the first page of the passport. The card will also depict the date of arrival and visa information. This card is called The “Electronic Gate Pass”.
                                </p>
                                <div class="img-wrapper">
								    <img src=${getImgUrl() +
                      "/posts/immigration-customs/1.jpg"} class="img-responsive">
							    </div>
							    <h3>The Gate Pass is an official form of identification while in Israel. We ask all tourists to keep the card at hand at all times as proof of their status.</strong><br>
										Arrival by Air and Land Crossings – Incoming travelers continue to the passenger luggage area after having their passports inspected. Carts are at their disposal. From there, they continue to customs control and to the airport exit.</p>
										<p><a href="https://www.gov.il/BlobFolder/service/group_entry_to_israel/en/land%20gateways%202017ENGLISH%20update.doc" target="_blank" rel="nofollow noopener" data-mk-aweb-org-font-size="17">Information Regarding  Israel’s Land Gateways&#8203;</a></p>
										<h3>Customs</h3>
										<p>General information regarding the laws and policies of the Customs Authority can be downloaded:<br>
										<a href="https://taxes.gov.il/English/Pages/Guides.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Pages/Guides.aspx</a></p>
										<h3>Please make note that travel through Allenby Bridge Crossing has specific limitations and directives. For example, visitors passing through the Allenby Bridge between Israel/Jordan may carry no more than the cash value of 2000 Jordanian Dinars.</h3>
										<h3>Customs and V.A.T. for Tourists:</h3>
										<p><a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a><br>
										<strong>Aside from Allenby Bridge Crossing, and for all other Gateways including airports,</strong> the following tourist guide is relevant for visitors as defined by the Customs and Tax Authority:<br>
										<a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a><br>
										<a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a><br>
										Please note: there is a two-lane customs transit system, one green and the other red, at Ben Gurion Airport and the various Crossing Points. Visitors who do not have goods to be declared may go through the green lane at the exit from the passenger arrival hall.</p>
								
		                        `,
      };
    },
  },

  // This post had moved to the Passport post/ ASked by HADAR 18.05.2020
  // {
  // 		id:"Immigration_Customs",
  //        	ctg : "TouristInfo",
  //         bgImage : "/posts/bank/plan-your-trip/1.jpg",
  //         mobBgImage : "/posts/bank/plan-your-trip/M.jpg",
  //        	isVid:false,
  //         title : "IMMIGRATION & CUSTOMS",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                               <h3>Passport Control</h3>
  //                               <p>Upon arrival in Israel, visitors go to passport control and must present a passport that is valid for at least six months from the <strong>date of their departure.</strong><br>
  //                                  Please note, Israel has incorporated a new and modern technological system instrumental in meeting the needs of the various Immigration, security, Airport and Tourism authorities as well as providing the tourist with the credentials necessary to prove his visa status without stamping the passport. At a press of a button, the Border Control station will print a card including the principle details of the traveler as in the first page of the passport. The card will also depict the date of arrival and visa information. This card is called The “Electronic Gate Pass”.
  //                               </p>
  //                               <div class="img-wrapper">
  // 						    <img src=${getImgUrl()+ "/posts/immigration-customs/1.jpg"} class="img-responsive">
  // 					    </div>
  // 					    <h3>The Gate Pass is an official form of identification while in Israel. We ask all tourists to keep the card at hand at all times as proof of their status.</strong><br>
  // 								Arrival by Air and Land Crossings – Incoming travelers continue to the passenger luggage area after having their passports inspected. Carts are at their disposal. From there, they continue to customs control and to the airport exit.</p>
  // 								<p><a href="https://www.gov.il/BlobFolder/service/group_entry_to_israel/en/land%20gateways%202017ENGLISH%20update.doc" target="_blank" rel="nofollow noopener" data-mk-aweb-org-font-size="17">Information Regarding  Israel’s Land Gateways&#8203;</a></p>
  // 								<h3>Customs</h3>
  // 								<p>General information regarding the laws and policies of the Customs Authority can be downloaded:<br>
  // 								<a href="https://taxes.gov.il/English/Pages/Guides.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Pages/Guides.aspx</a></p>
  // 								<h3>Please make note that travel through Allenby Bridge Crossing has specific limitations and directives. For example, visitors passing through the Allenby Bridge between Israel/Jordan may carry no more than the cash value of 2000 Jordanian Dinars.</h3>
  // 								<h3>Customs and V.A.T. for Tourists:</h3>
  // 								<p><a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a><br>
  // 								<strong>Aside from Allenby Bridge Crossing, and for all other Gateways including airports,</strong> the following tourist guide is relevant for visitors as defined by the Customs and Tax Authority:<br>
  // 								<a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a><br>
  // 								<a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a><br>
  // 								Please note: there is a two-lane customs transit system, one green and the other red, at Ben Gurion Airport and the various Crossing Points. Visitors who do not have goods to be declared may go through the green lane at the exit from the passenger arrival hall.</p>

  //                         `
  //     }
  //   }
  // },
  // END This post had moved to the Passport post/ ASked by HADAR 18.05.2020
  //   {
  //     id: "Frequently_Asked_Questions",
  //     ctg: "TouristInfo",
  //     bgImage: "/posts/bank/plan-your-trip/1.jpg",
  //     mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
  //     isVid: false,
  //     title: "FREQUENTLY ASKED QUESTIONS",
  //     smltitle: "",
  //     html: function() {
  //       return {
  //         __html: `
  // 								    <h3>Frequently Asked Questions about the COVID-19 </h3>

  //                                     <p>
  //                                         <ol start="1">
  // 									        <li>I am a tourist in Israel and I am concerned that I may have COVID-19, where should I go?<br/>
  // 									           <ul>
  // 									               <li>
  // 									                  If you have a fever of 100.4F (38C) or higher, cough, trouble breathing, or other respiratory symptoms, you must immediately enter self-isolation and call the 101 MDA Emergency Services Hotline for medical advice.
  // 									                <strong>
  // 									                  Do not go to an HMO clinic or emergency ward.
  // 									                </strong>

  // 									               </li>
  // 									           </ul>
  // 									        </li>
  // 									        <li>When will Israel be open to incoming visitors again?<br/>
  // 									           <ul>
  // 									               <li>
  // 									                At this moment there is not a known date in which Israel will be open to incoming visitors.

  // 									               </li>
  // 									           </ul>
  // 									        </li>

  // 									      </ol>
  //                                     </p>
  // 								    <h3>Isn’t Israel a long way away?</h3>
  // 									<p>Not nearly as far as you may think: just 10 hours from New York (it’s quicker to fly from New York to Israel than from New York to Hawaii!), or 14 hours from Los Angeles. There are about ten nonstop flights a day from North America to Israel, on Air Canada, American Airlines/US Airways, Delta, El Al Israel Airlines and United. Plus you can connect to Israel through dozens of European cities.</p>
  // 									<h3>What documents do I need to travel to Israel?</h3>
  // 									<p>For U.S. and Canadian citizens, all you need is a passport that’s valid at least six months longer than your date of arrival in Israel. (For stays up to three months, you don’t need a visa.) If you’re not a U.S. or Canadian citizen, the same conditions apply to citizens of most western countries, but just to be sure: click here.</p>
  // 									<h3>Is it safe to travel to Israel?</h3>
  // 									<p>We wouldn’t urge you to come if it wasn’t. Every year between 3 and 4 million tourists vacation in Israel – and apart from those who fall in love with an Israeli – or with Israel – they all go home again safe and sound. The planes of 90+ airlines wouldn’t fly to Israel if it weren’t safe.</p>
  // 									<h3>I hear there is a security interview before my flight…</h3>
  // 									<p>If you are flying EL AL Israel Airlines (or from Europe on Arkia Israel Airlines or Israir), please know that the security precautions taken by Israeli airlines are the stuff of legend and the envy of the world’s airlines. On check-in for your flights you will be asked a variety of questions during a security interview. Some of the questions may seem un-PC, intrusive, irrelevant or repetitive. Just answer truthfully, go with the flow and don’t lose your cool. Remember, the questions are designed to protect you and your fellow passengers. When you leave Israel, the departure process is identical to that outlined above for all airlines.</p>
  // 									<h3>What about health, medicines, vaccinations?</h3>
  // 									<p>Israel is an ultra-modern country with the world’s highest number of doctors per capita, and a health and hospital system that is the envy of the world. No vaccinations are required to visit Israel (unless you have recently been in an area where there have been epidemics of yellow fever, cholera or ebola). You can buy most standard over-the-counter equivalent of North American drugs in Israel. You can also bring supplies of your standard prescription drugs with you. (If you need to bring syringes and vials of medicine – bring along a letter from your doctor attesting to your needs, just in case.) If you need to see a doctor in Israel, check with your hotel concierge. Travel insurance (including medical coverage) is always recommended for all foreign travel.)</p>
  // 									<h3>What to wear?</h3>
  // 									<p>Like almost everywhere in the world, casual is the "rule" for everyday sightseeing. Bring good walking shoes or sneakers and "layers." Israelis (especially women) like to be “elegant casual” on evenings in Tel Aviv and Jerusalem. Some religious shrines require modest dress (arms and legs covered, and, occasionally, no pants for women). Don't forget your swimsuit and, for the Dead Sea, plastic shoes or aqausox.</p>
  // 									<h3>What about money?</h3>
  // 									<p>The Israeli currency is the Shekel (officially “New Israeli Shekel”), worth around 30 cents. Click here for the current conversion rate. On arrival in Israel, it’s a good idea to use your bank-card to withdraw some Shekels from the ATM in the arrival-halls at Ben Gurion - or change small amounts of dollars/or travelers’ checks at a bank or your hotel. There are ATM machines all over Israel and credit cards are widely accepted.</p>
  // 									<h3>Electricity</h3>
  // 									<p>Almost all hotel rooms are equipped with hairdryers, and all have shaver sockets. For other appliances, Israel's electricity is 220V A/C, single phase 50-cycles; 110V-220V transformers can be used. Israeli outlets have three prongs, but European two-prong adapters usually work. If you don’t have an adapter that seems to work, call the hotel’s front desk or visit a hardware store.</p>
  // 									<h3>Keeping in touch</h3>
  // 									<p>Most hotels have free wi-fi in the lobby, and some hotels provide it free in the room. Many hotels also have Business Centers where you can access e-mail and the internet without charge. American cell-phones that work overseas will work in Israel too. Israel is 6 or 7 hours ahead of the East Coast of the USA depending on the season.</p>
  // 									<h3>Temperatures</h3>
  // 									<p>Temperatures can vary widely so just pack for the "right" weather and you'll be fine. Seasons overlap of course, but general guidelines are:</p>
  // 									<h3>SUMMER</h3>
  // 									<p> (Jun/Jul/Aug/early Sep): Temperatures in the high 80º's, 90º's. Tel Aviv, and Tiberias will be hot and humid (like New York or Miami). Jerusalem is dryer and cooler, particularly at night. Masada and Eilat are extremely hot (110º+!)...but dry. There won't be a drop of rain.</p>
  // 									<h3>SHOULDERS</h3>
  // 									<p> (late Mar/Apr/May/late Sep/Oct/Nov): Daytime temperatures will be very pleasant: 75º-ish in most of the country (but hotter at the Red and Dead Seas). Jerusalem will be in the 70º's, 50º's in the evening. There'll be some rain - nothing torrential.</p>
  // 									<h3>WINTER</h3>
  // 									<p> (Dec/Jan/Feb/early Mar): Winter weather can fluctuate. Some winters are mild and sunny, some severe and overcast. There's often heavy rain and, in January and February, even snow sometimes. It'll probably be in the 50º's, 60º's most places, but in Jerusalem and the Galilee in the forties, and cold at night.</p>
  // 									<h3>Getting around</h3>
  // 									<p><strong>BUS</strong>: Israel has one of the world’s best and most inexpensive bus systems, with almost every city, town, village and settlement connected to the system. Click here for schedules and prices.</p>
  // 									<p><strong>TRAIN</strong>: High speed trains link Ben Gurion Airport with Tel Aviv, Jerusalem and Haifa, and there are fast and, efficient and inexpensive train service throughout much of the country. Rail travel is inexpensive and very easy to navigate. Click for full information.</p>
  // 									<p><strong>FLIGHTS</strong>: Tel Aviv and Eilat are connected by multiple flights daily aboard Arkia, El Al and Israir, and there are also flights to Haifa and the Galilee.</p>
  // 									<p><strong>TAXIS</strong>: There are taxis available in the cities, and taxi drivers are also happy to take you between cities. Check the price before you start your journey.</p>
  // 									<p><strong>SHARED TAXIS</strong>: Shared taxis or “Sherut” are very popular. There are “Sherut” stations throughout the cities. Ask at your hotel for the nearest Sherut stand.</p>
  // 									<p><strong>CAR RENTAL</strong>: Most international car rental groups have offices in Israel – and there are excellent Israeli car rental firms too. Your American or Canadian drivers’ license is valid in Israel.</p>

  // 		                        `,
  //       };
  //     },
  //   },
  {
    id: "Frequently_Asked_Questions",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "FREQUENTLY ASKED QUESTIONS",
    smltitle: "",
    html: function() {
      return {
        __html: `
		
		
		<h3>Where can I find resources and tools to market Israel to my clients?</h3>
  
		<p>The Israel Ministry of Tourism has numerous promotional assets that you can share with your clients. Please click <a href="https://agents.israel.travel/Pages/InterestsGeneral#travel-planning" rel="noopener" target="_target" style="text-decoration:underline">here</a> to find our various tools to promote our destination.</p>
		
	 <h3>Where can I learn more about selling Israel?</h3>
   
		<p>The Israel Ministry of Tourism regularly conducts training for travel advisors to help them sell our special destination. Click here to find our most recent webinars.</p>
		<br/>
		<p>You can contact one of the ministry’s national/regional office:</p>
		<p>
	   <!-- <a target="_blank" rel="noopener" href="https://www.gov.il/he/departments/topics/tourist-and-travelers-info/govil-landing-page">https://info.goisrael.com/en/office-abroad</a>
		<br/>
		or
		<br/>-->
		<a target="_blank" rel="noopener" href="https://israel.travel/contact-us/" style="text-decoration:underline">Click here</a>
		</p>
	 
	 
	 <h3>How can I find a DMC in Israel?</h3>
	 
		
		<p>
		Israel has many highly professional tour operators and service providers, please check out our “Find a Tour Operator/Hotel/Guide” section in this <a href="https://agents.israel.travel/Pages/InterestsGeneral#travel-planning" rel="noopener" target="_target" style="text-decoration:underline">website</a>
		</p>
   
	   <h3>How can I find out about hotels in the different cities in Israel?</h3>
	  
		
		<p>
		Israel has a diverse selection of hotels across the country from high end legacy luxury brands to guest houses that can be found only in Israel. There is something for everyone in every area of the country. To get started on your search, please check out our “Find a Tour Operator/Hotel/Guide” section in this <a href="https://agents.israel.travel/Pages/InterestsGeneral#travel-planning" rel="noopener" target="_target" style="text-decoration:underline">website</a> 
		 </p>
	  
	   
	   <h3>What types of travel packages can I offer in Israel?</h3>
	  
		
		<p>
		Israel offers many types of experiences to many types of travelers. In this website we highlighted main categories of travel, and you can browse and get informed about them. There are many other types of travel not listed, but very relevant, such as MICE, Voluntourism, bird watching and many more - to learn more please contact the Israel Government Tourism office in your country/region-
		 </p>
		 <p>
		 <!--<a target="_blank" rel="noopener" href="https://www.gov.il/en/Departments/DynamicCollectors/tourists-offices-abroad-english?skip=0">Click here</a>
		 <br/>
		 or
		 <br/>-->
		 <a target="_blank" rel="noopener" href="https://israel.travel/contact-us/" style="text-decoration:underline">Click here</a>
		 </p>
	   
	  <h3>How do I find a tour guide?</h3>
	   
		<p>
		Israel tour guides are renowned for their professionalism and are required to complete an 18 month training program comparable to a graduate degree. Almost any language is available. To find out more about guides please check out our “Find a Tour Operator/Hotel/Guide” section in this website 
		</p>
		<p>
		<a target="_blank" rel="noopener" href="https://info.goisrael.com/en/office-abroad">https://info.goisrael.com/en/office-abroad</a>
		</p>
	   
		 <h3>What languages are spoken by service providers in Israel (guides, drivers, restaurants etc.)?</h3>
		  <p>
		Israel is an immigrant society with more than 70 ethnicities represented in its population. While English is widely spoken, Spanish, Russian, French are also quite common. German, Portuegese, Chinese and other language service providers can generally be confirmed upon request.
		</p>
		
		 <h3>Can my client stay in one city and travel daily to different sites and areas in Israel?</h3>
	 
		<p>
		Israel is a relatively small country, it takes about 5 hours to cross from North to South, and less than two hours to cross from East to West. Most tourism sights are within two hours drive from the main cities, so tourists can be based in Jerusalem, Tel Aviv, Haifa or other central cities and take daily excursions to the majority of sites. Many itineraries include staying half of the visit in one region and the other in another, which allows touring the entire country during one visit.
		</p>
	   
		 <h3>My client has safety concerns about traveling in the Middle East after visiting Israel</h3>
   
		<p>
		Israel is one of the safest countries in the world and gets excellent reviews on surveys and online rating websites. There are no limitations of traveling into Israel after visiting other countries, and now after the recent peace agreements with many countries in the Middle East, there are almost no restrictions of entry to other countries after visiting Israel. Please also look at our general FAQ section for some more information -
		 </p>
		 <p>
		 <a target="_blank" rel="noopener" href="https://israel.travel/faq/" style="text-decoration:underline">Click here</a>
		 </p>
	  
	 <h3>I have questions about currency, visa types, health insurance etc.</h3>
   
		<p>
		Please visit our general FAQ section which has information about all the general topics and matters regarding an tourist’s visit to Israel -
		<p>
		<a target="_blank" rel="noopener" href="https://israel.travel/faq/"  style="text-decoration:underline">Click here</a>
		</p>
								   					
		                        `,
      };
    },
  },
  {
    id: "Passports_Visa",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "PASSPORTS AND VISA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <p>All visitors to Israel must hold a passport that is valid for at least six months from the date they are departing the country. People with no nationality must hold a valid laissez-passer, as well as a visa back to the country that issued it.</p>
                                <p>Visitors are entitled to remain in Israel up to three months from the date of their arrival, in accordance with the conditions of the visa issued to them. Visitors intending to work in Israel must submit a request to the Ministry of the Interior for a special visa.</p>
                                <p>Israel no longer stamps passports at airports and most Land Crossings. Nonetheless, because at times technical difficulties arise, and at times, the border control must revert to back to the method of stamping passports, we recommend that tourists continuing from Israel on to Arab countries <strong>officially request</strong> that an Israeli stamp does not appear on their passport. The tourist must notify the clerk of this request before documents are stamped.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/passports-visa/1.jpg"} class="img-responsive">
							    </div><br>
							    <h3>The “Electronic Gate Pass”</h3>
								<p>In accordance to section 13 of the law regarding entrance to Israel of 1952, an official inspector or police officer can request identification and proof of legal status in Israel. With this in mind, at a press of a button the Border Control station will print a card including the principle details of the traveler as in the first page of the passport. The card will also depict the date of arrival and visa information. This card is called The “Electronic Gate Pass” and it is a new and modern technological system instrumental in meeting the needs of the various Immigration, security, Airport and Tourism authorities as well as providing the tourist with the credentials necessary to prove his visa status. <strong>The “Electronic Gate Pass” replaces the system whereby passports were stamped.</strong> At the airport, this card allows the traveler to exit the arrival terminal without further delays.</p>
								<h3>The Gate Pass is an official form of identification while in Israel.</strong> We ask all tourists to keep the card at hand at all times as proof of their visa status. At the airport and designated Land Crossings, this card allows the traveler to exit the arrival terminal and continue to the luggage pickup area.</p>
								<h3>The tourist is asked to keep the card at hand at all times.</h3><br>
								<h3>&#8203;Tourist Visas</h3>
								<p>We welcome visitors to Israel. Many countries have a Visa Waiver Program with Israel, which allows their citizens to visit Israel without a visa arranged in advance. Before embarking on a trip, visitors desiring to stop in Israel on their way to other destinations must check if they need a prearranged tourist visa. The list of countries in the following link specifies from which countries tourists are required to present a prearranged visa.</p>
								<p><a href="http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" target="_blank" rel="noopener">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>
								<p>All Visa Waiver Program travelers must present a machine-readable passport at the port of entry in order to enter Israel without a prearranged visa; otherwise, a visa is required. This applies to tourists arriving with a passage card from countries with a Waiver Program.</p><br>
								<h3>Extension of Your Stay</h3>
								<p>&#8203;Your visa can be extended (fee required) at the Ministry of the Interior office closest to you, please call their call center at: *3450 or dial 12223450.</p>
            	                <h3>IMMIGRATION & CUSTOMS</h3>
            	                <h3>Passport Control</h3>
                                <p>Upon arrival in Israel, visitors go to passport control and must present a passport that is valid for at least six months from the <strong>date of their departure.</strong><br>
                                   Please note, Israel has incorporated a new and modern technological system instrumental in meeting the needs of the various Immigration, security, Airport and Tourism authorities as well as providing the tourist with the credentials necessary to prove his visa status without stamping the passport. At a press of a button, the Border Control station will print a card including the principle details of the traveler as in the first page of the passport. The card will also depict the date of arrival and visa information. This card is called The “Electronic Gate Pass”.
                                </p>
                                <div class="img-wrapper">
								    <img src=${getImgUrl() +
                      "/posts/immigration-customs/1.jpg"} class="img-responsive">
							    </div>
							    <h3>The Gate Pass is an official form of identification while in Israel. We ask all tourists to keep the card at hand at all times as proof of their status.</strong><br>
										Arrival by Air and Land Crossings – Incoming travelers continue to the passenger luggage area after having their passports inspected. Carts are at their disposal. From there, they continue to customs control and to the airport exit.</p>
										<p><a href="https://www.gov.il/BlobFolder/service/group_entry_to_israel/en/land%20gateways%202017ENGLISH%20update.doc" target="_blank" rel="nofollow noopener" data-mk-aweb-org-font-size="17">Information Regarding  Israel’s Land Gateways&#8203;</a></p>
										<h3>Customs</h3>
										<p>General information regarding the laws and policies of the Customs Authority can be downloaded:<br>
										<a href="https://taxes.gov.il/English/Pages/Guides.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Pages/Guides.aspx</a></p>
										<h3>Please make note that travel through Allenby Bridge Crossing has specific limitations and directives. For example, visitors passing through the Allenby Bridge between Israel/Jordan may carry no more than the cash value of 2000 Jordanian Dinars.</h3>
										<h3>Customs and V.A.T. for Tourists:</h3>
										<p><a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a><br>
										<strong>Aside from Allenby Bridge Crossing, and for all other Gateways including airports,</strong> the following tourist guide is relevant for visitors as defined by the Customs and Tax Authority:<br>
										<a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a><br>
										<a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a><br>
										Please note: there is a two-lane customs transit system, one green and the other red, at Ben Gurion Airport and the various Crossing Points. Visitors who do not have goods to be declared may go through the green lane at the exit from the passenger arrival hall.</p>
								
		                        `,
      };
    },
  },

  {
    id: "Destination_For_All",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: true,
    vidId: "QWA7qwsbbGY",
    title: "A DESTINATION FOR ALL",
    smltitle: "",
    html: function() {
      return {
        __html: `
		
		
					<p>Israel number of visitors is seeing an unprecedented growth. More and more people from around the world are fulfilling their dream of visiting Israel. The Ministry of tourism is committed to enabling everyone who wishes to visit, regardless of any possible impairment. </p>
					<p>When it comes to accessibility, Israel is a world leader in legislation. From infrastructure to service, Israel is adapt to provide a smooth and accepting stay. </p>
					<p class="ac-margin-bottom-5">Please see below links to all those that can assist and assure a smooth, pleasant and barrier free stay.</p>
				   <div class="img-wrapper">
					   <img src=${getImgUrl() +
               "/posts/destination-for-all/1.jpg"} class="img-responsive">
					</div><br>
					<h2 class="ac-margin-bottom-20">NGO's and Travel</h3>
					<p><b>Keren Kayemeth LeIsrael</b></p>
					<p><u>Accessible Forest, Parks and Sites in Israel</u><br/>
					In recent years, KKL-JNF has been working to develop suitable facilities for the physically challenged in its forests and parks. Our aim is to open nature to all sectors of the population, by creating an environment through which people with limited mobility can move safely and comfortably. We have also gone one step forward, and brought nature into the schoolyard with unique projects in special education schools.
					<a href="http://www.kkl-jnf.org/tourism-and-recreation/accessible-forests-parks-sites-israel/" target="_blank">www.kkl-jnf.org</a>
				   </p>
		
				   <p><b>Israel Nature and Parks Authority </b></p>
				   <p>INPA has worked in recent years to make its sites accessible to persons with disabilities. In all national parks, nature reserves, antiquities sites and heritage sites, work is underway to upgrade accessibility and provide access aids.<br/>
					INPA are doing everything possible to increase the number of visitors with disabilities who can tour and enjoy the sites, with all the activities they have to offer.<br/>
					On the website you can find further information and relevant maps. <a href="https://www.parks.org.il/en/accessibility/" target="_blank">www.parks.org.il</a></p>
					 
					<div class="img-wrapper">
					<img src=${getImgUrl() +
            "/posts/destination-for-all/2.jpg"} class="img-responsive">
				 </div><br>
					 <p><b>Yad Sarah for Tourists</b></p>
					 <p>Traveling abroad presents special challenges for people with special needs. Yad Sarah for Tourists offers assistance that will ensure an enjoyable and relaxing vacation for the individual with special needs and his family. Once plans are finalized with the Tourist Desk, the visitor can sit back and relax, knowing that all arrangements are in the capable hands of a Yad Sarah representative.</p>
				   
						<p> <u>Some of the services available</u>:<br/>
						 
						•  Lending of necessary medical equipment. Delivery to a hotel or residence can be arranged for a modest fee.<br/>
						•  Equipping your hotel room to make your stay more comfortable, including special beds, chairs, etc.<br/>
						•  Lending of oxygen cylinders/ concentrators.<br/>
						•  Transportation in wheelchair-locking vans, including transfers to and from the airport and sightseeing.<br/>
						•  Recommendation of tour guides specializing in guiding tourists with limited mobility and special needs including advice about tourist sites with easy access.<br/>
						<br/>
						 Yad Sarah’s personalized service is available, by prior arrangement with the Tourist Desk, for any tourist with special needs.<br/>
				
		
				 The service is available throughout Israel. <br/>
		
					For further details, or to arrange transportation or a tour, please call the Tourist Desk at <a href="tel:+97226444382">+972-2-6444382</a> or e-mail us: <a href="mailto:chaimvi@yadsarah.org.il">chaimvi@yadsarah.org.il</a></p>
					<div class="img-wrapper">
					<img src=${getImgUrl() +
            "/posts/destination-for-all/3.jpg"} class="img-responsive">
				 </div><br>
					<p><b>Access Israel</b></p>
					<p>Access Israel is a non-profit organization that promotes accessibility and inclusion for people with disabilities and the elderly in all spheres of life. Access Israel was established in 1999 by Yuval Wagner, a former helicopter pilot, who became wheelchair bound following a helicopter accident. Access Israel conducts various project to fulfill the goal of a fully accessible and inclusive society such awareness raising projects in schools, accessibility consulting for businesses, accessibility courses, sign language courses, conferences on various subjects and more. In addition, Access Israel works to promote accessibility in the Israeli law, runs an accessibility complaint center and organizes awareness raising events for the public. Access Israel promotes accessibility and inclusion in all spheres of life and in education, tourism, culture, emergency situations and more.
						<a href="https://www.aisrael.org/?CategoryID=3030" target="_blank">Accessible Tourism on Access Israel website</a></p>
		
						<p><u>LOTEM</u> is the largest organization in Israel for outdoor learning activities for children with special needs, providing outdoor educational activities as well as accessible hikes. Surin Hershko, a war hero who was severely injured in Operation Entebbe in 1976, is Founder and Chairman of LOTEM. His inspiration for LOTEM comes from the heart: “Giving children the basic right to experience life outdoors is the purpose of my life and it fills me with great joy.”
						The main site, Emek HaShalom (Valley of Peace), is a 40-acre farm located in Northern Israel, near Yokneam. Situated in the middle of a beautiful valley, the farm is surrounded by blooming nature and the peaceful flow of water. It provides a hands-on learning experience with a teaching garden, wheelchair accessible olive and wine presses, bakery, and wheelchair accessible trails.</p>
						<p><u>LOTEM</u> understands the vital role that the outdoors plays in Israelis’ lives, and the immeasurable impact making society accessible has, not just on the individual with a special need but on their family and the community as well. As part of its work to ensure that no member of society is left behind,  LOTEM provides the opportunity for children and adults with special needs to learn and participate in outdoor activities all across the country.  
						<a href="https://www.lotem.net/?page_id=386" target="_blank">www.lotem.net</a></p>
		
						<h2 class="ac-margin-bottom-20 ac-margin-top-20"> Transportation</h3>
						<p><b>Israel Airport Authority</b></p>
						<p>By law, the Israel Airport Authority is responsible for providing the physical infrastructure for the activity of the entities providing service to assisted passengers. However, according to transport regulations, the responsibility for handling assisted passengers and their baggage, from the moment of their entry into the terminal building, or their disembarkation from the aircraft, lies with the respective airline with which the passengers are flying. The actual service at Ben Gurion Airport is provided by ground handling companies. The service includes accompaniment and assistance to disabled passengers through the departure and arrival procedures.
						<a href="https://www.iaa.gov.il/en-us/airports/bengurion/pages/accessibility.aspx" target="_blank">www.iaa.gov.il</a></p>
						<p><b>These are the ground handling companies: </b></p>
						<p>Aero Handling: <a href="http://www.aerohandling.com/" target="_blank">www.aerohandling.com</a><br/>
						Laufer Aviation: GHI <a href="http://lauferghi.com/" target="_blank">www.lauferghi.com</a><br/>
						QAS: <a href="http://www.qasisrael.co.il" target="_blank">www.qasisrael.co.il</a><br/>
		
		
						</p>
						<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/destination-for-all/4.jpg"} class="img-responsive">
					 </div><br>
		
						<p>Ministry of Transportation help line (local call) <a href="tel:5678*">5678*</a></p>
						
						<p><b>Public transportation</b></p>
						<p>Trains - should you require assistance, in boarding and alighting from the train, from a staff member at the train station, please coordinate your trip with 'Israel Railways' in advance, through the website or through the service hotline on <a href="tel:*5770">*5770</a>.</p>
						 
						<p><u>'Israel Railways'</u> will do the best to provide you with the best possible service, even if you have not coordinated your trip in advance.</p>
						<p>In any case, please coordinate trips that occur between 20:00 in the evening and 06:00 the next morning, as well as trips occurring on Saturday night, in advance.</p>
						<p><u>Buses</u> – all bus lines within the city are adapted to provide service to all. Intrastate buses are partially accessible.   </p>
						<p><u>Taxis</u>– it is rare to catch an accessible taxi on the go. It is recommended to preorder from <a href="https://www.aisrael.org/?CategoryID=2657&ArticleID=64179" target="_blank">https://www.aisrael.org/?CategoryID=2657&ArticleID=64179</a>.</p>
		
		
						<h2  class="ac-margin-bottom-20 ac-margin-top-20">Accomodation</h3>
						<p>All types of accommodation in Israel, which have 7 or more rooms, is required by law to provide at least 1 accessible room. All service providers with a minimum of 25 employees are also required to have an Accessibility Supervisor. These laws can assure you that there is no corner in Israel in which the perfect accommodation solution cannot be found. A short pre-visit email coordination of expectation is always recommended. </p>
						<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/destination-for-all/5.jpg"} class="img-responsive">
					 </div><br>
						
						
						<div id="ac-left-nav">
						<h2 class="ac-margin-bottom-20 pr-fs-28 chapter-title inline-block">
											<!-- ngIf: Guide.ShowChaptersIndex -->
											<span class="ng-binding">Accessibility for those with special needs at the beaches:</span>
										</h3>
						<ul id="chaptersList" class="list-unstyled xs-mb-0">
							
								<!-- ngRepeat: chapter in Guide.Chapters -->
								<li data-show="1" class="ac-active ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope light-gray-e7-background blue-border-right-5px" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt nounderline  ng-binding reforma-bold">Northern District</span>						                  
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
								
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<li data-show="2" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Haifa District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<li data-show="3" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Central District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<div class="clear show-on-mobile"></div>
								<li data-show="4" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Tel Aviv District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li>
								<!-- end ngRepeat: chapter in Guide.Chapters --><li data-show="5" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Southern District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<div class="clear"></div>
							</ul>
						</div>
		
						<div id="res">
							<!-- ac part -->
							<div class="ac-part ac-part-1 ac-part-active">
		
								<div ng-include="chapterItem" class="row row-gov ng-scope">
									<!-- Sub Title -->
									<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
										<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
											<!-- ngIf: Guide.ShowChaptersIndex -->
											<span class="ng-binding">Northern District</span>
										</h3>
									</div>
		
									<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
										<!-- IMAGE TAG  ------->
										<!--- Image-->
		
								<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
									<div class="position-relative col-lg-10 lg-p-0">
										<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
										<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
										</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
										<!--Image desc-->
										<div>
											<div class="position-absolute">
												<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
											</div>
											<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
												<span class="small-txt ng-binding"></span>
												<span class="small-txt ng-binding"></span>
											</div><!-- end ngIf: CurrChapter.Image -->
										</div>
									</div>
								</div><!-- end ngIf: CurrChapter.Image -->
															<!-- End IMAGE TAG  ------->
		
															<div class="row row-gov no-gutters">
																<!--Content Text-->
																<div id="GuidesChapterContent-1" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
									<tbody>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Kineret Municipal Unio</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking       </strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Tzinbari</td>
											<td>Yes       </td>
											<td>Yes       </td>
											<td>No</td>
											<td>No</td>
											<td>Yes       </td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Berniki</td>
											<td>  </td>
											<td>  </td>
											<td>At the nearby Shikmim beach</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Shikmim</td>
											<td>Yes       </td>
											<td>Yes       </td>
											<td>Yes       </td>
											<td>Yes       </td>
											<td>Yes       </td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Hukok</td>
											<td>Yes       </td>
											<td>Yes       </td>
											<td>No</td>
											<td>No</td>
											<td>Yes       </td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Amnon</td>
											<td>Yes  </td>
											<td>Yes       </td>
											<td>No</td>
											<td>No</td>
											<td>Yes       </td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Kinar</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Doga</td>
											<td>  </td>
											<td>  </td>
											<td>  </td>
											<td>  </td>
											<td>Closed</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Tze’elon</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Kursi</td>
											<td>  </td>
											<td>  </td>
											<td>  </td>
											<td>  </td>
											<td>At the nearby Levanon beach</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Levanon</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Halukim</td>
											<td>At the nearby Levanon beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>At the nearby Levanon beach</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Shizaf</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Dugit – Golan</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Gofra</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Tiberias</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Guy</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Galei Kineret - Rimonim</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Leonardo Pacific</td>
											<td>  </td>
											<td>  </td>
											<td>  </td>
											<td>  </td>
											<td>Closed for renovations</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Coco Hot / Holiday Inn</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Jordan Valley Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Ein Gev Vacation</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Ginnosar</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Migdal Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Restal Magdala</td>
											<td>Yes</td>
											<td>No</td>
											<td>  </td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Mateh Asher Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Banana Beach Achziv</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Nahariya</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Sokolov</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Galil Central</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Acco</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Argaman Central</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Hatmarim</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
									</tbody>
								</table></div></div>
		
								<p>  </p>
								</div>
		
																<!--Chapters/Collapse-->
																<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
																	<!-- ngRepeat: collapse in CurrChapter.Collapses -->
																</div>
		
																<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
																<!--End of Chapters/Collapse-->
		
																<div class="col-12 xs-mb-25 lg-mb-30">
																	<!-- Files for Download-->
																	<!-- Files for Download-->
								<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
																	<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
																		<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																			<!-- horizontal line -->
																			<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																				<div class="horizontal-line"></div>
																			</div>
																		</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
																		<!--arrows subject nav  דפדוף-->
																		<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																			<!--  לדף הקודם -->
																			<!-- ngIf: CurrChapterindex > 0 -->
		
																			<!--  לדף הבא -->
																			<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																				<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																					<span class="small-txt gray-txt width-100">Next page:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																				</div>
																				<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																			</div>
																		</div>
																	</div><!-- end ngIf: !isOnPrintMode -->
																</div>
															</div>
														</div>
													</div>
		
							</div>
							<!-- ac- part -->
		
							<!-- ac part 2 -->
							<div class="ac-part ac-part-2">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Haifa District</span>
								</h3>
							</div>
		
							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
			<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
			<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
			</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
			<!--Image desc-->
			<div>
				<div class="position-absolute">
					<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
				</div>
				<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
					<span class="small-txt ng-binding"></span>
					<span class="small-txt ng-binding"></span>
				</div><!-- end ngIf: CurrChapter.Image -->
			</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
								<!-- End IMAGE TAG  ------->
		
								<div class="row row-gov no-gutters">
									<!--Content Text-->
									<div id="GuidesChapterContent-2" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table align="right" cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Kiryat Yam</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zevulun</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Haifa</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Zamir 1</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zamir 2</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Neot Kiryat Haim Central</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Bat Galim 1</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Bat Galim 2</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Hof Hacarmel Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Dor Central 2</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Neve Yam</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Aqueduct</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Jisr a-Zarka Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Jisr</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Hadera</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Kfar Yam  </td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Olga Central 2</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
		</tbody>
		</table></div></div>
		
		<p>  </p>
		</div>
		
									<!--Chapters/Collapse-->
									<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
										<!-- ngRepeat: collapse in CurrChapter.Collapses -->
									</div>
		
									<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
									<!--End of Chapters/Collapse-->
		
									<div class="col-12 xs-mb-25 lg-mb-30">
										<!-- Files for Download-->
										<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
										<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
											<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
												<!-- horizontal line -->
												<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
													<div class="horizontal-line"></div>
												</div>
											</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
											<!--arrows subject nav  דפדוף-->
											<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
												<!--  לדף הקודם -->
												<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
													<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
													<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
														<span class="small-txt gray-txt width-100"> Previous page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">Northern District</span>
													</div>
												</div><!-- end ngIf: CurrChapterindex > 0 -->
		
												<!--  לדף הבא -->
												<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
													<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
														<span class="small-txt gray-txt width-100">Next page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
													</div>
													<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
												</div>
											</div>
										</div><!-- end ngIf: !isOnPrintMode -->
									</div>
								</div>
							</div>
						</div>
							</div>
							<!-- end ac part-2 -->
		
							<!-- ac-part-3 -->
							<div class="ac-part ac-part-3">
														<div ng-include="chapterItem" class="row row-gov ng-scope">
														<!-- Sub Title -->
														<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
															<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
																<!-- ngIf: Guide.ShowChaptersIndex -->
																<span class="ng-binding">Central District</span>
															</h3>
														</div>
								
														<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
															<!-- IMAGE TAG  ------->
															<!--- Image-->
								
								<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
									<div class="position-relative col-lg-10 lg-p-0">
										<!-- ngIf: CurrChapter.Image.ClickURLRef -->
								
										<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
										</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
										<!--Image desc-->
										<div>
											<div class="position-absolute">
												<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
											</div>
											<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
												<span class="small-txt ng-binding"></span>
												<span class="small-txt ng-binding"></span>
											</div><!-- end ngIf: CurrChapter.Image -->
										</div>
									</div>
								</div><!-- end ngIf: CurrChapter.Image -->
															<!-- End IMAGE TAG  ------->
								
															<div class="row row-gov no-gutters">
																<!--Content Text-->
																<div id="GuidesChapterContent-3" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
									<tbody>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Emek Hefer Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Michmoret – Station number 1</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Michmoret – Station number 2</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>Joint with number 1</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beit Yannai</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>NeUrim Beach</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Netanya</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Kiryat Tzanz</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>HaOnot Beach</td>
											<td>אין חניה בחוף עצמו</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Ampi Beach</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Herzl</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Sironit Beach A</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Sironit Beach B</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Argaman Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Poleg Beach</td>
											<td>Yes</td>
											<td>Bathrooms only</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Hof Hasharon Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Shefayim (Ga’ash)</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Rishon Le-Zion</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 1 – Hakachol (Blue) Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 2 – Neve Hof Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 3 – Hofit Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 4 – Tel Yonah Beach</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 5 – Hayeladim (Children’s) Beach</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 6 – separate beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Gan Raveh Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Palmahim Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
									</tbody>
								</table></div></div>
								
								<p>  </p>
								</div>
								
																<!--Chapters/Collapse-->
																<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
																	<!-- ngRepeat: collapse in CurrChapter.Collapses -->
																</div>
								
																<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
																<!--End of Chapters/Collapse-->
								
																<div class="col-12 xs-mb-25 lg-mb-30">
																	<!-- Files for Download-->
																	<!-- Files for Download-->
								<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
								
																	<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
								
																		<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																			<!-- horizontal line -->
																			<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																				<div class="horizontal-line"></div>
																			</div>
																		</div><!-- end ngIf: Guide.Chapters.length > 1 -->
								
																		<!--arrows subject nav  דפדוף-->
																		<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																			<!--  לדף הקודם -->
																			<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
																				<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
																				<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
																					<span class="small-txt gray-txt width-100"> Previous page:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																				</div>
																			</div><!-- end ngIf: CurrChapterindex > 0 -->
								
																			<!--  לדף הבא -->
																			<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																				<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																					<span class="small-txt gray-txt width-100">Next page:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
																				</div>
																				<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																			</div>
																		</div>
																	</div><!-- end ngIf: !isOnPrintMode -->
																</div>
															</div>
														</div>
													</div>
							</div>
							<!-- end ac-part-3 -->
		
							<!-- ac-part-4 -->
							<div class="ac-part ac-part-4">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
					<!-- Sub Title -->
					<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
						<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span class="ng-binding">Tel Aviv District</span>
						</h3>
					</div>
		
					<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
						<!-- IMAGE TAG  ------->
						<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
		<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
		<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
		</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
		<!--Image desc-->
		<div>
		<div class="position-absolute">
			<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
		</div>
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
			<span class="small-txt ng-binding"></span>
			<span class="small-txt ng-binding"></span>
		</div><!-- end ngIf: CurrChapter.Image -->
		</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
						<!-- End IMAGE TAG  ------->
		
						<div class="row row-gov no-gutters">
							<!--Content Text-->
							<div id="GuidesChapterContent-4" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
		<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Herzliya</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Nof Yam</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Hasharon       Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Zevulun</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Acadia North Beach       </td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Acadia South Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Acadia South Beach – Disabled</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Separate beach</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Tel Aviv - Jaffa</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaTzuk Beach – Station number 1</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Tel Baruch Beach – Station number 1</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Nordau (Metzitzim) Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Nordau separate beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Gordon</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Bograshov</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Allenby (Jerusalem)</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Charles Clore</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Jaffa – Givat HaAliyah</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Hilton North</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaTzuk Beach – Station number 2</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Frishman</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Aviv Beach</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Bat Yam</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>HaSela – Station number 1</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaSela – Station number 2</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>HaSela – Station number 3</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Sample Beach</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Riviera</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Tayo</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		</tbody>
		</table></div></div>
		
		<p>  </p>
		</div>
		
							<!--Chapters/Collapse-->
							<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
								<!-- ngRepeat: collapse in CurrChapter.Collapses -->
							</div>
		
							<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
							<!--End of Chapters/Collapse-->
		
							<div class="col-12 xs-mb-25 lg-mb-30">
								<!-- Files for Download-->
								<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
								<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
									<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
										<!-- horizontal line -->
										<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
											<div class="horizontal-line"></div>
										</div>
									</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
									<!--arrows subject nav  דפדוף-->
									<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
										<!--  לדף הקודם -->
										<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
											<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
											<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
												<span class="small-txt gray-txt width-100"> Previous page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
											</div>
										</div><!-- end ngIf: CurrChapterindex > 0 -->
		
										<!--  לדף הבא -->
										<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
											<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
												<span class="small-txt gray-txt width-100">Next page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Southern District</span>
											</div>
											<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
										</div>
									</div>
								</div><!-- end ngIf: !isOnPrintMode -->
							</div>
						</div>
					</div>
				</div>
							</div>
							<!-- end ac-part-4 -->
		
							<!-- ac-part-5 -->
							<div class="ac-part ac-part-5">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Southern District</span>
								</h3>
							</div>
		
							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
			<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
			<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
			</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
			<!--Image desc-->
			<div>
				<div class="position-absolute">
					<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
				</div>
				<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
					<span class="small-txt ng-binding"></span>
					<span class="small-txt ng-binding"></span>
				</div><!-- end ngIf: CurrChapter.Image -->
			</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
								<!-- End IMAGE TAG  ------->
		
								<div class="row row-gov no-gutters">
									<!--Content Text-->
									<div id="GuidesChapterContent-5" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Ashdod</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Mei Ami Beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Lido</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>  </td>
				<td>  </td>
				<td>  </td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Oranim</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>Yes</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Hakshatot</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Separate beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Rova K</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Riviera</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td colspan="6" style="text-align: center;"><strong>Hof Ashkelon Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Nitzanim</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zikim</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Ashkelon</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Bar Kochva North</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Bar Kochva South</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Delila North</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Delila South</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Ashkelon National Park Beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Separate beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>לא</td>
				<td>לא</td>
				<td>לא</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Tamar Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Mazor Springs</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Meridian Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Hod Hotel Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Tzel Harim</td>
				<td>Yes</td>
				<td>Under construction       </td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Crown Plaza Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Lot</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Lot’s Wife</td>
				<td>Yes</td>
				<td>Under construction       </td>
				<td>Under construction       </td>
				<td>Under construction       </td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Ein Bokek South</td>
				<td>Yes</td>
				<td>Under construction       </td>
				<td>Under construction       </td>
				<td>Under construction       </td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Daniel Hotel Beach</td>
				<td>Yes</td>
				<td>Under construction       </td>
				<td>Under construction       </td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Solarium Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Isrotel Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>International Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Leonardo Plaza Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zohar Springs (North)</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Separate beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Leonardo Club Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Eilat       </strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><br>
				Separate beach</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Herod’s beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><br>
				Northwestern Beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
		</tbody>
		</table></div></div>
		
		<p>  </p>
		</div>
		
									<!--Chapters/Collapse-->
									<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
										<!-- ngRepeat: collapse in CurrChapter.Collapses -->
									</div>
		
									<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
									<!--End of Chapters/Collapse-->
		
									<div class="col-12 xs-mb-25 lg-mb-30">
										<!-- Files for Download-->
										<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
										<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
											<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
												<!-- horizontal line -->
												<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
													<div class="horizontal-line"></div>
												</div>
											</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
											<!--arrows subject nav  דפדוף-->
											<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-start" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
												<!--  לדף הקודם -->
												<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
													<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
													<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
														<span class="small-txt gray-txt width-100"> Previous page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
													</div>
												</div><!-- end ngIf: CurrChapterindex > 0 -->
		
												<!--  לדף הבא -->
												<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer ng-hide" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="true">
													<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
														<span class="small-txt gray-txt width-100">Next page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding"></span>
													</div>
													<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
												</div>
											</div>
										</div><!-- end ngIf: !isOnPrintMode -->
									</div>
								</div>
							</div>
						</div>
							</div>
							<!-- end ac-part-5 -->
		
						</div>
						<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/destination-for-all/6.jpg"} class="img-responsive">
					 </div><br>
							
							`,
      };
    },
  },

  {
    id: "Crazy_Night",
    ctg: "telaviv",
    bgImage: "/posts/bank/crazy-night/1.jpg",
    mobBgImage: "/posts/bank/crazy-night/M.jpg",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    title: "Looking for a crazy nightlife?",
    smltitle: "",
    html: function() {
      return {
        __html: `<div class="ac-cradit">
								<span class="ac-cradit-text">Credits:</span>
									<br/>
									<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
									<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
								</div>
								<p></p>
								</div>
                               <h3>
                                 Book your trip to Tel Aviv!
                               </h3>
                               <p>
                                 Amazing nightlife in Tel Aviv <a href="https://en.citiesbreak.com/Posts/telaviv/Amazing_Nightlife" target="_blank">Click here >> </a>
                               </p>
		                        `,
      };
    },
  },

  {
    id: "Heart_Of_The_World",
    ctg: "jerusalem",
    bgImage: "/posts/bank/heart-of-the-world/1.jpg",
    mobBgImage: "/posts/bank/heart-of-the-world/M.jpg",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    title: "JERUSALEM - THE HEART OF THE WORLD",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               
		                        `,
      };
    },
  },

  {
    id: "EILAT1",
    ctg: "general",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                

                        <p>Eilat is a port that is Israel’s outlet to India, eastern Asia and Africa. Six decades ago it was a shanty-style frontier town, but Eilat has developed into one of Israel’s major resorts whose Red Sea beaches and dozens of hotels attract Israelis and tourists from 100 countries. Eilat is devoted to vacationing. Resorts line the promenade and lagoon, along with a giant shopping mall, restaurants and a variety of attractions for visitors young and old. Eilat is also an entrée to one of the world’s most magnificent coral reefs: the Eilat Underwater Observatory is a must for every visitor, as is the dolphin reef where tourists swim with the dolphins.</p>
                        <div class="img-wrapper">
								    <img src=${getImgUrl() + "/posts/eilat1/1.jpg"} class="img-responsive">
							    </div>
                        <p>Eilat is a 4/5-hour drive from Tel Aviv and Jerusalem – or a one-hour flight into Eilat Airport which sits in the heart of town. A 15-minute drive south from Eilat brings visitors to the crossing point to Egypt. And 10-minutes to the north, tourists cross to Jordan and the neighboring port city of Aqaba. Many visitors to Eilat take day trips to Petra in Jordan.</p>
                       
                         <div class="img-wrapper">
								    <img src=${getImgUrl() + "/posts/eilat1/2.jpg"} class="img-responsive">
							    </div>
                        <h3>Take a deep at the Red Sea</h3>
                        <p>An amazing attraction in itself, Eilat’s gorgeous Red Sea and the 10 kilometer-long shoreline surrounding it are the city’s focal point and the main attraction for tourists from far and wide.<br> With their clean, clear and unexpectedly cool water allowing a welcome escape from the city’s high temperatures and dry air, and the wide variety of facilities and attractions, Eilat’s beaches are the perfect spot for sunbathing, rest and relaxation.</p>
                        <p>Extreme sports enthusiasts will love the dozens of water sports clubs spread along the southern and northern coasts of Eilat, and the range of activities such as Jet skiing, banana boats, tubing, kayaking and much more.</p>
                        <h3>Feel the vibe</h3>
                        <p>When evening comes and the hot desert sun sets on Eilat and the pools and beaches close, that is just the time to shower, change and hit the town’s fantastic nightlife scene. Eilat holds a unique record – the city with the most clubs, bars and other entertainment venues per capita in Israel, so there is no shortage of hotspots to make your night as fun-filled as your day.</p>
                        <h3>A desert adventure</h3>
                        <p>North of the city lies the southern Arava, a region of breathtaking desert vistas, and one of the most recommended areas to visit in the country, where you can feel the vast expanses and hike steep cliffs, valleys, streams and more.</p>
                        <p>The colorful and stunning mountains of the Eilat area, besides contributing to the city's breathtaking view, will provide all nature lovers with an unforgettable experience. There are a variety of routes and sites to visit and enjoy by hiking, bicycling, driving, camel riding and even rock climbing or rappelling down cliffs for the extreme sports enthusiasts.</p>
                        <p>Don't wait up. Visit Eilat. Escape to the sun.</p>
						 `,
      };
    },
  },
  {
    id: "Welcome_To_Eilat",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat2/1.jpg",
    mobBgImage: "/posts/bank/eilat2/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "WELCOME TO EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  <h3>A city of sun and fun!</h3>
									<p>The southernmost city in Israel, Eilat is renowned for its spectacular combination of the surrounding desert landscape, the beautiful bay and the summer sun that shines all year round.</p>
									<p>Whether you come to stay in Eilat as a family, a couple or even by yourself, you will find loads to see and do here. Accommodations are abundant, ranging from youth hostels to the r luxury resorts, offering visitors an unforgettable 5 star experience, with everything from the finest restaurants to beach side service.</p>
									<p></p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/welcome-to-eilat/1.jpg"} class="img-responsive">
									</div>
									<p>With a whopping 360 Sunny days a year, a visit to Eilat is a fun-filled experience, where you get to relax, recharge and get energized all at the same time. This lively resort city offers a multitude of year-round activities and attractions, excellent restaurants and cafés, shopping centers and trendy bars and clubs.</p>
									<h3>The Red Sea</h3>
									<p>An amazing attraction, Eilat’s gorgeous Red Sea and the 10-kilometer-long shoreline surrounding it are the city’s focal point and the main attraction for tourists from far and wide. With their clean, clear and unexpectedly cool water, allowing a welcome escape from the city’s high temperatures and dry air, and the wide variety of facilities and attractions, Eilat’s beaches are the perfect spot for sunbathing, rest and relaxation.</p>
									<p>Extreme sports enthusiasts will love the dozens of water sports clubs spread along the Southern and Northern coasts of Eilat, and the range of activities such as Jet skiing, banana boats, tubing, kayaking and much more.</p>
									


		                        `,
      };
    },
  },
  {
    id: "The_Ultimate_Holiday",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: false,
    title: "THE ULTIMATE HOLIDAY DESTINATION",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                 

                                 
							   <p><strong data-mk-aweb-org-font-size="17">Eilat,  </strong>the southernmost town in Israel, has all you need for a perfect vacation. Whether you're looking for a romantic gateway, family vacation, action-packed adventure or partying with your friends, this bustling resort town on the shores of the Red Sea is the place for you. Mediterranean Sun, crystal clear water, soothing Spas, vibrant night life, Tax free shopping, and endless list of attractions – that's Eilat.</p>
							   <p><strong data-mk-aweb-org-font-size="17">Soak up the sun.  </strong>With summer sun that shines throughout the year, the best time to visit Eilat is…anytime! Even in the middle of a freezing European winter Eilat offers an escape from the cold. Just hop on a plane and in few short hours you'll stop shivering and feel revived.</p>
							   <p><strong data-mk-aweb-org-font-size="17">Choose your vacation home.   </strong>Hostels and on the budget inns or luxury world-class and boutique hotels. Family and groups oriented resorts or secluded, peaceful and romantic ones - Eilat offers a large variety of accommodations to fit every budget and need.</p>
							   <p><strong data-mk-aweb-org-font-size="17">Jump into the water.</strong>  With over 7 kilometers of breathtaking Rad Sea coastline, Eilat has plenty to offer when it comes to water activities. From snorkeling and scuba-diving to wind- surfing, kite-surfing, sailing and so much more – this city got you covered.</p>
							   <p>Experience the  <strong data-mk-aweb-org-font-size="17">Dolphin's reef</strong>, a family friendly ecological beach with a gorgeous botanical garden, relaxation pools and the main attraction – an opportunity to watch, touch, swim and dive with Dolphins.   (<em>Don't worry, all interaction with these beautiful creatures is based solely on the Dolphin's free will</em>).</p>
							  
                               <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/the-ultimate-holiday/1.jpg"} class="img-responsive">
									</div>
							   <p>Visit the  <strong data-mk-aweb-org-font-size="17">Underwater Observatory</strong>, one of Eilat's most popular attractions that allows you and your family to view and learn about the Red Sea unique Marine life. Through the huge glass windows you'll see sharks, turtles, stings rays and multicolored Red Sea fishes. Through sailing on a glass ship, you'll feel a part of this magical underwater kingdom.</p>
							   <p>Don't miss the world famous<strong data-mk-aweb-org-font-size="17">  Coral Beach Nature Reserve  </strong>and its stunning coral reef<strong data-mk-aweb-org-font-size="17">.  </strong>Go snorkeling and scuba diving to see the colorful fish and extraordinary water plants in this rare delicate natural habitat.</p>
							   <p><strong data-mk-aweb-org-font-size="17">Go on a desert adventure.  </strong>The Negev desert offers some of the most spectacular scenic routes in Israel.   Hike, mount bike or take a Jeep tour to explore and marvel at the beauty that surrounds you.</p>
							   <p>Only 25 kilometers north of Eilat you'll find the  <strong data-mk-aweb-org-font-size="17">Timna Park Valley</strong>. Go on a tour, explore the gorgeous scenery and special antiquities of the world's first copper mine and enjoy the many attractions it offers for families and adventurers among you.</p>
							   <p>Want to expand your adventure? The city is easily accessible to the rest of the country. Take a day trip to the Dead Sea or Jerusalem.</p>
							   <p><strong data-mk-aweb-org-font-size="17">Allow yourself to relax.  </strong>Eilat is a laid back town where you can truly slow down and rest. True to its nature, it's also filled with fantastic Spa facilities that offers lots of different treatments from traditional messages to water therapy.  <em>Trust us, it's worth it!</em></p>
							   <p><strong data-mk-aweb-org-font-size="17">Buy, eat, drink and party.  </strong>Shop in the city's promenade's Bazaar, Luxurious shopping Boulevard and numerous malls<strong data-mk-aweb-org-font-size="17">  –  </strong>it's all TAX free<strong data-mk-aweb-org-font-size="17">!  </h3>
							   <p><strong data-mk-aweb-org-font-size="17">Go out to a night on the town.</strong>  Get entertained a see the amazing colorful audiovisual show of the musical fountain; prepare to be wowed with the Broadway style Wow show that combines dancing, acrobatics light effects, great soundtrack and many more surprises.</p>
							   <p>Dine in one of the many restaurants and bars in town and then go hit the dancefloor in a club.</p>
							   <p>It doesn't get better than this.</p>
							  


		                        `,
      };
    },
  },
  {
    id: "Eilat_Calling",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat2/1.jpg",
    mobBgImage: "/posts/bank/eilat2/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "365 DAYS OF NONSTOP SUNNY JOY",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  
									<p>Incredible adventure in Israel’s no. 1 vacation resort by the red sea.</p>
									<p>The capital of the red sea, Eilat is Israel's famous resort city drawing nearly 2.8 million visitors a year who come to vacation by the shores of the stunning red sea.</p>
									<p>The southernmost city in Israel, Eilat is renowned for its spectacular combination of the surrounding desert landscape, the beautiful bay and the summer sun that shines all year round.</p>
									<p>A visit to Eilat is a fun-filled experience where you get to relax, recharge and get energized all at the same time. Eilat boasts a whopping 360 sunny days a year, making it extremely popular with tourists from far and wide looking to get away from their cold winter climate.</p>
									<p>This lively resort city offers a multitude of year-round activities and attractions, excellent restaurants and cafés, shopping centers and trendy bars and clubs.</p>
											                        `,
      };
    },
  },
  {
    id: "Eilat_Doolphin_Reef",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    vidId: "3Cvz8GoxNzA",
    title: "A MEMORY TO LAST A LIFETIME",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
							   <p>							   Come fall in love with these treasures of the Red Sea at the Dolphin Reef of Eilat.
                                 </p>
							   <h3>Bond with the dolphins at Eilat’s unique seaside attraction</h3>
							   <p>The Dolphin Reef Eilat is a wildlife treasure on the shores of the Red Sea, where action-packed adventures go hand-in-hand with nature and relaxation. At the Reef, visitors enter a magical site, interacting with dolphins in their natural habitat; a stunning beach, where the plant-life is in full bloom and the view is breathtaking.</p>
							   <p>The site’s lengthy pier is an amazing spot for observing the local “bottlenose” dolphins as they go about their everyday routines of eating, playing, hunting, mating and socializing - at times choosing to engage with the site’s human visitors as well. Visitors seeking a more hands-on experience can attempt to interact with the dolphins through any one of the several activities open to the public.</p>
							   <p>A truly magical experience is watching the dolphins during mealtimes, scheduled yet captivating feeding times. There is something exciting in the childlike and spirited play of dolphins with their handlers, eagerly awaiting their food. The sheer joy sensed once the meal meets its diner almost instinctively provokes a round of applause by all members of the audience. In fact, visitors tend to feel as excited and satisfied as if they were the ones to have been fed themselves.</p>
							   <h3>Take the plunge and dive with the dolphins</h3>
							   <p>The beauty of the Dolphin Reef is that visitors don’t need to remain at a distance, but can take the plunge and dive with the dolphins, observing them in their unique ecosystem; swimming down to a depth of six meters and experiencing the magnificent and secret life as it naturally takes place beneath the sea. Or, visitors can choose to snorkel with the dolphins slightly closer to sea level; floating alongside the dolphins, enabling playful interaction between humans and dolphins</p>
							   <p>The Dolphin Reef’s “relaxation pools” are where visitors can let their worries wash away while floating to the sound of relaxing music. On-site eateries keep visitors feeling pampered and catered to, without them having to step outside the small sanctuary of natural beauty.</p>

		                        `,
      };
    },
  },
  {
    id: "Action_Packed_Eilat",
    ctg: "active-adventure",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: false,
    title: "ACTION PACKED EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               <p>So, you’ve heard about the fabulous beaches, the awesome nightlife and fantastic atmosphere of year round sunny Eilat, but aren’t you wondering, amongst all the leisure, what to do with the excess energy? Well wonder no more. Here are just some of the amazing ways to have some action-packed fun in the sun:</p>
		                       
                                   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/action-packed-eilat/1.jpg"} class="img-responsive">
									</div>
								   <p>Eilat’s stunning red sea offers loads of fantastic adventures. For one, its gorgeous underwater environment is known as a world-famous <b>scuba diving destination</b>. Not a pro? No problem. There are short courses that run for 1-2 days.</p>
								   <p>Atop the waves, you’ll find, <b>windsurfing</b>, <b>kitesurfing</b>, and <b>stand-up paddle boarding</b> options for which it’s always an ideal time in Eilat, with its pristine beaches, calm waters, and perfect sunny weather almost year-round. By the way, don’t worry about equipment or experience, as there are plenty of options for rentals and individual or group lessons for all ages as well as all-inclusive packages. You’ll be flying across the sea in no time!</p>
								   <p>Looking to flex a few more muscles? Eilat’s nearby desert area offers <b>fantastic hikes</b> in stunning trails where you can <b>walk or bike</b> through breathtaking desert scenery.<span class="Apple-converted-space">   </span>Feeling adventurous? Check out the huge array of unique action attractions from unforgettable camel rides to <b>adrenaline charged ATV rides</b> to thrilling off cliff <b>paragliding,</b> guaranteed to get the heart racing.</p>
								   <p>If your holidays are all about breathtaking adventures, Eilat is definitely the place for you!</p>
								 


		                        `,
      };
    },
  },
  {
    id: "Eilat_Ultimate_Beachside",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "EILAT ULTIMATE BEACHSIDE",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               
								   <h3>Enjoy the water attractions that make Eilat the ultimate beachside getaway</h3>
								   <p>Surrounded by water, Eilat, Israel’s most southern city, is a wet and wild adventure hub unlike anywhere else in the country. Eilat boasts top beaches, water sports, activities and attractions, open to the public year-round due to the warm local climate.</p>
								   <p>Dip your toes in the clear, blue waters of Eilat’s beaches, spanning over twelve kilometers of sand, boardwalk, hotel and commercial attractions.</p>
								   <p>Relax at one of the more secluded and quiet southern beach locations and swim around the coral reefs, or enjoy a vibrant tourist scene at one of the northern beaches, where nearby hotels, restaurants and shops keep the public satisfied and entertained. Or, enjoy the region from aboard a yacht sailing through the waters, allowing you to soak up the sun, unwind and socialize.</p>
								   <p>Delve into the uniquely beautiful habitat of the Eilat Coral Beach Nature Reserve. Put on snorkeling gear and observe or interact with the local sea creatures as they swim about.</p>
								   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/eilat-ultimate-beachside/1.jpg"} class="img-responsive">
									</div>

								   <h3>The heart of Israel’s extreme water adventures</h3>
								   <p>Eilat is the heart of Israel’s extreme water adventures. Feel the wind in your hair and sun on your cheeks as you embark upon a water ski, jetski, banana boat, surfing or glass bottom boat ride, speeding through the waters at an exhilarating pace. Prefer to remain above water? Opt instead to take in an aerial view of the waters and parasail over the Eilat Bay.</p>
								   <p>Do you love wildlife? Swim or snorkel with dolphins at Eilat’s Dolphin Reef. The unique ecological site, in the midst of a magical beach, allows visitors an up-close glimpse into the dolphins’ lives and makes for an exciting outdoor adventure. Fancy an underwater experience without getting wet? Take a tour of the Eilat Underwater Observatory, a captivating glimpse into life below sea level, combined with interactive activities and special exhibits.</p>
								   
		                        `,
      };
    },
  },
  {
    id: "One_Day_In_Eilat",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat2/1.jpg",
    mobBgImage: "/posts/bank/eilat2/M.jpg",
    isVid: false,
    title: "ONE DAY IN EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
								   <h3>Suggestions for an awesome day in the sun</h3>
								   <p>Whether you’re staying in one of the city’s 5 star hotels, a hostel or have opted for the cool camping alternative, we recommend to start your day with a delicious breakfast and make your way to the <b>Dolphin Reef</b>. This is one of the most popular attractions in Eilat, where you can touch, swim and dive with these beautiful creatures. Watch the dolphins in their natural habitat, visit the underwater photo center, or take part in either scuba diving or snorkeling. Check out also <b>Coral Beach</b>, the natural underwater reserve that extends for 1,200 meters along the coast and gives you the opportunity to go snorkeling with an extraordinary variety of tropical fish in a beautiful coral reef.</p>
								   <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/one-day-in-eilat/1.jpg"} class="img-responsive">
									</div>
								
								   <p>Once you’ve dried off, head to the stunning <b>Botanical Gardens</b> within Eilat. You’ll find there more than 1,000 types of trees and plants from all around the world, streams, waterfalls, a rainforest and bird sanctuaries.</p>
								   <p>To end of your day with something slightly different, head just outside of Eilat to the <b>Red Canyon,</b> where you can track through the riverbed and between the red Nubian sandstone walls that have been sculpted over the centuries by wind and water.</p>
								   <p>When evening comes, make your way to the buzzing Eilat promenade ,stroll by the shops and market stands which are open until late. You can treat yourself to a meal in any of the dozens of the excellent restaurants and cafés or a drink in any of the lively seaside pubs and bars.</p>
								  
		                        `,
      };
    },
  },
  {
    id: "Majestic_Desert",
    ctg: "eilat",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "NEGEV – ISRAEL’S MAJESTIC DESERT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/yXzhH92kREg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
								   <h3>Where Adventure and Inspiration Await</h3>
								   <p>An ideal destination for travelers who love adventure in the great outdoors. The south of Israel is sparsely populated, but packed with fascinating sites and activities.</p>
								   <p>With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset. A desert but definitely not deserted, there is so much to see and do here – there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert. Simply put, this majestic Southern region is one of the country’s greatest assets and an absolute must on the itinerary.</p>
								   <h3>Sde Boker</h3>
								   <p>A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50’s. Sde Boker is renowned as the home of David Ben Gurion, Israel’s first Prime Minister whose home is now a museum open to the public.</p>
								   <h3>Vidor Center</h3>
								   <p>A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.</p>
								   <h3>Nevatim</h3>
								   <p>A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world. The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.</p>
								   <h3>MidBurn Festival</h3>
								   <p>Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.</p>
								   <h3>Negev - Where Adventure and Inspiration Await</h3>
								   <div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/QL3BGy2p77g" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
						           <h3>The Bedouin Experience</h3>
                                    <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging. A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.</p>
		                           <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/1.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>
								
								   <h3>The Culinary Queens of Yeruham</h3>
								   <p>For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham – a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors. Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.</p>
								   <h3>The Old City of Be'er Sheva</h3>
								   <p>Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.</p>
								   <h3>Carasso Science Park</h3>
								   <p>New in the Old City of Be’er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel. Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.</p>
								   <h3>Arad</h3>
								   <p>Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style. With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.</p>
								   <h3>Yotvata Hai-Bar</h3>
								   <p>The Yotvata Hai-Bar Nature Reserve is the area’s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators’ center with its live predators and small desert animals, a Nocturnal animal’s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.</p>
								   
                                   <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/2.jpg"} class="img-responsive">
									</div>
									<h3>Extreme Adventures</h3>
                                    <p>The south of Israel is a total dream destination for adventure-hungry travelers. Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.</p>
                                      <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/3.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>
									<h3>Camel rides</h3>
                                    <p>A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.</p>
                                    <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/4.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>


		                        `,
      };
    },
  },
  {
    id: "Negev1",
    ctg: "general",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: true,
    vidId: "yXzhH92kREg",
    title: "NEGEV",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
							   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
							   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
							   <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/negev/1.jpg"} class="img-responsive">
									</div>


							   <h3>The Israeli desert is special for the following reasons:</h3>
							   <ul>
							      <li><strong>The desert is very near:</strong>  just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half). Starting from November, there will be direct flights from Europe and Russia to Ovda airport including  Ryanair, Wizzair, and SAS.</li>
							      <li><strong>Easy to Hike and Bike:</strong>  There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert.</li>
							      <li><strong>Cordial local population:</strong>  The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
							      <li><strong>Tourists Activities:</strong>  Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
							      <li>
							         <strong>Magnificent landscapes:</strong>  Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety
							         <ul>
							            <li>There are spectacular sand dunes in the north.</li>
							            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
							            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
							            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
							         </ul>
							         <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers. Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
							      </li>
							      <li><strong>The Negev is very safe to travel.</strong>  In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
							   </ul>
							   <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/negev/2.jpg"} class="img-responsive">
									</div>

		                        `,
      };
    },
  },
  {
    id: "Location_And_Approach",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    title: "NEGEV – LOCATION AND APPROACH",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
								   <p>Landing at the airports of Ovda or Eilat with the onward journey to Mitzpe Ramon or Sde Boker:</p>
								   <h3>Public means of transportation:</h3>
								   <p>Bus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.</p>
								   <p>Arrival at the central bus station of Mitzpe Ramon after about an hour and a half.</p>
								   <p>Mondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.</p>
								   <h3>Car rental in Eilat, Mitzpe Ramon and Be'erSheva:</h3>
								   <p>There a multiple option in renting a car in these cities. There is a choice of international and Israeli companies.</p>
								   <p>Landing at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon</p>
								   <h3>Public means of transportation:</h3>
								   <p>Bus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.Train from Ben Gurion or Tel Aviv to Be'erSheva.</p>
								   <p>From Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes). Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.</p>
								   <h3>NEGEV ROAD DISTANCES</h3>
								   <table>
								      <tbody>
								         <tr>
								            <th></th>
								            <th>Tel Aviv</th>
								            <th>Jerusalem</th>
								            <th>Bee'r Sheva</th>
								            <th>Eilat</th>
								         </tr>
								         <tr>
								            <td><strong>Old Town  Beer Sheva</strong></td>
								            <td>113 Km</td>
								            <td>122 Km</td>
								            <td></td>
								            <td>232 Km</td>
								         </tr>
								         <tr>
								            <td><strong>Tel Arad</strong></td>
								            <td>134 Km</td>
								            <td>144 Km</td>
								            <td>40 Km</td>
								            <td>229 Km</td>
								         </tr>
								         <tr>
								            <td><strong>Ben-Gurion's House  in Sde Boker</strong></td>
								            <td>162 Km</td>
								            <td>171 Km</td>
								            <td>49 Km</td>
								            <td>185 Km</td>
								         </tr>
								         <tr>
								            <td><strong>Ramon Crater</strong></td>
								            <td>210 Km</td>
								            <td>192 Km</td>
								            <td>97 Km</td>
								            <td>141 Km</td>
								         </tr>
								         <tr>
								            <td><strong>Hai Bar Wildlife  reserve Yotvata</strong></td>
								            <td>323 Km</td>
								            <td>288 Km</td>
								            <td>202 Km</td>
								            <td>35 Km</td>
								         </tr>
								         <tr>
								            <td><strong>Timna Park</strong></td>
								            <td>330 Km</td>
								            <td>294 Km</td>
								            <td>208 Km</td>
								            <td>30 Km</td>
								         </tr>
								      </tbody>
								   </table>
								   <h3>NEGEV DESERT - DON'T MISS</h3>
								   <h3>Ramon Crater</h3>
                                   <p>At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater,also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel’s largest national park, the Ramon Nature Reserve. Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon. The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>
                                    <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/location-and-approach/1.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>
									<h3>Timna Park</h3>
                                    <p>15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions. With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.</p>
		                            <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/location-and-approach/2.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>
									<h3>Timna Park - An Exhilarating Desert Adventure</h3>
									<div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/i_4QKtXIeto" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
						           <h3>Sandboarding in the desert</h3>
                                   <p>An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?</p>
                                    <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/location-and-approach/3.jpg"} class="img-responsive">
									</div>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/location-and-approach/4.jpg"} class="img-responsive">
									</div>
									<h3>Negev at night</h3>

                                    <p>The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.</p>
		                           <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/location-and-approach/5.jpg"} class="img-responsive">
									</div>
									<h3>Sunrise at Masada</h3>

                                    <p>Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.</p>


		                        `,
      };
    },
  },
  {
    id: "Stay_In_The_Negev",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: false,
    title: "STAY IN THE NEGEV",
    smltitle: "",
    html: function() {
      return {
        __html: `<p> A trip to the Negev offers so much more than just grand vistas and tranquil surroundings one tends to think about when conjuring up the word desert. While the Negev still offers all the natural beauty, calmness and wondrous sites, which the desert tourist is looking for, it is also extremely interesting, westernized and packed with activities and adventures and even offers all the comforts of a modern holiday.</p>
                                 <p> The Negev offers a huge variety of accommodation options. So much more than just a place to lay your hat down, the form of accommodation you choose will offer you opportunity to acquaint yourself with the undisputable gem of the Negev - its local community. From the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, you will find the people of the Negev are warm, hospitable and always ready to lend a hand. Here are just a few examples of hospitality options, which can be found in the Negev:</p>
                                 <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/stay-in-the-negev/1.jpg"} class="img-responsive">
								  </div>

								   <p>Hotels – the Negev has a huge host of hotel options ranging from budget hotels to 5-star international prize-winning luxury hotels, where you can chill in style during your desert break.</p>
								   <p>Hostels – an affordable accommodation geared mostly towards young travelers. Here many tourists enjoy the opportunity to meet and engage with other like-minded travelers from all over the world and spend their evenings socializing and often creating lasting friendships.</p>
								   <p>Zimmers -This is Israel’s version of the Bed and Breakfast, usually separate from the owners’ own home, these are often more secluded and cozy lodgings, suitable for travelers looking for romance and peaceful settings.</p>
								   <p>Bedouin Hospitality tents- the definite Negev must, this truly unique and authentic form of hospitality, which welcomes you into the indigenous Bedouin community’s way of life, affords an exceptional opportunity to take part in the Bedouin traditions in their natural environment – highly recommended.</p>
								   <p>Khans – again, unique to the Negev, the popular Kahns are in fact large outdoors complexes, which offer huts and communal sleep areas as well as all basic facilities. While Kahns are often a more basic and rustic form of accommodation, they are an excellent way to experience the chilled atmosphere of the area, connect with other travelers and locals and feel part of the natural surroundings of the desert.</p>
								   <p>Lone farms – a more recently developed form of accommodation, lone farms are in fact guest rooms in quaint and remote family-run farms throughout the Negev.   Combining tranquil settings with home comforts, the lone farms offer privacy, incredible views and an authentic way to experience the awesome desert atmosphere of the Negev.</p>
								   <p>Kibbutz - a distinctly Israeli form of collective communal settlements, Kibbutz accommodations offer good value accommodation at affordable prices. The true appeal of the Kibbutz, however, is their uncountably their special atmosphere and communal spirit, and the residents warm, inviting and hospitable spirit, guaranteeing a pleasant and memorable stay.</p>
								  
		                        `,
      };
    },
  },
  {
    id: "Pure_Desert_Magic",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "NEGEV PURE DESERT MAGIC",
    smltitle: "",
    html: function() {
      return {
        __html: `
						               <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
									   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
									   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
									   <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/pure-desert-magic/1.jpg"} class="img-responsive">
								       </div>  
								       <p><strong data-mk-aweb-org-font-size="17">The Israeli desert is special for the following reasons</strong>:</p>
									   <ul>
									      <li><strong>The desert is very near</strong>  - just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).</li>
									   </ul>
									   <p>Starting from November, there will be direct flights from Europe and Russia to Ovda airport including  <strong>Ryanair</strong>,  <strong>Wizzair</strong>, and  <strong>SAS</strong>.</p>
									   <p>For further details check the following link:  <a href="http://www.iaa.gov.il/en-US/airports/ovda/Pages/default.aspx" target="_blank" rel="noopener">www.iaa.gov.il</a></p>
									   <ul>
									      <li><strong>Easy to Hike and Bike</strong>: There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:  <a href="http://www.negevtour.co.il/" target="_blank" rel="noopener">www.negevtour.co.il</a>  ;  <a href="http://www.en.aravaway.co.il/" target="_blank" rel="noopener">www.en.aravaway.co.il</a></li>
									      <li><strong>Cordial local population</strong>: The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
									      <li><strong>Tourists Activities:</strong>  Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
									      <li>
									         <strong><strong>Magnificent landscapes:  Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety</strong></strong>
									         <ul>
									            <li>There are spectacular sand dunes in the north.</li>
									            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
									            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
									            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
									         </ul>
									      </li>
									   </ul>
									   <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.</p>
									   <p>Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
									   <ul>
									      <li><strong>The Negev is very safe to travel</strong>. In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
									   </ul>
									   <h3>More information and tips for accommodation and recommendations:</h3>
									   <p><a href="http://www.negevtour.co.il/" target="_blank" rel="noopener">www.negevtour.co.il</a></p>
									   <p><a href="http://www.en.aravaway.co.il/" target="_blank" rel="noopener">www.en.aravaway.co.il</a></p>                          
											                        `,
      };
    },
  },
  {
    id: "Action_Fun_In_The_Desert",
    ctg: "active-adventure",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: true,
    vidId: "yXzhH92kREg",
    title: "ACTION FUN IN THE ISRAELI DESERT",
    smltitle: "",
    html: function() {
      return {
        __html: `

						          <h3>The Uniqueness of the Desert</h3>
								   <p>You’ll be wowed by the natural beauty of Israel’s four main desert areas: the Dead Sea, the Eilat mountain range, the Negev and the Judean desert. Tourists can step out-of-this-world on a hike through the unique colors and rock formations of the Ramon Crater and the deeply glowing hues of Timna Park outside Eilat. Rappelling down multicolored cliffs or challenging yourself on dusty, challenging hike is even better when you end it with a refreshing plunge into a desert oasis like Ein Gedi near the Dead Sea. You’ll see more stars than you could have believed if you camp overnight at one of the many fully serviced campsites. You might even glimpse some of the desert’s shy nocturnal wildlife!</p>
								   <p>Spring, Fall and Winter are the best times to visit the dry, bracing climate of Israel’s desert. Step back in time at the famous Masada fortress to rediscover the bitter end of the last Jews fighting against the Romans and be awed by the grandeur of Herod’s palace. Explore Unexpected Byzantine ruins and the astonishing culture of the Nabateans’ ancient settlements carved out of the desert rock are waiting for you to explore them.</p>
								    <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/action-fun-in-the-desert/1.jpg"} class="img-responsive">
								       </div> 
								       <h3>Action Fun in the Desert</h3>
								   <p>Israel’s desert is full of fun activities. An exciting jeep tour will bounce you through the unique terrain of the Negev, or you can hire mountain bikes to challenge yourself in the unearthly beauty of Timna Park’s colorful rocks or across desert paths. Slow down to bond as a family or with friends on a calming horseback ride in the Judean desert or Eilat mountains, or sip mint tea and eat plump dates as you experience real Bedouin hospitality in the Negev. You can even ride on a camel to feel like a true ancient Israelite!</p>
								   <p>You could slather on the therapeutic mineral mud on the shores of the Dead Sea as you marvel at the towering mountains around you and the blue water beside you. Lovers of extreme sports can try their hand at sandsurfing down the Negev’s sweeping sand dunes, feeling the thrill of racing across acres of sand.</p>
								   <p>Israel’s deserts are full of more fun than you’d believe.</p>
								   <p>Photo credit:Alon Ron,  Dafna Tal.</p>                          
		                        `,
      };
    },
  },
  {
    id: "The_Incense_Route",
    ctg: "active-adventure",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    title: "THE INCENSE ROUTE",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						           <p>The legendary Incense Route is a 2,000 year old commercial success story<span dir="RTL" data-mk-aweb-org-font-size="17">.</span></p>
								   <p>At the time, without transportation, roads or maps, long caravans of camels traversed difficult trails navigating among robbers, looters, obstacles and narrow-minded rulers. Valuable goods traveled the route, which started in Yemen to the East, crossed Saudi Arabia and Jordan to end in Israel in the Gaza port, where they were loaded onto merchant ships bound for Europe. There the women of the Roman Empire could enjoy the perfumes of the frankincense and myrrh, the flavors of the eastern spices, and the useful salts for cooking and preserving foods<span dir="RTL" data-mk-aweb-org-font-size="17">.</span></p>
								   <p>The 2,400 kilometer Incense Route journey took about six months. The camel caravans including thousands of individuals, moved at a sluggish pace, passing through 56 stops, where they stopped, rested, took care of the animals and gathered strength for the day to come<span dir="RTL" data-mk-aweb-org-font-size="17">.</span></p>
								   <p>The Israeli section of the Incense Route covered about 150 kilometers. Across the Negev desert   there are still ruins of the route, and many travelers set out to follow them in exploring the desert and try to experience the lifestyle of the masters of the desert. Several of the rest stops remain starting with the Arava's Moa on the Jordanian border, where the ruins of an inn, a guard post, agriculture, caves, storerooms, and an aqueduct are still evident. From here, the route continues northwest to Mamshit, a large city whose impressive ruins include an inn, churches, a bathhouse, rainwater collecting pools and other structures<span dir="RTL" data-mk-aweb-org-font-size="17">.</span></p>
								   <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/the-incense-route/1.jpg"} class="img-responsive">
								       </div>  
								        <p>The next stop was the city of Ovdat, located high on a hill. Here too are ruins of a fortress, churches, an oil press, a ceramics workshop, homes, a bathhouse and even burial caves<span dir="RTL" data-mk-aweb-org-font-size="17">.</span></p>
								   <p>The caravan continued from Ovdat to Shivta, a small town with a well developed water system, pools, oil presses and a few churches. The next to last and northernmost stop was Halutsa, of which there remains the ruins of a theater and church, and from where the caravans headed straight to Gaza. A few minor stations were added along the way – Kasra, Nekarot, Makhmal and Grafon – as well as an additional inn, Ein-Saharonim, of which there is still a courtyard surrounded by workshops and a bath<span dir="RTL" data-mk-aweb-org-font-size="17">.</span></p>
								   <p>Along the route, there are reservoirs, guard towers, ritual sites, bathing facilities and milestones that marked the route<span dir="RTL" data-mk-aweb-org-font-size="17">.</span></p>
								   <p>Moa, Mamshit, Ovdat, Shivta and Haluza, as well as Ein-Saharonim, are all accessible with any vehicle. The route itself, through the desert is passable only in jeeps, although bicyclists and pedestrians can also enjoy the fascinating path. In 2005, UNESCO declared the Incense Route a world heritage site, and Israel invites you to the Negev and Arava to follow the footsteps of nomads and enjoy the impressive stories and splendid history that left behind a silent witness to a stormy age<span dir="RTL" data-mk-aweb-org-font-size="17">.</span></p>                         
										                        `,
      };
    },
  },
  {
    id: "Mount_Karkom",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "MOUNT KARKOM",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  <p>In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.</p>
								   <p>Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.</p>
								   <p>Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/mount-karkom/1.jpg"} class="img-responsive">
								       </div>	
								       <p>Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.</p>
                                    <p>To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.</p>                      

										                        `,
      };
    },
  },
  {
    id: "Machtesh_Ramon",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: false,
    title: "MACHTESH RAMON",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <p>At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater, also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an elongated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.</p>
		                        <div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/machtes-ramon/1.jpg"} class="img-responsive">
								</div>
								<p>Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock, and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.</p>
								<p>The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>
								<p>A visit to Machtesh Ramon offers a range of exciting experiences and attractions specifically geared towards tourists and world travelers:</p>
								<p><strong>Ramon Crater Visitor Center</strong>  –   Built on the crater’s edge, the visitor center overlooks the awesome views from the Machtesh and offers an opportunity to learn about its unique natural phenomena, and also about the life and work of Ilan Ramon, the first Israeli astronaut.</p>
								<p><strong>Hai Ramon</strong>  - Raising awareness to the local animal population, The Hai Ramon animal park offers a fascinating encounter with the often obscure and unseen small animals of the desert, The site features about 40 species of animals: lizards, snakes, turtles, spurs, hedgehogs, falcons, pheasants and more.</p>
								<p><strong>Kahn Saharonim</strong>  – a short walk from this once station on the Nabatean Spice Route, is Ein Saharonim, a beautiful spring (dry in the summer) which features rich vegetation and the footprints of the many animals that come to enjoy its waters.</p>
								<p><strong>The Carpentry</strong>  – a fascinating geological phenomenon, The Carpentry is a concentration of elongated stones in the form of prisms formed when the sandstone was "baked" at the high temperature created by a hot lava flow from the depths of the earth. During its cooling, the rock formed into thousands of ribbed columns, and the fragments of the columns act as the prisms.</p>
								<p><strong>The Ammonite Wall</strong>  - a rock wall featuring fossils of ammonites - marine animals that lived millions of years ago in the sea which then covered the entire Negev area.</p>
								<p>A trip to Machtesh Ramon is a fascinating experience, one guaranteed to create a strong impression and a lasting memory.</p>

		                        `,
      };
    },
  },
  {
    id: "Epic_Masada",
    ctg: "jewish",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    title: "EPIC MASADA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <h3>Re-live epic history atop the Judean Desert’s glorious fortification</h3>
								   <p>Journey to Masada National Park, the lone, isolated, ancient Judean Desert clifftop fortification, overlooking the nearby Dead Sea oasis. Hike up the winding snake path or Roman staircase from the fortification’s base, or enter the Masada Visitors’ Center and travel to the site’s summit via cable car and begin to experience a part of ancient history, as if it were still in the making.</p>
								   <h3>Explore regal ruins and feel a part of history</h3>
								   <p>Enter what was once a series of luxurious castles forming the final stronghold inhabited by freedom fighters, who courageously waged war against the Roman Empire following the destruction of the Second Temple. A site so rich in historical narrative, that the cool, stone walls practically weep for the brave souls who chose untimely death over enslavement under enemy regime.</p>
							       <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/epic-masada/1.jpg"} class="img-responsive">
								   </div>
								   <h3>Where experiencing culture and religion reaches new heights</h3>
								   <p>Stroll through the castle ruins and discover rooms and structures, archaeological findings highlighting life on Masada during the Roman siege. Enter the Northern Castle, the ruins of King Herod’s private fortress palace. Whisper a prayer in the ancient synagogue, where Jews congregated thrice daily to pray for salvation. Pay homage to the departed freedom fighters, who drew lots in the “Lottery Room” to determine the order of the men’s impending deaths, until the last remaining man put an end to his own life as well.</p>
								   <p>Gaze at what is left of a Byzantine-era church and its mosaic artwork, possibly used for centuries by escaped Christian monks as early as the 1st Century, for a period of roughly 600 years.</p>
								   <p>Experience Masada as one of UNESCO’s World Heritage Sites, complete with a sunset sound and light show at the fortification’s base, which delves into the way of life and battles experienced on site centuries ago.</p>

							    `,
      };
    },
  },
  {
    id: "The_Bedouin_Experience",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: false,
    title: "THE BEDOUIN EXPERIENCE",
    smltitle: "",
    html: function() {
      return {
        __html: `

						           <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.</p>
                                   <p>A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality.</p>
                                   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/the-bedouin-experience/1.jpg"} class="img-responsive">
								   </div>
								   <p>From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a long-forgotten way of life.</p>
		                        `,
      };
    },
  },
  {
    id: "The_Israel_National_Trail",
    ctg: "active-adventure",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: false,
    title: "ISRAEL NATIONAL TRAIL",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>Israel National Trail (“Shvil Israel”) is a national project, paving a marked and safe hiking route across the country. Over 900km long, the route is one of the most rewarding ways to experience the nature and community in Israel.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/the-israel-national-trail/1.jpg"} class="img-responsive">
								</div>
								<p>Israel Bike Trail (Part of Israel National Trail Project) is a national initiative to create mountain biking trail that crosses the country from north to south, connecting Mt. Hermon at one end with Eilat at the other. Perfectly suited for bicycle tourism, the trail passes through national sites and astounding landscapes, allowing riders to experience Israel's diversity of culture and types of communities along the way. The trail is one of the longest demarcated trails in the world suited to, and with appropriate signage for, mountain biking.</p>

							`,
      };
    },
  },
  {
    id: "The_Israel_National_Trail",
    ctg: "general",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: false,
    title: "ISRAEL NATIONAL TRAIL",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                    <p>Israel National Trail (“Shvil Israel”) is a national project, paving a marked and safe hiking route across the country. Over 900km long, the route is one of the most rewarding ways to experience the nature and community in Israel.</p>
		                            <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/the-israel-national-trail/1.jpg"} class="img-responsive">
								    </div>
								    <p>Israel Bike Trail (Part of Israel National Trail Project) is a national initiative to create mountain biking trail that crosses the country from north to south, connecting Mt. Hermon at one end with Eilat at the other. Perfectly suited for bicycle tourism, the trail passes through national sites and astounding landscapes, allowing riders to experience Israel's diversity of culture and types of communities along the way. The trail is one of the longest demarcated trails in the world suited to, and with appropriate signage for, mountain biking.</p>

		                        `,
      };
    },
  },
  {
    id: "Timna_Treasures",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: true,
    vidId: "i_4QKtXIeto",
    title: "TIMNA TREASURES",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <p>15,000 acres in a horseshoe-shaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions.</p>
		                       
                                    <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/1.jpg"} class="img-responsive">
								   </div>
								   <h3>Explore the Natural Beauty and Exciting Attractions Timna Park Has to Offer</h3>
								   <p>Timna Park is a one-of-a-kind experience, located just 20 minutes from Eilat, in the heart of the enchanted Israeli desert and ensconced between breathtaking natural scenery. With attractions and activities that combine nature, historical antiquities and adventure, the expansive grounds house excitement and enchantment that dare to impress visitors of all ages and interests.</p>
								   <h3>Witness outstanding natural phenomena</h3>
								   <p>Walk through the park’s grounds and gaze at the site’s unique rock formations With interesting names and rare shapes you can touch with your bare hands “Mushroom,” “Mushroom &amp; a Half,” “Pink Canyon,” “Arches,” “Solomon’s Pillars” and “Valley of Rock Drawings -” depict life from an era long ago, allowing you to feel as though you are witnessing something truly spectacular.</p>
								  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/2.jpg"} class="img-responsive">
								   </div>
								   <h3>Trek through the great outdoors</h3>
								   <p>Embark upon one of the park’s 20 well-marked hiking trails, each varying in level of difficulty, selected to fit your individual or group needs and capabilities. Trek through the spectacular, geological and archaeologically-significant trails, or choose instead to take it easy and lounge by the shaded Timna Lake and its adjacent camping grounds and King Solomon’s Khan restaurant, where desert-related crafts such as colored sand bottles can be made, or pedal boats can be taken for a spin.</p>
								   <p>Extreme sports more up your alley? Try out the park’s rappelling, zip line and bike tours, each sure to leave you feeling invigorated and accomplished.</p>
								   <h3>Experience ancient times today</h3>
								   <p>Learn about biblical history in the desert, during a guided visit of the reconstructed Tabernacle, complete with a replica of the Altar, Holy of Holies and Ark. Watch as younger visitors gaze in awe at the reproduction of the holy structure God commanded the Jews to build in the desert - and older visitors examine the reconstruction for historical accuracy, learning a thing or two along the way.</p>
								   <p>Timna Park. Where history meets adventure, deep in the Israeli desert.</p>                   

		                        `,
      };
    },
  },
  {
    id: "Negev_Desert_Dont_Miss",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "NEGEV DESERT – DON’T MISS",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  <h3>Sandboarding in the desert</h3>
                                  <p>An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?</p>
		                          <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/negev-desert-dont-miss/1.jpg"} class="img-responsive">
								   </div>

								   <h3>Negev at night</h3>
								   <p>The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.</p>
								   <h3>Camel rides</h3>
								   <p>A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.</p>
								   <p>Photo taken by photographer: Dafna Tal</p>
								   <h3>MidBurn Festival</h3>
								   <p>Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.</p>
								   <h3>Sunrise at Masada</h3>
								   <p>Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.</p>
										     

		                        `,
      };
    },
  },
  {
    id: "Negev_Charms",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: true,
    vidId: "3UddwPEzDXo",
    title: "ESCAPE TO THE NEVEG",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  <p>A desert holiday is unlike any other - the tranquility, the awe inspiring grand vistas, the clear star-studded night skies, all come together to create a truly mesmerizing and exotic experience most of us do not to partake in during our day to day lives.</p>
                                  <p>The Negev is so much more than just a Desert. While it still offers all the natural beauty, calmness and wonderous sites which the desert tourist is looking for, it is also extremely westernized and packed with activities and adventures while offering all the comforts of a holiday. This is exactly what makes a trip to the Negev the perfect destination for travelers from all over the world. Another gem of the Negev is undoubtedly its local community, from the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, the people of the Negev are warm, hospitable and always ready to lend a hand. The Negev is rich in geological and archeological treasures and offers loads of exciting activities for the more adventurous travelers.</p>
		                          <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/negev-charms/1.jpg"} class="img-responsive">
								   </div>
								   <p>At the same time, visitors looking for relaxation are sure to find it in the tranquil surroundings, and for some urban excitement, the nearby cities provide a wide range of city fun from culinary treats to exciting nightlife.</p>
  
		                        `,
      };
    },
  },

  {
    id: "Galilee",
    ctg: "general",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "5Ep3GgxELag",
    title: "GALILEE",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						          <p>Most of northern Israel is generically known as The Galilee (Galil in Hebrew). It stretches virtually from the Mediterranean to the harp-shaped Sea Of Galilee and River Jordan on whose shores vast history has been made. Here is Mount Gilboa where King Saul and his son, Jonathan, died in battle against the Phillistines. Here is Hazor, where Deborah killed Sisera. Here, at Mount Meron, is the grave of Rabbi Hillel. Here in Tzippori, Hamat Tveriya and Bet Alpha, gorgeous 1,800-year-old synagogue mosaics have been discovered. Here is Armageddon (Megiddo) where Solomon built giant stables. Here is the lakeshore city of Tiberias, one of the “Four Holy Cities of Judaism” (another is Galilee’s Safed), which reached fame 2,000 years ago as one of the chief locations in which the Talmud was written.</p>
                                  <h3 >Galilee</h3>
                                  <div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/lzYzxyvnfng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
						           <p>The restoration of the Jewish homeland in the period beginning in the 1880’s was largely centered in the Galilee, and in the ensuing 130 years a much neglected landscape of not much more than olive trees has been transformed into one of the most fertile areas in the world. Here are dozens of kibbutzim and independently owned farms – whose produce feeds not only Israelis but is also flown daily to the grocery stores and flower markets of Europe. Here are some of Israel’s 300+ vineyards producing award winning wines. And here are pretty villages, towns and cities including Nazareth and Carmiel.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/galilee/1.jpg"} class="img-responsive">
								   </div>
								   <p>In addition to hotels and very comfortable kibbutz guest houses, the Galilee is filled with dozens of country bed-and-breakfast accommodations, known as zimmerim. Many offer luxurious accommodations, including pools, and make a delightful base for relaxing and touring.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "Caesarea",
    ctg: "general",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "eLZ433_S6HI",
    title: "CAESAREA",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>The Roman port city of Caesarea is one of Israel’s wonders, combining ancient structures, archeology and a picture-perfect harbor, and adapting them for modern use.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/caesarea/1.jpg"} class="img-responsive">
								   </div>
								   <p>Built by Rome’s Judean Governor, Pontius Pilate, two millennia ago, Caesarea was one of the largest and most magnificent ports in the Mediterranean, with giant piers stretching out into the sea to accommodate dozens of ships. The city of Caesarea contained a giant hippodrome, aqueduct and theater; a thousand years later the Crusaders arrived and built a giant fortress, and then came the Ottomans, who turned it into a seaside town. Today, the Roman theatre is a venue for concerts, the Crusader fortress is thrilling to visit and the Ottoman harbor and beach are full of cafes, restaurants and a visitors’ center. Caesarea is 45 minutes’ drive from Tel Aviv, 20 from Haifa.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "Acre",
    ctg: "general",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "KlXXyToCmCM",
    title: "ACRE",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						          <p>Recognized by UNESCO as a World Heritage Site, visiting Acre (Akko) promises visitors an emotional journey to a glorious past and a one-of-a-kind experience. An ancient and wondrous city, Akko boasts many remarkable sites including the remnants of the Hellenistic-Roman period as well as structures from the Crusader and Ottoman periods.</p>
                                  <p>Much more than a historical and archeological marvel, Akko also has colorful Oriental markets, museums, beaches and water sports facilities, a fishermen’s port, marina, restaurants, hotels, and annual picturesque festivals – all that and more are just a few of the city’s fantastic tourist attractions.</p>
                                  <p>The city's fascinating historical heritage, its rare blend of East and West, authentic glimpses from the past and unique remnants from different cultures, have all made Akko into one of the most vital Ancient World cities.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/1.jpg"} class="img-responsive">
								   </div>
								   <h3>The Knights' Halls</h3>
								   <p>A magnificent tour of the halls of the Hospitallers Order’s Fortress from the Crusader period. Discover the amazing remains of the ancient Order, the renovated and stunningly reconstructed halls, courtyard and surrounding streets, and step into history as a 830-year old story unfolds before you within the halls of the citadel.</p>
								   <p>Be sure to visit the streets, chapels, stores and the Arts and Crafts Market, featuring artisans from the Crusades era, offering their wares: blacksmiths, glass blowers, potters, weavers, embroiderers, leather craftsmen, basket weavers, perfume and oil craftsmen, and more</p>
										<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/2.jpg"} class="img-responsive">
								   </div>						   
		                        `,
      };
    },
  },

  {
    id: "Haifa",
    ctg: "general",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "3ahATaKkhBk",
    title: "HAIFA",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>Haifa is Israel’s third-largest city, Israel’s chief port and home to 400,000.  Draped around the slopes of biblical Mount Carmel, it is a 100-year-old city whose importance burgeoned in the 1920’s and 1930’s as Britain followed its League of Nations mandate over Palestine to create a Jewish homeland. The bustling lower Carmel neighborhood is the port area and where much of Haifa’s daily business is conducted. The slopes of central Carmel are largely residential, and the mountaintop Upper Carmel is home to museums, many hotels and shops. Transportation from the top to the bottom of Mount Carmel is achieved by the Carmelit subway, the Bat Ganim cable car and, of course, by road.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/haifa/1.jpg"} class="img-responsive">
								   </div>
								   <p>Haifa’s iconic symbol is the golden-domed Baha’i Shrine of the Bab, completed in 1953, that abuts the international headquarters of the Baha’i Faith, a network of giant white Greco-Roman buildings whose beauty stuns the visitor. The Shrine of the Bab was further beautified with the completion in 2001 of the “hanging gardens” (a UNESCO World Heritage Site) magnificent terraced gardens that lead from the shrine to the bottom of Mount Carmel. Here is the restored Templer Colony – where the homes and workshops of 19th-century German Christian “Templer” immigrants are now a network of chic stores, bars and restaurants.</p>
								   <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/haifa/2.jpg"} class="img-responsive">
								   </div>
								   <p>Haifa is home to a dozen museums – including a museum of Japanese Art, Israel’s Railway Museum and the Af-Al-Pi-Chen Museum of Illegal Immigration. It is also home to the Technion, Israel’s version of MIT. Haifa’s Wadi Nisnas neighborhood is the center of multi-holiday celebrations reflecting Haifa’s identity as city that is home to Jews, Christians, Muslims and Baha’is.</p>
								   <h3>MUST SEES:</h3>
								   <p><em>Baha’i Shrine of the Bab</em></p>
								   <p><em>Baha’i “Hanging Gardens”</em></p>
								   <p><em>Panorama of Haifa Bay from Upper Carmel</em></p>
								   <p><em>Templer Colony</em></p>
								   <h3>IF YOU HAVE MORE TIME:</h3>
								   <p><em>Af-Al-Pi-Chen Museum of Illegal Immigration</em></p>
								   <p><em>Israel Railway Museum</em></p>
								   <p><em>Museum of Japanese Art</em></p>
								   <p><em>Technion</em></p>
								   <p><em>Wadi Nisnas</em></p>
		                        `,
      };
    },
  },

  {
    id: "Safed",
    ctg: "general",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "i3_ihL51bHo",
    title: "SAFED – WHERE MYSTICAL MEETS THE WORLDLY",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>With endless views that extend into distant horizons and pristine mountain air, Safed will instantly captivate you the moment you arrive. Known as the capital of Jewish mysticism past and present, this breathtaking ancient hilltop city is the highest in the Galilee and all of Israel – geologically and spiritually. One of the four sacred cities in Judaism, Safed offers a palpably mystical journey that will leave you in awe of its profound energy.</p>
                                  <p>A short drive from the revered Sea of Galilee, Safed welcomes you with quaint cobblestone alleys and numinous architecture. Listen as the many souls of history share their secrets through an old fortress erected by the Crusaders, the Mamluk, Ottoman and British influences, the War of Independence Monument, as well as a deep sacred history embodied by extraordinary synagogues and ancient tombs.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/Safed/1.jpg"} class="img-responsive">
								   </div>
								    <h3>The Eternal Kabbalah Capital</h3>
								   <p>From Rabbi Shimon Bar-Yohai, the 2nd  century author of the foundational work on the Kabbalah known as the Zohar, to Ari HaKadosh, the father of contemporary Kabbalah, Safed has been home to Judaism’s highest mystics and their devout students. It was 16th  century when Ari HaKadosh “democratized” Kabbalistic teachings by bringing in a new understanding – one that allowed Kabbalah to reach the laymen.</p>
								   <p>As you walk from one synagogue to the next, you’ll feel just how Safed became the unchanging home for such a long lineage of spiritual aspirants, regardless of all that history threw their way. The Abuhav Synanogue whose architectural elements embody numerical mysticism, the Ari Ashkenazi Synagogue dedicated to Ari HaKadosh, and the Yosef Caro Synagogue will all transport you through time and into mysticism’s upper worlds.</p>
								   <h3>An Inspirational Old City   </h3>
								   <p>Add more unforgettable moments to your trip by walking the winding cobblestone alleys in the Old City, viewing unique stone buildings and continuing on to the Artists’ Colony. Home to quality galleries that will introduce you to the exquisite works of local artists, including a wide variety of Judaica, this part of the Old City is for lovers of all things art. The Doll Museum and the Museum of Printing Art are special must-see for the culture-hungry.</p>
								   <p>Safed can be as nourishing for your body as it is for your soul – the Old City’s eclectic food offerings promise to please every taste and budget. From Yemenite pancakes and street food to unexpected delicacies at sit-down restaurants, you’ll find all that you’re looking for and more in this gracious city of deep traditions.</p>
																   
		                        `,
      };
    },
  },

  {
    id: "Safed",
    ctg: "jewish",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "i3_ihL51bHo",
    title: "SAFED – WHERE MYSTICAL MEETS THE WORLDLY",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>With endless views that extend into distant horizons and pristine mountain air, Safed will instantly captivate you the moment you arrive. Known as the capital of Jewish mysticism past and present, this breathtaking ancient hilltop city is the highest in the Galilee and all of Israel – geologically and spiritually. One of the four sacred cities in Judaism, Safed offers a palpably mystical journey that will leave you in awe of its profound energy.</p>
							  <p>A short drive from the revered Sea of Galilee, Safed welcomes you with quaint cobblestone alleys and numinous architecture. Listen as the many souls of history share their secrets through an old fortress erected by the Crusaders, the Mamluk, Ottoman and British influences, the War of Independence Monument, as well as a deep sacred history embodied by extraordinary synagogues and ancient tombs.</p>
							  <div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/Safed/1.jpg"} class="img-responsive">
							   </div>
								<h3>The Eternal Kabbalah Capital</h3>
							   <p>From Rabbi Shimon Bar-Yohai, the 2nd  century author of the foundational work on the Kabbalah known as the Zohar, to Ari HaKadosh, the father of contemporary Kabbalah, Safed has been home to Judaism’s highest mystics and their devout students. It was 16th  century when Ari HaKadosh “democratized” Kabbalistic teachings by bringing in a new understanding – one that allowed Kabbalah to reach the laymen.</p>
							   <p>As you walk from one synagogue to the next, you’ll feel just how Safed became the unchanging home for such a long lineage of spiritual aspirants, regardless of all that history threw their way. The Abuhav Synanogue whose architectural elements embody numerical mysticism, the Ari Ashkenazi Synagogue dedicated to Ari HaKadosh, and the Yosef Caro Synagogue will all transport you through time and into mysticism’s upper worlds.</p>
							   <h3>An Inspirational Old City   </h3>
							   <p>Add more unforgettable moments to your trip by walking the winding cobblestone alleys in the Old City, viewing unique stone buildings and continuing on to the Artists’ Colony. Home to quality galleries that will introduce you to the exquisite works of local artists, including a wide variety of Judaica, this part of the Old City is for lovers of all things art. The Doll Museum and the Museum of Printing Art are special must-see for the culture-hungry.</p>
							   <p>Safed can be as nourishing for your body as it is for your soul – the Old City’s eclectic food offerings promise to please every taste and budget. From Yemenite pancakes and street food to unexpected delicacies at sit-down restaurants, you’ll find all that you’re looking for and more in this gracious city of deep traditions.</p>
															   
							`,
      };
    },
  },

  {
    id: "The_Bahai_Gardens",
    ctg: "general",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "JV_AmfRULOo",
    title: "THE STUNNING BAHA’I GARDENS",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						          <h3>Visit the Baha’i Gardens</h3>
                                  <p>Picture yourself standing on the nineteenth terrace which is the very top of this breath taking monument where you can see the rolling hills of the Galilee, the city of Haifa, Akko and the Mediterranean Sea.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/bahai-gardens/1.jpg"} class="img-responsive">
								   </div>
								   <p>Beauty, grandeur, and inspired design combined with the meticulous gardening by generations of dedicated gardeners and a variety of cultures create the unique atmosphere of the Baha’i shrine and gardens in Haifa. While each garden offers a different experience they all share the same theme of gravelling paths, unique hedges and flourishing flower beds. A picture so perfect you must see it with your own eyes to believe the precision and symmetry.</p>
								   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/bahai-gardens/2.jpg"} class="img-responsive">
								   </div>
								     <p>This mystical iconic is site where members of the Baha’i faith have established their shrine and world centre because of its significance to their faith.</p>
                                   <p>The Baha’i faith had its origins from Iran. Its founder Baha'u'llah, was exiled from his homeland at the end of the 19th century, and came to Akko (Acre) and Haifa after suffering persecution in neighbouring countries.   He was impressed with the beauty of Mount Carmel and expressed the desire that the Bab (one of the central figures of the Baha’i faith) would be buried there. About 20 years later the bones of the Bab were laid to rest in Haifa on the site that then developed into the centre of The Baha’i faith which is visited by half a million people every year.</p>
		                        `,
      };
    },
  },

  {
    id: "The_Sea_Of_Galilee",
    ctg: "general",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "haG-t3wwuMc",
    title: "THE SEA OF GALILEE (KINNERET )",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  
								   
		                        `,
      };
    },
  },

  {
    id: "Rosh_Pina",
    ctg: "general",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "_qKbHL5-qrQ",
    title: "ROSH PINA",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <h3>Turn back the clock in the authentically picturesque Galilee village</h3>
                                 <p>Known as the Princess of the Galilee, Rosh Pina is home to the perfect mix of natural, cultural, historic and entertainment hotspots. A beautifully restored, serene northern village where aged olive trees and quaint homes are surrounded by lush golden fields, Rosh Pina is just the place for a leisurely and relaxing vacation, where visitors can relive village life as it was, over a century ago.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/rosh-pina/1.jpg"} class="img-responsive">
								   </div>
								   <h3>Where magical silence is broken only by chirping birds</h3>
								   <p>In search of a serene nature-filled location, reminiscent of Italy’s Tuscany or France’s Provence? Head north to Rosh Pina, where breathtaking rural landscapes are unhindered by the village’s attractions and you will feel as if transported to an era long ago. Choose from the many available guest houses, outfitted to provide maximum hospitality and interspersed throughout the village’s romantic alleyways, unadulterated by the bustle of the big city and breathing new life into the bewitchingly quaint and hospitable community.</p>
								   <p>Take advantage of the local natural beauty and traipse through stunning green  hiking pathsaround Rosh Pina’s river or about the  Baron de Rothschild’s Gardens, reportedly modeled to resemble the grand gardens at Versailles. Breathe in the fresh air and enjoy the sheer natural beauty as you stroll, becoming one with nature and recharging your batteries.</p>
								   <h3>A vacation colony with a unique, artistic charm</h3>
								   <p>Stroll about the village’s cobblestone streets, reminiscent of old European towns, and you will encounter a delightful cultural and artistic atmosphere surrounded by magnificent Galilee mountains. A place of trendy coffee shops, gourmet restaurants, art galleries, museums, festivals, historical sites and a shopping center, the city is teeming with antiquity, culture, nature and culinary delights, together recounting the history of the first “Galilee Moshava” (town) and the establishment of Jewish communities in Israel.</p>
																   
		                        `,
      };
    },
  },

  {
    id: "Nazareth",
    ctg: "general",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    title: "NAZARETH",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						         <p>A blend of faiths and cultures - See the “Cradle of Christianity” come alive before you.</p>
                                 <p>World renowned as the childhood home of Jesus, Nazareth is the largest Arab city in Israel, and an important site for pilgrims and tourists, coming to visit the Basilica of the Annunciation. bustling mini-metropolis, Nazareth offers shop-lined thoroughfares, stone-paved alleys lined with Ottoman-era mansions, and in recent years, has been reinventing itself as a sophisticated cultural and culinary destination. Everything in Nazareth is open for business on Shabbat (Friday night and Saturday) and its friendly vibe and stunning location, right in the middle of the Lower Galilee (about 15 miles West of the Sea of Galilee), makes it a beloved stop on many tourists’ routes.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/nazareth/1.jpg"} class="img-responsive">
								   </div>
								   <h3>The Cradle of Christianity</h3>
								   <p>Nazareth, which began as a small Jewish village about 2,000 years ago, became a stronghold of Christianity in the Byzantine period, just a few hundred years later. During that period the name of Nazareth spread far and wide, and the yearnings to see the place where the Virgin Mary and Jesus Christ had lived turned the city into a popular pilgrimage site. These visits led to the building of the city’s first church - the Church of the Annunciation at the traditional site of Joseph and Mary’s home. Many more churches have been built throughout the city, and were destroyed and rebuilt with the changes in Muslim and Christian rule over the centuries. In the 19th century Nazareth attracted renewed interest and Christians returned to live in this city and rebuilt churches and monasteries. Today Nazareth is the largest Arab city in Israel and has about 30 churches and monasteries, as well as mosques and ancient synagogues.</p>
								   <h3>A taste of the old city</h3>
								   <p>A tour of Nazareth is like reliving its various periods. Every era left behind it a powerful symbol that became a delightful and popular tourism site in the modern era. Most of the sites are concentrated in the Old City, built in the mid-19th century in a charming Middle Eastern architectural style. A walk through the narrow streets, between the picturesque houses, is an amazing experience and it is worth walking slowly to enjoy their beauty.</p>
								   <p>There are many ancient churches in the Old City, with the Church of the Annunciation heading the list. The rebuilt church retained parts of the previous churches, from the Crusader and Byzantine periods. The church also houses an impressive collection of paintings.</p>
								   <p>Right next to this church is the Church of Saint Joseph, built on the ruins of agricultural buildings where, according to tradition, Joseph, Mary’s husband, had his carpentry shop. While the Church of the Annunciation was built on the site of Mary’s home, the Greek Orthodox Church of the Annunciation is built over Mary’s Well, from which Jesus mother is said to have drank. This is a structure from the Crusader period and has some interesting frescoes. Right next to Mary’s Well is the Greek Orthodox Church of the Annunciation, inside a Crusader hall. According to tradition, this is the location of the synagogue in which Jesus prayed.</p>
								   <p>Among the many other churches in Nazareth are the Mensa&#8203; Christi Church, the Maronite Church, St. Gabriel’s Church and the Salesian Church. The Old City also has important buildings from the Ottoman period, including the Saraya, or Government House, built by Daher el Omar, the governor of the Galilee in the 18th century, and the White Mosque, which is used today as a house of prayer and an education and culture center. The White Mosque also houses a museum with exhibits that document Nazareth’s history.</p>
								   <p>No tour of Nazareth’s Old City would be complete without a visit to the local market, which has become a popular and well-known attraction thanks to the colorful stalls and the variety of merchandise. In the market you can enjoy a visual feast of fashionable fabrics, taste the spices and local foods, and by artwork and souvenirs. All the sounds, sights, smells and flavors promise an authentic Middle Eastern experience.</p>
								   <h3>Glimpse to a Middle Eastern charm</h3>
								   <p>Nazareth is full of fascinating and lovely corners that will open your heart to their beauty. Another place that is worth visiting during a walking tour is the Nabi Sain ridge promenade to enjoy the marvelous view of the Galilee. You can visit the ancient Turkish bath house discovered during renovations to one of the city’s stores, take a peek at a fancy manor house with a display of the riches and customs of the Ottoman upper class in the 19th century, including some amazing frescoes. Also worth visiting is the Greek Orthodox bishop’s house, where you can walk through a series of underground passages discovered in the courtyard. Another interesting site is the compound built by the Russians as a hostel for pilgrims.</p>
								   <p>Nazareth, which has welcomed pilgrims for centuries, has Christian hostels and fancy hotels for the comfort of the tourists who throng to this important site, especially around Christmas. Dozens of restaurants serve delicious foods with wonderful aromas foods that attract visitors all year long. Nazareth is glorious during Christmas, when the city is decorated for the holiday and its colors and excitement join the holy atmosphere and the sounds of prayer emanating from the city’s churches.</p>
																   
		                        `,
      };
    },
  },

  {
    id: "Cheers_To_Israel",
    ctg: "culinary",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "Cxii1yKqKwI",
    title: "GREAT WITH WHITE OR RED",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>Over the past decade, Israeli wine-making has become a vital and thriving industry.</p>
                                   <p>The fertile land of the area has been recognized worldwide as an excellent setting for burgeoning vineyards, and the local scene is trendy and opulent.</p>
                                   <p>In the north, the general atmosphere reminiscent of French or Italian wine regions while the south  has become renowned for its burgeoning  wine scene, thanks to pioneering farmers and their use of computerized drip irrigation.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/cheers-to-israel/1.jpg"} class="img-responsive">
								   </div>
								    <p><span style="font-family: arial,sans-serif;">The Israeli wine scene allows visitors a fantastic experience combining delectable wine tastings with the stunning vistas and energy this has to offer.</span></p>
								   <p>So come get a taste of Israel’s wine country through its many fantastic tours of the vineyards and boutique wineries, the fantastic wine and music festivals and year-round wine-themed events.</p>
								   <p>FYI, a visit to Israel goes great with white or red.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "A_Galilean_Treat",
    ctg: "culinary",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "kF808ENuuTQ",
    title: "CULINARY JOYS TO SUIT EVERY PALATE",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						          <p>A visit to the Galilee brings tastes and flavors unlike any you’ve ever experienced before. From regional cheeses handmade in artisanal dairies to world-class wines from boutique vineyards, from gourmet family-run restaurants to freshly-picked fruits and vegetables bursting with flavor, the Galilee is a foodie’s paradise.</p>
								   <h3>A Region Flowing with Milk and Wine</h3>
								   <p>Visit an artisanal dairy to discover the richness of Galilee cheeses and take part in the rhythm of cheese-making. Let an expert cheese-maker guide you as you taste some of the area’s many unique soft, hard and semi-hard cheeses, such as  <em>lebane</em>, a creamy yoghurt-like soft cheese made from sheep or goat’s milk that is often served mixed with local herbs like za’atar, or  <em>zefatit</em>, a salted sheep’s curd cheese that is molded into a basket and named for the area of  <em>Zefat</em>, or Safed, where it was first made.</p>
								   <p>If you’d like some wine to accompany your cheese, you’ll be in for a treat. Each wine is better than the last. A recent revolution in wine-making caused boutique wineries to spring up across the Galilee’s highly varied terroir, every vineyard raising grapes with a flavor that is specific to the soil in which they grow. Gaze out over hills covered in vines while you savor deep, fruity reds and fresh white wines with the guidance of Israel’s top wine-makers. Explore the grape blends that produced wines earning top honors at the world’s wine fairs, many of which are not available for sale outside of Israel.</p>
								   <h3>Taste the Harvest</h3>
								   <p>Visit pick-your-own orchards to revel in berries, apples, cherries, peaches, plums and even sabra-fruit that are plump, juicy and bursting with flavor. Tour spice farms to smell and taste an ever-changing range of herbs and spices, both those that are familiar to you and those that you’ve never encountered before. Discover the Galilee’s native flavors and create your own herbal teas and spice blends.</p>
								   <p>Another of the Galilee’s important harvests, olive oil, also awaits you. If you thought that all olive oil tastes the same, a visit to a family-run olive oil farm in the Galilee will change your mind. Sample olive oils to learn what makes each oil taste different and join the fun of picking olives and pressing them the old-fashioned way to make your own extra-virgin olive oil.</p>
								                                 
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/galilean-treat/1.jpg"} class="img-responsive">
								   </div>
								   <h3>Markets and Restaurants</h3>
								   <p>The Galilee’s ancient towns boast a plethora of markets where you can buy the best local produce and artisanal products, often sold by the experts who made them. Amble the markets tasting and testing to discover delights around every corner, or join a knowledgeable foodie guide who will lead you to the best stalls and finest treats.</p>
								   <p>As you wander the Galilee following your taste buds you’ll encounter gourmet restaurants tucked away in the unlikeliest corners. Some of the country’s best cooking is served in unassuming Galilee eateries perched on the edge of magnificent views. Many are family-run, serving dishes made with love from ingredients that were grown or raised within just a few miles. But to really plumb the depths of the Galilee’s produce, take part in a cooking workshop. They are led by local chefs who know the land inside and out and are eager to share the best way to choose, prepare and enjoy the tastiest local produce. Often you’ll pick your ingredients before you prepare them, making dishes that taste better than anything you’ve ever cooked before.</p>
								   <h3>The Unique Experience of the Galilee</h3>
								   <p>The Galilee is much more than a series of delicious flavors. Visit ruined fortresses and biblical sites where Jesus preached and battles were fought. Climb up mountains, thrill with white-water rafting and hike alongside bubbling streams as part of your dream vacation in the Galilee.</p>
											<p>Photo credit:Itamar Grinberg		</p>			   
		                        `,
      };
    },
  },

  {
    id: "Galilee_Action",
    ctg: "active-adventure",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "5Ep3GgxELag",
    title: "GALILEE ACTION",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>The Galilee’s multitude of rivers, lakes and coastline are the source of plenty of fun for all ages. Thrill-seekers can feel the spray on their faces while they race their friends on whitewater kayaking, or families or couples can relax together floating past the cool green banks of one of the Galilee’s many rivers. You can cool off with exciting water fun like water-skiing, tubing or kite surfing on the Sea of Galilee. Along the coast, tourists love hanging out on the Galilee’s hot sandy beaches or visit the eerie glowing beauty of the Rosh Hanikra grottoes.</p>
                                   <p>Extreme sports can be found on land and in the air as well as on water. Active tourists can enjoy adrenaline-packed activities like sky-jumping, jeeping over rough mountain tracks or rappelling down challenging cliffs. In winter, take the sports to the snow at the Hermon mountain range with skiing and snowboarding on easy or challenging pistes.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/galilee-action/1.jpg"} class="img-responsive">
								   </div>
								   <h3>The Breathtaking Natural Bounty of the Galilee</h3>
								
								   <p>The Galilee is overflowing with areas of natural beauty where families, lovers and groups of friends can hike, glimpse wildlife, or just enjoy a picnic in the calming embrace of nature. Clopping along quiet paths on horseback or following the well-marked trails on foot or on a bicycle rewards you with beauty, fun and excitement wherever you go. See nature in a more relaxed way by going bird and wildlife spotting at the Hula Valley Nature Reserve, or experience the magic of the whole patchwork of forest, field and river unfolding below you as you rise in a hot-air balloon in the Gilboa. Add to the experience by immersing yourself in spirituality in sites holy to Christians, Jews and the Baha’i.</p>
								   <p>The Galilee’s many hiking trails are a magnet for hikers of all ages, all year round. Whether you prefer a shady strolls alongside gentle brooks, the thrill of mountain climbing and rappelling, or enjoy the achievement of reaching the amazing view at the top of a challenging hill, you’ll find the perfect path waiting for you. In the Galilee all the options are open.</p>
								   <p>Photo credit:Itamar Grinberg</p>
								   
		                        `,
      };
    },
  },

  {
    id: "Bet_Shean",
    ctg: "general",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: false,
    title: "BET SHE’AN",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>South of the Sea of Galilee are the remains of one of the largest cities in the Roman-Byzantine Empire, Bet She’an. One of ten ancient cities (hence “Decapolis”) that included Philadelphia (present day Amman in Jordan) and Jerash, Scythopolis ((Bet She’an) was the only decapolis city west of the Jordan river.  It was very grand, with a giant theater, streets of tall columns, shops, bathhouses a hippodrome and hundreds of homes.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/bet-shean/1.jpg"} class="img-responsive">
								   </div>
								   <p>However, the splendid city was toppled in 749 by a massive earthquake, and never rebuilt. Over the centuries the ruins were overgrown – and it was not until the mid-20th century that Israeli archeologists pulled Bet She’an out of the murk, discovering (and restoring) the theater, the Cardo, the columns and much more.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "Zichron_Yaakov",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: false,
    title: "ZICHRON YA’AKOV",
    smltitle: "",
    html: function() {
      return {
        __html: ` <p>Zichron Ya’akov is a wonderful town for tourists, both local and foreign. This picturesque moshava semi-cooperative farming community built at the tip of the Carmel mountain range is the first moshava ever built in Israel and is a main tourism and vacation site in this region.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/zichron-yaakov/1.jpg"} class="img-responsive">
								   </div>
								    <p>Anyone who visits  <strong>Zichron  Ya’akov  </strong>goes straight to Ha-Nadiv Street, and Ha-Meyasdim Street in the town center, which has become a very popular pedestrian mall, thanks to the special atmosphere in this place. The streets are paved with stones and pass between the moshava’s original houses (some of which have been reconstructed), which are bustling with activity.</p>
								   <p>There are many quaint and charming restaurants and coffee shops, interspersed between beautifully designed stores that sell local art works and lovely souvenirs. There are art galleries, unique artists' studios and workshops. New, modern buildings stand alongside old ones, such as the synagogue and the administration building, an old courtyard with a display of antique agricultural implements.</p>
								   <p>From its early days,  <strong>Zichron Ya’akov</strong>  had two main characteristics: wine and tranquility. The moshava’s founding farmers cultivated vineyards and the large winery built here in 1889 became the area’s most important industry. During the British Mandate period (1917-1948), the moshava became a holiday resort and rural vacations site, and to this day has hotels, spas and guesthouses.</p>
																   
		                        `,
      };
    },
  },

  {
    id: "Discover_The_Wine_Routes",
    ctg: "culinary",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "Cxii1yKqKwI",
    title: "DISCOVER THE WINE ROUTES",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>Discover a different Israel through it's wineries and vineyards, through the passion of the people who are crafting award winning wines from home grown grapes.</p>
                                   <p>Enjoy vintage wines, gourmet foods, and gorgeous scenery. Spend time experiencing Israel as you never have before, as a Wine Connoisseur! The beauty of these routes in Israel is of course the authentic wine but also the incredible landscapes that surround the wineries. Many of the wineries are situated near ‘Zimmers’ which are little spa complexes that are dotted around northern Israel. They have little cabins with Jacuzzis that face out to the magnificent views of the rolling green hills. You can relax in your personal cabin with a splendid glass of wine from the local winery.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/discover-the-wine-routes/1.jpg"} class="img-responsive">
								   </div>
								   <div class="wpb_wrapper"><p>The Middle East &amp; Eastern Mediterranean was the cradle of wine production, and the ancient land of Canaan is in fact one of the earliest countries to cultivate wine over 2,000 years before the vine came to Europe.</p><p>There are currently over 25 commercial wineries and over 150 boutique wineries in Israel where wine making has become a personal obsession with wine makers striving to produce world class wines.</p><p>Israel like other 'long' countries such as Chile or Italy enjoys a variety of microclimates. While the northern region gets much rain and even snow in the winter, just a few hours away Israel's southern region is very arid with desert conditions. This range in microclimates supports many grape varieties, which can grow on several different types of soil, yielding excellent results.</p><p>As always in matters of taste, you must visit Israel’s wineries and vineyards and decide for yourself which is your favourite!</p><p></p></div>
								   
		                        `,
      };
    },
  },

  {
    id: "Birdtastic_Hula_Lake",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "ImobrsxsKl8",
    title: "BIRDTASTIC HULA LAKE",
    smltitle: "",
    html: function() {
      return {
        __html: `  <p>Hula Valley The Hula valley is located in a drained swampland by an attractive large lake, and is one of the area’s top places for friendly hiking and biking excursions. The Hula Valley is the country’s primary migration route for birds, making bird watching a very popular and fascinating experience.  <strong>In 2009, the BBC Nature Magazine named the Hula Valley as one of the top nature watching places in the world.</strong></p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/birdtastic-hula-lake/1.jpg"} class="img-responsive">
								   </div>
								   <h3>Discover One of the World's Top Birdwatching Sites</h3>
                                   <p>In the heart of the picturesque Hula Valley in Upper Galilee, only two hours drive north from Tel-Aviv, between two majestic mountain ranges, lays a place of extraordinary beauty - the Hula Lake. One of the most important birdwatching sites in the world, this ecological internationally acclaimed wetland reserve, is an oasis for birds and nature lovers everywhere. Offering a rare and unique opportunity to experience nature without barriers or partitions, it's an invitation for an experience of a lifetime.</p>
								    <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/birdtastic-hula-lake/2.jpg"} class="img-responsive">
								   </div>
								   <h3>Follow the Birds and Marvel Nature</h3>
								   <p>During every migration season (spring and fall) over 500 million birds and close to 400 species travel through the Hula Lake. This wetland paradise is the perfect stopover for small waterfalls, cormorants, heron, pelicans, raptors, strokes and cranes.</p>
								   <p>Declared by the BBC Wildlife as one of the world's top ten birdwatching sites, Hula Lake or as it called in Hebrew Agamon Hula, naturally attracts birdwatchers from all around the world. Join the international Hula bird festival every year in the fall and enjoy a truly not-to-be missed-experience.</p>
								   <p>There are several ways to witness this dazzling humbling phenomenon. All you need is simply choose your adventure.</p>
								   <p><strong>Explore the Trails</strong>. Tour the park's magical trails. You can walk, bike or use club carts to drive around. You'll pass through fruit groves waterway and get a glimpse of the wetland wildlife.</p>
								   <p><strong>Drive a Tractor</strong>. Join a guided tour in a Tractor-Drawn "Safari Wagon" that takes you deep into the Agamon's premises. The wagon "hides" you from the birds and therefore enables a rare up close and personal encounter with these beautiful creatures.</p>
								   <p><strong>Sunrise and Night tours</strong>. For the more adventurers, there are 2 special tour experiences. One is the 'Sunrise Tour' that offers unbeatable birdwatching and photography opportunities. Alternatively, the 'Night Owl Tour' offers a completely different look on the reserve. With campfire and star-gazing you'll peek into the lives of wild cats, nocturnal raptors and fruit bats.</p>
								   <p><strong>Uplift the Spirit and Witness Nature Preservation at Work</strong><br> Agamon Hula gained world acclaim for being model for a sustainable ecological system balancing between nature, tourism and agriculture.<br> Visit the ringing center in the park and watch the work done to preserve nature. Go to the "bird Island tour" and maybe you'll even get a chance to help release a bird back to nature. It doesn't get much better than this.<br> With so many different types of animals and tireless work to preserve nature in creative ecological ways, Hula Lake offers more than a fun trip with beautiful scenery but a true feel good experience that opens the heart and mind.</p>
										                     
		                        `,
      };
    },
  },

  {
    id: "The_Kibbutz_Experience",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: false,
    title: "THE INCOMPARABLE KIBBUTZ EXPERIENCE",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <p>Predominantly based amongst beautiful landscape settings dotted around the country the Kibbutz life is a modern day phenomenon and a totally unique way of living. The movement which started in 1905 is a collective community way of living traditionally based on agriculture. Each kibbutz would sell its own produce.  The people living on them would all collectively work together to preserve it and work the land.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/kibbutz-experience/1.jpg"} class="img-responsive">
								   </div>
								    <p>The word ‘Kibbutz’ in Hebrew means group.  The point being it is a voluntary democratic community where people live and work together to generate economically. It is founded on the principles of communal ownership of property and social equality.</p>
                                   <p>Some would describe the beautiful settings and a life of equality a utopia and why not experience it for yourself?   Many of the Kibbutzim are open to visitors whether you would like to stay a few hours or a few months learning what this life is all about.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "National_Parks",
    ctg: "general",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: false,
    title: "NATIONAL PARKS",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						          <p>Despite Israel being small its scenery varies immensely! You will find new cities and old, beaches and lakes, deserts and green mountains. Israel’s National parks and nature reserves make all this possible for you to experience the wondrous landscapes.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/national-parks/1.jpg"} class="img-responsive">
								   </div>
								   <p>In the south of the country you will find the expanse of the golden and orange plains of the desert. The Negev, Arava and Eilat are the fiery beautiful landscapes of the south that home the Dead Sea, Mitzpe Ramon and the beautiful desert oasis of En gedi not mention some wonderful hiking and cycling trails. When the sun sets the south turns in to a red illuminous sea of magic and when dark the sky turns in to a blanket of sparkles as the vast scenery makes it possible to see every star.</p>
                                   <p>In the North of the country you are welcomed with Luscious green hills and mountains including the snow-capped Mount Hermon.   The Golan Heights home to magnificent mountainous scenery and an array of cultures.   There are endless forest trails and water fall hikes for all the family to enjoy. The view from the mountain tops is breath taking as your eyes take you all the way out to the Mediterranean. Below the mountains you will find the green slopes of the Galilee home to the famous Kinneret, wineries and some wonderful relaxation spa’s. It really is a wonderland.</p>
								   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/national-parks/2.jpg"} class="img-responsive">
								   </div>
								   <p>The national parks offer exciting cultural and natural adventures. You have the opportunity to visit magnificent historical sites and follow wonderful nature trails while searching for some of the countries species i.e. The desert ibex and leopards, Eagles in the Golan. The impressive diversity of natural wonders, encounters with unspoiled nature and with plants.</p>
		                        `,
      };
    },
  },

  {
    id: "Tiberias",
    ctg: "north",
    bgImage: "/posts/bank/tiberias/1.jpg",
    mobBgImage: "/posts/bank/tiberias/M.jpg",
    isVid: false,
    title: "TIBERIAS (TVERYA)",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <p>Located at the shores of the Sea of Galilee, Tiberias, the capital of the Galilee, was established in the early Roman period and has served as a religious, administrative and culture center of the Jewish people for many years.</p>
                                  <p>In addition to its rich history and significance, modern day Tiberias is synonymous with holiday in Israel. Here one can enjoy a variety of activities the city has to offer, and experience a wonderful mix of relaxation, nature and history, along with contemporary attractions, active water sports, pilgrimage sites and unique tourist attractions</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/tiberias/1.jpg"} class="img-responsive">
								   </div>
								   <p>A visit to Tiberias is not complete without a visit to its surrounding area, which features many must-see sights, including The city Bet Shean, one of the oldest cities in the world, and one of the country’s largest archaeological sites; Magdala (Migdal) the ancient town on the Sea of Galilee which was home to many of Jesus’s disciples and is said to have been the home of Mary Magdalene; Megiddo, a beautiful and impressive national park and one of the most important archeological sites in Israel from the time of the Bible. Once an ancient city of critical strategic importance, Megiddo is a UNESCO World Heritage Site, and an inspiring location for lovers of history and archeology.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "Breakfast-In-Israel",
    ctg: "culinary",
    bgImage: "posts/bank/breakfast-in-israel/1.jpg",
    mobBgImage: "posts/bank/breakfast-in-israel/M.jpg",
    isVid: true,
    vidId: "JJ7PhOw1p5E",
    title: "BREAKFAST IN ISRAEL",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						          <h3>A LEGEND IN ITS OWN MEALTIME</h3>
						         
								    <p>Breakfast in an Israeli hotel or restaurant is unparalleled.<br/>
									The Israeli breakfast is a world renowned culinary institution. So much so in fact, that you can find it as its own standalone category on most self-respecting restaurants and café’s’ menus.</p>
									<p>What is so special about the Israeli breakfast you ask? Well, it’s actually a mixture of things.</p>
									<p>The ingredients – fresh, local, bursting with flavors and the perfect way to start a healthy energetic day in this vibrant country.</p>
                                    <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/breakfast-in-israel/1.jpg"} class="img-responsive">
								    </div>

                                    <p>The Variety -   While the Israeli breakfast has the same basic types of food – eggs, cheese, bread, salads etc. – everywhere you go you will receive different types, different flavors and different styles of cooking and serving- made to order, just as you like.</p>
									<p>The generosity – the Israeli breakfast is the gift that just keeps giving, from the incredible omelets to the huge selection of soft and hard cheeses, from the amazing variety of salads to the obligatory fresh squeezed juices and coffee to order - the Israeli breakfast can be the only meal you eat in a day.</p>
									<p>Location location location – the best way to enjoy the fantastic feast called the Israeli breakfast is of course - in Israel, while engaging in people watching in the trendy streets of Tel Aviv, chilling out by the waves in the cafes on the beaches or promenades, or taking in the magnificent air and stunning views of any of this country’s stunning attractions.</p>
											   
		                        `,
      };
    },
  },
  {
    id: "Mount_Carmel",
    ctg: "christian",
    bgImage: "posts/bank/mountcarmel/1.jpg",
    mobBgImage: "posts/bank/mountcarmel/M.jpg",
    isVid: false,
    vidId: "",
    title: "MOUNT CARMEL",
    smltitle: "",
    html: function() {
      return {
        __html: `	
								<p>"Your head crowns you like Carmel, and the flowing locks of your head are like purple threads" Song of Solomon 7:5</p>
								
								<p>Mount Carmel is situated between the Mediterranean Sea and the Jezreel Valley. The immense natural beauty of the Carmel forest is coupled with the biblical story of Elijah confronting the false prophets of Baal (1 Kings 18). The story can be recounted and experienced visually in the Stella Maris church, whose view is amazing, or from the Mukraha monastery, whose breath-taking view looks to the Jezreel Valley and the Kishon stream where the slaughter took place. You can see the traditional site of Elijah's Cave where Elijah hid in the cliffs towards the sea.</p>

								<p class="ac-margin-bot-20">In the heart of the Carmel National Park are the Druze communities of Daliat el Carmel and Issifiya, where you can enjoy the bustling markets featuring traditional Druze products. The Druze culture is fascinating, placing its roots as descendants of Jethro, Moses’ father-in-law (Exodus 4:17).</p>

								<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
								
								<p><i>“The wilderness and the dry land shall be glad; the desert shall rejoice and blossom like the crocus; it shall blossom abundantly and rejoice with joy and singing. The glory of Lebanon shall be given to it, the majesty of Carmel and Sharon. They shall see the glory of the LORD, the majesty of our God.” (Isaiah 35:1-2 ESV).</i></p>

								<p class="ac-margin-bot-20"><i>“When Ahab saw Elijah, Ahab said to him, “Is it you, you troubler of Israel?” And he answered, “I have not troubled Israel, but you have, and your father’s house, because you have abandoned the commandments of the LORD and followed the Baals. Now therefore send and gather all Israel to me at Mount Carmel, and the 450 prophets of Baal and the 400 prophets of Asherah, who eat at Jezebel’s table.” So Ahab sent to all the people of Israel and gathered the prophets together at Mount Carmel. And Elijah came near to all the people and said, “How long will you go limping between two different opinions? If the LORD is God, follow him; but if Baal, then follow him.” And the people did not answer him a word.” (1 Kings 18:17-21 ESV).</i></p>
									
								

							`,
      };
    },
  },
  {
    id: "Haifa",
    ctg: "christian",
    bgImage: "posts/bank/haifa/1.jpg",
    mobBgImage: "posts/bank/haifa/M.jpg",
    isVid: true,
    vidId: "3ahATaKkhBk",
    title: "HAIFA",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						


						
						<p>Haifa is Israel’s third-largest city, Israel’s chief port and home to 400,000.  Draped around the slopes of biblical Mount Carmel, it is a 100-year-old city whose importance burgeoned in the 1920’s and 1930’s as Britain followed its League of Nations mandate over Palestine to create a Jewish homeland. The bustling lower Carmel neighborhood is the port area and where much of Haifa’s daily business is conducted. The slopes of central Carmel are largely residential, and the mountaintop Upper Carmel is home to museums, many hotels and shops. Transportation from the top to the bottom of Mount Carmel is achieved by the Carmelit subway, the Bat Ganim cable car and by road.</p>
						<p>Haifa’s iconic symbol is the golden-domed Baha’i Shrine of the Bab, completed in 1953, it is the international headquarters of the Baha’i Faith. Its network of giant white Greco-Roman buildings stuns the visitor with its grandeur. The Shrine of the Bab was further beautified with the completion in 2001 of the “hanging gardens” (a UNESCO World Heritage Site) magnificent terraced gardens that lead from the shrine to the bottom of Mount Carmel. Here is the restored Templer Colony – where the homes and workshops of 19th-century German Christian “Templer” immigrants are now a network of chic stores, bars and restaurants.</p>
						<p class="ac-margin-bot-20">Haifa is home to a dozen museums – including a museum of Japanese Art, Israel’s Railway Museum and the Af-Al-Pi-Chen Museum of Illegal Immigration. It is also home to the Technion, Israel’s version of MIT. Haifa’s Wadi Nisnas neighborhood is the center of multi-holiday celebrations reflecting Haifa’s identity as a city that is home to Jews, Christians, Muslims and Baha’is.</p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						<p><i>“Now therefore send and gather all Israel to me at Mount Carmel, and the 450 prophets of Baal and the 400 prophets of Asherah, who eat at Jezebel's table. So Ahab sent to all the people of Israel and gathered the prophets together at Mount Carmel. And Elijah came near to all the people and said, “How long will you go limping between two different opinions? If the Lord is God, follow him; but if Baal, then follow him.” And the people did not answer him a word.” (1 Kings 18:19-21 ESV). </i></p>
						<p><i>“And Elijah said to Ahab, “Go up, eat and drink, for there is a sound of the rushing of rain.” So Ahab went up to eat and to drink. And Elijah went up to the top of Mount Carmel. And he bowed himself down on the earth and put his face between his knees. And he said to his servant, “Go up now, look toward the sea.” And he went up and looked and said, “There is nothing.” And he said, “Go again,” seven times. And at the seventh time he said, “Behold, a little cloud like a man's hand is rising from the sea.” And he said, “Go up, say to Ahab, ‘Prepare your chariot and go down, lest the rain stop you.’” And in a little while the heavens grew black with clouds and wind, and there was a great rain. And Ahab rode and went to Jezreel. And the hand of the Lord was on Elijah, and he gathered up his garment and ran before Ahab to the entrance of Jezreel.” (1 Kings 18:41-46 ESV). </i></p>
						

					`,
      };
    },
  },
  {
    id: "Akko",
    ctg: "christian",
    bgImage: "posts/bank/akko/1.jpg",
    mobBgImage: "posts/bank/akko/M.jpg",
    isVid: true,
    vidId: "KlXXyToCmCM",
    title: "AKKO",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						

						<p>Recognized by UNESCO as a World Heritage Site, visiting Acre (Akko) promises visitors an emotional journey to a glorious past and a one-of-a-kind experience. An ancient and wondrous city, Akko boasts many remarkable sites including the remnants of the Hellenistic-Roman period as well as structures from the Crusader and Ottoman periods.</p>

						<p>Much more than a historical and archeological marvel, Akko also has colorful Oriental markets, museums, beaches and water sports facilities, a fisherman's port, marina, restaurants, hotels, and annual picturesque festivals – all that and more are just a few of the city’s fantastic tourist attractions.</p>

						<p>The city's fascinating historical heritage is a rare blend of East and West, offering authentic glimpses from the past and unique remnants from different cultures. All of this has made Akko into one of the most vital Ancient World cities.</p>
						
						<h3>THE KNIGHTS’ HALLS</h3>

						<p>A magnificent tour of the halls of the Hospitalier's Order’s Fortress from the Crusader period. Discover the amazing remains of the ancient Order, the renovated and stunningly reconstructed halls, courtyard and surrounding streets. You will step into history as a 4,000-year old story unfolds before you within the halls of the citadel.</p>
						<p class="ac-margin-bot-20">Be sure to visit the streets, chapels, stores and the Arts and Crafts Market, featuring artisans from the Crusades era, offering their wares: blacksmiths, glass blowers, potters, weavers, embroiderers, leather craftsmen, basket weavers, perfume and oil craftsmen, and more. </p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						<p><i>“When Israel grew strong, they put the Canaanites to forced labor, but did not drive them out completely. And Ephraim did not drive out the Canaanites who lived in Gezer, so the Canaanites lived in Gezer among them. Zebulun did not drive out the inhabitants of Kitron, or the inhabitants of Nahalol, so the Canaanites lived among them, but became subject to forced labor. Asher did not drive out the inhabitants of Acco, or the inhabitants of Sidon or of Ahlab or of Achzib or of Helbah or of Aphik or of Rehob.” (Judges 1:28-31 ESV).</i></p>
						
						<p><i>“When we had finished the voyage from Tyre, we arrived at Ptolemais, and we greeted the brothers and stayed with them for one day.” (Acts 21:7 ESV).</i></p>
							
						

					`,
      };
    },
  },
  {
    id: "Caesarea",
    ctg: "christian",
    bgImage: "posts/bank/caesarea/1.jpg",
    mobBgImage: "posts/bank/caesarea/M.jpg",
    isVid: true,
    vidId: "eLZ433_S6HI",
    title: "CAESAREA",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						

						<p>King Herod was a magnificent builder and the Roman seaport of Caesarea stands to this day in testament to his ability to take the small town of Straton's Tower and turn it into the headquarters of Northern Palestine.</p>
						
						<p>This is where Peter baptized the Roman centurion Cornelius, the first gentile convert to Christianity (Acts 10). It was from this port that Paul set sail to preach in communities all over the Mediterranean, and where he was later imprisoned for two years and made his powerful speech before Felix, Festus, and King Agrippa (Acts 12-25:6).</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/caesarea/1.jpg"} class="img-responsive" />
						</div>

						<p>This Mediterranean gem offers a host of activities. Start at the monumental seacoast theater and imagine the finest Roman drama unfold before you. The theater was so well engineered that it still remains a mystery how it was done without modern technology; you can speak in a normal tone from the center of the theater and thousands sitting in the theater can hear you clearly.</p>

						<p>At the sea palace of Pontius Pilate there is a stone-encrypted commemoration of the Roman ruler who the New Testament mentions as sentencing Jesus to crucifixion. Along the beautiful beach is a large hippodrome where you can learn about Roman horse races from the impressive frescos along the walls. This hippodrome was also an amphitheater where history records both Christians and Jews were fed to the lions. A Roman administrative center, bathhouse, and a public toilet facility are clearly distinguishable among the remains. A great crusader moat and fortress built by King Baldwin I, stand out impressively.</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/caesarea/2.jpg"} class="img-responsive" />
						</div>
						
						<p>One of the most impressive aspects of Caesarea, which can be partly seen today, is the port built by King Herod, which he called "Sebastos." The Sebastos port was the largest seaport on the eastern Mediterranean and was built with volcanic ash called pozzolana, which kept the breakwater from floating. Aqueducts can be seen along Caesarea's shore that led water from nearby Taninim stream and Shuni spring to the city. Caesarea is also a site containing ante-Nicean Christian history. The remains of a martyrium church built over an earlier Roman pagan temple can be seen in Caesarea's main promenade. Christianity's largest library once stood in Caesarea, where church fathers, like Jerome, used to conduct their theological works.</p>

						<p>A few well-designed boutiques, and some of Israel’s finest restaurants alongside the archeological remains, make Caesarea a must visit. The museum offers a visual presentation, bringing all the stones to life. </p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/caesarea/3.jpg"} class="img-responsive" />
						</div>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						<p><i>“At Caesarea there was a man named Cornelius, a centurion of what was known as the Italian Cohort, a devout man who feared God with all his household, gave alms generously to the people, and prayed continually to God. About the ninth hour of the day he saw clearly in a vision an angel of God come in and say to him, “Cornelius.” And he stared at him in terror and said, “What is it, Lord?” And he said to him, “Your prayers and your alms have ascended as a memorial before God. And now send men to Joppa and bring one Simon who is called Peter. He is lodging with one Simon, a tanner, whose house is by the sea.” When the angel who spoke to him had departed, he called two of his servants and a devout soldier from among those who attended him, and having related everything to them, he sent them to Joppa.” (Acts 10:1-8 ESV).</i></p>

						<p><i>“After he stayed among them not more than eight or ten days, he went down to Caesarea. And the next day he took his seat on the tribunal and ordered Paul to be brought. When he had arrived, the Jews who had come down from Jerusalem stood around him, bringing many and serious charges against him that they could not prove. Paul argued in his defense, “Neither against the law of the Jews, nor against the temple, nor against Caesar have I committed any offense.” But Festus, wishing to do the Jews a favor, said to Paul, “Do you wish to go up to Jerusalem and there be tried on these charges before me?” But Paul said, “I am standing before Caesar's tribunal, where I ought to be tried. To the Jews I have done no wrong, as you yourself know very well. If then I am a wrongdoer and have committed anything for which I deserve to die, I do not seek to escape death. But if there is nothing to their charges against me, no one can give me up to them. I appeal to Caesar.” Then Festus, when he had conferred with his council, answered, “To Caesar you have appealed; to Caesar you shall go.” (Acts 25:6-12 ESV).</i></p>
							
						

					`,
      };
    },
  },
  {
    id: "Jaffa",
    ctg: "christian",
    bgImage: "posts/bank/jaffa/1.jpg",
    mobBgImage: "posts/bank/jaffa/M.jpg",
    isVid: true,
    vidId: "tgF0zMUYY2g",
    title: "JAFFA",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						<h3><u>OLD JAFFA</u></h3>

						<p>Jaffa is a place for beginnings; Jonah’s journey, Tabitha’s restoration to life, and Peter’s conversion of Gentiles all began here. Thus, Jaffa boasts bountiful biblical history, along with charming lanes, antiquities, quiet churches, galleries, and a picturesque fishing port.</p>

						<p>In Jaffa, Peter was divinely led to “think out of the box”. Acts 10:5-23, finds Peter on the rooftop of the House of Simon the Tanner, where he had his famous vision (Acts 10:12-13), which led him to preach the Gospel to the gentiles at Caesarea. Peter's resurrection of the righteous Tabitha (Acts 9:36-42), is marked at the Russian Orthodox Church of Tabitha.</p>

						<p>Jaffa’s landmark Church of St. Peter is off Kedumim Square, where the visitor center proudly boasts the city’s long and fascinating history. At the end of a lane leading through the artists’ colony to Summit Park, an archaeological dig reveals a fortress built by the “Pharaoh of the Exodus,” Ramses II.</p>

						<p>The view of the sea reminds visitors that King Hiram of Tyre sent cedar logs for the Temple to Jaffa, where they were hauled ashore and trundled up to Jerusalem (2 Chron 2:16).</p>

						<p class="ac-margin-bot-20">A plaque, on the beach north of Jaffa, honors the 157 American Christians from Jonesport, Maine, who landed here on the Nellie Chapin in September 1866, bringing the wood with them to build their houses. The story of the American Colony is told at one of the colony’s restored houses in Jaffa, the Maine Friendship House.</p>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						<p><i>“And now send men to Joppa and bring one Simon who is called Peter. He is lodging with one Simon, a tanner, whose house is by the sea.” When the angel who spoke to him had departed, he called two of his servants and a devout soldier from among those who attended him, and having related everything to them, he sent them to Joppa. The next day, as they were on their journey and approaching the city, Peter went up on the housetop about the sixth hour to pray. And he became hungry and wanted something to eat, but while they were preparing it, he fell into a trance and saw the heavens opened and something like a great sheet descending, being let down by its four corners upon the earth. In it were all kinds of animals and reptiles and birds of the air. And there came a voice to him: “Rise, Peter; kill and eat.” But Peter said, “By no means, Lord; for I have never eaten anything that is common or unclean.” And the voice came to him again a second time, “What God has made clean, do not call common.” This happened three times, and the thing was taken up at once to heaven. Now while Peter was inwardly perplexed as to what the vision that he had seen might mean, behold, the men who were sent by Cornelius, having made inquiry for Simon's house, stood at the gate and called out to ask whether Simon who was called Peter was lodging there. And while Peter was pondering the vision, the Spirit said to him, “Behold, three men are looking for you. Rise and go down and accompany them without hesitation, for I have sent them.” And Peter went down to the men and said, “I am the one you are looking for. What is the reason for your coming?” And they said, “Cornelius, a centurion, an upright and God-fearing man, who is well spoken of by the whole Jewish nation, was directed by a holy angel to send for you to come to his house and to hear what you have to say.” So he invited them in to be his guests. The next day he rose and went away with them, and some of the brothers from Joppa accompanied him.” (Acts 10:5-23 ESV).</i></p>
						
						<p><i>“Now there was in Joppa a disciple named Tabitha, which, translated, means Dorcas. She was full of good works and acts of charity. In those days she became ill and died, and when they had washed her, they laid her in an upper room. Since Lydda was near Joppa, the disciples, hearing that Peter was there, sent two men to him, urging him, “Please come to us without delay.” So Peter rose and went with them. And when he arrived, they took him to the upper room. All the widows stood beside him weeping and showing tunics and other garments that Dorcas made while she was with them. But Peter put them all outside, and knelt down and prayed; and turning to the body he said, “Tabitha, arise.” And she opened her eyes, and when she saw Peter she sat up. And he gave her his hand and raised her up. Then, calling the saints and widows, he presented her alive. And it became known throughout all Joppa, and many believed in the Lord.” (Acts 9:36-42 ESV).</i></p>

						<p><i>“And we will cut whatever timber you need from Lebanon and bring it to you in rafts by sea to Joppa, so that you may take it up to Jerusalem.” (2 Chronicles 2:16 ESV).</i></p>
						
							
						

					`,
      };
    },
  },
  {
    id: "Megiddo",
    ctg: "christian",
    bgImage: "posts/bank/megiddo/1.jpg",
    mobBgImage: "posts/bank/megiddo/M.jpg",
    isVid: false,
    vidId: "",
    title: "MEGIDDO",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						

						<p>On a hill in the Jezreel Valley, near the town of Afula you can find one of the most important archeological sites in Israel from the time of the Bible, Tel Megiddo.</p>

						<p>Undisturbed today, with an elegant appearance of a national park, it is difficult to imagine the tumultuous history this land has experienced. Megiddo is mentioned in Egyptian writings, and is also prophesied in the Book of Revelation to be the site of the great and final battle of Armageddon. Recognized as a UNESCO World Heritage Site in 2005, the impressive remains of several civilizations draw many visitors and pilgrims.</p>

						<p>Tel Megiddo was a strategic military location on the Via Maris, the Roman road that led from Egypt to Damascus. It had a long history of battles and conquests. The nearby springs and fertile ground drew the first settlers to the site. It was a city with formidable walls 5,000 years ago. One thousand years later it fell to Egyptian rule, after which the Canaanites conquered and held the city. Under King David, the city became an important administrative center. His son, Solomon, made Megiddo a royal city, which reached the heights of its powers under King Ahab around 2,900 years ago. Ahab turned Megiddo into  “Ir Rekhev” and built impressive water works. Israelite Megiddo fell to the Assyrians in 732 BCE and was finally demolished by the Egyptians in 609 BCE.</p>

						<p>The site includes remains from the city’s glorious past with paths leading through the main sites such as the City Gates and the Ivory Palace in which a treasure of ancient ivory objects and jewelry were discovered – the richest Canaanite treasure ever discovered. Other sites include the stables from Ahab’s time, and the waterworks that include an 80-foot deep shaft and a 230- foot-long tunnel that leads to the springs west of the tel.</p>

						<p class="ac-margin-bot-20">The onsite museum displays the history of Megiddo through an audio/visual presentation. The northern part of the tel has a spectacular view of the Jezreel Valley, while the southern part has an arbor for praying. </p>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						<p><i>“Now the rest of the acts of Josiah and all that he did, are they not written in the Book of the Chronicles of the Kings of Judah? In his days Pharaoh Neco king of Egypt went up to the king of Assyria to the river Euphrates. King Josiah went to meet him, and Pharaoh Neco killed him at Megiddo, as soon as he saw him. And his servants carried him dead in a chariot from Megiddo and brought him to Jerusalem and buried him in his own tomb. And the people of the land took Jehoahaz the son of Josiah, and anointed him, and made him king in his father’s place.” (2 Kings 23:29-30 ESV).</i></p>

						<p><i>“And I will pour out on the house of David and the inhabitants of Jerusalem a spirit of grace and pleas for mercy, so that, when they look on me, on him whom they have pierced, they shall mourn for him, as one mourns for an only child, and weep bitterly over him, as one weeps over a firstborn. On that day the mourning in Jerusalem will be as great as the mourning for Hadad-rimmon in the plain of Megiddo. The land shall mourn, each family by itself: the family of the house of David by itself, and their wives by themselves; the family of the house of Nathan by itself, and their wives by themselves; the family of the house of Levi by itself, and their wives by themselves; the family of the Shimeites by itself, and their wives by themselves; and all the families that are left, each by itself, and their wives by themselves.” (Zechariah 12:10-14 ESV).</i></p>
						
						<p><i>“And I saw, coming out of the mouth of the dragon and out of the mouth of the beast and out of the mouth of the false prophet, three unclean spirits like frogs. For they are demonic spirits, performing signs, who go abroad to the kings of the whole world, to assemble them for battle on the great day of God the Almighty. (“Behold, I am coming like a thief! Blessed is the one who stays awake, keeping his garments on, that he may not go about naked and be seen exposed!”) And they assembled them at the place that in Hebrew is called Armageddon.” (Revelation 16:13-16 ESV).</i></p>


					`,
      };
    },
  },
  {
    id: "Caesarea_Philippi",
    ctg: "christian",
    bgImage: "posts/bank/caesareaphilippi/1.jpg",
    mobBgImage: "posts/bank/caesareaphilippi/M.jpg",
    isVid: false,
    vidId: "",
    title: "CAESAREA PHILIPPI",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						

						<p>Caesarea Philippi was a Greco-Roman city located near the ancient city of Dan, in the northern part of Israel, by Mount Hermon and the Jordan River. As you follow the Banias stream to the cliff area, you can tell immediately you are in a unique place. There is a rocky face that rises 100 feet above you and 500 feet wide, centered by a foreboding cave with temple ruins strewn about. It was here that Herod the Great built the Temple of Augustus (Augusteum) in 19 B.C. to honor his Caesar.</p>

						<p>The temple sat in front of the cave that was believed to be the gateway to the underworld, and where the Greek god Pan lived. This was one of three temples Herod constructed to honor Caesar Augustus in Israel–Caesarea Maritima by the Mediterranean Sea, Samaria-Sebaste in the south, and Caesarea Philippi. Herod willed the region to his younger son Philip when he died in 4 B.C., who then built this city up to be his capital and to honor his Caesar, Tiberius.</p>

						<p>Josephus records the spot in the following: “And when Caesar had further bestowed upon him (Herod) another additional country, he built there also a temple of white marble, hard by the fountains of Jordan: the place is called Panium (Panias, Caesarea Philippi), where is a top of a mountain that is raised to an immense height, and at its side, beneath, or at its bottom, a dark cave opens itself; within which there is a horrible precipice, that descends abruptly to a vast depth: it contains a mighty quantity of water, which is immovable; and when anybody lets down anything to measure the depth of the earth beneath the water, no length of cord is sufficient to reach it. Now the fountains of Jordan rise at the roots of this cavity outwardly; and, as some think, this is the utmost origin of Jordan.” Prior to the Romans, the Greeks under Alexander the Great had conquered the area. They were so enamored with the spot Greek sanctuaries were built here to worship the god Pan. The Greeks called this place Panias, and the cave was the main attraction for Hellenistic pagan worship. Animal sacrifices were thrown into the bottomless pool inside. If the sacrifices sank, the gods were appeased.</p>

						<p>Next to the Pan cave are five niches with indented scalloped areas cut into the face of the cliff for their idols. These niches had elaborate temples attached to worship Pan, Zeus, Nemesis, and a sanctuary to the cult of the “dancing goats.” Pan was the god of the goats and his flute music would entice the goats to dance in a ritual of fertility. The worship on this site was so wicked that rabbis forbade Jews to come here. Still, Jesus brought his men here and revealed to them that He was the promised Messiah (Matthew 16). Why here? It was a simple way to let the world, both seen and unseen, know that there would be a coming battle for the souls of men.</p>

						<p>This mountain’s other significance is as the traditional site of the Transfiguration of Jesus (Matthew 17:1-8).</p>

						<p class="ac-margin-bot-20">Today you can see this cave, the rubble of the temples, and the shrines that were carved into the cliffs where Jesus acknowledged Peter’s revelation at Caesarea Philippi (today called Banias, most likely an Arab corruption of Pan, Panias). There are huge sections of carved stone from the Temple all around the area, and King Agrippa’s Palace nearby. Overall, a fascinating stop that even brought Mark Twain here in 1867. He described Caesarea Philippi like this: “…scattered everywhere, in the paths and in the woods, are Corinthian capitals, broken porphyry pillars, and little fragments of sculpture; and up yonder in the precipice where the fountain gushes out, are well-worn Greek inscriptions over niches in the rock where in ancient times the Greeks, and after them the Romans, worshipped the sylvan god Pan.” </p>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						<p><i>“Now when Jesus came into the district of Caesarea Philippi, he asked his disciples, “Who do people say that the Son of Man is?” And they said, “Some say John the Baptist, others say Elijah, and others Jeremiah or one of the prophets.” He said to them, “But who do you say that I am?” Simon Peter replied, “You are the Christ, the Son of the living God.” And Jesus answered him, “Blessed are you, Simon Bar-Jonah! For flesh and blood has not revealed this to you, but my Father who is in heaven. And I tell you, you are Peter, and on this rock I will build my church, and the gates of hell shall not prevail against it. I will give you the keys of the kingdom of heaven, and whatever you bind on earth shall be bound in heaven, and whatever you loose on earth shall be loosed in heaven.” (Matthew 16:13-19 ESV).</i></p>

						


					`,
      };
    },
  },
  {
    id: "Cana",
    ctg: "christian",
    bgImage: "posts/bank/cana/1.jpg",
    mobBgImage: "posts/bank/cana/M.jpg",
    isVid: false,
    vidId: "",
    title: "CANA",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						

						<p>The Arab village of Kafr Cana, Cana of the Galilee, in the Lower Galilee is the place Jesus performed the miracle of the wine, when he went to a wedding of a poor couple and turned water into wine (John 2:1-11).</p>

						<p>In the 17th century Kafr Cana was officially recognized by the Vatican, and the pope confirmed  Kafr Cana is Cana of the Galilee. Following this recognition, the village was added to the list of Christian holy places. Some researchers identify Kafr Cana with the Kana mentioned in the ancient Egyptian Amarna letters (from about 4,000 years ago).</p>

						<p>In the Roman-Byzantine period (1,000-2,000 years ago), there was a large Jewish community here, but  by the Mameluke period (about 800 years ago) most of the residents of Kafr Cana were Christian, although there was still a Jewish community here. Today most of the residents of Kafr Cana are Muslim.</p>

						<p>In the center of the village are a few remains of ancient buildings and burial caves. The villagers have built new houses to the southeast and northeast of the ancient village. The most important site in the village is the Catholic Church, built in 1879, on the traditional site of the miracle of the wine. Beside this church is the Greek Orthodox Church of St. George, built in 1886, which houses two stone jars that Greek Orthodox followers believe are the jars in which Jesus performed the miracle of the wine.</p>

						<p>There is also a church named after St. Bartholomew, built, according to tradition, on the site of the home of Nathaniel of Cana (St. Bartholomew), one of Jesus’ disciples.</p>

						<p class="ac-margin-bot-20">Some 200,000 tourists visit Kafr Cana annually. Inspired by the miracle of the wine, a tradition has developed of holding weddings here, as well as renewing wedding vows to strengthen a marriage, and visitors customarily buy wine here. The street of the churches, in the center of the village, has been renovated and a promenade has been built, connecting the religious centers. Small plazas have been built along the promenade with rest spots, and the facades and courtyards of the buildings have been attractively refinished. Infrastructure has been laid alongside the promenade for commercial and hotel facilities, so that visitors will be able to combine the comforts of modern tourism with their religious experience.</p>

						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						
						<p><i>“On the third day there was a wedding at Cana in Galilee, and the mother of Jesus was there. Jesus also was invited to the wedding with his disciples. When the wine ran out, the mother of Jesus said to him, “They have no wine.” And Jesus said to her, “Woman, what does this have to do with me? My hour has not yet come.” His mother said to the servants, “Do whatever he tells you.” Now there were six stone water jars there for the Jewish rites of purification, each holding twenty or thirty gallons. Jesus said to the servants, “Fill the jars with water.” And they filled them up to the brim. And he said to them, “Now draw some out and take it to the master of the feast.” So they took it. When the master of the feast tasted the water now become wine, and did not know where it came from (though the servants who had drawn the water knew), the master of the feast called the bridegroom and said to him, “Everyone serves the good wine first, and when people have drunk freely, then the poor wine. But you have kept the good wine until now.” This, the first of his signs, Jesus did at Cana in Galilee, and manifested his glory. And his disciples believed in him.” (John 2:1-11 ESV).</i></p>

						


					`,
      };
    },
  },
  {
    id: "Caper_Naum",
    ctg: "christian",
    bgImage: "posts/bank/capernaum/1.jpg",
    mobBgImage: "posts/bank/capernaum/M.jpg",
    isVid: false,
    vidId: "",
    title: "CAPERNAUM",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						

						<p>At Capernaum – known as Jesus’ “own town” (Matt. 9:1) – “walking where Jesus walked” takes on new meaning. As you sit on the stone benches of Capernaum’s ancient synagogue, you’ll be reminded that right here, Jesus taught (Mark 1:21; John 6:59) and healed a man possessed by an evil spirit (Mark 27-1:23).</p>

						<p>It was the synagogue on this very spot, the foundations of which can still be seen today, which Luke says was built by the centurion whose servant Jesus later healed (Luke 7:3-5). Jesus also raised from the dead the daughter of this synagogue’s leader (Luke 8:49-53).</p>

						<p>The ruins that surround you here, from homes with ordinary tools of daily life to intricately decorated stone carvings, are powerful reminders of Jesus’ prediction about this town (Matt. 11:23). A highlight is Peter’s house, where Jesus healed Peter’s mother-in-law (Matt. 8:14-15; Mark 1:29-31). Peter’s house was a simple dwelling, like many other archaeologists have unearthed in this small fishing and farming village. But unlike the others, here Christian pilgrims over the centuries left more than 131 inscriptions on the walls. Jesus’ name appears frequently, as does Peter’s, along with crosses, pilgrims’ names and blessings.</p>

						<p class="ac-margin-bot-20">In the mid-fourth century, a large church was built, its mosaic floor can still be seen today, with Peter’s house as its centerpiece. In 1990, a modern Franciscan church was built and suspended over the ruins.</p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						<p><i>“And they went into Capernaum, and immediately on the Sabbath he entered the synagogue and was teaching. And they were astonished at his teaching, for he taught them as one who had authority, and not as the scribes. And immediately there was in their synagogue a man with an unclean spirit. And he cried out, “What have you to do with us, Jesus of Nazareth? Have you come to destroy us? I know who you are—the Holy One of God.” But Jesus rebuked him, saying, “Be silent, and come out of him!” And the unclean spirit, convulsing him and crying out with a loud voice, came out of him. And they were all amazed, so that they questioned among themselves, saying, “What is this? A new teaching with authority! He commands even the unclean spirits, and they obey him.” And at once his fame spread everywhere throughout all the surrounding region of Galilee.” (Mark 1:21-28 ESV).</i></p>

						<p><i>“And getting into a boat he crossed over and came to his own city. And behold, some people brought to him a paralytic, lying on a bed. And when Jesus saw their faith, he said to the paralytic, “Take heart, my son; your sins are forgiven.” (Matthew 9:1-2 ESV).</i></p>

						<p><i>“So Jesus said to them, “Truly, truly, I say to you, unless you eat the flesh of the Son of Man and drink his blood, you have no life in you. Whoever feeds on my flesh and drinks my blood has eternal life, and I will raise him up on the last day. For my flesh is true food, and my blood is true drink.  Whoever feeds on my flesh and drinks my blood abides in me, and I in him. As the living Father sent me, and I live because of the Father, so whoever feeds on me, he also will live because of me. This is the bread that came down from heaven, not like the bread the fathers ate, and died. Whoever feeds on this bread will live forever.”  Jesus said these things in the synagogue, as he taught at Capernaum.” (John 6: 53-59 ESV).</i></p>

						<p><i>“When the centurion heard about Jesus, he sent to him elders of the Jews, asking him to come and heal his servant. And when they came to Jesus, they pleaded with him earnestly, saying, “He is worthy to have you do this for him, for he loves our nation, and he is the one who built us our synagogue.” (Luke 7:3-5 ESV).</i></p>

						<p><i>“While he was still speaking, someone from the ruler's house came and said, “Your daughter is dead; do not trouble the Teacher any more.” But Jesus on hearing this answered him, “Do not fear; only believe, and she will be well.” And when he came to the house, he allowed no one to enter with him, except Peter and John and James, and the father and mother of the child. And all were weeping and mourning for her, but he said, “Do not weep, for she is not dead but sleeping.” And they laughed at him, knowing that she was dead. But taking her by the hand he called, saying, “Child, arise.” And her spirit returned, and she got up at once. And he directed that something should be given her to eat.” (Luke 8:49-55 ESV).</i></p>

						<p><i>“And you, Capernaum, will you be exalted to heaven? You will be brought down to Hades. For if the mighty works done in you had been done in Sodom, it would have remained until this day.” (Matthew 11:23 ESV).</i></p>

						<p><i>“And when Jesus entered Peter's house, he saw his mother-in-law lying sick with a fever. He touched her hand, and the fever left her, and she rose and began to serve him.” (Matthew 8:14-15 ESV).</i></p>

						<p><i>“And immediately he left the synagogue and entered the house of Simon and Andrew, with James and John. Now Simon's mother-in-law lay ill with a fever, and immediately they told him about her. And he came and took her by the hand and lifted her up, and the fever left her, and she began to serve them.” (Mark 1:29-31 ESV).</i></p>


					`,
      };
    },
  },
  {
    id: "Magdala",
    ctg: "christian",
    bgImage: "posts/bank/magdala/1.jpg",
    mobBgImage: "posts/bank/magdala/M.jpg",
    isVid: false,
    vidId: "",
    title: "MAGDALA",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						

						<p>Magdala was a major first-century port on the Sea of Galilee. Located on the Western coastline and the eastern foothills of Mount Arbel, Magdala was a center of trade and commerce, and an exporter of salted fish to markets as far away as Europe. Archaeological discoveries early in the 21st century have made it a burgeoning pilgrimage destination. Magdala’s fame has rested on one notable person, Mary Magdalene.</p>

						<p>This enigmatic woman — revered as a saint by the Orthodox, Catholic, Anglican and Lutheran churches — was one of the few people named in the Gospels as being present at Christ’s crucifixion and the first recorded witness of His Resurrection. Whether she lived in Magdala or was simply born there is unknown, but she was apparently a wealthy woman.</p>

						<p>The city is mentioned only once in the New Testament. The Jewish historian Josephus says Magdala had a population of 40,000 people and a fleet of 230 boats about 30 years after Jesus died.</p>

						<p>In 2009, the Catholic church began construction on a retreat center for Christian travelers to the Galilee. As they began to dig the foundation for the guesthouse of the retreat center, they discovered a First Century Synagogue. This synagogue is the only first century synagogue found in the Galilee and one of just 7 found in the world from this time period. It was inside the synagogue they found the Magdala Stone. The stone is covered in decorative symbols relating to the structure of the Second Temple and ceremonial Jewish objects.</p>

						
						<p>Today, just 10% of the archaeology has been uncovered and is open to visitors to explore the first-century Jewish town. It is home to the beautiful Duc In Altum Chapel, which provides a place for worship, mass, and prayer.</p>

						<p class="ac-margin-bot-20">Magdala is referred as Dalmanutha by Mark (Mark 8:10) who also recorded the liberation of Miriam of Magdala from a demon by Jesus (Mark 16:9). She became a faithful follower of Jesus, even all the way to the cross unlike the other Disciples (John 19:25). When Jesus rose from the dead, she was the first one to witness this most important of miracles (John 20:14-18).</p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“And immediately he got into the boat with his disciples and went to the district of Dalmanutha.” (Mark 8:10 ESV).</i>.</p>

						<p><i>“Now when he rose early on the first day of the week, he appeared first to Mary Magdalene, from whom he had cast out seven demons.” (Mark 16:9 ESV).</i></p>

						<p><i>“But standing by the cross of Jesus were his mother and his mother's sister, Mary the wife of Clopas, and Mary Magdalene.” (John 19:25 ESV).</i></p>



					`,
      };
    },
  },
  {
    id: "Mount_Of_Beatitudes",
    ctg: "christian",
    bgImage: "posts/bank/mountofbeatitudes/1.jpg",
    mobBgImage: "posts/bank/mountofbeatitudes/M.jpg",
    isVid: false,
    vidId: "",
    title: "MOUNT OF BEATITUDES",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						

						<p>The Mount of Beatitudes is believed to be the location where Jesus delivered the Sermon on the Mount. Once known as Mt. Eremos, this hill is located between Capernaum and Tabgha and is just above the “Cove of the Sower.” This spacious hillside provides room for crowds to gather, as evidenced by preparation for 100,000 Catholics to observe mass nearby with the Pope’s visit in March 2000.</p>

						<p>The mountain is topped by a Catholic chapel built in 1939 by the Franciscan Sisters. The building which was constructed by the noted architect Antonio Barluzzi is full of numerical symbolism. In front of the church, the symbols on the pavement represent Justice, Prudence, Fortitude, Charity, Faith and Temperance. Inside the church hangs the cloak from Pope Paul VI’s visit in 1964.</p>
						
						<p class="ac-margin-bot-20">Surrounding the church are beautiful gardens and small places of meditation for Christians to sit quietly and pray as well as hold a devotional.</p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<h4><i>THE SERMON ON THE MOUNT</i></h4>
						<p><i>“Blessed are the poor in spirit, for theirs is the kingdom of heaven. “Blessed are those who mourn, for they shall be comforted. “Blessed are the meek, for they shall inherit the earth. “Blessed are those who hunger and thirst for righteousness, for they shall be satisfied. “Blessed are the merciful, for they shall receive mercy. “Blessed are the pure in heart, for they shall see God. “Blessed are the peacemakers, for they shall be called sons of God. “Blessed are those who are persecuted for righteousness' sake, for theirs is the kingdom of heaven.” (Matthew 5:3-10 ESV).</i></p>



					`,
      };
    },
  },
  {
    id: "Mount_Tabor",
    ctg: "christian",
    bgImage: "posts/bank/mounttabor/1.jpg",
    mobBgImage: "posts/bank/mounttabor/M.jpg",
    isVid: false,
    vidId: "",
    title: "MOUNT TABOR",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						

						<p>This mountain dome rises almost 1,400 feet over the Jezreel Plain and has both Old and New Testament significance.</p>
						
						<p>In the Old Testament, there are many heroes of the faith associated with it: Gideon, Elisha, Jethro, and Josiah to name a few, but there is only one account that features the heroics of two women.</p>
						
						<p>It was here that Deborah, the Judge of Israel, camped and fought against Sisera, the commander of Jabin’s idolatrous army with 900 chariots in 1125 B.C.  The Israelites had no chariots, but they had God, and His rains soaked the plain (an otherwise ideal spot for chariots) and the Kishon River flooded, making the chariots useless. After his shocking defeat from Barak’s men, Jabin fled in fear, ultimately hiding in a woman’s tent, and his life ended here according to Judges 4:21. </p>
						
						<p>One of the main New Testament occurrences here was the site of Jesus’ Transfiguration.  There are two churches to commemorate the event, a Greek Orthodox and a Roman Catholic. Despite these two beautiful structures, scholars disagree on the actual site.</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/mounttabor/1.jpg"} class="img-responsive" />
						</div>
						
						<p>Three spots vie for the Transfiguration moment. The other two include Mount Hermon and the Mount of Olives. Eusebius and the Pilgrim of Bordeaux couldn’t agree on where it happened. In 348, Cyril of Jerusalem decided on Tabor, and with Epiphanius and Jerome in agreement, it was settled.</p>
						
						<p>Whether or not it is the right spot, no one debates the stunning views of the Jezreel Valley below. The sight is well worth the hairpin turns up the mountain. It is also where two different resurrection miracles took place, either on or very near Mount Tabor. The first is with Elisha, as recorded in 2 Kings 4:32-35. </p>
						
						<p>The second event takes place in Nain, just two miles from Mount Tabor, as Luke records it in 7:11-15. </p>
						
						<p class="ac-margin-bot-20">Today you can see Crusader ruins from the 13th century on the summit, Roman structures, and the walls of an ancient city.  Saladin destroyed the Christian buildings here in 1183 A.D. and although rebuilt, they were decimated again in 1263 A.D. In the future it will be a witness again to the Book of Revelation’s final battle, as it sits on the eastern edge of the Jezreel Valley… also known as the Plain of Megiddo — the location of the battle of Armageddon.</p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“And after six days Jesus took with him Peter and James, and John his brother, and led them up a high mountain by themselves. And he was transfigured before them, and his face shone like the sun, and his clothes became white as light. And behold, there appeared to them Moses and Elijah, talking with him. And Peter said to Jesus, “Lord, it is good that we are here. If you wish, I will make three tents here, one for you and one for Moses and one for Elijah.” He was still speaking when, behold, a bright cloud overshadowed them, and a voice from the cloud said, “This is my beloved Son, with whom I am well pleased; listen to him.” When the disciples heard this, they fell on their faces and were terrified. But Jesus came and touched them, saying, “Rise, and have no fear.” And when they lifted up their eyes, they saw no one but Jesus only.” (Matthew 17:1-8 ESV).</i></p>

						<p><i>“And he said to them, “Truly, I say to you, there are some standing here who will not taste death until they see the kingdom of God after it has come with power.” And after six days Jesus took with him Peter and James and John and led them up a high mountain by themselves. And he was transfigured before them, and his clothes became radiant, intensely white, as no one on earth could bleach them. And there appeared to them Elijah with Moses, and they were talking with Jesus. And Peter said to Jesus, “Rabbi, it is good that we are here. Let us make three tents, one for you and one for Moses and one for Elijah.” For he did not know what to say, for they were terrified. And a cloud overshadowed them, and a voice came out of the cloud, “This is my beloved Son; listen to him.” And suddenly, looking around, they no longer saw anyone with them but Jesus only.” (Mark 9:1-8 ESV). </i></p>

						<p><i>“Now about eight days after these sayings he took with him Peter and John and James and went up on the mountain to pray. And as he was praying, the appearance of his face was altered, and his clothing became dazzling white. And behold, two men were talking with him, Moses and Elijah, who appeared in glory and spoke of his departure, which he was about to accomplish at Jerusalem. Now Peter and those who were with him were heavy with sleep, but when they became fully awake they saw his glory and the two men who stood with him. And as the men were parting from him, Peter said to Jesus, “Master, it is good that we are here. Let us make three tents, one for you and one for Moses and one for Elijah”—not knowing what he said. As he was saying these things, a cloud came and overshadowed them, and they were afraid as they entered the cloud. And a voice came out of the cloud, saying, “This is my Son, my Chosen One; listen to him!” And when the voice had spoken, Jesus was found alone. And they kept silent and told no one in those days anything of what they had seen.” (Luke 9:28-36 ESV).</i></p>



					`,
      };
    },
  },
  {
    id: "Nazareth",
    ctg: "christian",
    bgImage: "posts/bank/nazareth/1.jpg",
    mobBgImage: "posts/bank/nazareth/M.jpg",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    title: "NAZARETH",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						

						<p>See the “Cradle of Christianity” come alive before you.</p>

						<p>Nazareth is renowned all over the Christian world as the childhood home of Jesus Christ. It is the largest Arab city in the North District of Israel and is known as “the Arab capital of Israel.” The population is made up predominantly of Arab citizens of Israel, almost all of whom are either Muslim (69%) or Christian (30.9%). In the New Testament, the city is described as the childhood home of Jesus, and as such is a center of Christian travel, with many shrines commemorating biblical events.</p>

						<p>Nazareth is an active mini-metropolis and offers shop-lined streets, stone-paved alleys lined with Ottoman-era mansions. In recent years, the city has been reinventing itself as a sophisticated cultural and culinary destination. Everything in Nazareth is open for business on Shabbat (Friday night and Saturday) and its friendly vibe and stunning location, right in the middle of the Lower Galilee (about 15 miles West of the Sea of Galilee), makes it a beloved stop on many tourists’ routes.</p>

						 <p class="ac-margin-bot-20">Nazareth, or Natsrat as the Israelis pronounce it in Hebrew, is the cradle of Christianity, the city where, according to tradition, the angel Gabriel told Mary that she would conceive by the power of the Holy Spirit, and the place where Jesus spent his childhood and youth. Nazareth, in the lower Galilee, is located in the heart of a valley surrounded by mountains that embrace several of the most important Christian sites in the world. This is a city of faith, of spirituality and holiness, but also a city with a rich history, fascinating archeology, modern culture and Middle Eastern charm.</p>

						<h3 class="ac-uppercase">PLACES OF INTEREST</h3>
						
						<p class="ac-uppercase">BASILICA OF THE ANNUNCIATION, CHURCH OF ST. JOSEPH CARPENTRY COMPLEX</p>
						
						<p>Imposing modern two-story Basilica, erected over earlier Byzantine & Crusader church, marks the traditional Roman Catholic site of the Annunciation. The interior enshrines the sunken Grotto of the Annunciation – actual remains of the 1st century maiden home of Mary.</p>
						
						<p class="ac-uppercase">CHURCH OF ST JOSEPH’S CARPENTRY</p>
						
						<p>Situated on the same complex as the Basilica of the Annunciation. Traditionally the original workshop of Joseph and home of the Holy Family, it contains ruins of 1st century Nazareth.</p>
						
						<p class="ac-uppercase">ANCIENT SYNAGOGUE & GREEK CATHOLIC CHURCH</p>
						
						<p>Within the marketplace is a humble structure of thick, curved stone walls (known as the Synagogue Church) that is the site of the ancient synagogue where Jesus preached as a young man. It stands adjacent to the Greek Catholic church.</p>
						
						<p class="ac-uppercase">SOURCE OF MARY’S WELL ST. GABRIEL GREEK ORTHODOX CHURCH OF THE ANNUNCIATION</p>

						<p>The crypt of this ornate 18th century church houses a 1st century spring of water believed to be the source of Mary’s Well. The spring is connected to the site of the Well by an underground aqueduct.</p>

						<p class="ac-uppercase">MARY’S WELL</p>

						<p>Opposite the St. Gabriel Greek Orthodox Church, a modern stone structure in a small garden setting marks the site of Mary’s Well.</p>

						<p>THE MOUNT OF THE LEAP OF THE LORD (Mount of Precipice)</p>

						<p class="ac-margin-bot-20">Less than a mile outside the city, is the place where the people of Nazareth attempted to throw Jesus into the abyss. The Cave of the Leap site – one of the most important archeological discoveries in the world, dating back 50,000 years – to the Late and Middle Stone Age periods. Some 13 human skeletons and over 15,000 artifacts from these Stone Age periods were unearthed. The Nazareth Municipality is now undertaking a massive project to develop this Mount into a major tourist site.</p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>


						<p><i>“And he went and lived in a city called Nazareth, so that what was spoken by the prophets might be fulfilled, that he would be called a Nazarene.” (Matthew 2:23 ESV). </i></p>

						<p><i>“Nathanael said to him, “Can anything good come out of Nazareth?” Philip said to him, “Come and see.” (John 1:46 ESV).</i></p>

						<p><i>“In the sixth month the angel Gabriel was sent from God to a city of Galilee named Nazareth.” (Luke 1:26 ESV).</i></p>


						<p><i>“And he came to Nazareth, where he had been brought up. And as was his custom, he went to the synagogue on the Sabbath day, and he stood up to read. And the scroll of the prophet Isaiah was given to him. He unrolled the scroll and found the place where it was written, “The Spirit of the Lord is upon me, because he has anointed me to proclaim good news to the poor. He has sent me to proclaim liberty to the captives and recovering of sight to the blind, to set at liberty those who are oppressed, to proclaim the year of the Lord's favor.” And he rolled up the scroll and gave it back to the attendant and sat down. And the eyes of all in the synagogue were fixed on him. And he began to say to them, “Today this Scripture has been fulfilled in your hearing.” (Luke 4:16-21 ESV).</i></p>
						



						




					`,
      };
    },
  },
  {
    id: "Jesus_Boat",
    ctg: "christian",
    bgImage: "posts/bank/jesusboat/1.jpg",
    mobBgImage: "posts/bank/jesusboat/M.jpg",
    isVid: false,
    vidId: "",
    title: "JESUS BOAT",
    smltitle: "",
    html: function() {
      return {
        __html: `	

						<p>The Jesus Boat is one of the world’s most precious and meaningful archaeological treasures for Christians.</p>

						<p>In 1986 an ancient boat was discovered and removed from the mud along the shore of the Sea of Galilee. This amazing find gave us valuable information regarding the boats used during the time of Jesus. It is truly astonishing at how well preserved the boat is today. The Galilee Boat Museum was built to house and display the boat that sailed the Sea of Galilee around 2,000 years ago.</p>

						<p>Scholars say it was a combined ferry and fishing boat, and might have even served in a sea battle against the Romans, but for more than a million Christians who have seen it over the years it will always be the “Jesus boat”. While no one knows exactly who sailed in the boat or what purpose it served back then, it is a powerful visual today of the Gospels of Jesus and His disciples, many of whom were fishermen.</p>

						<p class="ac-margin-bot-20">After complex restoration, the Galilee Boat now sits above a calm blue-green sea at the Yigal Alon Center at Kibbutz Ginosar. At this superb indoor display, visitors learn the boat was mostly crafted of oak and cedar and was patched repeatedly and lovingly with 12 different kinds of wood. These very trees still grow along the walk to the museum.<br/>The museum is open daily from 8:00 to 17:00.</p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>


						<p><i>“And when he got into the boat, his disciples followed him. And behold, there arose a great storm on the sea, so that the boat was being swamped by the waves; but he was asleep. And they went and woke him, saying, “Save us, Lord; we are perishing.” And he said to them, “Why are you afraid, O you of little faith?” Then he rose and rebuked the winds and the sea, and there was a great calm. And the men marveled, saying, “What sort of man is this, that even winds and sea obey him?” (Matthew 8:23-27 ESV). </i></p>


						<p><i>On that day, when evening had come, he said to them, “Let us go across to the other side.” And leaving the crowd, they took him with them in the boat, just as he was. And other boats were with him. And a great windstorm arose, and the waves were breaking into the boat, so that the boat was already filling. But he was in the stern, asleep on the cushion. And they woke him and said to him, “Teacher, do you not care that we are perishing?” And he awoke and rebuked the wind and said to the sea, “Peace! Be still!” And the wind ceased, and there was a great calm. He said to them, “Why are you so afraid? Have you still no faith?” And they were filled with great fear and said to one another, “Who then is this, that even the wind and the sea obey him?” (Mark 4:35-41 ESV).</i></p>
						

						<p><i>“One day he got into a boat with his disciples, and he said to them, “Let us go across to the other side of the lake.” So they set out, and as they sailed he fell asleep. And a windstorm came down on the lake, and they were filling with water and were in danger. And they went and woke him, saying, “Master, Master, we are perishing!” And he awoke and rebuked the wind and the raging waves, and they ceased, and there was a calm. He said to them, “Where is your faith?” And they were afraid, and they marveled, saying to one another, “Who then is this, that he commands even winds and water, and they obey him?” (Luke 8:22-25 ESV).</i></p>


						<p><i>“On one occasion, while the crowd was pressing in on him to hear the word of God, he was standing by the lake of Gennesaret, and he saw two boats by the lake, but the fishermen had gone out of them and were washing their nets. Getting into one of the boats, which was Simon's, he asked him to put out a little from the land. And he sat down and taught the people from the boat. And when he had finished speaking, he said to Simon, “Put out into the deep and let down your nets for a catch.” And Simon answered, “Master, we toiled all night and took nothing! But at your word I will let down the nets.” And when they had done this, they enclosed a large number of fish, and their nets were breaking. They signaled to their partners in the other boat to come and help them. And they came and filled both the boats, so that they began to sink. But when Simon Peter saw it, he fell down at Jesus' knees, saying, “Depart from me, for I am a sinful man, O Lord.” For he and all who were with him were astonished at the catch of fish that they had taken, and so also were James and John, sons of Zebedee, who were partners with Simon. And Jesus said to Simon, “Do not be afraid; from now on you will be catching men.” And when they had brought their boats to land, they left everything and followed him.” (Luke 5:1-11 ESV).</i></p>

					`,
      };
    },
  },
  {
    id: "Tiberias",
    ctg: "christian",
    bgImage: "posts/bank/tiberias/1.jpg",
    mobBgImage: "posts/bank/tiberias/M.jpg",
    isVid: false,
    vidId: "",
    title: "TIBERIAS",
    smltitle: "",
    html: function() {
      return {
        __html: `	

						<p>Located at the shores of the Sea of Galilee, Tiberias, the capital of the Galilee, was established in the early Roman period and has served as a religious, administrative and culture center of the Jewish people for many years.</p>

						 <p class="ac-margin-bot-20">In addition to its rich history and significance, modern day Tiberias is synonymous with holiday in Israel. Here one can enjoy a variety of activities the city has to offer, and experience a wonderful mix of relaxation, nature and history, along with contemporary attractions, active water sports, pilgrimage sites and unique tourist attractions.</p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“After this Jesus went away to the other side of the Sea of Galilee, which is the Sea of Tiberias.” (John 6:1 ESV).</i></p>
						
						<p><i>“After this Jesus revealed himself again to the disciples by the Sea of Tiberias, and he revealed himself in this way.” (John 21:1 ESV).</i></p>

						

					`,
      };
    },
  },
  {
    id: "Yardenit",
    ctg: "christian",
    bgImage: "posts/bank/yardenit/1.jpg",
    mobBgImage: "posts/bank/yardenit/M.jpg",
    isVid: false,
    vidId: "",
    title: "YARDENIT",
    smltitle: "",
    html: function() {
      return {
        __html: `	

						<p>This baptismal site located at the Jordan River on the southern tip of the Sea of Galilee provides a delightful and tranquil setting for anyone who wishes to be baptized or re-baptized in the Jordan River. </p>

						<p>Over 400,000 visitors per year enjoy this convenient facility that provides baptismal robes, changing rooms and a stairway to walk down into the waters.</p>

						<p>When you see hundreds of people in white robes celebrating baptism in the waters of the River Jordan you will experience something special that will last a lifetime.</p>

						<p>Yardenit is designed to accommodate small or large groups and provides a quiet setting where visitors can reflect on deeply intimate moments; See the <a href="http://www.yardenit.com/">website</a> for further information.</p>
						
						<div class="img-wrapper">
							 <img src=${getImgUrl() + "/posts/yardenit/1.jpg"} class="img-responsive" />
						 </div>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“John appeared, baptizing in the wilderness and proclaiming a baptism of repentance for the forgiveness of sins. And all the country of Judea and all Jerusalem were going out to him and were being baptized by him in the river Jordan, confessing their sins. Now John was clothed with camel's hair and wore a leather belt around his waist and ate locusts and wild honey. And he preached, saying, “After me comes he who is mightier than I, the strap of whose sandals I am not worthy to stoop down and untie. I have baptized you with water, but he will baptize you with the Holy Spirit.” (Mark 1:4-8 ESV). </i></p>

						<p><i>“In those days Jesus came from Nazareth of Galilee and was baptized by John in the Jordan. And when he came up out of the water, immediately he saw the heavens opened and the Spirit descending upon him like a dove; and a voice came from heaven, 'Thou art my beloved Son; with thee I am well pleased.” (Mark 1:9-11 ESV).</i></p>

						<p><i>“IN THE LAND AND SHADOW OF DEATH, UPON THEM A LIGHT DAWNED.” From that time Jesus began to preach and say, “Repent, for the kingdom of heaven is at hand”. (Matthew 4:12-17 ESV).</i></p>
					
						

					`,
      };
    },
  },
  {
    id: "Sea_Of_Galilee",
    ctg: "christian",
    bgImage: "posts/bank/seaofgalilee/1.jpg",
    mobBgImage: "posts/bank/seaofgalilee/M.jpg",
    isVid: true,
    vidId: "haG-t3wwuMc",
    title: "SEA OF GALILEE",
    smltitle: "",
    html: function() {
      return {
        __html: `	

						<p>Time seems to have come to a stand-still where the green hills of the Galilee slope down to the Sea of Galilee. The Sea of Galilee is the enthralling power of this region for Christian visitors, where you don’t have to close your eyes to picture Jesus here – you have to open them.</p>

						<p>As Matthew 4:13 tells us, Jesus went from Nazareth  in the heart of Galilee, to Capernaum by the shore of the lake they called Genesaret. Here He gathered His first disciples – fishermen whom He found casting their nets from the shallows (Matt. 4:18). You can walk along that shore, in the very places where Jesus and the disciples walked and see the Bible come to life.</p>
						
						<div class="img-wrapper">כ
							 <img src=${getImgUrl() + "/posts/seaofgalilee/1.jpg"} class="img-responsive" />
						</div>
						 
						<p>Rise at dawn when the ancient fishermen used to come home with their catch – or without it and watch the frenzy of the fish feeding close to the shoreline. Understand why Jesus chose fishermen for His first apostles: “...the kingdom of heaven is like a net that was let down into the lake...” (Matt. 13:47). This was the backdrop for the feeding of the 4,000 (Matt. 15:32-37) and of the 5,000 (Mark 6:39-43), with a few loaves and fishes. The beloved stories of the miraculous catches of fish are remembered here, perhaps especially John 21, when Peter was reconciled to Jesus (John 21:15-17). The drama of the demoniacs in the land of the Gadarenes (Matt. 8:28-33) takes on new meaning as you stand on the craggy cliff marked centuries ago by Christians as the place where the pigs flew into the lake. This site, lost for centuries, was rediscovered and restored only a few decades ago by Israeli archaeologists.</p>

						<div class="img-wrapper">
							 <img src=${getImgUrl() + "/posts/seaofgalilee/2.jpg"} class="img-responsive" />
						</div>

						<p class="ac-margin-bot-20">A unique stone path was created along the northern part of the lake, from Capernaum to the place of the multiplication of loaves and fishes, allowing you to feel the land vibrate with ancient stories of glory and simple faith. Look around you – in winter and spring the “lilies of the field” (Matt. 6:28) abound, and seeds thrive in their beds of good soil (Mark 4:8). In late summer and fall, the choking thorns Parable of the sower still overtake those same fields, just as Jesus described it (Mark 4:7).</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/seaofgalilee/3.jpg"} class="img-responsive" />
						   </div>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“Jesus Calls the First Disciples While walking by the Sea of Galilee, he saw two brothers, Simon (who is called Peter) and Andrew his brother, casting a net into the sea, for they were fishermen. And he said to them, “Follow me, and I will make you fishers of men.” Immediately they left their nets and followed him.” (Matthew 4:18-20 ESV).</i></p>
						
						<p><i>“Again, the kingdom of heaven is like a net that was thrown into the sea and gathered fish of every kind.” (Matthew 13:47 ESV). </i></p>							
						
						<p><i>“Then Jesus called his disciples to him and said, “I have compassion on the crowd because they have been with me now three days and have nothing to eat. And I am unwilling to send them away hungry, lest they faint on the way.” And the disciples said to him, “Where are we to get enough bread in such a desolate place to feed so great a crowd?” And Jesus said to them, “How many loaves do you have?” They said, “Seven, and a few small fish.” And directing the crowd to sit down on the ground, he took the seven loaves and the fish, and having given thanks he broke them and gave them to the disciples, and the disciples gave them to the crowds. And they all ate and were satisfied. And they took up seven baskets full of the broken pieces left over.” (Matthew 15:32-37 ESV).</i></p>

						<p><i>“Then he commanded them all to sit down in groups on the green grass. So they sat down in groups, by hundreds and by fifties. And taking the five loaves and the two fish, he looked up to heaven and said a blessing and broke the loaves and gave them to the disciples to set before the people. And he divided the two fish among them all. And they all ate and were satisfied. And they took up twelve baskets full of broken pieces and of the fish.” (Mark 6:39-43 ESV).</i></p>

						<p><i>“And when he came to the other side, to the country of the Gadarenes, two demon-possessed men met him, coming out of the tombs, so fierce that no one could pass that way. And behold, they cried out, “What have you to do with us, O Son of God? Have you come here to torment us before the time?” Now a herd of many pigs was feeding at some distance from them. And the demons begged him, saying, “If you cast us out, send us away into the herd of pigs.” And he said to them, “Go.” So they came out and went into the pigs, and behold, the whole herd rushed down the steep bank into the sea and drowned in the waters. The herdsmen fled, and going into the city they told everything, especially what had happened to the demon-possessed men.” (Matthew 8:28-33 ESV).</i></p>


						

					`,
      };
    },
  },
  {
    id: "Tabgha",
    ctg: "christian",
    bgImage: "posts/bank/tabgha/1.jpg",
    mobBgImage: "posts/bank/tabgha/M.jpg",
    isVid: false,
    vidId: "",
    title: "TABGHA",
    smltitle: "",
    html: function() {
      return {
        __html: `	
						<h3>TABGHA (Primacy of St. Peter & Church of Multiplication)</h3>

						<p>Tabgha (Ein Sheva) is an area situated on the north-western shore of the Sea of Galilee in Israel. It is traditionally accepted as the place of the miracle of the multiplication of the loaves and fishes (Mark 6:30-46) and the fourth resurrection appearance of Jesus (Joh 21: 1-24) after His crucifixion where He also restored Peter after he denied Him three times. The earliest building at Tabgha was a small chapel built in the 4th century A.D. (around 350) by the Jewish convert to Christianity, Joseph of Tiberias. According to Epiphanius, Joseph was a contemporary of Emperor Constantine, a Rabbinical scholar, member of the Sanhedrin and a disciple of Hillel II.  Following his conversion, Emperor Constantine gave him the rank of count, and gave him permission to build churches in the Galilee, specifically, in Jewish towns where there was not a Christian community, and the Galilee including the Sea of Galilee, was an area with a Jewish majority. This was probably the shrine described by the pilgrim Egeria at the end of the 4th century. The 4th century small shrine was dismantled in 480 and a bigger chapel was built by Martyrius of Jerusalem. Patriarch of Jerusalem from 478 to 486.</p>

						<p class="ac-margin-bot-20">The mosaic of the fish and loaves is laid next to a large rock; some New Testament scholars speculate builders of the original church believed that Jesus stood on this rock when He blessed the fish and loaves before feeding the crowd who gathered  to hear Him.</p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						
						<p><i>“The apostles returned to Jesus and told him all that they had done and taught. And he said to them, “Come away by yourselves to a desolate place and rest a while.” For many were coming and going, and they had no leisure even to eat. And they went away in the boat to a desolate place by themselves. Now many saw them going and recognized them, and they ran there on foot from all the towns and got there ahead of them. When he went ashore he saw a great crowd, and he had compassion on them, because they were like sheep without a shepherd. And he began to teach them many things. And when it grew late, his disciples came to him and said, “This is a desolate place, and the hour is now late. Send them away to go into the surrounding countryside and villages and buy themselves something to eat.” But he answered them, “You give them something to eat.” And they said to him, “Shall we go and buy two hundred denarii worth of bread and give it to them to eat?” And he said to them, “How many loaves do you have? Go and see.” And when they had found out, they said, “Five, and two fish.” Then he commanded them all to sit down in groups on the green grass. So they sat down in groups, by hundreds and by fifties. And taking the five loaves and the two fish, he looked up to heaven and said a blessing and broke the loaves and gave them to the disciples to set before the people. And he divided the two fish among them all. And they all ate and were satisfied. And they took up twelve baskets full of broken pieces and of the fish. And those who ate the loaves were five thousand men.” (Mark 6:30-46 ESV). </i></p>
						
						<p><i>“When they had finished breakfast, Jesus said to Simon Peter, “Simon, son of John, do you love me more than these?” He said to him, “Yes, Lord; you know that I love you.” He said to him, “Feed my lambs.” He said to him a second time, “Simon, son of John, do you love me?” He said to him, “Yes, Lord; you know that I love you.” He said to him, “Tend my sheep.” He said to him the third time, “Simon, son of John, do you love me?” Peter was grieved because he said to him the third time, “Do you love me?” and he said to him, “Lord, you know everything; you know that I love you.” Jesus said to him, “Feed my sheep. Truly, truly, I say to you, when you were young, you used to dress yourself and walk wherever you wanted, but when you are old, you will stretch out your hands, and another will dress you and carry you where you do not want to go.” (This he said to show by what kind of death he was to glorify God.) And after saying this he said to him, “Follow me.” (John 21:15-19 ESV).</i></p>

						

					`,
      };
    },
  },
  {
    id: "THE_GOSPEL_TRAIL",
    ctg: "christian",
    bgImage: "posts/bank/thegospeltrail/1.jpg",
    mobBgImage: "posts/bank/thegospeltrail/M.jpg",
    isVid: false,
    vidId: "",
    title: "THE GOSPEL TRAIL",
    smltitle: "",
    html: function() {
      return {
        __html: `	

						
						<p>Following the footsteps of Jesus, takes a whole new meaning by following the "Gospel Trail". From Mount of Precipice on the southern outskirts of Nazareth to Capernaum, you can visit the same places and see the same landscapes that Jesus visited and saw.</p>
						
						<p>The Gospel Trail offers a golden opportunity to discover the cradle of Christianity in the Galilee. Follow the trail down the paths Jesus is believed to have taken when he left his childhood town of Nazareth for Capernaum, located on the northwestern shore of the Sea of Galilee and which became his center of ministry.  </p>
						
						<p>To enhance your experience, you will be able to choose how you want to travel the trail – by foot, bike or car, or even by sailing down the length of the Sea of Galilee. What’s more, you can even combine them in various segments. Choose what’s right for you based on your personal preferences and the level of difficulty you desire.</p>
						
						<p>The main portion of the route will start in Mount Precipice, Nazareth and end in Capernaum. The secondary paths will be shorter, branching off from the main route to attractive sites in the Galilee. From Mount Precipice the route takes you along the Nazareth Range, where you can see the landscapes of Mount Tabor and the Church of the Transfiguration, Kafr Kanna and the Turan Valley, via the Golani Junction and the Horns of Hattin, site of the clash between the Crusader forces and the Muslim armies under Saladin.</p>
						
						<p>The route will then descend down the Arbel cliffs in the direction of the Sea of Galilee, until reaching Migdal and the antiquities of ancient Magdala, home of Mary Magdalene. From Magdala, the route will continue northward along the Sea of Galilee to the holy triangle – Tabgha, Mount of Beatitudes and Capernaum, and down the length of the Sea of Galilee on the promenade, taking in the magnificent views, until you reach our final destination – Capernaum churches, National Park and dock.</p>
						
						<p class="ac-margin-bot-20">The secondary routes of the Gospel Trail will be in what is known as the Holy Basin, branching off into short trails from Tabgha, Mount of Beatitudes, House of Galilee (Domus Galilaeae), Chorazin and Bethsaida. All of these routes will end at the main destination  the Capernaum center, where you will enjoy the encounter with the water, sophisticated dock with boats at your service, prayer areas and inspirational solitude on the beach, as well as diverse tourism services – rest and refreshment, information, food, tourism products, tours, transportation and restrooms. Additional secondary routes will connect to the main route from Kafr Kanna and Sepphoris, Mount Tabor, Horns of Hattin and Mount Arbel.</p>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						<p><i>“But there will be no more gloom for her who was in anguish; in earlier times He treated the land of Zebulun and the land of Naphtali with contempt, but later on He shall make it glorious, by the way of the sea, on the other side of Jordan, Galilee of the Gentiles. The people who walk in darkness Will see a great light; Those who live in a dark land, The light will shine on them. You shall multiply the nation, You shall increase their gladness; They will be glad in Your presence As with the gladness of harvest, As men rejoice when they divide the spoil.” (Isaiah 9:1-3 ESV).</i></p>
						
						<p><i>“Now when Jesus heard that John had been taken into custody, He withdrew into Galilee; and leaving Nazareth, He came and settled in Capernaum, which is by the sea, in the region of Zebulun and Naphtali. This was to fulfill what was spoken through Isaiah the prophet: “THE LAND OF ZEBULUN AND THE LAND OF NAPHTALI, BY THE WAY OF THE SEA, BEYOND THE JORDAN, GALILEE OF THE GENTILES— “THE PEOPLE WHO WERE SITTING IN DARKNESS SAW A GREAT LIGHT, AND THOSE WHO WERE SITTING IN THE LAND AND SHADOW OF DEATH, UPON THEM THE LIGHT DAWNED.” (Matthew 4:12-16 ESV).</i></p>
			

						

					`,
      };
    },
  },
  {
    id: "Zippori",
    ctg: "christian",
    bgImage: "posts/bank/zippori/1.jpg",
    mobBgImage: "posts/bank/zippori/M.jpg",
    isVid: false,
    vidId: "",
    title: "ZIPPORI",
    smltitle: "",
    html: function() {
      return {
        __html: `	

													
						<p>Like our modern cities today, ancient cities needed artisans to build them and the city of Sepphoris (Zippori) was no different, with one critical exception–Joseph and his son Jesus probably helped Herod Antipas build it.</p>
						
						<p>Jesus is traditionally known as a woodworker (the Greek word used for carpenter is tekton, a generic term for “a builder who worked with his hands”), but with wood scarce and stone so prevalent in Israel, He was most likely a stonemason. Nazareth was only a few miles away and Joseph would have been a natural hire for Antipas’ Sepphoris rebuild.</p>
						
						<p>Josephus called Sepphoris “The Jewel of Galilee,” and although it is sometimes overlooked today for the more famous sites like Nazareth and Cana, in 4 B.C. Herod’s son selected it as the provincial capital for his government in Galilee. It sat near two major highways (Via Maris and Acre-Tiberias) and the rebuild would have been a busy hub that employed lots of people in Jesus’ day, sparking an economic boom for the entire Galilee area.</p>
						
						<p>Sepphoris is “perched like a bird” on a 400-foot hill that overlooks the Bet Netofa Valley and helps to explain its other Hebrew name, Zippori (bird). From this panoramic view of Lower Galilee one can survey Nazareth and Cana and imagine Jesus walking to work with His father every day.</p>
						
						<p>Excavations have revealed a cosmopolitan city of great affluence with a Roman theater built into the eastern side of the hill that held over 4,000 people. Today the magnificent ruins include such highlights as Herod’s palace, an upper city and a lower city, a fortified city wall for protection, multiple synagogues, bathhouses, churches, aqueducts, a massive reservoir, a marketplace, and residential areas alongside a colonnaded stone-paved street…with wagon wheel grooves still etched in them.</p>
						
						<p>Also known as the Mosaic City, some of the best mosaics in all of Israel are in Sepphoris and are reason enough to visit the ruins. More than 40 mosaic floors in nearby buildings depict the bustling life of a Roman city, but especially impressive is the Nile Mosaic in the Nile House.</p>
						
						<p>The Nile Mosaic shows Egyptian festivities when the Nile River peaked according to the “Nilometer” (a pillar with the number 17 on it shows the flood’s height), complete with crocodiles and other exotic wildlife, and the Pharos Lighthouse in Alexandria…one of the Seven Wonders of the World.</p>
						
						<p>The next mosaic is the “Mona Lisa Mosaic” in the Dionysus House (named for the Greek god of wine and revelry) that still captivates her visitors with the beauty of Venus. There is a 15-panel carpet of mosaics honoring Dionysus in this Roman mansion, as well as Hercules and Pan, but the “Mona Lisa of the Galilee” holds center court as a priceless piece of art. Her artist is unidentified, but the craftsmanship stands up even today.</p>
						
						<p>One of the best mosaics was discovered here in 1993 when a parking lot construction revealed exquisite mosaic floors in an ancient synagogue with seven separate sections. They depict Sarah’s angelic visit, Abraham’s sacrifice of Isaac, twin lions, menorahs with first century Temple artifacts, an elaborate Zodiac wheel, aspects of the Temple worship in Jerusalem, offerings to the Tabernacle and Temple, and Aaron officiating in his priestly robes with animal sacrifices. The artistry and scope are truly astounding.</p>
						
						<p>Even after Herod moved his capital and residence to Tiberias in 19 A.D., Sepphoris remained a cosmopolitan city that even survived the Jewish Revolt of 66 A.D. by siding with, and surrendering to, the Roman Vespasian. After the Temple was destroyed in 70 A.D. Sepphoris became a seat of rabbinic learning when the Sanhedrin fled here and continued as such with 18 synagogues in operation until an earthquake hit in 363.</p>
						
						<p>Tradition says that Mary’s parents, Joachim and Anna, lived here and would have been another reason for Joseph to visit the city beyond just employment opportunities. Later, the Crusaders built the Church of St Anne on the site believed to be their home.</p>
			
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						<p><i>“You are the light of the world. A city set on a hill cannot be hidden. Nor do people light a lamp and put it under a basket, but on a stand, and it gives light to all in the house. In the same way, let your light shine before others, so that they may see your good works and give glory to your Father who is in heaven.” (Matthew 5:14-16 ESV).</i></p>

						<p><i>“The land of Zebulun and the land of Naphtali, the way of the sea, beyond the Jordan, Galilee of the Gentiles—the people dwelling in darkness have seen a great light, and for those dwelling in the region and shadow of death, on them a light has dawned.” (Matthew 4:15-16 ESV).</i></p>
						

					`,
      };
    },
  },
  {
    id: "Mount_Zion_Church_of_the_Dormition_Davids_Tomb_Upper_Room",
    ctg: "christian",
    bgImage: "posts/bank/churchofthedormitiondavidstombupperroom/1.jpg",
    mobBgImage: "posts/bank/churchofthedormitiondavidstombupperroom/M.jpg",
    isVid: false,
    vidId: "",
    title: "Mount Zion",
    smltitle: "",
    html: function() {
      return {
        __html: `	

						<h3><u>MOUNT ZION</u></h3>

						<p>Located south of the Old City’s Armenian Quarter Mount Zion, was the highest point in ancient Jerusalem. Mount Zion was part of the walled upper city in ancient times, but today is just outside of the Old City walls, close to the Zion Gate.</p>

						<p>Several important events in the early Christian Church are likely to have taken place on Mount Zion:</p>

						<ul class="ac-margin-bot-20">

							<li>The Last Supper of Jesus and his disciples, and the coming of the Holy Spirit on the disciples </li>

							<li>The appearance of Jesus before the high priest Caiaphas, believed to have been at the site of the Church of St. Peter in Gallicantu  </li>

							<li>The “falling asleep” of the Virgin Mary, believed to have occurred at the site of the Church of the Dormition. </li>

							<li>The Council of Jerusalem, around AD 50, in which the early Church debated the status of converted gentiles (Acts 15:1-29),</li>

						</ul>

						<h3><u>CHURCH OF DORMITION</u></h3>

						<div class="img-wrapper">
							<img src=${getImgUrl() +
                "/posts/churchofdormition/1.jpg"} class="img-responsive" />
						</div>

						<p>A massive Benedictine church, with its high, domed bell tower visible from many points in the city, the Church of Dormition commemorates the taking of the Virgin Mary into heaven at the end of her earthly life. The church is next to the place venerated as the tomb of King David, and almost directly above it is the Cenacle – the Upper Room where Jesus celebrated the Last Supper with his disciples. Because of the special sanctity of the site, it became the location of an early Jewish-Christian church known as the Church of the Apostles.  </p>

						<p>In the early 5th century, Byzantine Christians built the great basilica of Hagia Sion (Holy Zion) on this site. It was destroyed by the Persians in 614. In the 12th century, the crusaders built an even greater church called Santa Maria in Monte Sion (Our Lady of Mount Zion), but it too was destroyed in 1187. The site remained abandoned until the late 19th century, when at the initiative of German Kaiser Wilhelm II the present basilica was built and inaugurated in 1910.   </p>

						<p>The Dormition is a popular destination for pilgrims and locals alike. Inside, the circular basilica is remarkable for its simplicity and beauty. At the center of its semi-circular apse is a mosaic of Mary and of the child Jesus, with the figures of twelve prophets below them. Around the church are six side chapels decorated by beautiful mosaics depicting scenes such as Mary and the infant Jesus receiving pilgrims, Jesus’ family tree, John the Baptist on the shore of the Jordan River, St. Benedict – the founder of the Benedictine order, and other saints. </p>

						<p>Two spiral staircases lead down to the crypt, a round pillared room with a sculpture of Mary “asleep” in the center. On the ceiling above her is the figure of Jesus, as if watching over her, surrounded by the great women of the Bible: Eve, Miriam, Yael, Ruth, Esther and Judith. Beyond this main room, are several other chapels and altars donated by various countries. </p>

						<p class="ac-margin-bot-20">With Mary known in Christian tradition as the personified “Daughter of Zion,” closely identified with the people of Israel, it is fitting that her place of rest is preserved on Mount Zion, where Jesus instituted the Eucharist and where the Holy Spirit descended upon the apostles at Pentecost.  </p>

						<h3><u>DAVID’S TOMB</u></h3>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/davidstomb/1.jpg"} class="img-responsive" />
						</div>

						<p>The traditional site known as King David’s final resting place is often contested, but it is still considered one of the holiest spots in Jerusalem. Located in a medieval-styled building near the Zion Gate, David’s sealed sarcophagus rests in the far back corner of a very busy room (divided for men and women) that is filled with observant Jews praying, singing, or studying. It’s a very moving experience.   </p>

						<p>Unfortunately, the large sarcophagus is empty, a Gothic cenotaph that the Crusaders put here, and can only serve as a memorial to David (it is still important to preserve his memory). So, who decided that this was the Tomb of David when there’s no body?  </p>

						<p>The Crusaders, not the Jews, decided upon the site in the 12th century, known today as the Tomb of King David.   </p>

						<p>During David’s reign (1000 B.C.), Jerusalem’s far western hill (today called Mount Zion and the site of the traditional Tomb of David) was well outside of David’s city walls and probably uninhabited. We know that David, however, was buried “in the City of David,” or inside the city walls to the far east of Mount Zion (2 Samuel 2:10-12). David’s Jerusalem was not the sprawling city we see today. It was a relatively tiny spur on the narrow ridge south of the Temple Mount (today called the City of David), near the Dung Gate. The current Tomb of David, due west of the biblical City of David, was eventually engulfed as Jerusalem grew westward.  </p>

						<p>As early as 33 A.D., David’s real tomb was well known, as the Apostle Peter testified in Acts 2:29, “Fellow Israelites, I can tell you confidently that the patriarch David died and was buried, and his tomb is here to this day.” So how could the biblical City of David (the eastern hill) get confused with today’s Mount Zion (the western hill) as David’s Jerusalem?  </p>

						<p>Less than 40 years after Peter’s statement, the Romans destroyed Jerusalem. No Jews were allowed in the city except on the anniversary of the Temple destructions. Ironically, this tragedy occurred on the very same day in 586 B.C. with the Babylonians, and in 70 A.D. with the Romans, the ninth day of the Hebrew month of Av (Tisha B’av). The knowledge of many sites in Jerusalem was lost in the razed wasteland Rome left behind, and it was even more obscured when Hadrian built over the fallen city to make the Roman city of Aelia Capitolina The Jerusalem Peter knew was demolished and rebuilt, with most eyewitnesses dead or gone. More changes would come over the next thousand years, with the Persians and Byzantines fighting over Jerusalem until the Crusaders showed up in 1099 A.D.  </p>

						<p class="ac-margin-bot-20">By the 12th century, the actual City of David had been buried for centuries, and these Europeans identified the wrong higher western hill as part of that ancient city. They called it Mount Zion. When the Crusaders mistakenly put an empty sarcophagus here, it became an accepted tradition that doesn’t line up with biblical archaeology. King David was buried in the southeastern part of the lower and smaller hill, which is directly south of the Temple Mount, and a half-mile away from the modern Tomb of David. </p>

						<h3 class="ac-capitalize"><u>UPPER ROOM</u></h3>
						
						<p>“On the first day of the Festival of Unleavened Bread, when it was customary to sacrifice the Passover lamb, Jesus’ disciples asked Him, ‘Where do you want us to go and make preparations for you to eat the Passover?’ So, He sent two of His disciples, telling them, ‘Go into the city, and a man carrying a jar of water will meet you. Follow him. Say to the owner of the house he enters, ‘The Teacher asks: Where is my guest room, where I may eat the Passover with my disciples?’ He will show you a large room upstairs, furnished and ready. Make preparations for us there.’ The disciples left, went into the city and found things just as Jesus had told them. So, they prepared the Passover.” (Mark 14:12-14)  </p>
						
						<p>The room where tradition says Jesus had the last Passover is in a 12th century Crusader building on the second floor, above the Tomb of David. The site, also called the Cenacle (“dining room”), is near the Zion Gate on Mount Zion. European knights built the site, so logically this cannot be the Upper Room (archaeological evidence confirms this is not King David’s tomb either). An artillery shell fired on the building in 1948 also sitrred up the location debate. </p>
						
						<p>During Israel’s War for Independence, a shell fired on the building led to repairs and digging. An Israeli archeologist, Jacob Pinkerfeld, took the opportunity to investigate the site. He found an indentation in the wall from the original structure he thought might be used for the Torah scrolls typical in synagogues. He said the following about his discovery:  </p>
						
						<p>“After removing the plaster from the whole surface of the apse (small Torah niche) there appeared a well-built wall of the late Roman period, constructed of ashlar stones. This is the first building period on the site and to it belong three of the outer walls of the hall on the north, south, and east.” </p>
						
						<p>The ashlar stones were in four mismatched rows in the remains of the partial outer wall. Ashlars are large blocks of stone like we see in the Western Wall, and were frequently re-purposed in other Jerusalem construction after the Romans destroyed the city in 70 A.D. Moving them to new sites usually rounded their corners, which these stones demonstrated. If they had been original, they would have been evenly shaped and set accordingly, but these were not. These stones dated in the late first century to early second century (roughly the same timeframe when Jews were not allowed in Jerusalem), but not early enough for Jesus’ time.  </p>
						
						<p>Pinkerfeld continued investigating and dug down about two feet, where he found several previous floors that turned out to be Crusader, Roman (late first century), and even the original floor. He also found some Christian graffiti on the walls in Greek that said, “Conquer, Savior, Mercy,” and another, “Oh Jesus, that I may live. Oh Lord of the Autocrat.” This wasn’t too surprising since the first Christians were all Jews, and these Jewish Christians initially used synagogues to worship Jesus as a normal continuance of Judaism. Our thinking today is that Gentiles are all Christians, but in the first century all the first Christians were Jews, and Gentiles as Christians were the exception (Acts 15). It would be normal for these Jews to use their synagogues for worshipping their risen Messiah.  </p>
						
						<p>Combining these clues, it seems this was a synagogue built in the late first century (when Jews were not building new synagogues in Jerusalem), after the Christians returned to Jerusalem from Pella (Jordan) where they went before, Titus destroyed the Temple. Despite all these fascinating discoveries, the site itself remains inconclusive as a first-century dwelling where the Upper Room may have once stood. Only ancient tradition says it is the Last Supper location. </p>
						
						<p>Tradition also says that after Jesus ascended, this Upper Room is where the Church was birthed, as recorded in Acts 1:12-14 and 2:1-3, Then the apostles returned to Jerusalem from the hill called the Mount of Olives, a Sabbath day’s walk from the city. When they arrived, they went upstairs to the room where they were staying.” </p>
						
						<p class="ac-margin-bot-20">“When the day of Pentecost came, they were all together in one place. Suddenly a sound like the blowing of a violent wind came from heaven and filled the whole house where they were sitting. They saw what seemed to be tongues of fire that separated and came to rest on each of them.” </p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						<p><i>“A SONG OF ASCENTS. Those who trust in the LORD are like Mount Zion, which cannot be moved, but abides forever. As the mountains surround Jerusalem, so the LORD surrounds his people, from this time forth and forevermore. For the scepter of wickedness shall not rest on the land allotted to the righteous, lest the righteous stretch out their hands to do wrong. Do good, O LORD, to those who are good, and to those who are upright in their hearts! But those who turn aside to their crooked ways the LORD will lead away with evildoers! Peace be upon Israel!” (Psalm 125 ESV).</i></p>
						<p><i>“And on the first day of Unleavened Bread, when they sacrificed the Passover lamb, his disciples said to him, “Where will you have us go and prepare for you to eat the Passover?” And he sent two of his disciples and said to them, “Go into the city, and a man carrying a jar of water will meet you. Follow him, and wherever he enters, say to the master of the house, ‘The Teacher says, where is my guest room, where I may eat the Passover with my disciples?’ And he will show you a large upper room furnished and ready; there prepare for us.” And the disciples set out and went to the city and found it just as he had told them, and they prepared the Passover.” (Mark 14:12-16 ESV).</i></p>
						<p><i>“Then they returned to Jerusalem from the mount called Olivet, which is near Jerusalem, a Sabbath day’s journey away. And when they had entered, they went up to the upper room, where they were staying, Peter and John and James and Andrew, Philip and Thomas, Bartholomew and Matthew, James the son of Alphaeus and Simon the Zealot and Judas the son of James. All these with one accord were devoting themselves to prayer, together with the women and Mary the mother of Jesus, and his brothers.” (Acts 1:12-14 ESV). </i></p>




					`,
      };
    },
  },
  {
    id: "Davidson_Center",
    ctg: "christian",
    bgImage: "posts/bank/davidsoncenter/1.jpg",
    mobBgImage: "posts/bank/davidsoncenter/M.jpg",
    isVid: false,
    vidId: "",
    title: "DAVIDSON CENTER (SOUTHERN WALL EXCAVATIONS)",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>Located adjacent to the Western Wall is an impressive archaeological park. The park contains artifacts from the First and Second Temple periods, the Byzantine Muslim period, the ancient Crusades period, and others. The most exciting findings are the walls of the city from the First Temple period, the steps leading up to the Temple, the original street from the time of the Second Temple period, shops, ritual baths and more. The Davidson Center is a museum within the archaeological park. With presentations and exhibitions related to findings from the site.</p>
						
						<p>Excavations conducted after the unification of Jerusalem adjacent to the Western Wall and the southern wall uncovered amazing finds. Adjacent to the Western Wall was a large and impressive street from the Second Temple period, which was the main street of Jerusalem at the time.  </p>
						
						<p>The Davidson Center has a museum showing artifacts found in the excavations. As well as an impressive, three-dimensional model that allows you to tour Jerusalem and go up to the Temple. You will have the opportunity to walk with a pilgrim through the street, buy a sacrifice, immerse in the mikveh, and accompany him on the ascent to the Temple Mount.  </p>
						
						<p class="ac-margin-bot-20">As you explore the Southern Temple Steps, this is the perfect place to read the Songs of Ascent from the book of Psalms like the Pilgrims from biblical times. </p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>
						
						<p><i>“A SONG OF ASCENTS OF DAVID. I was glad when they said to me, “Let us go to the house of the LORD!” Our feet have been standing within your gates, O Jerusalem! Jerusalem — built as a city that is bound firmly together, to which the tribes go up, the tribes of the LORD, as was decreed for Israel, to give thanks to the name of the LORD. There thrones for judgment were set, the thrones of the house of David. Pray for the peace of Jerusalem! “May they be secure who love you! Peace be within your walls and security within your towers!” For my brothers and companions’ sake I will say, “Peace be within you!” For the sake of the house of the LORD our God, I will seek your good.” (Psalm 122 ESV).</i></p>




					`,
      };
    },
  },
  {
    id: "Western_Wall",
    ctg: "christian",
    bgImage: "posts/bank/westernwall/1.jpg",
    mobBgImage: "posts/bank/westernwall/M.jpg",
    isVid: false,
    vidId: "",
    title: "WESTERN WALL AND WESTERN WALL TUNNELS",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>The Western Wall (or Kotel, in Hebrew) was part of the most magnificent building Jerusalem had ever seen, which was the Second Temple, built by King Herod the Great.</p>
						
						<p>The Second Temple was destroyed in the year 70 CE and despite the destruction that took place, all four of the Temple Mount supporting walls remained standing. Throughout the generations since the Temple’s destruction, the Western Wall was the remnant closest to the site of the Temple’s ‘holies of holies - a place where only the Jewish High Priests were allowed, as it was there they believed God was present. The actual remains of the Temple can be found in the Western Wall Tunnels, which are an extraordinary journey through time.</p>

						<p>For centuries Jewish and Christian people from around the world have been going there to mourn the loss of this grand temple. You will often find hundreds of people of different nationalities and religions pouring out their hearts with prayer and petition as the wall is believed to have enormous spiritual significance.</p>
						
						<p class="ac-margin-bot-20">It is tradition for the people that visit to write a note and place it in the cracks of the Western Wall, as it is believed the message will be taken to God. You will often find doves resting in the crevices of this impressive structure, which are a symbol of peace.</p>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“I love You, O LORD, my strength.” The LORD is my rock and my fortress and my deliverer, My God, my rock, in whom I take refuge, My shield and the horn of my salvation, my stronghold. I call upon the LORD, who is worthy to be praised, And I am saved from my enemies. The cords of death encompassed me, And the torrents of ungodliness terrified me. The cords of Sheol surrounded me; The snares of death confronted me. In my distress I called upon the LORD, And cried to my God for help; He heard my voice out of His temple, And my cry for help before Him came into His ears.” (Psalm 18:1-6 ESV).</i></p>

						<p><i>Jesus left the temple and was going away, when his disciples came to point out to him the buildings of the temple. But he answered them, “You see all these, do you not? Truly, I say to you, there will not be left here one stone upon another that will not be thrown down.” (Matthew 24:1-2 ESV).</i></p>

						<p><i>So, the Jews said to him, “What sign do you show us for doing these things?” Jesus answered them, “Destroy this temple, and in three days I will raise it up.” The Jews then said, “It has taken forty-six years to build this temple, and will you raise it up in three days?” But he was speaking about the temple of his body. When therefore he was raised from the dead, his disciples remembered that he had said this, and they believed the Scripture and the word that Jesus had spoken.” (John 2:18-22 ESV).</i></p>
						



					`,
      };
    },
  },
  {
    id: "City_Of_David",
    ctg: "christian",
    bgImage: "posts/bank/cityofdavid/1.jpg",
    mobBgImage: "posts/bank/cityofdavid/M.jpg",
    isVid: false,
    vidId: "",
    title: "CITY OF DAVID",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>Jerusalem (Yeru-shalayim), usually translated from Hebrew as “the City of Peace,” is the crown jewel of Israel that shines at 2,500 feet above sea level. Jerusalem is a large, modern city today, but the “proper” City of David was much smaller. The ancient City of David sat on the narrow ridge of a hilltop, slightly south of what is today called the “Old City.” For over 150 years The City of David has been revealing some of the most important archeological discoveries of the ancient world. During the days of Abraham, some 4,000 years ago, the first foundations of the city were laid by the Jebusites</p>
						
						<p>One thousand years later, King David left the city of Hebron, conquered the Jebusite city, and established a unified capital of the tribes of Israel in Jerusalem.  Years later, King Solomon, David’s son, built the First Temple north of the city on Mount Moriah, the very site where Abraham offered Isaac to the Lord.</p>
						
						<p>The location for the city that David claimed had two important attributes: fresh water from the Gihon Spring, and the defensive security of being on this steep hillside. The Kidron Valley protected the extremely narrow city on the east, with the west guarded by the Central Valley, and the south by the Hinnom Valley’s merger with the other two.</p>
						
						<p>There are so many sites to see here. A tour of the City of David begins with an observation point of biblical Jerusalem overlooking the Kidron, Central and Hinnom Valleys  As you move through the city you will see archaeological excavations and thrilling biblical finds spanning thousands of years of history including both First and Second Temple Jerusalem. Continue underground to the Gihon Spring, the major water source of Jerusalem for over 1,000 years. From here you can choose to trek through knee deep water in King Hezekiah's 2,700-year-old water tunnel or walk through a dry tunnel immersing yourself in the wonders of early engineering. Then continue to the Shiloah Pool, the major water source in biblical times, and reach the Herodian Road, the ancient thoroughfare that led pilgrims north to the Temple.</p>
						
						<p>Today’s visitor can see the ruins of David’s Palace, discovered in 2005. There are two parts: The Stepped Stone Structure (the Millo) and the Large Stone Structure (2 Samuel 5:7-9, 16:22).</p>
						
						<p>A visit is your passport to the past and biblical Jerusalem.</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/cityofdavid/1.jpg"} class="img-responsive" />
						</div>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“And David lived in the stronghold and called it the city of David. And David built the city all around from the Millo inward. And David became greater and greater, for the LORD, the God of hosts, was with him.” (2 Samuel 5:9 ESV).</i></p>

						<p><i>“Awake, awake, put on your strength, O Zion; put on your beautiful garments, O Jerusalem, the holy city; for there shall no more come into you the uncircumcised and the unclean. Shake yourself from the dust and arise; be seated, O Jerusalem; loose the bonds from your neck, O captive daughter of Zion.” (Isaiah 52:1-2 ESV).</i></p>
						
						<p><i>“This same Hezekiah closed the upper outlet of the waters of Gihon and directed them down to the west side of the city of David. And Hezekiah prospered in all his works.” (2 Chronicles 32:30 ESV).</i></p>
						
						<p><i>“As he passed by, he saw a man blind from birth. And his disciples asked him, “Rabbi, who sinned, this man or his parents, that he was born blind?” Jesus answered, “It was not that this man sinned, or his parents, but that the works of God might be displayed in him. We must work the works of him who sent me while it is day; night is coming, when no one can work. As long as I am in the world, I am the light of the world.” Having said these things, he spit on the ground and made mud with the saliva. Then he anointed the man’s eyes with the mud and said to him, “Go, wash in the pool of Siloam” (which means Sent). So he went and washed and came back seeing.” (John 9:1-7 ESV).</i></p>
						



					`,
      };
    },
  },
  {
    id: "Pool_Of_Siloam",
    ctg: "christian",
    bgImage: "posts/bank/poolofsiloam/1.jpg",
    mobBgImage: "posts/bank/poolofsiloam/M.jpg",
    isVid: false,
    vidId: "",
    title: "POOL OF SILOAM",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>In 2004, an old Turkish sewage pipe exploded in Jerusalem and during the subsequent repair, two ancient stone steps were found by the construction crew. Normally this would not make much news in Israel, even though it was near Hezekiah’s Tunnel that carries fresh water from the Gihon Spring, but the coins and pottery found dated it from the Second Temple period. It proved to be vastly important as these steps led the excavators down to where John recorded Jesus had healed a blind man (John 9:1-12).</p>
						
						<p>Located south of the City of David, on the west side of the eastern hill, the recently excavated reservoir is shaped like a trapezoid, with three sets of five steps that run for 225 feet alongside it. This massive pool dates to the siege of King Sennacherib of Assyria and King Hezekiah’s famous water tunnel in the 8th century (2 Chronicles 32). </p>
						
						<p>There are two pools that were identified as the Pool of Siloam. The traditional and older Pool of Siloam, now called the Byzantine Pool, was discovered in the 5th century. It is a narrow rectangle that was fed by the waters from Hezekiah's Tunnel. Around 450 A.D., a church was built next to it by the Byzantine empress Eudocia, which the Persians destroyed in 614 AD. Early Christian pilgrims came here to celebrate Jesus' miracle, but it was the wrong pool.</p>
						
						<p>The much larger 2004 Pool of Siloam is about 70 yards away from the older pool, and the actual one that John records in his Gospel. It had disappeared under centuries of winter rains that sent sediment and debris downhill, on top of the destruction from 70 A.D. Before this burial, the pool was an important part of the Feast of Tabernacles.</p>
						
						<p>Jewish pilgrims brought their harvest crops here in a musical procession, waving a palm branch with myrtle tied to it by a golden thread (lulav) in one hand and a citrus fruit (etrog) in the other, to watch the priest draw water from the pool in a golden pitcher, which was then taken to the Temple with great fanfare and trumpets (Leviticus 23:40-40). The High priest would receive it from him and pour it into a basin, with a second pouring of wine into a separate basin while singing praises to God from Psalm 118 (Isaiah 12:3).</p>
						
						<p>It was at this moment, when there was a silent pause in the ceremony, that Jesus revealed Himself as the Sent One, promising “living water” to “save now” those who had “gained their sight” by believing in Him (John 7:37-38). As they sang Psalm 118:22-27, they prophetically confirmed Him as their Messiah.</p>

						<p>The Greek word Siloam is derived from the Hebrew word “shiloach,” which means, “sent” Our English equivalent is “apostle,” which means, “sent one.” Interestingly, the Sent One only does two miracles in Jerusalem. Jesus heals a lame man at the Bethesda Pool (John 5:2-9) and a blind man at the pool of Siloam, both of which have added significance to His Davidic identity from 2 Samuel 2:5-8. </p>

						<p>The rest of the pool, extending an additional 120 feet, remains buried, The Greek Orthodox Church who owns the property has not allowed the excavation to continue.</p>
						
						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/poolofsiloam/1.jpg"} class="img-responsive" />
						</div>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“As he passed by, he saw a man blind from birth. And his disciples asked him, “Rabbi, who sinned, this man or his parents, that he was born blind?” Jesus answered, “It was not that this man sinned, or his parents, but that the works of God might be displayed in him. We must work the works of him who sent me while it is day; night is coming, when no one can work. As long as I am in the world, I am the light of the world.” Having said these things, he spit on the ground and made mud with the saliva. Then he anointed the man's eyes with the mud and said to him, “Go, wash in the pool of Siloam” (which means Sent). So he went and washed and came back seeing.” (John 9:1-7, ESV).</i></p>

						



					`,
      };
    },
  },
  {
    id: "Zedekiahs_Cave",
    ctg: "christian",
    bgImage: "posts/bank/zedekiahscave/1.jpg",
    mobBgImage: "posts/bank/zedekiahscave/M.jpg",
    isVid: false,
    vidId: "",
    title: "ZEDEKIAH’S CAVE",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>To understand Hezekiah’s Tunnel and to truly appreciate this tremendous feat of engineering, some background is needed. Judah had been reduced by Assyria to a vassal state, as was most of the world, but when Sargon King of Assyria died these suppressed kingdoms rebelled…and were crushed by his son Sennacherib’s armies (Micah 1:8-12).</p>
						
						<p>Hezekiah was the king of Judah at this time (726-697 B.C.), and he refused to pay tribute to Sennacherib (2 Kings 18:7), trusting in an alliance with Egypt instead (Isaiah 36:4-7). The natural response to this rebellion was to invade Judah, which prompted Hezekiah to agree to pay the tribute of 300 talents of silver and 30 talents of gold, but he did so by stripping down the Temple (2 Kings 18:14-16).</p>
						
						<p>This concession was too little, too late, though, and Assyria marched on Jerusalem (Isaiah 36:1-2). Withstanding this siege would require ensuring there would be enough water for the city to survive, which meant a tunnel would need to be dug from the spring (2 Chronicles 32:1-4).</p>
						
						<p>In 1880, a boy discovered an inscription on the tunnel wall while bathing. It has since been removed to the Istanbul Museum, but it explained the rare engineering feat of digging through solid bedrock with picks, axes, and a bucket brigade. It described two teams digging simultaneously from opposite directions:</p>
						
						<p>“And when the tunnel was driven through...the hewers wielded the ax, each man toward his fellow...there was heard a man's voice calling to his fellow...the hewers hacked each toward the other, ax against ax, and the water flowed from the spring to the pool, a distance of 1,200 cubits....”</p>
						
						<p>Hezekiah’s Tunnel is a remarkable experience, though not as difficult today as when Warren first discovered it. Still, at 2 feet wide and 5 feet high for much of the tunnel, it can be a bit of a challenge. On a summer day, the 63-degree, spring-fed water is very refreshing, but not advisable during the winter months without a change of clothes, because you will get wet (the water level rises from your ankles to your knees to your waist). Give yourself about 40-60 minutes to wade through the 1,740-foot tunnel and be sure to bring a flashlight or headlamp</p>

						<p>If you don’t want to get wet, then you can take the dry Canaanite Tunnel (to the immediate left of the main tunnel), which was used for crop irrigation. It’s narrow, but completely passable. The source of the water’s flow, the Gihon Spring, is also famous as the spot where Solomon was crowned King of Israel (1 Kings 1:38-40). Standing on the very ground where Solomon was anointed king is something you can experience as part of the underground, dry tunnel walk.</p>

						<p>You can also walk down the Herodian street (also underground) that myriads of Jews walked up to the Temple from the Pool of Siloam. This is the same path Jesus would have used 2,000 years ago. These tunnels were the last hiding places during the Roman destruction, and excavations in the tunnels revealed a Roman sword in its leather sheath.</p>

						<p>The whole tunnel system exposes an aspect of Jerusalem that leaves you astounded at the engineering skill involved. When you consider what it took to complete the construction above ground, what Lies beneath only adds to the marvel of the City of David.</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/zedekiahscave/1.jpg"} class="img-responsive" />
						</div>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“The rest of the deeds of Hezekiah and all his might and how he made the pool and the conduit and brought water into the city, are they not written in the Book of the Chronicles of the Kings of Judah.” (2 Kings 20:20, ESV).</i></p>

						<p><i>“This same Hezekiah closed the upper outlet of the waters of Gihon and directed them down to the west side of the city of David. And Hezekiah prospered in all his works.” (2 Chronicles 32:20, ESV).</i></p>

						



					`,
      };
    },
  },
  {
    id: "Mount_Of_Olives",
    ctg: "christian",
    bgImage: "posts/bank/mountofolives/1.jpg",
    mobBgImage: "posts/bank/mountofolives/M.jpg",
    isVid: false,
    vidId: "",
    title: "MOUNT OF OLIVES",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>When you first arrive in Jerusalem, this two-mile long ridge is where you will most likely get your first full view of the famous City of David. Named for the olive trees that used to grow here in abundance, and where Roman legions camped during the city siege in 70 A.D., its slopes are now one of the main Jewish burial grounds for Jerusalem.  </p>
						
						<p>Between the Temple Mount and the Mount of Olives is the Kidron Valley, and on the hillside rising up over it are more than 150,000 Jewish graves. According to Jewish tradition, their hope is to be the first resurrected when the Messiah arrives and walks through the East Gate (Ezekiel 44:1-3). Directly in front of the East Gate are Muslim tombs that were purposely placed to block His arrival. This gate is the oldest of all the gates (dated from the time of Nehemiah). Suleiman the Magnificent sealed it in 1541 to stop Him from entering.  </p>
						
						<p>At almost 3,000 feet high, with a spectacular view of Jerusalem, the Mount of Olives has witnessed a lot of history: as the refuge for David when he fled from Absalom (2 Samuel 15:30), where Solomon made altars to false gods (1 Kings 11:5-7), and where King Josiah later “smashed the sacred stones and tore down the Asherah poles” to deter further abominations (2 Kings 23:14). The Prophet Zechariah also closely identified with this area and is said to have been buried on the Mount of Olives.</p>
						
						<p>In New Testament times, this was a favorite spot for Jesus, a spot where He gave His famous Olivet Discourse (Matthew 24), predicting the coming Roman destruction in 70 A.D., and where He descended into Jerusalem to the shouts of “Hosanna!” on the first Palm Sunday, thus fulfilling Zechariah 9:9.  </p>
						
						<p>“Rejoice greatly, Daughter of Zion! Shout, Daughter of Jerusalem! See, your king comes to you, righteous and victorious, lowly and riding on a donkey, on a colt, the foal of a donkey.” <br/>The palms were a traditional symbol of rebellion against Roman rule by the conquered Jews, who did not understand Jesus’ peaceful mission. Palm fronds are still waved today by Jews during Sukkoth (the Feast of Tabernacles) on the Mount of Olives; one circle each day is made on the summit for the first six days to symbolize the Temple service when the priests used to circle the altar once a day.  </p>
						
						<p>The Garden of Gethsemane is on the lower slope. Today, the Garden is fenced off to protect the ancient Olive trees that are at least a thousand years old.  Despite being where Jesus traveled to many times, the Mount is most renowned today as the spot where He ascended into Heaven (Acts 1:9-12).  </p>
						
						<p>There are three locations that claim this Ascension distinction. The first is the Dome of the Ascension, in a courtyard of a small mosque. Second is a church under the modern Pater Noster Church (built above Queen Helena's 4th century structure), and last is a Russian </p>

						<p>Orthodox Church. The only thing we know from Scripture is that it was near Bethany (Matthew 26:6), which would probably rule out all three claims geographically.  </p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/mountofolives/1.jpg"} class="img-responsive" />
						</div>
						
						<p>Despite this, it is a majestic place to ponder all that happened when Jesus was here. It provides an excellent view of the Temple Mount. Although a peaceful area today, Zechariah 14:4 speaks of the Day of Judgment beginning on the Mount of Olives when the Messiah returns to vanquish Israel’s foes:  </p>
						
						<p>“On that day his feet will stand on the Mount of Olives, east of Jerusalem, and the Mount of Olives will be split in two from east to west, forming a great valley, with half of the mountain moving north and half moving south.”  </p>
						
						<p class="ac-margin-bot-20">If Jesus did ascend to Heaven from the Mount of Olives, then returning to this same mountain in triumph makes even more sense when you consider David’s flight as the rejected King (like the Son of David’s rejection 2,000 years ago). According to Zechariah, its remarkable recent history as a favorite spot of Jesus for fellowship, rest, and prayer, will be surpassed by a much more remarkable future event. </p>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“Behold, a day is coming for the LORD, when the spoil taken from you will be divided in your midst. For I will gather all the nations against Jerusalem to battle, and the city shall be taken and the houses plundered and the women raped. Half of the city shall go out into exile, but the rest of the people shall not be cut off from the city. Then the LORD will go out and fight against those nations as when he fights on a day of battle. On that day his feet shall stand on the Mount of Olives that lies before Jerusalem on the east, and the Mount of Olives shall be split in two from east to west by a very wide valley, so that one half of the Mount shall move northward, and the other half southward. And you shall flee to the valley of my mountains, for the valley of the mountains shall reach to Azal. And you shall flee as you fled from the earthquake in the days of Uzziah king of Judah. Then the LORD my God will come, and all the holy ones with him.” (Zechariah 14:1-5 ESV).</i></p>
						
						<p><i>“As he sat on the Mount of Olives, the disciples came to him privately, saying, “Tell us, when will these things be, and what will be the sign of your coming and of the end of the age?” And Jesus answered them, “See that no one leads you astray. For many will come in my name, saying, ‘I am the Christ,’ and they will lead many astray. And you will hear of wars and rumors of wars. See that you are not alarmed, for this must take place, but the end is not yet. For nation will rise against nation, and kingdom against kingdom, and there will be famines and earthquakes in various places. All these are but the beginning of the birth pains.” (Matthew 24:3-8 ESV).</i></p>
						
						<p><i>“As he was drawing near — already on the way down the Mount of Olives—the whole multitude of his disciples began to rejoice and praise God with a loud voice for all the mighty works that they had seen, saying, “Blessed is the King who comes in the name of the Lord! Peace in heaven and glory in the highest!” (Luke 19:37-38 ESV).</i></p>
						
						<p><i>“So when they had come together, they asked him, “Lord, will you at this time restore the kingdom to Israel?” He said to them, “It is not for you to know times or seasons that the Father has fixed by his own authority. But you will receive power when the Holy Spirit has come upon you, and you will be my witnesses in Jerusalem and in all Judea and Samaria, and to the end of the earth.” And when he had said these things, as they were looking on, he was lifted up, and a cloud took him out of their sight. And while they were gazing into heaven as he went, behold, two men stood by them in white robes, and said, “Men of Galilee, why do you stand looking into heaven? This Jesus, who was taken up from you into heaven, will come in the same way as you saw him go into heaven.” Then they returned to Jerusalem from the mount called Olivet, which is near Jerusalem, a Sabbath day’s journey away.” (Acts 1:6-12 ESV).</i></p>

						



					`,
      };
    },
  },
  {
    id: "Garden_Of_Gethsemane",
    ctg: "christian",
    bgImage: "posts/bank/gardenofgethsemane/1.jpg",
    mobBgImage: "posts/bank/gardenofgethsemane/M.jpg",
    isVid: false,
    vidId: "",
    title: "GARDEN OF GETHSEMANE",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>The Garden of Gethsemane is where Jesus prayed on the night of His betrayal and arrest (Mark 14:32-41). According to the record in Luke, Jesus’ despair in Gethsemane was so deep that He sweat drops of blood (Luke 22:40-46).  </p>
						
						<p>“Then Jesus came with them to a place called Gethsemane, and said to His disciples, "Sit here while I go over there and pray." And He took with Him Peter and the two sons of Zebedee and began to be grieved and distressed.” (Matthew 26:36-45).</p>
						
						<p>Sitting at the foot of the Mount of Olives, within the grounds of the Church of all Nations, the tranquil garden has magnificent ancient olive trees dating back to approximately 1,000 years ago, still producing olives today.</p>
						
						<p>There is debate about the exact age of the olive trees and whether this was the properly named spot where Jesus prayed. Without a doubt, the amazing trees are offshoots from the same ones Jesus prayed next to.  </p>
						
						<p>Across the lane is a less-frequented grove, where arrangements can be made to spend a more private time of worship and contemplation. </p>

						<div class="img-wrapper">
							<img src=${getImgUrl() +
                "/posts/gardenofgethsemane/2.jpg"} class="img-responsive" />
						</div>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“And they went to a place called Gethsemane. And he said to his disciples, “Sit here while I pray.” And he took with him Peter and James and John, and began to be greatly distressed and troubled. And he said to them, “My soul is very sorrowful, even to death. Remain here and watch.” And going a little farther, he fell on the ground and prayed that, if it were possible, the hour might pass from him. And he said, “Abba, Father, all things are possible for you. Remove this cup from me. Yet not what I will, but what you will.” And he came and found them sleeping, and he said to Peter, “Simon, are you asleep? Could you not watch one hour? Watch and pray that you may not enter into temptation. The spirit indeed is willing, but the flesh is weak.” And again he went away and prayed, saying the same words. And again he came and found them sleeping, for their eyes were very heavy, and they did not know what to answer him. And he came the third time and said to them, “Are you still sleeping and taking your rest? It is enough; the hour has come. The Son of Man is betrayed into the hands of sinners.” (Mark 14:32-41 ESV).</i></p>

						<p><i>“And when he came to the place, he said to them, “Pray that you may not enter into temptation.” And he withdrew from them about a stone's throw, and knelt down and prayed, saying, “Father, if you are willing, remove this cup from me. Nevertheless, not my will, but yours, be done.” And there appeared to him an angel from heaven, strengthening him. And being in agony he prayed more earnestly; and his sweat became like great drops of blood falling down to the ground. And when he rose from prayer, he came to the disciples and found them sleeping for sorrow, and he said to them, “Why are you sleeping? Rise and pray that you may not enter into temptation.” (Luke 22:40-46 ESV).</i></p>

						<p><i>“Then Jesus went with them to a place called Gethsemane, and he said to his disciples, “Sit here, while I go over there and pray.” And taking with him Peter and the two sons of Zebedee, he began to be sorrowful and troubled. Then he said to them, “My soul is very sorrowful, even to death; remain here, and watch with me.” And going a little farther he fell on his face and prayed, saying, “My Father, if it be possible, let this cup pass from me; nevertheless, not as I will, but as you will.” And he came to the disciples and found them sleeping. And he said to Peter, “So, could you not watch with me one hour? Watch and pray that you may not enter into temptation. The spirit indeed is willing, but the flesh is weak.” Again, for the second time, he went away and prayed, “My Father, if this cannot pass unless I drink it, your will be done.” And again he came and found them sleeping, for their eyes were heavy. So, leaving them again, he went away and prayed for the third time, saying the same words again. Then he came to the disciples and said to them, “Sleep and take your rest later on. See, the hour is at hand, and the Son of Man is betrayed into the hands of sinners.” (Matthew 26:36-45 ESV).</i></p>
						



					`,
      };
    },
  },
  {
    id: "Via_Dolorosa",
    ctg: "christian",
    bgImage: "posts/bank/viadolorosa/1.jpg",
    mobBgImage: "posts/bank/viadolorosa/M.jpg",
    isVid: false,
    vidId: "",
    title: "VIA DOLOROSA",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>Every Friday afternoon a large procession of Catholics meets near the Lions’ Gate and wind their way through the streets of Jerusalem’s Old City. They are led by Franciscan friars, and sometimes accompanied by an impressive Muslim escort dressed in Ottoman Zouave uniforms — a red fez, baggy blue pants, and a gold-embroidered vest. As they walk, each one bangs their silver-tipped staff on the pavement to part the passing crowd. The 1,640-foot procession stops at the 14 Stations of the Cross, the Catholic tradition of the Via Dolorosa that remembers the path Jesus took to His death and ends at the Church of the Holy Sepulchre.</p>
						
						<p>The Via Dolorosa (the way of suffering) takes pilgrims through tight marketplace streets full of shoppers, citizens, and tourists. The path is 14 stops marked by circular bronze disks with Roman numerals embedded in the walls.  </p>

						<p>Here are the 14 traditional Catholic Stations of the Cross:</p>
						
						<p>1 Station: Jesus condemned by Pontius Pilate. <br/>2 Station: Jesus took up his cross. <br/>3 Station: Jesus fell for the first time. <br/>4 Station: Mary watched her son go by with the cross. <br/>5 Station: Simon of Cyrene is forced to help Jesus carry the cross. <br/>6 Station: Veronica wipes Jesus' face. <br/>7 Station: Jesus falls a second time. <br/>8 Station: Jesus consoles the crying women. <br/>9 Station: Jesus falls a third time. <br/>10 Station: Jesus is stripped. <br/>11 Station: Jesus is nailed to the cross. <br/>12 Station: Jesus dies. <br/>13 Station: Jesus is taken down from the cross. <br/>14 Station: Jesus is laid in the tomb. </p>

						<p>While the route has changed a number of times throughout history, the 14 stations that have become tradition were accepted by Roman Catholics by the 19th century.  </p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/viadolorosa/2.jpg"} class="img-responsive" />
						</div>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“And the soldiers led him away inside the palace (that is, the governor's headquarters), and they called together the whole battalion. And they clothed him in a purple cloak, and twisting together a crown of thorns, they put it on him. And they began to salute him, “Hail, King of the Jews!” And they were striking his head with a reed and spitting on him and kneeling down in homage to him. And when they had mocked him, they stripped him of the purple cloak and put his own clothes on him. And they led him out to crucify him. The Crucifixion And they compelled a passerby, Simon of Cyrene, who was coming in from the country, the father of Alexander and Rufus, to carry his cross.” (Mark 15:16-21 ESV).</i></p>

						<p><i>“And when they came to a place called Golgotha (which means Place of a Skull), they offered him wine to drink, mixed with gall, but when he tasted it, he would not drink it. And when they had crucified him, they divided his garments among them by casting lots. Then they sat down and kept watch over him there. And over his head they put the charge against him, which read, “This is Jesus, the King of the Jews.” (Matthew 27:33-37 ESV).</i></p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/viadolorosa/1.jpg"} class="img-responsive" />
						</div>
					   


					`,
      };
    },
  },
  {
    id: "St_Anna",
    ctg: "christian",
    bgImage: "posts/bank/stanna/1.jpg",
    mobBgImage: "posts/bank/stanna/M.jpg",
    isVid: false,
    vidId: "",
    title: "ST. ANNE AND THE POOLS OF BETHESDA",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>While the canonical Gospels are silent about the Virgin Mary’s origins, we know about her parents Joachim and Anne, her birth and childhood. Early Christian tradition places the home of Joachim and Anne next to a double pool that was a popular healing center - the pool of Bethesda, known to us from the Gospel of John: It is there that Jesus healed a paralytic. The double significance of the site as birthplace of Mary and location of a miracle soon turned it into an important Christian sanctuary. The Byzantines built a large basilica, St. Mary of the Probatic, over the pools.” Damaged by the Persian invasions in 614, it was rebuilt and then destroyed by the Arabs around 1010. The Crusaders built a small monastery over the ruins, and in 1030 they also built the present basilica, a large Romanesque church dedicated to St. Anne, above the caves where the memory of the Virgin’s birthplace was kept.</p>
						
						<p>At the end of the Crusader period, St. Anne’s was turned into an Islamic law school, and it fell into neglect under the Ottoman Empire. In 1856, the Ottomans offered the basilica to France, and it was entrusted to the Missionaries of Africa or White Fathers, who have welcomed travelers until today.</p>

						<p>The Church of St. Anne is located at the beginning of the Via Dolorosa in the Muslim Quarter, just inside Lion’s Gate at the eastern entrance of the Old City. The complex is an oasis of peace amid the noisy hustle and bustle of the Arab markets. The Basilica is known for its extraordinary acoustics, and visitors are invited to sing their hymns of worship to God before they walk down to the crypt dedicated to Mary’s birth. The massive complex of pools and ruins of the Byzantine and Crusader churches is still well preserved. Visitors can walk down into the deep cistern where water remains, as a memory and perhaps invitation to all those who still seek healing in this place.</p>
						
						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/stanna/2.jpg"} class="img-responsive" />
						</div>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“Now there is in Jerusalem by the Sheep Gate a pool in Aramaic called Bethesda, which has five roofed colonnades. In these lay a multitude of invalids — blind, lame, and paralyzed. One man was there who had been an invalid for thirty-eight years. When Jesus saw him lying there and knew that he had already been there a long time, he said to him, “Do you want to be healed?” The sick man answered him, “Sir, I have no one to put me into the pool when the water is stirred up, and while I am going another steps down before me.” Jesus said to him, “Get up, take up your bed, and walk.” And at once the man was healed, and he took up his bed and walked. Now that day was the Sabbath.” (John 5:2-9 ESV).</i></p>
					   


					`,
      };
    },
  },
  {
    id: "Gates_Of_Jerusalem",
    ctg: "christian",
    bgImage: "posts/bank/gatesofjerusalem/1.jpg",
    mobBgImage: "posts/bank/gatesofjerusalem/M.jpg",
    isVid: false,
    vidId: "",
    title: "GATES OF JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>Jerusalem’s Old City walls, built in the early 16th century by the Turkish Sultan Suleiman the Magnificent, have eight gates. All but one (the Gate of Mercy) still serve Jerusalemites and visitors streaming to its markets, and sacred and historic sites.  </p>

						<p>The gates are listed counter-clockwise from south to west:</p>

						<h3>THE ZION GATE:</h3>

						<p>Bearing Jerusalem’s earliest biblical name in Hebrew and English, this gate’s Arabic name is the Gate of the Prophet David, as the Tomb of King David, on adjacent Mount Zion, is only a few steps away. Zion Gate leads directly to the Armenian and Jewish quarters. </p>

						<h3>THE DUNG GATE:</h3>

						<p>This gate’s unusual name derives from the refuse dumped here in antiquity, where the prevailing winds would carry odors away. Nehemiah 2:13 mentions a Dung Gate that was probably near this one. This gate leads directly to the Western Wall and the Southern Wall Archaeological Park.  </p>

						<h3>GATE OF MERCY:</h3>
						
						<p>This gate, in the eastern Temple-Mount wall, may be the best-known of them all. Also called the Golden Gate or the Eastern Gate, it has been blocked for centuries, and is said to be awaiting a miraculous opening when the Messiah comes, and the dead are resurrected.  </p>

						<div class="img-wrapper">
							<img src=${getImgUrl() +
                "/posts/gatesofjerusalem/2.jpg"} class="img-responsive" />
						</div>
						
						<h3>LION’S GATE:</h3>
						
						<p>This portal is named after a pair of ferocious-looking animal carvings that flank it. They are actually tigers, the heraldic symbol of the 13th-century Sultan Beybars. It is also called St. Stephen’s Gate, after the first Christian martyr, who tradition says was stoned nearby. Lion’s Gate, which leads to the Pools of Bethesda, the Via Dolorosa, and the markets, became famous during the Six Day War.  </p>
						
						<h3>HEROD’S GATE:</h3>
						
						<p>Despite its name, the notorious Judean king had nothing to do with this gate. In Arabic and Hebrew this north-facing gate, which leads to the Old City markets, is called the Flowers Gate. Some say the name derives from a rosette carved over it. However, in Arabic a similar word means “awakened,” and may refer to a nearby cemetery and the hope of resurrection.  </p>

						<div class="img-wrapper">
							<img src=${getImgUrl() +
                "/posts/gatesofjerusalem/1.jpg"} class="img-responsive" />
						</div>
						
						<h3>DAMASCUS GATE:</h3>
						
						<p>This most imposing of Jerusalem’s gateways also faces north and is named for the grand city from which Jerusalem’s rulers once came. It is always a busy thoroughfare, thanks to the bustling markets within. Below the 16th-century gate, archaeologists have uncovered part of the entryway built by Emperor Hadrian in the second century CE. </p>
						
						<h3>THE NEW GATE:</h3>
						
						<p>This is the only Old City entryway not part of the original design of the 16th-century walls. It was breached in the waning days of the Ottoman Empire to allow Christian pilgrims quicker access to their holy places within the ramparts.  </p>
						
						<h3>THE JAFFA GATE:</h3>
						
						<p class="ac-margin-bot-20">This was the destination of Jewish and Christian pilgrims disembarking at the Jaffa port, hence its name. It led (and still leads) directly to the Jewish and Christian quarters, as well as to the most popular parts of the market, and to the Tower of David Museum, once Jerusalem’s citadel and now a showcase of its history.  </p>


						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“Sing praises to the LORD, who sits enthroned in Zion! Tell among the peoples his deeds! For he who avenges blood is mindful of them; he does not forget the cry of the afflicted. Be gracious to me, O LORD! See my affliction from those who hate me, O you who lift me up from the gates of death, that I may recount all your praises, that in the gates of the daughter of Zion I may rejoice in your salvation.” (Psalm 9:11-14 ESV).</i></p>
						
						<p><i>“A PSALM OF THE SONS OF KORAH. A SONG. On the holy mount stands the city he founded; the LORD loves the gates of Zion more than all the dwelling places of Jacob. Glorious things of you are spoken, O city of God. Selah.” (Psalm 87:1-3 ESV).</i></p>

						<p><i>“On your walls, O Jerusalem, I have set watchmen; all the day and all the night they shall never be silent. You who put the LORD in remembrance, take no rest, and give him no rest until he establishes Jerusalem and makes it a praise in the earth.” (Isaiah 62:6-7 ESV).</i></p>



					`,
      };
    },
  },
  {
    id: "Garden_Tomb",
    ctg: "christian",
    bgImage: "posts/bank/gardentomb/1.jpg",
    mobBgImage: "posts/bank/gardentomb/M.jpg",
    isVid: false,
    vidId: "",
    title: "GARDEN TOMB",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>The Garden Tomb is a peaceful garden where you can hold worship services, devotionals or just enjoy the beautiful surroundings.</p>
						
						<p>Many are stirred as they come face-to-face with the empty grave. Some stay for hours reading from the Bible, praying or observing different reactions as visitors see the tomb for the first time. </p>
						
						<p>General Charles Gordon discovered this site in 1883 when he noticed a rocky crag that looked like it could be the "place of the skull" (Matthew 27:33) where Jesus was crucified. Around the corner Gordon discovered an ancient tomb and then putting the two together, he found the hill of crucifixion and the nearby burial place. This location is considered by many the strongest possibility of where Jesus was laid in the tomb.  </p>
						
						<p>Groups must book their visit in advance</p>


						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/gardentomb/1.jpg"} class="img-responsive" />
						</div>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“And when they came to a place called Golgotha (which means Place of a Skull).” (Matthew 27:33 ESV).</i></p>

						<p><i>“After these things Joseph of Arimathea, who was a disciple of Jesus, but secretly for fear of the Jews, asked Pilate that he might take away the body of Jesus, and Pilate gave him permission. So he came and took away his body. Nicodemus also, who earlier had come to Jesus by night, came bringing a mixture of myrrh and aloes, about seventy-five pounds in weight. So they took the body of Jesus and bound it in linen cloth with the spices, as is the burial custom of the Jews. Now in the place where he was crucified there was a garden, and in the garden a new tomb in which no one had yet been laid. So because of the Jewish day of Preparation, since the tomb was close at hand, they laid Jesus there.” (John 19:38-42 ESV).</i></p>

						



					`,
      };
    },
  },
  {
    id: "Yad_Vashem",
    ctg: "christian",
    bgImage: "posts/bank/yadvashem/1.jpg",
    mobBgImage: "posts/bank/yadvashem/M.jpg",
    isVid: false,
    vidId: "",
    title: "YAD VASHEM",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>Yad Vashem, Israel’s main Holocaust remembrance and education center is situated on the green slopes of Har HaZikaron, (the Mount of Remembrance) in Jerusalem. </p>
						<p>Israel’s Holocaust commemoration project began in 1953 with the task of perpetuating the memory of Holocaust victims and documenting the history of the Jewish people during the Holocaust so that it will be remembered by future generations. This project was an important step for the young nation of Israel at the time and was significant for the citizens of Israel, particularly for the survivors of the ghettos and concentration camps. </p>
						
						
						<p>The new Yad Vashem museum was opened to the public in 2005. The museum is designed in the shape of a prism penetrating the mountain. Divided into nine galleries, the museum relates the stories of the Jewish communities before the Second World War and the series of events beginning from the rise of the Nazis to power, the pursuit of the Jews, their eviction to the ghettos and ending with “the Final Solution” and mass genocide. </p>
						<p>The personal experiences and feelings of the victims of the Holocaust constitute the groundwork for the museum’s exhibits. Photographs, films, documents, letters, works of art, and personal items found in the camps and ghettos are all an integral part of the exhibits. As you exit the Museum, the Hall of Names is an inspiring memorial containing over three million names of Holocaust victims that were submitted by their families and relatives. Names can still be submitted by visitors to the memorial and added to the computerized archive. </p>
						<p>In addition to the Holocaust History Museum, Yad Vashem has other memorials and monuments, including the Hall of Remembrance, where the ashes of the dead are buried and an eternal flame burns in commemoration; Yad Layeled, the children’s memorial, commemorates the one and a half million Jewish children who were murdered in the Holocaust. <br/>The Memorial to the Deportees, is an authentic railroad car hanging over the cliff on the road winding down from the mountain. The car was used to transport Jews who had been banished from their homes to the concentration camps.</p>
						
						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/yadvashem/1.jpg"} class="img-responsive" />
						</div>


						<p>The Avenue of the Righteous Among the Nations has over 2,000 trees planted in honor of non-Jews who endangered their lives in order to rescue Jews from the Nazis; the archives and library of Yad Vashem House is the world’s largest repository of material about the Holocaust. <br/> Visiting the Yad Vashem museum is an emotional and heartrending experience, but seeing the exhibits and remembering the Holocaust gives the more than one million individuals, world leaders and dignitaries who pass through its doors annually a meaningful way to commemorate the six million Jewish victims of the Holocaust. </p>



						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/yadvashem/2.jpg"} class="img-responsive" />
						</div>



					`,
      };
    },
  },
  {
    id: "Ein_Karem",
    ctg: "christian",
    bgImage: "posts/bank/einkarem/1.jpg",
    mobBgImage: "posts/bank/einkarem/M.jpg",
    isVid: false,
    vidId: "",
    title: "EIN KAREM",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						
						<p><strong>Ein Karem,</strong> southwest of Jerusalem, is famous for the <strong>Church of the Visitation</strong>, commemorating St. Mary's visit to St. Elizabeth, and the <strong>Church of St. John the Baptist</strong>, commemorating St. John's birth: “In those days Mary arose and went with haste into the hill country, to a city of Judah, and she entered the house of Zechariah and greeted Elizabeth” (Lk. 1:39-40).* An amazing archeological find was discovered close to Ein Karem: the <strong>Cave of John the Baptist</strong> in Kibbutz Tzuba.</p>
						
						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/einkarem/1.jpg"} class="img-responsive" />
						</div>

						<p>Even before reaching the city, you can visit the picturesque neighborhood of Ein Kerem. Just a 20-minute drive from the city center, it is known for its idyllic character. Nestled in greenery, Ein Kerem brings you breathtaking views, charming stone houses, churches and mosques, fascinating historical sites, enchanting alleys, galleries and special boutique shops, cafes and fine restaurants, as well as exquisite hotels, both old and new. </p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/einkarem/2.jpg"} class="img-responsive" />
						</div>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“Malchijah the son of Rechab, ruler of the district of Beth-haccherem, repaired the Dung Gate. He rebuilt it and set its doors, its bolts, and its bars.” (Nehemiah 3:14 ESV).</i></p>

						<p><i>“In those days Mary arose and went with haste into the hill country, to a town in Judah, and she entered the house of Zechariah and greeted Elizabeth. And when Elizabeth heard the greeting of Mary, the baby leaped in her womb. And Elizabeth was filled with the Holy Spirit, and she exclaimed with a loud cry, “Blessed are you among women, and blessed is the fruit of your womb! And why is this granted to me that the mother of my Lord should come to me? For behold, when the sound of your greeting came to my ears, the baby in my womb leaped for joy. And blessed is she who believed that there would be a fulfillment of what was spoken to her from the Lord.” (Luke 1:39-45 ESV).</i></p>

					`,
      };
    },
  },
  {
    id: "Elah_Valley",
    ctg: "christian",
    bgImage: "posts/bank/elahvalley/1.jpg",
    mobBgImage: "posts/bank/elahvalley/M.jpg",
    isVid: false,
    vidId: "",
    title: "ELAH VALLEY",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>The Valley of Elah, "the Valley of the Terebinth". It named after the large and shady terebinth trees which are indigenous to this area, and best known as the place described in the Bible where the Israelites were encamped when David fought Goliath (1 Sam. 17:2, 19). It was near Azekah and Socho (17:1). On the west side of the valley, near Socho, there is an exceptionally large and ancient Terebinth tree, 55 feet in height, 17 feet in circumference, with the breadth of its shade no less than 75 feet. It marks the upper end of the valley and is the largest terebinths in the area. Rising from the valley on its extreme south-east end lies the hilltop ruin, Adullam. </p>
						
						<h3>ELAH TREE</h3>
						
						<p>The valley gets its name from the Elah tree, a type of oak or terebinth tree. This large and old Elah tree remains in the valley, reminding visitors of the day when trees proliferated in the Shephelah (cf. 1 Kings 10:27).  </p>
						
						<h3>BROOK ELAH</h3>
						
						<p>Brook Elah is famous for the five stones it contributed to the young slinger, David. Some surmise David chose five stones instead of the one needed in case he needed to face Goliath's four brothers. </p>
						
						<h3>ADULLAM</h3>
						
						<p>Located on the east end of the valley is the site of Adullam. This proved to be the perfect place for David to hide during his initial flight from Saul. Today it rests on the border between pre-1967 Israel and the West Bank, in David's day, this site was in "no-man's land" where he could stay safely out of the path of Saul or the Philistines.  </p>
						
						<h3>CAVE OF ADULLAM</h3>
						
						<p>1 Samuel 22 says David hid in the "cave of Adullam."  Today there are many caves at the site and it is not clear which one or ones David used, as many have been used and modified in the years since. While he was here, 400 men who were in debt, distress, or discontent, gathered around David. </p>
						
						<h3>VIEW OF VALLEY FROM SOCOH</h3>
						
						<p class="ac-margin-bot-20">This panoramic view of the Elah Valley from the south is the approximate view of what the Philistine army saw as they faced the Israelites in the battle commonly known as "David vs. Goliath."  The Philistines were encamped on the south side of the valley and King Saul's forces occupied the hill on the northern side. </p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>Now the Philistines gathered their armies for battle. And they were gathered at Socoh, which belongs to Judah, and encamped between Socoh and Azekah, in Ephes-dammim. And Saul and the men of Israel were gathered, and encamped in the Valley of Elah, and drew up in line of battle against the Philistines. And the Philistines stood on the mountain on the one side, and Israel stood on the mountain on the other side, with a valley between them (1 Samuel 17:1-4 ESV). </i></p>

						<p><i>“David departed from there and escaped to the cave of Adullam. And when his brothers and all his father's house heard it, they went down there to him. And everyone who was in distress, and everyone who was in debt, and everyone who was bitter in soul, gathered to him. And he became commander over them. And there were with him about four hundred men.” (1 Samuel 22:1-2 ESV).</i></p>
						

						



					`,
      };
    },
  },
  {
    id: "Church_Of_The_Holy_Sepulchre",
    ctg: "christian",
    bgImage: "posts/bank/churchoftheholysepulchre/1.jpg",
    mobBgImage: "posts/bank/churchoftheholysepulchre/M.jpg",
    isVid: false,
    vidId: "",
    title: "CHURCH OF THE HOLY SEPULCHRE",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>The Church of the Holy Sepulchre, built by Emperor Constantine after he professed a Christian faith, was based on his mother’s instructions. Helena, Constantine’s mother, came to the Holy Land in 326 A.D. After talking to the locals about the traditional Christian spots of relevance, she built three churches – the Church of the Nativity in Bethlehem, the Church of the Ascension on the Mount of Olives, and the Church of the Holy Sepulchre. Most scholars agree the Church of the Holy Sepulchre is built in the “general proximity” of Golgotha, but no one is absolutely certain where “outside the gate” referenced 2,000 years ago (Hebrews 13:12). The gate was probably the Garden Gate (Gennath).  </p>
						
						<p>Crucifixions were intended to maximize the fear of Rome in their conquered populaces and were therefore very public events. This means a main road where Passover pilgrims traveled would be ideal, a main road where they could hurl insults at the blasphemer (Matthew 27:39, Mark 15:29). The Garden Gate was chosen because it had two main roads, thereby doubling the public relations impact.</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() +
                "/posts/churchoftheholysepulchre/1.jpg"} class="img-responsive" />
						</div>

						<p>The church we see today has survived earthquakes and fires, but it is not the original and larger Constaninian church built here in 335 A.D. After the Persians burned it in 614 A.D., it was rebuilt, and then 400 years later decimated by the Fatimid Caliph Al-Hakim bi-Amr Allah, who had the tomb destroyed   down to the bedrock. The Crusaders rebuilt it in 1149, and it is this present building we visit today, which is maintained by the Greek Orthodox Church (and shared by six other Christian denominations).  </p>

						<p>There are over 30 chapels inside the sprawling basilica, that are architecturally connected to remains of Hadrian’s Temple façade as well as Constantine’s columns. Immediately to the right upon entering the building, a short flight of steps leads to the probable site of the crucifixion. At the top of the stairs beneath an altar, the glass floor reveals the original rocky ground where the cross of Jesus was held. Archaeological digs confirm this spot as being both outside the city and close to one of the gates at the time of Christ. The second major site inside the basilica is called the Edicule (“little house”). This is the traditional site of Jesus’ tomb, which the Muslims destroyed in 1009. The best evidence for this being the actual tomb of Jesus is the existence of other ancient tombs inside the church, which are found in the “Syrian Chapel,” just behind the main rotunda. One of these tombs carved into the original bedrock is said to be the tomb of Joseph of Arimathea. At least four have been found, and all four burial sites date to the time of Jesus. This helps confirm the site’s authenticity because it proves that the site was a cemetery where He was laid, and y close enough to Golgotha for His burial to occur before sundown (Luke 23:50-53).  </p>

						<div class="img-wrapper">
							<img src=${getImgUrl() +
                "/posts/churchoftheholysepulchre/2.jpg"} class="img-responsive" />
						</div>

						<p class="ac-margin-bot-20">There are over 30 chapels inside the sprawling basilica, that are architecturally connected to remains of Hadrian’s Temple façade as well as Constantine’s columns. Immediately to the right upon entering the building, a short flight of steps leads to the probable site of the crucifixion. At the top of the stairs beneath an altar, the glass floor reveals the original rocky ground where the cross of Jesus was held. Archaeological digs confirm this spot as being both outside the city and close to one of the gates at the time of Christ. The second major site inside the basilica is called the Edicule (“little house”). This is the traditional site of Jesus’ tomb, which the Muslims destroyed in 1009. The best evidence for this being the actual tomb of Jesus is the existence of other ancient tombs inside the church, which are found in the “Syrian Chapel,” just behind the main rotunda. One of these tombs carved into the original bedrock is said to be the tomb of Joseph of Arimathea. At least four have been found, and all four burial sites date to the time of Jesus. This helps confirm the site’s authenticity because it proves that the site was a cemetery where He was laid, and is close enough to Golgotha for His burial to occur before sundown (Luke 23:50-53).</p>

						<h3><i><u>FROM THE SCRIPTURES</u></i></h3>

						<p><i>“Now in the place where he was crucified there was a garden, and in the garden a new tomb in which no one had yet been laid. So because of the Jewish day of Preparation, since the tomb was close at hand, they laid Jesus there.” (John 19:41-42 ESV).</i></p>
					   
						<p><i>“And they brought him to the place called Golgotha (which means Place of a Skull).” (Mark 15:22 ESV).</i></p>

						<p><i>“And Joseph bought a linen shroud, and taking him down, wrapped him in the linen shroud and laid him in a tomb that had been cut out of the rock. And he rolled a stone against the entrance of the tomb.” (Mark 15:46 ESV).</i></p>
					   
					   
					   



					`,
      };
    },
  },
  {
    id: "Qasr_Al_Yahud",
    ctg: "christian",
    bgImage: "posts/bank/qasralyahud/1.jpg",
    mobBgImage: "posts/bank/qasralyahud/M.jpg",
    isVid: false,
    vidId: "",
    title: "Qasr Al-Yahud",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>Qasr al Yahud, an ancient Arabic name that means “The Castle of the Jews,” is an important site revered by Jews and Christians. According to Jewish tradition, this is the place where Joshua led the Children of Israel, with priests bearing the Ark of the Covenant in a miraculous crossing of the Jordan River and entered the Holy Land after their 40 years of wandering in the desert.  It was here that: “…as soon as the soles of the feet of the priests who bear the ark of the Lord, the Lord of all the earth, shall rest in the waters of the Jordan, that the waters of the Jordan shall be cut off, the waters that come down from upstream, and they shall stand as a heap.” (Joshua 3:13).</p>

						<p>Centuries later, Qasr al Yahud is believed to be the place where Jesus was baptized by John the Baptist and was therefore “spiritually born,” marking the beginning of His public ministry. It is also the site of Elijah’s ascension to heaven in a fiery chariot after he and Elisha crossed the Jordan: “Now Elijah took his mantle, rolled it up, and struck the water; and it was divided this way and that so that the two of them crossed over on dry ground.” (2 Kings 2:8).</p>
						
						<p>Today visitors can visit the monasteries surrounding the site and be baptized in the Jordan River as Jesus was baptized by John the Baptist.</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/qasralyahud/2.jpg"} class="img-responsive" />
						</div>

						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“So when the people set out from their tents to pass over the Jordan with the priests bearing the ark of the covenant before the people, and as soon as those bearing the ark had come as far as the Jordan, and the feet of the priests bearing the ark were dipped in the brink of the water (now the Jordan overflows all its banks throughout the time of harvest), the waters coming down from above stood and rose up in a heap very far away, at Adam, the city that is beside Zarethan, and those flowing down toward the Sea of the Arabah, the Salt Sea, were completely cut off. And the people passed over opposite Jericho. Now the priests bearing the ark of the covenant of the LORD stood firmly on dry ground in the midst of the Jordan, and all Israel was passing over on dry ground until all the nation finished passing over the Jordan.” (Joshua 3:14-17 ESV).</i></p>

						<p><i>“Then Elijah said to him, “Please stay here, for the LORD has sent me to the Jordan.” But he said, “As the LORD lives, and as you yourself live, I will not leave you.” So the two of them went on. Fifty men of the sons of the prophets also went and stood at some distance from them, as they both were standing by the Jordan. Then Elijah took his cloak and rolled it up and struck the water, and the water was parted to the one side and to the other, till the two of them could go over on dry ground. When they had crossed, Elijah said to Elisha, “Ask what I shall do for you, before I am taken from you.” And Elisha said, “Please let there be a double portion of your spirit on me.” And he said, “You have asked a hard thing; yet, if you see me as I am being taken from you, it shall be so for you, but if you do not see me, it shall not be so.” And as they still went on and talked, behold, chariots of fire and horses of fire separated the two of them. And Elijah went up by a whirlwind into heaven. And Elisha saw it and he cried, “My father, my father! The chariots of Israel and its horsemen!” And he saw him no more. Then he took hold of his own clothes and tore them in two pieces.” (2 Kings 2:6-12 ESV).</i></p>

						<p><i>“And this is the testimony of John, when the Jews sent priests and Levites from Jerusalem to ask him, “Who are you?” He confessed, and did not deny, but confessed, “I am not the Christ.” And they asked him, “What then? Are you Elijah?” He said, “I am not.” “Are you the Prophet?” And he answered, “No.” So they said to him, “Who are you? We need to give an answer to those who sent us. What do you say about yourself?” He said, “I am the voice of one crying out in the wilderness, ‘Make straight the way of the Lord,’ as the prophet Isaiah said.” (Now they had been sent from the Pharisees.) They asked him, “Then why are you baptizing, if you are neither the Christ, nor Elijah, nor the Prophet?” John answered them, “I baptize with water, but among you stands one you do not know, even he who comes after me, the strap of whose sandal I am not worthy to untie.” These things took place in Bethany across the Jordan, where John was baptizing.” (John 1:19-28 ESV).</i></p>

						<p><i>“In those days Jesus came from Nazareth of Galilee and was baptized by John in the Jordan. And when he came up out of the water, immediately he saw the heavens being torn open and the Spirit descending on him like a dove. And a voice came from heaven, “You are my beloved Son; with you I am well pleased.” (Mark 1:9-11 ESV).</i></p>
						



					`,
      };
    },
  },
  {
    id: "Qumran",
    ctg: "christian",
    bgImage: "posts/bank/qumran/1.jpg",
    mobBgImage: "posts/bank/qumran/M.jpg",
    isVid: false,
    vidId: "",
    title: "Qumran",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>In 1946, near a desolate spot in the Judean desert known as Khirbet Qumran, a Bedouin teenager crawled into a cave and discovered multiple clay jars  he hoped were filled with treasure. He was disappointed when what he found inside was just some old scrolls. These old scrolls turned out to be more valuable than treasure though, and this accidental discovery exploded into an 11-year search producing almost 900 different manuscripts.</p>
						
						<p>This was the greatest biblical manuscript discovery of all time confirming the reliability of the Old Testament. The manuscripts range from full scrolls to tiny fragments, written on papyrus, parchment, and bronze. They are written in Hebrew, Greek, and Aramaic, and can be divided into two categories: biblical books (Isaiah, Jeremiah, Psalms, etc.) and non-biblical books (prayers, legal, and end-time documents).</p>
						
						<p>The initial scrolls were in such great shape that buyers doubted they were actually ancient. The scrolls were most likely hidden in this near perfect environment when word came of the approaching Roman army bent on crushing the Jewish Revolt (66-73 A.D.). It was written by the Essenes, a separatist sect of Jews who had retreated into the wilderness, and among other things, painstakingly transcribed the Scriptures over several years. The scrolls are significant because they are the oldest group of Old Testament manuscripts ever found. The ruins of the Qumran community where the Essenes lived can be visited today. The excavations revealed pools that were used for ritual baths, cisterns, storehouses, and a large meeting hall.</p>
						
						<p>The most interesting room is the Scriptorium, where two inkwells were found with benches for scribes to do their work. This room is probably where many of the manuscripts were copied.</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/posts/qumran/2.jpg"} class="img-responsive" />
						</div>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“Oh, how I love your law! It is my meditation all the day. Your commandment makes me wiser than my enemies, for it is ever with me. I have more understanding than all my teachers, for your testimonies are my meditation. I understand more than the aged, for I keep your precepts. I hold back my feet from every evil way, in order to keep your word. I do not turn aside from your rules, for you have taught me. How sweet are your words to my taste, sweeter than honey to my mouth! Through your precepts I get understanding; therefore I hate every false way.” (Psalm 119:97-104 ESV).</i></p>
						
						<p><i>“Your word is a lamp to my feet and a light to my path. I have sworn an oath and confirmed it, to keep your righteous rules. I am severely afflicted; give me life, O LORD, according to your word! Accept my freewill offerings of praise, O LORD, and teach me your rules. I hold my life in my hand continually, but I do not forget your law. The wicked have laid a snare for me, but I do not stray from your precepts. Your testimonies are my heritage forever, for they are the joy of my heart. I incline my heart to perform your statutes forever, to the end.” (Psalm 119:105-112 ESV).</i></p>
						
						<p><i>“For the word of God is living and active, sharper than any two-edged sword, piercing to the division of soul and of spirit, of joints and of marrow, and discerning the thoughts and intentions of the heart. And no creature is hidden from his sight, but all are naked and exposed to the eyes of him to whom we must give account.” (Hebrews 4:12-13 ESV).</i></p>



					`,
      };
    },
  },
  {
    id: "Ein_Gedi",
    ctg: "christian",
    bgImage: "posts/bank/eingedi/1.jpg",
    mobBgImage: "posts/bank/eingedi/M.jpg",
    isVid: false,
    vidId: "",
    title: "EIN GEDI",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>Ein Gedi and its nature reserve on the shore of the Dead Sea, is where the fauna and flora of a splendid nature reserve intersect with great biblical adventures. This oasis has been a green Garden of Eden in the wilderness since ancient times, a refuge in the endless desert. The living landscape of David’s hideout from Saul and the Song of Solomon comprise some of these adventures.</p>

						<p>As you climb the path toward the sparkling waterfall, the picture of David hiding from King Saul (1 Sam. 24:1-22) comes alive with a view of cliff-side caves. The spirited animals that gave the site its biblical name, the “crags of the wild goats'' (1 Sam. 24:2), rest at cave entrances and walk around the reserve. The water gurgling through the tangled reeds and under shady acacias once nourished the beds of spices that enrich the poetry of the Song of Solomon (Song 1:14).</p>

						<p>The mosaic floor at the excavated remains of the Ein Gedi Ancient Synagogue and town shows the dramatic story of Ein Gedi’s people at the time of Jesus The inhabitants of Ein Gedi in present days have established an internationally acclaimed botanical garden, where you can find more than 900 species of plants from all over the world.</p>

						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“When Saul returned from following the Philistines, he was told, “Behold, David is in the wilderness of Engedi.” Then Saul took three thousand chosen men out of all Israel and went to seek David and his men in front of the Wildgoats' Rocks. And he came to the sheepfolds by the way, where there was a cave, and Saul went in to relieve himself. Now David and his men were sitting in the innermost parts of the cave. And the men of David said to him, “Here is the day of which the Lord said to you, ‘Behold, I will give your enemy into your hand, and you shall do to him as it shall seem good to you.’ Then David arose and stealthily cut off a corner of Saul's robe. And afterward David's heart struck him, because he had cut off a corner of Saul's robe. He said to his men, “The Lord forbid that I should do this thing to my lord, the Lord's anointed, to put out my hand against him, seeing he is the Lord's anointed.” So David persuaded his men with these words and did not permit them to attack Saul. And Saul rose up and left the cave and went on his way.” (1 Samuel 24:1-7 ESV). </i></p>

						<p><i>“My beloved is to me a cluster of henna blossoms in the vineyards of Engedi.” (Song of Songs 1:14 ESV).</i></p>
						



					`,
      };
    },
  },
  {
    id: "Kursi",
    ctg: "christian",
    bgImage: "posts/bank/kursi/1.jpg",
    mobBgImage: "posts/bank/kursi/M.jpg",
    isVid: false,
    vidId: "",
    title: "KURSI",
    smltitle: "",
    html: function() {
      return {
        __html: `	


						<p>Kursi is approximately 3 miles north of Ein Gev, near the junction where route 789 leaves the lakeside road and leads to the Golan Heights. Its name, meaning “chair” in Semitic languages, probably refers to the shape of the valley behind it.</p>

						<p>In 1970, a bulldozer constructing a new road to the Golan Heights revealed pieces of Byzantine pottery in its trail uncovering Kursi. Archeologists discovered Kursi’s extensive monastery, the largest in Israel from the Byzantine period. The monastery was built in the 5th century, covering 1.8 hectares. Around it stood a defensive stone wall with a watchtower. At the heart of the monastery was a large church, with a spacious courtyard in front of it.</p>

						<p>The church was divided by two rows of stone columns into a nave with two side aisles. Under a chapel in the right-hand aisle, skeletons of 30 monks were found buried in a crypt. The floor of the church was paved with mosaics depicting animal and plant life: Roosters, geese, doves, cormorants, fish, grapes, figs, pomegranates, watermelon and bananas.</p>

						<p>A large oil press was found in a side room in the left-hand aisle, suggesting that production of olive oil would have been a major source of income for the monastery.</p>

						<p>A guesthouse and bath complex for pilgrims has been uncovered in addition to the monks’ quarters. A paved road led from the monastery to the harbor where pilgrims arrived. The harbor was a fishing harbor, one of at least 16 around the Sea of Galilee. It had a breakwater and a pool where live fish were kept awaiting sale.</p>

						<p>The monastery was abandoned in the early 8th century after it was damaged by fire and earthquake and was invaded by Persians and Muslims. After being abandoned it was used by local Arabs to live in and house their animals. At that time all of the animal mosaics were obliterated to comply with the Islamic prohibition against human or animal representations.</p>

						<p>Kursi was an important place of Christian pilgrimage from the 5th century, when the lakeside towns of Capernaum, Bethsaida and Chorazin were condemned by Jesus for their lack of faith and fell into decline.</p>

						<p>It was in Kursi Jesus was confronted by a man possessed by demons. Jesus orders the demons to leave the man. The demons begged to be allowed to enter a herd of swine grazing nearby.  Jesus agrees and the swine rush down a bank into the water and drowned.<br/>The dismayed swineherds run off to spread the news, and the local people ask Jesus to leave their neighborhood. The healed man begs to go with Jesus — but Jesus tells him to go home and tell his friends what has happened.</p>

						<p>“And he went away and began to proclaim in the Decapolis how much Jesus had done for him; and everyone was amazed” (Mark 5:20). It was this gentile man who became the first person commissioned by Jesus to spread the Good News to non-Jews.</p>
						
						<h3><u><i>FROM THE SCRIPTURES</i></u></h3>

						<p><i>“Then they sailed to the country of the Gerasenes, which is opposite Galilee. When Jesus had stepped out on land, there met him a man from the city who had demons. For a long time he had worn no clothes, and he had not lived in a house but among the tombs.  When he saw Jesus, he cried out and fell down before him and said with a loud voice, “What have you to do with me, Jesus, Son of the Most High God? I beg you, do not torment me.”  For he had commanded the unclean spirit to come out of the man. (For many a time it had seized him. He was kept under guard and bound with chains and shackles, but he would break the bonds and be driven by the demon into the desert.)  Jesus then asked him, “What is your name?” And he said, “Legion,” for many demons had entered him. And they begged him not to command them to depart into the abyss.  Now a large herd of pigs was feeding there on the hillside, and they begged him to let them enter these. So he gave them permission.  Then the demons came out of the man and entered the pigs, and the herd rushed down the steep bank into the lake and drowned.</i></p>

						<p><i>When the herdsmen saw what had happened, they fled and told it in the city and in the country. Then people went out to see what had happened, and they came to Jesus and found the man from whom the demons had gone, sitting at the feet of Jesus, clothed and in his right mind, and they were afraid.  And those who had seen it told them how the demon-possessed man had been healed. Then all the people of the surrounding country of the Gerasenes asked him to depart from them, for they were seized with great fear. So he got into the boat and returned. The man from whom the demons had gone begged that he might be with him, but Jesus sent him away, saying, “Return to your home, and declare how much God has done for you.” And he went away, proclaiming throughout the whole city how much Jesus had done for him.” (Luke 8:26-39 ESV).</i></p>

						<p><i>“They came to the other side of the sea, to the country of the Gerasenes. And when Jesus[b] had stepped out of the boat, immediately there met him out of the tombs a man with an unclean spirit. He lived among the tombs. And no one could bind him anymore, not even with a chain, for he had often been bound with shackles and chains, but he wrenched the chains apart, and he broke the shackles in pieces. No one had the strength to subdue him. Night and day among the tombs and on the mountains he was always crying out and cutting himself with stones. And when he saw Jesus from afar, he ran and fell down before him.  And crying out with a loud voice, he said, “What have you to do with me, Jesus, Son of the Most High God? I adjure you by God, do not torment me.” For he was saying to him, “Come out of the man, you unclean spirit!”  And Jesus asked him, “What is your name?” He replied, “My name is Legion, for we are many.” And he begged him earnestly not to send them out of the country. Now a great herd of pigs was feeding there on the hillside, and they begged him, saying, “Send us to the pigs; let us enter them.” So he gave them permission. And the unclean spirits came out and entered the pigs; and the herd, numbering about two thousand, rushed down the steep bank into the sea and drowned in the sea.</i></p>

						<p><i>The herdsmen fled and told it in the city and in the country. And people came to see what it was that had happened. And they came to Jesus and saw the demon-possessed man, the one who had had the legion, sitting there, clothed and in his right mind, and they were afraid. And those who had seen it described to them what had happened to the demon-possessed man and to the pigs. And they began to beg Jesus to depart from their region. As he was getting into the boat, the man who had been possessed with demons begged him that he might be with him. And he did not permit him but said to him, “Go home to your friends and tell them how much the Lord has done for you, and how he has had mercy on you.”  And he went away and began to proclaim in the Decapolis how much Jesus had done for him, and everyone marveled.” (Mark 5:1-20 ESV).</i></p>

						<p><i>“And when he came to the other side, to the country of the Gadarenes, two demon-possessed men met him, coming out of the tombs, so fierce that no one could pass that way. And behold, they cried out, “What have you to do with us, O Son of God? Have you come here to torment us before the time?” Now a herd of many pigs was feeding at some distance from them. And the demons begged him, saying, “If you cast us out, send us away into the herd of pigs.” And he said to them, “Go.” So they came out and went into the pigs, and behold, the whole herd rushed down the steep bank into the sea and drowned in the waters. The herdsmen fled, and going into the city they told everything, especially what had happened to the demon-possessed men. And behold, all the city came out to meet Jesus, and when they saw him, they begged him to leave their region.” (Matthew 8:28-34 ESV).</i></p>

										


					`,
      };
    },
  },
  {
    id: "Masada",
    ctg: "christian",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    title: "MASADA",
    smltitle: "",
    html: function() {
      return {
        __html: `
					   <h3>Re-live epic history atop the Judean Desert’s glorious fortification</h3>
					   <p>Journey to Masada National Park, the lone, isolated, ancient Judean Desert clifftop fortification, overlooking the nearby Dead Sea oasis. Hike up the winding snake path or Roman staircase from the fortification’s base, or enter the Masada Visitors’ Center and travel to the site’s summit via cable car and begin to experience a part of ancient history, as if it were still in the making.</p>
					   <h3>Explore regal ruins and feel a part of history</h3>
					   <p>Enter what was once a series of luxurious castles forming the final stronghold inhabited by freedom fighters, who courageously waged war against the Roman Empire following the destruction of the Second Temple. A site so rich in historical narrative, that the cool, stone walls practically weep for the brave souls who chose untimely death over enslavement under enemy regime.</p>
					   <div class="img-wrapper">
						   <img src=${getImgUrl() + "/posts/epic-masada/1.jpg"} class="img-responsive">
					   </div>
					   <h3>Where experiencing culture and religion reaches new heights</h3>
					   <p>Stroll through the castle ruins and discover rooms and structures, archaeological findings highlighting life on Masada during the Roman siege. Enter the Northern Castle, the ruins of King Herod’s private fortress palace. Whisper a prayer in the ancient synagogue, where Jews congregated thrice daily to pray for salvation. Pay homage to the departed freedom fighters, who drew lots in the “Lottery Room” to determine the order of the men’s impending deaths, until the last remaining man put an end to his own life as well.</p>
					   <p>Gaze at what is left of a Byzantine-era church and its mosaic artwork, possibly used for centuries by escaped Christian monks as early as the 1st Century, for a period of roughly 600 years.</p>
					   <p>Experience Masada as one of UNESCO’s World Heritage Sites, complete with a sunset sound and light show at the fortification’s base, which delves into the way of life and battles experienced on site centuries ago.</p>

					   <h3><u><i>FROM THE SCRIPTURES</i></u></h3>

					   <p><i>“In you, O Lord, do I take refuge; let me never be put to shame; in your righteousness deliver me! Incline your ear to me; rescue me speedily! Be a rock of refuge for me, a strong fortress [metzuda] to save me! For you are my rock and my fortress; and for your name's sake you lead me and guide me.” (Psalm 31:1-3, ESV).</p></i>

					`,
      };
    },
  },
  {
    id: "pride-parade-2018",
    ctg: "lgbtq",
    bgImage: "/posts/bank/pride-parade-2018/1.jpg",
    mobBgImage: "/posts/bank/pride-parade-2018/M.jpg",
    isVid: true,
    vidId: "U8KwXVP3Xng",
    title: "PRIDE PARADE 2018",
    smltitle: "",
    html: function() {
      return {
        __html: `
							<h3>The Most Epic Event of the Year</h3>

							<p>Tel Aviv 2018 Pride Celebrations – guaranteed to blow your mind!</p>
							
							<p>Tel Aviv, one of the most celebrated gay capitals in the world is famous for its round the clock energy and extravagant nonstop parties, but by far one of the biggest and hottest event in this city are the Gay Pride Week festivities culminating in the awsome Friday Pride Parade.</p>

							<p>The parade, a tradition which began as early as 1998 draws a huge crowd of the coolest people from around the world who come together to celebrate and support freedom and the embracing of all lifestyles and genres in an open minded off the charts celebration.</p>

							<p>The parade is the highlight of a week of gay pride events which take place around the city and include nonstop pride themed parties, exhibitions, movie festivals, music concerts and so much more.</p>

							<p>The parade itself takes place along the buzzing main streets of amazing Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic floats, live music, dance performances and revelers dressed in a colorful festival dress.</p>

							<p>The parade culminates at the stunning Tel Aviv promenade by the shores of the beautiful Mediterranean where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances and lasting well into the small hours of the night. </p>

							<p>The 2018 parade will take place on June 8th 2018 and participation, as always, will be completely free of charge.</p>
	 
							<p><small>Video By Basti Hansen<br/>Photo By Guy Yechiely</small></p>
	 
						 `,
      };
    },
  },
  {
    id: "tel-aviv-ya-habibi-tel-aviv",
    ctg: "lgbtq",
    bgImage: "/posts/bank/tel-aviv-ya-habibi-tel-aviv/1.jpg",
    mobBgImage: "/posts/bank/tel-aviv-ya-habibi-tel-aviv/M.jpg",
    isVid: true,
    vidId: "Bjf9neovBtM",
    title: "TEL AVIV YA HABIBI TEL AVIV",
    smltitle: "",
    html: function() {
      return {
        __html: `
		 
								<p><small>Video By Basti Hansen<br/>Photo By Guy Yechiely</small></p>
		 
							 `,
      };
    },
  },
  {
    id: "pride-parade-2017",
    ctg: "lgbtq",
    bgImage: "/posts/bank/pride-parade-2017/1.jpg",
    mobBgImage: "/posts/bank/pride-parade-2017/M.jpg",
    isVid: true,
    vidId: "PtyoZ9V4h74",
    title: "PRIDE PARADE 2017",
    smltitle: "",
    html: function() {
      return {
        __html: `
									<h3>GAY PRIDE PARADE TEL AVIV</h3>
		
									<p>Tel Aviv, one of the most celebrated gay capitals in the world is famous for its round the clock energy and extravagant nonstop parties, but by far one of the biggest events in this city are the Gay Pride Week festivities culminating in the amazing Friday Pride Parade.</p>

									<p>The parade, a tradition which began as early as 1998 is an exciting and moving festivity of Gay Pride, drawing a huge crowd of like-minded individuals from around the world who come together to celebrate and support freedom and the embracing of all lifestyles and genres in an accepting, open minded and joyous celebration.</p>

									<p>The parade is the highlight of a week of gay pride events which take place around the city and include pride related parties, exhibitions, movie festivals, music concerts and much</p>

									<p>The parade itself takes place along the lively main streets of Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic floats, live music, dance performances and revelers dressed in a colorful festival dress.</p>

									<p>The parade culminates at the stunning TA boardwalk by the shores of the beautiful Mediterranean where it turns into an awesome adrenaline-charged beach party featuring leading DJs and live performances and lasting well into the small hours of the night.</p>

									<p>The 2018 parade will take place on June 8th 2018 and participation, as always, will be completely free of charge.</p>
			 
									<p><small>Video By Basti Hansen<br/>Photo By Guy Yechiely</small></p>
			 
								 `,
      };
    },
  },
  {
    id: "western-galilee-yechiam-cabri",
    ctg: "active-adventure",
    bgImage: "/posts/bank/western-galilee-yechiam-cabri/1.jpg",
    mobBgImage: "/posts/bank/western-galilee-yechiam-cabri/M.jpg",
    isVid: false,
    vidId: "",
    title: "Cycle tour in Western Galilee - Yechiam single and Cabri single",
    smltitle: "",
    html: function() {
      return {
        __html: `
										<p><b>Geographic region:</b> Western Galilee, east of Nahariya</p>

										<p>Western Galilee runs from Rosh Hannikra to the north to the Beit Netofa Valley to the south, and has a diverse landscape consisting of the shore, high hills, streams and natural woodland. Everything is blossoming and green in the spring months.</p>

										<p>This expansive area hosts an enormous range of attractions, particularly for people who like challenging sports, from diverse cycle routes, triathlons, swims of various lengths, foot tours in natural woodland and water sources, along with historical stories from the times of foundation of the State of Israel and the War of Independence.  The whole area is filled with comforting guest houses in the surrounding moshav settlements.</p>

										<p><b>How to arrive:</b> The routes start from the Hashayara (column) parking lot, half a kilometer from Kabri Junction, on Highway 70.</p>

										<p><b>The route:</b></p>

										<p><b>Route length:</b> There are three cycling options:</p>

										<p>Kabri single: 15 km, about 250 meters cumulative climb</p>
										
										<p>Yechiam single: 27 km, about 400 meters cumulative climb</p>
										
										<p>Yechiam and Kabri combined: 42 km</p>

										<p><b>Difficulty leve:</b> Medium</p>

										<p>Recommended cycling seasons: Summer, autumn, spring, in the winter it is advisable to check on rainfall before departing, as the route may be muddy and slippery, and if the Gaaton River is flowing, the culvert on the river cannot be crossed.</p>

										<p>Cycling type: Circular, trails and singles running in forests and natural woodland.</p>

										<p><b>Ascents:</b> Kabri single only approximately 250 meters cumulative climb. Yechiam single only approximately 400 meters</p>

										<p><b>Route is suitable for:</b> Suitable for experienced cyclists</p>

										<p><b>Technical level:</b> Medium</p>

										<p><b>Physical difficulty level: </b>Medium</p>

										<p><b>Family attractions in the area: </b> The Achziv swim that is held each year in March (it is worth checking to make sure) from the Banana Beach in Achziv to a range of distances, rental of bicycles and tour routes for the whole family in the Nahariya area, visit to the impressive caves in Rosh Hanikra, traditional Druze hosting in Jat, a learning center on making olive oil and hands on workshops, a visit to a local beer brewery.</p>

										<p><b>Description of the Yechiam single route:</b></p>

										<p>The Kabri and Yechiam routes are both started from the Hashayara parking lot, a parking lot in memory of the Yechiam column that departed from Nahariya for Kibbutz Yechiam on March 27, 1948, in Israel’s War of Independence, which was attacked en route, resulting in 47 soldiers being killed. Today, the remains of the armored vehicles from that incident may be seen.</p>

										<p>The cycling begins on a convenient jeep trail along Wadi Gaaton. At a certain stage, one enters the river bed and rides along it, and as one progresses the landscape becomes prettier. One crosses a culvert and passes the Gaaton ruins, a place that was owned by a rich Lebanese family. After the rain, there are running springs at this site. You climb up a difficult stretch that passes on a trail of arbutus trees, which have a brown-reddish trunk and blossom in the spring with crème colored blossom, which and are the subject of many popular legends. At the end of the climb, it is advisable to stop to enjoy the unique landscape and surrounding woodland.</p>

										<p>The route combines white paths and four pretty, challenging and enjoyable single stretches.</p>
				 
									 `,
      };
    },
  },
  {
    id: "israel-national-trail",
    ctg: "active-adventure",
    bgImage: "/posts/bank/israel-national-trail/1.jpg",
    mobBgImage: "/posts/bank/israel-national-trail/M.jpg",
    isVid: false,
    vidId: "",
    title: "ISRAEL NATIONAL TRAIL",
    smltitle: "",
    html: function() {
      return {
        __html: `
											<p>Named one of the "holy grails of hikes.", Israel’s national trail is placed among the top 20 epic hikes in the world and is a renowned attraction among the international hikers community. </p>
	
											<p>Inaugurated in 1995, the Israel National Trail (INT) is a 620-mile (1,009 km) trail that crosses the entire country from North to South. Hikers on the INT experience an amazing variety of natural and human landscapes, exposing them to Israel's many eco-systems and habitats.</p>
	
											<p>The most common way to hike the INT is <b>North to South</b>. The northern part, while beautiful and exciting is at an easier level, allowing beginners a better chance to get in shape for the long trail, acclimatize and adjust to the trail life. This of course depends on the time of year you set out as it is better to try and avoid reaching the southern desert in the hottest months of the summer season.</p>
	
											<p>Hiking Seasons</p>
	
											<p>It is recommended to hike in the INT during two main seasons - from mid-February and mid-May, and from September until December. The summer (mid-May to late August) is too hot to walk on the path, while during the winter months (late December-January) it can often be rainy and too cold for an enjoyable experience.</p>
	
											<p><b>Trail Angels</b></p>
	
											<p><u><b>Part 1 – Tel Dan to the Roaring Lion Monument</b></u></p>
											
											<p><b>Distance:</b> 13.5 km</p>
											
											<p><b>Water along the trail:</b></p>

											<p>At starting point<br/>Hatzbani Stream<br/>Snir Stream – inside the nature reserve (admission fee required)<br/>Gas station near Snir Bridge<br/>End point (Tel Chai monument)</p>

											<p><b>Trail Angels:</b> Kibbutz Dan</p>

											<p><b>Description:</b></p>

											<p>The trail begins at the Beit Ussishkin Museum in Kibbutz Dan, located in the northern Hula Valley below the Dan River. At the museum, you can learn about wildlife and nature in the Hula Valley and Upper Galilee region, and gaze northward towards Mount Hermon.</bp>

											<p>The trail passes nearby the Dan Nature Reserve (the Israel Trail intentionally bypasses nature reserves and national parks). At the observation point, facing north, you'll see the impressive Nimrod Fortress just straight ahead. Nimrod Fortress is a 13th century Muslim fortress strategically located on the route to Damascus, 800 meters above sea level. From the observation point, you can also see Mount Hermon, Israel's highest mountain, rising 2,814 meters above sea level and situated on Israel's border with Lebanon and Syria. The highest peak of the mountain is within Israel's borders and is 3,236 meters high. In the winter, the entire region is blanketed in snow and the Hermon becomes a ski resort and winter tourism site. The trail runs through the valley where the Israel-Syria border meets the Lebanon border.</bp>

											<p>The trail continues to the Snir Nature Reserve (Hatzbani), the only site along the trail where admission is charged. Hiking alongside the rushing stream is a very enjoyable experience. The air is cool and the platanus trees growing on the banks of the stream offer plenty of shade. As tempting as it may be, bathing in the stream is forbidden. Not far away is a fish restaurant, which you may even be able to smell from the nature reserve. The trail continues alongside the road past Kibbutz Maayan Baruch toward the Yuval village.</bp>

											<p>From there, cross the bridge over Nahal Ayun, a river that flows all year round. In the winter and spring, the area is covered in colorful wildflowers, including irises, anemones, cyclamens and lilies. The trail then continues towards Kibbutz Kfar Hagiladi and ends at the Roaring Lion monument. The monument was erected in memory of the eight pioneers who gave their lives while defending the land, including Joseph Trumpeldor, a national hero.</bp>

											<p><u><b>Part 2- Tel Chai to Koach Fort</b></u></p>

											<p><b>Distance:</b> Approximately 18 km</p>

											<p><b>Water along the trail:</b></p>

											<p>Starting point (Tel Chai Roaring Lion monument)</p>

											<p>Mishkenot Haroim – water tank located inside the ranch (follow signs from the trail)</p>

											<p>Yesha (Koach) Fort – end point, in the park</p>

											<p><b>Trail Angels:</b> Mishkenot Haroim. If the water tank is empty or any assistance is required along the way, contact Chanaya – 050-5272422</p>

											<p>Ramot Naftali – luxury guest room for hikers, free of charge</p>

											<p>There is an option of volunteering in the ecological farm in exchange for full board and classes.</p>

											<p>Shimon Osher – 050-7379218</p>

											<p><b>Description:</b></p>

											<p>The trail begins at the Roaring Lion monument which was erected in memory of the fallen warriors in the battle for Tel Chai. One of these warriors was Joseph Trumpeldor, a national hero. The trail then continues towards route 9977, crosses the road and heads eastward for about 200 meters along a leveled trail. Before reaching the Tel Chai College, turn onto a short trail and head down to a path dotted with statues. Turn right to continue west. This area belongs to the Tel Chai statue park, where artists create their works of art on site and leave them there for the public to enjoy.</p>

											<p>After leaving the park, the route bends leftward towards a trail marked with green markers, through forests planned by the JNF. The next stop along the way is Ein Roim, a nice picnic area that is a perfect place for breakfast and a cup of coffee. When you're ready to move on, follow the gently sloped trail heading downhill to the south. After about three kilometers, you'll notice several Juda's trees that bloom with glorious purple flowers between February and April. The trail then heads right.</p>

											<p>You are now standing below the Ramim mountain ridge, about 2 kilometers from Kiryat Shemona. At this point, you can choose how to proceed. The first option is to head south on the Israel Trail. The second is to turn left and hike down to Kiryat Shemona, and the third is leave the trail, and head right to visit the Ramim ridge, then turn back to continue on the Israel Trail.</p>

											<p>We recommend leaving the trail for a closer view of the Ramim mountain ridge, despite the steep ascent. Along this 2 km trail are signs with explanations about the region. Looking down, you'll see the Hula Valley which was formed some four-million years ago as part of the Great Rift Valley. The cliff on which you are standing was also formed by the Great Rift, and ancient geological layers can be observed, one above another. You'll pass by 12 different signs, each describing a different geological era. You will also see fossil remains of fish and reptiles embedded in the stone, proving that the entire region was once beneath the sea.</p>

											<p>Hike back to the trail and leave the green trail after about two kilometers, and continue along the blue trail which leads to Yesha Junction. At this point, the trail passes through the Nahal Kadesh nature reserve. Enjoy the beautiful, lush vegetation along the trail, and the breathtaking Hula Valley landscape below.</p>

											<p>After about two kilometers, you'll reach the Lipa Gal observation point, named for a JNF employee and nature lover. Sit down on the bench and relax for a few minutes while you enjoy the pleasant breeze and lovely view of the Hula region and surrounding mountains.</p>

											<p>Next, walk through the canyons of Nahal Kadesh, where you may catch a glimpse of the rock badgers that live there, if you're lucky. Be careful in the winter and spring when the rocks are slippery. Turn into the southern tributary, climb out of the river channel, and cross the fence surrounding Yesha Fort to reach the entrance.</p>

											<p>The fort marks the end of this trail and is one of the five forts built by the British Mandate that ruled the region until the State of Israel was established in 1948. It is an excellent observation point that offers strategic control of the entire region and the main highways. Today, the fort serves as an army base.</p>

											<p><u><b>Part 3- Yesha (koach) Fort to Nachal Dishon</b></u></p>

											<p><b>Distance: 20 km</b></p>

											<p><b>Water along the trail:</b> At Nahal Dishon before reaching the road, Ein Aviv – a Mekorot site. The faucet is located to the left of the entrance to the site.</p>

											<p><b>Trail Angels:</b> Kibbutz Yiron – accommodations in rooms equipped with refrigerators, microwaves, showers and more for only 10 NIS. Sleeping on the public kibbutz lawns is prohibited.</p>

											<p><b>Description:</b></p>

											<p>After the trail leaves Yesha Fort, it passes by the ruins of Nebi Yusha located south of the fort. This is a holy site for the Muslims who believe it to be the burial site of the biblical Joshua. Muslims believe that visiting this grave brings health, fertility and marriage. This is an excellent place to stop for breakfast. From Nebi Yusha, follow the Israel Trail for about two kilometers until you see the green trail marker. Follow the dirt road through the thicket towards Keren Naftali Mountain. The 500 meter climb is steep but well worth the effort. This is the highest observation point in the region; it is a triangulation point, meaning it is the highest point to have been surveyed and marked. When creating a trig point, the idea is for two additional trig points to be visible from each so that surveyors can calculate their precise location by measuring their distance from each of the three points. Keren Naftali Mountain offers an excellent opportunity to see what a trig point actually looks like. You’ll see three metal poles with an iron triangle welded to them.</p>

											<p>At Keren Naftali, you’ll find the ruins of a Hellenistic temple from the Roman era. Lovely Atlantic terebinth trees grow among the ruins. There is a mosaic at the site and several burial caves have been carved into the stone. You’ll also enjoy a breathtaking view of the entire Hula Valley, Golan Heights, Hermon Mountain and the Upper Galilee.</p>

											<p>From there, follow the trail towards Nahal Dishon. The river channel is brimming with lush Mediterranean vegetation, including oak, terebinth, birch, carob, olive, and Judas trees. At this point, the trail is marked in red. The cliff to the side of the trail is a nesting site for birds of prey and in the spring, the region blooms with orchids and irises.</p>

											<p>Note that during the winter months, the river channel may be full of water.</p>

											<p>As you hike along Nahal Dishon, you’ll see Ein Aviv, a spring from which water is currently pumped. In November, the saffron flowers blossom approximately 150 meters along the trail past Ein Aviv. In the wadi just past Ein Aviv, you’ll find the ruins of windmills that were once operated by the river and serve as living proof of the water that once flowed through the Dishon.</p>

											<p>After hiking two kilometers further through the river bed, you’ll see a shape on the mountain to your left that resembles a rhinoceros’ horn. This means that you’ve nearly reached the end of the trail. When you reach the area below the horn, you’ll see the entrance to the Dishon cave above you. The trail ends at route 899. </p>
	
											<p><u><b>Part 4 - Nachal Dishon to Mount Meron</b></u></p>
	
											<p><b>Distance: 14 km</b></p>
 
											<p><b>Water along the trail:</b> There is water available at the Mount Meron Field School (Rashbi’s grave), and at the gas station at Meron junction (500 meters off of the trail).</p>
											
											<p><b>Trail angels:</b> Mount Meron Field School, the “pipe” at Nahal Zivon</p>
											
											<p><b>Camping:</b> Pisga camp site</p>
											
											<p><b>Description:</b></p>
											
											<p>The trail begins alongside route 899, ascending south from Avivim junction towards Yiron and Avivim. One kilometer north of the junction is a wooden sign indicating the entrance to the Nahal Dishon nature reserve. Follow the wide dirt trail alongside the road and Nahal Dishon. Between mid-October and mid-November, the saffron flower blooms along the slopes of Puah Mountain (visible on your left, to the southwest). The saffron is a beautiful flower from the iris family. It has a lovely orange-yellow hue that resembles an egg yolk. If you visit the region during this month, look for this wildflower. Continue to follow the trail and cross the road to its southern side. After about three kilometers, the trial turns left and passes by Ein Aravot. Years ago, bathing in the spring was permitted, but today it is fenced off. Walk around the fence to reach the south side of the road. You will now see a red trail marker, indicating the continuation of the trail. The trail crosses Nahal Dishon several times, making it a rather wet experience in the wintertime. Several hundred meters after Nahal Dishon connects with Nahal Gush Halav, you’ll reach a cattle fence. Follow the trail for another 300 meters to enter the Bara’am Forest nature reserve, leading into a small grove of terebinth trees, which is a wonderful place for a picnic breakfast and a cup of coffee.</p>
											 
											
											<p>Follow the red trail and when Nahal Zivon meets Nahal Dishon, bear right to reach Nahal Zivon. This is one of the loveliest portions of the Israel Trail. The shade of the large trees growing alongside the stream and the moss-covered stones make the trail pleasant and cool. The roots of the trees form stairs to help you climb up the river channel. The trail leads to a clearing and intersects with a trail marked in black. Turn left and continue following the red trail. At this point, the Meron mountain ridge, one of the highest peaks in Israel, becomes visible, rising 1,208 meters above sea level. There is a trail leading around the peak of the mountain, offering glorious views of the Upper Galilee. Several holy Jewish and Druze sites are located at the foot of the mountain. The trail leads to route 89. Cross the road and look for the trail markers on the other side. Continue to follow the red trail until you reach the Israel Trail marker once again. This will take you up the mountain, through an oak tree grove and towards the Mount Meron Field School. Follow the trail to the Hamama ruins, where a black trail begins and leads to the peak of Mount Meron.</p>
											 
											
											<p>Water is available near the ruins of Hamama. From here on, you will be following the black trail markers along an uphill trail. It is not very steep and there are plenty of places to stop along the way and rest in the shade. The vegetation along the trail is dense and includes terebinth, oak and occasionally even red-trunked arbutus trees. You’ll pass by the Neriya observation point which features a well-marked sign that explains exactly what you are looking at. From there, you can see the Nahal Dishon channel, Kibbutz Sasa, the Golan Heights, the villages on the northbound road, and a large portion of the trail that you have just hiked. The black markers on the trail meet up with the red trail markers and there are now two options. You can turn right, leave the Israel Trail and hike down a short but steep trail leading to the end of the route, or you can turn left towards the trail along the Meron mountaintop, circle the mountain and add an extra half-hour to your hike. The trail ends at the Pisga camp site.</p>
					 
										 `,
      };
    },
  },
  {
    id: "israel-national-trail-part-2-tel-chai-to-koach-fort",
    ctg: "active-adventure",
    bgImage:
      "/posts/bank/israel-national-trail-part-2-tel-chai-to-koach-fort/1.jpg",
    mobBgImage:
      "/posts/bank/israel-national-trail-part-2-tel-chai-to-koach-fort/M.jpg",
    isVid: false,
    vidId: "",
    title: "Israel National Trail Part 2- Tel Chai to Koach Fort",
    smltitle: "",
    html: function() {
      return {
        __html: `

											<p><b>Distance: Approximately 18 km</b></p>

											<p><b>Water along the trail:</b><br/>
											Starting point (Tel Chai Roaring Lion monument)<br/>
											Mishkenot Haroim – water tank located inside the ranch (follow signs from the trail)<br/>
											Yesha (Koach) Fort – end point, in the park</p>
											
											<p><b>Trail Angels:</b> Mishkenot Haroim. If the water tank is empty or any assistance is required along the way, contact Chanaya – 050-5272422</p>
											
											<p>Ramot Naftali – luxury guest room for hikers, free of charge</p>
											
											<p>There is an option of volunteering in the ecological farm in exchange for full board and classes.<br/>
											Shimon Osher – 050-7379218</p>
											
											<p><b>Description:</b></p>
											
											<p>The trail begins at the Roaring Lion monument which was erected in memory of the fallen warriors in the battle for Tel Chai. One of these warriors was Joseph Trumpeldor, a national hero. The trail then continues towards route 9977, crosses the road and heads eastward for about 200 meters along a leveled trail. Before reaching the Tel Chai College, turn onto a short trail and head down to a path dotted with statues. Turn right to continue west. This area belongs to the Tel Chai statue park, where artists create their works of art on site and leave them there for the public to enjoy.</p>
											
											<p>After leaving the park, the route bends leftward towards a trail marked with green markers, through forests planned by the JNF. The next stop along the way is Ein Roim, a nice picnic area that is a perfect place for breakfast and a cup of coffee. When you're ready to move on, follow the gently sloped trail heading downhill to the south. After about three kilometers, you'll notice several Juda's trees that bloom with glorious purple flowers between February and April. The trail then heads right.</p>
											
											<p>You are now standing below the Ramim mountain ridge, about 2 kilometers from Kiryat Shemona. At this point, you can choose how to proceed. The first option is to head south on the Israel Trail. The second is to turn left and hike down to Kiryat Shemona, and the third is leave the trail, and head right to visit the Ramim ridge, then turn back to continue on the Israel Trail.</p>
											
											<p>We recommend leaving the trail for a closer view of the Ramim mountain ridge, despite the steep ascent. Along this 2 km trail are signs with explanations about the region. Looking down, you'll see the Hula Valley which was formed some four-million years ago as part of the Great Rift Valley. The cliff on which you are standing was also formed by the Great Rift, and ancient geological layers can be observed, one above another. You'll pass by 12 different signs, each describing a different geological era. You will also see fossil remains of fish and reptiles embedded in the stone, proving that the entire region was once beneath the sea.</p>
											
											<p>Hike back to the trail and leave the green trail after about two kilometers, and continue along the blue trail which leads to Yesha Junction. At this point, the trail passes through the Nahal Kadesh nature reserve. Enjoy the beautiful, lush vegetation along the trail, and the breathtaking Hula Valley landscape below.</p>
											
											<p>After about two kilometers, you'll reach the Lipa Gal observation point, named for a JNF employee and nature lover. Sit down on the bench and relax for a few minutes while you enjoy the pleasant breeze and lovely view of the Hula region and surrounding mountains.</p>
											
											<p>Next, walk through the canyons of Nahal Kadesh, where you may catch a glimpse of the rock badgers that live there, if you're lucky. Be careful in the winter and spring when the rocks are slippery. Turn into the southern tributary, climb out of the river channel, and cross the fence surrounding Yesha Fort to reach the entrance.</p>
											
											<p>The fort marks the end of this trail and is one of the five forts built by the British Mandate that ruled the region until the State of Israel was established in 1948. It is an excellent observation point that offers strategic control of the entire region and the main highways. Today, the fort serves as an army base.</p>
										 `,
      };
    },
  },
  {
    id: "israel-national-trail-part-3-yesha-fort-to-nachal-dishon",
    ctg: "active-adventure",
    bgImage:
      "/posts/bank/israel-national-trail-part-3-yesha-fort-to-nachal-dishon/1.jpg",
    mobBgImage:
      "/posts/bank/israel-national-trail-part-3-yesha-fort-to-nachal-dishon/M.jpg",
    isVid: false,
    vidId: "",
    title: "Israel National Trail Part 3- Yesha (koach) Fort to Nachal Dishon",
    smltitle: "",
    html: function() {
      return {
        __html: `

									 			<p><u>Segment 3 – Yesha (Koach) Fort to Nahal Dishon</u></p>
	
												<p><b>Distance: 20 km</b></p>
	
												<p><b>Water along the trail:</b><br/>
												At Nahal Dishon before reaching the road, Ein Aviv – a Mekorot site. The faucet is located to the left of the entrance to the site.</p>
												
												<p><b>Trail Angels:</b> Kibbutz Yiron – accommodations in rooms equipped with refrigerators, microwaves, showers and more for only 10 NIS. Sleeping on the public kibbutz lawns is prohibited.</p>
												
												<p><b>Description:</b></p>
												
												<p>After the trail leaves Yesha Fort, it passes by the ruins of Nebi Yusha located south of the fort. This is a holy site for the Muslims who believe it to be the burial site of the biblical Joshua. Muslims believe that visiting this grave brings health, fertility and marriage. This is an excellent place to stop for breakfast. From Nebi Yusha, follow the Israel Trail for about two kilometers until you see the green trail marker. Follow the dirt road through the thicket towards Keren Naftali Mountain. The 500 meter climb is steep but well worth the effort. This is the highest observation point in the region; it is a triangulation point, meaning it is the highest point to have been surveyed and marked. When creating a trig point, the idea is for two additional trig points to be visible from each so that surveyors can calculate their precise location by measuring their distance from each of the three points. Keren Naftali Mountain offers an excellent opportunity to see what a trig point actually looks like. You’ll see three metal poles with an iron triangle welded to them.</p>
												
												<p>At Keren Naftali, you’ll find the ruins of a Hellenistic temple from the Roman era. Lovely Atlantic terebinth trees grow among the ruins. There is a mosaic at the site and several burial caves have been carved into the stone. You’ll also enjoy a breathtaking view of the entire Hula Valley, Golan Heights, Hermon Mountain and the Upper Galilee.</p>
												
												<p>From there, follow the trail towards Nahal Dishon. The river channel is brimming with lush Mediterranean vegetation, including oak, terebinth, birch, carob, olive, and Judas trees. At this point, the trail is marked in red. The cliff to the side of the trail is a nesting site for birds of prey and in the spring, the region blooms with orchids and irises.</p>
												
												<p>Note that during the winter months, the river channel may be full of water.</p>
												
												<p>As you hike along Nahal Dishon, you’ll see Ein Aviv, a spring from which water is currently pumped. In November, the saffron flowers blossom approximately 150 meters along the trail past Ein Aviv. In the wadi just past Ein Aviv, you’ll find the ruins of windmills that were once operated by the river and serve as living proof of the water that once flowed through the Dishon.</p>
												
												<p>After hiking two kilometers further through the river bed, you’ll see a shape on the mountain to your left that resembles a rhinoceros’ horn. This means that you’ve nearly reached the end of the trail. When you reach the area below the horn, you’ll see the entrance to the Dishon cave above you. The trail ends at route 899.</p>
												
											 `,
      };
    },
  },
  {
    id: "israel-national-trail-part-4-nachal-dishon-to-mount-meron",
    ctg: "active-adventure",
    bgImage:
      "/posts/bank/israel-national-trail-part-4-nachal-dishon-to-mount-meron/1.jpg",
    mobBgImage:
      "/posts/bank/israel-national-trail-part-4-nachal-dishon-to-mount-meron/M.jpg",
    isVid: false,
    vidId: "",
    title: "Israel National Trail Part 4- Nachal Dishon to Mount Meron",
    smltitle: "",
    html: function() {
      return {
        __html: `

										 			<p><u>Segement 4 – Nahal Dishon to Mount Meron</u></p>
		
													<p><b>Distance: 14 km</b></p>
		
													<p><b>Water along the trail:</b><br/>
													There is water available at the Mount Meron Field School (Rashbi’s grave), and at the gas station at Meron junction (500 meters off of the trail).</p>
													
													<p><b>Trail Angels:</b> Mount Meron Field School, the “pipe” at Nahal Zivon.</p>

													<p><b>Camping:</b> Pisga camp site.</p>
													
													<p><b>Description:</b></p>
													
													<p>The trail begins alongside route 899, ascending south from Avivim junction towards Yiron and Avivim. One kilometer north of the junction is a wooden sign indicating the entrance to the Nahal Dishon nature reserve. Follow the wide dirt trail alongside the road and Nahal Dishon.</p>
													
													<p>Between mid-October and mid-November, the saffron flower blooms along the slopes of Puah Mountain (visible on your left, to the southwest). The saffron is a beautiful flower from the iris family. It has a lovely orange-yellow hue that resembles an egg yolk. If you visit the region during this month, look for this wildflower. Continue to follow the trail and cross the road to its southern side. After about three kilometers, the trial turns left and passes by Ein Aravot. Years ago, bathing in the spring was permitted, but today it is fenced off. Walk around the fence to reach the south side of the road. You will now see a red trail marker, indicating the continuation of the trail. The trail crosses Nahal Dishon several times, making it a rather wet experience in the wintertime. Several hundred meters after Nahal Dishon connects with Nahal Gush Halav, you’ll reach a cattle fence. Follow the trail for another 300 meters to enter the Bara’am Forest nature reserve, leading into a small grove of terebinth trees, which is a wonderful place for a picnic breakfast and a cup of coffee.</p>
													
													<p>Follow the red trail and when Nahal Zivon meets Nahal Dishon, bear right to reach Nahal Zivon. This is one of the loveliest portions of the Israel Trail. The shade of the large trees growing alongside the stream and the moss-covered stones make the trail pleasant and cool. The roots of the trees form stairs to help you climb up the river channel. The trail leads to a clearing and intersects with a trail marked in black. Turn left and continue following the red trail. At this point, the Meron mountain ridge, one of the highest peaks in Israel, becomes visible, rising 1,208 meters above sea level. There is a trail leading around the peak of the mountain, offering glorious views of the Upper Galilee. Several holy Jewish and Druze sites are located at the foot of the mountain. The trail leads to route 89. Cross the road and look for the trail markers on the other side. Continue to follow the red trail until you reach the Israel Trail marker once again. This will take you up the mountain, through an oak tree grove and towards the Mount Meron Field School. Follow the trail to the Hamama ruins, where a black trail begins and leads to the peak of Mount Meron.</p>
													
													<p>Water is available near the ruins of Hamama. From here on, you will be following the black trail markers along an uphill trail. It is not very steep and there are plenty of places to stop along the way and rest in the shade. The vegetation along the trail is dense and includes terebinth, oak and occasionally even red-trunked arbutus trees. You’ll pass by the Neriya observation point which features a well-marked sign that explains exactly what you are looking at. From there, you can see the Nahal Dishon channel, Kibbutz Sasa, the Golan Heights, the villages on the northbound road, and a large portion of the trail that you have just hiked. The black markers on the trail meet up with the red trail markers and there are now two options. You can turn right, leave the Israel Trail and hike down a short but steep trail leading to the end of the route, or you can turn left towards the trail along the Meron mountaintop, circle the mountain and add an extra half-hour to your hike. The trail ends at the Pisga camp site.</p>
													
												 `,
      };
    },
  },

  {
    id: "Privacy_Policy",
    ctg: "telaviv",
    bgImage: "/HomeSlider/desktop/1.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "PRIVACY POLICY",
    smltitle: "",
    html: function() {
      return {
        __html: `


								<p><u><span>Last updated</span></u><span>: March 4, 2020</span></p>
								
								<h3><span>OUR COMMITMENT TO YOU</span><span>  </span></h3>
								<p>We, at  The Israeli government, the Ministry of Tourism ("<strong>us</strong>", "<strong>we</strong>" or the<strong>  "Ministry</strong>") respect the privacy of our users (each, a "<strong>User</strong>" or "<strong>you</strong>") and are committed to protect the privacy of Users who access, download, install, register, use or engage with our website, our mobile application(s), and any other service we provide (the<strong>  </strong>"<strong>Website</strong>" and "<strong>App</strong>" respectively, and collectively the "<strong>Service(s)</strong>").   </p>
								<p>We've prepared this Privacy Policy to outline our practices with respect to collecting, using and disclosing your information when you use the Services. We encourage you to read this Privacy Policy carefully and use it to make informed decisions. By using the Services, you agree to the terms of this Privacy Policy and your continued use of the Services constitutes your ongoing agreement to the Privacy Policy.</p>
								
								<h3><span>CONTENTS</span></h3>
								<p>
								  <a href="#Grounds" style="color:#000">GROUNDS FOR DATA COLLECTION<span>..  </span><span>1</span></a><br/>

								  <a href="#WhatType" style="color:#000">WHAT TYPE OF DATA WE COLLECT?<span>.  </span><span>2</span></a><br/>

								  <a href="#HowDoWeUse" style="color:#000">HOW DO WE USE THE DATA WE COLLECT?<span>.  </span><span>2</span></a><br/>

								  <a href="#Tracking" style="color:#000">TRACKING TECHNOLOGIES<span>.  </span><span>3</span></a><br/>

								  <a href="#WitWhom" style="color:#000">WITH WHOM DO WE SHARE YOUR PERSONAL DATA?<span>.  </span><span>6</span></a><br/>

								  <a href="#HowWeProtect" style="color:#000">HOW WE PROTECT YOUR INFORMATION<span>..  </span><span>6</span></a><br/>

								  <a href="#Retention" style="color:#000">RETENTION<span>..  </span><span>7</span></a><br/>

								  <a href="#UserRigths" style="color:#000">USER RIGHTS<span>.  </span><span>7</span></a><br/>

								  <a href="#Transfer" style="color:#000">TRANSFER OF DATA OUTSIDE THE EEA<span>..  </span><span>8</span></a><br/>

								  <a href="#OurPolicy" style="color:#000">OUR POLICY TOWARD CHILDREN<span>..  </span><span>8</span></a><br/>

								  <a href="#HowToContactUs" style="color:#000">HOW TO CONTACT US?<span>.  </span><span>8</span></a><br/>

								  <a href="#Updates" style="color:#000">UPDATES TO THIS POLICY<span>.  </span><span>8</span></a><br/>
								</p>

								
								<h3 id="Grounds"><span>GROUNDS FOR DATA COLLECTION</span><span>  </span></h3>
								<p><span>Processing of your “<strong>Personal Data</strong>” (meaning any information which may potentially allow your identification, either directly or by using reasonable means) is necessary for the performance of our contractual obligations towards you, for providing you with our Services and the operation of our Website, to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</span></p>
								<p><span>When you use our Services, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</span></p>
								
								<h3 id="WhatType"><span>WHAT TYPE OF DATA WE COLLECT?</span></h3>
								<h3><span>Personal Data</span></h3>
								<p><span>In the course of using the Services, we may collect certain Personal Data to provide and improve the Services, to contact or identify you, to enable you to access certain parts of the Service</span><span>  or as otherwise indicated in this Policy. We collect the following Personal Data about you</span><span>:</span></p>
								<ul style="list-style-type: disc;margin-left:0in;">
								  <li><span>When you send us an email  </span><span>or contact us through a contact form on the Website, we will collect your name and email address so we could respond to your inquiry. We may also collect any Personal Data that you choose to include in your inquiry to us.</span></li>
								  <li><span>Our webserver may also automatically collect your IP address, and unique online identifiers. These details are pseudonymized (cannot directly identify you) and are collected for the purpose of delivering relevant content and operating and improving our Service.</span></li>
								</ul>
								<h3><span>Non-Personal Data</span></h3>
								<p><span>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:  </span><span>Your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), your general location (city and country), and general information regarding your browser and device.</span></p>
								<p><span>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data.  </span></p>
								
								<h3 id="HowDoWeUse"><span>HOW DO WE USE THE DATA WE COLLECT?</span></h3>
								<ul>
								  <li><strong><span>Provision of the Service</span></strong><em><span>  –  </span></em><span>we will use the Personal Data you provide us for the provision and improvement of our Service, providing customer support and to respond to your queries.  </span></li>
								  <li><strong><span>Service announcements</span></strong><span>  - we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Service and offer you service offers.</span></li>
								  <li><strong><span>Analytics, surveys and research</span></strong><span>  - from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and offerings, and think of new and exciting features for our users.</span></li>
								  <li><strong><span>Protecting our interests</span></strong><em><span>  -  </span></em><span>we may use your Personal Data when we believe it’s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of the Ministry, its users and/or partners.  </span></li>
								  <li><strong><span>Enforcing of policies</span></strong><span>  - we may use your Personal Data in order to enforce our policies, including but not limited to our <a href="https://goisrael.com/Posts/telaviv/Privacy_Policy" style="text-decoration:underline;color:#000" target="_blank"> Terms </a></span><span style="line-height:115%;font-family:Calibri;font-size:8.0pt;color:windowtext;">
								     
								    </span><span style="line-height:;font-family:Calibri;line-height:;color:windowtext;">.  </span></li>
								  <li><strong><span>Compliance with legal and regulatory requirements</span></strong><span>  - we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</span></li>
								  <li><strong><span>Newsletter</span></strong><span>  - we may use your Personal Data in order to send you our newsletter, if you subscribed to it.   </span>
								    <ol style="list-style-type: circle;">
								      <li><u><span>Opt-out of receiving our newsletter</span></u><span>  - You may choose not to receive our newsletter by clicking on the “unsubscribe” link contained therein. Please note that even if you unsubscribe, we may continue to send you Service-related updates and notifications, or reply to your queries and feedback you provide us.  </span></li>
								    </ol>
								  </li>
								</ul>
								
								<h3 id="Tracking"><span>TRACKING TECHNOLOGIES</span></h3>
								<p><span>When you visit or access our Services we use (and authorize 3<sup>rd</sup> parties to use) pixels, cookies, events and other technologies (collectively, "<strong>Tracking Technologies</strong>"). Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Services’ performance, perform analytics and customize your experience. In addition, we may merge data we have with data collected through these tracking technologies and data we may obtain from other sources and, as a result, such data may become Personal Data.</span></p>
								<p>If you do not accept the use of cookies by us, please disable cookies by following the instructions below. However, please note that disabling cookies might seriously affect the function, User experience and other features of our Services.</p>
								<h3>Types of Tracking Technologies We Use</h3>
								<p>There are two broad categories of cookies: (a) <strong>First party cookies</strong>, served directly by us to your computer or mobile device, and (b) <strong>Third party cookies</strong>, served by a third party. We use third party cookies for functionality, performance and analytics, and social media purposes.</p>
								<p>Cookies can remain on your computer or mobile device for different periods of time. Some cookies are "session cookies" and expires upon closing of your browser. Other cookies are "persistent cookies", meaning that they survive after your browser is closed. They can be used by websites to recognize your computer when you open your browser and browse the Internet again.</p>
								<p>For example, we use a performance tracking technology tool called “<strong>Google Analytics</strong>” to collect information about the use of the Website. Google Analytics collects information such as how often users visit this site, what pages they visit when they do so, and what other sites they used prior to coming to this Site. We use the information we get from Google Analytics to maintain and improve the Site and our products. We do not combine the information collected through the use of Google Analytics with personally identifiable information. Google’s ability to use and share information collected by Google Analytics about your visits to this Site is restricted by the Google Analytics Terms of Service, available at 
								  <a href="http://www.google.com/analytics/terms/us.html" target="_blank" style="text-decoration:underline;color:#000">www.google.com/analytics/</a>, and the Google Privacy Policy, available at 
								  <a href="http://www.google.com/policies/privacy/" target="_blank" style="text-decoration:underline;color:#000">www.google.com/policies/</a>. You can opt-out of Google's collection of Personal Data through Google Analytics by downloading and installing the Google Analytics Opt-out Browser Add-on, available at 
								  <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" style="text-decoration:underline;color:#000">tools.google.com/dlpage/gaoptout</a>.
								</p>
								<h3><span>Interest-Based Advertising &amp; User Choice</span></h3>
								<p>Through our Services, we may display advertisements that are tailored to you, for example ads or partner services that are based on your recent browsing behavior. In order to tailor advertisements and services in which you might be interested, we as well as certain third parties may use Tracking Technologies to display advertisements based on your visits to the Websites, to target advertisements to you for products and services in which you might be interested, and to measure the effectiveness of the ads. You can turn off certain third party Tracking Technologies used for behavioral advertising purposes by visiting the Network Advertising Initiative  or by visiting the  DAA opt-out program  or the  EDAA consumer choice page  (if you reside in the EU) using the links provided below. Please note that certain Tracking Technologies operate at the device and browser level, so to fully opt-out across devices, you will need to do so on each device and browser individually, as described below as well.</p>
								<h3><span>How to Manage Your Tracking Technologies Settings</span></h3>
								<p>There are various ways in which you can manage and control your Tracking Technologies settings. Please remember that, by deleting or blocking Tracking Technologies, some of the features of the Services may not work properly or as effectively.</p>
								<p style="margin-bottom:6.0pt;"><strong>Turning off cookies via your web browser
								    <br>  
								  </strong>Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device. Information about cookies is usually found in the "Help" section of the web browser. Below are some links to some commonly used web browsers:</p>
								<p>
								  <a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank" style="text-decoration:underline;color:#000"><span>Google Chrome</span></a><br/>

								  <a href="https://support.microsoft.com/en-us/kb/260971" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Explorer</span></a><br/>

								  <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" style="text-decoration:underline;color:#000"><span>Mozilla Firefox</span></a><br/>

								  <a href="https://support.apple.com/kb/PH5042?locale=en_US" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Desktop)</span></a><br/>

								  <a href="https://support.apple.com/en-us/HT201265" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Mobile)</span></a><br/>

								  <a href="http://support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067" target="_blank" style="text-decoration:underline;color:#000"><span>Android Browser</span></a><br/>

								  <a href="http://www.opera.com/help" target="_blank" style="text-decoration:underline;color:#000"><span>Opera</span></a><br/>

								  <a href="http://www.opera.com/help/mobile/android#privacy" target="_blank" style="text-decoration:underline;color:#000"><span>Opera Mobile</span></a>
								</p>
								<p>For other browsers, please consult the documentation that your browser manufacturer provides.</p>
								<p style="margin-bottom:6.0pt;"><strong>Turning off third party cookies
								    <br>  
								  </strong>You can turn off certain third party targeting/advertising cookies by visiting the following link:  
								  <a href="http://www.networkadvertising.org/choices/" target="_blank" style="text-decoration:underline;color:#000">Network Advertising Initiative</a>.
								</p>
								<h3><span>Other helpful resources</span></strong><br/>
								<span>To learn more about advertisers’ use of cookies the following links may be helpful:</span><br/>
								  <a href="http://www.youronlinechoices.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>European Interactive Digital Advertising Alliance (EU)</span></a><br/>

								  <a href="http://www.iab.net/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (US)</span></a><br/>

								  <a href="http://www.iabeurope.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (EU)</span></a>
								</p>
								<p style="margin-top:6.0pt;margin-right:0in;margin-bottom:.0001pt;margin-left:0in;text-align:justify;"><strong>Turning off cookies on a mobile device</h3>
								<p>You can-opt out of certain types of interest-based advertising, by accessing the “settings” on your device:</p>
								<ul style="list-style-type: disc;margin-left:undefined;">
								  <li><strong><span>If you're using an Apple device</span></strong><span>  you can configure your device to limit ad tracking to by clicking on "settings" &gt; "privacy" &gt; "advertising" and toggling "limit ad tracking" to ‘on.’</span></li>
								  <li><strong><span>If you're using an Android device</span></strong><span>  you can opt out of most app-based tracking for advertising by opening the "Google Settings" app on your device, selecting "Ads", and then selecting the option to opt-out of interest-based ads.</span></li>
								</ul>
								<p>Please note that the above information may change when manufacturers update their systems. Also note, that your device may use another platform, not described above. In that case, please consult the manufacturer documentation for further instructions.</p>
								
								<h3 id="WitWhom"><span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span></h3>
								<ul>
								  <li><strong><span>Internal concerned parties</span></strong><span>  - we may share your information with other</span><span style="color:windowtext;">  </span><span>government ministries, as well as our employees, as needed to provide our Services.</span></li>
								  <li><strong><span>Business partners</span></strong><span>  - we may share your information with business partners such as storage and analytics providers who help us provide you with our Services. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with the highest security standards and applicable data protection legislation, and may not use your Personal Data for any other purpose.</span></li>
								  <li><strong><span>Compliance with laws and law enforcement entities</span></strong><span>  - we cooperate with other governmental agencies and law enforcement officials to enforce and comply with the law. We will disclose Personal Data about you to government or law enforcement officials or private parties if we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party's property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.  </span></li>
								</ul>
								
								<h3 id="HowWeProtect"><span>HOW WE PROTECT YOUR INFORMATION</span></h3>
								<p><span>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn’t publicly available. We limit access of your information only to those employees or partners on a “need to know” basis, in order to enable the carrying out of the agreement between us.  </span></p>
								<p><span>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You should be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the Service, and you do so at your own risk.  </span></p>
								
								<h3 id="Retention"><span>RETENTION</span></h3>
								<p><span>We will retain your Personal Data for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Data, communications and anything else as required by applicable laws and regulations.  </span></p>
								
								<h3  id="UserRigths"><span>USER RIGHTS</span></h3>
								<h4><strong><span style="font-family:&quot;Calibri&quot;,sans-serif;color:windowtext;font-style:normal;">EU User Rights</span></strong></h4>
								<p><span>As an EU resident, you may request to:  </span></p>
								<ol start="1" style="list-style-type: lower-alpha;margin-left: 0px;">
								  <li><span>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.  </span></li>
								  <li><span>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.  </span></li>
								  <li><span>Request rectification of your Personal Data that is in our control.</span></li>
								  <li><span>Request erasure of your Personal Data.  </span></li>
								  <li><span>Object to the processing of Personal Data by us.  </span></li>
								  <li><span>Request to restrict processing of your Personal Data by us.</span></li>
								  <li><span>Lodge a complaint with a supervisory authority.</span></li>
								</ol>
								<p><span>Please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements.  </span></p>
								<h3><span>Users Outside the EU -  </span></strong><span>Some of the aforementioned rights are applicable in certain jurisdictions outside the EU as well. Users residing outside the EU are welcome to contact us for any questions or requests by using the details provided below.</span></p>
								
								<h3 id="Transfer"><span>TRANSFER OF DATA OUTSIDE THE EEA</span><span>  </span></h3>
								<p><span>If you reside in the European Union ("<strong>EU</strong>"), please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</span></p>
								
								<h3 id="OurPolicy"><span>OUR POLICY TOWARD CHILDREN</span></h3>
								<p>We do not knowingly collect or solicit personal information from anyone under 18 years of age, (or the age of consent as determined under the applicable laws where the individual resides; “<strong>Age of Consent</strong>”). By accessing, using or interacting with our Services, you certify to us that you are not under the Age of Consent. In the event that we learn that we have collected personal information from an individual under the Age of Consent without verification of parental consent, we will delete that information upon discovery. If you believe that we might have any information from or about an individual under the Age of Consent, then please contact us through the contact details available below.</p>
								
								<h3 id="HowToContactUs"><span>HOW TO CONTACT US?</span></h3>
								<p><span>If you wish to exercise any of the aforementioned rights, or receive more information, please contact us using the details below:</span><br/>Email:<a href="mailto:Dpo@tourism.gov.il" style="text-decoration:underline;color:#000"> Dpo@tourism.gov.il</a>
								</p>
								
								<h3 id="Updates"><span>UPDATES TO THIS POLICY</span></h3>
								<p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our Services (as reflected in the "Last Updated" heading). You are advised to check for updates regularly. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.  </p>

                               
		                        `,
      };
    },
  },

  {
    id: "Catholic_Itinerary_7_Days_Tour",
    ctg: "itineraries",
    bgImage: "posts/bank/catholicinterestitineraries10daystour/1.jpg",
    mobBgImage: "posts/bank/catholicinterestitineraries10daystour/M.jpg",
    isVid: false,
    vidId: "",
    title: "Catholic Interest Itineraries - 7 Days Tour",
    smltitle: "",
    html: function() {
      return {
        __html: `	
		<h3>Day 1</h3>
		<p>Your journey begins at Jaffa, one of the oldest port cities in the world and the home of the Church of St. Peter. From there, you will drive north along the Mediterranean coast to Caesarea, the great Roman port city and one of the largest archeological digs in Israel.  Continue to Mount Carmel, where Elijah battle the prophets of Baal. Next, drive across the valley to Nazareth, the boyhood home of Jesus and the site of the Basilica of the Annunciation, with its magnificent representations of Mary from around the world. Then go north to Cana where Jesus performed his first miracle, turning water into wine; for those that would like to, this is the perfect place to renew your marriage vows. Finally, drive to Tiberias where you will stay for the night.</p>
		
		<h3>Day 2</h3>
		<p>Your day will begin visiting the biblical sites around the Sea of Galilee. Start your tour at the Mount of Beatitudes, where Jesus gave the Sermon on the Mount, and one of the many sites where Pope Paul VI and Pope John Paul II prayed while in Israel. Next visit Capernaum, the town where Jesus lived during his Galilee ministry and site of the Memorial of St. Peter. This is a favorite place to celebrate mass. Just down the road is Tabgha, where Jesus multiplied the loaves and fishes. Continue to Mensa Christi (table if Christ) where Jesus asked Peter, “Do you love me?” You will stop at Nof Ginnosar to see the 2,000-year-old “Jesus Boat” unearthed from the Sea of Galilee. Then, enjoy a boat ride on the Sea of Galilee. After lunch, visit Magadala, the home of Mary Magdelene and one of six first-century synagogues in the world. Finish your day at Yardenit Baptismal Site on the Jordan River before you return to your hotel in Tiberias.</p>
		
		<h3>Day 3</h3>
		<p>Today you travel down the Jordan River Valley from the Sea of Galilee to the Dead Sea. Your first stop will be the Crusader fortress of Belvoir overlooking the Jordan River Valley. Then drive on to Beit Shean, the largest and most spectacular exaction in all of Israel. Then, continue to the Dead Sea. Travel through the wilderness of Judah to your hotel at Ein Bokek, near the Dead Sea, where you can enjoy some personal time at your hotel’s refreshing spa.</p>
		
		
		<h3>Day 4</h3>
		<p>Begin your journey today with a visit to Masada, where you will ascend the mountain by cable car to view Herod’s desert fortress. Continue to Ein Gedi where David hid from King Saul. Stop for a short float on float on the Dead Sea. Then drive to Qumran, the home of the first century sect known as the Essenes, the authors of the Dead Sea Scrolls. Finally, the bus makes its way to Jerusalem. The road from Jericho to Jerusalem is an ascent of 4,000 feet in 13 miles. Stop at the top of Mount Scopus for your first view of the “Golden City” as the sun sets over Jerusalem.</p>
		
		<h3>Day 5</h3>
		<p>Today you will explore Jerusalem. Begin with a drive around the old city walls and note each of the city gates. Travel by bus to the top of the Mount of Olives and view the entire city of Jerusalem. Then, walk down the Palm Sunday Road to the Garden of Gethsemane, stopping at Dominus Flavit, where Jesus stopped and wept over Jerusalem. See the ancient olive trees in the Garden of Gethsemane and visit the beautiful Church of All Nations, which is also known as the Basilica of the Agony because of the blood Jesus seated in his final prayers. Next, the bus will ascend Mt. Zion where you will visit the Tomb of David and the Upper Room. Enter the Old City through the Zion Gate, make your way to the Jewish Quarter and visit the Cardo, Hezekiah’s Wall, and have your first glimpse of the Western Wall. Then, leaving the Old City for the day, a short drive takes you to the Israel Museum and the Shrine of the Book, where the Dead Sea scrolls are kept. Stop by the Model of Jerusalem from the time of the second temple. Finally, continue to Yad Vashem, the site of the Holocaust memorial, before returning to your hotel for the evening. </p>
		
		<h3>Day 6</h3>
		<p>Enter the Old City through the Dung Gate where you can then explore the Southern Temple Excavations and the Western Wall. Visit the Rabbinic Tunnel, which takes you underground to the base of the Temple Mount, and the actual streets Jesus and his disciples walked upon. Continue with a walking tour of the Old City that includes the Via Dolorosa and the 14 Stations of the Cross, the Pools of Bethesda, St. Anne’s Chapel, Lithostrotos, Ecco Homo Arch, and the Church of the Holy Sepulchre and the Church of the Visitation are excellent places for holding Mass. Return to your hotel for a relaxing dinner, and later, visit the pedestrian mall on Ben Yehuda Street before retiring for the night.</p>
		
		<h3>Day 7</h3>
		
		<p>A short drive from Jerusalem to Ein Karem, a serene, picturesque Jerusalem suburb and home to the Church of John the Baptist and the Church of the Visitation. From here travel to Yad Veshem Holocaust museum. After a museum tour, spend the rest of the afternoon at leisure, collecting your thoughts and reflecting on your trip to Israel. Take the time to revisit the places that interested you most of do some shopping within the walls of the Old City. After dinner, transfer to Ben Guion Airport for your return flight home. </p>
		
		<p>Masses will be celebrated daily.</p>
		<p>
		When a priest accompanies the group, private masses can be arranged. These should be booked in advance and can be held Monday-Saturday (subject to space) at the following sites:
		<ul>
		<li>Church of St. Peter's Primacy in the Galilee</li>
		<li>Basilica of the Annunciation in Nazareth</li>
		<li>Church of the Nativity in Bethlehem</li>
		<li>Church of the Holy Sepulcher in Jerusalem</li>
		<li>Church of the Visitation in Ein Karem</li>
		<li>If a group arrives without a priest, they can participate in regular Masses in English on Sundays. Some places also conduct Mass in the afternoons during the week.</li>
		</ul>
		</p>
		`,
      };
    },
  },
];



// WEBPACK FOOTER //
// ./src/Posts/PostsData.js